webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_firestore__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebaseConfig__ = __webpack_require__(507);



var firebaseApp = __WEBPACK_IMPORTED_MODULE_0_firebase_app__["a" /* default */].initializeApp(__WEBPACK_IMPORTED_MODULE_2__firebaseConfig__["a" /* default */]);
var db = __WEBPACK_IMPORTED_MODULE_0_firebase_app__["a" /* default */].firestore();
db.settings({ timestampsInSnapshots: true });
db.enablePersistence({ synchronizeTabs: true }).then(function () {
    console.log("Woohoo! Multi-Tab Persistence!");
}).catch(function (err) {
    if (err.code == 'failed-precondition') {
        // Multiple tabs open, persistence can only be enabled
        // in one tab at a a time.
        // ...
    } else if (err.code == 'unimplemented') {
        // The current browser does not support all of the
        // features required to enable persistence
        // ...
    }
});

/* harmony default export */ __webpack_exports__["a"] = (db);

/***/ }),
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Logo2.29a36f7.jpeg";

/***/ }),
/* 14 */,
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bus", function() { return bus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Store__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase_auth__ = __webpack_require__(928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__firebase_messaging__ = __webpack_require__(930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config_FirebaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_bootstrap_vue__ = __webpack_require__(932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_barcode_scanner__ = __webpack_require__(1040);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_barcode_scanner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_barcode_scanner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_carousel_3d__ = __webpack_require__(1041);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_carousel_3d___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_carousel_3d__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_js_modal__ = __webpack_require__(1042);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_js_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_js_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_product_zoomer__ = __webpack_require__(1043);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_product_zoomer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_product_zoomer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_image_zoom__ = __webpack_require__(1044);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_image_zoom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_image_zoom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_image_zoom_dist_vue_image_zoom_css__ = __webpack_require__(1045);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_image_zoom_dist_vue_image_zoom_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_image_zoom_dist_vue_image_zoom_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui__ = __webpack_require__(1046);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_locale_lang_en__ = __webpack_require__(1096);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_locale_lang_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_element_ui_lib_locale_lang_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_element_ui_index_css__ = __webpack_require__(1097);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_element_ui_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__assets_element_ui_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_backtotop__ = __webpack_require__(1098);











// inject barcode scanner with option (add sound effect)
// sound will trigger when it's already scanned
var options = {
  sound: false, // default is false
  soundSrc: '/static/sound.wav', // default is blank
  sensitivity: 10, // default is 100
  requiredAttr: false, // default is false
  controlSequenceKeys: ['NumLock', 'Clear'], // default is null
  callbackAfterTimeout: true // default is false
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue_barcode_scanner___default.a, options);

// import VueHtmlToPaper from 'vue-html-to-paper';
// const printOptions = {
//   name: '_blank',
//   specs: [
//     'fullscreen=yes',
//     'titlebar=yes',
//     'scrollbars=yes'
//   ],
//   styles: [

//     '../static/pos.css'
//   ],
//   timeout: 1000, // default timeout before the print window appears
//   autoClose: true, // if false, the window will not close after printing
//   windowTitle: window.document.title, // override the window title
// }
// Vue.use(VueHtmlToPaper,printOptions);

// var SocialSharing = require('vue-social-sharing');
// Vue.use(SocialSharing)

// import { Icon }  from 'leaflet'
// import 'leaflet/dist/leaflet.css'
// this part resolve an issue where the markers would not appear
// delete Icon.Default.prototype._getIconUrl;
// Icon.Default.mergeOptions({
//   iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
//   iconUrl: require('leaflet/dist/images/marker-icon.png'),
//   shadowUrl: require('leaflet/dist/images/marker-shadow.png')
// });

// import * as VueGoogleMaps from 'vue2-google-maps'
// import VueTypedJs from 'vue-typed-js'
// import VueFormWizard from 'vue-form-wizard'
// import 'vue-form-wizard/dist/vue-form-wizard.min.css'
// import VuePwaInstallPlugin from "vue-pwa-install";
// Vue.use(VuePwaInstallPlugin);





// import VueCharts from 'hchs-vue-charts';


// import VeeValidate from 'vee-validate';


// import 'element-ui/lib/theme-chalk/index.css';




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_18_vue_backtotop__["a" /* default */]);
// const router = new Router({
//   routes,
//   mode:'history'
// })
// import jQuery from 'jQuery'
// global.jQuery = jQuery
// global.$ = jQuery
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13_vue_image_zoom___default.a);
// Vue.use(window.VueCharts);
// Vue.use(VueFormWizard)
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_vue_product_zoomer___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_vue_js_modal___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vue_carousel_3d___default.a);
var VueScrollTo = __webpack_require__(1102);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(VueScrollTo);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_15_element_ui___default.a, { locale: __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_locale_lang_en___default.a });
// Vue.use(VueTypedJs)

// Vue.use(VeeValidate);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = true;

var bus = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]();

var app = void 0;
__WEBPACK_IMPORTED_MODULE_4_firebase_app__["a" /* default */].auth().onAuthStateChanged(function (user) {
  if (!app) {
    new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
      store: __WEBPACK_IMPORTED_MODULE_3__Store__["a" /* store */],
      el: '#app',
      router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
      render: function render(h) {
        return h(__WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]);
      }
    });
  }
});

// Vue.prototype.$messaging = firebase.messaging()
// Vue.prototype.$messaging.usePublicVapidKey("BOM7o4aqlQ3j8BKb4xN5626BIOSiJP0RerrA3RMrIlVw4WSIKjRB_dfCvQluDAh5J_6R4vlnHYUhd6jSVZo9th4");
// navigator.serviceWorker.register('../static/firebase-messaging-sw.js')
//   .then((registration) => {
//     Vue.prototype.$messaging.useServiceWorker(registration)
//   }).catch(err => {
//     alert(err)
//   })
// Vue.use(VueGoogleMaps, {
//  load: {
//    key: '',
//    v: 'quarterly',

//  },

// })
/* eslint-disable no-new */

/***/ }),
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    "Mobiles": ["Apple", "Sony", "HTC", "Samsung"],

    "Accessories": ["HandFree", "Chargers", "Bettries"]
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({

				"Men’s Clothing": ["T-Shirts", "Shirts", "Blazers", "Sweaters ", "Jeans", "Pants", "Shorts", "Coats & Jackets", "Suits", "Athletic Apparel", "Socks", "Underwear", "Shoes"],

				"Women’s Clothing": ["Dresses", "Tops & Blouses", "T- Shirts", "Sweaters", "Coats & Jackets", "Jeans", "Pants", "Shorts", "Skirts", "Swimwear", "Intimates & Sleepwear"],

				"Kids & Baby": ["Girls (newborn - 5T)", "Girls (4 and Up)", "Boys (newborn -5T)", "Boys (4 and Up)"],

				"Men’s Accessories": ["Sunglasses", "Wallets", "Scarves & Wraps", "Watches", "Belts", "Hats", "Caps", "Gloves & Mittens"],

				"Women’s Accessories": ["Sunglasses", "Wallets", "Scarves & Wraps", "Watches", "Belts", "Hats", "Caps", "Gloves & Mittens"]

});

/***/ }),
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  value: 'All of Sri Lanka',
  label: 'All of Sri Lanka'
}, {
  value: 'Colombo',
  label: 'Colombo',

  children: [{
    value: 'All of Colombo',
    label: 'All of Colombo'
  }, {
    value: 'Colombo 01',
    label: 'Colombo 01'
  }, {
    value: 'Colombo 02',
    label: 'Colombo 02'
  }, {
    value: 'Colombo 03',
    label: 'Colombo 03'
  }, {
    value: 'Colombo 04',
    label: 'Colombo 04'
  }, {
    value: 'Colombo 05',
    label: 'Colombo 05'
  }, {
    value: 'Colombo 06',
    label: 'Colombo 06'
  }, {
    value: 'Colombo 07',
    label: 'Colombo 07'
  }, {
    value: 'Colombo 08',
    label: 'Colombo 08'
  }, {
    value: 'Colombo 08',
    label: 'Colombo 08'
  }, {
    value: 'Colombo 08',
    label: 'Colombo 08'
  }, {
    value: 'Colombo 09',
    label: 'Colombo 09'
  }, {
    value: 'Colombo 10',
    label: 'Colombo 10'
  }, {
    value: 'Colombo 11',
    label: 'Colombo 11'
  }, {
    value: 'Colombo 12',
    label: 'Colombo 12'
  }, {
    value: 'Colombo 13',
    label: 'Colombo 13'
  }, {
    value: 'Colombo 14',
    label: 'Colombo 14'
  }, {
    value: 'Colombo 15',
    label: 'Colombo 15'
  }, {
    value: 'Angoda ',
    label: 'Angoda '
  }, {
    value: 'Athurugiriya',
    label: 'Athurugiriya'
  }, {
    value: 'Awissawella',
    label: 'Awissawella'
  }, {
    value: 'Battaramulla',
    label: 'Battaramulla'
  }, {
    value: 'Boralesgamuwa',
    label: 'Boralesgamuwa'
  }, {
    value: 'Dehiwala',
    label: 'Dehiwala'
  }, {
    value: 'Hanwella',
    label: 'Hanwella'
  }, {
    value: 'Homagama ',
    label: 'Homagama '
  }, {
    value: 'Kaduwela',
    label: 'Kaduwela'
  }, {
    value: 'Kesbewa',
    label: 'Kesbewa'
  }, {
    value: 'Kohuwala',
    label: 'Kohuwala'
  }, {
    value: 'Kolonnawa',
    label: 'Kolonnawa'
  }, {
    value: 'Kottawa',
    label: 'Kottawa'
  }, {
    value: 'Kotte',
    label: 'Kotte'
  }, {
    value: 'Maharagama',
    label: 'Maharagama'

  }, {
    value: 'Malabe',
    label: 'Malabe'
  }, {
    value: 'Moratuwa',
    label: 'Moratuwa'
  }, {
    value: 'Mount Lavinia',
    label: 'Mount Lavinia'
  }, {
    value: 'Nawala',
    label: 'Nawala'
  }, {
    value: 'Nugegoda',
    label: 'Nugegoda'
  }, {
    value: 'Padukka',
    label: 'Padukka'
  }, {
    value: 'Pannipitiya',
    label: 'Pannipitiya'
  }, {
    value: 'Piliyandala',
    label: 'Piliyandala'
  }, {
    value: 'Rajagiriya',
    label: 'Rajagiriya'
  }, {
    value: 'Rathmalana',
    label: 'Rathmalana'
  }, {
    value: 'Thalawathugoda',
    label: 'Thalawathugoda'
  }, {
    value: 'Wellampitiya',
    label: 'Wellampitiya'
  }]
}, {
  value: 'Kandy',
  label: 'Kandy',

  children: [{
    value: 'All of Kandy',
    label: 'All of Kandy'
  }, {
    value: 'Kandy',
    label: 'Kandy'
  }, {
    value: 'Katugastota',
    label: 'Katugastota'
  }, {
    value: 'Peradeniya',
    label: 'Peradeniya'
  }, {
    value: 'Gampola',
    label: 'Gampola'
  }, {
    value: 'Kadugannawa',
    label: 'Kadugannawa'
  }, {
    value: 'Kundasale',
    label: 'Kundasale'
  }, {
    value: 'Akurana',
    label: 'Akurana'
  }, {
    value: 'Gelioya',
    label: 'Gelioya'
  }, {
    value: 'Delthota',
    label: 'Delthota'
  }, {
    value: 'Nawalapitiya',
    label: 'Nawalapitiya'
  }, {
    value: 'Pilimathalawa',
    label: 'Pilimathalawa'

  }]
}, {
  value: 'Gampaha',
  label: 'Gampaha',

  children: [{
    value: 'All of Gampaha',
    label: 'All of Gampaha'
  }, {
    value: 'Gampaha',
    label: 'Gampaha'
  }, {
    value: 'Negombo',
    label: 'Negombo'
  }, {
    value: 'Kelaniya',
    label: 'Kelaniya'
  }, {
    value: 'Kiribathgoda',
    label: 'Kiribathgoda'
  }, {
    value: 'Kadawatha',
    label: 'Kadawatha'
  }, {
    value: 'Delgoda',
    label: 'Delgoda'
  }, {
    value: 'Divulapitiya',
    label: 'Divulapitiya'
  }, {
    value: 'Ganemulla',
    label: 'Ganemulla'
  }, {
    value: 'Ja-Ela',
    label: 'Ja-Ela'
  }, {
    value: 'Kandana',
    label: 'Kandana'
  }, {
    value: 'Katunayake',
    label: 'Katunayake'
  }, {
    value: 'Kirindiwela',
    label: 'Kirindiwela'
  }, {
    value: 'Minuwangoda',
    label: 'Minuwangoda'
  }, {
    value: 'Mirigama',
    label: 'Mirigama'
  }, {
    value: 'Nittambuwa',
    label: 'Nittambuwa'
  }, {
    value: 'Ragama',
    label: 'Ragama'
  }, {
    value: 'Veyangoda',
    label: 'Veyangoda'
  }, {
    value: 'Wattala',
    label: 'Wattala'

  }]
}, {
  value: 'Galle',
  label: 'Galle',

  children: [{
    value: 'All of Galle',
    label: 'All of Galle'
  }, {
    value: 'Galle',
    label: 'Galle'
  }, {
    value: 'Ambalangoda',
    label: 'Ambalangoda'
  }, {
    value: 'Elpitiya',
    label: 'Elpitiya'
  }, {
    value: 'Hikkaduwa',
    label: 'Hikkaduwa'
  }, {
    value: 'Baddegama',
    label: 'Baddegama'
  }, {
    value: 'Ahangama',
    label: 'Ahangama'
  }, {
    value: 'Batapola',
    label: 'Batapola'
  }, {
    value: 'Benthota',
    label: 'Benthota'
  }, {
    value: 'Katapitiya',
    label: 'Katapitiya'

  }]
}, {
  value: 'Ampara',
  label: 'Ampara',

  children: [{
    value: 'All of Ampara',
    label: 'All of Ampara'
  }, {
    value: 'Ampara',
    label: 'Ampara'
  }, {
    value: 'Akkarepattu',
    label: 'Akkarepattu'
  }, {
    value: 'Kalmunai',
    label: 'Kalmunai'
  }, {
    value: 'Sainthamaruthu',
    label: 'Sainthamaruthu'

  }]
}, {
  value: 'Anuradhapura',
  label: 'Anuradhapura',

  children: [{
    value: 'All of Anuradhapura',
    label: 'All of Anuradhapura'
  }, {
    value: 'Anuradhapura',
    label: 'Anuradhapura'
  }, {
    value: 'Kekirawa',
    label: 'Kekirawa'
  }, {
    value: 'Medawachchiya',
    label: 'Medawachchiya'
  }, {
    value: 'Eppawala',
    label: 'Eppawala'
  }, {
    value: 'Tambuttegama',
    label: 'Tambuttegama'
  }, {
    value: 'Galenbidunuwewa',
    label: 'Galenbidunuwewa'
  }, {
    value: 'Galnewa',
    label: 'Galnewa'
  }, {
    value: 'Habarana',
    label: 'Habarana'
  }, {
    value: 'Mihinthale',
    label: 'Mihinthale'
  }, {
    value: 'Nochchiyagama',
    label: 'Nochchiyagama'
  }, {
    value: 'Thalawa',
    label: 'Thalawa'

  }]
}, {
  value: 'Badulla',
  label: 'Badulla',

  children: [{
    value: 'All of Badulla',
    label: 'All of Badulla'
  }, {
    value: 'Badulla',
    label: 'Badulla'
  }, {
    value: 'Bandarawela',
    label: 'Bandarawela'
  }, {
    value: 'Welimada',
    label: 'Welimada'
  }, {
    value: 'Mahiyanganaya',
    label: 'Mahiyanganaya'
  }, {
    value: 'Ella',
    label: 'Ella'
  }, {
    value: 'Haputale',
    label: 'Haputale'

  }]
}, {
  value: 'Batticaloa',
  label: 'Batticaloa',

  children: [{
    value: 'All of Batticaloa',
    label: 'All of Batticaloa'
  }, {
    value: 'Batticaloa',
    label: 'Batticaloa'
  }]
}, {
  value: 'Hambantota',
  label: 'Hambantota',

  children: [{
    value: 'All of Hambantota',
    label: 'All of Hambantota'
  }, {
    value: 'Hambantota',
    label: 'Hambantota'
  }, {
    value: 'Tangalla',
    label: 'Tangalla'
  }, {
    value: 'Beliatta',
    label: 'Beliatta'
  }, {
    value: 'Ambalantota',
    label: 'Ambalantota'
  }, {
    value: 'Tissamaharama',
    label: 'Tissamaharama'

  }]
}, {
  value: 'Jaffna',
  label: 'Jaffna',

  children: [{
    value: 'All of Jaffna',
    label: 'All of Jaffna'
  }, {
    value: 'Jaffna',
    label: 'Jaffna'
  }, {
    value: 'Nallur',
    label: 'Nallur'
  }, {
    value: 'Chavakachcheri',
    label: 'Chavakachcheri'

  }]
}, {
  value: 'Kalutara',
  label: 'Kalutara',

  children: [{
    value: 'All of Kalutara',
    label: 'All of Kalutara'
  }, {
    value: 'Kalutara',
    label: 'Kalutara'
  }, {
    value: 'Horana',
    label: 'Horana'
  }, {
    value: 'Panadura',
    label: 'Panadura'
  }, {
    value: 'Bandaragama',
    label: 'Bandaragama'
  }, {
    value: 'Dharga Town',
    label: 'Dharga Town'
  }, {
    value: 'Matugama',
    label: 'Matugama'
  }, {
    value: 'Aluthgama',
    label: 'Aluthgama'
  }, {
    value: 'Beruwala',
    label: 'Beruwala'
  }, {
    value: 'Ingiriya',
    label: 'Ingiriya'
  }, {
    value: 'Wadduwa',
    label: 'Wadduwa'

  }]
}, {
  value: 'Kegalle',
  label: 'Kegalle',

  children: [{
    value: 'All of Kegalle',
    label: 'All of Kegalle'
  }, {
    value: 'Kegalle',
    label: 'Kegalle'
  }, {
    value: 'Aranayaka',
    label: 'Aranayaka'
  }, {
    value: 'Mawanella',
    label: 'Mawanella'
  }, {
    value: 'Warakapola',
    label: 'Warakapola'
  }, {
    value: 'Rambukkana',
    label: 'Rambukkana'
  }, {
    value: 'Galigamuwa',
    label: 'Galigamuwa'

  }]
}, {
  value: 'Kilinochchi',
  label: 'Kilinochchi',

  children: [{
    value: 'All of Kilinochchi',
    label: 'All of Kilinochchi'
  }, {
    value: 'Kilinochchi',
    label: 'Kilinochchi'
  }]
}, {
  value: 'Kurunegala',
  label: 'Kurunegala',

  children: [{
    value: 'All of Kurunegala',
    label: 'All of Kurunegala'
  }, {
    value: 'Kurunegala',
    label: 'Kurunegala'
  }, {
    value: 'Kuliyapitiya',
    label: 'Kuliyapitiya'
  }, {
    value: 'Pannala',
    label: 'Pannala'
  }, {
    value: 'Narammala',
    label: 'Narammala'
  }, {
    value: 'Wariyapola',
    label: 'Wariyapola'
  }, {
    value: 'Alawwa',
    label: 'Alawwa'
  }, {
    value: 'Bingiriya',
    label: 'Bingiriya'
  }, {
    value: 'Galgamuwa',
    label: 'Galgamuwa'
  }, {
    value: 'Giriulla',
    label: 'Giriulla'
  }, {
    value: 'Hettipola',
    label: 'Hettipola'
  }, {
    value: 'Ibbagamuwa',
    label: 'Ibbagamuwa'
  }, {
    value: 'Mawathagama',
    label: 'Mawathagama'
  }, {
    value: 'Nikaweratiya',
    label: 'Nikaweratiya'
  }, {
    value: 'Polgahawela',
    label: 'Polgahawela'

  }]
}, {
  value: 'Mannar',
  label: 'Mannar',

  children: [{
    value: 'All of Mannar',
    label: 'All of Mannar'
  }, {
    value: 'Mannar',
    label: 'Mannar'
  }]
}, {
  value: 'Matale',
  label: 'Matale',

  children: [{
    value: 'All of Matale',
    label: 'All of Matale'
  }, {
    value: 'Matale',
    label: 'Matale'
  }, {
    value: 'Dambulla',
    label: 'Dambulla'
  }, {
    value: 'Galewela',
    label: 'Galewela'
  }, {
    value: 'Ukuwela',
    label: 'Ukuwela'
  }, {
    value: 'Sigiriya',
    label: 'Sigiriya'
  }, {
    value: 'Palapathwela',
    label: 'Palapathwela'
  }, {
    value: 'Rattota',
    label: 'Rattota'
  }, {
    value: 'Yatawatta',
    label: 'Yatawatta'

  }]
}, {
  value: 'Matara',
  label: 'Matara',

  children: [{
    value: 'All of Matara',
    label: 'All of Matara'
  }, {
    value: 'Matara',
    label: 'Matara'
  }, {
    value: 'Akuressa',
    label: 'Akuressa'
  }, {
    value: 'Weligama',
    label: 'Weligama'
  }, {
    value: 'Dikwella',
    label: 'Dikwella'
  }, {
    value: 'Hakmana',
    label: 'Hakmana'
  }, {
    value: 'Deniyaya',
    label: 'Deniyaya'
  }, {
    value: 'Kamburugamuwa',
    label: 'Kamburugamuwa'
  }, {
    value: 'Kamburupitiya',
    label: 'Kamburupitiya'
  }, {
    value: 'Mirissa',
    label: 'Mirissa'
  }, {
    value: 'Morawaka',
    label: 'Morawaka'
  }, {
    value: 'Pitabaddara',
    label: 'Pitabaddara'

  }]
}, {
  value: 'Monaragala',
  label: 'Monaragala',

  children: [{
    value: 'All of Monaragala',
    label: 'All of Monaragala'
  }, {
    value: 'Monaragala',
    label: 'Monaragala'
  }, {
    value: 'Wellawaya',
    label: 'Wellawaya'
  }, {
    value: 'Bibile',
    label: 'Bibile'
  }, {
    value: 'Kataragama',
    label: 'Kataragama'
  }, {
    value: 'Buttala',
    label: 'Buttala'

  }]
}, {
  value: 'Mullativu',
  label: 'Mullativu',

  children: [{
    value: 'All of Mullativu',
    label: 'All of Mullativu'
  }, {
    value: 'Mullativu',
    label: 'Mullativu'
  }]
}, {
  value: 'Nuwara Eliya',
  label: 'Nuwara Eliya',

  children: [{
    value: 'All of Nuwara Eliya',
    label: 'All of Nuwara Eliya'
  }, {
    value: 'Nuwara Eliya',
    label: 'Nuwara Eliya'
  }, {
    value: 'Hatton',
    label: 'Hatton'
  }, {
    value: 'Ginigathena',
    label: 'Ginigathena'
  }, {
    value: 'Thalawakele',
    label: 'Thalawakele'
  }, {
    value: 'Maskeliya',
    label: 'Maskeliya'

  }]
}, {
  value: 'Polonnaruwa',
  label: 'Polonnaruwa',

  children: [{
    value: 'All of Polonnaruwa',
    label: 'All of Polonnaruwa'
  }, {
    value: 'Polonnaruwa',
    label: 'Polonnaruwa'
  }, {
    value: 'Kaduruwela',
    label: 'Kaduruwela'
  }, {
    value: 'Hingurakgoda',
    label: 'Hingurakgoda'
  }, {
    value: 'Medirigiriya',
    label: 'Medirigiriya'

  }]
}, {
  value: 'Puttalam',
  label: 'Puttalam',

  children: [{
    value: 'All of Puttalam',
    label: 'All of Puttalam'
  }, {
    value: 'Puttalam',
    label: 'Puttalam'
  }, {
    value: 'Chilaw',
    label: 'Chilaw'
  }, {
    value: 'Wennappuwa',
    label: 'Wennappuwa'
  }, {
    value: 'Dankotuwa',
    label: 'Dankotuwa'
  }, {
    value: 'Nattandiya',
    label: 'Nattandiya'
  }, {
    value: 'Marawila',
    label: 'Marawila'

  }]
}, {
  value: 'Ratnapura',
  label: 'Ratnapura',

  children: [{
    value: 'All of Ratnapura',
    label: 'All of Ratnapura'
  }, {
    value: 'Ratnapura',
    label: 'Ratnapura'
  }, {
    value: 'Embilipitiya',
    label: 'Embilipitiya'
  }, {
    value: 'Balangoda',
    label: 'Balangoda'
  }, {
    value: 'Pelmadulla',
    label: 'Pelmadulla'
  }, {
    value: 'Eheliyagoda',
    label: 'Eheliyagoda'
  }, {
    value: 'Kuruwita',
    label: 'Kuruwita'
  }, {
    value: 'Godakawela',
    label: 'Godakawela'
  }, {
    value: 'Udawalawa',
    label: 'Udawalawa'

  }]
}, {
  value: 'Trincomalee',
  label: 'Trincomalee',

  children: [{
    value: 'All of Trincomalee',
    label: 'All of Trincomalee'
  }, {
    value: 'Trincomalee',
    label: 'Trincomalee'
  }, {
    value: 'Kinniya',
    label: 'Kinniya'

  }]
}, {
  value: 'Vavuniya',
  label: 'Vavuniya',

  children: [{
    value: 'All of Vavuniya',
    label: 'All of Vavuniya'
  }, {
    value: 'Vavuniya',
    label: 'Vavuniya'
  }]
}]);

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([
// {
//     value: 'shop',
//     label: 'All Shops',
// },
{
    value: 'Essential Goods & Food',
    label: 'Essential Goods & Food',

    children: [{
        value: 'Vegetables & Fruits',
        label: 'Vegetables & Fruits'
    }, {
        value: 'Supermarket',
        label: 'Supermarket'
    }, {
        value: 'Grocery',
        label: 'Grocery'
    }, {
        value: 'Food / Restaurants',
        label: 'Food / Restaurants'
    }, {
        value: 'Agri Products',
        label: 'Agri Products'
    }]
}, {
    value: 'Fashion',
    label: 'Fashion',

    children: [{
        value: 'Clothing',
        label: 'Clothing'
    }, {
        value: 'Health & Beauty',
        label: 'Health & Beauty'
    }, {
        value: 'Jewelry & Watches',
        label: 'Jewelry & Watches'

    }, {
        value: 'Diamonds & Gems',
        label: 'Diamonds & Gems'
    }, {
        value: 'Fancy Items',
        label: 'Fancy Items'
    }, {
        value: 'Baby Kids & Toys',
        label: 'Baby Kids & Toys'
    }, {
        value: 'Shoes & Footwear',
        label: 'Shoes & Footwear'
    }, {
        value: 'Bags',
        label: 'Bags'
    }]
}, {
    value: 'Mobiles & Tablets',
    label: 'Mobiles & Tablets'
}, {
    value: 'Computers',
    label: 'Computers'
}, {
    value: 'Vehicles',
    label: 'Vehicles',

    children: [{
        value: 'Vehicles',
        label: 'Vehicles'
    }, {
        value: 'Auto Parts',
        label: 'Auto Parts'
    }]
}, {
    value: 'Electronics',
    label: 'Electronics'
}, {
    value: 'Home Appliances',
    label: 'Home Appliances',

    children: [{
        value: 'Household Supplies',
        label: 'Household Supplies'
    }, {
        value: 'Tiles & Bathware',
        label: 'Tiles & Bathware'
    }, {
        value: 'Lighting & Electrical',
        label: 'Lighting & Electrical'
    }, {
        value: 'Outdoor',
        label: 'Outdoor'
    }]
}, {
    value: 'Furniture',
    label: 'Furniture'
}, {
    value: 'Cameras',
    label: 'Cameras'
}, {
    value: 'Home Decor',
    label: 'Home Decor',

    children: [{
        value: 'Home Decoration',
        label: 'Home Decoration'
    }, {
        value: 'Window Treatments',
        label: 'Window Treatments'
    }, {
        value: 'Handicrafts',
        label: 'Handicrafts'
    }]
}, {
    value: 'Tools & Machines',
    label: 'Tools & Machines'
}, {
    value: 'Books',
    label: 'Books'
}, {
    value: 'Sports',
    label: 'Sports'
}, {
    value: 'Music',
    label: 'Music'
}]);

/***/ }),
/* 86 */,
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PriceTable_vue__ = __webpack_require__(204);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e1dcf45a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PriceTable_vue__ = __webpack_require__(607);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PriceTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e1dcf45a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PriceTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableHeader_vue__ = __webpack_require__(215);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00956926_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableHeader_vue__ = __webpack_require__(682);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00956926_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_FirebaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(174);






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    state: {
        items: {},
        products: {},
        starterplanproducts: {},
        offers: {},
        shops: {},
        topshops: [],
        searchResults: {},
        searchLocation: '',
        searchParam: '',
        serVisits: '',
        searchServicesCat: '',
        searchServicesParam: '',
        searchServicesLocation: '',
        cartItems: {},
        secondaryApp: {},
        secondaryDatabase: {},
        users: [],
        customers: [],
        viewedCustPage: false,
        suppliers: [],
        viewedSupplierPage: false,
        stores: [],
        selectedStore: '',
        prdNameList: [],
        categories: {},
        systemUser: {
            isLogedIn: false,
            role: "",
            name: "",
            id: "",
            stores: [],
            permissions: []
        },
        allProducts: [],
        noDB: '',
        plan: '',
        // broadcastChannel: '',
        // isOriginalTab: true,
        permissionsList: ["dashboard", "analytics", "invoice list", "invoice write", "invoice return", "GRN list", "GRN return", "GRN write", "quotation list", "quotation write", "cash flow", "expenses", "suppliers", "customers", "users", "online store", "stores", "settings", "products", "categories"],
        starterPlanPermissionsList: ["dashboard", "analytics", "invoice list", "invoice write", "invoice return", "users", "online store", "stores", "settings", "products", "categories"]

    },
    mutations: {
        getAppConfig: function getAppConfig(state, storename) {
            // try{
            //     firebase.app(storename)
            //     state.secondaryDatabase = firebase.app(storename).firestore()
            //     console.log('secondaryDB Exsits', state.secondaryDatabase)
            // }catch(err){
            // db.collection('shops').where('owner', '==', storename).onSnapshot(querySnapshot => {
            //     var shops = []
            //     querySnapshot.forEach(doc => {
            //     const data = {
            //     'id' : doc.id,
            //     'shoptype' : doc.data().shoptype,
            //     'visits': doc.data().visits,
            //     'loc': doc.data().location,
            //     'categories':doc.data().categories,
            //     'plan':doc.data().plan,
            //     'cat': doc.data().cat,
            //     'details': doc.data().details,  
            //     'config': doc.data().config

            //     }
            //     shops.push(data)
            //     console.log(shops[0].config)
            //     console.log(shops[0].id)
            //     var secondaryAppConfig = shops[0].config
            //      var secondary = firebase.initializeApp(secondaryAppConfig, storename)
            //     state.secondaryDatabase = secondary.firestore()
            //     // this.$store.state.secondaryApp = this.$route.params.storename
            //     state.secondaryDatabase.settings({timestampsInSnapshots: true,})
            //     state.secondaryDatabase.enablePersistence({experimentalTabSynchronization:true}).then(() => {
            //         //console.log("Woohoo! Multi-Tab Persistence!");
            //     });
            //     console.log('secondaryDB', state.secondaryDatabase)
            //     })
            //     })
            // }
        }
    },
    actions: {},
    getters: {
        // getItems: (state) => (cat) => {
        //     db.collection('products').where("owner", "==", firebase.auth().currentUser.uid)
        //     .where('cat', '==', cat).get()
        //     .then(querySnapshot => {
        //        var  newitems = []
        //       querySnapshot.forEach(doc => {
        //         // console.log('this.items.length is', state.items.length)
        //         const data = {
        //           'id' : doc.id,
        //           'name': doc.data().name,
        //           'category': doc.data().cat,
        //           'brand': doc.data().brand,
        //           'price': doc.data().disprice,
        //           'subcategory': doc.data().subcat,
        //           'desc': doc.data().desc,
        //           // 'img': doc.data().img,
        //           // 'otherimgs': doc.data().otherimgs,
        //         }
        //          newitems.push(data)
        //         state.items[cat] = newitems
        //         console.log('state.items[cat]',state.items[cat]) 
        //       })

        //       console.log('newitems', newitems)
        //       console.log('state.items',state.items)

        //     })
        //     return state.items[cat]
        // }
    }
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  value: 'fa-cogs',
  label: 'Auto Parts'
}, {
  value: 'fa-child',
  label: 'Baby Kids & Toys'
}, {
  value: 'fa-female',
  label: 'Clothing'
}, {
  value: 'fa-laptop',
  label: 'Computers'
}, {
  value: 'fa-television',
  label: 'Electronics'
}, {
  value: 'fa-gift',
  label: 'Fancy Items'
}, {
  value: 'fa-bed',
  label: 'Furniture'
}, {
  value: 'fa-bookmark',
  label: 'Handicrafts'
}, {
  value: 'fa-medkit',
  label: 'Health & Beauty'
}, {
  value: 'fa-glass',
  label: 'Household Supplies'
}, {
  value: 'fa-link',
  label: 'Jewelry & Watches'
}, {
  value: 'fa-lightbulb-o',
  label: 'Lighting & Electrical'
}, {
  value: 'fa-mobile',
  label: 'Mobiles & Tablets'
}, {
  value: 'fa-music',
  label: 'Music'
}, {
  value: 'fa-paw',
  label: 'Shoes & Footwear'
}, {
  value: 'fa-futbol-o',
  label: 'Sports'
}, {
  value: 'fa-shopping-basket',
  label: 'Supermarket'
}, {
  value: 'fa-bath',
  label: 'Tiles & Bathware'
}, {
  value: 'fa-wrench',
  label: 'Tools & Machines'
},
// {
//     value: 'fa-briefcase',
//     label: 'Bags'                       
// },
{
  value: 'fa-car',
  label: 'Vehicles'
}]);

/***/ }),
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Admin_vue__ = __webpack_require__(233);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59e10ed8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Admin_vue__ = __webpack_require__(786);
function injectStyle (ssrContext) {
  __webpack_require__(710)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-59e10ed8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Admin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59e10ed8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Admin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__(236);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0457d28c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__(771);
function injectStyle (ssrContext) {
  __webpack_require__(713)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0457d28c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0457d28c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_POSPrinter_vue__ = __webpack_require__(414);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_156c3bc4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_POSPrinter_vue__ = __webpack_require__(839);
function injectStyle (ssrContext) {
  __webpack_require__(838)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-156c3bc4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_POSPrinter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_156c3bc4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_POSPrinter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrintInvo_vue__ = __webpack_require__(417);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e22764c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrintInvo_vue__ = __webpack_require__(846);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrintInvo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e22764c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrintInvo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_FirebaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__firebase_database__ = __webpack_require__(508);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "App",
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    var _this = this;

    //   window.addEventListener('beforeunload', function (e) {
    //   e.preventDefault();
    //   e.returnValue = '';
    // });

    // window.addEventListener('focus', function () {
    //     if (document.hidden) {
    //         alert('Please use only one tab or window for this website.');
    //         window.close();
    //     }
    // });
    // const messaging = firebase.messaging();
    // messaging.requestPermission()
    // .then(() => {
    //   //console.log('Notification permission granted.')
    //   return messaging.getToken()
    // })
    // .then(token => {
    //   //console.log(token)
    //   this.saveToken(firebase.auth().currentUser, token)
    // })
    // .catch((err) => {
    //   // this.loading = false
    //   // this.fetched = true
    //   // console.log('Unable to get permission to notify.', err)
    // })

    // // Listen for token refresh
    // messaging.onTokenRefresh(() => {
    //   messaging.getToken()
    //   .then(refreshedToken => {
    //     //console.log('Token refreshed.');
    //     this.saveToken(firebase.auth().currentUser, refreshedToken)
    //   })
    //   .catch( err => {
    //     // this.loading = false
    //     // this.fetched = true
    //     //console.log(err, 'Unable to retrieve new token')
    //   })
    // })

    // //Receive Message
    // messaging.onMessage((payload) => {
    //   // console.log("Message received. ", payload);
    //   // console.log("Message1 received. ", payload.notification);
    //   this.open1(payload.notification.title, payload.notification.body)
    // })

    if (this.$route.params.storename != undefined) {
      try {
        __WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].app(this.$route.params.storename);
        this.$store.state.secondaryDatabase = __WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].app(this.$route.params.storename).firestore();
        this.show = true;
        //console.log('secondaryDB Exsits', this.$store.state.secondaryDatabase)
      } catch (err) {
        __WEBPACK_IMPORTED_MODULE_1__config_FirebaseInit__["a" /* default */].collection("shops").where("owner", "==", this.$route.params.storename).onSnapshot(function (querySnapshot) {
          var shops = [];
          querySnapshot.forEach(function (doc) {
            var data = {
              id: doc.id,
              shoptype: doc.data().shoptype,
              visits: doc.data().visits,
              loc: doc.data().location,
              categories: doc.data().categories,
              plan: doc.data().plan,
              cat: doc.data().cat,
              details: doc.data().details,
              config: doc.data().config,
              noDB: doc.data().noDB
            };
            shops.push(data);
            // console.log('shops[0].config',shops[0].config)
            // console.log(shops[0].id)

            if (!shops[0].noDB) {
              // having own db
              var secondaryAppConfig = shops[0].config;
              var secondary = __WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].initializeApp(secondaryAppConfig, _this.$route.params.storename);
              _this.$store.state.secondaryDatabase = secondary.firestore();
              // this.$store.state.secondaryApp = this.$route.params.storename
              _this.$store.state.secondaryDatabase.settings({
                timestampsInSnapshots: true
              });
              _this.$store.state.secondaryDatabase.enablePersistence({ synchronizeTabs: true }).then(function () {
                //console.log("Woohoo! Multi-Tab Persistence!");
              });
            } else {
              _this.$store.state.secondaryDatabase = __WEBPACK_IMPORTED_MODULE_1__config_FirebaseInit__["a" /* default */];
              _this.$store.state.noDB = true;
            }
            _this.show = true;
            //console.log('secondaryDB', this.$store.state.secondaryDatabase)
          });
        });
      }
    } else {
      this.show = true;
      //console.log('this.$route.params.storename',this.$route.params.storename)
    }
  },

  methods: {
    saveToken: function saveToken(user, token) {
      var currentTokens = user.fcmTokens || [];
      //console.log('currentTokens',currentTokens)
      // If token does not exist in firestore, update db
      if (!currentTokens[token]) {
        var userRef = __WEBPACK_IMPORTED_MODULE_1__config_FirebaseInit__["a" /* default */].collection("users").doc(user.uid);
        var tokens = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(currentTokens), [token]);
        //console.log('tokens',tokens)
        userRef.update({ fcmTokens: tokens });
      }
    },
    open1: function open1(title, msg) {
      this.$notify({
        title: title,
        message: msg,
        type: "info"
      });
    }
  }
});

/***/ }),
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Store__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Manage__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Search__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_StartStore__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Benefits__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Restaurants__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_About__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_TermsOfUse__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_PrivacyPolicy__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_store_StoreNavbar__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_store_Cart__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_store_Categories__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_store_Offers__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_store_Products__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_store_ProductDetails__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_store_StoreHome__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_store_Contact__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_store_About__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_user_UserSignup__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_user_Signin__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_user_CheckEmail__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_user_MyAccount__ = __webpack_require__(587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_user_RegShop__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_admin_AllProducts__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_admin_Categories__ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_admin_EditCommonProduct__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_admin_EditMobiles__ = __webpack_require__(702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_admin_EditVehicles__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_admin_Offers__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_admin_Items__ = __webpack_require__(788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_admin_AllOffers__ = __webpack_require__(791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_admin_AllItems__ = __webpack_require__(794);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_admin_Dashboard__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_admin_Payment__ = __webpack_require__(797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_admin_Orders__ = __webpack_require__(800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_admin_Gallery__ = __webpack_require__(803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_admin_MyShopin__ = __webpack_require__(806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_admin_Customers__ = __webpack_require__(809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_admin_AdminHome__ = __webpack_require__(812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_admin_AdminAbout__ = __webpack_require__(817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_admin_AdminContact__ = __webpack_require__(821);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_admin_AdminSetting__ = __webpack_require__(824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_admin_Mobiles__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_admin_Vehicles__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_admin_AdminView__ = __webpack_require__(827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_admin_CreateInvoice__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_admin_CreateBarcode__ = __webpack_require__(841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_admin_InvoiceList__ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_admin_ManageCategories__ = __webpack_require__(848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_admin_Analytics__ = __webpack_require__(851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__components_admin_Returns__ = __webpack_require__(866);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__components_admin_ReturnsGRN__ = __webpack_require__(869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__components_admin_Users__ = __webpack_require__(872);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__components_admin_VerifyUser__ = __webpack_require__(875);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__components_admin_Setting__ = __webpack_require__(878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__components_admin_StoreLocations__ = __webpack_require__(881);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__components_admin_Suppliers__ = __webpack_require__(884);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__components_admin_CashFlow__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__components_admin_CashFlowList__ = __webpack_require__(892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__components_admin_Expenses__ = __webpack_require__(895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__components_admin_ExpenseCategories__ = __webpack_require__(898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__components_admin_Quotations__ = __webpack_require__(901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__components_admin_PurchaseOrders__ = __webpack_require__(904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__components_admin_KOT__ = __webpack_require__(907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__components_admin_StockSummary__ = __webpack_require__(916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__components_admin_JobNotes__ = __webpack_require__(919);




// import Home from '@/components/Home'


// import ServicesSearch from '@/components/ServicesSearch'






// import StoreSidebar from '@/components/store/StoreSidebar'

// import Header from '@/components/store/Header'






// import StoreServices from '@/components/store/StoreServices'


// import PSResults from '@/components/store/PSResults'


















// import Admin from '@/components/admin/Admin'




// import AddUser from '@/components/admin/AddUser'

// import Sidebar from '@/components/admin/Sidebar'







// import RegServices from '@/components/user/RegServices'
// import Services from '@/components/admin-services/Services'
// import Gallery from '@/components/admin-services/Gallery'
// import AllServices from '@/components/admin-services/AllServices'
// import DashboardServices from '@/components/admin-services/Dashboard'
// import AdminServices from '@/components/admin-services/Admin'
// import MyShopinServices from '@/components/admin-services/MyShopin'
// import AdminHomeServices from '@/components/admin-services/AdminHome'
// import AdminAboutServices from '@/components/admin-services/AdminAbout'
// import AdminContactServices from '@/components/admin-services/AdminContact'

























__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/app.js',
    name: 'app',
    component: __WEBPACK_IMPORTED_MODULE_6__components_StartStore__["a" /* default */],
    meta: {
      title: 'Eshops.lk - Its all about success of your business.'
    }
  }, {
    path: '/',
    name: 'home',
    component: __WEBPACK_IMPORTED_MODULE_6__components_StartStore__["a" /* default */],
    meta: {
      title: 'Eshops.lk - Its all about success of your business.'
    }
  }, {
    path: '/index.html',
    component: __WEBPACK_IMPORTED_MODULE_6__components_StartStore__["a" /* default */],
    meta: {
      title: 'Eshops.lk - Its all about success of your business.'
    }
  }, // Fix for PWA at /index.html
  {
    path: '/benefits',
    name: 'benefits',
    component: __WEBPACK_IMPORTED_MODULE_7__components_Benefits__["a" /* default */],
    meta: {
      title: 'Eshops.lk - Explore features and benefits'
    }
  }, {
    path: '/for-restaurants',
    name: 'restaurants',
    component: __WEBPACK_IMPORTED_MODULE_8__components_Restaurants__["a" /* default */],
    meta: {
      title: 'Eshops.lk - Special benefits for restaurants & cafes'
    }
  },
  // {
  //   path: '/adminview',
  //   name: 'home',
  //   component: AdminView,
  //   meta: {
  //     title: 'Eshops.lk - Start Your Online Store | Shop Online in Your City',
  //   }
  // },

  // {
  //   path: '/search',
  //   name: 'search',
  //   component: Search,
  //   meta: {
  //     title: 'Search - Stores',
  //   }
  // },
  // {
  //   path: '/services-search',
  //   name: 'servicessearch',
  //   component: ServicesSearch,
  //   meta: {
  //     title: 'Search - Services',
  //   }
  // },
  // {
  //   path: '/productssearch',
  //   name: 'psresults',
  //   component: PSResults
  // },
  {
    path: '/',
    name: 'startstore',
    component: __WEBPACK_IMPORTED_MODULE_6__components_StartStore__["a" /* default */],
    meta: {
      title: 'eshops.lk - Start Your Online Store Now'
    }
  }, {
    path: '/manage',
    name: 'manage',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Manage__["a" /* default */],
    meta: {
      requiresAuth: true,
      title: 'Manage'
    }
  }, {
    path: '/about',
    name: 'about',
    component: __WEBPACK_IMPORTED_MODULE_9__components_About__["a" /* default */],
    meta: {
      title: 'About Us'
    }
  }, {
    path: '/termsofuse',
    name: 'termsofuse',
    component: __WEBPACK_IMPORTED_MODULE_10__components_TermsOfUse__["a" /* default */],
    meta: {
      title: 'Terms Of Use'
    }
  }, {
    path: '/privacypolicy',
    name: 'privacypolicy',
    component: __WEBPACK_IMPORTED_MODULE_11__components_PrivacyPolicy__["a" /* default */],
    meta: {
      title: 'Privacy Policy'
    }
  },
  // {
  //   path: '/services/:pageid',
  //   name: 'storeservices',
  //   component: StoreServices,
  //   meta: {
  //     title: 'Services',
  //   }
  // },

  {
    path: '/stores/:storename/',
    name: 'storehome',
    component: __WEBPACK_IMPORTED_MODULE_18__components_store_StoreHome__["a" /* default */],
    meta: {
      title: 'Store Home'
    },
    children: [{
      path: 'contact',
      name: 'storecontact',
      component: __WEBPACK_IMPORTED_MODULE_19__components_store_Contact__["a" /* default */],
      meta: {
        title: 'Store Contact'
      }
    }, {
      path: 'about',
      name: 'storeabout',
      component: __WEBPACK_IMPORTED_MODULE_20__components_store_About__["a" /* default */],
      meta: {
        title: 'Store About'
      }
    }, {
      path: 'cart',
      name: 'storecart',
      component: __WEBPACK_IMPORTED_MODULE_13__components_store_Cart__["a" /* default */],
      meta: {
        title: 'Store Cart'
      }
    }, {
      path: 'categories',
      name: 'storecategories',
      component: __WEBPACK_IMPORTED_MODULE_14__components_store_Categories__["a" /* default */],
      meta: {
        title: 'Store Categories'
      }
    }, {
      path: 'offers',
      name: 'storeoffers',
      component: __WEBPACK_IMPORTED_MODULE_15__components_store_Offers__["a" /* default */],
      meta: {
        title: 'Store Offers'
      }
    }, {
      path: 'categories/:cat',
      name: 'storeproducts',
      component: __WEBPACK_IMPORTED_MODULE_16__components_store_Products__["a" /* default */],
      meta: {
        title: 'Store Products'
      }
    }, {
      path: 'productdetails/:id',
      name: 'storeproductdetails',
      component: __WEBPACK_IMPORTED_MODULE_17__components_store_ProductDetails__["a" /* default */],
      meta: {
        title: 'Store Product Details'
      }
    }]
  }, {
    path: '/usersignup',
    name: 'usersignup',
    component: __WEBPACK_IMPORTED_MODULE_21__components_user_UserSignup__["a" /* default */],
    meta: {
      requiresGuest: true,
      title: 'Sign up'
    }
  }, {
    path: '/signin',
    name: 'signin',
    component: __WEBPACK_IMPORTED_MODULE_22__components_user_Signin__["a" /* default */],
    meta: {
      requiresGuest: true,
      title: 'Sign in'
    }

  }, {
    path: '/myaccount',
    name: 'myaccount',
    component: __WEBPACK_IMPORTED_MODULE_24__components_user_MyAccount__["a" /* default */],
    meta: {
      requiresAuth: true,
      title: 'My Account'
    }

  }, {
    path: '/registration/:plan',
    name: 'regshop',
    component: __WEBPACK_IMPORTED_MODULE_25__components_user_RegShop__["a" /* default */],
    meta: {
      // only remove this requiredAuth to enable link
      requiresAuth: false,
      title: 'Register Store'
    }

  },
  // {
  //   path: '/registration-starter-plan',
  //   name: 'regservices',
  //   component: RegServices,
  //   meta: {
  //     title: 'Register Store/Service'
  //   }

  // },
  {
    path: '/verifyemail',
    name: 'checkemail',
    component: __WEBPACK_IMPORTED_MODULE_23__components_user_CheckEmail__["a" /* default */],
    meta: {

      title: 'Verify Your Email'
    }

  }, {
    path: '/admin/',
    name: 'admin',
    component: __WEBPACK_IMPORTED_MODULE_47__components_admin_AdminView__["a" /* default */],
    // path: 'admin',
    // name: 'admin',
    // component: Sidebar,
    meta: {
      requiresAuth: true,
      title: 'Admin'
    },
    children: [
    // {
    //   path: 'sidebar',
    //   name: 'sidebar',
    //   component: Sidebar
    // },
    {
      path: 'dashboard',
      name: 'dashboard',
      component: __WEBPACK_IMPORTED_MODULE_35__components_admin_Dashboard__["a" /* default */],
      meta: {
        requiresAuth: true,
        title: 'Admin Dashboard'
      }
    }, {
      path: 'adminhome',
      name: 'adminhome',
      component: __WEBPACK_IMPORTED_MODULE_41__components_admin_AdminHome__["a" /* default */],
      meta: {
        requiresAuth: true,
        title: 'Admin Home Page'
      }
    }, {
      path: 'adminabout',
      name: 'adminabout',
      component: __WEBPACK_IMPORTED_MODULE_42__components_admin_AdminAbout__["a" /* default */],
      meta: {
        requiresAuth: true,
        title: 'Admin About Page'
      }
    }, {
      path: 'admincontact',
      name: 'admincontact',
      component: __WEBPACK_IMPORTED_MODULE_43__components_admin_AdminContact__["a" /* default */],
      meta: {
        requiresAuth: true,
        title: 'Admin Contact Page'
      }
    }, {
      path: 'admin-setting',
      name: 'adminsetting',
      component: __WEBPACK_IMPORTED_MODULE_44__components_admin_AdminSetting__["a" /* default */],
      meta: {
        requiresAuth: true,
        title: 'Setting'
      }
    }, {
      path: 'setting',
      name: 'setting',
      component: __WEBPACK_IMPORTED_MODULE_57__components_admin_Setting__["a" /* default */],
      meta: {
        requiresAuth: true,
        title: 'Setting'
      }
    }, {
      path: 'gallery',
      name: 'admingallery',
      component: __WEBPACK_IMPORTED_MODULE_38__components_admin_Gallery__["a" /* default */],
      meta: {
        requiresAuth: true,
        title: 'Admin Gallery'
      }
    }, {
      path: 'stock-summary',
      name: 'stockSummary',
      component: __WEBPACK_IMPORTED_MODULE_67__components_admin_StockSummary__["a" /* default */],
      meta: {
        requiresAuth: true,
        title: 'Stock Summary'
      }
    },
    // {
    //   path: 'add-customer',
    //   name: 'addcustomer',
    //   component: AddUser,
    //   meta: {
    //     requiresAuth: true,
    //     title: 'Add Customer'
    //   }
    // },
    {
      path: 'createinvoice',
      name: 'createinvoice',
      component: __WEBPACK_IMPORTED_MODULE_48__components_admin_CreateInvoice__["a" /* default */],
      meta: {
        requiresAuth: true,
        title: 'Invoice'
      }
    }, {
      path: 'create-purchase-order',
      name: 'create-purchase-order',
      component: __WEBPACK_IMPORTED_MODULE_48__components_admin_CreateInvoice__["a" /* default */],
      meta: {
        requiresAuth: true,
        title: 'Purchase Order'
      }
    }, {
      path: 'create-quotation',
      name: 'create-quotation',
      component: __WEBPACK_IMPORTED_MODULE_48__components_admin_CreateInvoice__["a" /* default */],
      meta: {
        requiresAuth: true,
        title: 'Quotation'
      }
    }, {
      path: 'cash-flow',
      name: 'cash-flow',
      component: __WEBPACK_IMPORTED_MODULE_60__components_admin_CashFlow__["a" /* default */],
      meta: {
        requiresAuth: true,
        title: 'Cash Flow'
      }
    }, {
      path: 'create-labels',
      name: 'create-labels',
      component: __WEBPACK_IMPORTED_MODULE_49__components_admin_CreateBarcode__["a" /* default */],
      meta: {
        requiresAuth: true,
        title: 'Create Labels'
      }
    }, {
      path: 'kot',
      name: 'kot',
      component: __WEBPACK_IMPORTED_MODULE_66__components_admin_KOT__["a" /* default */],
      meta: {
        requiresAuth: true,
        title: 'Create KOT'
      }
    }, {
      path: 'kot/:id',
      name: 'kotedit',
      component: __WEBPACK_IMPORTED_MODULE_66__components_admin_KOT__["a" /* default */],
      meta: {
        requiresAuth: true,
        title: 'Update KOT'
      }
    }, {
      path: 'job-notes',
      name: 'jobNotes',
      component: __WEBPACK_IMPORTED_MODULE_68__components_admin_JobNotes__["a" /* default */],
      meta: {
        requiresAuth: true,
        title: 'Job Notes'
      }
    }, {
      path: 'order-processing',
      name: 'orderProcessing',
      component: __WEBPACK_IMPORTED_MODULE_68__components_admin_JobNotes__["a" /* default */],
      meta: {
        requiresAuth: true,
        title: 'Order Processing'
      }
    }, {
      path: 'invoicelist',
      name: 'invoicelist',
      component: __WEBPACK_IMPORTED_MODULE_50__components_admin_InvoiceList__["a" /* default */],
      meta: {
        requiresAuth: true,
        title: 'Invoice List'
      }
    }, {
      path: 'purchase-order-list',
      name: 'purchase-order-list',
      component: __WEBPACK_IMPORTED_MODULE_65__components_admin_PurchaseOrders__["a" /* default */],
      meta: {
        requiresAuth: true,
        title: 'Purchase Order List'
      }
    }, {
      path: 'quotation-list',
      name: 'quotation-list',
      component: __WEBPACK_IMPORTED_MODULE_64__components_admin_Quotations__["a" /* default */],
      meta: {
        requiresAuth: true,
        title: 'Quotations List'
      }
    }, {
      path: 'cash-flow-history',
      name: 'cash-flow-history',
      component: __WEBPACK_IMPORTED_MODULE_61__components_admin_CashFlowList__["a" /* default */],
      meta: {
        requiresAuth: true,
        title: 'Cash Flow History'
      }
    }, {
      path: 'returns',
      name: 'returns',
      component: __WEBPACK_IMPORTED_MODULE_53__components_admin_Returns__["a" /* default */],
      meta: {
        requiresAuth: true,
        title: 'Returns'
      }
    }, {
      path: 'purchase-order-returns',
      name: 'purchase-order-returns',
      component: __WEBPACK_IMPORTED_MODULE_54__components_admin_ReturnsGRN__["a" /* default */],
      meta: {
        requiresAuth: true,
        title: 'Purchase Order Returns'
      }
    }, {
      path: 'suppliers',
      name: 'suppliers',
      component: __WEBPACK_IMPORTED_MODULE_59__components_admin_Suppliers__["a" /* default */],
      meta: {
        requiresAuth: true,
        title: 'Suppliers'
      }
    }, {
      path: 'expenses',
      name: 'expenses',
      component: __WEBPACK_IMPORTED_MODULE_62__components_admin_Expenses__["a" /* default */],
      meta: {
        requiresAuth: true,
        title: 'Expenses'
      }
    }, {
      path: 'expense-categories',
      name: 'expense-categories',
      component: __WEBPACK_IMPORTED_MODULE_63__components_admin_ExpenseCategories__["a" /* default */],
      meta: {
        requiresAuth: true,
        title: 'Manage Expense Categories'
      }
    }, {
      path: 'users',
      name: 'users',
      component: __WEBPACK_IMPORTED_MODULE_55__components_admin_Users__["a" /* default */],
      meta: {
        requiresAuth: true,
        title: 'Users'
      }
    }, {
      path: 'verify-user',
      name: 'verifyusers',
      component: __WEBPACK_IMPORTED_MODULE_56__components_admin_VerifyUser__["a" /* default */],
      meta: {
        requiresAuth: false,
        title: 'User Verification'
      }
    }, {
      path: 'managecategories',
      name: 'managecategories',
      component: __WEBPACK_IMPORTED_MODULE_51__components_admin_ManageCategories__["a" /* default */],
      meta: {
        requiresAuth: true,
        title: 'Manage Categories'
      }
    }, {
      path: 'analytics',
      name: 'analytics',
      component: __WEBPACK_IMPORTED_MODULE_52__components_admin_Analytics__["a" /* default */],
      meta: {
        requiresAuth: true,
        title: 'Analytics'
      }
    }, {
      path: 'store-locations',
      name: 'storelocations',
      component: __WEBPACK_IMPORTED_MODULE_58__components_admin_StoreLocations__["a" /* default */],
      meta: {
        requiresAuth: true,
        title: 'Store Locations'
      }
    }, {
      path: 'customers',
      name: 'customers',
      component: __WEBPACK_IMPORTED_MODULE_40__components_admin_Customers__["a" /* default */],
      meta: {
        requiresAuth: true,
        title: 'All Customers'
      }
    }, {
      path: 'categories/:cat/allProducts',
      name: 'allProducts',
      component: __WEBPACK_IMPORTED_MODULE_26__components_admin_AllProducts__["a" /* default */],
      meta: {
        requiresAuth: true,
        title: 'Admin All Products'
      }
    }, {
      path: 'offers',
      name: 'offers',
      component: __WEBPACK_IMPORTED_MODULE_31__components_admin_Offers__["a" /* default */],
      meta: {
        requiresAuth: true,
        title: 'Admin Offers'
      }
    }, {
      path: 'offers/alloffers',
      name: 'alloffers',
      component: __WEBPACK_IMPORTED_MODULE_33__components_admin_AllOffers__["a" /* default */],
      meta: {
        requiresAuth: true,
        title: 'Admin All Offers'
      }
    }, {
      path: 'items',
      name: 'items',
      component: __WEBPACK_IMPORTED_MODULE_32__components_admin_Items__["a" /* default */],
      meta: {
        requiresAuth: true,
        title: 'Admin Items'
      }
    }, {
      path: 'items/allitems',
      name: 'allitems',
      component: __WEBPACK_IMPORTED_MODULE_34__components_admin_AllItems__["a" /* default */],
      meta: {
        requiresAuth: true,
        title: 'Admin All Items'
      }
    }, {
      path: 'orders',
      name: 'orders',
      component: __WEBPACK_IMPORTED_MODULE_37__components_admin_Orders__["a" /* default */],
      meta: {
        requiresAuth: true,
        title: 'Admin Orders'
      }
    }, {
      path: 'myshopin',
      name: 'myshopin',
      component: __WEBPACK_IMPORTED_MODULE_39__components_admin_MyShopin__["a" /* default */],
      meta: {
        requiresAuth: true,
        title: 'MY SHOPiN'
      }
    }, {
      path: 'categories/:cat/addproducts',
      name: 'categories',
      component: __WEBPACK_IMPORTED_MODULE_27__components_admin_Categories__["a" /* default */],
      meta: {
        requiresAuth: true,
        title: 'Admin Categories'
      }
    }, {
      path: 'categories/computers&mobiles/:cat/addproducts',
      name: 'mobiles',
      component: __WEBPACK_IMPORTED_MODULE_45__components_admin_Mobiles__["a" /* default */],
      meta: {
        requiresAuth: true,
        title: 'Admin Categories'
      }
    }, {
      path: 'categories/vehicles/:cat/addproducts',
      name: 'vehicles',
      component: __WEBPACK_IMPORTED_MODULE_46__components_admin_Vehicles__["a" /* default */],
      meta: {
        requiresAuth: true,
        title: 'Admin Categories'
      }
    }, {
      path: 'categories/:cat/product/edit/:product_id',
      name: 'editcommonproduct',
      component: __WEBPACK_IMPORTED_MODULE_28__components_admin_EditCommonProduct__["a" /* default */],
      meta: {
        requiresAuth: true,
        title: 'Admin  Edit Products'
      }
    }, {
      path: 'categories/computers&mobiles/:cat/product/edit/:product_id',
      name: 'editmobiles',
      component: __WEBPACK_IMPORTED_MODULE_29__components_admin_EditMobiles__["a" /* default */],
      meta: {
        requiresAuth: true,
        title: 'Admin  Edit Products'
      }
    }, {
      path: 'categories/vehicles/:cat/product/edit/:product_id',
      name: 'editvehicles',
      component: __WEBPACK_IMPORTED_MODULE_30__components_admin_EditVehicles__["a" /* default */],
      meta: {
        requiresAuth: true,
        title: 'Admin  Edit Products'
      }
    }, {
      path: 'payment',
      name: 'payment',
      component: __WEBPACK_IMPORTED_MODULE_36__components_admin_Payment__["a" /* default */],
      meta: {
        requiresAuth: true,
        title: 'Payment'
      }
    }]
  }],
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});

router.beforeEach(function (to, from, next) {
  document.title = to.meta.title;
  //check for requriedAuth
  if (to.matched.some(function (record) {
    return record.meta.requiresAuth;
  })) {
    if (!__WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].auth().currentUser) {
      //Go to Signin
      //console.log('user not')
      next({
        path: '/signin',
        query: {
          redirect: to.fullPath
        }
      });
    } else if (__WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].auth().currentUser.displayName == 'super admin' || __WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].auth().currentUser.displayName == 'editor') {
      next();
    } else if (__WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].auth().currentUser.displayName == 'shop owner') {

      //Proceed to route
      if (to.fullPath != '/admin-services' && to.fullPath != '/admin-services/dashboard' && to.fullPath != '/admin-services/admincontact' && to.fullPath != '/admin-services/adminhome' && to.fullPath != '/admin-services/adminabout' && to.fullPath != '/admin-services/services' && to.fullPath != '/admin-services/gallery' && to.fullPath != '/admin-services/myshopin' && to.fullPath != '/admin-services/services/allservices' && to.fullPath != '/myaccount' && to.fullPath != '/admin/items' && to.fullPath != '/admin/items/allitems') {
        //console.log('user else', firebase.auth().currentUser.displayName)
        // console.log('store.state.systemUser.isLogedIn', store.state.systemUser.isLogedIn, to, from)
        if (__WEBPACK_IMPORTED_MODULE_3__Store__["a" /* store */].state.systemUser.isLogedIn && from.fullPath.includes('admin')) {
          //console.log('store.state', from.fullPath)

          //********* NO NEED these role check bcz cant access refresh to verify user page ******
          // if (store.state.systemUser.role === 'Cashier') {
          //   if (to.fullPath == '/admin/createinvoice' || to.fullPath == '/admin/invoicelist' ||
          //     to.fullPath == '/admin/returns' || to.fullPath == '/admin/createbarcode') {
          //     next()
          //   }
          // } else if (store.state.systemUser.role === 'Shop Manager') {
          //   if (to.fullPath != '/admin/store-locations' && to.fullPath != '/admin/setting'
          //     && to.fullPath != '/admin/users') {
          //     next()
          //   }
          // } else next();
          next();
        }
        if (__WEBPACK_IMPORTED_MODULE_3__Store__["a" /* store */].state.systemUser.isLogedIn && !from.fullPath.includes('admin')) {
          if (to.path != '/admin/verify-user') {
            // console.log('redirect')
            next('/admin/verify-user');
          }
          if (to.path == '/admin/verify-user') {
            // console.log('redirect')
            next();
          }
        }
        if (!__WEBPACK_IMPORTED_MODULE_3__Store__["a" /* store */].state.systemUser.isLogedIn) {
          // if (to.fullPath != '/admin/verify-user') {
          //   return next()
          // }
          // console.log('!store.state', store.state, to.fullPath == '/admin/verify-user')
          if (to.path != '/admin/verify-user') {
            // console.log('redirect')
            next('/admin/verify-user');
          }
          if (to.path == '/admin/verify-user') {
            // console.log('redirect')
            next();
          }
        }
      }
      // if(to.fullPath == '/myaccount'){
      //   next();
      // }
    } else if (__WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].auth().currentUser.displayName == 'starterplan shop owner') {
      //Proceed to route
      if (
      // to.fullPath == '/admin' || to.fullPath == '/admin/dashboard'
      // || to.fullPath == '/admin/gallery' || to.fullPath == '/admin/orders'
      // || to.fullPath == '/admin/admincontact' || to.fullPath == '/admin/adminhome'
      // || to.fullPath == '/admin/gallery' || to.fullPath == '/admin/offers' || to.fullPath == '/admin/verify-user' || to.fullPath == '/admin/offers/alloffers' || to.fullPath == '/admin/items/allitems'
      // || to.fullPath == '/admin/myshopin' || to.fullPath == '/admin/payment' || to.fullPath == '/admin/setting'
      // || to.fullPath == '/admin/analytics' || to.fullPath == '/admin/managecategories'
      // || to.fullPath == '/admin/stock-summary' || to.fullPath == '/admin/createinvoice'
      // || to.fullPath == '/admin/invoicelist' || to.fullPath == '/admin/returns'
      // || to.fullPath == '/admin/users' || to.fullPath == '/admin/store-locations'
      // || to.name == 'allProducts' || to.name == 'categories' || to.name == 'editcommonproduct'

      // checking not allowed paths instead of above allowed paths

      to.fullPath !== '/admin/customers' || to.fullPath == '/admin/suppliers' || to.fullPath == '/admin/quotation-list' || to.fullPath == '/admin/create-quotation' || to.fullPath == '/admin/purchase-order-list' || to.fullPath == '/admin/create-purchase-order' || to.fullPath == '/admin/purchase-order-returns' || to.fullPath == '/admin/expenses' || to.fullPath == '/admin/expense-categories' || to.fullPath == '/admin/cash-flow-history' || to.fullPath == '/admin/cash-flow') {
        //console.log('user else', firebase.auth().currentUser.displayName)
        //console.log('user owner')stock-summary
        if (__WEBPACK_IMPORTED_MODULE_3__Store__["a" /* store */].state.systemUser.isLogedIn) {
          next();
        }
        if (!__WEBPACK_IMPORTED_MODULE_3__Store__["a" /* store */].state.systemUser.isLogedIn) {
          if (to.path != '/admin/verify-user') {
            // console.log('redirect')
            next('/admin/verify-user');
          }
          if (to.path == '/admin/verify-user') {
            // console.log('redirect')
            next();
          }
        }
      }
    } else if (__WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].auth().currentUser.displayName == 'page owner') {
      //Proceed to route
      if (to.fullPath == '/admin-services' || to.fullPath == '/admin-services/dashboard' || to.fullPath == '/admin-services/admincontact' || to.fullPath == '/admin-services/adminhome' || to.fullPath == '/admin-services/adminabout' || to.fullPath == '/admin-services/services' || to.fullPath == '/admin-services/gallery' || to.fullPath == '/admin-services/myshopin' || to.fullPath == '/admin-services/services/allservices') {
        //console.log('user else', firebase.auth().currentUser.displayName)
        //console.log('user owner')
        next();
      }
    } else if (__WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].auth().currentUser.displayName == null) {
      //Proceed to route
      if (to.fullPath == '/myaccount') {
        //console.log('user else', firebase.auth().currentUser.displayName)
        //console.log('user owner')
        next();
      }
    }
    // else if(firebase.auth().currentUser && !firebase.auth().currentUser.emailVerified){
    //   //Proceed to route
    //   //console.log('user else', firebase.auth().currentUser.displayName)
    //   //console.log('user else', firebase.auth().currentUser.emailVerified)
    //   //console.log('user else', firebase.auth().currentUser)
    //   //console.log('user owner')
    //   next({
    //     path: '/verifyemail',
    //     query: {
    //       redirect: to.fullPath
    //     }
    //   });
    // }
    else {
        //console.log('user else', firebase.auth().currentUser)
        //console.log('user else', firebase.auth().currentUser.displayName)
        // next({
        //   path: '/myaccount',
        //   query: {
        //     redirect: to.fullPath
        //   }
        // });
      }
  } else if (to.matched.some(function (record) {
    return record.meta.requiresGuest;
  })) {
    if (__WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].auth().currentUser) {
      if (__WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].auth().currentUser.displayName == 'shop owner') {
        //console.log('user owner')
        next({
          path: '/admin/dashboard',
          query: {
            redirect: to.fullPath
          }
        });
      } else if (__WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].auth().currentUser.displayName == 'starterplan shop owner') {
        //console.log('user owner')
        next({
          path: '/admin/dashboard',
          query: {
            redirect: to.fullPath
          }
        });
      } else if (__WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].auth().currentUser.displayName == 'page owner') {
        //console.log('user owner')
        next({
          path: '/admin-services/dashboard',
          query: {
            redirect: to.fullPath
          }
        });
      } else if (__WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].auth().currentUser.displayName == null) {
        //console.log('user else', firebase.auth().currentUser.emailVerified)
        next({
          path: '/myaccount',
          query: {
            redirect: to.fullPath
          }
        });
      }
    } else {
      //Proceed to route
      //console.log('user not guest')
      next();
    }
  } else if (to.matched.some(function (record) {
    return record.name === 'regshop';
  })) {
    if (__WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].auth().currentUser) {
      if (__WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].auth().currentUser.displayName == 'shop owner' || __WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].auth().currentUser.displayName == 'starterplan shop owner') {
        console.log('user owner');
        router.push("/admin");
      } else if (__WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].auth().currentUser.displayName == null) {
        //console.log('user else', firebase.auth().currentUser.emailVerified)
        router.push("/myaccount");
      } else {
        next();
      }
    } else {
      next();
    }
  } else {
    //Proceed to route
    //console.log('user is')
    next();
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_FirebaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "manage",
  data: function data() {
    return {
      emptyText: "Loading Records...",
      items: [],
      fields: ["index", { key: "name", label: "Name", sortable: true }, { key: "regtel", label: "Telephone", sortable: false }, { key: "config", label: "Config", sortable: true }, { key: "location", label: "City", sortable: true }, { key: "cat", label: "Cat", sortable: true }, { key: "rank", label: "Rank", sortable: true }, { key: "products", label: "#Prd", sortable: true }, { key: "district", label: "District", sortable: true }, { key: "shoptype", label: "Type", sortable: true }, { key: "regemail", label: "Email", sortable: true }, { key: "created", label: "Registered", sortable: true },
      // { key: 'owner', label: 'Owner', sortable: true },
      { key: "actions", label: "Actions" }],
      currentPage: 1,
      perPage: 10,
      totalRows: items.length,
      pageOptions: [10, 25, 50, 100, 300, 500, 1000],
      sortBy: null,
      sortDesc: false,
      filter: null,
      loading: false,
      loading1: false,
      loading2: false,
      changed: true,
      inputObj: "",
      config: {},
      pidNO: 0,
      cusNO: 0,
      dialogFormVisible: false,
      width: "50%",
      prdstat: {}
    };
  },


  computed: {
    sortOptions: function sortOptions() {
      // Create an options list from our fields
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return { text: f.label, value: f.key };
      });
    }
  },
  methods: {
    getStat: function getStat() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__config_FirebaseInit__["a" /* default */].collection("aaa").doc("pid").get().then(function (doc) {
        _this.pidNO = doc.data().pidNo;
        _this.cusNO = doc.data().cusNo;
        alert("pidno " + doc.data().pidNo + " cusno " + doc.data().cusNo);
      }).catch(function (error) {
        return alert(error);
      });
    },
    upShop: function upShop(id, item) {
      __WEBPACK_IMPORTED_MODULE_0__config_FirebaseInit__["a" /* default */].collection("shops").doc(id).update({
        rank: item.rank,
        search: item.search
      }).then(function (doc) {
        alert("shop updated");
      }).catch(function (error) {
        return alert(error);
      });
    },
    getprd: function getprd(id, owner, item) {
      var secondary = __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].initializeApp(item.fullconfig, id);
      this.$store.state.secondaryDatabase = secondary.firestore();
      // this.$store.state.secondaryApp = this.$route.params.storename
      this.$store.state.secondaryDatabase.settings({
        timestampsInSnapshots: true
      });
      this.$store.state.secondaryDatabase.enablePersistence({ synchronizeTabs: true }).then(function () {
        //console.log("Woohoo! Multi-Tab Persistence!");
      });
      this.$store.state.secondaryDatabase.collection("shops").doc(owner).get().then(function (doc) {
        var catValues = doc.data().catValues;
        var sum = 0;
        for (var key in catValues) {
          sum += catValues[key];
        }
        //data.products = sum
        alert("prd sum is " + sum);
      }).catch(function (error) {
        return console.log(error);
      });
    },
    upStat: function upStat() {
      __WEBPACK_IMPORTED_MODULE_0__config_FirebaseInit__["a" /* default */].collection("aaa").doc("pid").update({
        pidNo: this.pidNO,
        cusNo: this.cusNO
      }).then(function (doc) {
        alert("pidno & cusno updated");
      }).catch(function (error) {
        return alert(error);
      });
    },
    onFiltered: function onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    upConfig: function upConfig(id, owner, item) {
      var _this2 = this;

      this.loading = true;
      this.changed = false;
      this.config.projectId = this.inputObj;
      console.log("this.config", this.config["projectId"]);
      if (this.config.projectId) {
        this.config.authDomain = this.config.projectId + ".firebaseapp.com";
        this.config.databaseURL = "https://" + this.config.projectId + ".firebaseio.com";
        this.config.storageBucket = this.config.projectId + ".appspot.com";
        __WEBPACK_IMPORTED_MODULE_0__config_FirebaseInit__["a" /* default */].collection("shops").doc(id).update({
          config: this.config,
          hasconfig: true
        }).then(function (doc) {
          __WEBPACK_IMPORTED_MODULE_0__config_FirebaseInit__["a" /* default */].collection("shops").doc(id).get().then(function (doc) {
            console.log(doc.data());
            var data = doc.data();
            var secondary = __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].initializeApp(_this2.config, id);
            _this2.$store.state.secondaryDatabase = secondary.firestore();
            // this.$store.state.secondaryApp = this.$route.params.storename
            _this2.$store.state.secondaryDatabase.settings({
              timestampsInSnapshots: true
            });
            _this2.$store.state.secondaryDatabase.enablePersistence({ synchronizeTabs: true }).then(function () {
              //console.log("Woohoo! Multi-Tab Persistence!");
            });
            _this2.$store.state.secondaryDatabase.collection("shops").doc(owner).set(data).then(function (id) {
              console.log("secondaryDB shop id", id);
            }).catch(function (error) {
              return alert(error);
            });
            alert("Project Id Updated");
            _this2.loading = false;
            _this2.changed = true;
          }).catch(function (error) {
            return alert(error);
          });
        }).catch(function (error) {
          return alert(error);
        });
      } else {
        alert("Please enter valid config object");
        this.loading = false;
        this.changed = true;
      }
    }
  },
  created: function created() {
    var _this3 = this;

    this.loading1 = true;
    this.changed = false;
    if (screen.width > 767) {
      this.width = "50%";
    } else {
      this.width = "85%";
    }
    // if(this.$store.state.users.length != 0){
    //     this.items = this.$store.state.users
    //     this.loading1 = false
    //     this.changed = true
    // }else{
    __WEBPACK_IMPORTED_MODULE_0__config_FirebaseInit__["a" /* default */].collection("shops").get().then(function (querySnapshot) {
      querySnapshot.forEach(function (doc) {
        var data = {
          id: doc.id,
          name: doc.data().name,
          regemail: doc.data().regemail,
          created: doc.data().created.toDate().toLocaleString(),
          regtel: doc.data().regtel,
          cus: doc.data().cus,
          config: doc.data().config.projectId,
          fullconfig: doc.data().config,
          hasconfig: doc.data().hasconfig,
          district: doc.data().district,
          location: doc.data().location,
          cat: doc.data().cat,
          shoptype: doc.data().shoptype,
          owner: doc.data().owner,
          rank: doc.data().rank,
          search: doc.data().search
        };

        _this3.items.push(data);
        //this.$store.state.users = this.items
      });
      if (_this3.items.length == 0) {
        _this3.emptyText = "There are no records to show";
      }
      __WEBPACK_IMPORTED_MODULE_0__config_FirebaseInit__["a" /* default */].collection("aaa").doc("prdstat").get().then(function (doc) {
        _this3.prdstat = doc.data().prdno;
      });
      _this3.loading1 = false;
      _this3.changed = true;
    });
    //}
  }
});

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_FirebaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_cities__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_maincategories__ = __webpack_require__(85);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "search",
  data: function data() {
    return {
      cities: [{
        value: "Colombo",
        label: "Colombo",

        children: [{
          value: "Embilipitiya",
          label: "Embilipitiya"
        }]
      }, {
        value: "Kandy",
        label: "Kandy",

        children: [{
          value: "Katugastota",
          label: "Katugastota"
        }, {
          value: "Awissawella",
          label: "Awissawella"
        }]
      }],

      categories: [{
        value: "Fashion",
        label: "Fashion"
      }, {
        value: "Home Appliances",
        label: "Home Appliances",

        children: [{
          value: "Home Electronics",
          label: "Home Electronics"
        }, {
          value: "Lighting & Electrical",
          label: "Lighting & Electrical"
        }]
      }, {
        value: "Clothing",
        label: "Clothing",

        children: [{
          value: "Fashion",
          label: "Fashion"
        }]
      }],
      city: [],
      cat: [],
      loading: false,
      loading1: true,
      fetch: false,
      noresults: false,
      shops: [],
      category: undefined,
      location: undefined,
      sortby: "",
      curprods: "",
      labelPosition: "left",
      links: [],
      isVisible: false,
      lastVisible: "",
      moreshops: undefined,
      user: false,
      visitor: false,
      admin: false,
      starterplanadmin: false,
      pageadmin: false,
      modalShow: false,
      modalShow0: false,
      modalShow1: false,
      modalShow2: false,
      datanotify: "Add to My SHOPiN",
      favshops: [],
      isFavShop: "show",
      fsfetched: false,
      param: "",
      place: ""
    };
  },

  watch: {
    $route: function $route(to, from) {
      var _this = this;

      //console.log('route change', this.$route.query.cat)
      this.noresults = false;
      this.shops = [];
      this.moreshops = undefined;
      this.loading = true;
      this.fetch = false;
      this.city = [];
      this.cat = [];
      this.category = this.$route.query.cat;
      this.location = this.$route.query.loc;

      if (this.$route.query.loc == "All of Colombo") {
        this.param = "district";
        this.place = "Colombo";
      } else if (this.$route.query.loc == "All of Kandy") {
        this.param = "district";
        this.place = "Kandy";
      } else if (this.$route.query.loc == "All of Gampaha") {
        this.param = "district";
        this.place = "Gampaha";
      } else if (this.$route.query.loc == "All of Kurunegala") {
        this.param = "district";
        this.place = "Kurunegala";
      } else if (this.$route.query.loc == "All of Kalutara") {
        this.param = "district";
        this.place = "Kalutara";
      } else if (this.$route.query.loc == "All of Ratnapura") {
        this.param = "district";
        this.place = "Ratnapura";
      } else if (this.$route.query.loc == "All of Galle") {
        this.param = "district";
        this.place = "Galle";
      } else if (this.$route.query.loc == "All of Anuradhapura") {
        this.param = "district";
        this.place = "Anuradhapura";
      } else if (this.$route.query.loc == "All of Kegalle") {
        this.param = "district";
        this.place = "Kegalle";
      } else if (this.$route.query.loc == "All of Badulla") {
        this.param = "district";
        this.place = "Badulla";
      } else if (this.$route.query.loc == "All of Matara") {
        this.param = "district";
        this.place = "Matara";
      } else if (this.$route.query.loc == "All of Puttalam") {
        this.param = "district";
        this.place = "Puttalam";
      } else if (this.$route.query.loc == "All of Ampara") {
        this.param = "district";
        this.place = "Ampara";
      } else if (this.$route.query.loc == "All of Hambantota") {
        this.param = "district";
        this.place = "Hambantota";
      } else if (this.$route.query.loc == "All of Jaffna") {
        this.param = "district";
        this.place = "Jaffna";
      } else if (this.$route.query.loc == "All of Batticaloa") {
        this.param = "district";
        this.place = "Batticaloa";
      } else if (this.$route.query.loc == "All of Matale") {
        this.param = "district";
        this.place = "Matale";
      } else if (this.$route.query.loc == "All of Monaragala") {
        this.param = "district";
        this.place = "Monaragala";
      } else if (this.$route.query.loc == "All of Polonnaruwa") {
        this.param = "district";
        this.place = "Polonnaruwa";
      } else if (this.$route.query.loc == "All of Trincomalee") {
        this.param = "district";
        this.place = "Trincomalee";
      } else if (this.$route.query.loc == "All of Vavuniya") {
        this.param = "district";
        this.place = "Vavuniya";
      } else if (this.$route.query.loc == "All of Mannar") {
        this.param = "district";
        this.place = "Mannar";
      } else if (this.$route.query.loc == "All of Mullativu") {
        this.param = "district";
        this.place = "Mullativu";
      } else if (this.$route.query.loc == "All of Nuwara Eliya") {
        this.param = "district";
        this.place = "Nuwara Eliya";
      } else if (this.$route.query.loc == "All of Kilinochchi") {
        this.param = "district";
        this.place = "Kilinochchi";
      } else if (this.$route.query.loc == "All of Sri Lanka") {
        this.param = "hasconfig";
        this.place = true;
      } else {
        this.param = "location";
        this.place = this.$route.query.loc;
      }
      this.$store.state.searchParam = this.param;
      this.$store.state.searchLocation = this.$route.query.loc;
      if (this.$route.fullPath != "/search") {
        //console.log('this. route change', this.$route.query.cat)
        // this.loading = true
        // this.fetch = false
        //console.log('this.loading', this.loading)

        if (!this.$store.state.searchResults[this.$route.query.cat]) {
          this.$store.state.searchResults[this.$route.query.cat] = {};
          // this.$store.state.searchResults[this.param][this.place]['results']
        }
        if (!this.$store.state.searchResults[this.$route.query.cat][this.$route.query.loc]) {
          this.$store.state.searchResults[this.$route.query.cat][this.$route.query.loc] = {};
          // this.$store.state.searchResults[this.param][this.place]['results']
        }
        if (this.$store.state.searchResults[this.$route.query.cat][this.$route.query.loc]["results"] != undefined) {
          this.shops = this.$store.state.searchResults[this.$route.query.cat][this.$route.query.loc]["results"];
          this.lastVisible = this.$store.state.searchResults[this.$route.query.cat][this.$route.query.loc]["lastVisible"];
          if (this.shops.length >= 20) {
            this.moreshops = "show";
          }
          this.loading = false;
          this.fetch = true;
          //console.log('results from store')
        } else {
          __WEBPACK_IMPORTED_MODULE_0__config_FirebaseInit__["a" /* default */].collection("shops").where("cat", "==", this.$route.query.cat).where(this.param, "==", this.place).where("permission", "==", "allowed").where("search", "==", "yes").orderBy("rank").orderBy("visits", "desc").limit(20).get().then(function (querySnapshot) {
            querySnapshot.forEach(function (doc) {
              var data = {
                id: doc.id,
                name: doc.data().name,
                shoptype: doc.data().shoptype,
                location: doc.data().location,
                owner: doc.data().owner,
                visits: doc.data().visits,
                homeimg: doc.data().homeimg,
                plan: doc.data().plan,
                details: doc.data().details,
                isfavshop: false,
                isHosted: doc.data().isHosted,
                domain: doc.data().domain,
                isCloned: doc.data().isCloned,
                realOwner: doc.data().realOwner,
                regtel: doc.data().regtel
              };
              if (doc.data().homeimg != undefined) {
                data.homeimg = doc.data().homeimg;
              } else {
                data.homeimg = "../../static/images/ecommerce.jpg";
              }
              _this.shops.push(data);
              //console.log(this.shops)
            });
            var findFavShop = function findFavShop(fshops, id) {
              var findedid = fshops.find(function (fs, index) {
                return fs == id;
              });
              return findedid;
            };
            if (__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser) {
              _this.shops.forEach(function (shop) {
                var isFavShop = findFavShop(_this.favshops[0].favshops, shop.id);
                //console.log('isFavShop',this.isFavShop)
                if (isFavShop == shop.id) {
                  shop.isfavshop = true;
                }
              });
            }
            _this.loading = false;
            _this.fetch = true;
            if (querySnapshot.docs.length == 0) {
              _this.noresults = true;
              _this.lastVisible = undefined;
              //console.log("noresults", this.noresults);
            }
            if (querySnapshot.docs.length > 0) {
              _this.noresults = false;
              _this.lastVisible = querySnapshot.docs[querySnapshot.docs.length - 1];
              _this.$store.state.searchResults[_this.$route.query.cat][_this.$route.query.loc]["results"] = _this.shops;
              _this.$store.state.searchResults[_this.$route.query.cat][_this.$route.query.loc]["lastVisible"] = _this.lastVisible;
              //console.log("noresults", this.noresults);
            }

            //console.log(" moreitems last", this.lastVisible);
            //console.log(" moreitems snapshot.length", querySnapshot.docs.length);
            if (querySnapshot.docs.length == 20) {
              _this.moreshops = "show";
              //console.log("last", this.moreshops);
            }
          });
        }
      } else if (this.$route.fullPath == "/search") {
        this.cat = undefined;
        this.city = undefined;
        this.fetch = true;
        this.loading = false;
        //console.log("this.fetch", this.fetch);
      } else {
        this.category = undefined;
        this.location = undefined;
        this.fetch = true;
        this.loading = false;
        //console.log("this.fetch", this.fetch);
      }
    }
  },
  methods: {
    selectCat: function selectCat(value) {
      //console.log(value)
      if (value.length == 1) {
        this.category = value[0];
        //console.log('this.searchForm.category',this.category)
      } else if (value.length == 2) {
        this.category = value[1];
        //console.log('this.searchForm.category',this.category)
      } else if (value.length == 0) {
        this.category = undefined;
      }
    },
    handleChange: function handleChange(value) {
      //console.log(value)
      if (value.length == 1) {
        this.location = value[0];
      } else if (value.length == 2) {
        this.location = value[1];
      }
      //console.log('this.searchForm.location',this.location)
    },
    logout: function logout() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().signOut().then(function () {
        _this2.$router.push("/");
      });
    },
    showme: function showme() {
      if (this.category == undefined || this.location == undefined) {
        this.modalShow = true;
      } else {
        this.$router.push({
          name: "search",
          query: { cat: this.category, loc: this.location }
        });
      }
    },

    // resetLoc(){
    //   //console.log("set loc");
    //   this.location = ''
    // },
    setRoute: function setRoute() {
      var _this3 = this;

      //console.log("setRoute");
      this.$route.query.cat = this.category;
      this.$route.query.loc = this.location;
      if (this.$route.query.cat == undefined || this.$route.query.loc == undefined) {
        this.modalShow = true;
        this.noresults = false;
      } else if (this.$route.query.cat != undefined && this.$route.query.loc != undefined) {
        //console.log("setRoute if true", this.$route.query)
        //console.log('route change', this.$route.query.cat)
        this.noresults = false;
        this.shops = [];
        this.lastVisible = undefined;
        __WEBPACK_IMPORTED_MODULE_0__config_FirebaseInit__["a" /* default */].collection("shops").where("cat", "==", this.$route.query.cat).where("location", "==", this.$route.query.loc).where("permission", "==", "allowed").where("search", "==", "yes").orderBy("rank").orderBy("visits", "desc").limit(20).onSnapshot(function (querySnapshot) {
          _this3.shops = [];
          querySnapshot.forEach(function (doc) {
            var data = {
              id: doc.id,
              name: doc.data().name,
              shoptype: doc.data().shoptype,
              location: doc.data().location,
              owner: doc.data().owner,
              visits: doc.data().visits,
              homeimg: doc.data().homeimg,
              plan: doc.data().plan,
              details: doc.data().details
            };
            _this3.shops.push(data);
            //console.log(this.shops)
            _this3.loading = false;
            _this3.fetch = true;
          });
          if (querySnapshot.docs.length == 0) {
            _this3.noresults = true;
            _this3.lastVisible = undefined;
            //console.log("noresults", this.noresults);
          }
          _this3.lastVisible = querySnapshot.docs[querySnapshot.docs.length - 1];
          //console.log(" moreitems last", this.lastVisible);
          //console.log(" moreitems snapshot.length", querySnapshot.docs.length);
          if (querySnapshot.docs.length < 20) {
            _this3.lastVisible = undefined;
            //console.log("last", this.lastVisible);
          }
        });
      }
    },
    userVisits: function userVisits(n) {
      if (__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser) {
        if (__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.displayName == "shop owner" || __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.displayName == "starterplan shop owner") {
          var newVisits = this.shops[n].visits;
        }
        if (__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.displayName == "page owner" || __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.displayName == null) {
          var newVisits = this.shops[n].visits + 1;
          //console.log('newvists', newVisits)
          __WEBPACK_IMPORTED_MODULE_0__config_FirebaseInit__["a" /* default */].collection("shops").doc(this.shops[n].id).update({
            visits: newVisits
          }).then(function () {
            //console.log('newvists', newVisits)
          }).catch(function (error) {
            //console.log('error',error)
          });
        }
      } else {
        // var newVisits = this.shops[n].visits + 1
        // //console.log('newvists', newVisits)
        //  db.collection('shops').doc(this.shops[n].id)
        // .update({
        //   visits: newVisits
        // })
        // .then(() => //console.log('newvists', newVisits))
        // .catch(error => //console.log('error',error))
      }
    },
    addToFavourite: function addToFavourite(shop) {
      if (!__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser) {
        this.modalShow0 = true;
      }
      if (__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser) {
        // if(firebase.auth().currentUser.displayName == 'shop owner'){
        // 	this.modalShow = true
        // }else{
        if (this.favshops[0].favshops.length <= 25) {
          this.favshops[0].favshops.push(shop.id);
          //console.log('favsp updated', this.favshops[0].favshops)
          shop.isfavshop = true;
          this.modalShow2 = true;
          __WEBPACK_IMPORTED_MODULE_0__config_FirebaseInit__["a" /* default */].collection("users").doc(this.favshops[0].docid).update({
            favshops: this.favshops[0].favshops
          }).then(function () {
            //console.log('')
          }).catch(function (error) {
            //console.log('error',error)
          });
        } else {
          this.modalShow1 = true;
        }
        //}
      }
      // else if(firebase.auth().currentUser && !firebase.auth().currentUser.emailVerified){
      // 	this.modalShow0 = true
      // }
    },
    submitForm: function submitForm(formName) {},
    querySearch: function querySearch(queryString, cb) {
      var links = this.links;
      var results = queryString ? links.filter(this.createFilter(queryString)) : links;
      // call callback function to return suggestions
      cb(results);
    },
    createFilter: function createFilter(queryString) {
      return function (link) {
        return link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },
    handleSelect: function handleSelect(item) {
      //console.log('item is',item)
      //console.log(this.location)
      //console.log(this.category)
    },


    //  initToTopButton: function() {
    //   $(document).bind('scroll', function() {
    //     var backToTopButton = $('.goTop');
    //     if ($(document).scrollTop() > 250) {
    //       backToTopButton.addClass('isVisible');
    //       this.isVisible = true;
    //     } else {
    //       backToTopButton.removeClass('isVisible');
    //       this.isVisible = false;
    //     }
    //   }.bind(this));
    // },
    // backToTop: function() {
    //   $('html,body').stop().animate({
    //     scrollTop: 0
    //   }, 'slow', 'swing');
    // },

    moreItems: function moreItems() {
      var _this4 = this;

      if (this.lastVisible != undefined) {
        this.loading1 = false;
        //this.fetch = false
        __WEBPACK_IMPORTED_MODULE_0__config_FirebaseInit__["a" /* default */].collection("shops").where("cat", "==", this.$route.query.cat).where(this.param, "==", this.place).where("permission", "==", "allowed").where("search", "==", "yes").orderBy("rank").orderBy("visits", "desc").startAfter(this.lastVisible).limit(20).get().then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            var data = {
              id: doc.id,
              name: doc.data().name,
              shoptype: doc.data().shoptype,
              location: doc.data().location,
              owner: doc.data().owner,
              visits: doc.data().visits,
              homeimg: doc.data().homeimg,
              plan: doc.data().plan,
              details: doc.data().details,
              isfavshop: false,
              isHosted: doc.data().isHosted,
              domain: doc.data().domain,
              isCloned: doc.data().isCloned,
              realOwner: doc.data().realOwner,
              regtel: doc.data().regtel
            };
            if (doc.data().homeimg != undefined) {
              data.homeimg = doc.data().homeimg;
            } else {
              data.homeimg = "../../static/images/ecommerce.jpg";
            }
            _this4.shops.push(data);
            //console.log(this.shops)
          });
          var findFavShop = function findFavShop(fshops, id) {
            var findedid = fshops.find(function (fs, index) {
              return fs == id;
            });
            return findedid;
          };
          if (__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser) {
            _this4.shops.forEach(function (shop) {
              var isFavShop = findFavShop(_this4.favshops[0].favshops, shop.id);
              //console.log('isFavShop',this.isFavShop)
              if (isFavShop == shop.id) {
                shop.isfavshop = true;
              }
            });
          }
          _this4.loading1 = true;
          //this.fetch = true
          if (querySnapshot.docs.length > 0) {
            _this4.lastVisible = querySnapshot.docs[querySnapshot.docs.length - 1];
            _this4.$store.state.searchResults[_this4.$route.query.cat][_this4.$route.query.loc]["lastVisible"] = _this4.lastVisible;
            //console.log("noresults", this.lastVisible);
          }
          //console.log(" moreitems last", this.lastVisible);
          //console.log(" moreitems snapshot.length", querySnapshot.docs.length);
          if (querySnapshot.docs.length < 20) {
            _this4.moreshops = undefined;
            //console.log("last", this.moreshops);
          }
        });
      }
    }
  },
  beforeCreate: function beforeCreate() {
    var _this5 = this;

    if (__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser) {
      __WEBPACK_IMPORTED_MODULE_0__config_FirebaseInit__["a" /* default */].collection("users").where("uid", "==", __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.uid).onSnapshot(function (querySnapshot) {
        _this5.favshops = [];
        querySnapshot.forEach(function (doc) {
          var data = {
            favshops: doc.data().favshops,
            docid: doc.id
          };
          _this5.favshops.push(data);
          _this5.fsfetched = true;
          //console.log('favshops',this.favshops)
        });
      });
    }
  },
  created: function created() {
    var _this6 = this;

    this.cities = __WEBPACK_IMPORTED_MODULE_2__data_cities__["a" /* default */];
    this.categories = __WEBPACK_IMPORTED_MODULE_3__data_maincategories__["a" /* default */];
    if (__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser) {
      if (__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.displayName == null) {
        this.user = true;
      } else if (__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.displayName == "shop owner" || __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.displayName == "starterplan shop owner") {
        this.admin = true;
      } else if (__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.displayName == "page owner") {
        this.pageadmin = true;
      }
    } else {
      this.visitor = true;
    }

    this.$nextTick(function () {
      //this.initToTopButton();
    });
    // this.backToTop()
    //console.log('this.route', this.$route)
    //console.log('this.loading', this.loading)
    // this.cat[0] = this.$route.query.cat
    // this.city[0] = this.$route.query.
    this.category = this.$route.query.cat;
    this.location = this.$route.query.loc;

    if (this.$route.fullPath != "/search") {
      //console.log('this.loading', this.$route.query.cat)
      if (this.$route.query.loc == "All of Colombo") {
        this.param = "district";
        this.place = "Colombo";
      } else if (this.$route.query.loc == "All of Kandy") {
        this.param = "district";
        this.place = "Kandy";
      } else if (this.$route.query.loc == "All of Gampaha") {
        this.param = "district";
        this.place = "Gampaha";
      } else if (this.$route.query.loc == "All of Kurunegala") {
        this.param = "district";
        this.place = "Kurunegala";
      } else if (this.$route.query.loc == "All of Kalutara") {
        this.param = "district";
        this.place = "Kalutara";
      } else if (this.$route.query.loc == "All of Ratnapura") {
        this.param = "district";
        this.place = "Ratnapura";
      } else if (this.$route.query.loc == "All of Galle") {
        this.param = "district";
        this.place = "Galle";
      } else if (this.$route.query.loc == "All of Anuradhapura") {
        this.param = "district";
        this.place = "Anuradhapura";
      } else if (this.$route.query.loc == "All of Kegalle") {
        this.param = "district";
        this.place = "Kegalle";
      } else if (this.$route.query.loc == "All of Badulla") {
        this.param = "district";
        this.place = "Badulla";
      } else if (this.$route.query.loc == "All of Matara") {
        this.param = "district";
        this.place = "Matara";
      } else if (this.$route.query.loc == "All of Puttalam") {
        this.param = "district";
        this.place = "Puttalam";
      } else if (this.$route.query.loc == "All of Ampara") {
        this.param = "district";
        this.place = "Ampara";
      } else if (this.$route.query.loc == "All of Hambantota") {
        this.param = "district";
        this.place = "Hambantota";
      } else if (this.$route.query.loc == "All of Jaffna") {
        this.param = "district";
        this.place = "Jaffna";
      } else if (this.$route.query.loc == "All of Batticaloa") {
        this.param = "district";
        this.place = "Batticaloa";
      } else if (this.$route.query.loc == "All of Matale") {
        this.param = "district";
        this.place = "Matale";
      } else if (this.$route.query.loc == "All of Monaragala") {
        this.param = "district";
        this.place = "Monaragala";
      } else if (this.$route.query.loc == "All of Polonnaruwa") {
        this.param = "district";
        this.place = "Polonnaruwa";
      } else if (this.$route.query.loc == "All of Trincomalee") {
        this.param = "district";
        this.place = "Trincomalee";
      } else if (this.$route.query.loc == "All of Vavuniya") {
        this.param = "district";
        this.place = "Vavuniya";
      } else if (this.$route.query.loc == "All of Mannar") {
        this.param = "district";
        this.place = "Mannar";
      } else if (this.$route.query.loc == "All of Mullativu") {
        this.param = "district";
        this.place = "Mullativu";
      } else if (this.$route.query.loc == "All of Nuwara Eliya") {
        this.param = "district";
        this.place = "Nuwara Eliya";
      } else if (this.$route.query.loc == "All of Kilinochchi") {
        this.param = "district";
        this.place = "Kilinochchi";
      } else if (this.$route.query.loc == "All of Sri Lanka") {
        this.param = "hasconfig";
        this.place = true;
      } else {
        this.param = "location";
        this.place = this.$route.query.loc;
      }

      if (this.$route.query.cat == "Vehicles") {
        this.curprods = 5;
      } else {
        this.curprods = 25;
      }
      this.loading = true;
      this.fetch = false;
      this.$store.state.searchParam = this.param;
      this.$store.state.searchLocation = this.$route.query.loc;
      //console.log('this.loading', this.loading)
      if (!this.$store.state.searchResults[this.$route.query.cat]) {
        this.$store.state.searchResults[this.$route.query.cat] = {};
        // this.$store.state.searchResults[this.param][this.place]['results']
      }
      if (!this.$store.state.searchResults[this.$route.query.cat][this.$route.query.loc]) {
        this.$store.state.searchResults[this.$route.query.cat][this.$route.query.loc] = {};
        // this.$store.state.searchResults[this.param][this.place]['results']
      }
      if (this.$store.state.searchResults[this.$route.query.cat][this.$route.query.loc]["results"] != undefined) {
        this.shops = this.$store.state.searchResults[this.$route.query.cat][this.$route.query.loc]["results"];
        this.lastVisible = this.$store.state.searchResults[this.$route.query.cat][this.$route.query.loc]["lastVisible"];
        if (this.shops.length >= 20) {
          this.moreshops = "show";
        }
        this.loading = false;
        this.fetch = true;
        //console.log('results from store')
      } else {
        __WEBPACK_IMPORTED_MODULE_0__config_FirebaseInit__["a" /* default */].collection("shops").where("cat", "==", this.$route.query.cat).where(this.param, "==", this.place).where("permission", "==", "allowed").where("search", "==", "yes").orderBy("rank").orderBy("visits", "desc").limit(20).get().then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            var data = {
              id: doc.id,
              name: doc.data().name,
              shoptype: doc.data().shoptype,
              location: doc.data().location,
              owner: doc.data().owner,
              visits: doc.data().visits,
              homeimg: doc.data().homeimg,
              plan: doc.data().plan,
              details: doc.data().details,
              isfavshop: false,
              isHosted: doc.data().isHosted,
              domain: doc.data().domain,
              isCloned: doc.data().isCloned,
              realOwner: doc.data().realOwner,
              regtel: doc.data().regtel
            };
            if (doc.data().homeimg != undefined) {
              data.homeimg = doc.data().homeimg;
            } else {
              data.homeimg = "../../static/images/ecommerce.jpg";
            }
            _this6.shops.push(data);
            //console.log(this.shops)
            var findFavShop = function findFavShop(fshops, id) {
              var findedid = fshops.find(function (fs, index) {
                return fs == id;
              });
              return findedid;
            };
            if (__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser && _this6.fsfetched) {
              _this6.shops.forEach(function (shop) {
                var isFavShop = findFavShop(_this6.favshops[0].favshops, shop.id);
                //console.log('isFavShop',this.isFavShop)
                if (isFavShop == shop.id) {
                  shop.isfavshop = true;
                }
              });
            }
          });

          _this6.loading = false;
          _this6.fetch = true;
          //console.log('fetched from created')
          if (querySnapshot.docs.length == 0) {
            _this6.noresults = true;
            _this6.lastVisible = undefined;
            //console.log("noresults", this.noresults);
          }
          if (querySnapshot.docs.length > 0) {
            _this6.noresults = false;
            _this6.lastVisible = querySnapshot.docs[querySnapshot.docs.length - 1];
            _this6.$store.state.searchResults[_this6.$route.query.cat][_this6.$route.query.loc]["results"] = _this6.shops;
            _this6.$store.state.searchResults[_this6.$route.query.cat][_this6.$route.query.loc]["lastVisible"] = _this6.lastVisible;
            //console.log("noresults", this.noresults);
          }

          //console.log(" moreitems last", this.lastVisible);
          //console.log(" moreitems snapshot.length", querySnapshot.docs.length);
          if (querySnapshot.docs.length == 20) {
            _this6.moreshops = "show";
            //console.log("last", this.moreshops);
          }
        });
      }
    } else if (this.$route.fullPath == "/search") {
      this.fetch = true;
      this.loading = false;
      //console.log("this.fetch", this.fetch);
    } else {
      this.fetch = true;
      this.loading = false;
      //console.log("this.fetch", this.fetch);
    }
  },
  mounted: function mounted() {
    // this.links = towns;
  }
});

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_FirebaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_cities__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_caticons__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_maincategories__ = __webpack_require__(85);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "startstore",
  data: function data() {
    return {
      isVisible: false,
      user: false,
      visitor: false,
      admin: false,
      editor: false,
      deferredPrompt: false,
      starterplanadmin: false,
      pageadmin: false,
      searchForm: {
        category: undefined,
        location: undefined,
        shopname: ""
      },
      modalShow: false,
      labelPosition: "left",
      cities: [],
      categories: [],
      city: [],
      cat: [],
      loading: false,
      fetched: false,
      topshops: [],
      shopcats: ["Supermarket", "Clothing", "Shoes & Footwear", "Mobiles & Tablets"]
    };
  },

  methods: {
    logout: function logout() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().signOut().then(function () {
        _this.$router.push("/");
      });
    },
    showme: function showme() {
      if (this.searchForm.category == undefined || this.searchForm.location == undefined) {
        this.modalShow = true;
      } else {
        this.$router.push({
          name: "search",
          query: {
            cat: this.searchForm.category,
            loc: this.searchForm.location
          }
        });
      }
    },
    showDialog: function showDialog(shop) {
      this.$router.push({
        name: "storehome",
        params: { storename: shop.owner }
      });
    },
    selectCat: function selectCat(value) {
      //console.log(value)
      if (value.length == 1) {
        this.searchForm.category = value[0];
        //console.log('this.searchForm.category',this.searchForm.category)
      } else if (value.length == 2) {
        this.searchForm.category = value[1];
        //console.log('this.searchForm.category',this.searchForm.category)
      }
    },
    handleChange: function handleChange(value) {
      //console.log(value)
      if (value.length == 1) {
        this.searchForm.location = value[0];
      } else if (value.length == 2) {
        this.searchForm.location = value[1];
      }
      //console.log('this.searchForm.location',this.searchForm.location)
    },
    scrollWin: function scrollWin() {
      window.scrollBy(0, 800);
    },
    promptInstall: function promptInstall() {
      var _this2 = this;

      // Show the prompt:
      this.deferredPrompt.prompt();
      //console.log("deferredPrompt e",this.deferredPrompt)
      // Wait for the user to respond to the prompt:
      //console.log("choiceResult.outcome",choiceResult.outcome)
      this.deferredPrompt.userChoice.then(function (choiceResult) {
        if (choiceResult.outcome === "accepted") {
          alert("eSHOPS App is being Installed.");
        } else {
          //console.log("User dismissed the install prompt");
        }

        _this2.deferredPrompt = null;
      });
    }
  },
  created: function created() {
    var _this3 = this;

    window.addEventListener("beforeinstallprompt", function (e) {
      // Prevent the mini-infobar from appearing on mobile
      e.preventDefault();
      // Stash the event so it can be triggered later.
      //alert("deferredPrompt",this.deferredPrompt)
      _this3.deferredPrompt = e;
      //console.log("deferredPrompt e",this.deferredPrompt)
      // Update UI notify the user they can install the PWA
      //showInstallPromotion();
    });
    this.loading = true;
    this.fetched = false;
    if (this.$store.state.topshops.length !== 0) {
      this.topshops = this.$store.state.topshops;
      this.fetched = true;
      this.loading = false;
      //console.log('results from store')
    } else {
      __WEBPACK_IMPORTED_MODULE_0__config_FirebaseInit__["a" /* default */].collection("shops").where("permission", "==", "allowed").where("search", "==", "yes").orderBy("rank").orderBy("created", "desc").limit(12).get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          var data = {
            id: doc.id,
            name: doc.data().name,
            cat: doc.data().cat,
            shoptype: doc.data().shoptype,
            location: doc.data().location,
            owner: doc.data().owner,
            visits: doc.data().visits,
            homeimg: doc.data().homeimg,
            plan: doc.data().plan,
            details: doc.data().details,
            isfavshop: false,
            isHosted: doc.data().isHosted,
            domain: doc.data().domain,
            isCloned: doc.data().isCloned,
            realOwner: doc.data().realOwner,
            regtel: doc.data().regtel
          };
          _this3.topshops.push(data);
          //console.log(this.topshops)
        });
        _this3.fetched = true;
        _this3.loading = false;
        if (querySnapshot.docs.length > 0) {
          //this.lastVisible = querySnapshot.docs[querySnapshot.docs.length-1];
          _this3.$store.state.topshops = _this3.topshops;
        }
      }).catch(function (e) {
        //console.log(e)
        _this3.fetched = true;
        _this3.loading = false;
      });
    }
    if (__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser) {
      if (__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.displayName == null) {
        this.user = true;
      } else if (__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.displayName == "shop owner" || __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.displayName == "starterplan shop owner") {
        this.admin = true;
      } else if (__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.displayName == "page owner") {
        this.pageadmin = true;
      } else if (__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.displayName == "editor" || __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.displayName == "super admin") {
        this.editor = true;
      }
    } else {
      this.visitor = true;
    }
    this.cities = __WEBPACK_IMPORTED_MODULE_2__data_cities__["a" /* default */];
    this.categories = __WEBPACK_IMPORTED_MODULE_4__data_maincategories__["a" /* default */];
    this.shopcats = __WEBPACK_IMPORTED_MODULE_3__data_caticons__["a" /* default */];
    this.$nextTick(function () {
      // this.initToTopButton();
    });
  }
});

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_FirebaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_cities__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_caticons__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_maincategories__ = __webpack_require__(85);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "startstore",
  data: function data() {
    return {
      isVisible: false,
      user: false,
      visitor: false,
      admin: false,
      editor: false,
      deferredPrompt: false,
      starterplanadmin: false,
      pageadmin: false,
      searchForm: {
        category: undefined,
        location: undefined,
        shopname: ""
      },
      modalShow: false,
      labelPosition: "left",
      cities: [],
      categories: [],
      city: [],
      cat: [],
      loading: false,
      fetched: false,
      topshops: [],
      shopcats: ["Supermarket", "Clothing", "Shoes & Footwear", "Mobiles & Tablets"]
    };
  },

  methods: {
    logout: function logout() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().signOut().then(function () {
        _this.$router.push("/");
      });
    },
    showme: function showme() {
      if (this.searchForm.category == undefined || this.searchForm.location == undefined) {
        this.modalShow = true;
      } else {
        this.$router.push({
          name: "search",
          query: {
            cat: this.searchForm.category,
            loc: this.searchForm.location
          }
        });
      }
    },
    showDialog: function showDialog(shop) {
      this.$router.push({
        name: "storehome",
        params: { storename: shop.owner }
      });
    },
    selectCat: function selectCat(value) {
      //console.log(value)
      if (value.length == 1) {
        this.searchForm.category = value[0];
        //console.log('this.searchForm.category',this.searchForm.category)
      } else if (value.length == 2) {
        this.searchForm.category = value[1];
        //console.log('this.searchForm.category',this.searchForm.category)
      }
    },
    handleChange: function handleChange(value) {
      //console.log(value)
      if (value.length == 1) {
        this.searchForm.location = value[0];
      } else if (value.length == 2) {
        this.searchForm.location = value[1];
      }
      //console.log('this.searchForm.location',this.searchForm.location)
    },
    scrollWin: function scrollWin() {
      window.scrollBy(0, 800);
    },
    promptInstall: function promptInstall() {
      var _this2 = this;

      // Show the prompt:
      this.deferredPrompt.prompt();
      //console.log("deferredPrompt e",this.deferredPrompt)
      // Wait for the user to respond to the prompt:
      //console.log("choiceResult.outcome",choiceResult.outcome)
      this.deferredPrompt.userChoice.then(function (choiceResult) {
        if (choiceResult.outcome === "accepted") {
          alert("eSHOPS App is being Installed.");
        } else {
          //console.log("User dismissed the install prompt");
        }

        _this2.deferredPrompt = null;
      });
    }
  },
  created: function created() {
    var _this3 = this;

    window.addEventListener("beforeinstallprompt", function (e) {
      // Prevent the mini-infobar from appearing on mobile
      e.preventDefault();
      // Stash the event so it can be triggered later.
      //alert("deferredPrompt",this.deferredPrompt)
      _this3.deferredPrompt = e;
      //console.log("deferredPrompt e",this.deferredPrompt)
      // Update UI notify the user they can install the PWA
      //showInstallPromotion();
    });

    if (__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser) {
      if (__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.displayName == null) {
        this.user = true;
      } else if (__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.displayName == "shop owner" || __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.displayName == "starterplan shop owner") {
        this.admin = true;
      } else if (__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.displayName == "page owner") {
        this.pageadmin = true;
      } else if (__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.displayName == "editor" || __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.displayName == "super admin") {
        this.editor = true;
      }
    } else {
      this.visitor = true;
    }
    this.cities = __WEBPACK_IMPORTED_MODULE_2__data_cities__["a" /* default */];
    this.categories = __WEBPACK_IMPORTED_MODULE_4__data_maincategories__["a" /* default */];
    this.shopcats = __WEBPACK_IMPORTED_MODULE_3__data_caticons__["a" /* default */];
    this.$nextTick(function () {
      // this.initToTopButton();
    });
  }
});

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_FirebaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_cities__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_caticons__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_maincategories__ = __webpack_require__(85);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "startstore",
  data: function data() {
    return {
      isVisible: false,
      user: false,
      visitor: false,
      admin: false,
      editor: false,
      deferredPrompt: false,
      starterplanadmin: false,
      pageadmin: false,
      searchForm: {
        category: undefined,
        location: undefined,
        shopname: ""
      },
      modalShow: false,
      labelPosition: "left",
      cities: [],
      categories: [],
      city: [],
      cat: [],
      loading: false,
      fetched: false,
      topshops: [],
      shopcats: ["Supermarket", "Clothing", "Shoes & Footwear", "Mobiles & Tablets"]
    };
  },

  methods: {
    logout: function logout() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().signOut().then(function () {
        _this.$router.push("/");
      });
    },
    showme: function showme() {
      if (this.searchForm.category == undefined || this.searchForm.location == undefined) {
        this.modalShow = true;
      } else {
        this.$router.push({
          name: "search",
          query: {
            cat: this.searchForm.category,
            loc: this.searchForm.location
          }
        });
      }
    },
    showDialog: function showDialog(shop) {
      this.$router.push({
        name: "storehome",
        params: { storename: shop.owner }
      });
    },
    selectCat: function selectCat(value) {
      //console.log(value)
      if (value.length == 1) {
        this.searchForm.category = value[0];
        //console.log('this.searchForm.category',this.searchForm.category)
      } else if (value.length == 2) {
        this.searchForm.category = value[1];
        //console.log('this.searchForm.category',this.searchForm.category)
      }
    },
    handleChange: function handleChange(value) {
      //console.log(value)
      if (value.length == 1) {
        this.searchForm.location = value[0];
      } else if (value.length == 2) {
        this.searchForm.location = value[1];
      }
      //console.log('this.searchForm.location',this.searchForm.location)
    },
    scrollWin: function scrollWin() {
      window.scrollBy(0, 800);
    },
    promptInstall: function promptInstall() {
      var _this2 = this;

      // Show the prompt:
      this.deferredPrompt.prompt();
      //console.log("deferredPrompt e",this.deferredPrompt)
      // Wait for the user to respond to the prompt:
      //console.log("choiceResult.outcome",choiceResult.outcome)
      this.deferredPrompt.userChoice.then(function (choiceResult) {
        if (choiceResult.outcome === "accepted") {
          alert("eSHOPS App is being Installed.");
        } else {
          //console.log("User dismissed the install prompt");
        }

        _this2.deferredPrompt = null;
      });
    }
  },
  created: function created() {
    var _this3 = this;

    window.addEventListener("beforeinstallprompt", function (e) {
      // Prevent the mini-infobar from appearing on mobile
      e.preventDefault();
      // Stash the event so it can be triggered later.
      //alert("deferredPrompt",this.deferredPrompt)
      _this3.deferredPrompt = e;
      //console.log("deferredPrompt e",this.deferredPrompt)
      // Update UI notify the user they can install the PWA
      //showInstallPromotion();
    });

    if (__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser) {
      if (__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.displayName == null) {
        this.user = true;
      } else if (__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.displayName == "shop owner" || __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.displayName == "starterplan shop owner") {
        this.admin = true;
      } else if (__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.displayName == "page owner") {
        this.pageadmin = true;
      } else if (__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.displayName == "editor" || __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.displayName == "super admin") {
        this.editor = true;
      }
    } else {
      this.visitor = true;
    }
    this.cities = __WEBPACK_IMPORTED_MODULE_2__data_cities__["a" /* default */];
    this.categories = __WEBPACK_IMPORTED_MODULE_4__data_maincategories__["a" /* default */];
    this.shopcats = __WEBPACK_IMPORTED_MODULE_3__data_caticons__["a" /* default */];
    this.$nextTick(function () {
      // this.initToTopButton();
    });
  }
});

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_FirebaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "about",
  data: function data() {
    return {
      isVisible: false,
      user: false,
      visitor: false,
      admin: false,
      starterplanadmin: false,
      pageadmin: false
    };
  },

  methods: {
    logout: function logout() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().signOut().then(function () {
        _this.$router.push("/");
      });
    },
    scrollWin: function scrollWin() {
      window.scrollBy(0, 800);
    }
  },
  created: function created() {
    if (__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser) {
      if (__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.displayName == null) {
        this.user = true;
      } else if (__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.displayName == "shop owner" || __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.displayName == "starterplan shop owner") {
        this.admin = true;
      } else if (__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.displayName == "page owner") {
        this.pageadmin = true;
      }
    } else {
      this.visitor = true;
    }

    this.$nextTick(function () {
      // this.initToTopButton();
    });
  }
});

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_FirebaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "termsofuse",
  data: function data() {
    return {
      isVisible: false,
      user: false,
      visitor: false,
      admin: false,
      starterplanadmin: false,
      pageadmin: false
    };
  },

  methods: {
    logout: function logout() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().signOut().then(function () {
        _this.$router.push("/");
      });
    },
    scrollWin: function scrollWin() {
      window.scrollBy(0, 800);
    }
  },
  created: function created() {
    if (__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser) {
      if (__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.displayName == null) {
        this.user = true;
      } else if (__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.displayName == "shop owner" || __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.displayName == "starterplan shop owner") {
        this.admin = true;
      } else if (__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.displayName == "page owner") {
        this.pageadmin = true;
      }
    } else {
      this.visitor = true;
    }

    this.$nextTick(function () {
      //this.initToTopButton();
    });
  }
});

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_FirebaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "privacypolicy",
  data: function data() {
    return {
      isVisible: false,
      user: false,
      visitor: false,
      admin: false,
      starterplanadmin: false,
      pageadmin: false
    };
  },

  methods: {
    logout: function logout() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().signOut().then(function () {
        _this.$router.push("/");
      });
    },
    scrollWin: function scrollWin() {
      window.scrollBy(0, 800);
    }
  },
  created: function created() {
    if (__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser) {
      if (__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.displayName == null) {
        this.user = true;
      } else if (__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.displayName == "shop owner" || __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.displayName == "starterplan shop owner") {
        this.admin = true;
      } else if (__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.displayName == "page owner") {
        this.pageadmin = true;
      }
    } else {
      this.visitor = true;
    }

    this.$nextTick(function () {
      //this.initToTopButton();
    });
  }
});

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StoreNavbar_vue__ = __webpack_require__(184);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b3b1a254_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StoreNavbar_vue__ = __webpack_require__(541);
function injectStyle (ssrContext) {
  __webpack_require__(540)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b3b1a254"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StoreNavbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b3b1a254_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StoreNavbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_FirebaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_mobiles__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_ClothingAccessories__ = __webpack_require__(27);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// require('../../assets/store/vendor/jquery/jquery-3.2.1.min.js')
// import '../../assets/store/vendor/animsition/js/animsition.min.js'



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "navbar",
  data: function data() {
    return {
      modalShow: false,
      modalShow1: false,
      modalShow2: false,
      showsidemenu: false,
      categoriesList: [],
      shops: [],
      favshops: [],
      isFavShop: "show",
      isFavourite: false,
      isLoggedIn: false,
      visits: "",
      loc: "",
      cat: "",
      param: "",
      searchQuery: {},
      plan: "",
      cartItems: 0,
      homeimg: "",
      filesArray: [],
      user: false,
      admin: false,
      pageadmin: false,
      visitor: false,
      datanotify: "Add to My SHOPiN",
      shopcats: {},
      shopname: "",
      fullPath: "",
      adminLink: 'admin'
    };
  },

  // props: ['categoriesList'],
  watch: {
    shops: function shops() {
      if (this.shops[0].shoptype == "Fashion") {
        this.categoriesList = __WEBPACK_IMPORTED_MODULE_4__data_ClothingAccessories__["a" /* default */];
      }
      if (this.shops[0].shoptype == "Elec") {
        this.categoriesList = __WEBPACK_IMPORTED_MODULE_3__data_mobiles__["a" /* default */];
      }
    }
  },
  methods: {
    share: function share() {
      if (navigator.share) {
        navigator.share({
          title: this.shopname,
          text: this.$route.meta.title,
          url: "https://eshops.lk/#" + this.$route.fullPath
        }).then(function () {
          alert("Successful share");
        }).catch(function (error) {
          alert("Error sharing " + error);
        });
      } else {
        var url = "https://eshops.lk/#" + this.$route.fullPath;
        alert("Web Share is not supported by this browser. You can copy this link and share it. Link - " + url);
      }
    },
    addToFavourite: function addToFavourite() {
      if (!__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser) {
        this.modalShow = true;
      }
      if (__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser) {
        // if(firebase.auth().currentUser.displayName == 'shop owner'){
        // 	this.modalShow = true
        // }else{
        if (this.favshops[0].favshops.length <= 25) {
          this.favshops[0].favshops.push(this.$store.state.shops[this.$route.params.storename].id);
          //console.log('favsp updated', this.favshops[0].favshops)
          this.isFavShop = this.$store.state.shops[this.$route.params.storename].id;
          this.isFavourite = true;
          this.datanotify = "Added to My SHOPiN";
          this.modalShow2 = true;
          __WEBPACK_IMPORTED_MODULE_0__config_FirebaseInit__["a" /* default */].collection("users").doc(this.favshops[0].docid).update({
            favshops: this.favshops[0].favshops
          }).then(function () {
            //console.log('')
          }).catch(function (error) {
            //console.log('error',error)
          });
        } else {
          this.modalShow1 = true;
        }
        //}
      }
      // else if(firebase.auth().currentUser && !firebase.auth().currentUser.emailVerified){
      // 	this.modalShow = true
      // }
    },
    logout: function logout() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().signOut().then(function () {
        _this.$router.push("/");
      });
    },
    cartClicked: function cartClicked() {
      if (this.visitor) {
        this.modalShow = true;
      } else if (this.user || this.admin || this.pageadmin) {
        this.cartlink = true;
        this.$router.push({
          name: "storecart",
          params: { storename: this.$route.params.storename }
        });
      }
    }
  },
  created: function created() {
    var _this2 = this;

    //console.log(this.$route.meta.title)
    this.fullPath = this.$route.fullPath;
    __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$on("cartChanged", function (data) {
      _this2.cartItems = data;
    });

    if (__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser) {
      if (this.$store.state.systemUser.role === "Cashier" || this.$store.state.systemUser.role === 'Shop Manager') this.adminLink = 'createinvoice';else if (this.$store.state.systemUser.role === "Kitchen Staff" || this.$store.state.systemUser.role === "Service Staff") this.adminLink = 'kot';
      if (__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.displayName == null) {
        this.user = true;
      } else if (__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.displayName == "shop owner" || __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.displayName == "starterplan shop owner") {
        this.admin = true;
      } else if (__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.displayName == "page owner") {
        this.pageadmin = true;
      }
    } else {
      this.visitor = true;
    }
    // if(firebase.auth().currentUser){
    // if(firebase.auth().currentUser.displayName != 'shop owner'){
    // 	this.isLoggedIn = true
    // }
    // }
    //console.log("this.shops[0].shoptype")
    if (this.$store.state.shops[this.$route.params.storename] != undefined) {
      //  var secondaryAppConfig = this.$store.state.shops[this.$route.params.storename].config
      //  if(firebase.app().name != this.$store.state.shops[this.$route.params.storename].id){
      //  this.$store.state.secondaryApp = firebase.initializeApp(secondaryAppConfig, this.$store.state.shops[this.$route.params.storename].id)
      //  this.$store.state.secondaryDatabase = secondary.firestore()
      //  }
      //  console.log('secondaryDB', this.$store.state.secondaryDatabase)

      this.shopcats = this.$store.state.shops[this.$route.params.storename].categories;
      this.visits = this.$store.state.shops[this.$route.params.storename].visits;
      // this.loc = this.shops[0].loc
      this.cat = this.$store.state.shops[this.$route.params.storename].cat;
      this.plan = this.$store.state.shops[this.$route.params.storename].plan;
      this.shopname = this.$store.state.shops[this.$route.params.storename].name;
      if (this.$store.state.shops[this.$route.params.storename].homeimg != undefined) {
        this.homeimg = this.$store.state.shops[this.$route.params.storename].homeimg;
        this.filesArray.push(this.homeimg);
        //console.log('ary is', this.filesArray)
      } else {
        this.homeimg = "../../../static/images/ecommerce.jpg";
        this.filesArray.push(this.homeimg);
        //console.log('ary is', this.filesArray)
      }
      //console.log('cat is', this.cat)
      //console.log('this.$store.state.shops[this.$route.params.storename] is', this.$store.state.shops[this.$route.params.storename])

      this.loc = this.$store.state.searchLocation;

      this.searchQuery["cat"] = this.cat;
      this.searchQuery["loc"] = this.loc;
    } else {
      __WEBPACK_IMPORTED_MODULE_0__config_FirebaseInit__["a" /* default */].collection("shops").where("owner", "==", this.$route.params.storename).onSnapshot(function (querySnapshot) {
        _this2.shops = [];
        querySnapshot.forEach(function (doc) {
          var data = {
            id: doc.id,
            name: doc.data().name,
            shoptype: doc.data().shoptype,
            visits: doc.data().visits,
            loc: doc.data().location,
            categories: doc.data().categories,
            homeimg: doc.data().homeimg,
            plan: doc.data().plan,
            cat: doc.data().cat,
            details: doc.data().details,
            config: doc.data().config
          };
          _this2.shops.push(data);
          //console.log(this.shops[0].config)
          //console.log(this.shops[0].id)
          // var secondaryAppConfig = this.shops[0].config
          // var secondary = firebase.initializeApp(secondaryAppConfig, this.$route.params.storename)
          // this.$store.state.secondaryDatabase = secondary.firestore()
          // this.$store.state.secondaryApp = this.$route.params.storename
          // this.$store.state.secondaryDatabase.settings({timestampsInSnapshots: true,})
          // this.$store.state.secondaryDatabase.enablePersistence({experimentalTabSynchronization:true}).then(() => {
          // 	//console.log("Woohoo! Multi-Tab Persistence!");
          // });
          // console.log('secondaryDB', this.$store.state.secondaryDatabase)

          _this2.shopcats = _this2.shops[0].categories;
          _this2.visits = _this2.shops[0].visits;
          // this.loc = this.shops[0].loc
          _this2.cat = _this2.shops[0].cat;
          _this2.plan = _this2.shops[0].plan;
          _this2.shopname = _this2.shops[0].name;
          if (_this2.shops[0].homeimg != undefined) {
            _this2.homeimg = _this2.shops[0].homeimg;
            _this2.filesArray.push(_this2.homeimg);
            //console.log('ary is', this.filesArray)
          } else {
            _this2.homeimg = "../../../static/images/ecommerce.jpg";
            _this2.filesArray.push(_this2.homeimg);
            //console.log('ary is', this.filesArray)
          }
          //console.log('cat is', this.cat)
          //console.log('cat is', this.shops[0].cat)
          _this2.$store.state.shops[_this2.$route.params.storename] = _this2.shops[0];
          //console.log('cat is', this.$store.state.shops[this.$route.params.storename])
          _this2.loc = _this2.$store.state.searchLocation;

          _this2.searchQuery["cat"] = _this2.cat;
          _this2.searchQuery["loc"] = _this2.loc;
        });
      });
    }
    //   beforeCreate(){

    if (__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser) {
      // if(firebase.auth().currentUser.displayName != 'shop owner'){
      __WEBPACK_IMPORTED_MODULE_0__config_FirebaseInit__["a" /* default */].collection("users").where("uid", "==", __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.uid).get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          var data = {
            favshops: doc.data().favshops,
            docid: doc.id
          };
          _this2.favshops.push(data);
          //console.log('favshops',this.favshops)
        });
        var findFavShop = function findFavShop(fshops, id) {
          var findedid = fshops.find(function (fs, index) {
            return fs == id;
          });
          return findedid;
        };
        _this2.isFavShop = findFavShop(_this2.favshops[0].favshops, _this2.$store.state.shops[_this2.$route.params.storename].id);
        //console.log('isFavShop',this.isFavShop)
        if (_this2.isFavShop == _this2.$store.state.shops[_this2.$route.params.storename].id) {
          _this2.isFavourite = true;
          _this2.datanotify = "Added to My SHOPiN";
        }
      });

      //console.log('cartitems',this.$store.state.cartItems[this.$route.params.storename])
      if (this.$store.state.cartItems[this.$route.params.storename] != undefined) {
        this.cartItems = this.$store.state.cartItems[this.$route.params.storename];
        //console.log('Store cartItems',this.cartItems)
      } else {
        var cartitems = [];
        var foreachRun = false;
        this.$store.state.secondaryDatabase.collection("carts").where("uid", "==", __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.uid).where("shopid", "==", this.$route.params.storename).get().then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            var data = {};
            foreachRun = true;
            cartitems.push(data);
            //console.log('cartitems',cartitems)
            _this2.cartItems = cartitems.length;
            _this2.$store.state.cartItems[_this2.$route.params.storename] = cartitems.length;
            //console.log('this.cartItems',this.cartItems)
          });
          //console.log('cartitems',cartitems)
          if (foreachRun == false) {
            _this2.$store.state.cartItems[_this2.$route.params.storename] = 0;
          }
        });
      }
    }
    // 		    this.$nextTick(() => {
    //   //   $('.header-v4').hide();
    //   /*==================================================================
    //     [ Fixed Header ]*/
    //     var headerDesktop = $('.container-menu-desktop');
    //     var wrapMenu = $('.wrap-menu-desktop');

    //     if($('.top-bar').length > 0) {
    //         var posWrapHeader = $('.top-bar').height();
    //     }
    //     else {
    //         var posWrapHeader = 0;
    //     }

    //     if($(window).scrollTop() > posWrapHeader) {
    //         $(headerDesktop).addClass('fix-menu-desktop');
    //         $(wrapMenu).css('top',0);
    //     }
    //     else {
    //         $(headerDesktop).removeClass('fix-menu-desktop');
    //         $(wrapMenu).css('top',posWrapHeader - $(this).scrollTop());
    //     }

    //     $(window).on('scroll',function(){
    //         if($(this).scrollTop() > posWrapHeader) {
    //             $(headerDesktop).addClass('fix-menu-desktop');
    //             $(wrapMenu).css('top',0);
    //         }
    //         else {
    //             $(headerDesktop).removeClass('fix-menu-desktop');
    //             $(wrapMenu).css('top',posWrapHeader - $(this).scrollTop());
    //         }
    //     });

    //     /*==================================================================
    //     [ Menu mobile ]*/
    // 	$('.btn-show-menu-mobile').on('click', function(){
    //         $(this).toggleClass('is-active');
    //         $('.menu-mobile').slideToggle();
    //     });

    //     var arrowMainMenu = $('.arrow-main-menu-m');

    //     for(var i=0; i<arrowMainMenu.length; i++){
    //         $(arrowMainMenu[i]).on('click', function(){
    //             $(this).parent().find('.sub-menu-m').slideToggle();
    //             $(this).toggleClass('turn-arrow-main-menu-m');
    //         })
    //     }

    //     $(window).resize(function(){
    //         if($(window).width() >= 992){
    //             if($('.menu-mobile').css('display') == 'block') {
    //                 $('.menu-mobile').css('display','none');
    //                 $('.btn-show-menu-mobile').toggleClass('is-active');
    //             }

    //             $('.sub-menu-m').each(function(){
    //                 if($(this).css('display') == 'block') {
    //                     //console.log('hello');
    //                     $(this).css('display','none');
    //                     $(arrowMainMenu).removeClass('turn-arrow-main-menu-m');
    //                 }
    //             });

    //         }
    //   });

    //   /*==================================================================
    //     [ Isotope ]*/
    //     var $topeContainer = $('.isotope-grid');
    //     var $filter = $('.filter-tope-group');

    //     // filter items on button click
    //     $filter.each(function () {
    //         $filter.on('click', 'button', function () {
    //             var filterValue = $(this).attr('data-filter');
    //             $topeContainer.isotope({filter: filterValue});
    //         });

    //     });

    //     // init Isotope
    //     $(window).on('load', function () {
    //         var $grid = $topeContainer.each(function () {
    //             $(this).isotope({
    //                 itemSelector: '.isotope-item',
    //                 layoutMode: 'fitRows',
    //                 percentPosition: true,
    //                 animationEngine : 'best-available',
    //                 masonry: {
    //                     columnWidth: '.isotope-item'
    //                 }
    //             });
    //         });
    //     });

    //     var isotopeButton = $('.filter-tope-group button');

    //     $(isotopeButton).each(function(){
    //         $(this).on('click', function(){
    //             for(var i=0; i<isotopeButton.length; i++) {
    //                 $(isotopeButton[i]).removeClass('how-active1');
    //             }

    //             $(this).addClass('how-active1');
    //         });
    //     });

    //     /*==================================================================
    //     [ Filter / Search product ]*/
    //     $('.js-show-filter').on('click',function(){
    //         $(this).toggleClass('show-filter');
    //         $('.panel-filter').slideToggle(400);

    //         if($('.js-show-search').hasClass('show-search')) {
    //             $('.js-show-search').removeClass('show-search');
    //             $('.panel-search').slideUp(400);
    //         }
    //     });

    //     $('.js-show-search').on('click',function(){
    //         $(this).toggleClass('show-search');
    //         $('.panel-search').slideToggle(400);

    //         if($('.js-show-filter').hasClass('show-filter')) {
    //             $('.js-show-filter').removeClass('show-filter');
    //             $('.panel-filter').slideUp(400);
    //         }
    //     });

    // 	 /*==================================================================
    //     [ Cart ]*/
    //     $('.js-show-cart').on('click',function(){
    //         $('.js-panel-cart').addClass('show-header-cart');
    //     });

    //     $('.js-hide-cart').on('click',function(){
    //         $('.js-panel-cart').removeClass('show-header-cart');
    //     });

    //     /*==================================================================
    //     [ Cart ]*/
    //     $('.js-show-sidebar').on('click',function(){
    //         $('.js-sidebar').addClass('show-sidebar');
    //     });

    //     $('.js-hide-sidebar').on('click',function(){
    //         $('.js-sidebar').removeClass('show-sidebar');
    // 	});

    // 	 /*==================================================================
    //     [ Show / hide modal search ]*/
    //     $('.js-show-modal-search').on('click', function(){
    //         $('.modal-search-header').addClass('show-modal-search');
    //         $(this).css('opacity','0');
    //     });

    //     $('.js-hide-modal-search').on('click', function(){
    //         $('.modal-search-header').removeClass('show-modal-search');
    //         $('.js-show-modal-search').css('opacity','1');
    //     });

    //     $('.container-search-header').on('click', function(e){
    //         e.stopPropagation();
    //     });

    //      /*==================================================================
    //     [ +/- num product ]*/
    //     $('.btn-num-product-down').on('click', function(){
    //         var numProduct = Number($(this).next().val());
    //         if(numProduct > 0) $(this).next().val(numProduct - 1);
    //     });

    //     $('.btn-num-product-up').on('click', function(){
    //         var numProduct = Number($(this).prev().val());
    //         $(this).prev().val(numProduct + 1);
    //     });

    //     /*==================================================================
    //     [ Rating ]*/
    //     $('.wrap-rating').each(function(){
    //         var item = $(this).find('.item-rating');
    //         var rated = -1;
    //         var input = $(this).find('input');
    //         $(input).val(0);

    //         $(item).on('mouseenter', function(){
    //             var index = item.index(this);
    //             var i = 0;
    //             for(i=0; i<=index; i++) {
    //                 $(item[i]).removeClass('zmdi-star-outline');
    //                 $(item[i]).addClass('zmdi-star');
    //             }

    //             for(var j=i; j<item.length; j++) {
    //                 $(item[j]).addClass('zmdi-star-outline');
    //                 $(item[j]).removeClass('zmdi-star');
    //             }
    //         });

    //         $(item).on('click', function(){
    //             var index = item.index(this);
    //             rated = index;
    //             $(input).val(index+1);
    //         });

    //         $(this).on('mouseleave', function(){
    //             var i = 0;
    //             for(i=0; i<=rated; i++) {
    //                 $(item[i]).removeClass('zmdi-star-outline');
    //                 $(item[i]).addClass('zmdi-star');
    //             }

    //             for(var j=i; j<item.length; j++) {
    //                 $(item[j]).addClass('zmdi-star-outline');
    //                 $(item[j]).removeClass('zmdi-star');
    //             }
    //         });
    //     });

    //     /*==================================================================
    //     [ Show modal1 ]*/
    //     $('.js-show-modal1').on('click',function(e){
    //         e.preventDefault();
    //         $('.js-modal1').addClass('show-modal1');
    //     });

    //     $('.js-hide-modal1').on('click',function(){
    //         $('.js-modal1').removeClass('show-modal1');
    //     });

    //      /*[ Back to top ]
    //     ===========================================================*/
    //     var windowH = $(window).height()/2;

    //     $(window).on('scroll',function(){
    //         if ($(this).scrollTop() > windowH) {
    //             $("#myBtn").css('display','flex');
    //         } else {
    //             $("#myBtn").css('display','none');
    //         }
    //     });

    //     $('#myBtn').on("click", function(){
    //         $('html, body').animate({scrollTop: 0}, 300);
    //     });

    //     /***********Slick js *********************/

    // (function ($) {
    //     // USE STRICT
    //     "use strict";

    //         /*==================================================================
    //         [ Slick1 ]*/
    //         $('.wrap-slick1').each(function(){
    //             var wrapSlick1 = $(this);
    //             var slick1 = $(this).find('.slick1');

    //             var itemSlick1 = $(slick1).find('.item-slick1');
    //             var layerSlick1 = $(slick1).find('.layer-slick1');
    //             var actionSlick1 = [];

    //             $(slick1).on('init', function(){
    //                 var layerCurrentItem = $(itemSlick1[0]).find('.layer-slick1');

    //                 for(var i=0; i<actionSlick1.length; i++) {
    //                     clearTimeout(actionSlick1[i]);
    //                 }

    //                 $(layerSlick1).each(function(){
    //                     $(this).removeClass($(this).data('appear') + ' visible-true');
    //                 });

    //                 for(var i=0; i<layerCurrentItem.length; i++) {
    //                     actionSlick1[i] = setTimeout(function(index) {
    //                         $(layerCurrentItem[index]).addClass($(layerCurrentItem[index]).data('appear') + ' visible-true');
    //                     },$(layerCurrentItem[i]).data('delay'),i);
    //                 }
    //             });

    //             var showDot = false;
    //             if($(wrapSlick1).find('.wrap-slick1-dots').length > 0) {
    //                 showDot = true;
    //             }

    //             $(slick1).slick({
    //                 pauseOnFocus: false,
    //                 pauseOnHover: false,
    //                 slidesToShow: 1,
    //                 slidesToScroll: 1,
    //                 fade: true,
    //                 speed: 1000,
    //                 infinite: true,
    //                 autoplay: true,
    //                 autoplaySpeed: 6000,
    //                 arrows: true,
    //                 appendArrows: $(wrapSlick1),
    //                 prevArrow:'<button class="arrow-slick1 prev-slick1"><i class="zmdi zmdi-caret-left"></i></button>',
    //                 nextArrow:'<button class="arrow-slick1 next-slick1"><i class="zmdi zmdi-caret-right"></i></button>',
    //                 dots: showDot,
    //                 appendDots: $(wrapSlick1).find('.wrap-slick1-dots'),
    //                 dotsClass:'slick1-dots',
    //                 customPaging: function(slick, index) {
    //                     var linkThumb = $(slick.$slides[index]).data('thumb');
    //                     var caption = $(slick.$slides[index]).data('caption');
    //                     return  '<img src="' + linkThumb + '">' +
    //                             '<span class="caption-dots-slick1">' + caption + '</span>';
    //                 },
    //             });

    //             $(slick1).on('afterChange', function(event, slick, currentSlide){

    //                 var layerCurrentItem = $(itemSlick1[currentSlide]).find('.layer-slick1');

    //                 for(var i=0; i<actionSlick1.length; i++) {
    //                     clearTimeout(actionSlick1[i]);
    //                 }

    //                 $(layerSlick1).each(function(){
    //                     $(this).removeClass($(this).data('appear') + ' visible-true');
    //                 });

    //                 for(var i=0; i<layerCurrentItem.length; i++) {
    //                     actionSlick1[i] = setTimeout(function(index) {
    //                         $(layerCurrentItem[index]).addClass($(layerCurrentItem[index]).data('appear') + ' visible-true');
    //                     },$(layerCurrentItem[i]).data('delay'),i);
    //                 }

    //             });

    //         });

    //         /*==================================================================
    //         [ Slick2 ]*/
    //         $('.wrap-slick2').each(function(){
    //             $(this).find('.slick2').slick({
    //               slidesToShow: 4,
    //               slidesToScroll: 4,
    //               infinite: false,
    //               autoplay: false,
    //               autoplaySpeed: 6000,
    //               arrows: true,
    //               appendArrows: $(this),
    //               prevArrow:'<button class="arrow-slick2 prev-slick2"><i class="fa fa-angle-left" aria-hidden="true"></i></button>',
    //               nextArrow:'<button class="arrow-slick2 next-slick2"><i class="fa fa-angle-right" aria-hidden="true"></i></button>',
    //               responsive: [
    //                 {
    //                   breakpoint: 1200,
    //                   settings: {
    //                     slidesToShow: 4,
    //                     slidesToScroll: 4
    //                   }
    //                 },
    //                 {
    //                   breakpoint: 992,
    //                   settings: {
    //                     slidesToShow: 3,
    //                     slidesToScroll: 3
    //                   }
    //                 },
    //                 {
    //                   breakpoint: 768,
    //                   settings: {
    //                     slidesToShow: 2,
    //                     slidesToScroll: 2
    //                   }
    //                 },
    //                 {
    //                   breakpoint: 576,
    //                   settings: {
    //                     slidesToShow: 1,
    //                     slidesToScroll: 1
    //                   }
    //                 }
    //               ]
    //             });
    //           });

    //         $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
    //           var nameTab = $(e.target).attr('href');
    //           $(nameTab).find('.slick2').slick('reinit');
    //         });

    //         /*==================================================================
    //         [ Slick3 ]*/
    //         $('.wrap-slick3').each(function(){
    //             $(this).find('.slick3').slick({
    //                 slidesToShow: 1,
    //                 slidesToScroll: 1,
    //                 fade: true,
    //                 infinite: true,
    //                 autoplay: false,
    //                 autoplaySpeed: 6000,

    //                 arrows: true,
    //                 appendArrows: $(this).find('.wrap-slick3-arrows'),
    //                 prevArrow:'<button class="arrow-slick3 prev-slick3"><i class="fa fa-angle-left" aria-hidden="true"></i></button>',
    //                 nextArrow:'<button class="arrow-slick3 next-slick3"><i class="fa fa-angle-right" aria-hidden="true"></i></button>',

    //                 dots: true,
    //                 appendDots: $(this).find('.wrap-slick3-dots'),
    //                 dotsClass:'slick3-dots',
    //                 customPaging: function(slick, index) {
    //                     var portrait = $(slick.$slides[index]).data('thumb');
    //                     return '<img src=" ' + portrait + ' "/><div class="slick3-dot-overlay"></div>';
    //                 },
    //             });
    //         });

    // })(jQuery);

    //     /***********Magnify Popup *********************/
    //   $('.gallery-lb').each(function() { // the containers for all your galleries
    // 			$(this).magnificPopup({
    // 		        delegate: 'a', // the selector for gallery item
    // 		        type: 'image',
    // 		        gallery: {
    // 		        	enabled:true
    // 		        },
    // 		        mainClass: 'mfp-fade'
    // 		    });
    // 		});

    //     })
  }
});

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_FirebaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__(15);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "cart",
  data: function data() {
    return {
      loading: false,
      fetch: false,
      modalShow: false,
      modalShow1: false,
      cartItems: [],
      cartSubTotals: [],
      shops: [],
      orders: "",
      cartLength: 0,
      Total: 0,
      display: "none",
      formdata: {
        name: "",
        telephone: "",
        address: ""
      }
    };
  },

  computed: {},
  beforeCreate: function beforeCreate() {
    //console.log('firebase.auth().currentUser', firebase.auth().currentUser.displayName)
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    // this.prvroute = from
    //console.log(from.fullPath)
    if (__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser) {
      if (__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.displayName != "shop owner") {
        next();
      } else if (__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.displayName == "shop owner") {
        next();
        // 	    setTimeout(() => {
        //     next(vm => {
        //      return vm.$router.push(from.fullPath)
        //     })
        //   },100)
      }
    } else if (!__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser) {
      setTimeout(function () {
        next(function (vm) {
          return vm.$router.push("/signin");
        });
      }, 100);
    }
  },
  created: function created() {
    var _this = this;

    this.backToTop();
    this.loading = true;
    this.fetch = false;
    this.$store.state.secondaryDatabase.collection("carts").where("uid", "==", __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.uid).where("shopid", "==", this.$route.params.storename).get().then(function (querySnapshot) {
      querySnapshot.forEach(function (doc) {
        var data = {
          id: doc.id,
          name: doc.data().prdname,
          price: doc.data().price,
          prdid: doc.data().prdid,
          image: doc.data().img,
          quantity: doc.data().quantity,
          subTotal: doc.data().total,
          barcode: doc.data().barcode
        };
        _this.cartItems.push(data);
        _this.cartLength = _this.cartItems.length;
        _this.cartSubTotals = _this.cartItems.map(function (citem) {
          return citem.subTotal;
        });
        //console.log(this.cartItems)
        //console.log('subtotal array',this.cartSubTotals)
      });
    }).then(function () {
      _this.loading = false;
      _this.fetch = true;
      _this.cartTotal(_this.cartSubTotals);
      _this.display = "block";
      //console.log('called')
    });
    this.$store.state.secondaryDatabase.collection("shops").where("owner", "==", this.$route.params.storename).get().then(function (querySnapshot) {
      querySnapshot.forEach(function (doc) {
        var data = {
          id: doc.id,
          orders: doc.data().orders
        };
        _this.shops.push(data);
        _this.orders = _this.shops[0].orders;
      });
    });
  },


  methods: {
    sendOrder: function sendOrder(fdata) {
      var _this2 = this;

      //console.log('cartItems are:', Array.isArray(this.cartItems))
      this.$refs[fdata].validate(function (valid) {
        if (valid) {
          _this2.modalShow1 = true;
          var products = [];
          _this2.cartItems.forEach(function (item) {
            if (item.quantity > 0) {
              products.push(item);
            }
          });
          //console.log(products)
          if (products.length > 0) {
            var orderNo = Math.floor(Math.random() * 100000001).toString();

            __WEBPACK_IMPORTED_MODULE_0__config_FirebaseInit__["a" /* default */].collection("orders").add({
              uemail: __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.email,
              uid: __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.uid,
              uname: _this2.formdata.name,
              telno: _this2.formdata.telephone,
              address: _this2.formdata.address,
              shopid: _this2.$route.params.storename,
              products: products,
              total: _this2.Total,
              status: "Pending",
              date: __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].firestore.Timestamp.now(),
              orderNo: orderNo
              //   price: this.filteredProducts[n].price,
              //   total: this.filteredProducts[n].price,
              // imageUrl: this.item.image
            }).then(function (doc) {
              //console.log(doc.id)
              if (!_this2.$store.state.noDB) {
                _this2.$store.state.secondaryDatabase.collection("orders").add({
                  uemail: __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.email,
                  uid: __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.uid,
                  uname: _this2.formdata.name,
                  telno: _this2.formdata.telephone,
                  address: _this2.formdata.address,
                  shopid: _this2.$route.params.storename,
                  products: products,
                  total: _this2.Total,
                  status: "Pending",
                  refid: doc.id,
                  date: __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].firestore.Timestamp.now(),
                  orderNo: orderNo
                  //   price: this.filteredProducts[n].price,
                  //   total: this.filteredProducts[n].price,
                  // imageUrl: this.item.image
                }).then(function (doc2) {}).catch(function (error) {
                  return alert(error);
                });
              }
              _this2.orders += 1;
              _this2.$store.state.secondaryDatabase.collection("shops").doc(_this2.shops[0].id).update({
                orders: _this2.orders
              }).then(function (doc) {
                _this2.modalShow = true;
                //console.log('doc is', doc)
              }).catch(function (error) {
                return alert(error);
              });

              _this2.$store.state.secondaryDatabase.collection("carts").where("uid", "==", __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.uid).where("shopid", "==", _this2.$route.params.storename).get().then(function (querySnapshot) {
                querySnapshot.forEach(function (doc) {
                  //console.log('doc id',doc.id)
                  _this2.$store.state.secondaryDatabase.collection("carts").doc(doc.id).delete().then(function () {
                    //console.log('cart item deleted')
                    _this2.$store.state.cartItems[_this2.$route.params.storename] = 0;
                  }).catch(function (error) {
                    return alert(error);
                  });
                });
                //  setTimeout(() => {
                // 	this.$router.go(this.$route.fullPath)
                //  }, 2000)
                _this2.cartItems = [];
                _this2.Total = 0;
                _this2.cartLength = 0;
                _this2.formdata.name = "";
                _this2.formdata.telephone = "";
                _this2.formdata.address = "";
                var cartItems = 0;
                __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit("cartChanged", cartItems);
                _this2.$store.state.cartItems[_this2.$route.params.storename] = 0;
              }).catch(function (error) {
                return alert(error);
              });
            }).catch(function (error) {
              return alert(error);
            });
          } else {
            alert("Please Add Items to the Cart !!!");
          }
        } else {
          alert("Please Enter Your Details !!!");
          return false;
        }
      });
    },

    backToTop: function backToTop() {
      $("html,body").stop().animate({
        scrollTop: 0
      }, "fast", "swing");
    },
    incQuantity: function incQuantity(n) {
      this.cartItems[n].quantity++;
      this.cartItems[n].subTotal = this.cartItems[n].quantity * this.cartItems[n].price;
      this.Total += this.cartItems[n].price;

      this.$store.state.secondaryDatabase.collection("carts").doc(this.cartItems[n].id).update({
        quantity: this.cartItems[n].quantity,
        total: this.cartItems[n].subTotal
      });
    },
    decQuantity: function decQuantity(n) {
      if (this.cartItems[n].quantity > 1) {
        this.cartItems[n].quantity--;

        this.cartItems[n].subTotal = this.cartItems[n].quantity * this.cartItems[n].price;
        this.Total -= this.cartItems[n].price;

        this.$store.state.secondaryDatabase.collection("carts").doc(this.cartItems[n].id).update({
          quantity: this.cartItems[n].quantity,
          total: this.cartItems[n].subTotal
        });
      }
    },
    cartTotal: function cartTotal(total) {
      //console.log('cartTotal called')
      //   this.subTotals(this.cartItems)
      this.Total += total.reduce(add, 0);

      function add(a, b) {
        return a + b;
      }
      //console.log(this.Total, 'at func')
      return this.Total;
    },
    deleteCartItem: function deleteCartItem(n) {
      var _this3 = this;

      var newCart = this.cartItems.filter(function (citem) {
        return citem.id !== _this3.cartItems[n].id;
      });
      this.cartSubTotals = [];

      //console.log('newCart', newCart)
      //console.log('empty this.cartSubTotals', this.cartSubTotals)

      this.$store.state.secondaryDatabase.collection("carts").doc(this.cartItems[n].id).delete().then(function () {
        //console.log('cart item deleted')

        _this3.cartItems = newCart;
        _this3.cartLength -= 1;
        var cartItems = _this3.cartLength;
        __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit("cartChanged", cartItems);
        _this3.$store.state.cartItems[_this3.$route.params.storename] -= 1;

        //console.log('new this.cartItems', this.cartItems)
        _this3.Total = 0;
        _this3.cartSubTotals = _this3.cartItems.map(function (citem) {
          return citem.subTotal;
        });
        //console.log('new this.cartSubTotals', this.cartSubTotals)
        _this3.cartTotal(_this3.cartSubTotals);

        //return this.$router.go(this.$route.fullPath)
      }).catch(function (error) {
        //console.log(error)
      });
    }
  }
});

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_FirebaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_mobiles__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_ClothingAccessories__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_fashi__ = __webpack_require__(547);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'categories',
	data: function data() {
		return {
			loading: false,
			fetch: false,
			currentPage4: 4,
			products: [],
			visible: 'block',
			visible1: 'none',
			category: this.$route.query.cat,

			display: "none",
			suggestion: 'none',
			openedItems: {},
			categoriesList: [],
			subcategories: this.$route.query.cat,
			subcat: [],
			shops: [],
			categoryList: [],
			shopcats: {},

			search: '',
			lastVisible: '',
			items: 25,
			dismore: '',
			maxitems: 100000
		};
	},


	watch: {
		subcategories: function subcategories() {

			//console.log(this.subcategories + "subct")
			if (this.shops[0].shoptype == 'Fashion') {
				//console.log(this.$route.query.cat + "shop")

				this.categoriesList = __WEBPACK_IMPORTED_MODULE_3__data_ClothingAccessories__["a" /* default */][this.subcategories];

				//console.log( "rtggg")
				//   for( i in this.categoriesList){

				// 			    //console.log(this.categoriesList[i])
				// 		   }
				// 	  //console.log(this.categoriesList)
				// 	  //console.log(this.shops)
			}
			if (this.shops[0].shoptype == 'Elec') {
				this.categoriesList = __WEBPACK_IMPORTED_MODULE_2__data_mobiles__["a" /* default */];
			}
		},
		shops: function shops() {
			//console.log(this.subcategories + "subct")
			if (this.shops[0].shoptype == 'Fashion') {
				//console.log(this.$route.query.cat + "shop")
				this.categoryList = __WEBPACK_IMPORTED_MODULE_3__data_ClothingAccessories__["a" /* default */];
				this.categoriesList = __WEBPACK_IMPORTED_MODULE_3__data_ClothingAccessories__["a" /* default */][this.subcategories];

				//console.log( "rtggg")
				//   for( i in this.categoriesList){

				// 			    //console.log(this.categoriesList[i])
				// 		   }
				// 	  //console.log(this.categoriesList)
				// 	  //console.log(this.shops)
			}
			if (this.shops[0].shoptype == 'Elec') {
				this.categoriesList = __WEBPACK_IMPORTED_MODULE_2__data_mobiles__["a" /* default */];
			}
		}
	},

	beforeCreate: function beforeCreate() {},

	methods: {
		backToTop: function backToTop() {
			$('html,body').stop().animate({
				scrollTop: 0
			}, 'fast', 'swing');
		}
	},
	created: function created() {
		var _this = this;

		this.backToTop();
		this.loading = true;
		this.fetch = false;
		this.$store.state.secondaryDatabase.collection('shops').where('owner', '==', this.$route.params.storename).onSnapshot(function (querySnapshot) {
			_this.shops = [];
			querySnapshot.forEach(function (doc) {
				var data = {
					'id': doc.id,
					'shoptype': doc.data().shoptype,
					'categories': doc.data().categories

				};
				_this.shops.push(data);
				_this.shopcats = _this.shops[0].categories;
				//console.log(this.shops[0])
				_this.loading = false;
				_this.fetch = true;
			});
		});
		// .then( () => {
		// 		  db.collection('shops').doc('eFN01P0oQmpoeIRmyhP3').update(
		// 			 {
		// 				 categories: {

		// "Men’s Clothing": {
		//     "T-Shirts":0,
		//     "Shirts":0,
		//     "Blazers":0,
		// 	"Sweaters ":0,
		// 	"Jeans":0,
		// 	"Pants":0,
		// 	"Shorts":0,
		// 	"Coats & Jackets":0,
		// 	"Suits":0,
		// 	"Athletic Apparel":0,
		// 	"Socks":0,
		// 	"Underwear":0,
		// 	"Shoes":0

		// },


		// "Women’s Clothing": {
		//     "Dresses":0,
		//     "Tops & Blouses":0,
		// 	"T- Shirts":0,
		// 	"Sweaters":0,
		// 	"Coats & Jackets":0,
		// 	"Jeans":0,
		// 	"Pants":0,
		// 	"Shorts":0,
		// 	"Skirts":0,
		// 	"Swimwear":0,
		// 	"Intimates & Sleepwear":0 

		// },


		// "Kids & Baby": {
		// 	"Girls (newborn - 5T)":0,
		// 	"Girls (4 and Up)" :0,
		// 	"Boys (newborn -5T)":0,
		// 	"Boys (4 and Up)":0


		// },

		// "Men’s Accessories":{
		// 	"Sunglasses":0,
		// 	"Wallets":0,
		// 	"Scarves & Wraps":0,
		// 	"Watches":0,
		// 	"Belts":0,
		// 	"Hats":0,
		// 	"Caps":0,
		// 	"Gloves & Mittens":0,		

		// },

		// "Women’s Accessories":{
		// 	"Sunglasses":0,
		// 	"Wallets":0,
		// 	"Scarves & Wraps":0,
		// 	"Watches":0,
		// 	"Belts":0,
		// 	"Hats":0,
		// 	"Caps":0,
		// 	"Gloves & Mittens":0,	

		// },


		// }

		// 			 }
		// 		 )
		// 		  .then(doc => {
		//           //console.log('doc is', doc)
		// 	  })
		//	 })

	}
});

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_FirebaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'offers',
  data: function data() {
    return {
      loading: false,
      fetch: false,
      noresults: false,
      offers: []
    };
  },

  methods: {
    backToTop: function backToTop() {
      $('html,body').stop().animate({
        scrollTop: 0
      }, 'fast', 'swing');
    }
  },
  created: function created() {
    var _this = this;

    //console.log('this.route', this.$route)
    //console.log('this.loading', this.loading)
    this.backToTop();
    this.loading = true;
    this.fetch = false;
    //console.log('this.loading', this.loading)
    // 	if(this.$store.state.secondaryApp != this.$route.params.storename){

    //     db.collection('shops').where('owner', '==', this.$route.params.storename).onSnapshot(querySnapshot => {
    //       const shops = []
    //     querySnapshot.forEach(doc => {
    //       const data = {
    //       'id' : doc.id,
    //       'shoptype' : doc.data().shoptype,
    //       'visits': doc.data().visits,
    //       'loc': doc.data().location,
    //       'categories':doc.data().categories,
    //       'plan':doc.data().plan,
    //       'cat': doc.data().cat,
    //       'details': doc.data().details,  
    //       'config': doc.data().config

    //     }
    //     shops.push(data)
    //     console.log(shops[0].config)
    //     console.log(shops[0].id)
    //     var secondaryAppConfig = shops[0].config
    //     var secondary = firebase.initializeApp(secondaryAppConfig, this.$route.params.storename)
    //     this.$store.state.secondaryDatabase = secondary.firestore()
    //     this.$store.state.secondaryApp = this.$route.params.storename
    //     this.$store.state.secondaryDatabase.settings({timestampsInSnapshots: true,})
    //     this.$store.state.secondaryDatabase.enablePersistence({experimentalTabSynchronization:true}).then(() => {
    //       //console.log("Woohoo! Multi-Tab Persistence!");
    //     });
    //     console.log('secondaryDB', this.$store.state.secondaryDatabase)
    //   })
    //   })
    // }
    this.$store.commit('getAppConfig', this.$route.params.storename);
    if (this.$store.state.offers[this.$route.params.storename] != undefined) {
      this.offers = this.$store.state.offers[this.$route.params.storename];
      this.loading = false;
      this.fetch = true;
      if (this.$store.state.offers[this.$route.params.storename].length == 0) {
        this.noresults = true;
        //console.log("noresults", this.noresults);
      }
      //console.log('offers from store', this.$store.state.offers[this.$route.params.storename])
    } else if (this.$store.state.offers[this.$route.params.storename] == undefined) {
      this.$store.state.secondaryDatabase.collection('offers').where("owner", "==", __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.uid).limit(20).get().then(function (querySnapshot) {
        _this.offers = [];
        querySnapshot.forEach(function (doc) {
          var data = {
            'id': doc.id,
            'image': doc.data().img,
            'dis': doc.data().dis,
            'desc': doc.data().desc
          };
          _this.offers.push(data);
          _this.$store.state.offers[_this.$route.params.storename] = _this.offers;
          //console.log(this.offers)
        });
        _this.loading = false;
        _this.fetch = true;
        if (querySnapshot.docs.length == 0) {
          _this.noresults = true;
          //console.log("noresults", this.noresults);
        }
      });
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_FirebaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_mobiles__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_ClothingAccessories__ = __webpack_require__(27);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






//import shopCat from '../../data/shopCat'
/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'products',
	components: {},

	data: function data() {
		return {
			loading: false,
			fetch: false,
			currentPage4: 4,
			modalShow: false,
			modalShow2: false,
			modalShow3: false,
			checkval: false,
			users: [],
			products: [],
			cartItems: 0,
			visible: 'block',
			visible1: 'none',
			category: this.$route.query.cat,
			image: '',
			otherimgs: [],
			cartitems: [],
			ctrl: true,
			incart: false,
			isLoggedIn: false,
			currentUser: false,
			isCartItem: '',
			cartPrdIDs: [],
			width: '75%',

			display: "none",
			suggestion: 'none',
			openedItems: {},
			categoriesList: [],
			subcategories: this.$route.query.cat,
			subcat: [],
			shops: [],
			allProducts: [],
			shopcat: {},
			shopcats: {},
			chngcat: '',

			cartclr: '#7ED7F8',
			search: '',
			lastVisible: '',
			items: 100000,
			dismore: '',
			maxitems: 100000,
			sidecat: '',
			dismobi: 'none',
			plan: '',

			formdata: {
				id: '',
				name: '',
				price: '',
				dis: 0,
				disprice: 0,
				brand: '',
				color: '',
				cond: '',
				warranty: '',
				desc: '',
				image: null,
				imageUrl: "",
				imageUrl2: '',
				imageUrl3: '',
				owner: '',

				model: '',
				cpu: '',
				cpugen: '',
				hard: '',
				storage: '',
				ram: '',
				graphics: '',
				screen: '',
				rearcamera: '',
				frontcamera: '',
				os: '',
				battery: '',
				weight: '',

				details: {}

			}

		};
	},

	computed: {
		filteredProducts: function filteredProducts() {
			var _this = this;

			//console.log('filprd:')

			return this.products.filter(function (product) {
				//   this.lowerCase(product.name)
				//   this.lowerCase(this.search)
				//console.log('filfkkk')
				// //console.log('sidecat', this.sidecat)
				// if(this.sidecat !== null){
				// 	 return product.subcategory.match(this.sidecat)
				// }else{
				return product.name.match(_this.search);
				//}
			});
		}
	},

	mounted: function mounted() {
		var _this2 = this;

		if (__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser) {

			this.$store.state.secondaryDatabase.collection('carts').where('uid', '==', __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.uid).where('shopid', '==', this.$route.params.storename).get().then(function (querySnapshot) {
				querySnapshot.forEach(function (doc) {
					var data = {
						'id': doc.id,
						'prdid': doc.data().prdid
					};
					_this2.cartitems.push(data);
					_this2.cartItems = _this2.cartitems.length;
					_this2.cartPrdIDs = _this2.cartitems.map(function (citem) {
						return citem.prdid;
					});
					//console.log('this.cartitems',this.cartitems)
					//console.log('this.cartPrdIDs',this.cartPrdIDs)
				});
				// var findCartItem = function(citem, id){
				// 	var findedid = citem.find((ci, index) => {
				// 		return ci == id
				// 	})
				// 	return findedid
				// }
				// if(this.cartPrdIDs != undefined){
				// 	this.isCartItem = findCartItem(this.cartPrdIDs, this.$route.params.id)
				// }
				// //console.log('isCartItem',this.isCartItem)

				// if(this.isCartItem == this.$route.params.id){

				// }
			});
		}
	},
	created: function created() {
		var _this3 = this;

		this.$nextTick(function () {
			this.initToTopButton();
			//  $('.zoom').zoom();
		});
		if (screen.width > 575) {
			this.width = '100%';
		}
		//   },
		//    beforeCreate () {
		this.loading = true;
		this.fetch = false;
		this.backToTop();
		this.$store.state.secondaryDatabase.collection('shops').where('owner', '==', this.$route.params.storename).get().then(function (querySnapshot) {
			querySnapshot.forEach(function (doc) {
				var data = {
					'id': doc.id,
					'categories': doc.data().categories,
					'shoptype': doc.data().shoptype,
					'plan': doc.data().plan

				};
				_this3.shops.push(data);
				_this3.shopcats = _this3.shops[0].categories;
				_this3.plan = _this3.shops[0].plan;
				//console.log(this.shops[0].shoptype)
			});
		});

		var cat = this.$route.params.cat;
		if (!this.$store.state.products[this.$route.params.storename]) {
			this.$store.state.products[this.$route.params.storename] = {};
			//console.log('store obj created', this.$store.state.products[this.$route.params.storename])
		}

		//console.log(this.$store.state.products)
		//console.log('condition is ', this.$store.state.products[this.$route.params.storename][this.$route.params.cat])
		if (this.$store.state.products[this.$route.params.storename][this.$route.params.cat] != undefined) {

			this.allProducts = this.$store.state.products[this.$route.params.storename][this.$route.params.cat];
			this.products = this.allProducts;
			this.shopcat[cat] = this.products;
			//console.log('this.shopcat[this.$route.query.cat]', this.shopcat[this.$route.params.cat])
			//console.log(this.products)
			//console.log('products from store!!!')
			this.loading = false;
			this.fetch = true;
		} else {

			this.$store.state.secondaryDatabase.collection("products").where("subcat", "==", this.$route.params.cat).where("owner", "==", this.$route.params.storename).get().then(function (snapshot) {
				_this3.allProducts = [];
				snapshot.forEach(function (doc) {
					var data = {
						'id': doc.id,
						'color': doc.data().color,
						'name': doc.data().name,
						'price': doc.data().price,
						'disprice': doc.data().disprice,
						'image': doc.data().img,
						'subcat': doc.data().subcat,

						'brand': doc.data().brand,
						'cond': doc.data().cond,
						'warranty': doc.data().war,
						'desc': doc.data().desc,
						'details': doc.data().details,
						'otherimgs': doc.data().otherimgs,
						barcode: doc.data().barcode

					};
					_this3.allProducts.push(data);
					_this3.products = _this3.allProducts;
					_this3.shopcat[cat] = _this3.products;
					_this3.$store.state.products[_this3.$route.params.storename][cat] = _this3.products;
					//console.log('this.shopcat[this.$route.query.cat]', this.shopcat[this.$route.params.cat])
					//console.log(this.products)
					//console.log('shop cat from for each', this.shopcat)
				});
				_this3.loading = false;
				_this3.fetch = true;
				//console.log('shop cat from', this.shopcat)
				// this.lastVisible = snapshot.docs[snapshot.docs.length-1];
				// //console.log("last", this.lastVisible);
				//   //console.log("prd color", this.products[0].color);
				//    if(snapshot.docs.length < 25){
				// 	  this.lastVisible = undefined
				// 		//console.log("last", this.lastVisible);
				// 		  this.dismore = undefined
				// 		//console.log("dismore", this.dismore);
				// 		  this.maxitems = this.products.length
				// 		  //console.log("maxitems", this.maxitems);
				//   }

				// snapshot.docChanges().forEach(function(change) {
				// 	if (change.type === "added") {
				// 		//console.log("New city: ", change.doc.data());
				// 	}

				// 	var source = snapshot.metadata.fromCache ? "local cache" : "server";
				// 	//console.log("Data came from " + source);
				// });
			});
		}

		//    //console.log('this.products')
		//   db.collection('products').where("category", "==", this.$route.query.cat)
		//   .get()
		// .then(querySnapshot => {
		//   querySnapshot.forEach(doc => {
		// 	  //console.log('this.products')
		//     const data = {
		//       'id' : doc.id,
		//       'name': doc.data().name,
		// 	  'price': doc.data().price,
		// 	  'image': doc.data().imageUrl
		//     }
		//     this.products.push(data)
		//     //console.log(this.products)

		//   })
		// })
	},


	methods: {
		//   zoom(image){
		// 	//   this.$zoom(image);
		//   },
		sharePrd: function sharePrd() {
			if (navigator.share) {
				navigator.share({
					title: this.formdata.name,
					text: this.formdata.desc,
					url: 'https://eshops.lk/#/stores/' + this.$route.params.storename + '/productdetails/' + this.formdata.id
				}).then(function () {
					alert('Successful share');
				}).catch(function (error) {
					alert('Error sharing ' + error);
				});
			} else {
				var url = 'https://eshops.lk/#/stores/' + this.$route.params.storename + '/productdetails/' + this.formdata.id;
				alert("Web Share is not supported by this browser. You can copy this link and share it. Link - " + url);
			}
		},
		close: function close() {
			this.$modal.hide('prdDetails');
		},
		show: function show(item) {
			//console.log('showmodal clixkes')
			var findCartItem = function findCartItem(citem, id) {
				var findedid = citem.find(function (ci, index) {
					return ci == id;
				});
				return findedid;
			};
			if (this.cartPrdIDs != undefined) {
				this.isCartItem = findCartItem(this.cartPrdIDs, item.id);
				if (this.isCartItem == item.id) {
					this.incart = true;
				} else {
					this.incart = false;
				}
			} else {
				this.incart = false;
			}

			//console.log('isCartItem',this.isCartItem)

			this.prdID = item.id;
			this.otherimgs = item.otherimgs;
			//console.log('this.otherimgs',this.otherimgs)
			this.image = item.image;
			this.formdata.id = item.id;
			this.formdata.name = item.name;
			this.subcategory = item.subcat;
			this.formdata.brand = item.brand;
			this.formdata.price = item.price;
			// this.formdata.dis = item.dis
			this.formdata.color = item.color;
			this.formdata.condition = item.cond;
			this.formdata.barcode = item.barcode, this.formdata.warranty = item.warranty;
			this.formdata.desc = item.desc;
			this.formdata.details = item.details;
			if (this.otherimgs == undefined || this.otherimgs.length == 0) {
				this.ctrl = false;
			} else if (this.otherimgs.length > 0) {
				this.ctrl = true;
			}
			this.$modal.show('prdDetails');
		},
		cartClicked: function cartClicked() {
			if (!__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser) {
				this.modalShow = true;
			} else if (__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser) {
				this.cartlink = true;
				this.$router.push({ name: 'storecart', params: { storename: this.$route.params.storename } });
			}
		},
		addToCart: function addToCart() {
			var _this4 = this;

			//console.log('added to cart')


			if (!__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser) {
				this.modalShow = true;
			}
			if (__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser) {
				// if(firebase.auth().currentUser.displayName != 'shop owner'){
				// if(this.isCartItem != this.$route.params.id){
				// this.cartclr = 'green'
				//this.isCartItem = this.$route.params.id
				this.modalShow2 = true;
				this.cartPrdIDs.push(this.prdID);
				this.incart = true;
				//console.log('checked')
				this.$store.state.secondaryDatabase.collection("carts").add({
					uid: __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.uid,
					shopid: this.$route.params.storename,
					prdid: this.prdID,
					prdname: this.formdata.name,
					barcode: this.formdata.barcode,
					quantity: 1,
					price: this.formdata.price,
					total: this.formdata.price,
					img: this.image

				}).then(function (doc) {

					_this4.cartItems += 1;
					__WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit('cartChanged', _this4.cartItems);
					_this4.$store.state.cartItems[_this4.$route.params.storename] += 1;
					//console.log(doc.id)
					//console.log('store cart',this.$store.state.cartItems[this.$route.params.storename])
				}).catch(function (error) {
					return alert('An error is occured!!!');
				});
				// }else if(this.isCartItem == this.$route.params.id){
				// 	this.modalShow3 = true
				// }

				// }else if(firebase.auth().currentUser.displayName == 'shop owner'){
				// 	this.modalShow = true
				// 	this.checkval = false
				// }
			}
			// else if(firebase.auth().currentUser && !firebase.auth().currentUser.emailVerified){  
			// 	this.modalShow = true
			// }	 
		},
		removeCart: function removeCart() {
			var _this5 = this;

			var newcartPrdIDs = this.cartPrdIDs.filter(function (citem) {
				return citem !== _this5.prdID;
			});
			this.incart = false;
			this.modalShow3 = true;
			this.cartPrdIDs = newcartPrdIDs;
			//console.log("this.cartPrdIDs", this.cartPrdIDs)
			this.$store.state.secondaryDatabase.collection("carts").where('prdid', '==', this.prdID).where('uid', '==', __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.uid).get().then(function (querySnapshot) {
				querySnapshot.forEach(function (doc) {
					//console.log('doc id',doc.id)
					_this5.$store.state.secondaryDatabase.collection("carts").doc(doc.id).delete().then(function () {
						_this5.cartItems -= 1;
						__WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit('cartChanged', _this5.cartItems);
						_this5.$store.state.cartItems[_this5.$route.params.storename] -= 1;
						//console.log('cart item deleted')
					}).catch(function (error) {
						return alert(error);
					});
				});
			}).catch(function (error) {
				return alert(error);
			});
		},


		initToTopButton: function initToTopButton() {
			$(document).bind('scroll', function () {
				var backToTopButton = $('.goTop');
				if ($(document).scrollTop() > 100) {
					backToTopButton.addClass('isVisible');
					this.isVisible = true;
				} else {
					backToTopButton.removeClass('isVisible');
					this.isVisible = false;
				}
			}.bind(this));
		},
		backToTop: function backToTop() {
			$('html,body').stop().animate({
				scrollTop: 0
			}, 'fast', 'swing');
		},

		disFilter: function disFilter() {
			//console.log('disfiltr', this.dismobi)
			if (this.dismobi == 'none') {
				return this.dismobi = 'block';
			}
			if (this.dismobi == 'block') {
				return this.dismobi = 'none';
			}
		},
		colorSort: function colorSort() {
			//console.log('clrsort:')

			this.products = this.products.filter(function (product) {
				//   this.lowerCase(product.name)
				//   this.lowerCase(this.search)
				//console.log('filfkkk')
				return product.color == 'black';
			});
		},
		sortPriceLTH: function sortPriceLTH() {
			//console.log('clicked price')
			this.dismobi = 'none';
			this.backToTop();
			this.products.sort(function (a, b) {
				//   //console.log('clicked price again')
				return a.price - b.price;
			});
			//console.log('clicked price agin', this.filteredProducts)
		},
		sortPriceHTL: function sortPriceHTL() {
			this.dismobi = 'none';
			this.backToTop();
			//console.log('clicked price')
			this.products.sort(function (a, b) {
				//   //console.log('clicked price again')
				return a.price - b.price;
			}).reverse();
			//console.log('clicked price again', this.filteredProducts)
		},
		setSearch: function setSearch(name) {
			this.search = name;
			this.suggestion = 'none';
		},
		clickSearch: function clickSearch() {
			//console.log('length',this.search.length)
			if (this.search.length == 0) {
				this.products = this.$store.state.products[this.$route.params.storename][this.$route.params.cat];
			}
			this.suggestion = 'block';
		},


		//   maincat(){
		// 	  this.dismobi = 'none'
		// 	   this.backToTop()
		// 	  this.products = this.allProducts
		//   },	
		moreItems: function moreItems() {
			var _this6 = this;

			if (this.lastVisible != undefined) {
				this.$store.state.secondaryDatabase.collection("products").where("cat", "==", this.category).where("owner", "==", this.$route.params.storename).startAfter(this.lastVisible).limit(25).onSnapshot(function (snapshot) {
					snapshot.forEach(function (doc) {
						var data = {
							'id': doc.id,
							'name': doc.data().name,
							'price': doc.data().price,
							'disprice': doc.data().disprice,
							'image': doc.data().img,
							'shopID': doc.data().shopID,
							'color': doc.data().color

						};
						_this6.products.push(data);
						//console.log(this.products)
					});
					_this6.lastVisible = snapshot.docs[snapshot.docs.length - 1];
					//console.log(" moreitems last", this.lastVisible);
					//console.log(" moreitems snapshot.length", snapshot.docs.length);
					if (snapshot.docs.length < 25) {
						_this6.lastVisible = undefined;
						//console.log("last", this.lastVisible);
						_this6.dismore = undefined;
						//console.log("dismore", this.dismore);
						_this6.maxitems = _this6.products.length;
						//console.log("maxitems", this.maxitems);
					}
				});
			}
			this.items += 25;
			//console.log('moreitems items', this.items)
			//console.log("mritms maxitems", this.maxitems);
		},
		lessItems: function lessItems() {
			this.items -= 25;
			//console.log(this.items)
		},
		collapseItem: function collapseItem(subcat) {
			var _this7 = this;

			this.dismobi = 'none';
			this.loading = true;
			this.fetch = false;

			// this.products = []
			this.search = '';
			////console.log(this.categoriesList[n])
			// this.products = this.allProducts
			// //console.log(this.products)
			//    this.sidecat = this.categoriesList[n]
			//    //console.log('sidecat', this.sidecat)

			//console.log('clrsort:')

			// this.products = this.products.filter( (product) => {
			//     //   this.lowerCase(product.name)
			//     //   this.lowerCase(this.search)
			// 	//console.log('product subcat', product.subcat)
			//       return product.subcat == this.categoriesList[n]
			//   })


			if (this.$store.state.products[this.$route.params.storename][subcat]) {
				this.products = [];
				this.$route.params.cat = subcat;
				//console.log('route cat', this.$route.params.cat)
				this.products = this.$store.state.products[this.$route.params.storename][subcat];
				this.backToTop();
				//console.log('products from fetched data')
				this.$route.params.cat = subcat;
				this.$router.replace({ name: 'storeproducts', params: { storename: this.$route.params.storename, cat: subcat } });
				this.loading = false;
				this.fetch = true;
				//console.log('route cat', this.$route.params.cat)
			} else {
				this.backToTop();
				this.$store.state.secondaryDatabase.collection("products").where("subcat", "==", subcat).where("owner", "==", this.$route.params.storename).get().then(function (snapshot) {
					_this7.products = [];
					snapshot.forEach(function (doc) {
						var data = {
							'id': doc.id,
							'color': doc.data().color,
							'name': doc.data().name,
							'price': doc.data().price,
							'disprice': doc.data().disprice,
							'image': doc.data().img,
							'subcat': doc.data().subcat,

							'brand': doc.data().brand,
							'cond': doc.data().cond,
							'warranty': doc.data().war,
							'desc': doc.data().desc,
							'details': doc.data().details,
							'otherimgs': doc.data().otherimgs
						};
						_this7.products.push(data);
						_this7.shopcat[subcat] = _this7.products;
						_this7.$store.state.products[_this7.$route.params.storename][subcat] = _this7.products;
					});
					_this7.$route.params.cat = subcat;

					_this7.$router.replace({ name: 'storeproducts', params: { storename: _this7.$route.params.storename, cat: subcat } });
					_this7.loading = false;
					_this7.fetch = true;
					//console.log('route cat', this.$route.params.cat)
					//console.log(this.products)
					//console.log( 'prds')
					_this7.$route.params.cat = subcat;
					//console.log('route cat', this.$route.params.cat)
				});
			}
		},
		handleSizeChange: function handleSizeChange(val) {
			//console.log(`${val} items per page`);
		},
		handleCurrentChange: function handleCurrentChange(val) {
			//console.log(`current page: ${val}`);
		}
	}
});

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_FirebaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__(15);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'productdetails',
	data: function data() {
		return {
			loaded: false,
			loading: false,
			fetch: false,
			otherimgsLength: '',
			isAdded: false,
			image: '',
			otherimgs: [],
			cartItems: 0,
			cartitems: [],
			ctrl: true,
			modalShow: false,
			modalShow2: false,
			modalShow3: false,
			shops: [],
			plan: '',
			isLoggedIn: false,
			currentUser: false,
			isCartItem: '',
			cartPrdIDs: [],

			formdata: {
				name: '',
				price: '',
				dis: 0,
				disprice: 0,
				brand: '',
				color: '',
				cond: '',
				warranty: '',
				desc: '',
				image: null,
				imageUrl: "",
				imageUrl2: '',
				imageUrl3: '',
				owner: '',

				model: '',
				cpu: '',
				cpugen: '',
				hard: '',
				storage: '',
				ram: '',
				graphics: '',
				screen: '',
				rearcamera: '',
				frontcamera: '',
				os: '',
				battery: '',
				weight: '',

				details: {}

			}
		};
	},
	created: function created() {
		var _this = this;

		this.$nextTick(function () {
			// $("#zoom_01").elevateZoom({
			// zoomType				: "inner",
			// cursor: "crosshair"
			// });
			// $("#zoom_02").elevateZoom({
			// zoomType				: "inner",
			// cursor: "crosshair"
			// });
			// $("#zoom_03").elevateZoom({
			// zoomType				: "inner",
			// cursor: "crosshair"
			// });
			$('.zoom').zoom();
		});
		this.backToTop();
		this.loading = true;
		this.fetch = false;
		this.$store.state.secondaryDatabase.collection('products').doc(this.$route.params.id).get().then(function (doc) {

			_this.otherimgs = doc.data().otherimgs;
			_this.otherimgsLength = _this.otherimgs.length;
			if (_this.otherimgs == undefined || _this.otherimgs.length == 0) {
				_this.ctrl = false;
			} else if (_this.otherimgs.length > 0) {
				_this.ctrl = true;
			}
			_this.image = doc.data().img;

			_this.formdata.name = doc.data().name, _this.subcategory = doc.data().subcat, _this.formdata.brand = doc.data().brand, _this.formdata.price = doc.data().price, _this.formdata.barcode = doc.data().barcode, _this.formdata.dis = doc.data().dis, _this.formdata.color = doc.data().color, _this.formdata.condition = doc.data().cond, _this.formdata.warranty = doc.data().war, _this.formdata.desc = doc.data().desc, _this.formdata.details = doc.data().details, _this.formdata.model = doc.data().details.model, _this.formdata.cpu = doc.data().details.cpu, _this.formdata.storage = doc.data().details.storage, _this.formdata.ram = doc.data().details.ram, _this.formdata.screen = doc.data().details.screen, _this.formdata.rearcamera = doc.data().details.rearcamera, _this.formdata.frontcamera = doc.data().details.frontcamera, _this.formdata.os = doc.data().details.os, _this.formdata.battery = doc.data().details.battery, _this.formdata.weight = doc.data().details.weight, _this.formdata.cpugen = doc.data().details.cpugen, _this.formdata.hard = doc.data().details.hard, _this.formdata.graphics = doc.data().details.graphics;

			//this.loaded = true
			//console.log('other imgs', this.otherimgs)
			//console.log('other imgs length', this.otherimgsLength)
		});

		//  .then(() =>{

		//  this.fetch = true
		//  })
		this.$store.state.secondaryDatabase.collection('shops').where('owner', '==', this.$route.params.storename).get().then(function (querySnapshot) {
			querySnapshot.forEach(function (doc) {
				var data = {
					'id': doc.id,
					'shoptype': doc.data().shoptype,
					'plan': doc.data().plan

				};
				_this.shops.push(data);
				_this.plan = _this.shops[0].plan;
			});
		});

		if (__WEBPACK_IMPORTED_MODULE_0_firebase_app__["a" /* default */].auth().currentUser) {

			this.$store.state.secondaryDatabase.collection('carts').where('uid', '==', __WEBPACK_IMPORTED_MODULE_0_firebase_app__["a" /* default */].auth().currentUser.uid).where('shopid', '==', this.$route.params.storename).get().then(function (querySnapshot) {
				querySnapshot.forEach(function (doc) {
					var data = {
						'id': doc.id,
						'prdid': doc.data().prdid
					};
					_this.cartitems.push(data);
					_this.cartItems = _this.cartitems.length;
					_this.cartPrdIDs = _this.cartitems.map(function (citem) {
						return citem.prdid;
					});
					//console.log('this.cartitems',this.cartitems)
					//console.log('this.cartPrdIDs',this.cartPrdIDs)
				});
				var findCartItem = function findCartItem(citem, id) {
					var findedid = citem.find(function (ci, index) {
						return ci == id;
					});
					return findedid;
				};
				if (_this.cartPrdIDs != undefined) {
					_this.isCartItem = findCartItem(_this.cartPrdIDs, _this.$route.params.id);
				}

				//console.log('isCartItem',this.isCartItem)
				// if(this.isCartItem == this.$route.params.id){

				// }
			});
		}
		this.loading = false;
		this.fetch = true;
	},


	methods: {
		backToTop: function backToTop() {
			$('html,body').stop().animate({
				scrollTop: 0
			}, 'fast', 'swing');
		},
		cartClicked: function cartClicked() {
			if (!__WEBPACK_IMPORTED_MODULE_0_firebase_app__["a" /* default */].auth().currentUser) {
				this.modalShow = true;
			} else if (__WEBPACK_IMPORTED_MODULE_0_firebase_app__["a" /* default */].auth().currentUser) {
				this.cartlink = true;
				this.$router.push({ name: 'storecart', params: { storename: this.$route.params.storename } });
			}
		},
		addToCart: function addToCart() {
			var _this2 = this;

			//console.log('added to cart')


			if (!__WEBPACK_IMPORTED_MODULE_0_firebase_app__["a" /* default */].auth().currentUser) {
				this.modalShow = true;
			}
			if (__WEBPACK_IMPORTED_MODULE_0_firebase_app__["a" /* default */].auth().currentUser) {
				// if(firebase.auth().currentUser.displayName != 'shop owner'){
				if (this.isCartItem != this.$route.params.id) {
					// this.cartclr = 'green'
					this.isCartItem = this.$route.params.id;
					this.modalShow2 = true;
					//console.log('checked')
					this.$store.state.secondaryDatabase.collection("carts").add({
						uid: __WEBPACK_IMPORTED_MODULE_0_firebase_app__["a" /* default */].auth().currentUser.uid,
						shopid: this.$route.params.storename,
						prdid: this.$route.params.id,
						prdname: this.formdata.name,
						barcode: this.formdata.barcode,
						quantity: 1,
						price: this.formdata.price,
						total: this.formdata.price,
						img: this.image

					}).then(function (doc) {

						_this2.cartItems += 1;
						__WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit('cartChanged', _this2.cartItems);
						_this2.$store.state.cartItems[_this2.$route.params.storename] += 1;
						//console.log(doc.id)
					}).catch(function (error) {
						return alert('An error is occured!!!');
					});
				} else if (this.isCartItem == this.$route.params.id) {
					this.modalShow3 = true;
				}

				// }else if(firebase.auth().currentUser.displayName == 'shop owner'){
				// 	this.modalShow = true
				// 	this.checkval = false
				// }
			}
			// else if(firebase.auth().currentUser && !firebase.auth().currentUser.emailVerified){  
			// 	this.modalShow = true
			// }   
		}
	}
});

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_FirebaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StoreNavbar__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Home__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__StoreFooter__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_store_js_jquery_imagezoom_js__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_store_js_jquery_imagezoom_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_store_js_jquery_imagezoom_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







// import Products from './Products'
// import Cart from './Cart'
// import ProductDetails from './ProductDetails'
// require('../../assets/store/vendor/jquery/jquery-3.2.1.min.js')
// import '../../assets/store/vendor/animsition/js/animsition.min.js'
// import '../../assets/store/vendor/slick/slick.min.js'
// import '../../assets/store/js/slick-custom.js'

// import '../../assets/store/js/storemain.js'
// import { setTimeout } from 'timers';
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "storehome",
  components: {
    StoreNavbar: __WEBPACK_IMPORTED_MODULE_2__StoreNavbar__["a" /* default */],
    StoreFooter: __WEBPACK_IMPORTED_MODULE_4__StoreFooter__["a" /* default */],
    // Products,
    Home: __WEBPACK_IMPORTED_MODULE_3__Home__["a" /* default */]
  },
  data: function data() {
    return {
      loading: false,
      fetch: false,
      show: true,
      show2: false,
      shops: [],
      secondaryDatabase: {}
      //   categoriesList: [],
      //   shops: []
    };
  },


  //   watch: {

  //       shops () {
  //          if(this.shops[0].shoptype == 'Fashion'){
  //           this.categoriesList = fashion
  //       }
  //       if(this.shops[0].shoptype == 'Elec'){
  //           this.categoriesList = mobiles
  //       }
  //       }
  //   },

  //    beforeRouteEnter (to, from, next) {
  //     try{
  //         firebase.app(to.params.storename).firestore()
  //         console.log('secondaryDB Exsisted')
  //         next()
  //     }catch(err){
  //         db.collection('shops').where('owner', '==', to.params.storename).onSnapshot(querySnapshot => {
  //         var shops = []
  //         querySnapshot.forEach(doc => {
  //         const data = {
  //         'id' : doc.id,
  //         'shoptype' : doc.data().shoptype,
  //         'visits': doc.data().visits,
  //         'loc': doc.data().location,
  //         'categories':doc.data().categories,
  //         'plan':doc.data().plan,
  //         'cat': doc.data().cat,
  //         'details': doc.data().details,
  //         'config': doc.data().config

  //         }
  //         shops.push(data)
  //         console.log(shops[0].config)
  //         console.log(shops[0].id)
  //         var secondaryAppConfig = shops[0].config
  //         var secondaryApp = firebase.initializeApp(secondaryAppConfig, to.params.storename)
  //         var secondaryDatabase = secondaryApp.firestore()
  //         console.log('var secondaryDatabase', secondaryDatabase)
  //         setTimeout(() => {
  //             next( vm =>{
  //                 vm.secondaryDatabase = secondaryDatabase
  //                 console.log('vmsecondaryDB', vm.secondaryDatabase)
  //                 vm.$store.state.secondaryDatabase = secondaryDatabase
  //                 vm.$store.state.secondaryDatabase.settings({timestampsInSnapshots: true,})
  //                 vm.$store.state.secondaryDatabase.enablePersistence({experimentalTabSynchronization:true}).then(() => {
  //                 //console.log("Woohoo! Multi-Tab Persistence!");
  //                 });
  //                 console.log('secondaryDB', vm.$store.state.secondaryDatabase)
  //                 })
  //         },100)
  //     })
  //     })
  //     }
  //    },

  watch: {
    $route: function $route() {
      var _this = this;

      this.show2 = false;
      try {
        __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].app(this.$route.params.storename);
        this.$store.state.secondaryDatabase = __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].app(this.$route.params.storename).firestore();
        this.show2 = true;
        //console.log('secondaryDB Exsits', this.$store.state.secondaryDatabase)
      } catch (err) {
        __WEBPACK_IMPORTED_MODULE_0__config_FirebaseInit__["a" /* default */].collection("shops").where("owner", "==", this.$route.params.storename).onSnapshot(function (querySnapshot) {
          var shops = [];
          querySnapshot.forEach(function (doc) {
            var data = {
              id: doc.id,
              name: doc.data().name,
              shoptype: doc.data().shoptype,
              visits: doc.data().visits,
              loc: doc.data().location,
              categories: doc.data().categories,
              homeimg: doc.data().homeimg,
              plan: doc.data().plan,
              cat: doc.data().cat,
              details: doc.data().details,
              config: doc.data().config,
              noDB: doc.data().noDB
            };
            shops.push(data);
            //console.log(shops[0].config)
            //console.log(shops[0].id)
            if (!shops[0].noDB) {
              // having own db
              var secondaryAppConfig = shops[0].config;
              var secondary = __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].initializeApp(secondaryAppConfig, _this.$route.params.storename);
              _this.$store.state.secondaryDatabase = secondary.firestore();
              // this.$store.state.secondaryApp = this.$route.params.storename
              _this.$store.state.secondaryDatabase.settings({
                timestampsInSnapshots: true
              });
              _this.$store.state.secondaryDatabase.enablePersistence({ synchronizeTabs: true }).then(function () {
                //console.log("Woohoo! Multi-Tab Persistence!");
              });
              _this.show2 = true;
            } else {
              _this.$store.state.secondaryDatabase = __WEBPACK_IMPORTED_MODULE_0__config_FirebaseInit__["a" /* default */];
              _this.$store.state.noDB = true;
              _this.show2 = true;
            }
            //console.log('secondaryDB', this.$store.state.secondaryDatabase)
          });
        });
      }
      if (this.$route.name != "storehome") {
        this.show = false;
      } else if (this.$route.name == "storehome") {
        this.show = true;
      }
    }
  },
  mounted: function mounted() {
    // console.log('secondaryDB 1', this.$store.state.secondaryDatabase)
    // setTimeout(() => console.log('secondaryDB time out', this.$store.state.secondaryDatabase),5000)
    // console.log('secondaryDB 3', this.$store.state.secondaryDatabase)
    if (this.$route.name != "storehome") {
      this.show = false;
    } else if (this.$route.name == "storehome") {
      this.show = true;
    }
  },
  beforeCreate: function beforeCreate() {
    // db.collection('shops').where('owner', '==', this.$route.params.storename).onSnapshot(querySnapshot => {
    // var shops = []
    // querySnapshot.forEach(doc => {
    // const data = {
    // 'id' : doc.id,
    // 'shoptype' : doc.data().shoptype,
    // 'visits': doc.data().visits,
    // 'loc': doc.data().location,
    // 'categories':doc.data().categories,
    // 'plan':doc.data().plan,
    // 'cat': doc.data().cat,
    // 'details': doc.data().details,
    // 'config': doc.data().config
    // }
    // shops.push(data)
    // console.log(shops[0].config)
    // console.log(shops[0].id)
    // var secondaryAppConfig = shops[0].config
    //  var secondary = firebase.initializeApp(secondaryAppConfig, this.$route.params.storename)
    // this.$store.state.secondaryDatabase = secondary.firestore()
    // this.$store.state.secondaryApp = this.$route.params.storename
    // this.$store.state.secondaryDatabase.settings({timestampsInSnapshots: true,})
    // this.$store.state.secondaryDatabase.enablePersistence({experimentalTabSynchronization:true}).then(() => {
    //     //console.log("Woohoo! Multi-Tab Persistence!");
    // });
    // console.log('secondaryDB', this.$store.state.secondaryDatabase)
    // })
    // })
  },
  created: function created() {
    var _this2 = this;

    //   this.loading = true
    //    this.$store.commit('getAppConfig',this.$route.params.storename)
    //    setTimeout(()=> {
    //        this.loading = false
    //        this.show2 = true
    //     }, 1000)

    try {
      __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].app(this.$route.params.storename);
      this.$store.state.secondaryDatabase = __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].app(this.$route.params.storename).firestore();
      this.show2 = true;
      //console.log('secondaryDB Exsits', this.$store.state.secondaryDatabase)
    } catch (err) {
      __WEBPACK_IMPORTED_MODULE_0__config_FirebaseInit__["a" /* default */].collection("shops").where("owner", "==", this.$route.params.storename).get().then(function (querySnapshot) {
        var shops = [];
        querySnapshot.forEach(function (doc) {
          var data = {
            id: doc.id,
            name: doc.data().name,
            shoptype: doc.data().shoptype,
            visits: doc.data().visits,
            loc: doc.data().location,
            categories: doc.data().categories,
            homeimg: doc.data().homeimg,
            plan: doc.data().plan,
            cat: doc.data().cat,
            details: doc.data().details,
            config: doc.data().config,
            noDB: doc.data().noDB
          };
          shops.push(data);
          //console.log(shops[0].config)
          //console.log(shops[0].id)
          if (!shops[0].noDB) {
            // having own db
            if (shops[0].config) {
              var secondaryAppConfig = shops[0].config;
              var secondary = __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].initializeApp(secondaryAppConfig, _this2.$route.params.storename);
              _this2.$store.state.secondaryDatabase = secondary.firestore();
              // this.$store.state.secondaryApp = this.$route.params.storename
              _this2.$store.state.secondaryDatabase.settings({
                timestampsInSnapshots: true
              });
              _this2.$store.state.secondaryDatabase.enablePersistence({ synchronizeTabs: true }).then(function () {
                //console.log("Woohoo! Multi-Tab Persistence!");
              });
              _this2.show2 = true;
            }
            //console.log('secondaryDB', this.$store.state.secondaryDatabase)
          } else {
            //console.log('shop config', shops[0].config)
            _this2.$store.state.secondaryDatabase = __WEBPACK_IMPORTED_MODULE_0__config_FirebaseInit__["a" /* default */];
            _this2.$store.state.noDB = true;
            _this2.show2 = true;
          }
        });
      });
    }
    if (this.$route.name != "storehome") {
      this.show = false;
    } else if (this.$route.name == "storehome") {
      this.show = true;
    }
  }
});

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_FirebaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import Banner from './Banner'

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'home',
	components: {},
	data: function data() {
		return {
			modalShow: false,
			desc: '',
			latestItems: [],
			saleItems: [],
			bestSelling: [],
			loading: false,
			fetch: false,
			show: false,
			slide: 0,
			sliding: null,

			shops: [],
			shops2: [],
			shops3: [],
			stime: '',
			etime: "",
			name: '',
			darea: '',
			tel1: '',
			homeimg: '',
			shopcats: {},
			shopcat: '',
			plan: '',
			products: [],
			allProducts: [],
			color1: '',
			secondaryDatabase: {},
			type: ''

		};
	},

	methods: {
		backToTop: function backToTop() {
			$('html,body').stop().animate({
				scrollTop: 0
			}, 'fast', 'swing');
		},
		showDetails: function showDetails(p) {
			this.$router.push({ name: 'storeproductdetails', params: { id: p.id } });
		},
		showDesc: function showDesc(desc) {
			var regExp = RegExp(/<[^>]*>/g);
			if (regExp.test(desc) === true) {
				this.desc = 'No product details';
				//console.log('1', this.desc);
				this.$alert(this.desc, 'Product Details', {
					dangerouslyUseHTMLString: true
				});
				return false;
			} else if (desc === null || desc === '' || desc === undefined) {
				this.desc = 'No product details';
				//console.log('2', this.desc);
				this.$alert(this.desc, 'Product Details', {
					dangerouslyUseHTMLString: true
				});
				return false;
			} else {
				desc = desc.toString();
				this.desc = desc.replace(/<[^>]*>/g, '');

				//textarea is reference to that object, "<br>" is string that will replace the encoded return
				this.desc = escape(this.desc);
				//encode textarea string's carriage returns

				for (var i = 0; i < this.desc.length; i++) {
					//loop through string, replacing carriage return encoding with HTML break tag

					if (this.desc.indexOf("%0D%0A") > -1) {
						//Windows encodes returns as \r\n hex
						this.desc = this.desc.replace("%0D%0A", "<br>");
					} else if (this.desc.indexOf("%0A") > -1) {
						//Unix encodes returns as \n hex
						this.desc = this.desc.replace("%0A", "<br>");
					} else if (this.desc.indexOf("%0D") > -1) {
						//Macintosh encodes returns as \r hex
						this.desc = this.desc.replace("%0D", "<br>");
					}
				}
				this.desc = unescape(this.desc);
				//console.log('4', this.desc);
				//unescape all other encoded characters
				this.$alert(this.desc, 'Product Details', {
					dangerouslyUseHTMLString: true
				});
			}
		},
		onSlideStart: function onSlideStart(slide) {
			this.sliding = true;
		},
		onSlideEnd: function onSlideEnd(slide) {
			this.sliding = false;
		},
		filterProduct: function filterProduct(type) {
			//console.log('clrsort:')
			if (type != '') {
				this.products = this.allProducts;
				this.products = this.products.filter(function (product) {
					//   this.lowerCase(product.name)
					//   this.lowerCase(this.search)
					//console.log('filfkkk')
					return product.type == type;
				});
			} else {
				this.products = this.allProducts;
			}
		},
		changeItems: function changeItems(type) {
			if (type == 'bestselling') {
				this.products = this.bestSelling;
			} else if (type == 'latest') {
				this.products = this.latestItems;
			}
		}
	},
	mounted: function mounted() {},
	created: function created() {
		var _this = this;

		this.backToTop();
		this.loading = true;
		this.fetch = false;
		if (screen.width > 767) {
			this.type = 'card';
		} else {
			this.type = '';
		}

		//   },

		//  beforeCreate() {
		//console.log("home img")

		//console.log('this.loading', this.loading)
		//console.log("navigator.onLine", navigator.onLine)
		__WEBPACK_IMPORTED_MODULE_0__config_FirebaseInit__["a" /* default */].collection('shops').where('owner', '==', this.$route.params.storename).onSnapshot(function (querySnapshot) {
			_this.shops = [];
			querySnapshot.forEach(function (doc) {
				var data = {
					'shoptype': doc.data().shoptype,
					'shopcat': doc.data().cat,
					'name': doc.data().name,
					'details': doc.data().details,
					'homeimg': doc.data().homeimg,
					'categories': doc.data().categories,
					'plan': doc.data().plan,
					'txtcolor': doc.data().txtcolor
				};
				_this.shops.push(data);
				_this.shopcat = _this.shops[0].shopcat;
				_this.color1 = _this.shops[0].txtcolor;
				//console.log("homeimg is", this.shops[0].homeimg)
				if (_this.shops[0].homeimg != undefined) {
					_this.homeimg = _this.shops[0].homeimg;
				} else {
					_this.homeimg = '../../../static/images/ecommerce.jpg';
				}
				_this.name = _this.shops[0].name;
				_this.stime = _this.shops[0].details.stime;
				_this.etime = _this.shops[0].details.etime;
				_this.tel1 = _this.shops[0].details.tel1;
				_this.plan = _this.shops[0].plan;
				_this.darea = _this.shops[0].details.darea;

				_this.$store.state.secondaryDatabase.collection("shops").where('owner', '==', _this.$route.params.storename).onSnapshot(function (snapshot) {
					_this.shops2 = [];
					snapshot.forEach(function (doc) {
						var data = {
							'id': doc.id,
							'categories': doc.data().categories,
							'curProducts': doc.data().curProducts
						};
						_this.shops2.push(data);
						_this.shopcats = _this.shops2[0].categories;
					});
					if (_this.shops2[0].curProducts <= 40) {

						//console.log(this.$store.state.starterplanproducts)
						if (_this.$store.state.starterplanproducts[_this.$route.params.storename] != undefined) {

							_this.allProducts = _this.$store.state.starterplanproducts[_this.$route.params.storename];
							_this.products = _this.allProducts;

							//console.log(this.products)
							//console.log('products from store!!!')
							_this.loading = false;
							_this.fetch = true;
						} else {

							_this.$store.state.secondaryDatabase.collection("products").where('owner', '==', _this.$route.params.storename).onSnapshot(function (snapshot) {
								_this.allProducts = [];
								snapshot.forEach(function (doc) {
									var data = {
										'id': doc.id,
										'color': doc.data().color,
										'name': doc.data().name,
										'price': doc.data().price,
										'disprice': doc.data().disprice,
										'image': doc.data().img,
										'subcat': doc.data().subcat,

										'brand': doc.data().brand,
										'cond': doc.data().cond,
										'warranty': doc.data().war,
										'desc': doc.data().desc,
										'details': doc.data().details,
										'otherimgs': doc.data().otherimgs

									};
									_this.allProducts.push(data);
									_this.products = _this.allProducts;
									_this.$store.state.starterplanproducts[_this.$route.params.storename] = _this.products;
									//console.log(this.products)
								});
								_this.loading = false;
								_this.fetch = true;
							});
						}
					} else {
						_this.loading = false;
						_this.fetch = true;
					}
				});

				_this.$store.state.secondaryDatabase.collection('galleries').doc(_this.$route.params.storename).get().then(function (doc) {
					if (doc.data()) {
						var _data = {
							'id': doc.id,
							'gallery': doc.data().gallery
						};
						_this.shops3.push(_data);
					}

					if (!_this.shops3[0]) {
						_this.shops3[0] = {};
						_this.shops3[0].gallery = [];
					}
					_this.show = true;
				}).catch(function (error) {
					return alert(error);
				});

				//console.log("homeimg is", this.homeimg)
				//console.log("name is", this.shops[0].name)
				//console.log("details are", this.shops[0].details)
				////console.log("url is", this.url)
			});
		});
		// db.collection('shops').where('owner', '==', this.$route.params.storename).get().then(querySnapshot => {
		// 			const shops = []
		// 		querySnapshot.forEach(doc => {
		// 			const data = {
		// 			'id' : doc.id,
		// 			'shoptype' : doc.data().shoptype,
		// 			'visits': doc.data().visits,
		// 			'loc': doc.data().location,
		// 			'categories':doc.data().categories,
		// 			'plan':doc.data().plan,
		// 			'cat': doc.data().cat,
		// 			'details': doc.data().details,  
		// 			'config': doc.data().config

		// 		}
		// 		shops.push(data)
		// 		console.log(shops[0].config)
		// 		console.log(shops[0].id)
		// 		var secondaryAppConfig = shops[0].config

		// var secondary = firebase.initializeApp(this.$store.state.secondaryAppConfig, this.$route.params.storename)
		// this.$store.state.secondaryDatabase = secondary.firestore()
		// this.$store.state.secondaryApp = this.$route.params.storename
		// this.$store.state.secondaryDatabase.settings({timestampsInSnapshots: true,})
		// this.$store.state.secondaryDatabase.enablePersistence({experimentalTabSynchronization:true}).then(() => {
		// 	//console.log("Woohoo! Multi-Tab Persistence!");
		// });
		// console.log('secondaryDB', this.$store.state.secondaryDatabase)
		// })
		// })

		//  this.$store.state.secondaryDatabase.collection('offers')
		//   .limit(20).get().then(querySnapshot => {
		//     const offers = []
		//   querySnapshot.forEach(doc => {
		//     const data = {
		//       'id' : doc.id,
		//       'image': doc.data().img,
		//       'dis': doc.data().dis,
		//       'desc': doc.data().desc,
		//     }
		//     offers.push(data)
		//     this.$store.state.offers[this.$route.params.storename] = offers
		//     console.log(offers)
		// 	})
		// 	})

		if (this.plan != 'Starter') {
			this.$store.state.secondaryDatabase.collection('products').where("owner", "==", this.$route.params.storename).where("type", "==", "bestselling").limit(8).onSnapshot(function (querySnapshot) {
				_this.bestSelling = [];
				querySnapshot.forEach(function (doc) {
					//console.log('this.bestSelling')
					var data = {
						'id': doc.id,
						'image': doc.data().img,
						'name': doc.data().name,
						'price': doc.data().price,
						'disprice': doc.data().disprice
					};
					_this.bestSelling.push(data);
					_this.products = _this.bestSelling;
					//console.log(this.bestSelling)
				});
				// this.loading = false
				// this.fetch = true
			});
			this.$store.state.secondaryDatabase.collection('products').where("owner", "==", this.$route.params.storename).where("type", "==", "latest").limit(8).onSnapshot(function (querySnapshot) {
				_this.latestItems = [];
				querySnapshot.forEach(function (doc) {
					//console.log('this.latestItems')
					var data = {
						'id': doc.id,
						'image': doc.data().img,
						'name': doc.data().name,
						'price': doc.data().price,
						'disprice': doc.data().disprice
					};
					_this.latestItems.push(data);
					//console.log(this.latestItems)
				});
			});
		}
	}
});

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_FirebaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      shops: [],
      address: "",
      email: "",
      tel1: "",
      tel2: "",
      plan: "",
      user: false,
      admin: false,
      cat: "",
      loc: "",
      searchQuery: {}
    };
  },

  methods: {
    setRoute: function setRoute(index) {
      this.$router.push({ name: index });
    },
    setRoute2: function setRoute2(index, query) {
      this.$router.push({ name: index, query: query });
    }
  },
  created: function created() {
    var _this = this;

    if (__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser) {
      if (__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.displayName == null) {
        this.user = true;
      } else if (__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.displayName == "shop owner" || __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.displayName == "starterplan shop owner") {
        this.admin = true;
      }
    }
    //console.log("navigator.onLine", navigator.onLine)
    if (this.$store.state.shops[this.$route.params.storename] != undefined) {
      this.address = this.$store.state.shops[this.$route.params.storename].details.address;
      this.email = this.$store.state.shops[this.$route.params.storename].details.email;
      this.tel1 = this.$store.state.shops[this.$route.params.storename].details.tel1;
      this.tel2 = this.$store.state.shops[this.$route.params.storename].details.tel2;
      this.plan = this.$store.state.shops[this.$route.params.storename].plan;
      this.cat = this.$store.state.shops[this.$route.params.storename].cat;
      this.loc = this.$store.state.searchLocation;
      this.searchQuery["cat"] = this.cat;
      this.searchQuery["loc"] = this.loc;
      //console.log('footer .$store.state.shops[this.$route.params.storename] is', this.$store.state.shops[this.$route.params.storename])
    } else {
      __WEBPACK_IMPORTED_MODULE_0__config_FirebaseInit__["a" /* default */].collection("shops").where("owner", "==", this.$route.params.storename).get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          var data = {
            shoptype: doc.data().shoptype,
            details: doc.data().details,
            plan: doc.data().plan,
            cat: doc.data().cat
          };
          _this.shops.push(data);
          _this.address = _this.shops[0].details.address;
          _this.email = _this.shops[0].details.email;
          _this.tel1 = _this.shops[0].details.tel1;
          _this.tel2 = _this.shops[0].details.tel2;
          _this.plan = _this.shops[0].plan;
          _this.cat = _this.shops[0].cat;
          _this.loc = _this.$store.state.searchLocation;
          _this.searchQuery["cat"] = _this.cat;
          _this.searchQuery["loc"] = _this.loc;

          //console.log("footer details are", this.shops[0].details)
          //console.log("url is", this.url)
        });
      });
    }
  }
});

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_FirebaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {
			loading: false,
			fetch: false,
			center: {},
			markers: [{
				position: {}
			}],
			load: false,
			shops: [],
			stime: '',
			etime: '',
			address: '',
			email: '',
			tel1: '',
			tel2: ''

		};
	},

	methods: {
		backToTop: function backToTop() {
			$('html,body').stop().animate({
				scrollTop: 0
			}, 'fast', 'swing');
		}
	},
	created: function created() {
		var _this = this;

		this.backToTop();
		this.loading = true;
		this.fetch = false;
		//console.log("navigator.onLine", navigator.onLine)
		__WEBPACK_IMPORTED_MODULE_0__config_FirebaseInit__["a" /* default */].collection('shops').where('owner', '==', this.$route.params.storename).get().then(function (querySnapshot) {
			querySnapshot.forEach(function (doc) {
				var data = {
					'shoptype': doc.data().shoptype,
					'details': doc.data().details
					// 'lat'   : doc.data().lat,
					// 'lng' : doc.data().lng
				};
				_this.shops.push(data);
				_this.address = _this.shops[0].details.address;
				_this.stime = _this.shops[0].details.stime;
				_this.etime = _this.shops[0].details.etime;
				_this.email = _this.shops[0].details.email;
				_this.tel1 = _this.shops[0].details.tel1;
				_this.tel2 = _this.shops[0].details.tel2;
				_this.center.lat = _this.shops[0].details.lat;
				_this.center.lng = _this.shops[0].details.lng;
				_this.markers[0].position.lat = _this.shops[0].details.lat;
				_this.markers[0].position.lng = _this.shops[0].details.lng;
				_this.load = true;
				//  this.center = this.shops[0].center
				//  this.markers[0].position = this.shops[0].center
				_this.loading = false;
				_this.fetch = true;
				//console.log("center are", this.center)
				//console.log("markers are", this.markers)
				//console.log("url is", this.url)
			});
		});
	}
});

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_FirebaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'about',
	data: function data() {
		return {
			loading: false,
			fetch: false,
			aboutimg: '',
			shops: [],
			about: '',
			address: '',
			tel1: ''
		};
	},

	methods: {
		backToTop: function backToTop() {
			$('html,body').stop().animate({
				scrollTop: 0
			}, 'fast', 'swing');
		}
	},
	created: function created() {
		var _this = this;

		this.backToTop();
		this.loading = true;
		this.fetch = false;
		//	console.log("navigator.onLine", navigator.onLine)
		__WEBPACK_IMPORTED_MODULE_0__config_FirebaseInit__["a" /* default */].collection('shops').where('owner', '==', this.$route.params.storename).get().then(function (querySnapshot) {
			querySnapshot.forEach(function (doc) {
				var data = {
					'shoptype': doc.data().shoptype,
					'aboutimg': doc.data().aboutimg,
					'about': doc.data().about,
					'details': doc.data().details
				};
				_this.shops.push(data);
				_this.aboutimg = _this.shops[0].aboutimg;
				_this.about = _this.shops[0].about;
				_this.address = _this.shops[0].details.address;
				_this.tel1 = _this.shops[0].details.tel1;

				//	console.log("details are", this.shops[0].details)
				//console.log("url is", this.url)
				_this.loading = false;
				_this.fetch = true;
			});
		});
	}
});

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_FirebaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_app__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



//import dataUrl from '../../data/dataUrl'
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "usersignup",
  data: function data() {
    var _this = this;

    var validatePass = function validatePass(rule, value, callback) {
      if (value === "") {
        callback(new Error("Please input the password"));
      } else {
        if (_this.formdata.checkPass !== "") {
          _this.$refs.formdata.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = function validatePass2(rule, value, callback) {
      if (value === "") {
        callback(new Error("Please input the password again"));
      } else if (value !== _this.formdata.pass) {
        callback(new Error("Two inputs don't match!"));
      } else {
        callback();
      }
    };
    return {
      checked: false,
      prvroute: "",
      loading: false,
      fetch: true,
      dataUrl: "",
      formdata: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        name: "",
        email: "",
        telephone: "",
        pass: "",
        checkPass: ""
      }, "telephone", ""),
      rules2: {
        pass: [{ validator: validatePass, trigger: "blur" }],
        checkPass: [{ validator: validatePass2, trigger: "blur" }]
      },
      labelPosition: "top"
    };
  },

  methods: {
    submit: function submit(checked) {
      if (checked) {
        //console.log('checked')
      }
      if (!checked) {
        //console.log('not checked')
      }
    },
    submitForm: function submitForm(fdata) {
      var _this2 = this;

      this.$refs[fdata].validate(function (valid) {
        if (valid) {
          _this2.fetch = false;
          _this2.loading = true;
          //console.log(this.prvroute)
          __WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].auth().createUserWithEmailAndPassword(_this2.formdata.email, _this2.formdata.pass).then(function (user) {
            // below code is to create admin & editor

            // user.user
            //   .updateProfile({
            //     displayName: "super admin",
            //   })
            //   .then(() => {
            //     // Update successful.
            //     //console.log(user)
            //   })
            //   .catch((error) => {
            //     alert(error);
            //     //console.log(error)
            //   });

            //console.log(user)
            __WEBPACK_IMPORTED_MODULE_1__config_FirebaseInit__["a" /* default */].collection("users").doc(__WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].auth().currentUser.uid).set({
              name: _this2.formdata.name,
              email: _this2.formdata.email,
              pswd: _this2.formdata.pass,
              telephone: _this2.formdata.telephone,
              uid: __WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].auth().currentUser.uid,
              refCode: "eshops" + Math.floor(Math.random() * 1000001),
              role: "visitor",
              favshops: [],
              favpages: []
            }).then(function (docRef) {
              // var id = docRef.id
              ////console.log(id)
              // alert(`Added ${user.email}` )
              _this2.fetch = false;
              _this2.loading = true;
              //console.log('prv',this.prvroute)
              //console.log('load', this.loading)
              //console.log('fetch', this.fetch)

              _this2.fetch = false;
              _this2.loading = true;
              //console.log('load', this.loading)
              //console.log('fetch', this.fetch)
            }).catch(function (error) {
              return alert(error);
            });
            __WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].auth().currentUser.sendEmailVerification().then(function () {
              // this.$router.push(this.prvroute);
              _this2.$router.push("/myaccount");
              //  if(this.prvroute == '/'){
              //   this.$router.push('/myaccount')
              //  // alert(`signin user ${user.email}`)
              //   }else{
              //      this.$router.push(this.prvroute)
              //  // alert(`signin user ${user.email}`)
              //   }
            }).catch(function (error) {
              return alert(error);
            });
          }).catch(function (error) {
            return alert(error);
          });
        } else {
          alert("error submit!!");
          return false;
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  },
  created: function created() {
    this.prvroute = true;
    //this.dataUrl = dataUrl
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    setTimeout(function () {
      next(function (vm) {
        vm.prvroute = from.fullPath;
      });
    }, 200);
  }
});

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_FirebaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


;
//import dataUrl from '../../data/dataUrl'
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "signin",
  data: function data() {

    return {
      ruleForm3: {

        email: '',
        pass: '',
        prvroute: ''

      },
      loading: false,
      fetch: true,
      dataUrl: '',
      modalShow: false,
      modalShow2: false,
      labelPosition: "top"
    };
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    //     // this.prvroute = from
    //     //console.log(from.fullPath)
    //     if(firebase.auth().currentUser){
    //     // if(firebase.auth().currentUser.displayName != 'shop owner'){
    //        setTimeout(() => {
    //       next()
    //     },100)
    //     //} 
    //     }

    setTimeout(function () {
      next(function (vm) {
        vm.prvroute = from.fullPath;
      });
    }, 200);
  },
  created: function created() {
    //this.dataUrl = dataUrl
  },

  methods: {
    respsw: function respsw() {
      var _this = this;

      if (this.ruleForm3.email == '') {
        this.modalShow = true;
      } else {
        var auth = __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth();
        var emailAddress = this.ruleForm3.email;

        auth.sendPasswordResetEmail(emailAddress).then(function () {
          // Email sent.
          _this.modalShow2 = true;
        }).catch(function (error) {
          // An error happened.
        });
      }
    },
    signin: function signin(formName) {
      var _this2 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this2.fetch = false;
          _this2.loading = true;
          __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().signInWithEmailAndPassword(_this2.ruleForm3.email, _this2.ruleForm3.pass).then(function (user) {

            //console.log(user)
            // if(firebase.auth().currentUser.displayName == 'shop owner'){
            //   this.$router.push('/admin')
            //  // alert(`signin admin ${user.email}` )
            // }else{
            if (_this2.prvroute == '/' || _this2.prvroute == '/startstore' || _this2.prvroute == '/termsofuse' || _this2.prvroute == 'privacypolicy' || _this2.prvroute == 'about') {
              if (__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.displayName == 'shop owner') {
                _this2.$router.push('/admin');
                // alert(`signin admin ${user.email}` )
              } else if (__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.displayName == 'starterplan shop owner') {
                _this2.$router.push('/admin');
              } else if (__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.displayName == 'page owner') {
                _this2.$router.push('/admin-services');
                // alert(`signin user ${user.email}`)
              } else if (__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.displayName == null) {
                _this2.$router.push('/myaccount');
                // alert(`signin user ${user.email}`)
              }
            } else {
              _this2.$router.push(_this2.prvroute);
              // alert(`signin user ${user.email}`)
            }
            //}
          }).catch(function (err) {
            _this2.fetch = true;
            _this2.loading = false;
            //console.log(err)
            alert(err);
          });
        } else {
          //console.log('error submit!!')
          return false;
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
});

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_FirebaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


;
/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'checkemail',
    data: function data() {
        return {
            display: '',
            curuser: '',
            direct: '',
            modalShow: false,
            modalShow2: false
        };
    },

    methods: {
        signin: function signin() {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.reload().then(function () {
                if (__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.emailVerified && __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.displayName == 'shop owner') {
                    _this.modalShow2 = true;
                    _this.$router.push('/admin');
                } else if (__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.emailVerified && __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.displayName == 'starterplan shop owner') {
                    //this.modalShow2 = true
                    _this.$router.push('/admin');
                } else if (__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.emailVerified && __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.displayName == 'page owner') {
                    //this.modalShow2 = true
                    _this.$router.push('/admin-services');
                } else if (__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.emailVerified && __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.displayName == null) {
                    _this.$router.push('/myaccount');
                } else {
                    _this.modalShow = true;
                }
            });
        }
    }
    //   computed: {
    //       verify: function(){
    //         //    var user = firebase.auth().currentUser
    //         //    console.log(user.emailVerified)
    //         //    if(user.emailVerified){
    //         //         console.log(user.emailVerified)
    //         //        this.display = 'block'
    //         //    }


    //       }
    //   },
    //   watch: {
    //     //   curuser(){

    //     //            console.log(user.emailVerified)
    //     //             if (user.emailVerified) {
    //     //                 // User is signed in.
    //     //                 this.display = user.emailVerified
    //     //                   console.log(user.emailVerified)
    //     //            this.display = 'block'
    //     //             } else {
    //     //                 // No user is signed in.
    //     //             }


    //     //   },
    //     curuser(){
    //         console.log('watch',firebase.auth().currentUser)
    //             // this.$router.push('/admin')

    //     }
    //   },
    //   created(){
    //       console.log('check',firebase.auth().currentUser)
    //   },
    //   mounted(){

    //        var user = firebase.auth().currentUser
    //                console.log(user.emailVerified)


    //                     // this.curuser = user.emailVerified


    //   }
});

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_FirebaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_towns__ = __webpack_require__(199);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "myaccount",
  data: function data() {
    return {
      loading: false,
      fetch: false,
      noresults: false,
      nofavshops: false,
      shops: [],
      category: "",
      location: "",
      sortby: "",
      labelPosition: "left",
      links: [],
      isVisible: false,
      lastVisible: "",
      favshops: [],
      refCode: "",
      emptyText: "Loading Records...",
      sortBy: null,
      sortDesc: false,
      filter: null,
      items: [],
      fields: [{ key: "name", label: "Shop", sortable: true }, { key: "status", label: "Paid", sortable: false }, { key: "regtel", label: "Telephone", sortable: false }, { key: "regemail", label: "Email", sortable: true }, { key: "location", label: "City", sortable: true }, { key: "created", label: "Created Date", sortable: true }, { key: "actions", label: "Actions" }]
    };
  },


  methods: {
    logout: function logout() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().signOut().then(function () {
        _this.$router.push("/");
      });
    },
    delFavShop: function delFavShop(shop) {
      var index = this.favshops[0].favshops.indexOf(shop.id);
      //console.log(index)
      //console.log(shop.id)
      if (index > -1) {
        this.favshops[0].favshops.splice(index, 1);
        //console.log(this.favshops[0].favshops)
        __WEBPACK_IMPORTED_MODULE_0__config_FirebaseInit__["a" /* default */].collection("users").doc(this.favshops[0].docid).update({
          favshops: this.favshops[0].favshops
        }).then(function () {
          //console.log('removed fav shop')
        }).catch(function (error) {
          //console.log('error',error)
        });
        this.backToTop();
        this.shops = this.shops.filter(function (s) {
          return s.id !== shop.id;
        });
        if (this.shops.length == 0) {
          this.nofavshops = true;
        }
      }
      //console.log('shops', this.shops)
    },
    userVisits: function userVisits(n) {
      if (__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser) {
        // if(firebase.auth().currentUser.displayName == 'shop owner' || firebase.auth().currentUser.displayName == 'starterplan shop owner'){
        //   var newVisits = this.shops[n].visits
        // }
        if (__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.displayName == null) {
          var newVisits = this.shops[n].visits + 1;
          //console.log('newvists', newVisits)
          __WEBPACK_IMPORTED_MODULE_0__config_FirebaseInit__["a" /* default */].collection("shops").doc(this.shops[n].id).update({
            visits: newVisits
          }).then(function () {
            //console.log('newvists', newVisits)
          }).catch(function (error) {
            //console.log('error',error)
          });
        }
      } else {
        // var newVisits = this.shops[n].visits + 1
        // //console.log('newvists', newVisits)
        //  db.collection('shops').doc(this.shops[n].id)
        // .update({
        //   visits: newVisits
        // })
        // .then(() => //console.log('newvists', newVisits))
        // .catch(error => //console.log('error',error))
      }
    }
  },
  created: function created() {
    var _this2 = this;

    this.$nextTick(function () {
      //  this.initToTopButton();
    });
    //this.backToTop()
    this.loading1 = true;
    this.fetch = false;
    __WEBPACK_IMPORTED_MODULE_0__config_FirebaseInit__["a" /* default */].collection("users").where("uid", "==", __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.uid).get().then(function (Snapshot) {
      Snapshot.forEach(function (doc) {
        _this2.refCode = doc.data().refCode;
        __WEBPACK_IMPORTED_MODULE_0__config_FirebaseInit__["a" /* default */].collection("shops").where("refCode", "==", doc.data().refCode).get().then(function (querySnapshot) {
          _this2.shops = [];
          querySnapshot.forEach(function (doc) {
            var data = {
              id: doc.id,
              name: doc.data().name,
              shoptype: doc.data().shoptype,
              location: doc.data().location,
              created: doc.data().created.toDate().toLocaleString(),
              regtel: doc.data().regtel,
              regemail: doc.data().regemail,
              status: doc.data().search
            };
            _this2.items.push(data);
          });
          if (_this2.items.length == 0) {
            _this2.emptyText = "There are no records to show";
          }
          _this2.loading1 = false;
          _this2.fetch = true;
        }).catch(function (error) {
          return alert(error);
        });
      });
    }).catch(function (error) {
      return alert(error);
    });

    // rendering fav shops
    //  db.collection('users').where('uid', '==', firebase.auth().currentUser.uid).get()
    //   .then(Snapshot => {
    //   Snapshot.forEach(doc => {
    //     const data = {
    //       'favshops' : doc.data().favshops,
    //       'docid' : doc.id

    //     }
    //     this.favshops.push(data)
    //       //console.log(this.favshops)
    //   })
    //   }).catch(error => alert(error))
    //  .then( () => {
    //    if(this.favshops[0].favshops.length != 0){
    //   this.favshops[0].favshops.forEach( shopId => {
    //       db.collection('shops').doc(shopId).get()
    //       .then(doc => {
    //                 const data = {
    //                         'id' : doc.id,
    //                         'name': doc.data().name,
    //                         'category': doc.data().cat,
    //                         'shoptype': doc.data().shoptype,
    //                         'location': doc.data().location,
    //                         'owner' : doc.data().owner,
    //                         'visits': doc.data().visits,
    //                         'homeimg':doc.data().homeimg,
    //                         'plan':doc.data().plan,
    //                         'details':doc.data().details,
    //                         'isHosted' : doc.data().isHosted,
    //                         'domain' : doc.data().domain,
    //                         'isCloned' : doc.data().isCloned,
    //                         'realOwner' : doc.data().realOwner
    //                         }
    //                 this.shops.push(data)
    //                 //console.log('shops',this.shops)
    //                 this.loading1 = false
    //             this.fetch = true
    //              if(this.shops.length == 0){
    //               this.noresults = true
    //                 //console.log("noresults", this.noresults);
    //             }
    //             // this.lastVisible = querySnapshot.docs[querySnapshot.docs.length-1];
    //             // //console.log(" moreitems last", this.lastVisible);
    //             // //console.log(" moreitems snapshot.length", querySnapshot.docs.length);
    //             // if(querySnapshot.docs.length < 1){
    //             //   this.lastVisible = undefined
    //             //     //console.log("last", this.lastVisible);
    //             // }

    //        }).catch(error => alert(error))

    //      })
    //    }else{
    //       this.loading1 = false
    //       this.fetch = true
    //       this.noresults = true
    //    }
    // }).catch(error => alert(error))
  },
  mounted: function mounted() {
    this.links = __WEBPACK_IMPORTED_MODULE_2__data_towns__["a" /* default */];
  }
});

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{ name: 'Kandy', value: "Kandy" }, { name: 'Galle', value: "Galle" }, { name: 'Colombo', value: "Colombo" }, { name: 'Embilipitiya', value: "Embilipitiya" }]);

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_FirebaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_regcities__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_shops__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_categories__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__main__ = __webpack_require__(15);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



//import dataUrl from '../../data/dataUrl'




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "regshop",

  data: function data() {
    var _this = this;

    var validatePass = function validatePass(rule, value, callback) {
      if (value === "") {
        callback(new Error("Please input the password"));
      } else {
        if (_this.formdata.checkPass !== "") {
          _this.$refs.formdata.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = function validatePass2(rule, value, callback) {
      if (value === "") {
        callback(new Error("Please input the password again"));
      } else if (value !== _this.formdata.pass) {
        callback(new Error("Two inputs don't match!"));
      } else {
        callback();
      }
    };

    return {
      cities: [],
      city: [],
      shops: [],
      catValues: {},
      plan: "",
      users: [],
      docid: "",
      dataUrl: "",
      disableEmail: false,
      modalShow: false,
      modalShow1: false,
      modalShow2: false,
      modalShow3: false,
      // subshops:[],
      shopcat: [],
      checked: true,
      loading: false,
      fetch: false,
      config: {},
      formdata: {
        location: "",
        district: "",
        categories: {},
        shopcat: "",
        shoptype: "",
        name: "",
        rank: "",
        email: "",
        api: "",
        sysid: "",
        pidNo: '',
        pass: "",
        checkPass: "",
        telephone: "",
        refCode: "",
        maxProducts: "",
        curProducts: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: "",
        links: []
      },
      owner: "",
      isLoggedIn: false,
      currentUser: false,
      userDisplayName: '',
      labelPosition: "top",
      rules: {
        pass: [{ validator: validatePass, trigger: "blur" }],
        checkPass: [{ validator: validatePass2, trigger: "blur" }],
        name: [{
          required: true,
          message: "Please input shop name",
          trigger: "blur"
        }, {
          min: 3,
          max: 50,
          message: "Length should be 3 to 50",
          trigger: "blur"
        }],

        location: [{
          required: true,
          message: "Please select location",
          trigger: "change"
        }],
        shopcat: [{
          required: true,
          message: "Please pick a category",
          trigger: "change"
        }],
        type: [{
          type: "array",
          required: true,
          message: "Please select at least one activity type",
          trigger: "change"
        }],
        resource: [{
          required: true,
          message: "Please select activity resource",
          trigger: "change"
        }],
        desc: [{
          required: true,
          message: "Please input activity form",
          trigger: "blur"
        }]
      }
    };
  },

  watch: {
    // shopcat(){
    //   this.subshops = []
    //   this.formdata.shoptype = ''
    //   this.subshops = this.shops[this.shopcat]
    //   //console.log('subshops', this.subshops)
    // }
  },
  methods: {
    handleChange: function handleChange(value) {
      //console.log(value)
      this.formdata.district = value[0];
      this.formdata.location = value[1];
      //console.log('this.searchForm.location',this.formdata.location)
      //console.log('this.searchForm.district',this.formdata.district)
    },
    handleChange2: function handleChange2(value) {
      //console.log(value)
      if (value.length == 0) {
        this.formdata.shopcat = "";
      } else if (value.length == 1) {
        this.formdata.shopcat = value[0];
        this.formdata.categories = __WEBPACK_IMPORTED_MODULE_5__data_categories__["a" /* default */][value[0]];
        var catvalue = [];
        catvalue = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.formdata.categories);
        var newObj = {};
        for (var i = 0; i < catvalue.length; i++) {
          newObj[catvalue[i]] = 0;
        }
        this.catValues = newObj;
        //console.log('catValues',this.catValues)
        //console.log('category1',this.formdata.shopcat)
        //console.log('categories are',this.formdata.categories)
      } else if (value.length == 2) {
        if (value[0] == "Home Appliances" || value[0] == "Home Decor" || value[0] == "Essential Goods & Food") {
          this.formdata.shopcat = value[1];
          this.formdata.categories = __WEBPACK_IMPORTED_MODULE_5__data_categories__["a" /* default */][value[1]];
          var catvalue = [];
          catvalue = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.formdata.categories);
          var newObj = {};
          for (var i = 0; i < catvalue.length; i++) {
            newObj[catvalue[i]] = 0;
          }
          this.catValues = newObj;
          // console.log('catValues',this.catValues)
          // console.log('category2',this.formdata.shopcat)
          //  console.log('categories are',this.formdata.categories)
        } else if (value[0] == "Vehicles" || value[0] == "Auto Parts") {
          this.formdata.shopcat = value[0];
          this.formdata.shoptype = value[1];
          this.formdata.categories = __WEBPACK_IMPORTED_MODULE_5__data_categories__["a" /* default */][value[0]];
          var catvalue = [];
          catvalue = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.formdata.categories);
          var newObj = {};
          for (var i = 0; i < catvalue.length; i++) {
            newObj[catvalue[i]] = 0;
          }
          this.catValues = newObj;
          //console.log('catValues',this.catValues)
          //console.log('category2',this.formdata.shopcat)
          //console.log('categories are',this.formdata.categories)
        } else {
          this.formdata.shopcat = value[0];
          this.formdata.shoptype = value[1];
          this.formdata.categories = __WEBPACK_IMPORTED_MODULE_5__data_categories__["a" /* default */][value[1]];
          var catvalue = [];
          catvalue = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.formdata.categories);
          var newObj = {};
          for (var i = 0; i < catvalue.length; i++) {
            newObj[catvalue[i]] = 0;
          }
          this.catValues = newObj;
          //console.log('catValues',this.catValues)
          //console.log('category',this.formdata.shopcat)
          //console.log('type',this.formdata.shoptype)
          //console.log('categories are',this.formdata.categories)
        }
      }
    },
    submitForm: function submitForm(fdata) {
      var _this2 = this;

      this.$refs[fdata].validate(function (valid) {
        if (valid) {
          _this2.fetch = false;
          _this2.loading = true;
          var displayName = "shop owner";
          var permissions = _this2.$store.state.permissionsList;
          if (_this2.plan === 'Starter' || _this2.plan === 'Basic') {
            displayName = 'starterplan shop owner';
            permissions = _this2.$store.state.starterPlanPermissionsList;
          }

          if (__WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].auth().currentUser) {
            if (__WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].auth().currentUser.displayName == "editor" || __WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].auth().currentUser.displayName == "super admin") {
              // this.config.projectId = "eshopslkshop" + this.pidNo;
              _this2.config.projectId = _this2.formdata.pidNo; //"eshopslk-pos-" + this.pidNo; // example -> eshopslk-pos-1
              //console.log('this.config', this.config['projectId'])
              _this2.config.authDomain = _this2.config.projectId + ".firebaseapp.com";
              _this2.config.databaseURL = "https://" + _this2.config.projectId + ".firebaseio.com";
              _this2.config.storageBucket = _this2.config.projectId + ".appspot.com";
              _this2.config.apiKey = _this2.formdata.api;

              // below if condition and firebase auth implementation for previous self shop registration

              // if (firebase.auth().currentUser.displayName == null) {
              // var user = firebase.auth().currentUser;
              // user
              //   .updateProfile({
              //     displayName: "shop owner",
              //   })
              //   .then(() => {
              //     // Update successful.
              //     //console.log(user)
              //   })
              //   .catch((error) => {
              //     alert(error);
              //     //console.log(error)
              //   });

              // db.collection("users")
              //   .doc(this.docid)
              //   .update({
              //     name: this.formdata.name,
              //     pswd: this.formdata.pass,
              //     role: "shop owner",
              //   })
              //   .then((docRef) => {
              //     //console.log(id)
              //   })
              //   .catch((error) => {
              //     // alert(error)
              //     //console.log(error)
              //   });

              // console.log("curentUser", firebase.auth().currentUser);

              var user = void 0;
              __WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].auth().createUserWithEmailAndPassword(_this2.formdata.email, _this2.formdata.pass).then(function (newUser) {
                // alert('Please Wait a Moment. Your Account is being Created.')
                // console.log(
                //   "curentUser after reg",
                //   firebase.auth().currentUser
                // );
                user = newUser.user;
                user.updateProfile({
                  displayName: displayName
                }).then(function () {
                  // Update successful.
                  //console.log(user)
                }).catch(function (error) {
                  alert(error);
                });

                __WEBPACK_IMPORTED_MODULE_1__config_FirebaseInit__["a" /* default */].collection("users").doc(user.uid).set({
                  name: _this2.formdata.name,
                  email: _this2.formdata.email,
                  pswd: _this2.formdata.pass,
                  uid: user.uid,
                  role: displayName,
                  favshops: [],
                  favpages: [],
                  created: __WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].firestore.Timestamp.now()
                }).then(function (docRef) {
                  //var id = docRef.id
                  // //console.log(id)
                }).catch(function (error) {
                  alert(error);
                });

                if (_this2.plan == "Starter") {
                  _this2.formdata.maxProducts = 25;
                  _this2.formdata.rank = 10;
                } else if (_this2.plan == "Basic") {
                  _this2.formdata.maxProducts = 200;
                  _this2.formdata.rank = 8;
                } else if (_this2.plan == "Premium") {
                  _this2.formdata.maxProducts = 2000;
                  _this2.formdata.rank = 6;
                } else if (_this2.plan == "Enterprise") {
                  _this2.formdata.maxProducts = 5000;
                  _this2.formdata.rank = 4;
                } else {
                  _this2.formdata.maxProducts = 0;
                  _this2.formdata.rank = 99999;
                }
                __WEBPACK_IMPORTED_MODULE_1__config_FirebaseInit__["a" /* default */].collection("shops").doc(user.uid).set({
                  name: _this2.formdata.name,
                  plan: _this2.plan,
                  district: _this2.formdata.district,
                  location: _this2.formdata.location,
                  categories: _this2.formdata.categories,
                  cat: _this2.formdata.shopcat,
                  shoptype: _this2.formdata.shoptype,
                  catValues: _this2.catValues,
                  maxProducts: _this2.formdata.maxProducts,
                  curProducts: 0,
                  curOffers: 0,
                  search: "yes",
                  visits: 0,
                  orders: 0,
                  created: __WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].firestore.Timestamp.now(),
                  rank: _this2.formdata.rank,
                  permission: "allowed",
                  owner: user.uid,
                  regemail: _this2.formdata.email,
                  regtel: _this2.formdata.telephone,
                  refCode: _this2.formdata.refCode,
                  config: _this2.config,
                  hasconfig: true,
                  details: {
                    stime: "",
                    etime: "",
                    tel1: "",
                    tel2: "",
                    address: "",
                    email: "",
                    lat: "",
                    lng: ""
                  },
                  cus: 0,
                  pay: 0,
                  users: 0,
                  invo: 0,
                  netPay: 0,
                  totalRemain: 0,
                  setting: {
                    printSize: "POS Printer 80 mm Paper",
                    printPopup: true,
                    discountMode: "Percentage",
                    lowStockAlertQuantity: 1,
                    loyalityPoints: 0,
                    referralPoints: 0,
                    header: "",
                    footer: ""
                  },
                  noDB: false
                }).then(function (docRef) {
                  _this2.pidNo += 1;
                  _this2.cusNo += 1;
                  __WEBPACK_IMPORTED_MODULE_1__config_FirebaseInit__["a" /* default */].collection("aaa").doc("pid").update({
                    pidNo: _this2.pidNo,
                    cusNo: _this2.cusNo
                  }).then(function () {
                    var secondary = __WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].initializeApp(_this2.config, user.uid);
                    _this2.$store.state.secondaryDatabase = secondary.firestore();
                    // this.$store.state.secondaryApp = this.$route.params.storename
                    _this2.$store.state.secondaryDatabase.settings({
                      timestampsInSnapshots: true
                    });
                    _this2.$store.state.secondaryDatabase.enablePersistence({
                      synchronizeTabs: true
                    }).then(function () {
                      //console.log("Woohoo! Multi-Tab Persistence!");
                    });

                    __WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].auth(secondary).createUserWithEmailAndPassword(_this2.formdata.email, user.uid).then(function (usr) {}).catch(function (err) {
                      return alert(err);
                    });
                    _this2.$store.state.secondaryDatabase.collection("shops").doc(user.uid).set({
                      name: _this2.formdata.name,
                      plan: _this2.plan,
                      district: _this2.formdata.district,
                      location: _this2.formdata.location,
                      categories: _this2.formdata.categories,
                      cat: _this2.formdata.shopcat,
                      shoptype: _this2.formdata.shoptype,
                      catValues: _this2.catValues,
                      maxProducts: _this2.formdata.maxProducts,
                      curProducts: 0,
                      curOffers: 0,
                      search: "yes",
                      visits: 0,
                      orders: 0,
                      created: __WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].firestore.Timestamp.now(),
                      rank: _this2.formdata.rank,
                      permission: "allowed",
                      owner: user.uid,
                      regemail: _this2.formdata.email,
                      regtel: _this2.formdata.telephone,
                      refCode: _this2.formdata.refCode,
                      config: _this2.config,
                      hasconfig: true,
                      details: {
                        stime: "",
                        etime: "",
                        tel1: "",
                        tel2: "",
                        address: "",
                        email: "",
                        lat: "",
                        lng: ""
                      },
                      cus: 0,
                      pay: 0,
                      users: 1, // adding belowa as admin
                      invo: 0,
                      netPay: 0,
                      totalRemain: 0,
                      setting: {
                        printSize: "POS Printer 80 mm Paper",
                        printPopup: true,
                        discountMode: "Percentage",
                        lowStockAlertQuantity: 1,
                        loyalityPoints: 0,
                        referralPoints: 0,
                        header: "",
                        footer: ""
                      }
                    }).then(function (id) {
                      //console.log('secondaryDB shop id', id)
                      var sysuser = {
                        name: "Admin",
                        email: _this2.formdata.email,
                        city: _this2.formdata.location,
                        regdate: __WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].firestore.Timestamp.now(),
                        //uid: firebase.auth().currentUser.uid,
                        telephone: _this2.formdata.telephone,
                        sysid: _this2.formdata.sysid || "1234",
                        role: "Admin",
                        store: [],
                        note: "",
                        permissions: permissions
                      };
                      _this2.$store.state.secondaryDatabase.collection("sysusers").add(sysuser).then(function (docRef) {
                        _this2.$store.state.systemUser = sysuser;
                        delete _this2.$store.state.systemUser.sysid;
                      }).catch(function (error) {
                        return alert(error);
                      });
                      __WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].auth().currentUser.sendEmailVerification().then(function () {
                        window.location.reload();
                        //this.$router.push("/admin");
                      }).catch(function (error) {
                        return alert(error);
                      });
                    }).catch(function (error) {
                      return alert(error);
                    });
                  }).catch(function (error) {
                    return alert(error);
                  });
                  // var id = docRef.id
                  // //console.log(id)
                  //this.modalShow3 = true
                  //console.log(docRef.id)
                  //  db.collection('shops').doc(docRef.id)
                  // .collection('notify').add(
                  // {
                  //   notice: {
                  //     title:'Congratulations!',
                  //     msg:'Your eshop has been successfully created.'
                  //   }
                  // })
                  // .then(docRef => {
                  //this.$router.push("/admin");
                  //   //console.log('msg added')
                  // }).catch(error =>{
                  //     alert(error)
                  //     //console.log(error)
                  // })
                  // firebase.auth().currentUser.photoURL = docRef.id;
                  // //console.log(firebase.auth().currentUser.photoURL)
                }).catch(function (error) {
                  alert(error);
                  //console.log(error)
                });
              }).catch(function (error) {
                alert(error);
              });
            } else if (__WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].auth().currentUser.displayName == "shop owner" || __WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].auth().currentUser.displayName == "starterplan shop owner") {
              if (_this2.formdata.email == __WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].auth().currentUser.email) {
                _this2.fetch = true;
                _this2.loading = false;
                _this2.modalShow = true;
              } else {
                _this2.fetch = true;
                _this2.loading = false;
                _this2.modalShow1 = true;
              }
            } else if (__WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].auth().currentUser.displayName == "page owner") {
              if (_this2.formdata.email == __WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].auth().currentUser.email) {
                _this2.fetch = true;
                _this2.loading = false;
                _this2.modalShow2 = true;
              } else {
                _this2.fetch = true;
                _this2.loading = false;
                _this2.modalShow1 = true;
              }
            }
          } else {
            __WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].auth().createUserWithEmailAndPassword(_this2.formdata.email, _this2.formdata.pass).then(function (user) {
              // alert('Please Wait a Moment. Your Account is being Created.')
              var user = __WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].auth().currentUser;
              user.updateProfile({
                displayName: displayName
              }).then(function () {
                // Update successful.
                //console.log(user)
              }).catch(function (error) {
                alert(error);
              });

              // user.sendEmailVerification().then(() => {
              //this.$router.push("/verifyemail");
              //console.log(user, "Email sent");// Email sent.
              __WEBPACK_IMPORTED_MODULE_1__config_FirebaseInit__["a" /* default */].collection("users").doc(__WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].auth().currentUser.uid).set({
                name: _this2.formdata.name,
                email: _this2.formdata.email,
                pswd: _this2.formdata.pass,
                uid: user.uid,
                role: displayName,
                favshops: [],
                favpages: [],
                created: __WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].firestore.Timestamp.now()
              }).then(function (docRef) {
                //var id = docRef.id
                // //console.log(id)
              }).catch(function (error) {
                //console.log(error)
              });

              if (_this2.plan == "Starter") {
                _this2.formdata.maxProducts = 25;
                _this2.formdata.rank = 10;
              } else if (_this2.plan == "Basic") {
                _this2.formdata.maxProducts = 200;
                _this2.formdata.rank = 8;
              } else if (_this2.plan == "Premium") {
                _this2.formdata.maxProducts = 2000;
                _this2.formdata.rank = 6;
              } else if (_this2.plan == "Enterprise") {
                _this2.formdata.maxProducts = 10000;
                _this2.formdata.rank = 4;
              } else {
                _this2.formdata.maxProducts = 0;
                _this2.formdata.rank = 99999;
              }
              __WEBPACK_IMPORTED_MODULE_1__config_FirebaseInit__["a" /* default */].collection("shops").doc(__WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].auth().currentUser.uid).set({
                name: _this2.formdata.name,
                plan: _this2.plan,
                district: _this2.formdata.district,
                location: _this2.formdata.location,
                categories: _this2.formdata.categories,
                cat: _this2.formdata.shopcat,
                shoptype: _this2.formdata.shoptype,
                catValues: _this2.catValues,
                maxProducts: _this2.formdata.maxProducts,
                curProducts: 0,
                curOffers: 0,
                search: "yes",
                visits: 0,
                orders: 0,
                created: __WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].firestore.Timestamp.now(),
                rank: _this2.formdata.rank,
                permission: "allowed",
                owner: user.uid,
                regemail: _this2.formdata.email,
                regtel: _this2.formdata.telephone,
                refCode: _this2.formdata.refCode,
                config: _this2.config,
                hasconfig: true,
                details: {
                  stime: "",
                  etime: "",
                  tel1: "",
                  tel2: "",
                  address: "",
                  email: "",
                  lat: "",
                  lng: ""
                },
                cus: 0,
                pay: 0,
                users: 0,
                invo: 0,
                netPay: 0,
                totalRemain: 0,
                setting: {
                  printSize: "POS Printer 80 mm Paper",
                  printPopup: true,
                  discountMode: "Percentage",
                  lowStockAlertQuantity: 1,
                  loyalityPoints: 0,
                  referralPoints: 0,
                  header: "",
                  footer: ""
                },
                noDB: true
              }).then(function (docRef) {
                _this2.pidNo += 1;
                _this2.cusNo += 1;
                __WEBPACK_IMPORTED_MODULE_1__config_FirebaseInit__["a" /* default */].collection("aaa").doc("pid").update({
                  // pidNo: this.pidNo, // as not having own DB
                  cusNo: _this2.cusNo
                }).then(function () {
                  // if having own DB - will not happen when user creating account as he cant create indexes
                  // so commented below block

                  // if (noDB) { 
                  // var secondary = firebase.initializeApp(
                  //   this.config,
                  //   firebase.auth().currentUser.uid
                  // );
                  // this.$store.state.secondaryDatabase =
                  //   secondary.firestore();
                  // // this.$store.state.secondaryApp = this.$route.params.storename
                  // this.$store.state.secondaryDatabase.settings({
                  //   timestampsInSnapshots: true,
                  // });
                  // this.$store.state.secondaryDatabase
                  //   .enablePersistence({
                  //     synchronizeTabs: true,
                  //   })
                  //   .then(() => {
                  //     //console.log("Woohoo! Multi-Tab Persistence!");
                  //   });
                  // this.$store.state.secondaryDatabase
                  //   .collection("shops")
                  //   .doc(firebase.auth().currentUser.uid)
                  //   .set({
                  //     name: this.formdata.name,
                  //     plan: this.plan,
                  //     district: this.formdata.district,
                  //     location: this.formdata.location,
                  //     categories: this.formdata.categories,
                  //     cat: this.formdata.shopcat,
                  //     shoptype: this.formdata.shoptype,
                  //     catValues: this.catValues,
                  //     maxProducts: this.formdata.maxProducts,
                  //     curProducts: 0,
                  //     curOffers: 0,
                  //     search: "yes",
                  //     visits: 0,
                  //     orders: 0,
                  //     created: firebase.firestore.Timestamp.now(),
                  //     rank: this.formdata.rank,
                  //     permission: "allowed",
                  //     owner: user.uid,
                  //     regemail: this.formdata.email,
                  //     regtel: this.formdata.telephone,
                  //     refCode: this.formdata.refCode,
                  //     config: this.config,
                  //     hasconfig: true,
                  //     details: {
                  //       stime: "",
                  //       etime: "",
                  //       tel1: "",
                  //       tel2: "",
                  //       address: "",
                  //       email: "",
                  //       lat: "",
                  //       lng: "",
                  //     },
                  //     cus: 0,
                  //     pay: 0,
                  //     users: 0,
                  //     invo: 0,
                  //     netPay: 0,
                  //     totalRemain: 0,
                  //     setting: {
                  //       printSize: "POS Printer 80 mm Paper",
                  //       printPopup: true,
                  //       discountMode: "Percentage",
                  //       lowStockAlertQuantity: 1,
                  //       loyalityPoints: 0,
                  //       referralPoints: 0,
                  //       header: "",
                  //       footer: "",
                  //     },
                  //   })
                  //   .then((id) => {
                  //     //console.log('secondaryDB shop id', id)

                  //      this.$store.state.secondaryDatabase
                  //         .collection("sysusers")
                  //         .add({
                  //           name: "Admin",
                  //           email: this.formdata.email,
                  //           city: this.formdata.location,
                  //           regdate: firebase.firestore.Timestamp.now(),
                  //           //uid: firebase.auth().currentUser.uid,
                  //           telephone: this.formdata.telephone,
                  //           sysid: "1234",
                  //           role: "Admin",
                  //           store: [],
                  //           note: "",
                  //           permissions: this.$store.state.permissionsList,
                  //         })
                  //         .then((docRef) => {})
                  //         .catch((error) => alert(error));
                  //       firebase
                  //         .auth()
                  //         .currentUser.sendEmailVerification()
                  //         .then(() => {
                  //           this.$store.state.systemUser.isLogedIn = true;
                  //           this.$store.state.systemUser.role = "Admin";
                  //           this.$router.push("/admin");
                  //         })
                  //         .catch((error) => alert(error));
                  //   })
                  //   .catch((error) => {
                  //     //console.log(error)
                  //   });
                  // } else {
                  _this2.$store.state.secondaryDatabase = __WEBPACK_IMPORTED_MODULE_1__config_FirebaseInit__["a" /* default */];

                  _this2.$store.state.secondaryDatabase.collection("stores").add({
                    name: _this2.formdata.name,
                    email: _this2.formdata.email,
                    city: _this2.formdata.location,
                    address: '',
                    telephone: _this2.formdata.telephone,
                    invo: 0,
                    netPay: 0,
                    totalRemain: 0,
                    totalProfit: 0,
                    POTotal: 0,
                    POs: 0,
                    PORemain: 0,
                    totalExp: 0,
                    shopOwner: __WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].auth().currentUser.uid,
                    setting: {
                      printSize: "POS Printer 80 mm Paper",
                      printPopup: true,
                      // discountMode: "",
                      taxMode: "Percentage",
                      // lowStockAlertQuantity: 1,
                      loyalityPoints: 0,
                      referralPoints: 0,
                      // header: "",
                      footer: "",
                      printOnly: true
                    }
                  }).then(function (docRef) {
                    var sysuser = {
                      name: "Admin",
                      email: _this2.formdata.email,
                      city: _this2.formdata.location,
                      regdate: __WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].firestore.Timestamp.now(),
                      shopOwner: __WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].auth().currentUser.uid,
                      telephone: _this2.formdata.telephone,
                      sysid: _this2.formdata.sysid || "1234",
                      role: "Admin",
                      store: [docRef.id],
                      note: "",
                      permissions: permissions
                    };
                    _this2.$store.state.secondaryDatabase.collection("sysusers").add(sysuser).then(function (docRef) {
                      _this2.$store.state.systemUser = sysuser;
                      delete _this2.$store.state.systemUser.sysid;
                    }).catch(function (error) {
                      return alert(error);
                    });
                  }).catch(function (error) {
                    return alert(error);
                  });

                  __WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].auth().currentUser.sendEmailVerification().then(function () {
                    window.location.reload(true);
                    //this.$router.push("/admin");
                  }).catch(function (error) {
                    return alert(error);
                  });
                  // }
                }).catch(function (error) {
                  //console.log(error)
                });
                //var id = docRef.id
                //console.log(id)
                //this.modalShow3 = true
                //console.log(docRef.id)
                //  db.collection('shops').doc(id)
                // .collection('notify').add(
                // {
                //   notice: {
                //     title:'Congratulations!',
                //     msg:'Your eshop has been successfully created.'
                //   }
                // })
                // .then(docRef => {
                //   //console.log('msg added')
                // }).catch(error =>{
                //     alert(error)
                // })
                // firebase.auth().currentUser.photoURL = docRef.id;
                // //console.log(firebase.auth().currentUser.photoURL)
              }).catch(function (error) {
                //console.log(error)
              });

              // }).catch(error =>{
              //       console.log(error)
              //     })
            }).catch(function (error) {
              //console.log(error)
            });
          }
        } else {
          alert("error submit!!!");
          return false;
        }
      });
      //var user = firebase.auth().currentUser;
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    querySearch: function querySearch(queryString, cb) {
      var links = this.links;
      var results = queryString ? links.filter(this.createFilter(queryString)) : links;
      // call callback function to return suggestions
      cb(results);
    },
    createFilter: function createFilter(queryString) {
      return function (link) {
        return link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },
    loadAll: function loadAll() {
      return [{ value: "Kandy", link: "https://github.com/vuejs/vue" }, { value: "Embilipitiya", link: "https://github.com/ElemeFE/element" }, { value: "cooking", link: "https://github.com/ElemeFE/cooking" }, { value: "mint-ui", link: "https://github.com/ElemeFE/mint-ui" }, { value: "vuex", link: "https://github.com/vuejs/vuex" }, { value: "vue-router", link: "https://github.com/vuejs/vue-router" }, { value: "babel", link: "https://github.com/babel/babel" }, { value: "vue", link: "https://github.com/vuejs/vue" }, { value: "element", link: "https://github.com/ElemeFE/element" }, { value: "cooking", link: "https://github.com/ElemeFE/cooking" }, { value: "mint-ui", link: "https://github.com/ElemeFE/mint-ui" }, { value: "vuex", link: "https://github.com/vuejs/vuex" }, { value: "vue-router", link: "https://github.com/vuejs/vue-router" }];
    },
    handleSelect: function handleSelect(item) {
      //console.log(item);
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    //console.log('path', to.fullPath)
    if (to.fullPath == "/registration/Basic" || to.fullPath == "/registration/Premium" || to.fullPath == "/registration/Enterprise") {
      next();
    } else {
      setTimeout(function () {
        next(function (vm) {
          return vm.$router.push(from.fullPath);
        });
      }, 100);
    }
  },
  mounted: function mounted() {
    this.links = this.loadAll();
    // this.loading = false
    // this.fetch = true
  },
  created: function created() {
    var _this3 = this;

    this.loading = true;
    this.fetch = false;
    //this.dataUrl = dataUrl
    //console.log('screen',screen.width)
    if (screen.width > 575) {
      this.labelPosition = "right";
    } else {
      this.labelPosition = "top";
    }
    this.cities = __WEBPACK_IMPORTED_MODULE_3__data_regcities__["a" /* default */];
    this.shops = __WEBPACK_IMPORTED_MODULE_4__data_shops__["a" /* default */];
    this.plan = this.$route.params.plan || "Premium";
    if (__WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].auth().currentUser) {
      this.userDisplayName = __WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].auth().currentUser.displayName;
      if (__WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].auth().currentUser.displayName == null) {
        this.formdata.email = __WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].auth().currentUser.email;
        this.disableEmail = true;
        __WEBPACK_IMPORTED_MODULE_1__config_FirebaseInit__["a" /* default */].collection("users").where("uid", "==", __WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].auth().currentUser.uid).get().then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            var data = {
              docid: doc.id
            };
            _this3.users.push(data);
            _this3.docid = _this3.users[0].docid;
            //console.log('this.docid',this.docid)
          });
        });
      }
      // this.isLoggedIn = true;
      // this.currentUser = firebase.auth().currentUser.email;
    }
    this.loading = true;
    this.fetch = false;
    __WEBPACK_IMPORTED_MODULE_1__config_FirebaseInit__["a" /* default */].collection("aaa").doc("pid").get().then(function (doc) {
      _this3.pidNo = doc.data().pidNo;
      _this3.cusNo = doc.data().cusNo;
      _this3.loading = false;
      _this3.fetch = true;
    }).catch(function (error) {
      return alert(error);
    });
  }
});

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    value: 'Essential Goods & Food',
    label: 'Essential Goods & Food',

    children: [{
        value: 'Vegetables & Fruits',
        label: 'Vegetables & Fruits'
    }, {
        value: 'Supermarket',
        label: 'Supermarket'
    }, {
        value: 'Grocery',
        label: 'Grocery'
    }, {
        value: 'Food / Restaurants',
        label: 'Food / Restaurants'
    }, {
        value: 'Agri Products',
        label: 'Agri Products'
    }]
}, {
    value: 'Clothing',
    label: 'Clothing',

    children: [{
        value: 'Men’s & Women’s Clothing',
        label: 'Men’s & Women’s Clothing'
    }, {
        value: 'Men’s Clothing',
        label: 'Men’s Clothing'
    }, {
        value: 'Women’s Clothing',
        label: 'Women’s Clothing'
    }] }, {
    value: 'Vehicles',
    label: 'Vehicles',

    children: [{
        value: 'All Vehicles',
        label: 'All Vehicles'
    }, {
        value: 'Car',
        label: 'Car'
    }, {
        value: 'Van',
        label: 'Van'
    },, {
        value: 'Jeep & Pickup',
        label: 'Jeep & Pickup'
    },, {
        value: 'Crew Cab',
        label: 'Crew Cab'
    },, {
        value: 'Bus',
        label: 'Bus'
    },, {
        value: 'Lorry',
        label: 'Lorry'
    },, {
        value: 'Tipper',
        label: 'Tipper'
    },, {
        value: 'Truck',
        label: 'Truck'
    },, {
        value: 'Three Wheeler',
        label: 'Three Wheeler'
    },, {
        value: 'Motorcycle',
        label: 'Motorcycle'
    },, {
        value: 'Heavy-Duty & Land Vehicle',
        label: 'Heavy-Duty & Land Vehicle'
    }, {
        value: 'Agriculture Machinery',
        label: 'Agriculture Machinery'
    }] }, {
    value: 'Auto Parts',
    label: 'Auto Parts',

    children: [{
        value: 'All Vehicles',
        label: 'All Vehicles'
    }, {
        value: 'Car',
        label: 'Car'
    }, {
        value: 'Van',
        label: 'Van'
    },, {
        value: 'Jeep & Pickup',
        label: 'Jeep & Pickup'
    },, {
        value: 'Crew Cab',
        label: 'Crew Cab'
    },, {
        value: 'Bus',
        label: 'Bus'
    },, {
        value: 'Lorry',
        label: 'Lorry'
    },, {
        value: 'Tipper',
        label: 'Tipper'
    },, {
        value: 'Truck',
        label: 'Truck'
    },, {
        value: 'Three Wheeler',
        label: 'Three Wheeler'
    },, {
        value: 'Motorcycle',
        label: 'Motorcycle'
    },, {
        value: 'Heavy-Duty & Land Vehicle',
        label: 'Heavy-Duty & Land Vehicle'
    }, {
        value: 'Agriculture Machinery',
        label: 'Agriculture Machinery'
    }] }, {
    value: 'Shoes & Footwear',
    label: 'Shoes & Footwear'
}, {
    value: 'Mobiles & Tablets',
    label: 'Mobiles & Tablets'
}, {
    value: 'Computers',
    label: 'Computers'
}, {
    value: 'Electronics',
    label: 'Electronics'
}, {
    value: 'Cameras',
    label: 'Cameras'
}, {
    value: 'Tools & Machines',
    label: 'Tools & Machines'
}, {
    value: 'Home Appliances',
    label: 'Home Appliances',

    children: [{
        value: 'Household Supplies',
        label: 'Household Supplies'
    }, {
        value: 'Tiles & Bathware',
        label: 'Tiles & Bathware'
    }, {
        value: 'Lighting & Electrical',
        label: 'Lighting & Electrical'
    }, {
        value: 'Outdoor',
        label: 'Outdoor'
    }]
}, {
    value: 'Home Decor',
    label: 'Home Decor',

    children: [{
        value: 'Home Decoration',
        label: 'Home Decoration'
    }, {
        value: 'Window Treatments',
        label: 'Window Treatments'
    }, {
        value: 'Handicrafts',
        label: 'Handicrafts'
    }]
}, {
    value: 'Furniture',
    label: 'Furniture'
}, {
    value: 'Health & Beauty',
    label: 'Health & Beauty'
}, {
    value: 'Fancy Items',
    label: 'Fancy Items'
}, {
    value: 'Jewelry & Watches',
    label: 'Jewelry & Watches',

    children: [{
        value: 'Jewelry & Watches',
        label: 'Jewelry & Watches'
    }, {
        value: 'Jewelry',
        label: 'Jewelry'
    }, {
        value: 'Watches',
        label: 'Watches'
    }] }, {
    value: 'Diamonds & Gems',
    label: 'Diamonds & Gems'
}, {
    value: 'Baby Kids & Toys',
    label: 'Baby Kids & Toys'
}, {
    value: 'Bags',
    label: 'Bags'
}, {
    value: 'Sports',
    label: 'Sports'
}, {
    value: 'Music',
    label: 'Music'
}, {
    value: 'Books',
    label: 'Books'
}]);

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_FirebaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_easy_print__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firestore_size__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firestore_size___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_firestore_size__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PriceTable_vue__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PrintLabels_vue__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TableHeader_vue__ = __webpack_require__(91);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var items = [];

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "allProducts",
  components: {
    PriceTable: __WEBPACK_IMPORTED_MODULE_6__PriceTable_vue__["a" /* default */],
    vueEasyPrint: __WEBPACK_IMPORTED_MODULE_3_vue_easy_print__["a" /* default */],
    PrintLabels: __WEBPACK_IMPORTED_MODULE_7__PrintLabels_vue__["a" /* default */],
    TableHeader: __WEBPACK_IMPORTED_MODULE_8__TableHeader_vue__["a" /* default */]
  },
  data: function data() {
    var checkprice = function checkprice(rule, value, callback) {
      if (!value) {
        return callback(new Error("Please input the price"));
      }
      setTimeout(function () {
        if (!__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default()(value)) {
          callback(new Error("Please input numbers"));
        } else {
          if (value < 0) {
            callback(new Error("price cannot be negetive"));
          } else {
            callback();
          }
        }
      }, 100);
    };

    var checkdis = function checkdis(rule, value, callback) {
      setTimeout(function () {
        if (!__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default()(value)) {
          callback(new Error("Please input numbers"));
        } else {
          if (value < 0 || value > 100) {
            callback(new Error("Discount should be 0 to 100"));
          } else {
            callback();
          }
        }
      }, 100);
    };
    return {
      emptyText: "Loading Records...",
      items: [],
      month: new Date(),
      printPrd: '',
      printItemPrice: '',
      printItemName: '',
      fields: ["index", { key: "name", label: "Name", sortable: true }, { key: "barcode", label: "Barcode", sortable: true }, { key: "totalQnty", label: "Total Qty", sortable: true }, { key: "altertQunty", label: "Low Alert Qty", sortable: true }, { key: "subcategory", label: "Sub Category", sortable: true }, { key: "brand", label: "Brand", sortable: true }, { key: "price", label: "Price (RS)", sortable: true }, { key: "rack", label: "Bin/Rack", sortable: true }, { key: "actions", label: "Actions" }],
      formdata: {
        name: "",
        price: "",
        dis: 0,
        disprice: 0,
        brand: "",
        color: "",
        desc: "",
        image: null,
        imageUrl1: "",
        imageUrl2: "",
        imageUrl3: "",
        owner: "",
        isLoggedIn: false,
        currentUser: false,
        prdstat: {}
      },
      rules: {
        name: [{
          required: true,
          message: "Please input Activity name",
          trigger: "blur"
        }, {
          min: 3,
          max: 25,
          message: "Length should be 3 to 25",
          trigger: "blur"
        }],
        price: [{ validator: checkprice, trigger: "blur" }],
        dis: [{ validator: checkdis, trigger: "blur" }],
        category: [{ message: "Please select category", trigger: "change" }],
        subcategory: [{ message: "Please select sub category", trigger: "change" }],
        brand: [{ message: "Please select brand", trigger: "change" }],
        color: [{ message: "Please select picture", trigger: "blur" }],
        desc: [{ message: "Please input description", trigger: "blur" }]
      },
      labelPosition: "top",
      imgfiles: [],
      otherimgs: [],
      maxFiles: 4,
      category: "",
      subcategory: "",
      shops: [],
      shopcat: "",

      loading: false,
      loading1: false,
      loading2: false,
      changed: true,

      productId: "",
      currentPage: 1,
      perPage: 25,
      totalRows: items.length,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      filter: null,
      isLoggedIn: false,
      currentUser: false,
      modalInfo: { title: "", content: "" }
    };
  },

  computed: {
    sortOptions: function sortOptions() {
      // Create an options list from our fields
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return { text: f.label, value: f.key };
      });
    }
  },
  watch: {
    // items(){
    //     return this.$store.state.items[this.$route.params.cat]
    // }
  },
  methods: {
    // refresh(){
    //     this.loading1 = true
    //     this.changed = false
    //    setTimeout( () => {
    //        this.items = this.$store.state.items[this.$route.params.cat]
    //     this.loading1 = false
    //     this.changed = true
    //      //console.log('this.items]', this.items)
    //     },3000)
    // },
    print: function print(item, row) {
      this.printPrd = item;
      this.printItemPrice = row.sellPr;
      this.printItemName = item.name + " " + (row.serial ? row.serial : '');
      // Pass the element id here
      setTimeout(function () {
        var mywindow = window.open("", "PRINT", "fullscreen=yes");

        mywindow.document.write("<html><head><title>" + document.title + "</title>");

        mywindow.document.write("</head><body >");
        mywindow.document.write(document.getElementById(item.id).innerHTML);
        mywindow.document.write("</body></html>");

        mywindow.document.close(); // necessary for IE >= 10
        mywindow.focus(); // necessary for IE >= 10*/

        mywindow.print();
        return true;
      }, 300);

      // if (!this.showPrintPopup) {
      //   mywindow.close();
      // }
    },
    info: function info(item, index, button) {
      this.modalInfo.title = "Row index: " + index;
      this.modalInfo.content = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item, null, 2);
      this.$root.$emit("bv::show::modal", "modalInfo", button);
    },
    resetModal: function resetModal() {
      this.modalInfo.title = "";
      this.modalInfo.content = "";
    },
    onFiltered: function onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getId: function getId(item) {
      //console.log('getId fun invoked')
      this.productId = item.id;
      //console.log(this.productId)
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    fileSelect1: function fileSelect1(event) {
      var _this = this;

      //console.log('event is', event)
      var files = event.target.files;
      var filename = files[0].name;
      var fileReader = new FileReader();
      fileReader.addEventListener("load", function () {
        _this.visible = "none";
        _this.formdata.imageUrl1 = fileReader.result;
        _this.visible1 = "block";
      });
      fileReader.readAsDataURL(files[0]);
      //this.image = files[0];
      var imageCompressor = new ImageCompressor();
      imageCompressor.compress(files[0], { quality: 0.6 }).then(function (result) {
        // Handle the compressed image file.
        if (result.size >= 1000000) {
          var _imageCompressor = new ImageCompressor();
          _imageCompressor.compress(result, { quality: 0.5 }).then(function (result) {
            _this.image1 = result;
            //console.log(filename)
            //console.log(result.size)
          });
        } else {
          _this.image1 = result;
          //console.log(filename)
          //console.log('else',result.size)
        }
      }).catch(function (err) {
        // Handle the error
        //console.log("error is" + err)
      });
    },
    otherIMG: function otherIMG(event) {
      var _this2 = this;

      var files = event.target.files;
      //console.log('files are', files)
      //console.log('imgfiles.length are', this.imgfiles.length)
      if (files.length > this.maxFiles || this.imgfiles.length >= this.maxFiles || files.length + this.imgfiles.length > this.maxFiles) {
        alert("You can only upload a maximum of " + this.maxFiles + " files");
        return 0;
      } else {
        for (var i = 0; i < files.length; i++) {
          if (files[i].size > 5000200) {
            alert("File " + files[i].name + "is too large!");
          } else {
            var reader = new FileReader();

            reader.addEventListener("load", function () {
              //   document.getElementsByClassName('image-upload-wrap').hide();
              _this2.visible = "none";
              // this.logoimg = reader.result
              _this2.visible2 = "inline";
            });
            reader.readAsDataURL(files[i]);
            //console.log('files[0]', files[i])
            var imageCompressor = new ImageCompressor();
            imageCompressor.compress(files[i], { quality: 0.6, width: 720, height: 1340 }).then(function (result) {
              // Handle the compressed image file.
              if (result.size >= 1000000) {
                var _imageCompressor2 = new ImageCompressor();
                _imageCompressor2.compress(result, { quality: 0.5 }).then(function (result) {
                  var fileReader = new FileReader();

                  // This fires after the blob has been read/loaded.
                  fileReader.addEventListener("load", function () {
                    _this2.imgfiles.push(fileReader.result);
                    var otherimg = fileReader.result;
                    _this2.otherimgs.push(otherimg);
                    //console.log('image is',this.otherimgs)
                  });

                  // Start reading the blob as text.
                  fileReader.readAsDataURL(result);

                  ////console.log(filename)
                  //console.log(result.size)
                  //console.log('image is',result)
                });
              } else {
                //  const reader = new FileReader();

                //     // This fires after the blob has been read/loaded.
                //     reader.addEventListener('loadend', (e) => {
                //       this.image2 = e.srcElement.result;
                //      //console.log('else image is',this.image2)
                //     });

                //     // Start reading the blob as text.
                //     reader.readAsText(result);
                var fileReader = new FileReader();
                fileReader.addEventListener("load", function () {
                  _this2.imgfiles.push(fileReader.result);
                  var otherimg = fileReader.result;
                  _this2.otherimgs.push(otherimg);
                  //console.log('else image is',this.otherimgs)
                });
                fileReader.readAsDataURL(result);
                ////console.log(filename)
                //console.log('else',result.size)
                //console.log('ekse image is',result)
              }
            }).catch(function (err) {
              // Handle the error
              //console.log("error is" + err)
            });
          }
        }
      }
    },

    backToTop: function backToTop() {
      $("html,body").stop().animate({
        scrollTop: 0
      }, "fast", "swing");
    },
    open: function open(id) {
      var _this3 = this;

      this.$confirm("This will permanently delete the item. Continue?", "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
        center: true
      }).then(function () {
        _this3.deleteItem(id);
      }).catch(function () {
        _this3.$message({
          type: "info",
          message: "Delete canceled"
        });
      });
    },
    savePriceDetails: function savePriceDetails(item) {
      var _this4 = this;

      this.$store.state.secondaryDatabase.collection("products").doc(item.id).update({
        priceList: item.priceList
      }).then(function () {
        _this4.$store.state.items[_this4.$route.params.cat].find(function (_ref) {
          var id = _ref.id;

          //console.log('filfkkk')
          return id === item.id;
        }).priceList = item.priceList;
        _this4.$notify({
          title: "Success",
          message: "Price data updated",
          type: "success"
        });
      }).catch(function (error) {
        return alert(error);
      });
    },
    deleteItem: function deleteItem(itm) {
      var _this5 = this;

      this.loading2 = true;
      this.changed = false;
      this.$store.state.secondaryDatabase.collection("products").doc(itm.id).delete().then(function () {
        //console.log('item deleted', itm.id)
        var newitems = _this5.items.filter(function (item) {
          //console.log('filfkkk')
          return item.id !== itm.id;
        });
        _this5.items = newitems;
        _this5.totalRows = _this5.items.length;
        _this5.$store.state.items[_this5.$route.params.cat] = newitems;
        if (_this5.items.length == 0) {
          //console.log('this.items.length is', this.items.length)
          _this5.emptyText = "There are no records to show";
        }
        // this.prdstat[firebase.auth().currentUser.uid] -= 1;
        // db.collection("aaa").doc("prdstat").update({
        //   prdno: this.prdstat,
        // });
        //console.log(this.items)
        _this5.shops[0].catValues[itm.category] -= 1;
        _this5.shops[0].categories[itm.category][itm.subcategory] -= 1;
        _this5.shops[0].curProducts -= 1;
        if (_this5.shops[0].curProducts < 5 && _this5.shops[0].shopcat == "Vehicles") {
          _this5.shops[0].cansearch = "no";
        } else if (_this5.shops[0].curProducts < 10 && _this5.shops[0].shopcat != "Vehicles") {
          _this5.shops[0].cansearch = "no";
        }
        _this5.$store.state.secondaryDatabase.collection("shops").doc(_this5.shops[0].id).update({
          categories: _this5.shops[0].categories,
          curProducts: _this5.shops[0].curProducts,
          search: _this5.shops[0].cansearch,
          catValues: _this5.shops[0].catValues
        }).then(function (doc) {
          _this5.loading2 = false;
          _this5.changed = true;
          //console.log('doc is', doc)
        }).catch(function (error) {
          return alert("shop error", error);
        });
        _this5.$store.state.prdNameList = _this5.$store.state.prdNameList.filter(function (p) {
          return p.barcode !== itm.barcode;
        });
        var prds = 'prds';
        if (_this5.$store.state.noDB === true) {
          prds = "prds" + __WEBPACK_IMPORTED_MODULE_4_firebase_app__["a" /* default */].auth().currentUser.uid;
        }
        _this5.$store.state.secondaryDatabase.collection("prdlist").doc(prds).set({ data: _this5.$store.state.prdNameList }).then(function (doc) {}).catch(function (error) {
          alert(error);
        });
      }).catch(function (error) {
        return alert("prd error", error);
      });
    }
  },
  mounted: function mounted() {},
  created: function created() {
    var _this6 = this;

    this.backToTop();
    this.loading1 = true;
    this.changed = false;
    if (__WEBPACK_IMPORTED_MODULE_4_firebase_app__["a" /* default */].auth().currentUser) {
      this.isLoggedIn = true;
      this.currentUser = __WEBPACK_IMPORTED_MODULE_4_firebase_app__["a" /* default */].auth().currentUser.email;
    }
    this.$store.state.secondaryDatabase.collection("shops").where("owner", "==", __WEBPACK_IMPORTED_MODULE_4_firebase_app__["a" /* default */].auth().currentUser.uid).get().then(function (querySnapshot) {
      querySnapshot.forEach(function (doc) {
        var data = {
          id: doc.id,
          categories: doc.data().categories,
          shoptype: doc.data().shoptype,
          shopcat: doc.data().cat,
          curProducts: doc.data().curProducts,
          catValues: doc.data().catValues,
          cansearch: doc.data().search
        };
        _this6.shops.push(data);
        if (_this6.shops[0].shopcat == "Vehicles") {
          _this6.shopcat = _this6.shops[0].shopcat;
        }
        _this6.category = _this6.$route.params.cat;
        _this6.subcategories = _this6.shops[0].categories[_this6.$route.params.cat];
        //console.log('this.subcategories is', this.subcategories)
      });
    });
    if (this.$store.state.items[this.$route.params.cat] != undefined) {
      this.items = this.$store.state.items[this.$route.params.cat];
      this.totalRows = this.items.length;
      this.loading1 = false;
      this.changed = true;
      //console.log(' from STATE this.$store.state.items[this.$route.params.cat]', this.$store.state.items[this.$route.params.cat])
    } else if (this.$store.state.items[this.$route.params.cat] == undefined) {
      //   var loadedItems = []
      //    //console.log(' before getter this.items]', this.items)
      //  loadedItems = this.$store.getters.getItems(this.$route.params.cat)
      //   setTimeout( () => {
      //      this.items = this.$store.state.items[this.$route.params.cat]
      //   this.loading1 = false
      //   this.changed = true
      //   //console.log(' from getter this.$store.getters.getItems(this.$route.params.cat)', this.$store.getters.getItems(this.$route.params.cat))
      //   //console.log(' from getter loadedItems]', loadedItems)
      //    //console.log(' from getter this.items]', this.items)
      //   },4000)

      this.$store.state.secondaryDatabase.collection("products").where("owner", "==", __WEBPACK_IMPORTED_MODULE_4_firebase_app__["a" /* default */].auth().currentUser.uid).where("cat", "==", this.$route.params.cat).get().then(function (querySnapshot) {
        var newitems = [];
        querySnapshot.forEach(function (doc) {
          // //console.log('this.items.length is', state.items.length)
          var data = {
            id: doc.id,
            name: doc.data().name,
            barcode: doc.data().barcode,
            altertQunty: doc.data().altertQunty,
            category: doc.data().cat,
            brand: doc.data().brand,
            price: doc.data().disprice,
            subcategory: doc.data().subcat,
            desc: doc.data().desc,
            profitMargin: doc.data().profitMargin,
            priceList: doc.data().priceList,
            totalQnty: 0,
            rack: doc.data().rack || '',
            _showDetails: false // toggle row details
            // 'img': doc.data().img,
            // 'otherimgs': doc.data().otherimgs,
          };
          data.priceList.forEach(function (item) {
            return data.totalQnty += item.quantity;
          });
          var bytes = __WEBPACK_IMPORTED_MODULE_5_firestore_size___default()(doc.data());
          console.log("size of doc", bytes, doc.data().name);
          newitems.push(data);

          _this6.items = newitems.sort(function (a, b) {
            return a.name > b.name ? 1 : b.name > a.name ? -1 : 0;
          });
          _this6.totalRows = _this6.items.length;
          _this6.$store.state.items[_this6.$route.params.cat] = newitems.sort(function (a, b) {
            return a.name > b.name ? 1 : b.name > a.name ? -1 : 0;
          });
          //console.log('state.items[cat]',this.$store.state.items[this.$route.params.cat])
        });
        if (_this6.items.length == 0) {
          _this6.emptyText = "There are no records to show";
        }
        _this6.loading1 = false;
        _this6.changed = true;
        //console.log('newitems', newitems)
        //console.log('state.items',this.$store.state.items)
      });
    }
    // db.collection("aaa")
    //   .doc("prdstat")
    //   .get()
    //   .then((doc) => {
    //     this.prdstat = doc.data().prdno;
    //   });
    // //console.log('this.items.length is', this.items.length)
    // if(this.items.length == 0){
    //     this.emptyText = 'There are no records to show'
    // }
  }
});

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "vue-easy-print",
    components: {},
    props: {
        // 针对分页表格模式：末尾空白行插入
        spaceRow: {
            type: Boolean,
            default: false
        },

        // 针对分页表格模式：传入的打印数据。
        tableData: {
            type: Object,
            default: function _default() {
                return undefined;
            }
        },
        // 是否显示表格
        tableShow: {
            type: Boolean,
            default: false
        },
        // 是否显示默认的打印按钮
        buttonShow: {
            type: Boolean,
            default: false
        },
        buttonClass: {
            type: String,
            default: "el-button el-button--default"
        },
        // 每页多少行
        onePageRow: {
            type: Number,
            default: 5
        },

        beforeCopy: Function,
        beforePrint: Function
    },
    data: function data() {
        return {};
    },
    mounted: function mounted() {
        this.init();
    },

    methods: {
        init: function init() {
            var _this = this;

            var printI = document.getElementById("easyPrintIframe");
            if (!printI) {
                printI = document.createElement("iframe");
                printI.id = "easyPrintIframe";
                printI.style.position = 'fixed';
                printI.style.width = '0';
                printI.style.height = '0';
                printI.style.top = '-100px';

                // 兼容ie
                if (window.location.hostname !== document.domain && navigator.userAgent.match(/msie/i)) {

                    printI.src = 'javascript:document.write("<head><script>document.domain=\\"' + document.domain + '\\";</s' + 'cript></head><body></body>")';
                }
                printI.onload = function () {
                    _this.getStyle();
                };

                document.body.appendChild(printI);
            } else {
                this.getStyle();
            }
        },
        print: function print() {
            if (typeof this.beforeCopy === "function") {
                // 检测到有复制前需要执行的功能
                this.beforeCopy();
            }

            var $iframe = document.getElementById("easyPrintIframe");
            // 复制body，打印内容
            $iframe.contentDocument.body.innerHTML = this.$refs.template.innerHTML;

            if (typeof this.beforePrint === "function") {
                // 检测到有打印前需要执行的功能
                // 比如有些二维码组件无法直接复制dom完成。
                this.beforePrint();
            }

            // 执行打印
            this.$nextTick(function () {
                setTimeout(function () {
                    $iframe.contentWindow.print();
                }, 100);
            });
        },
        getStyle: function getStyle() {
            var printI = document.getElementById("easyPrintIframe");
            var str = "",
                styles1 = document.querySelectorAll("style");
            for (var i = 0; i < styles1.length; i++) {
                str += styles1[i].outerHTML;
            }

            printI.contentDocument.head.innerHTML = str;
            // 添加link引入
            var styles = document.querySelectorAll("link");
            for (var _i = 0; _i < styles.length; _i++) {
                // chrome 正常，firefox不正常，能执行到，但是添加没结果
                var link = document.createElement("link");
                link.setAttribute("rel", "stylesheet");
                if (styles[_i].type) link.setAttribute("type", styles[_i].type);else link.setAttribute("type", 'text/css');
                link.setAttribute("href", styles[_i].href);
                link.setAttribute('media', 'all');
                printI.contentDocument.head.appendChild(link);
            }
        },
        getChineseNumber: function getChineseNumber(currencyDigits) {
            // 转换数字到中文大写，请用prop传递给模版组件，这个函数在网上扣的。
            var MAXIMUM_NUMBER = 99999999999.99;
            // Predefine the radix characters and currency symbols for output:
            var CN_ZERO = "零";
            var CN_ONE = "壹";
            var CN_TWO = "贰";
            var CN_THREE = "叁";
            var CN_FOUR = "肆";
            var CN_FIVE = "伍";
            var CN_SIX = "陆";
            var CN_SEVEN = "柒";
            var CN_EIGHT = "捌";
            var CN_NINE = "玖";
            var CN_TEN = "拾";
            var CN_HUNDRED = "佰";
            var CN_THOUSAND = "仟";
            var CN_TEN_THOUSAND = "万";
            var CN_HUNDRED_MILLION = "亿";
            var CN_SYMBOL = ""; // 可以设置前缀 比如 人民币
            var CN_DOLLAR = "元";
            var CN_TEN_CENT = "角";
            var CN_CENT = "分";
            var CN_INTEGER = "整";

            // Variables:
            var integral; // Represent integral part of digit number.
            var decimal; // Represent decimal part of digit number.
            var outputCharacters; // The output result.
            var parts;
            var digits, radices, bigRadices, decimals;
            var zeroCount;
            var i, p, d;
            var quotient, modulus;

            // Validate input string:
            if (currencyDigits === undefined) {
                return "";
            }
            currencyDigits = currencyDigits.toString();
            if (currencyDigits == "") {
                // alert("Empty input!");
                return "";
            }
            if (currencyDigits.match(/[^,.\d]/) != null) {
                // alert("Invalid characters in the input string!");
                return "";
            }
            if (currencyDigits.match(/^((\d{1,3}(,\d{3})*(.((\d{3},)*\d{1,3}))?)|(\d+(.\d+)?))$/) == null) {
                // alert("Illegal format of digit number!");
                return "";
            }

            // Normalize the format of input digits:
            currencyDigits = currencyDigits.replace(/,/g, ""); // Remove comma delimiters.
            currencyDigits = currencyDigits.replace(/^0+/, ""); // Trim zeros at the beginning.
            // Assert the number is not greater than the maximum number.
            if (Number(currencyDigits) > MAXIMUM_NUMBER) {
                alert("您输入的金额太大，请重新输入!");
                return "";
            }

            // Process the coversion from currency digits to characters:
            // Separate integral and decimal parts before processing coversion:
            parts = currencyDigits.split(".");
            if (parts.length > 1) {
                integral = parts[0];
                decimal = parts[1];
                // Cut down redundant decimal digits that are after the second.
                decimal = decimal.substr(0, 2);
            } else {
                integral = parts[0];
                decimal = "";
            }
            // Prepare the characters corresponding to the digits:
            digits = new Array(CN_ZERO, CN_ONE, CN_TWO, CN_THREE, CN_FOUR, CN_FIVE, CN_SIX, CN_SEVEN, CN_EIGHT, CN_NINE);
            radices = new Array("", CN_TEN, CN_HUNDRED, CN_THOUSAND);
            bigRadices = new Array("", CN_TEN_THOUSAND, CN_HUNDRED_MILLION);
            decimals = new Array(CN_TEN_CENT, CN_CENT);
            // Start processing:
            outputCharacters = "";
            // Process integral part if it is larger than 0:
            if (Number(integral) > 0) {
                zeroCount = 0;
                for (i = 0; i < integral.length; i++) {
                    p = integral.length - i - 1;
                    d = integral.substr(i, 1);
                    quotient = p / 4;
                    modulus = p % 4;
                    if (d == "0") {
                        zeroCount++;
                    } else {
                        if (zeroCount > 0) {
                            outputCharacters += digits[0];
                        }
                        zeroCount = 0;
                        outputCharacters += digits[Number(d)] + radices[modulus];
                    }
                    if (modulus == 0 && zeroCount < 4) {
                        outputCharacters += bigRadices[quotient];
                    }
                }
                outputCharacters += CN_DOLLAR;
            }
            // Process decimal part if there is:
            if (decimal != "") {
                for (i = 0; i < decimal.length; i++) {
                    d = decimal.substr(i, 1);
                    if (d != "0") {
                        outputCharacters += digits[Number(d)] + decimals[i];
                    }
                }
            }
            // Confirm and return the final output string:
            if (outputCharacters == "") {
                outputCharacters = CN_ZERO + CN_DOLLAR;
            }
            if (decimal == "") {
                outputCharacters += CN_INTEGER;
            }
            outputCharacters = CN_SYMBOL + outputCharacters;
            return outputCharacters;
        }
    }
});

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "priceTable",
  props: ["priceData", "showPriceTable", "printMethod", "product", 'profitMargin'],
  data: function data() {
    return {
      currentRow: null,
      store: 'all', //this.$store.state.selectedStore,
      tableData: [],
      stores: [{ id: "all", value: "all", label: "All Stores" }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.$store.state.stores))
    };
  },
  created: function created() {
    this.tableData = this.priceData;
    console.log("profitMargin", this.profitMargin);
  },


  methods: {
    print: function print(product, item) {
      this.printMethod(product, item);
    },
    updatePriceData: function updatePriceData(store) {
      // this.tableData = this.priceData;
      // this.tableData = this.tableData.filter((data) => data.store === store);
      console.log(this.priceData, this.tableData);
    },
    setRowSellPr: function setRowSellPr(scope) {
      scope.row.sellPr = this.profitMargin && scope.row.purcPr ? scope.row.purcPr + scope.row.purcPr * this.profitMargin / 100 : scope.row.sellPr;
    },
    addRow: function addRow() {
      this.priceData.push({
        purcPr: 0,
        sellPr: 0,
        quantity: 0,
        serial: '',
        store: this.store
      });
      console.log(this.priceData, this.tableData);
    },
    handleDelete: function handleDelete(index, row) {
      var foundIndex = this.priceData.findIndex(function (pr) {
        return pr.store === row.store && pr.sellPr === row.sellPr && pr.purcPr === row.purcPr && pr.serial === row.serial && pr.quantity === row.quantity;
      });
      this.priceData.splice(foundIndex, 1);
      console.log(this.priceData, this.tableData);
    },
    open: function open(index, row) {
      var _this = this;

      this.$confirm("This will permanently delete the item. Continue?", "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
        center: true
      }).then(function () {
        _this.handleDelete(index, row);
      }).catch(function () {
        _this.$message({
          type: "info",
          message: "Delete canceled"
        });
      });
    }
  }
});

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrintLabels_vue__ = __webpack_require__(206);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_102be4a9_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrintLabels_vue__ = __webpack_require__(644);
function injectStyle (ssrContext) {
  __webpack_require__(608)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-102be4a9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrintLabels_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_102be4a9_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrintLabels_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_barcode__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_barcode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_barcode__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "printlabels",
  components: {
    barcode: __WEBPACK_IMPORTED_MODULE_0_vue_barcode___default.a
  },
  props: ["showPrint", "barcode", "price", "name"],
  data: function data() {
    return {};
  },
  created: function created() {},

  methods: {}
});

/***/ }),
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SavePDF_vue__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_export_from_json__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_read_excel_file__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firebase_app__ = __webpack_require__(2);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var fileName = 'download';
var exportType = 'csv';
/* harmony default export */ __webpack_exports__["a"] = ({
  components: { SavePDF: __WEBPACK_IMPORTED_MODULE_3__SavePDF_vue__["a" /* default */] },
  props: ["items", "perPage", "pageOptions", "visibleFields", "fields", "month", "downloadCSVMethod", "enableToggle", 'shops'],
  data: function data() {
    return {
      tableColumns: [],
      showToggleDetails: false,
      userDisplayName: __WEBPACK_IMPORTED_MODULE_6_firebase_app__["a" /* default */].auth().currentUser.displayName
    };
  },
  created: function created() {
    this.tableColumns = this.visibleFields;
    this.showToggleDetails = this.enableToggle;
  },


  computed: {
    // visibleFields() {

    // }
  },

  methods: {
    handleChange: function handleChange(file, fileList) {
      var _this = this;

      // this.fileList.push(file);
      console.log(file, fileList);
      var schema = {
        'name': {
          // JSON object property name.
          prop: 'name',
          type: String
        },
        'barcode/SKU': {
          prop: 'barcode',
          type: String,
          required: true
        },
        'serial No': {
          prop: 'serial',
          type: String
        },
        'store': {
          prop: 'store',
          type: String,
          required: true
        },
        'category': {
          prop: 'category',
          type: String,
          required: true
        },
        'sub category': {
          prop: 'subCategory',
          type: String,
          required: true
        },
        'cost': {
          prop: 'cost',
          type: Number,
          required: true
        },
        'selling price': {
          prop: 'price',
          type: Number,
          required: true
        },
        'quantity': {
          prop: 'quantity',
          type: Number,
          required: true
        },
        'low alert quantity': {
          prop: 'lowalertquantity',
          type: Number,
          required: true
        }
      };
      Object(__WEBPACK_IMPORTED_MODULE_5_read_excel_file__["a" /* default */])(file.raw).then(function (sheetNames) {
        console.log('sheetNames', sheetNames);
        Object(__WEBPACK_IMPORTED_MODULE_5_read_excel_file__["a" /* default */])(file.raw, { sheet: 1, schema: schema }).then(function (rows) {
          var groupedByNames = rows.rows.reduce(function (r, a) {
            r[a.name] = r[a.name] || {};
            if (!r[a.name].items) r[a.name].items = [];
            r[a.name].items.push(a);
            r[a.name].name = a.name;
            r[a.name].category = a.category;
            r[a.name].subCategory = a.subCategory;
            r[a.name].lowalertquantity = a.lowalertquantity;
            r[a.name].barcode = a.barcode;
            return r;
          }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(null));

          console.log('rows', rows, _this.shops, groupedByNames);
          // for (const key in groupedByNames) {
          //   const row = groupedByNames[key]
          //   console.log("row",row)
          // }

          var _loop = function _loop(key) {
            var row = groupedByNames[key];
            var priceList = _this.$store.state.stores.map(function (store) {
              // for now only working for single store
              return groupedByNames[key].items.map(function (rec) {
                return {
                  serial: rec.serial,
                  purcPr: rec.cost,
                  sellPr: rec.price,
                  quantity: rec.quantity,
                  store: store.id
                };
              });
            });
            console.log('row', row);
            _this.$store.state.secondaryDatabase.collection("products").add({
              name: row.name,
              cat: row.category,
              subcat: row.subCategory,
              loc: _this.shops[0].loc,
              sname: _this.shops[0].shopname,
              price: 0,
              dis: 0,
              disprice: 0,
              barcode: row.barcode,
              altertQunty: row.lowalertquantity,

              profitMargin: 0,
              priceList: priceList[0], // bcz it returns array inside array
              variations: [],
              colors: [],
              expireDate: '',
              brand: '',
              rack: '',
              color: '',
              cond: '',
              type: '',
              war: '',
              desc: '',
              img: "data:image/jpeg;base64,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",
              otherimgs: [],
              owner: __WEBPACK_IMPORTED_MODULE_6_firebase_app__["a" /* default */].auth().currentUser.uid,
              shopID: _this.shops[0].id,
              details: {
                model: '',
                karat: '',
                metal: '',
                author: '',
                publisher: '',
                size: '',
                screensize: '',
                material: ''
              }

            }).then(function (docRef) {
              console.log('this.$store.state.prdNameList', _this.$store.state.prdNameList);
              _this.$store.state.prdNameList.push({
                name: row.name,
                barcode: row.barcode
              });
              var prds = 'prds';
              if (_this.$store.state.noDB === true) {
                prds = 'prds' + __WEBPACK_IMPORTED_MODULE_6_firebase_app__["a" /* default */].auth().currentUser.uid;
              }
              _this.$store.state.secondaryDatabase.collection("prdlist").doc(prds).set({ data: _this.$store.state.prdNameList }).then(function (doc) {}).catch(function (error) {
                alert(error);
              });

              //console.log('# items are', this.shops[0].categories[this.category][this.formdata.subcategory])
              if (!_this.shops[0].categories[row.category]) {
                _this.shops[0].categories[row.category] = {};
              }
              if (!_this.shops[0].categories[row.category][row.subCategory]) {
                _this.shops[0].categories[row.category][row.subCategory] = 0;
              }
              if (!_this.shops[0].catValues[row.category]) _this.shops[0].catValues[row.category] = 0;
              _this.shops[0].catValues[row.category] += 1;
              _this.shops[0].categories[row.category][row.subCategory] += 1;
              _this.shops[0].curProducts += 1;

              console.log('# updated items are', { categories: _this.shops[0].categories,
                curProducts: _this.shops[0].curProducts,
                catValues: _this.shops[0].catValues });
              _this.$store.state.secondaryDatabase.collection("shops").doc(_this.shops[0].id).update({
                categories: _this.shops[0].categories,
                curProducts: _this.shops[0].curProducts,
                catValues: _this.shops[0].catValues
              }).then(function (doc) {}).catch(function (error) {
                return console.log(error);
              });
            }).catch(function (error) {
              return console.log(error);
            });
            // `rows` is an array of rows
            // each row being an array of cells.
          };

          for (var key in groupedByNames) {
            _loop(key);
          }
        });
      });
    },
    toggleDetails: function toggleDetails() {
      this.items.forEach(function (item) {
        return item._showDetails = !item._showDetails;
      });
    },
    downloadPDF: function downloadPDF() {
      var _this2 = this;

      this.perPage = this.items.length;
      this.$root.$emit('savePDFClicked');
      setTimeout(function () {
        return _this2.perPage = _this2.pageOptions[2];
      }, 2000);
    },
    callCSVDownload: function callCSVDownload(downloadCSVMethod) {
      if (downloadCSVMethod === 'downloadCSV') this.downloadCSV();else if (downloadCSVMethod === 'downloadCSVCashFlow') this.downloadCSVCashFlow();else if (downloadCSVMethod === 'downloadCSVProducts') this.downloadCSVProducts();
    },
    downloadCSVCashFlow: function downloadCSVCashFlow() {
      var itemsToSave = [];
      this.items.forEach(function (item) {
        itemsToSave.push({
          start: item.start,
          end: item.end,
          open_Amount: item.open,
          close_Amount: item.close,
          sales: item.sales,
          addition: item.add,
          deduction: item.deduct,
          inRegister: item.inRegi,
          difference: item.diff,
          description: item.desc,
          updated: item.updated,
          createdBy: item.createdBy,
          updatedBy: item.updatedBy
        });
      });

      //console.log("dowld",this.items,data, products)
      var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(itemsToSave));
      var date = new Date(this.month);
      var monthName = date.toLocaleString('default', { month: 'long' });
      var fileName = 'cash-flows-' + date.getFullYear() + '-' + monthName;
      Object(__WEBPACK_IMPORTED_MODULE_4_export_from_json__["a" /* default */])({ data: data, fileName: fileName, exportType: exportType });
    },
    downloadCSVProducts: function downloadCSVProducts() {
      var _this3 = this;

      var productsToSaveAsCSV = [];
      this.items.forEach(function (item) {
        // item.priceList.forEach(p => {
        //   p.invoiceNo = item.invoiceNo;
        //   p.date = item.date;
        // })
        var products = [];
        products.push.apply(products, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(item.priceList));
        products.forEach(function (prd) {
          if (prd.quantity !== 0 && prd.sellPr !== 0) {
            // removing non related stores for products
            productsToSaveAsCSV.push({
              name: item.name,
              barcode: item.barcode,
              serialNo: prd.serial,
              store: _this3.$store.state.stores.find(function (store) {
                return store.id == prd.store;
              }).name,
              category: item.category,
              subcategory: item.subcategory,
              cost: prd.purcPr,
              price: prd.sellPr,
              quantity: prd.quantity
              // availableQnty: prd.availableQnty,
            });
          }
        });
      });

      productsToSaveAsCSV.sort(function (a, b) {
        return a.name.localeCompare(b.name);
      });

      var productsData = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(productsToSaveAsCSV));
      //console.log("dowld",this.items,data)
      var date = new Date(this.month);
      var monthName = date.toLocaleString('default', { month: 'long' });
      var fileName = 'products-' + productsToSaveAsCSV[0].category + '-' + date.getFullYear() + '-' + monthName;

      Object(__WEBPACK_IMPORTED_MODULE_4_export_from_json__["a" /* default */])({ data: productsData, fileName: fileName, exportType: exportType });
    },
    downloadCSV: function downloadCSV() {
      var products = [];
      var productsToSaveAsCSV = [];
      this.items.forEach(function (item) {
        item.products.forEach(function (p) {
          p.invoiceNo = item.invoiceNo;
          p.date = item.date;
        });
        products.push.apply(products, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(item.products));
        delete item.products;
        delete item.storeLocation;
        delete item.cashier;
      });
      products.forEach(function (prd) {
        productsToSaveAsCSV.push({
          name: prd.name,
          barcode: prd.barcode,
          serialNo: prd.serial,
          invoiceNo: prd.invoiceNo,
          date: prd.date,
          category: prd.category,
          subcategory: prd.subcategory,
          cost: prd.cost,
          price: prd.price,
          quantity: prd.quantity,
          subTotal: prd.subTotal,
          discount: prd.discount,
          profit: prd.profit
          // availableQnty: prd.availableQnty,
        });
      });
      productsToSaveAsCSV.sort(function (a, b) {
        return a.name.localeCompare(b.name);
      });
      //console.log("dowld",this.items,data, products)
      var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.items));
      var productsData = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(productsToSaveAsCSV));
      //console.log("dowld",this.items,data)
      var date = new Date(this.month);
      var monthName = date.toLocaleString('default', { month: 'long' });
      var fileName = 'invoices-' + date.getFullYear() + '-' + monthName;
      var productFileName = 'products-sold-' + date.getFullYear() + '-' + monthName;
      Object(__WEBPACK_IMPORTED_MODULE_4_export_from_json__["a" /* default */])({ data: data, fileName: fileName, exportType: exportType });
      Object(__WEBPACK_IMPORTED_MODULE_4_export_from_json__["a" /* default */])({ data: productsData, fileName: productFileName, exportType: exportType });
    }
  }
});

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SavePDF',
  props: ['fields', 'items', 'filter', 'sortBy', 'sortDesc', 'onFiltered'],
  mounted: function mounted() {
    var _this = this;

    this.$root.$on("savePDFClicked", function () {
      // this.fields = fields;
      // this.items = items;
      // this.filter = filter;
      // this.sortDesc = sortDesc
      // this.sortBy = sortBy;
      console.log("this.stores ", _this.items);
      if (_this.items) {
        setTimeout(function () {
          _this.PrintElem("realtable");
        }, 200);
      }
    });
  },

  methods: {
    PrintElem: function PrintElem(elem) {
      var mywindow = window.open("", "PRINT", "fullscreen=yes");

      mywindow.document.write("<html><head><title>" + document.title + "</title>");

      mywindow.document.write('<link rel="stylesheet" href="../../../../static/bootstrap-vue.css" type="text/css" />');
      // mywindow.document.write(
      //   `<link rel='stylesheet' href='../../../../static/bootstrap4.min.css' type="text/css" />`
      // );
      mywindow.document.write('<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@4.1.3/dist/css/bootstrap.min.css" integrity="sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO" crossorigin="anonymous">');
      mywindow.document.write("</head><body >");
      mywindow.document.write(document.getElementById(elem).innerHTML);
      mywindow.document.write("</body></html>");

      mywindow.document.close(); // necessary for IE >= 10
      mywindow.focus(); // necessary for IE >= 10*/

      mywindow.print();

      return true;
    }
  }
});

/***/ }),
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__commonProducts__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Mobiles__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Vehicles__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_FirebaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_app__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'categories',
  components: {
    commonProducts: __WEBPACK_IMPORTED_MODULE_0__commonProducts__["a" /* default */],
    Mobiles: __WEBPACK_IMPORTED_MODULE_1__Mobiles__["a" /* default */],
    Vehicles: __WEBPACK_IMPORTED_MODULE_2__Vehicles__["a" /* default */]
  },
  data: function data() {
    return {
      shops: [],
      shopcat: '',
      shoptype: '',
      common: false,
      mobiles: false,
      vehicles: false,
      loading: false,
      loading1: false,
      changed: true
    };
  },
  created: function created() {
    var _this = this;

    this.loading1 = true;
    this.changed = false;
    this.$store.state.secondaryDatabase.collection('shops').where('owner', '==', __WEBPACK_IMPORTED_MODULE_4_firebase_app__["a" /* default */].auth().currentUser.uid).get().then(function (querySnapshot) {
      querySnapshot.forEach(function (doc) {
        var data = {
          'id': doc.id,
          'categories': doc.data().categories,
          'shopcat': doc.data().cat,
          'shoptype': doc.data().shoptype,
          'curProducts': doc.data().curProducts

        };
        _this.shops.push(data);
        _this.shopcat = _this.shops[0].shopcat;
        _this.shoptype = _this.shops[0].shoptype;
        _this.loading1 = false;
        _this.changed = true;
        //console.log('shop', this.shops[0])
      });
      //  if(this.$route.params.cat == 'Mobiles' && this.shopcat == 'Mobiles & Tablets'){
      //     this.mobiles = true
      //      //console.log(this.mobiles)
      //   }else if(this.$route.params.cat == 'Tablets' && this.shopcat == 'Mobiles & Tablets'){
      //     this.mobiles = true
      //       //console.log(this.mobiles)
      //   }else if(this.$route.params.cat == 'Laptops' && this.shopcat == 'Computers'){
      //     this.mobiles = true
      //       //console.log(this.mobiles)
      //   }else if(this.$route.params.cat == 'Desktops' && this.shopcat == 'Computers'){
      //     this.mobiles = true
      //       //console.log(this.mobiles)
      //   }else if(this.shopcat == 'Vehicles'){
      //     this.vehicles = true
      //       //console.log(this.vehicles)
      //   }else{
      //     this.common = true
      //       //console.log('comon',this.common)
      //   }
    });
  }
});

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_image_compressor_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_FirebaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PriceTable_vue__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__VariationsTable_vue__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__data_mobiles__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__data_ClothingAccessories__ = __webpack_require__(27);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: "commonproducts",
  components: {
    PriceTable: __WEBPACK_IMPORTED_MODULE_5__PriceTable_vue__["a" /* default */],
    VariationsTable: __WEBPACK_IMPORTED_MODULE_6__VariationsTable_vue__["a" /* default */]
  },
  data: function data() {
    var checkprice = function checkprice(rule, value, callback) {
      // if (value == undefined || value == "") {
      //   return callback(new Error("Please input the price"));
      // }
      setTimeout(function () {
        // if (!Number.isInteger(value)) {
        //   callback(new Error("Please input numbers"));
        // } else {
        if (value < 0) {
          callback(new Error("Price cannot be negetive"));
        } else {
          callback();
        }
        //}
      }, 100);
    };

    var checkdis = function checkdis(rule, value, callback) {
      setTimeout(function () {
        if (!__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default()(value)) {
          callback(new Error("Please input numbers"));
        } else {
          if (value < 0 || value > 100) {
            callback(new Error("Discount should be 0 to 100"));
          } else {
            callback();
          }
        }
      }, 100);
    };
    var defaultImage = "data:image/jpeg;base64,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";
    return {
      categoriesList: [],
      subcategories: {},
      category: "",
      tags: [],
      shops: [],
      shopcat: "",
      shoptype: "",
      cansearch: "no",
      modalShow: false,
      modalShow2: false,
      options: [],
      visible: "block",
      visible1: "none",
      visible2: "none",
      visible3: "none",
      imgfiles: [],
      otherimgs: [],
      maxFiles: 4,
      labelPosition: "",
      loading: false,
      loading1: false,
      changed: true,
      showPriceTable: false,
      showVariationsTable: false,
      priceTableWidth: "50%",
      image1: defaultImage,

      formdata: {
        name: "",
        price: 0,
        barcode: "",
        quantity: 1,
        profitMargin: 0,
        priceList: [],
        priceData: this.$store.state.stores.map(function (store) {
          return {
            purcPr: 0,
            sellPr: 0,
            quantity: 0,
            serial: "",
            store: store.id
          };
        }),
        purchasedPriceList: [],
        variations: [],
        colors: [],
        expireDate: "",
        dis: 0,
        disprice: 0,
        subcategory: "",
        brand: "",
        model: "",
        karat: "",
        metal: "",
        author: "",
        publisher: "",
        size: "",
        screensize: "",
        material: "",
        color: "",
        cond: "",
        type: "",
        warranty: "",
        desc: "",
        image: null,
        imageUrl1: "",
        imageUrl2: "",
        imageUrl3: "",
        owner: "",
        isLoggedIn: false,
        currentUser: false,
        prdstat: {},
        rack: ''
      },

      rules: {
        name: [{ required: true, message: "Please input name", trigger: "blur" }, {
          min: 3,
          max: 100,
          message: "Length should be 3 to 100",
          trigger: "blur"
        }],
        barcode: [{ required: true, message: "Please input barcode", trigger: "blur" }],
        quantity: [{ required: true, message: "Please input quantity", trigger: "blur" }, {
          min: 1,
          type: "number",
          message: "Minimum quantity is 1",
          trigger: "blur"
        }],
        price: [{ validator: checkprice, trigger: "blur" }],
        dis: [{ validator: checkdis, trigger: "blur" }],
        // purchasedPriceList: [
        //   { message: "Please select purchased Price", trigger: "change" },
        // ],
        category: [{ message: "Please select category", trigger: "change" }],
        subcategory: [{
          required: true,
          message: "Please select sub category",
          trigger: "change"
        }],
        brand: [{ message: "Please select brand", trigger: "change" }],
        color: [{ message: "Please select picture", trigger: "blur" }],
        desc: [{ message: "Please input description", trigger: "blur" }]
      }
    };
  },


  watch: {
    // category () {
    //   this.subcategories = []
    //   this.formdata.subcategory = ""
    //   if (this.category.length > 0) {
    //           this.subcategories = this.categoriesList[this.category]
    //       }
    // },
    // shops () {
    //    if(this.shops[0].shoptype == 'Fashion'){
    //     this.categoriesList = ClothingAccessories
    // }
    // if(this.shops[0].shoptype == 'Elec'){
    //     this.categoriesList = mobiles
    // }
    // }
  },

  methods: {
    pickFile: function pickFile() {
      this.$refs.fileInput.click();
    },
    fileSelect1: function fileSelect1(event) {
      var _this = this;

      //console.log('event is', event)
      if (event.target.files.length > 0) {
        var files = event.target.files;
        var filename = files[0].name;
        //console.log('files[0].type', files[0].type)
        if (files[0].type == "image/png" || files[0].type == "image/gif" || files[0].type == "image/svg+xml" || files[0].type == "image/tiff") {
          alert("File " + files[0].name + " is not type of jpeg or jpg!. You cannot upload other types of images.");
        } else if (files[0].size > 5000200) {
          alert("File " + files[0].name + " is too large!");
        } else {
          var reader = new FileReader();
          reader.addEventListener("load", function () {
            _this.visible = "none";
            _this.formdata.imageUrl1 = reader.result;
            _this.visible1 = "block";
          });
          reader.readAsDataURL(files[0]);
          //this.image = files[0];
          var imageCompressor = new __WEBPACK_IMPORTED_MODULE_2_image_compressor_js__["a" /* default */]();
          imageCompressor.compress(files[0], { quality: 0.8, width: 720, height: 1340 }).then(function (result) {
            // Handle the compressed image file.
            if (result.size >= 1000000) {
              var _imageCompressor = new __WEBPACK_IMPORTED_MODULE_2_image_compressor_js__["a" /* default */]();
              _imageCompressor.compress(result, { quality: 0.5 }).then(function (result) {
                var fileReader = new FileReader();

                // This fires after the blob has been read/loaded.
                fileReader.addEventListener("load", function () {
                  _this.image1 = fileReader.result;

                  //console.log('image is',this.image1)
                });

                // Start reading the blob as text.
                fileReader.readAsDataURL(result);

                ////console.log(filename)
                //console.log(result.size)
                //console.log('image is',result)
              });
            } else {
              var fileReader = new FileReader();
              fileReader.addEventListener("load", function () {
                _this.image1 = fileReader.result;

                //console.log('else image is',this.image1)
              });
              fileReader.readAsDataURL(result);
              ////console.log(filename)
              //console.log('else',result.size)
              //console.log('ekse image is',result)
            }
          }).catch(function (err) {
            // Handle the error
            //console.log("error is" + err)
          });
        }
      }
    },
    otherIMG: function otherIMG(event) {
      var _this2 = this;

      var files = event.target.files;
      //console.log('files are', files)
      //console.log('imgfiles.length are', this.imgfiles.length)
      if (files.length > this.maxFiles || this.imgfiles.length >= this.maxFiles || files.length + this.imgfiles.length > this.maxFiles) {
        alert("You can only upload a maximum of " + this.maxFiles + " files");
        return 0;
      } else {
        for (var i = 0; i < files.length; i++) {
          if (files[0].type == "image/png" || files[0].type == "image/gif" || files[0].type == "image/svg+xml" || files[0].type == "image/tiff") {
            alert("File " + files[0].name + " is not type of jpeg or jpg!. You cannot upload other types of images.");
          } else if (files[i].size > 5000200) {
            alert("File " + files[i].name + " is too large!");
          } else {
            var reader = new FileReader();

            reader.addEventListener("load", function () {
              //   document.getElementsByClassName('image-upload-wrap').hide();
              _this2.visible = "none";
              // this.logoimg = reader.result
              _this2.visible2 = "inline";
            });
            reader.readAsDataURL(files[i]);
            //console.log('files[0]', files[i])
            var imageCompressor = new __WEBPACK_IMPORTED_MODULE_2_image_compressor_js__["a" /* default */]();
            imageCompressor.compress(files[i], { quality: 0.6, width: 720, height: 1340 }).then(function (result) {
              // Handle the compressed image file.
              if (result.size >= 1000000) {
                var _imageCompressor2 = new __WEBPACK_IMPORTED_MODULE_2_image_compressor_js__["a" /* default */]();
                _imageCompressor2.compress(result, { quality: 0.5 }).then(function (result) {
                  var fileReader = new FileReader();

                  // This fires after the blob has been read/loaded.
                  fileReader.addEventListener("load", function () {
                    _this2.imgfiles.push(fileReader.result);
                    var otherimg = fileReader.result;
                    _this2.otherimgs.push(otherimg);
                    //console.log('image is',this.otherimgs)
                  });

                  // Start reading the blob as text.
                  fileReader.readAsDataURL(result);

                  ////console.log(filename)
                  //console.log(result.size)
                  //console.log('image is',result)
                });
              } else {
                //  const reader = new FileReader();

                //     // This fires after the blob has been read/loaded.
                //     reader.addEventListener('loadend', (e) => {
                //       this.image2 = e.srcElement.result;
                //      //console.log('else image is',this.image2)
                //     });

                //     // Start reading the blob as text.
                //     reader.readAsText(result);
                var fileReader = new FileReader();
                fileReader.addEventListener("load", function () {
                  _this2.imgfiles.push(fileReader.result);
                  var otherimg = fileReader.result;
                  _this2.otherimgs.push(otherimg);
                  //console.log('else image is',this.otherimgs)
                });
                fileReader.readAsDataURL(result);
                ////console.log(filename)
                //console.log('else',result.size)
                //console.log('ekse image is',result)
              }
            }).catch(function (err) {
              // Handle the error
              //console.log("error is" + err)
            });
          }
        }
      }
    },
    removeimg: function removeimg(i) {
      if (i > -1) {
        this.otherimgs.splice(i, 1);
        this.imgfiles.splice(i, 1);
      }
      //console.log('img files is', this.imgfiles)
      //console.log('otherimg is', this.otherimgs)
    },
    checkBarcode: function checkBarcode() {
      var _this3 = this;

      if (this.formdata.barcode) {
        this.$store.state.secondaryDatabase.collection("products").where("owner", "==", __WEBPACK_IMPORTED_MODULE_4_firebase_app__["a" /* default */].auth().currentUser.uid).where("barcode", "==", this.formdata.barcode).limit(1).get().then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            var barcode = _this3.formdata.barcode;
            _this3.formdata.barcode = "";
            return _this3.$notify.error({
              title: "Error",
              message: "Barcode " + barcode + " is already used",
              type: "error"
            });
          });
        }).catch(function (error) {
          return alert(error.message);
        });
      }
    },
    submitForm: function submitForm(fdata) {
      var _this4 = this;

      if (this.shops[0].curProducts < this.shops[0].maxProducts) {
        this.$refs[fdata].validate(function (valid) {
          if (valid && _this4.image1 != undefined) {
            _this4.loading = true;
            _this4.changed = false;
            _this4.backToTop();
            if (_this4.formdata.dis != 0) {
              _this4.formdata.disprice = _this4.formdata.price;
              _this4.formdata.price = _this4.formdata.price - _this4.formdata.price * _this4.formdata.dis / 100;
            } else if (_this4.formdata.dis == 0) {
              _this4.formdata.disprice = _this4.formdata.price;
            }
            var docID;
            _this4.$store.state.secondaryDatabase.collection("products").add({
              name: _this4.formdata.name,
              cat: _this4.category,
              subcat: _this4.formdata.subcategory,
              loc: _this4.shops[0].loc,
              sname: _this4.shops[0].shopname,
              dis: _this4.formdata.dis,
              price: _this4.formdata.price,
              disprice: _this4.formdata.disprice,
              barcode: _this4.formdata.barcode,
              altertQunty: _this4.formdata.quantity,
              // priceList: this.formdata.priceList.map((price) => +price),
              // purchasedPriceList: this.formdata.purchasedPriceList.map(
              //   (price) => +price
              // ),
              profitMargin: _this4.formdata.profitMargin,
              priceList: _this4.formdata.priceData,
              variations: _this4.formdata.variations,
              colors: _this4.formdata.colors,
              expireDate: _this4.formdata.expireDate,
              brand: _this4.formdata.brand,
              rack: _this4.formdata.rack,
              color: _this4.formdata.color,
              cond: _this4.formdata.cond,
              type: _this4.formdata.type,
              war: _this4.formdata.warranty,
              desc: _this4.formdata.desc,
              img: _this4.image1,
              otherimgs: _this4.otherimgs,
              owner: __WEBPACK_IMPORTED_MODULE_4_firebase_app__["a" /* default */].auth().currentUser.uid,
              shopID: _this4.shops[0].id,
              details: {
                model: _this4.formdata.model,
                karat: _this4.formdata.karat,
                metal: _this4.formdata.metal,
                author: _this4.formdata.author,
                publisher: _this4.formdata.publisher,
                size: _this4.formdata.size,
                screensize: _this4.formdata.screensize,
                material: _this4.formdata.material
              }
            }).then(function (docRef) {
              docID = docRef.id;
              // if (!this.prdstat[firebase.auth().currentUser.uid]) {
              //   this.prdstat[firebase.auth().currentUser.uid] = 1;
              // } else if (this.prdstat[firebase.auth().currentUser.uid]) {
              //   this.prdstat[firebase.auth().currentUser.uid] += 1;
              // }
              // db.collection("aaa").doc("prdstat").update({
              //   prdno: this.prdstat,
              // });
              //console.log(docID)
              //console.log('docRef isss',docRef)
              var totalQnty = 0;
              _this4.formdata.priceData.forEach(function (item) {
                return totalQnty += item.quantity;
              });
              var prdData = {
                id: docRef.id,
                name: _this4.formdata.name,
                barcode: _this4.formdata.barcode,
                altertQunty: _this4.formdata.quantity,
                category: _this4.category,
                subcategory: _this4.formdata.subcategory,
                price: _this4.formdata.price,
                brand: _this4.formdata.brand,
                priceList: _this4.formdata.priceData,
                profitMargin: _this4.formdata.profitMargin,
                rack: _this4.formdata.rack,
                totalQnty: totalQnty
                //make sure to use same property name used in store.js getItems fun
              };

              if (_this4.$store.state.items[_this4.$route.params.cat]) {
                // this.$store.state.items[this.$route.params.cat] = [];

                _this4.$store.state.items[_this4.$route.params.cat].push(prdData);
                //console.log('store obj created',  this.$store.state.items[this.$route.params.cat])
              }

              if (_this4.$store.state.allProducts != undefined && _this4.$store.state.allProducts.length !== 0) {

                _this4.$store.state.allProducts.unshift(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, prdData, {
                  img: _this4.image1,
                  _showDetails: false // toggle row details
                  //make sure to use same property name used in store.js getItems fun
                }));
              }

              _this4.$store.state.prdNameList.push({
                name: _this4.formdata.name,
                barcode: _this4.formdata.barcode
              });
              var prds = 'prds';
              if (_this4.$store.state.noDB === true) {
                prds = "prds" + __WEBPACK_IMPORTED_MODULE_4_firebase_app__["a" /* default */].auth().currentUser.uid;
              }
              _this4.$store.state.secondaryDatabase.collection("prdlist").doc(prds).set({ data: _this4.$store.state.prdNameList }).then(function (doc) {}).catch(function (error) {
                alert(error);
              });

              //console.log('# items are', this.shops[0].categories[this.category][this.formdata.subcategory])
              _this4.shops[0].catValues[_this4.category] += 1;
              _this4.shops[0].categories[_this4.category][_this4.formdata.subcategory] += 1;
              _this4.shops[0].curProducts += 1;
              if (_this4.shops[0].curProducts >= 5 && _this4.shops[0].shopcat == "Vehicles") {
                _this4.cansearch = "yes";
              } else if (_this4.shops[0].curProducts >= 10 && _this4.shops[0].shopcat != "Vehicles") {
                _this4.cansearch = "yes";
              }
              //console.log('# updated items are', this.shops[0].categories[this.category][this.formdata.subcategory])
              _this4.$store.state.secondaryDatabase.collection("shops").doc(_this4.shops[0].id).update({
                categories: _this4.shops[0].categories,
                curProducts: _this4.shops[0].curProducts,
                search: _this4.cansearch,
                catValues: _this4.shops[0].catValues
              }).then(function (doc) {
                _this4.formdata = {
                  name: "",
                  price: 0,
                  dis: 0,
                  disprice: 0,
                  barcode: "",
                  quantity: 1,
                  priceList: [],
                  profitMargin: 0,
                  priceData: _this4.$store.state.stores.map(function (store) {
                    return {
                      purcPr: 0,
                      sellPr: 0,
                      quantity: 0,
                      store: store.id
                    };
                  }),
                  purchasedPriceList: [],
                  variations: [],
                  colors: [],
                  expireDate: "",
                  subcategory: "",
                  brand: "",
                  model: "",
                  karat: "",
                  metal: "",
                  author: "",
                  publisher: "",
                  size: "",
                  screensize: "",
                  material: "",
                  color: "",
                  cond: "",
                  type: "",
                  warranty: "",
                  desc: "",
                  image: null,
                  imageUrl1: "",
                  imageUrl2: "",
                  imageUrl3: "",
                  owner: "",
                  isLoggedIn: false,
                  currentUser: false,
                  rack: ""
                };
                _this4.imgfiles = [];
                _this4.otherimgs = [];
                _this4.image1 = "data:image/jpeg;base64,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";
                _this4.loading = false;
                _this4.changed = true;
                _this4.modalShow2 = true;
                //console.log('doc is', doc)
              });
              return docID;
            }).catch(function (error) {
              return alert(error);
            });
          } else {
            if (_this4.image1 == undefined) {
              alert("Add a main image!!!");
              _this4.backToTop();
            }
            alert("error occured");
            _this4.backToTop();
            return false;
          }
        });
      } else {
        this.modalShow = true;
      }
    },
    resetForm: function resetForm(formName) {
      //console.log(formName)
      this.$refs[formName].resetFields();
      this.formdata.imageUrl1 = "";
      this.imgfiles = [];
      this.otherimgs = [];
    },


    //    initToTopButton: function() {
    //   $(document).bind('scroll', function() {
    //     var backToTopButton = $('.goTop');
    //     if ($(document).scrollTop() > 250) {
    //       backToTopButton.addClass('isVisible');
    //       this.isVisible = true;
    //     } else {
    //       backToTopButton.removeClass('isVisible');
    //       this.isVisible = false;
    //     }
    //   }.bind(this));
    // },
    backToTop: function backToTop() {
      $("html,body").stop().animate({
        scrollTop: 0
      }, "slow", "swing");
    }
  },

  created: function created() {
    var _this5 = this;

    //  this.$nextTick(function() {
    //      this.initToTopButton();
    //   })
    this.backToTop();
    if (screen.width > 575) {
      this.labelPosition = "left";
    } else {
      this.labelPosition = "top";
      this.priceTableWidth = "80%";
    }
    if (__WEBPACK_IMPORTED_MODULE_4_firebase_app__["a" /* default */].auth().currentUser) {
      this.isLoggedIn = true;
      this.currentUser = __WEBPACK_IMPORTED_MODULE_4_firebase_app__["a" /* default */].auth().currentUser.email;

      //console.log(firebase.auth().currentUser.uid)
    }

    this.$store.state.secondaryDatabase.collection("shops").where("owner", "==", __WEBPACK_IMPORTED_MODULE_4_firebase_app__["a" /* default */].auth().currentUser.uid).get().then(function (querySnapshot) {
      querySnapshot.forEach(function (doc) {
        var data = {
          id: doc.id,
          categories: doc.data().categories,
          shopcat: doc.data().cat,
          shoptype: doc.data().shoptype,
          curProducts: doc.data().curProducts,
          maxProducts: doc.data().maxProducts,
          loc: doc.data().location,
          shopname: doc.data().name,
          catValues: doc.data().catValues,
          cansearch: doc.data().search
        };
        _this5.shops.push(data);
        _this5.shopcat = _this5.shops[0].shopcat;
        _this5.shoptype = _this5.shops[0].shoptype;
        _this5.category = _this5.$route.params.cat;
        _this5.subcategories = _this5.shops[0].categories[_this5.$route.params.cat];
        _this5.cansearch = _this5.shops[0].cansearch;

        //console.log('this.subcategories is', this.subcategories)
      });
    });
    // db.collection("aaa")
    //   .doc("prdstat")
    //   .get()
    //   .then((doc) => {
    //     this.prdstat = doc.data().prdno;
    //   });
  },
  mounted: function mounted() {}
});

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "VariationsTable",
  props: ["variationsData", "showVariationsTable"],
  data: function data() {
    return {
      currentRow: null,
      store: this.$store.state.selectedStore,
      tableData: [],
      stores: [{ id: "all", value: "all", label: "All Stores" }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.$store.state.stores))
    };
  },
  created: function created() {
    this.tableData = this.variationsData;
  },


  methods: {
    updatePriceData: function updatePriceData(store) {
      // this.tableData = this.variationsData;
      // this.tableData = this.tableData.filter((data) => data.store === store);
      console.log(this.variationsData, this.tableData);
    },
    addRow: function addRow() {
      this.variationsData.push({
        serial: '',
        quantity: 0,
        store: this.store
      });
      console.log(this.variationsData, this.tableData);
    },
    handleDelete: function handleDelete(index, row) {
      var foundIndex = this.variationsData.findIndex(function (pr) {
        return pr.store === row.store && pr.serial === row.serial && pr.quantity === row.quantity;
      });
      this.variationsData.splice(foundIndex, 1);
      console.log(this.variationsData, this.tableData);
    },
    open: function open(index, row) {
      var _this = this;

      this.$confirm("This will permanently delete the item. Continue?", "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
        center: true
      }).then(function () {
        _this.handleDelete(index, row);
      }).catch(function () {
        _this.$message({
          type: "info",
          message: "Delete canceled"
        });
      });
    }
  }
});

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Mobiles_vue__ = __webpack_require__(226);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_643cfe24_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Mobiles_vue__ = __webpack_require__(695);
function injectStyle (ssrContext) {
  __webpack_require__(694)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-643cfe24"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Mobiles_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_643cfe24_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Mobiles_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_image_compressor_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_FirebaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_mobiles__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_ClothingAccessories__ = __webpack_require__(27);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "mobiles",
  data: function data() {
    var checkprice = function checkprice(rule, value, callback) {
      if (!value) {
        return callback(new Error("Please input the price"));
      }
      setTimeout(function () {
        if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(value)) {
          callback(new Error("Please input numbers"));
        } else {
          if (value < 0) {
            callback(new Error("Price cannot be negetive"));
          } else {
            callback();
          }
        }
      }, 100);
    };

    var checkdis = function checkdis(rule, value, callback) {
      setTimeout(function () {
        if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(value)) {
          callback(new Error("Please input numbers"));
        } else {
          if (value < 0 || value > 100) {
            callback(new Error("Discount should be 0 to 100"));
          } else {
            callback();
          }
        }
      }, 100);
    };
    return {
      categoriesList: [],
      subcategories: {},
      category: "",
      shoptype: "",
      shopcat: "",
      tags: [],
      shops: [],
      cansearch: "no",
      modalShow: false,
      modalShow2: false,
      options: [{
        value: "Option1",
        label: "Option1"
      }, {
        value: "Option2",
        label: "Option2"
      }, {
        value: "Option3",
        label: "Option3"
      }, {
        value: "Option4",
        label: "Option4"
      }, {
        value: "Option5",
        label: "Option5"
      }],
      visible: "block",
      visible1: "none",
      visible2: "none",
      visible3: "none",
      imgfiles: [],
      otherimgs: [],
      maxFiles: 4,
      labelPosition: "top",
      loading: false,
      loading1: false,
      changed: true,

      formdata: {
        name: "",
        price: "",
        barcode: "",
        quantity: 0,
        priceList: [],
        variations: [],
        colors: [],
        expireDate: "",
        dis: 0,
        disprice: 0,
        subcategory: "",
        brand: "",
        color: "",
        cond: "",
        type: "",
        warranty: "",
        desc: "",
        image: null,
        imageUrl1: "",
        imageUrl2: "",
        imageUrl3: "",
        owner: "",
        isLoggedIn: false,
        currentUser: false,
        prdstat: {},

        model: "",
        cpu: "",
        cpugen: "",
        hard: "",
        storage: "",
        ram: "",
        graphics: "",
        screen: "",
        rearcamera: "",
        frontcamera: "",
        os: "",
        battery: "",
        weight: ""
      },

      rules: {
        name: [{ required: true, message: "Please input name", trigger: "blur" }, {
          min: 3,
          max: 100,
          message: "Length should be 3 to 100",
          trigger: "blur"
        }],
        barcode: [{ required: true, message: "Please input barcode", trigger: "blur" }],
        quantity: [{ required: true, message: "Please input quantity", trigger: "blur" }, {
          min: 1,
          type: "number",
          message: "Minimum quantity is 0",
          trigger: "blur"
        }],
        price: [{ validator: checkprice, trigger: "blur" }],
        dis: [{ validator: checkdis, trigger: "blur" }],
        category: [{ message: "Please select category", trigger: "change" }],
        subcategory: [{
          required: true,
          message: "Please select the brand",
          trigger: "change"
        }],
        model: [{ required: true, message: "Please input model", trigger: "blur" }],
        cond: [{
          required: true,
          message: "Please select condition",
          trigger: "change"
        }],
        desc: [{ message: "Please input description", trigger: "blur" }]
      }
    };
  },


  watch: {
    // category () {
    //   this.subcategories = []
    //   this.formdata.subcategory = ""
    //   if (this.category.length > 0) {
    //           this.subcategories = this.categoriesList[this.category]
    //       }
    // },
    // shops () {
    //    if(this.shops[0].shoptype == 'Fashion'){
    //     this.categoriesList = ClothingAccessories
    // }
    // if(this.shops[0].shoptype == 'Elec'){
    //     this.categoriesList = mobiles
    // }
    // }
  },

  methods: {
    pickFile: function pickFile() {
      this.$refs.fileInput.click();
    },
    fileSelect1: function fileSelect1(event) {
      var _this = this;

      //console.log('event is', event)
      if (event.target.files.length > 0) {
        var files = event.target.files;
        var filename = files[0].name;
        if (files[0].type == "image/png" || files[0].type == "image/gif" || files[0].type == "image/svg+xml" || files[0].type == "image/tiff") {
          alert("File " + files[0].name + " is not type of jpeg or jpg!. You cannot upload other types of images.");
        } else if (files[0].size > 5000200) {
          alert("File " + files[0].name + " is too large!");
        } else {
          var reader = new FileReader();
          reader.addEventListener("load", function () {
            _this.visible = "none";
            _this.formdata.imageUrl1 = reader.result;
            _this.visible1 = "block";
          });
          reader.readAsDataURL(files[0]);
          //this.image = files[0];
          var imageCompressor = new __WEBPACK_IMPORTED_MODULE_1_image_compressor_js__["a" /* default */]();
          imageCompressor.compress(files[0], { quality: 0.8, width: 720, height: 1340 }).then(function (result) {
            // Handle the compressed image file.
            if (result.size >= 1000000) {
              var _imageCompressor = new __WEBPACK_IMPORTED_MODULE_1_image_compressor_js__["a" /* default */]();
              _imageCompressor.compress(result, { quality: 0.6 }).then(function (result) {
                var fileReader = new FileReader();

                // This fires after the blob has been read/loaded.
                fileReader.addEventListener("load", function () {
                  _this.image1 = fileReader.result;

                  //console.log('image is',this.image1)
                });

                // Start reading the blob as text.
                fileReader.readAsDataURL(result);

                ////console.log(filename)
                //console.log(result.size)
                //console.log('image is',result)
              });
            } else {
              var fileReader = new FileReader();
              fileReader.addEventListener("load", function () {
                _this.image1 = fileReader.result;

                //console.log('else image is',this.image1)
              });
              fileReader.readAsDataURL(result);
              ////console.log(filename)
              //console.log('else',result.size)
              //console.log('ekse image is',result)
            }
          }).catch(function (err) {
            // Handle the error
            //console.log("error is" + err)
          });
        }
      }
    },
    otherIMG: function otherIMG(event) {
      var _this2 = this;

      var files = event.target.files;
      //console.log('files are', files)
      //console.log('imgfiles.length are', this.imgfiles.length)
      if (files.length > this.maxFiles || this.imgfiles.length >= this.maxFiles || files.length + this.imgfiles.length > this.maxFiles) {
        alert("You can only upload a maximum of " + this.maxFiles + " files");
        return 0;
      } else {
        for (var i = 0; i < files.length; i++) {
          if (files[0].type == "image/png" || files[0].type == "image/gif" || files[0].type == "image/svg+xml" || files[0].type == "image/tiff") {
            alert("File " + files[0].name + " is not type of jpeg or jpg!. You cannot upload other types of images.");
          } else if (files[i].size > 5000200) {
            alert("File " + files[i].name + " is too large!");
          } else {
            var reader = new FileReader();

            reader.addEventListener("load", function () {
              //   document.getElementsByClassName('image-upload-wrap').hide();
              _this2.visible = "none";
              // this.logoimg = reader.result
              _this2.visible2 = "inline";
            });
            reader.readAsDataURL(files[i]);
            //console.log('files[0]', files[i])
            var imageCompressor = new __WEBPACK_IMPORTED_MODULE_1_image_compressor_js__["a" /* default */]();
            imageCompressor.compress(files[i], { quality: 0.6, width: 720, height: 1340 }).then(function (result) {
              // Handle the compressed image file.
              if (result.size >= 1000000) {
                var _imageCompressor2 = new __WEBPACK_IMPORTED_MODULE_1_image_compressor_js__["a" /* default */]();
                _imageCompressor2.compress(result, { quality: 0.5 }).then(function (result) {
                  var fileReader = new FileReader();

                  // This fires after the blob has been read/loaded.
                  fileReader.addEventListener("load", function () {
                    _this2.imgfiles.push(fileReader.result);
                    var otherimg = fileReader.result;
                    _this2.otherimgs.push(otherimg);
                    //console.log('image is',this.otherimgs)
                  });

                  // Start reading the blob as text.
                  fileReader.readAsDataURL(result);

                  ////console.log(filename)
                  //console.log(result.size)
                  //console.log('image is',result)
                });
              } else {
                //  const reader = new FileReader();

                //     // This fires after the blob has been read/loaded.
                //     reader.addEventListener('loadend', (e) => {
                //       this.image2 = e.srcElement.result;
                //      //console.log('else image is',this.image2)
                //     });

                //     // Start reading the blob as text.
                //     reader.readAsText(result);
                var fileReader = new FileReader();
                fileReader.addEventListener("load", function () {
                  _this2.imgfiles.push(fileReader.result);
                  var otherimg = fileReader.result;
                  _this2.otherimgs.push(otherimg);
                  //console.log('else image is',this.otherimgs)
                });
                fileReader.readAsDataURL(result);
                ////console.log(filename)
                //console.log('else',result.size)
                //console.log('ekse image is',result)
              }
            }).catch(function (err) {
              // Handle the error
              //console.log("error is" + err)
            });
          }
        }
      }
    },
    removeimg: function removeimg(i) {
      if (i > -1) {
        this.otherimgs.splice(i, 1);
        this.imgfiles.splice(i, 1);
      }
      //console.log('img files is', this.imgfiles)
      //console.log('otherimg is', this.otherimgs)
    },
    checkBarcode: function checkBarcode() {
      var _this3 = this;

      if (this.formdata.barcode) {
        this.$store.state.secondaryDatabase.collection("products").where("barcode", "==", this.formdata.barcode).limit(1).get().then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            var barcode = _this3.formdata.barcode;
            _this3.formdata.barcode = "";
            return _this3.$notify.error({
              title: "Error",
              message: "Barcode " + barcode + " is already used",
              type: "error"
            });
          });
        }).catch(function (error) {
          return alert(error.message);
        });
      }
    },
    submitForm: function submitForm(fdata) {
      var _this4 = this;

      if (this.shops[0].curProducts < this.shops[0].maxProducts) {
        this.$refs[fdata].validate(function (valid) {
          if (valid && _this4.image1 != undefined) {
            _this4.loading = true;
            _this4.changed = false;
            _this4.backToTop();
            if (_this4.formdata.dis != 0) {
              _this4.formdata.disprice = _this4.formdata.price;
              _this4.formdata.price = _this4.formdata.price - _this4.formdata.price * _this4.formdata.dis / 100;
            } else if (_this4.formdata.dis == 0) {
              _this4.formdata.disprice = _this4.formdata.price;
            }
            var docID;
            _this4.$store.state.secondaryDatabase.collection("products").add({
              name: _this4.formdata.name,
              cat: _this4.category,
              subcat: _this4.formdata.subcategory,
              loc: _this4.shops[0].loc,
              sname: _this4.shops[0].shopname,
              dis: _this4.formdata.dis,
              price: _this4.formdata.price,
              disprice: _this4.formdata.disprice,
              barcode: _this4.formdata.barcode,
              quantity: _this4.formdata.quantity,
              priceList: _this4.formdata.priceList.map(function (price) {
                return +price;
              }),
              variations: _this4.formdata.variations,
              colors: _this4.formdata.colors,
              expireDate: _this4.formdata.expireDate,
              brand: _this4.formdata.subcategory,
              color: _this4.formdata.color,
              cond: _this4.formdata.cond,
              type: _this4.formdata.type,
              war: _this4.formdata.warranty,
              desc: _this4.formdata.desc,
              img: _this4.image1,
              otherimgs: _this4.otherimgs,
              owner: __WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].auth().currentUser.uid,
              shopID: _this4.shops[0].id,
              details: {
                model: _this4.formdata.model,
                cpu: _this4.formdata.cpu,
                storage: _this4.formdata.storage,
                ram: _this4.formdata.ram,
                screen: _this4.formdata.screen,
                rearcamera: _this4.formdata.rearcamera,
                frontcamera: _this4.formdata.frontcamera,
                os: _this4.formdata.os,
                battery: _this4.formdata.battery,
                weight: _this4.formdata.weight,
                cpugeneration: _this4.formdata.cpugen,
                hard: _this4.formdata.hard,
                graphics: _this4.formdata.graphics
              }
            }).then(function (docRef) {
              docID = docRef.id;
              if (!_this4.prdstat[__WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].auth().currentUser.uid]) {
                _this4.prdstat[__WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].auth().currentUser.uid] = 1;
              } else if (_this4.prdstat[__WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].auth().currentUser.uid]) {
                _this4.prdstat[__WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].auth().currentUser.uid] += 1;
              }
              __WEBPACK_IMPORTED_MODULE_2__config_FirebaseInit__["a" /* default */].collection("aaa").doc("prdstat").update({
                prdno: _this4.prdstat
              });
              //console.log(docID)
              if (_this4.$store.state.items[_this4.$route.params.cat]) {
                // this.$store.state.items[this.$route.params.cat] = [];
                _this4.$store.state.items[_this4.$route.params.cat].push({
                  id: docRef.id,
                  name: _this4.formdata.name,
                  barcode: _this4.formdata.barcode,
                  quantity: _this4.formdata.quantity,
                  category: _this4.category,
                  subcategory: _this4.formdata.subcategory,
                  price: _this4.formdata.price,
                  brand: _this4.formdata.brand
                  //make sure to use same property name used in store.js getItems fun
                });
                //console.log('store obj created',  this.$store.state.items[this.$route.params.cat])
              }
              //console.log('# items are', this.shops[0].categories[this.category][this.formdata.subcategory])
              _this4.shops[0].catValues[_this4.category] += 1;
              _this4.shops[0].categories[_this4.category][_this4.formdata.subcategory] += 1;
              _this4.shops[0].curProducts += 1;
              if (_this4.shops[0].curProducts >= 5 && _this4.shops[0].shopcat == "Vehicles") {
                _this4.cansearch = "yes";
              } else if (_this4.shops[0].curProducts >= 10 && _this4.shops[0].shopcat != "Vehicles") {
                _this4.cansearch = "yes";
              }
              //console.log('# updated items are', this.shops[0].categories[this.category][this.formdata.subcategory])
              _this4.$store.state.secondaryDatabase.collection("shops").doc(_this4.shops[0].id).update({
                categories: _this4.shops[0].categories,
                curProducts: _this4.shops[0].curProducts,
                search: _this4.cansearch,
                catValues: _this4.shops[0].catValues
              }).then(function (doc) {
                _this4.formdata = {
                  name: "",
                  price: "",
                  dis: 0,
                  disprice: 0,
                  barcode: "",
                  quantity: 1,
                  priceList: [],
                  variations: [],
                  colors: [],
                  expireDate: "",
                  subcategory: "",
                  brand: "",
                  color: "",
                  cond: "",
                  type: "",
                  warranty: "",
                  desc: "",
                  image: null,
                  imageUrl1: "",
                  imageUrl2: "",
                  imageUrl3: "",
                  owner: "",
                  isLoggedIn: false,
                  currentUser: false,

                  model: "",
                  cpu: "",
                  cpugen: "",
                  hard: "",
                  storage: "",
                  ram: "",
                  graphics: "",
                  screen: "",
                  rearcamera: "",
                  frontcamera: "",
                  os: "",
                  battery: "",
                  weight: ""
                };
                _this4.imgfiles = [];
                _this4.otherimgs = [];
                _this4.image1 = undefined;
                _this4.loading = false;
                _this4.changed = true;
                _this4.modalShow2 = true;
                //console.log('doc is', doc)
              });
              return docID;
            }).catch(function (error) {
              return alert(error);
            });
          } else {
            if (_this4.image1 == undefined) {
              alert("Add a main image!!!");
              _this4.backToTop();
            }
            alert("error occured");
            _this4.backToTop();
            return false;
          }
        });
      } else {
        this.modalShow = true;
      }
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
      this.formdata.imageUrl1 = "";
      this.imgfiles = [];
      this.otherimgs = [];
    },


    backToTop: function backToTop() {
      $("html,body").stop().animate({
        scrollTop: 0
      }, "slow", "swing");
    }
  },

  created: function created() {
    var _this5 = this;

    this.backToTop();
    this.loading1 = true;
    this.changed = false;
    // this.$nextTick(function() {
    //    this.initToTopButton();
    // })
    if (screen.width > 575) {
      this.labelPosition = "left";
    } else {
      this.labelPosition = "top";
    }
    if (__WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].auth().currentUser) {
      this.isLoggedIn = true;
      this.currentUser = __WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].auth().currentUser.email;

      //console.log(firebase.auth().currentUser.uid)
    }

    this.$store.state.secondaryDatabase.collection("shops").where("owner", "==", __WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].auth().currentUser.uid).get().then(function (querySnapshot) {
      querySnapshot.forEach(function (doc) {
        var data = {
          id: doc.id,
          categories: doc.data().categories,
          shoptype: doc.data().shoptype,
          shopcat: doc.data().cat,
          curProducts: doc.data().curProducts,
          maxProducts: doc.data().maxProducts,
          loc: doc.data().location,
          shopname: doc.data().name,
          catValues: doc.data().catValues,
          cansearch: doc.data().search
        };
        _this5.shops.push(data);
        _this5.shopcat = _this5.shops[0].shopcat;
        _this5.shoptype = _this5.shops[0].shoptype;
        _this5.category = _this5.$route.params.cat;
        _this5.subcategories = _this5.shops[0].categories[_this5.$route.params.cat];
        _this5.cansearch = _this5.shops[0].cansearch;
        _this5.loading1 = false;
        _this5.changed = true;
        //console.log('this.subcategories is', this.subcategories)
      });
    });
    __WEBPACK_IMPORTED_MODULE_2__config_FirebaseInit__["a" /* default */].collection("aaa").doc("prdstat").get().then(function (doc) {
      _this5.prdstat = doc.data().prdno;
    });
  },
  mounted: function mounted() {}
});

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Vehicles_vue__ = __webpack_require__(228);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7562f3a0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Vehicles_vue__ = __webpack_require__(697);
function injectStyle (ssrContext) {
  __webpack_require__(696)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7562f3a0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Vehicles_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7562f3a0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Vehicles_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_image_compressor_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_FirebaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_mobiles__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_ClothingAccessories__ = __webpack_require__(27);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vehicles",
  data: function data() {
    var checkprice = function checkprice(rule, value, callback) {
      if (!value) {
        return callback(new Error("Please input the price"));
      }
      setTimeout(function () {
        if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(value)) {
          callback(new Error("Please input numbers"));
        } else {
          if (value < 0) {
            callback(new Error("Price cannot be negetive"));
          } else {
            callback();
          }
        }
      }, 100);
    };

    var checkdis = function checkdis(rule, value, callback) {
      setTimeout(function () {
        if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(value)) {
          callback(new Error("Please input numbers"));
        } else {
          if (value < 0 || value > 100) {
            callback(new Error("Discount should be 0 to 100"));
          } else {
            callback();
          }
        }
      }, 100);
    };
    return {
      categoriesList: [],
      subcategories: {},
      category: "",
      tags: [],
      shops: [],
      shopcat: "",
      shoptype: "",
      cansearch: "no",
      modalShow: false,
      modalShow2: false,
      options: [{
        value: "Option1",
        label: "Option1"
      }, {
        value: "Option2",
        label: "Option2"
      }, {
        value: "Option3",
        label: "Option3"
      }, {
        value: "Option4",
        label: "Option4"
      }, {
        value: "Option5",
        label: "Option5"
      }],
      visible: "block",
      visible1: "none",
      visible2: "none",
      visible3: "none",
      imgfiles: [],
      otherimgs: [],
      maxFiles: 4,
      labelPosition: "",
      loading: false,
      loading1: false,
      changed: true,

      formdata: {
        name: "",
        price: "",
        barcode: "",
        quantity: 0,
        priceList: [],
        variations: [],
        colors: [],
        expireDate: "",
        dis: 0,
        disprice: 0,
        subcategory: "",
        brand: "",
        model: "",
        modelcode: "",
        manuyear: "",
        cond: "",
        transmission: "",
        fueltype: "",
        enginetype: "",
        enginecapacity: "",
        bodytype: "",
        mileage: "",
        color: "",
        type: "",
        warranty: "",
        desc: "",
        image: null,
        imageUrl1: "",
        imageUrl2: "",
        imageUrl3: "",
        owner: "",
        isLoggedIn: false,
        currentUser: false,
        prdstat: {}
      },

      rules: {
        name: [{ required: true, message: "Please input name", trigger: "blur" }, {
          min: 3,
          max: 100,
          message: "Length should be 3 to 100",
          trigger: "blur"
        }],
        barcode: [{ required: true, message: "Please input barcode", trigger: "blur" }],
        quantity: [{ required: true, message: "Please input quantity", trigger: "blur" }, {
          min: 1,
          type: "number",
          message: "Minimum quantity is 0",
          trigger: "blur"
        }],
        price: [{ validator: checkprice, trigger: "blur" }],
        dis: [{ validator: checkdis, trigger: "blur" }],
        category: [{ message: "Please select category", trigger: "change" }],
        subcategory: [{
          required: true,
          message: "Please select the make",
          trigger: "change"
        }],
        model: [{ required: true, message: "Please input model", trigger: "blur" }],
        cond: [{
          required: true,
          message: "Please select condition",
          trigger: "change"
        }],
        modelcode: [{
          required: true,
          message: "Please input model code",
          trigger: "blur"
        }],
        manuyear: [{
          required: true,
          message: "Please input manufactured year",
          trigger: "blur"
        }]
      }
    };
  },


  watch: {
    // category () {
    //   this.subcategories = []
    //   this.formdata.subcategory = ""
    //   if (this.category.length > 0) {
    //           this.subcategories = this.categoriesList[this.category]
    //       }
    // },
    // shops () {
    //    if(this.shops[0].shoptype == 'Fashion'){
    //     this.categoriesList = ClothingAccessories
    // }
    // if(this.shops[0].shoptype == 'Elec'){
    //     this.categoriesList = mobiles
    // }
    // }
  },

  methods: {
    pickFile: function pickFile() {
      this.$refs.fileInput.click();
    },
    fileSelect1: function fileSelect1(event) {
      var _this = this;

      //console.log('event is', event)
      if (event.target.files.length > 0) {
        var files = event.target.files;
        var filename = files[0].name;
        if (files[0].type == "image/png" || files[0].type == "image/gif" || files[0].type == "image/svg+xml" || files[0].type == "image/tiff") {
          alert("File " + files[0].name + " is not type of jpeg or jpg!. You cannot upload other types of images.");
        } else if (files[0].size > 5000200) {
          alert("File " + files[0].name + " is too large!");
        } else {
          var reader = new FileReader();
          reader.addEventListener("load", function () {
            _this.visible = "none";
            _this.formdata.imageUrl1 = reader.result;
            _this.visible1 = "block";
          });
          reader.readAsDataURL(files[0]);
          //this.image = files[0];
          var imageCompressor = new __WEBPACK_IMPORTED_MODULE_1_image_compressor_js__["a" /* default */]();
          imageCompressor.compress(files[0], { quality: 0.8, width: 720, height: 1340 }).then(function (result) {
            // Handle the compressed image file.
            if (result.size >= 1000000) {
              var _imageCompressor = new __WEBPACK_IMPORTED_MODULE_1_image_compressor_js__["a" /* default */]();
              _imageCompressor.compress(result, { quality: 0.6 }).then(function (result) {
                var fileReader = new FileReader();

                // This fires after the blob has been read/loaded.
                fileReader.addEventListener("load", function () {
                  _this.image1 = fileReader.result;

                  //console.log('image is',this.image1)
                });

                // Start reading the blob as text.
                fileReader.readAsDataURL(result);

                ////console.log(filename)
                //console.log(result.size)
                //console.log('image is',result)
              });
            } else {
              var fileReader = new FileReader();
              fileReader.addEventListener("load", function () {
                _this.image1 = fileReader.result;

                //console.log('else image is',this.image1)
              });
              fileReader.readAsDataURL(result);
              ////console.log(filename)
              //console.log('else',result.size)
              //console.log('ekse image is',result)
            }
          }).catch(function (err) {
            // Handle the error
            //console.log("error is" + err)
          });
        }
      }
    },
    otherIMG: function otherIMG(event) {
      var _this2 = this;

      var files = event.target.files;
      //console.log('files are', files)
      //console.log('imgfiles.length are', this.imgfiles.length)
      if (files.length > this.maxFiles || this.imgfiles.length >= this.maxFiles || files.length + this.imgfiles.length > this.maxFiles) {
        alert("You can only upload a maximum of " + this.maxFiles + " files");
        return 0;
      } else {
        for (var i = 0; i < files.length; i++) {
          if (files[0].type == "image/png" || files[0].type == "image/gif" || files[0].type == "image/svg+xml" || files[0].type == "image/tiff") {
            alert("File " + files[0].name + " is not type of jpeg or jpg!. You cannot upload other types of images.");
          } else if (files[i].size > 5000200) {
            alert("File " + files[i].name + " is too large!");
          } else {
            var reader = new FileReader();

            reader.addEventListener("load", function () {
              //   document.getElementsByClassName('image-upload-wrap').hide();
              _this2.visible = "none";
              // this.logoimg = reader.result
              _this2.visible2 = "inline";
            });
            reader.readAsDataURL(files[i]);
            //console.log('files[0]', files[i])
            var imageCompressor = new __WEBPACK_IMPORTED_MODULE_1_image_compressor_js__["a" /* default */]();
            imageCompressor.compress(files[i], { quality: 0.6, width: 720, height: 1340 }).then(function (result) {
              // Handle the compressed image file.
              if (result.size >= 1000000) {
                var _imageCompressor2 = new __WEBPACK_IMPORTED_MODULE_1_image_compressor_js__["a" /* default */]();
                _imageCompressor2.compress(result, { quality: 0.5 }).then(function (result) {
                  var fileReader = new FileReader();

                  // This fires after the blob has been read/loaded.
                  fileReader.addEventListener("load", function () {
                    _this2.imgfiles.push(fileReader.result);
                    var otherimg = fileReader.result;
                    _this2.otherimgs.push(otherimg);
                    //console.log('image is',this.otherimgs)
                  });

                  // Start reading the blob as text.
                  fileReader.readAsDataURL(result);

                  ////console.log(filename)
                  //console.log(result.size)
                  //console.log('image is',result)
                });
              } else {
                //  const reader = new FileReader();

                //     // This fires after the blob has been read/loaded.
                //     reader.addEventListener('loadend', (e) => {
                //       this.image2 = e.srcElement.result;
                //      //console.log('else image is',this.image2)
                //     });

                //     // Start reading the blob as text.
                //     reader.readAsText(result);
                var fileReader = new FileReader();
                fileReader.addEventListener("load", function () {
                  _this2.imgfiles.push(fileReader.result);
                  var otherimg = fileReader.result;
                  _this2.otherimgs.push(otherimg);
                  //console.log('else image is',this.otherimgs)
                });
                fileReader.readAsDataURL(result);
                ////console.log(filename)
                //console.log('else',result.size)
                //console.log('ekse image is',result)
              }
            }).catch(function (err) {
              // Handle the error
              //console.log("error is" + err)
            });
          }
        }
      }
    },
    removeimg: function removeimg(i) {
      if (i > -1) {
        this.otherimgs.splice(i, 1);
        this.imgfiles.splice(i, 1);
      }
      //console.log('img files is', this.imgfiles)
      //console.log('otherimg is', this.otherimgs)
    },
    checkBarcode: function checkBarcode() {
      var _this3 = this;

      if (this.formdata.barcode) {
        this.$store.state.secondaryDatabase.collection("products").where("barcode", "==", this.formdata.barcode).limit(1).get().then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            var barcode = _this3.formdata.barcode;
            _this3.formdata.barcode = "";
            return _this3.$notify.error({
              title: "Error",
              message: "Barcode " + barcode + " is already used",
              type: "error"
            });
          });
        }).catch(function (error) {
          return alert(error.message);
        });
      }
    },
    submitForm: function submitForm(fdata) {
      var _this4 = this;

      if (this.shops[0].curProducts < this.shops[0].maxProducts) {
        this.$refs[fdata].validate(function (valid) {
          if (valid && _this4.image1 != undefined) {
            _this4.loading = true;
            _this4.changed = false;
            _this4.backToTop();
            if (_this4.formdata.dis != 0) {
              _this4.formdata.disprice = _this4.formdata.price;
              _this4.formdata.price = _this4.formdata.price - _this4.formdata.price * _this4.formdata.dis / 100;
            } else if (_this4.formdata.dis == 0) {
              _this4.formdata.disprice = _this4.formdata.price;
            }
            var docID;
            _this4.$store.state.secondaryDatabase.collection("products").add({
              name: _this4.formdata.name,
              cat: _this4.category,
              subcat: _this4.formdata.subcategory,
              loc: _this4.shops[0].loc,
              sname: _this4.shops[0].shopname,
              dis: _this4.formdata.dis,
              price: _this4.formdata.price,
              disprice: _this4.formdata.disprice,
              barcode: _this4.formdata.barcode,
              quantity: _this4.formdata.quantity,
              priceList: _this4.formdata.priceList.map(function (price) {
                return +price;
              }),
              variations: _this4.formdata.variations,
              colors: _this4.formdata.colors,
              expireDate: _this4.formdata.expireDate,
              brand: _this4.formdata.brand,
              color: _this4.formdata.color,
              cond: _this4.formdata.cond,
              type: _this4.formdata.type,
              war: _this4.formdata.warranty,
              desc: _this4.formdata.desc,
              tags: _this4.tags,
              img: _this4.image1,
              otherimgs: _this4.otherimgs,
              owner: __WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].auth().currentUser.uid,
              shopID: _this4.shops[0].id,
              details: {
                model: _this4.formdata.model,
                modelcode: _this4.formdata.modelcode,
                year: _this4.formdata.manuyear,
                transmission: _this4.formdata.transmission,
                fueltype: _this4.formdata.fueltype,
                enginetype: _this4.formdata.enginetype,
                enginecapacity: _this4.formdata.enginecapacity,
                bodytype: _this4.formdata.bodytype,
                mileage: _this4.formdata.mileage
              }
            }).then(function (docRef) {
              docID = docRef.id;
              if (!_this4.prdstat[__WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].auth().currentUser.uid]) {
                _this4.prdstat[__WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].auth().currentUser.uid] = 1;
              } else if (_this4.prdstat[__WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].auth().currentUser.uid]) {
                _this4.prdstat[__WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].auth().currentUser.uid] += 1;
              }
              __WEBPACK_IMPORTED_MODULE_2__config_FirebaseInit__["a" /* default */].collection("aaa").doc("prdstat").update({
                prdno: _this4.prdstat
              });
              //console.log(docID)
              if (_this4.$store.state.items[_this4.$route.params.cat]) {
                // this.$store.state.items[this.$route.params.cat] = [];
                _this4.$store.state.items[_this4.$route.params.cat].push({
                  id: docRef.id,
                  name: _this4.formdata.name,
                  barcode: _this4.formdata.barcode,
                  quantity: _this4.formdata.quantity,
                  category: _this4.category,
                  subcategory: _this4.formdata.subcategory,
                  price: _this4.formdata.price,
                  brand: _this4.formdata.brand
                  //make sure to use same property name used in store.js getItems fun
                });
                //console.log('store obj created',  this.$store.state.items[this.$route.params.cat])
              }
              //console.log('# items are', this.shops[0].categories[this.category][this.formdata.subcategory])
              _this4.shops[0].catValues[_this4.category] += 1;
              _this4.shops[0].categories[_this4.category][_this4.formdata.subcategory] += 1;
              _this4.shops[0].curProducts += 1;
              if (_this4.shops[0].curProducts >= 5 && _this4.shops[0].shopcat == "Vehicles") {
                _this4.cansearch = "yes";
              } else if (_this4.shops[0].curProducts >= 10 && _this4.shops[0].shopcat != "Vehicles") {
                _this4.cansearch = "yes";
              }
              //console.log('# updated items are', this.shops[0].categories[this.category][this.formdata.subcategory])
              _this4.$store.state.secondaryDatabase.collection("shops").doc(_this4.shops[0].id).update({
                categories: _this4.shops[0].categories,
                curProducts: _this4.shops[0].curProducts,
                search: _this4.cansearch,
                catValues: _this4.shops[0].catValues
              }).then(function (doc) {
                _this4.formdata = {
                  name: "",
                  price: "",
                  dis: 0,
                  disprice: 0,
                  barcode: "",
                  quantity: 1,
                  priceList: [],
                  variations: [],
                  colors: [],
                  expireDate: "",
                  subcategory: "",
                  brand: "",
                  model: "",
                  modelcode: "",
                  manuyear: "",
                  cond: "",
                  transmission: "",
                  fueltype: "",
                  enginetype: "",
                  enginecapacity: "",
                  bodytype: "",
                  mileage: "",
                  color: "",
                  type: "",
                  warranty: "",
                  desc: "",
                  image: null,
                  imageUrl1: "",
                  imageUrl2: "",
                  imageUrl3: "",
                  owner: "",
                  isLoggedIn: false,
                  currentUser: false
                };
                _this4.imgfiles = [];
                _this4.otherimgs = [];
                _this4.image1 = undefined;
                _this4.loading = false;
                _this4.changed = true;
                _this4.modalShow2 = true;
                //console.log('doc is', doc)
              });
              return docID;
            }).catch(function (error) {
              return alert(error);
            });
          } else {
            if (_this4.image1 == undefined) {
              alert("Add a main image!!!");
              _this4.backToTop();
            }
            alert("error occured");
            _this4.backToTop();
            return false;
          }
        });
      } else {
        this.modalShow = true;
      }
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
      this.formdata.imageUrl1 = "";
      this.imgfiles = [];
      this.otherimgs = [];
    },


    backToTop: function backToTop() {
      $("html,body").stop().animate({
        scrollTop: 0
      }, "slow", "swing");
    }
  },

  created: function created() {
    var _this5 = this;

    this.backToTop();
    this.loading1 = true;
    this.changed = false;
    // this.$nextTick(function() {
    //    this.initToTopButton();
    // })
    if (screen.width > 575) {
      this.labelPosition = "left";
    } else {
      this.labelPosition = "top";
    }
    if (__WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].auth().currentUser) {
      this.isLoggedIn = true;
      this.currentUser = __WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].auth().currentUser.email;

      //console.log(firebase.auth().currentUser.uid)
    }

    this.$store.state.secondaryDatabase.collection("shops").where("owner", "==", __WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].auth().currentUser.uid).get().then(function (querySnapshot) {
      querySnapshot.forEach(function (doc) {
        var data = {
          id: doc.id,
          categories: doc.data().categories,
          shopcat: doc.data().cat,
          shoptype: doc.data().shoptype,
          curProducts: doc.data().curProducts,
          maxProducts: doc.data().maxProducts,
          loc: doc.data().location,
          shopname: doc.data().name,
          catValues: doc.data().catValues,
          cansearch: doc.data().search
        };
        _this5.shops.push(data);
        _this5.shopcat = _this5.shops[0].shopcat;
        _this5.shoptype = _this5.shops[0].shoptype;
        _this5.category = _this5.$route.params.cat;
        _this5.subcategories = _this5.shops[0].categories[_this5.$route.params.cat];
        _this5.cansearch = _this5.shops[0].cansearch;
        _this5.loading1 = false;
        _this5.changed = true;
        //console.log('this.subcategories is', this.subcategories)
      });
    });
    __WEBPACK_IMPORTED_MODULE_2__config_FirebaseInit__["a" /* default */].collection("aaa").doc("prdstat").get().then(function (doc) {
      _this5.prdstat = doc.data().prdno;
    });
  },
  mounted: function mounted() {}
});

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_image_compressor_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_FirebaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PriceTable_vue__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_mobiles__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__data_ClothingAccessories__ = __webpack_require__(27);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: "editcommonproduct",
  components: {
    PriceTable: __WEBPACK_IMPORTED_MODULE_5__PriceTable_vue__["a" /* default */]
  },
  data: function data() {
    var checkprice = function checkprice(rule, value, callback) {
      // if (!value) {
      //   return callback(new Error("Please input the price"));
      // }
      setTimeout(function () {
        // if (!Number.isInteger(value)) {
        //   callback(new Error("Please input numbers"));
        // } else {
        if (value < 0) {
          callback(new Error("Price cannot be negetive"));
        } else {
          callback();
        }
        // }
      }, 100);
    };

    var checkdis = function checkdis(rule, value, callback) {
      setTimeout(function () {
        if (!__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default()(value)) {
          callback(new Error("Please input numbers"));
        } else {
          if (value < 0 || value > 100) {
            callback(new Error("Discount should be 0 to 100"));
          } else {
            callback();
          }
        }
      }, 100);
    };
    return {
      categoriesList: [],
      subcategories: {},
      category: "",
      subcategory: "",
      tags: [],
      shops: [],
      shoptype: "",
      shopcat: "",
      options: [{
        value: "Option1",
        label: "Option1"
      }, {
        value: "Option2",
        label: "Option2"
      }, {
        value: "Option3",
        label: "Option3"
      }, {
        value: "Option4",
        label: "Option4"
      }, {
        value: "Option5",
        label: "Option5"
      }],
      visible: "block",
      visible1: "none",
      visible2: "none",
      visible3: "none",
      imgfiles: [],
      otherimgs: [],
      maxFiles: 4,
      labelPosition: "",
      dis: "",
      price: "",

      loading: false,
      loading1: false,
      changed: true,
      initPrdName: "",
      initPrdBarcode: "",
      showPriceTable: false,
      priceTableWidth: "50%",

      formdata: {
        name: "",
        price: 0,
        barcode: "",
        quantity: 0,
        priceList: [],
        priceData: [],
        profitMargin: 0,
        variations: [],
        colors: [],
        expireDate: "",
        dis: 0,
        disprice: 0,
        brand: "",
        model: "",
        karat: "",
        metal: "",
        author: "",
        publisher: "",
        size: "",
        screensize: "",
        material: "",
        color: "",
        cond: "",
        type: "",
        warranty: "",
        desc: "",
        image: null,
        imageUrl: "",
        imageUrl2: "",
        imageUrl3: "",
        owner: "",
        isLoggedIn: false,
        currentUser: false,
        rack: ''
      },

      rules: {
        name: [{ required: true, message: "Please input name", trigger: "blur" }, {
          min: 3,
          max: 100,
          message: "Length should be 3 to 100",
          trigger: "blur"
        }],
        barcode: [{ required: true, message: "Please input barcode", trigger: "blur" }],
        quantity: [{ required: true, message: "Please input quantity", trigger: "blur" }, {
          min: 1,
          type: "number",
          message: "Minimum quantity is 1",
          trigger: "blur"
        }],
        price: [{ validator: checkprice, trigger: "blur" }],
        dis: [{ validator: checkdis, trigger: "blur" }],
        category: [{ message: "Please select category", trigger: "change" }],
        subcategory: [{ message: "Please select sub category", trigger: "blur" }],
        brand: [{ message: "Please select brand", trigger: "change" }],
        color: [{ message: "Please select picture", trigger: "blur" }],
        desc: [{ message: "Please input description", trigger: "blur" }]
      }
    };
  },


  methods: {
    pickFile: function pickFile() {
      this.$refs.fileInput.click();
    },
    goback: function goback() {
      this.$router.push({
        name: "allProducts",
        params: { cat: this.$route.params.cat }
      });
    },
    fileSelect1: function fileSelect1(event) {
      var _this = this;

      //console.log('event is', event)
      if (event.target.files.length > 0) {
        var files = event.target.files;
        var filename = files[0].name;
        if (files[0].type == "image/png" || files[0].type == "image/gif" || files[0].type == "image/svg+xml" || files[0].type == "image/tiff") {
          alert("File " + files[0].name + " is not type of jpeg or jpg!. You cannot upload other types of images.");
        } else if (files[0].size > 5000200) {
          alert("File " + files[0].name + " is too large!");
        } else {
          var reader = new FileReader();
          reader.addEventListener("load", function () {
            _this.visible = "none";
            _this.formdata.imageUrl = reader.result;
            _this.visible1 = "block";
          });
          reader.readAsDataURL(files[0]);
          //this.image = files[0];
          var imageCompressor = new __WEBPACK_IMPORTED_MODULE_2_image_compressor_js__["a" /* default */]();
          imageCompressor.compress(files[0], { quality: 0.8, width: 720, height: 1340 }).then(function (result) {
            // Handle the compressed image file.
            if (result.size >= 1000000) {
              var _imageCompressor = new __WEBPACK_IMPORTED_MODULE_2_image_compressor_js__["a" /* default */]();
              _imageCompressor.compress(result, { quality: 0.6 }).then(function (result) {
                var fileReader = new FileReader();

                // This fires after the blob has been read/loaded.
                fileReader.addEventListener("load", function () {
                  _this.formdata.imageUrl = fileReader.result;

                  //console.log('image is',this.formdata.imageUrl)
                });

                // Start reading the blob as text.
                fileReader.readAsDataURL(result);

                ////console.log(filename)
                //console.log(result.size)
                //console.log('image is',result)
              });
            } else {
              var fileReader = new FileReader();
              fileReader.addEventListener("load", function () {
                _this.formdata.imageUrl = fileReader.result;

                //console.log('else image is',this.formdata.imageUrl)
              });
              fileReader.readAsDataURL(result);
              ////console.log(filename)
              //console.log('else',result.size)
              //console.log('ekse image is',result)
            }
          }).catch(function (err) {
            // Handle the error
            //console.log("error is" + err)
          });
        }
      }
    },
    otherIMG: function otherIMG(event) {
      var _this2 = this;

      var files = event.target.files;
      //console.log('files are', files)
      //  //console.log('imgfiles.length are', this.imgfiles.length)
      if (files.length > this.maxFiles || this.imgfiles.length >= this.maxFiles || files.length + this.imgfiles.length > this.maxFiles) {
        alert("You can only upload a maximum of " + this.maxFiles + " files");
        return 0;
      } else {
        for (var i = 0; i < files.length; i++) {
          if (files[0].type == "image/png" || files[0].type == "image/gif" || files[0].type == "image/svg+xml" || files[0].type == "image/tiff") {
            alert("File " + files[0].name + " is not type of jpeg or jpg!. You cannot upload other types of images.");
          } else if (files[i].size > 5000200) {
            alert("File " + files[i].name + " is too large!");
          } else {
            var reader = new FileReader();

            reader.addEventListener("load", function () {
              //   document.getElementsByClassName('image-upload-wrap').hide();
              _this2.visible = "none";
              // this.logoimg = reader.result
              _this2.visible2 = "inline";
            });
            reader.readAsDataURL(files[i]);
            //console.log('files[0]', files[i])
            var imageCompressor = new __WEBPACK_IMPORTED_MODULE_2_image_compressor_js__["a" /* default */]();
            imageCompressor.compress(files[i], { quality: 0.6, width: 720, height: 1340 }).then(function (result) {
              // Handle the compressed image file.
              if (result.size >= 1000000) {
                var _imageCompressor2 = new __WEBPACK_IMPORTED_MODULE_2_image_compressor_js__["a" /* default */]();
                _imageCompressor2.compress(result, { quality: 0.5 }).then(function (result) {
                  var fileReader = new FileReader();

                  // This fires after the blob has been read/loaded.
                  fileReader.addEventListener("load", function () {
                    _this2.imgfiles.push(fileReader.result);
                    var otherimg = fileReader.result;
                    _this2.otherimgs.push(otherimg);
                    //console.log('image is',this.otherimgs)
                  });

                  // Start reading the blob as text.
                  fileReader.readAsDataURL(result);

                  ////console.log(filename)
                  //console.log(result.size)
                  //console.log('image is',result)
                });
              } else {
                //  const reader = new FileReader();

                //     // This fires after the blob has been read/loaded.
                //     reader.addEventListener('loadend', (e) => {
                //       this.image2 = e.srcElement.result;
                //      //console.log('else image is',this.image2)
                //     });

                //     // Start reading the blob as text.
                //     reader.readAsText(result);
                var fileReader = new FileReader();
                fileReader.addEventListener("load", function () {
                  _this2.imgfiles.push(fileReader.result);
                  var otherimg = fileReader.result;
                  _this2.otherimgs.push(otherimg);
                  //console.log('else image is',this.otherimgs)
                });
                fileReader.readAsDataURL(result);
                ////console.log(filename)
                //console.log('else',result.size)
                //console.log('ekse image is',result)
              }
            }).catch(function (err) {
              // Handle the error
              //console.log("error is" + err)
            });
          }
        }
      }
    },
    removeimg: function removeimg(i) {
      if (i > -1) {
        this.otherimgs.splice(i, 1);
        this.imgfiles.splice(i, 1);
      }
      //console.log('img files is', this.imgfiles)
      //console.log('otherimg is', this.otherimgs)
    },
    checkBarcode: function checkBarcode() {
      var _this3 = this;

      if (this.formdata.barcode) {
        this.$store.state.secondaryDatabase.collection("products").where("owner", "==", __WEBPACK_IMPORTED_MODULE_4_firebase_app__["a" /* default */].auth().currentUser.uid).where("barcode", "==", this.formdata.barcode).limit(1).get().then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            if (_this3.$route.params.product_id !== doc.id) {
              var barcode = _this3.formdata.barcode;
              _this3.formdata.barcode = "";
              return _this3.$notify.error({
                title: "Error",
                message: "Barcode " + barcode + " is already used",
                type: "error"
              });
            }
          });
        }).catch(function (error) {
          return alert(error.message);
        });
      }
    },
    updateForm: function updateForm(fdata) {
      var _this4 = this;

      this.$refs[fdata].validate(function (valid) {
        if (valid) {
          _this4.backToTop();
          _this4.loading = true;
          _this4.changed = false;
          var scope = _this4;
          if (_this4.formdata.dis != _this4.dis || _this4.formdata.price != _this4.price) {
            _this4.formdata.disprice = _this4.formdata.price;
            _this4.formdata.price = _this4.formdata.price - _this4.formdata.price * _this4.formdata.dis / 100;
          } else {
            _this4.formdata.disprice = _this4.formdata.price;
          }
          _this4.$store.state.secondaryDatabase.collection("products").doc(_this4.$route.params.product_id).update({
            name: _this4.formdata.name,
            cat: _this4.category,
            subcat: _this4.subcategory,
            price: _this4.formdata.price,
            dis: _this4.formdata.dis,
            disprice: _this4.formdata.disprice,
            barcode: _this4.formdata.barcode,
            altertQunty: _this4.formdata.quantity,
            profitMargin: _this4.formdata.profitMargin,
            priceList: _this4.formdata.priceData,
            variations: _this4.formdata.variations,
            colors: _this4.formdata.colors,
            expireDate: _this4.formdata.expireDate ? new Date(_this4.formdata.expireDate) : "",
            brand: _this4.formdata.brand,
            rack: _this4.formdata.rack,
            color: _this4.formdata.color,
            cond: _this4.formdata.cond,
            type: _this4.formdata.type,
            war: _this4.formdata.warranty,
            desc: _this4.formdata.desc,
            img: _this4.formdata.imageUrl,
            otherimgs: _this4.otherimgs,

            details: {
              model: _this4.formdata.model,
              karat: _this4.formdata.karat,
              metal: _this4.formdata.metal,
              author: _this4.formdata.author,
              publisher: _this4.formdata.publisher,
              size: _this4.formdata.size,
              screensize: _this4.formdata.screensize,
              material: _this4.formdata.material
            }
          }).then(function () {
            var totalQnty = 0;
            _this4.formdata.priceData.forEach(function (item) {
              return totalQnty += item.quantity;
            });
            var prdData = {
              id: _this4.$route.params.product_id,
              name: _this4.formdata.name,
              barcode: _this4.formdata.barcode,
              altertQunty: _this4.formdata.quantity,
              category: _this4.category,
              subcategory: _this4.subcategory,
              price: _this4.formdata.disprice,
              brand: _this4.formdata.brand,
              priceList: _this4.formdata.priceData,
              profitMargin: _this4.formdata.profitMargin,
              rack: _this4.formdata.rack,
              totalQnty: totalQnty
              //make sure to use same property name used in store.js getItems fun
            };

            if (_this4.$store.state.items[_this4.$route.params.cat]) {
              var newitems = _this4.$store.state.items[_this4.$route.params.cat].filter(function (item) {
                //console.log('filfkkk')
                return item.id !== _this4.$route.params.product_id;
              });

              newitems.unshift(prdData);
              _this4.$store.state.items[_this4.$route.params.cat] = newitems;
            }

            if (_this4.$store.state.allProducts != undefined && _this4.$store.state.allProducts.length !== 0) {
              var newAllPrd = _this4.$store.state.allProducts.filter(function (item) {
                return item.id !== _this4.$route.params.product_id;
              });
              newAllPrd.unshift(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, prdData, {
                img: _this4.formdata.imageUrl,
                _showDetails: false // toggle row details
              }));
              _this4.$store.state.allProducts = newAllPrd;
            }

            if (_this4.initPrdBarcode != _this4.formdata.barcode || _this4.initPrdName != _this4.formdata.name) {
              var foundPrd = _this4.$store.state.prdNameList.find(function (p) {
                return p.barcode == _this4.initPrdBarcode;
              });
              _this4.$store.state.prdNameList = _this4.$store.state.prdNameList.filter(function (p) {
                return p.barcode != _this4.initPrdBarcode;
              });
              _this4.$store.state.prdNameList.push({
                name: _this4.formdata.name,
                barcode: _this4.formdata.barcode,
                lowStock: foundPrd.lowStock || ""
              });
              var prds = 'prds';
              if (_this4.$store.state.noDB === true) {
                prds = "prds" + __WEBPACK_IMPORTED_MODULE_4_firebase_app__["a" /* default */].auth().currentUser.uid;
              }
              _this4.$store.state.secondaryDatabase.collection("prdlist").doc(prds).set({ data: _this4.$store.state.prdNameList }).then(function (doc) {}).catch(function (error) {
                alert(error);
              });
            }

            _this4.$router.push({
              name: "allProducts",
              params: { cat: _this4.$route.params.cat }
            });
            //console.log('prd updated')
          });
        } else {
          alert("error update");
          return false;
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    },


    backToTop: function backToTop() {
      $("html,body").stop().animate({
        scrollTop: 0
      }, "slow", "swing");
    }
  },

  created: function created() {
    var _this5 = this;

    this.backToTop();
    this.loading1 = true;
    this.changed = false;
    if (screen.width > 575) {
      this.labelPosition = "left";
    } else {
      this.labelPosition = "top";
      this.priceTableWidth = "80%";
    }
    if (__WEBPACK_IMPORTED_MODULE_4_firebase_app__["a" /* default */].auth().currentUser) {
      this.isLoggedIn = true;
      this.currentUser = __WEBPACK_IMPORTED_MODULE_4_firebase_app__["a" /* default */].auth().currentUser.email;

      //console.log(firebase.auth().currentUser.uid)
    }

    this.$store.state.secondaryDatabase.collection("shops").where("owner", "==", __WEBPACK_IMPORTED_MODULE_4_firebase_app__["a" /* default */].auth().currentUser.uid).get().then(function (querySnapshot) {
      querySnapshot.forEach(function (doc) {
        var data = {
          id: doc.id,
          categories: doc.data().categories,
          shoptype: doc.data().shoptype,
          shopcat: doc.data().cat
        };
        _this5.shops.push(data);
        _this5.shopcat = _this5.shops[0].shopcat;
        _this5.shoptype = _this5.shops[0].shoptype;
        _this5.category = _this5.$route.params.cat;
        _this5.subcategories = _this5.shops[0].categories[_this5.$route.params.cat];
        //console.log('this.subcategories is', this.subcategories)
      });
    });

    //console.log(this.$route.params.product_id)
    this.$store.state.secondaryDatabase.collection("products").doc(this.$route.params.product_id).get().then(function (doc) {
      _this5.formdata.name = doc.data().name, _this5.subcategory = doc.data().subcat, _this5.formdata.brand = doc.data().brand, _this5.formdata.price = doc.data().disprice, _this5.formdata.dis = doc.data().dis, _this5.dis = doc.data().dis, _this5.price = doc.data().disprice, _this5.formdata.barcode = doc.data().barcode, _this5.formdata.quantity = doc.data().altertQunty;
      _this5.formdata.profitMargin = doc.data().profitMargin || 0;
      _this5.formdata.priceData = doc.data().priceList;
      _this5.formdata.variations = doc.data().variations;
      _this5.formdata.colors = doc.data().colors;
      _this5.formdata.expireDate = doc.data().expireDate ? doc.data().expireDate.toDate().toLocaleString() : "", _this5.formdata.color = doc.data().color, _this5.formdata.rack = doc.data().rack || '', _this5.formdata.cond = doc.data().cond, _this5.formdata.type = doc.data().type, _this5.formdata.warranty = doc.data().war, _this5.formdata.desc = doc.data().desc, _this5.formdata.imageUrl = doc.data().img;
      _this5.imgfiles = doc.data().otherimgs, _this5.otherimgs = doc.data().otherimgs, _this5.formdata.model = doc.data().details.model, _this5.formdata.karat = doc.data().details.karat, _this5.formdata.metal = doc.data().details.metal, _this5.formdata.author = doc.data().details.author, _this5.formdata.publisher = doc.data().details.publisher, _this5.formdata.size = doc.data().details.size, _this5.formdata.screensize = doc.data().details.screensize, _this5.formdata.material = doc.data().details.material;
      // console.log("formdata", this.formdata, this.imgfiles);
      _this5.initPrdBarcode = doc.data().barcode;
      _this5.initPrdName = doc.data().name;
      _this5.loading1 = false;
      _this5.changed = true;
    });
  },
  mounted: function mounted() {}
});

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_image_compressor_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_FirebaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_mobiles__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_ClothingAccessories__ = __webpack_require__(27);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "editmobiles",
  data: function data() {
    var checkprice = function checkprice(rule, value, callback) {
      if (!value) {
        return callback(new Error("Please input the price"));
      }
      setTimeout(function () {
        if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(value)) {
          callback(new Error("Please input numbers"));
        } else {
          if (value < 0) {
            callback(new Error("Price cannot be negetive"));
          } else {
            callback();
          }
        }
      }, 100);
    };

    var checkdis = function checkdis(rule, value, callback) {
      setTimeout(function () {
        if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(value)) {
          callback(new Error("Please input numbers"));
        } else {
          if (value < 0 || value > 100) {
            callback(new Error("Discount should be 0 to 100"));
          } else {
            callback();
          }
        }
      }, 100);
    };
    return {
      categoriesList: [],
      subcategories: {},
      category: "",
      subcategory: "",
      shoptype: "",
      shopcat: "",
      tags: [],
      shops: [],
      options: [{
        value: "Option1",
        label: "Option1"
      }, {
        value: "Option2",
        label: "Option2"
      }, {
        value: "Option3",
        label: "Option3"
      }, {
        value: "Option4",
        label: "Option4"
      }, {
        value: "Option5",
        label: "Option5"
      }],
      visible: "block",
      visible1: "none",
      visible2: "none",
      visible3: "none",
      imgfiles: [],
      otherimgs: [],
      maxFiles: 4,
      labelPosition: "",
      dis: "",
      price: "",

      loading: false,
      loading1: false,
      changed: true,

      formdata: {
        name: "",
        price: "",
        barcode: "",
        quantity: 0,
        priceList: [],
        variations: [],
        colors: [],
        expireDate: "",
        dis: "",
        disprice: "",
        brand: "",
        color: "",
        cond: "",
        type: "",
        warranty: "",
        desc: "",
        image: null,
        imageUrl: "",
        imageUrl2: "",
        imageUrl3: "",
        owner: "",
        isLoggedIn: false,
        currentUser: false,

        model: "",
        cpu: "",
        cpugen: "",
        hard: "",
        storage: "",
        ram: "",
        graphics: "",
        screen: "",
        rearcamera: "",
        frontcamera: "",
        os: "",
        battery: "",
        weight: ""
      },

      rules: {
        name: [{ required: true, message: "Please input name", trigger: "blur" }, {
          min: 3,
          max: 100,
          message: "Length should be 3 to 100",
          trigger: "blur"
        }],
        barcode: [{ required: true, message: "Please input barcode", trigger: "blur" }],
        quantity: [{ required: true, message: "Please input quantity", trigger: "blur" }, {
          min: 1,
          type: "number",
          message: "Minimum quantity is 0",
          trigger: "blur"
        }],
        price: [{ validator: checkprice, trigger: "blur" }],
        dis: [{ validator: checkdis, trigger: "blur" }],
        category: [{ message: "Please select category", trigger: "change" }],
        subcategory: [{ message: "Please select the brand", trigger: "change" }],
        model: [{ required: true, message: "Please input model", trigger: "blur" }],
        cond: [{
          required: true,
          message: "Please select condition",
          trigger: "change"
        }],
        desc: [{ message: "Please input description", trigger: "blur" }]
      }
    };
  },


  methods: {
    pickFile: function pickFile() {
      this.$refs.fileInput.click();
    },
    goback: function goback() {
      this.$router.push({
        name: "allProducts",
        params: { cat: this.$route.params.cat }
      });
    },
    fileSelect1: function fileSelect1(event) {
      var _this = this;

      //console.log('event is', event)
      if (event.target.files.length > 0) {
        var files = event.target.files;
        var filename = files[0].name;
        if (files[0].type == "image/png" || files[0].type == "image/gif" || files[0].type == "image/svg+xml" || files[0].type == "image/tiff") {
          alert("File " + files[0].name + " is not type of jpeg or jpg!. You cannot upload other types of images.");
        } else if (files[0].size > 5000200) {
          alert("File " + files[0].name + " is too large!");
        } else {
          var reader = new FileReader();
          reader.addEventListener("load", function () {
            _this.visible = "none";
            _this.formdata.imageUrl = reader.result;
            _this.visible1 = "block";
          });
          reader.readAsDataURL(files[0]);
          //this.image = files[0];
          var imageCompressor = new __WEBPACK_IMPORTED_MODULE_1_image_compressor_js__["a" /* default */]();
          imageCompressor.compress(files[0], { quality: 0.8, width: 720, height: 1340 }).then(function (result) {
            // Handle the compressed image file.
            if (result.size >= 1000000) {
              var _imageCompressor = new __WEBPACK_IMPORTED_MODULE_1_image_compressor_js__["a" /* default */]();
              _imageCompressor.compress(result, { quality: 0.6 }).then(function (result) {
                var fileReader = new FileReader();

                // This fires after the blob has been read/loaded.
                fileReader.addEventListener("load", function () {
                  _this.formdata.imageUrl = fileReader.result;

                  //console.log('image is',this.formdata.imageUrl)
                });

                // Start reading the blob as text.
                fileReader.readAsDataURL(result);

                ////console.log(filename)
                //console.log(result.size)
                //console.log('image is',result)
              });
            } else {
              var fileReader = new FileReader();
              fileReader.addEventListener("load", function () {
                _this.formdata.imageUrl = fileReader.result;

                //console.log('else image is',this.formdata.imageUrl)
              });
              fileReader.readAsDataURL(result);
              ////console.log(filename)
              //console.log('else',result.size)
              //console.log('ekse image is',result)
            }
          }).catch(function (err) {
            // Handle the error
            //console.log("error is" + err)
          });
        }
      }
    },
    otherIMG: function otherIMG(event) {
      var _this2 = this;

      var files = event.target.files;
      //console.log('files are', files)
      //  //console.log('imgfiles.length are', this.imgfiles.length)
      if (files.length > this.maxFiles || this.imgfiles.length >= this.maxFiles || files.length + this.imgfiles.length > this.maxFiles) {
        alert("You can only upload a maximum of " + this.maxFiles + " files");
        return 0;
      } else {
        for (var i = 0; i < files.length; i++) {
          if (files[0].type == "image/png" || files[0].type == "image/gif" || files[0].type == "image/svg+xml" || files[0].type == "image/tiff") {
            alert("File " + files[0].name + " is not type of jpeg or jpg!. You cannot upload other types of images.");
          } else if (files[i].size > 5000200) {
            alert("File " + files[i].name + " is too large!");
          } else {
            var reader = new FileReader();

            reader.addEventListener("load", function () {
              //   document.getElementsByClassName('image-upload-wrap').hide();
              _this2.visible = "none";
              // this.logoimg = reader.result
              _this2.visible2 = "inline";
            });
            reader.readAsDataURL(files[i]);
            //console.log('files[0]', files[i])
            var imageCompressor = new __WEBPACK_IMPORTED_MODULE_1_image_compressor_js__["a" /* default */]();
            imageCompressor.compress(files[i], { quality: 0.6, width: 720, height: 1340 }).then(function (result) {
              // Handle the compressed image file.
              if (result.size >= 1000000) {
                var _imageCompressor2 = new __WEBPACK_IMPORTED_MODULE_1_image_compressor_js__["a" /* default */]();
                _imageCompressor2.compress(result, { quality: 0.5 }).then(function (result) {
                  var fileReader = new FileReader();

                  // This fires after the blob has been read/loaded.
                  fileReader.addEventListener("load", function () {
                    _this2.imgfiles.push(fileReader.result);
                    var otherimg = fileReader.result;
                    _this2.otherimgs.push(otherimg);
                    //console.log('image is',this.otherimgs)
                  });

                  // Start reading the blob as text.
                  fileReader.readAsDataURL(result);

                  ////console.log(filename)
                  //console.log(result.size)
                  //console.log('image is',result)
                });
              } else {
                //  const reader = new FileReader();

                //     // This fires after the blob has been read/loaded.
                //     reader.addEventListener('loadend', (e) => {
                //       this.image2 = e.srcElement.result;
                //      //console.log('else image is',this.image2)
                //     });

                //     // Start reading the blob as text.
                //     reader.readAsText(result);
                var fileReader = new FileReader();
                fileReader.addEventListener("load", function () {
                  _this2.imgfiles.push(fileReader.result);
                  var otherimg = fileReader.result;
                  _this2.otherimgs.push(otherimg);
                  //console.log('else image is',this.otherimgs)
                });
                fileReader.readAsDataURL(result);
                ////console.log(filename)
                //console.log('else',result.size)
                //console.log('ekse image is',result)
              }
            }).catch(function (err) {
              // Handle the error
              //console.log("error is" + err)
            });
          }
        }
      }
    },
    removeimg: function removeimg(i) {
      if (i > -1) {
        this.otherimgs.splice(i, 1);
        this.imgfiles.splice(i, 1);
      }
      //console.log('img files is', this.imgfiles)
      //console.log('otherimg is', this.otherimgs)
    },
    checkBarcode: function checkBarcode() {
      var _this3 = this;

      if (this.formdata.barcode) {
        this.$store.state.secondaryDatabase.collection("products").where("barcode", "==", this.formdata.barcode).limit(1).get().then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            if (_this3.$route.params.product_id !== doc.id) {
              var barcode = _this3.formdata.barcode;
              _this3.formdata.barcode = "";
              return _this3.$notify.error({
                title: "Error",
                message: "Barcode " + barcode + " is already used",
                type: "error"
              });
            }
          });
        }).catch(function (error) {
          return alert(error.message);
        });
      }
    },
    updateForm: function updateForm(fdata) {
      var _this4 = this;

      this.$refs[fdata].validate(function (valid) {
        if (valid) {
          _this4.backToTop();
          _this4.loading = true;
          _this4.changed = false;
          var scope = _this4;
          if (_this4.formdata.dis != _this4.dis || _this4.formdata.price != _this4.price) {
            _this4.formdata.disprice = _this4.formdata.price;
            _this4.formdata.price = _this4.formdata.price - _this4.formdata.price * _this4.formdata.dis / 100;
          } else {
            _this4.formdata.disprice = _this4.formdata.price;
          }
          _this4.$store.state.secondaryDatabase.collection("products").doc(_this4.$route.params.product_id).update({
            name: _this4.formdata.name,
            cat: _this4.category,
            subcat: _this4.subcategory,
            price: _this4.formdata.price,
            disprice: _this4.formdata.disprice,
            barcode: _this4.formdata.barcode,
            quantity: _this4.formdata.quantity,
            priceList: _this4.formdata.priceList.map(function (price) {
              return +price;
            }),
            variations: _this4.formdata.variations,
            colors: _this4.formdata.colors,
            expireDate: _this4.formdata.expireDate ? new Date(_this4.formdata.expireDate) : "",
            dis: _this4.formdata.dis,
            brand: _this4.formdata.brand,
            color: _this4.formdata.color,
            cond: _this4.formdata.cond,
            type: _this4.formdata.type,
            war: _this4.formdata.warranty,
            desc: _this4.formdata.desc,
            img: _this4.formdata.imageUrl,
            otherimgs: _this4.otherimgs,

            details: {
              model: _this4.formdata.model,
              cpu: _this4.formdata.cpu,
              storage: _this4.formdata.storage,
              ram: _this4.formdata.ram,
              screen: _this4.formdata.screen,
              rearcamera: _this4.formdata.rearcamera,
              frontcamera: _this4.formdata.frontcamera,
              os: _this4.formdata.os,
              battery: _this4.formdata.battery,
              weight: _this4.formdata.weight,
              cpugeneration: _this4.formdata.cpugen,
              hard: _this4.formdata.hard,
              graphics: _this4.formdata.graphics
            }
          }).then(function () {
            var newitems = _this4.$store.state.items[_this4.$route.params.cat].filter(function (item) {
              //console.log('filfkkk')
              return item.id !== _this4.$route.params.product_id;
            });
            newitems.unshift({
              id: _this4.$route.params.product_id,
              name: _this4.formdata.name,
              barcode: _this4.formdata.barcode,
              quantity: _this4.formdata.quantity,
              category: _this4.category,
              subcategory: _this4.subcategory,
              price: _this4.formdata.price,
              brand: _this4.formdata.brand
              //make sure to use same property name used in store.js getItems fun
            });
            _this4.$store.state.items[_this4.$route.params.cat] = newitems;
            _this4.$router.push({
              name: "allProducts",
              params: { cat: _this4.$route.params.cat }
            });
            //console.log('prd updated')
          });
        } else {
          alert("error update");
          return false;
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    },


    backToTop: function backToTop() {
      $("html,body").stop().animate({
        scrollTop: 0
      }, "slow", "swing");
    }
  },

  created: function created() {
    var _this5 = this;

    this.backToTop();
    this.loading1 = true;
    this.changed = false;
    if (screen.width > 575) {
      this.labelPosition = "left";
    } else {
      this.labelPosition = "top";
    }
    if (__WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].auth().currentUser) {
      this.isLoggedIn = true;
      this.currentUser = __WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].auth().currentUser.email;

      //console.log(firebase.auth().currentUser.uid)
    }

    this.$store.state.secondaryDatabase.collection("shops").where("owner", "==", __WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].auth().currentUser.uid).get().then(function (querySnapshot) {
      querySnapshot.forEach(function (doc) {
        var data = {
          id: doc.id,
          categories: doc.data().categories,
          shoptype: doc.data().shoptype,
          shopcat: doc.data().cat
        };
        _this5.shops.push(data);
        _this5.shopcat = _this5.shops[0].shopcat;
        _this5.shoptype = _this5.shops[0].shoptype;
        _this5.category = _this5.$route.params.cat;
        _this5.subcategories = _this5.shops[0].categories[_this5.$route.params.cat];
        //console.log('this.subcategories is', this.subcategories)
      });
    });

    //console.log(this.$route.params.product_id)
    this.$store.state.secondaryDatabase.collection("products").doc(this.$route.params.product_id).get().then(function (doc) {
      _this5.formdata.name = doc.data().name, _this5.subcategory = doc.data().subcat, _this5.formdata.brand = doc.data().brand, _this5.formdata.price = doc.data().disprice, _this5.formdata.dis = doc.data().dis, _this5.dis = doc.data().dis, _this5.price = doc.data().disprice, _this5.formdata.barcode = doc.data().barcode, _this5.formdata.quantity = doc.data().quantity;
      _this5.formdata.priceList = doc.data().priceList;
      _this5.formdata.variations = doc.data().variations;
      _this5.formdata.colors = doc.data().colors;
      _this5.formdata.expireDate = doc.data().expireDate ? doc.data().expireDate.toDate().toLocaleString() : "";

      _this5.formdata.color = doc.data().color, _this5.formdata.cond = doc.data().cond, _this5.formdata.type = doc.data().type;
      _this5.formdata.warranty = doc.data().war, _this5.formdata.desc = doc.data().desc, _this5.formdata.imageUrl = doc.data().img;
      _this5.imgfiles = doc.data().otherimgs, _this5.otherimgs = doc.data().otherimgs, _this5.formdata.model = doc.data().details.model, _this5.formdata.cpu = doc.data().details.cpu, _this5.formdata.storage = doc.data().details.storage, _this5.formdata.ram = doc.data().details.ram, _this5.formdata.screen = doc.data().details.screen, _this5.formdata.rearcamera = doc.data().details.rearcamera, _this5.formdata.frontcamera = doc.data().details.frontcamera, _this5.formdata.os = doc.data().details.os, _this5.formdata.battery = doc.data().details.battery, _this5.formdata.weight = doc.data().details.weight, _this5.formdata.cpugen = doc.data().details.cpugeneration, _this5.formdata.hard = doc.data().details.hard, _this5.formdata.graphics = doc.data().details.graphics;

      _this5.loading1 = false;
      _this5.changed = true;
    });
  },
  mounted: function mounted() {}
});

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_image_compressor_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_FirebaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_mobiles__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_ClothingAccessories__ = __webpack_require__(27);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "editvehicles",
  data: function data() {
    var checkprice = function checkprice(rule, value, callback) {
      if (!value) {
        return callback(new Error("Please input the price"));
      }
      setTimeout(function () {
        if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(value)) {
          callback(new Error("Please input numbers"));
        } else {
          if (value < 0) {
            callback(new Error("Price cannot be negetive"));
          } else {
            callback();
          }
        }
      }, 100);
    };

    var checkdis = function checkdis(rule, value, callback) {
      setTimeout(function () {
        if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(value)) {
          callback(new Error("Please input numbers"));
        } else {
          if (value < 0 || value > 100) {
            callback(new Error("Discount should be 0 to 100"));
          } else {
            callback();
          }
        }
      }, 100);
    };
    return {
      categoriesList: [],
      subcategories: {},
      category: "",
      subcategory: "",
      tags: [],
      shops: [],
      options: [{
        value: "Option1",
        label: "Option1"
      }, {
        value: "Option2",
        label: "Option2"
      }, {
        value: "Option3",
        label: "Option3"
      }, {
        value: "Option4",
        label: "Option4"
      }, {
        value: "Option5",
        label: "Option5"
      }],
      visible: "block",
      visible1: "none",
      visible2: "none",
      visible3: "none",
      imgfiles: [],
      otherimgs: [],
      maxFiles: 4,
      labelPosition: "",
      shoptype: "",
      shopcat: "",
      dis: "",
      price: "",

      loading: false,
      loading1: false,
      changed: true,

      formdata: {
        name: "",
        price: "",
        barcode: "",
        quantity: 0,
        priceList: [],
        variations: [],
        colors: [],
        expireDate: "",
        dis: 0,
        disprice: 0,
        subcategory: "",
        brand: "",
        model: "",
        modelcode: "",
        manuyear: "",
        cond: "",
        transmission: "",
        fueltype: "",
        enginetype: "",
        enginecapacity: "",
        bodytype: "",
        mileage: "",
        color: "",
        type: "",
        warranty: "",
        desc: "",
        image: null,
        imageUrl: "",
        imageUrl2: "",
        imageUrl3: "",
        owner: "",
        isLoggedIn: false,
        currentUser: false
      },

      rules: {
        name: [{ required: true, message: "Please input name", trigger: "blur" }, {
          min: 3,
          max: 100,
          message: "Length should be 3 to 100",
          trigger: "blur"
        }],
        barcode: [{ required: true, message: "Please input barcode", trigger: "blur" }],
        quantity: [{ required: true, message: "Please input quantity", trigger: "blur" }, {
          min: 1,
          type: "number",
          message: "Minimum quantity is 0",
          trigger: "blur"
        }],
        price: [{ validator: checkprice, trigger: "blur" }],
        dis: [{ validator: checkdis, trigger: "blur" }],
        category: [{ message: "Please select category", trigger: "change" }],
        subcategory: [{ message: "Please select the make", trigger: "change" }],
        model: [{ required: true, message: "Please input model", trigger: "blur" }],
        cond: [{
          required: true,
          message: "Please select condition",
          trigger: "change"
        }],
        modelcode: [{
          required: true,
          message: "Please input model code",
          trigger: "blur"
        }],
        manuyear: [{
          required: true,
          message: "Please input manufactured year",
          trigger: "blur"
        }]
      }
    };
  },


  methods: {
    pickFile: function pickFile() {
      this.$refs.fileInput.click();
    },
    goback: function goback() {
      this.$router.push({
        name: "allProducts",
        params: { cat: this.$route.params.cat }
      });
    },
    fileSelect1: function fileSelect1(event) {
      var _this = this;

      //console.log('event is', event)
      if (event.target.files.length > 0) {
        var files = event.target.files;
        var filename = files[0].name;
        if (files[0].type == "image/png" || files[0].type == "image/gif" || files[0].type == "image/svg+xml" || files[0].type == "image/tiff") {
          alert("File " + files[0].name + " is not type of jpeg or jpg!. You cannot upload other types of images.");
        } else if (files[0].size > 5000200) {
          alert("File " + files[0].name + " is too large!");
        } else {
          var reader = new FileReader();
          reader.addEventListener("load", function () {
            _this.visible = "none";
            _this.formdata.imageUrl = reader.result;
            _this.visible1 = "block";
          });
          reader.readAsDataURL(files[0]);
          //this.image = files[0];
          var imageCompressor = new __WEBPACK_IMPORTED_MODULE_1_image_compressor_js__["a" /* default */]();
          imageCompressor.compress(files[0], { quality: 0.8, width: 720, height: 1340 }).then(function (result) {
            // Handle the compressed image file.
            if (result.size >= 1000000) {
              var _imageCompressor = new __WEBPACK_IMPORTED_MODULE_1_image_compressor_js__["a" /* default */]();
              _imageCompressor.compress(result, { quality: 0.6 }).then(function (result) {
                var fileReader = new FileReader();

                // This fires after the blob has been read/loaded.
                fileReader.addEventListener("load", function () {
                  _this.formdata.imageUrl = fileReader.result;

                  //console.log('image is',this.formdata.imageUrl)
                });

                // Start reading the blob as text.
                fileReader.readAsDataURL(result);

                ////console.log(filename)
                //console.log(result.size)
                //console.log('image is',result)
              });
            } else {
              var fileReader = new FileReader();
              fileReader.addEventListener("load", function () {
                _this.formdata.imageUrl = fileReader.result;

                //console.log('else image is',this.formdata.imageUrl)
              });
              fileReader.readAsDataURL(result);
              ////console.log(filename)
              //console.log('else',result.size)
              //console.log('ekse image is',result)
            }
          }).catch(function (err) {
            // Handle the error
            //console.log("error is" + err)
          });
        }
      }
    },
    otherIMG: function otherIMG(event) {
      var _this2 = this;

      var files = event.target.files;
      //console.log('files are', files)
      //  //console.log('imgfiles.length are', this.imgfiles.length)
      if (files.length > this.maxFiles || this.imgfiles.length >= this.maxFiles || files.length + this.imgfiles.length > this.maxFiles) {
        alert("You can only upload a maximum of " + this.maxFiles + " files");
        return 0;
      } else {
        for (var i = 0; i < files.length; i++) {
          if (files[0].type == "image/png" || files[0].type == "image/gif" || files[0].type == "image/svg+xml" || files[0].type == "image/tiff") {
            alert("File " + files[0].name + " is not type of jpeg or jpg!. You cannot upload other types of images.");
          } else if (files[i].size > 5000200) {
            alert("File " + files[i].name + " is too large!");
          } else {
            var reader = new FileReader();

            reader.addEventListener("load", function () {
              //   document.getElementsByClassName('image-upload-wrap').hide();
              _this2.visible = "none";
              // this.logoimg = reader.result
              _this2.visible2 = "inline";
            });
            reader.readAsDataURL(files[i]);
            //console.log('files[0]', files[i])
            var imageCompressor = new __WEBPACK_IMPORTED_MODULE_1_image_compressor_js__["a" /* default */]();
            imageCompressor.compress(files[i], { quality: 0.6, width: 720, height: 1340 }).then(function (result) {
              // Handle the compressed image file.
              if (result.size >= 1000000) {
                var _imageCompressor2 = new __WEBPACK_IMPORTED_MODULE_1_image_compressor_js__["a" /* default */]();
                _imageCompressor2.compress(result, { quality: 0.5 }).then(function (result) {
                  var fileReader = new FileReader();

                  // This fires after the blob has been read/loaded.
                  fileReader.addEventListener("load", function () {
                    _this2.imgfiles.push(fileReader.result);
                    var otherimg = fileReader.result;
                    _this2.otherimgs.push(otherimg);
                    //console.log('image is',this.otherimgs)
                  });

                  // Start reading the blob as text.
                  fileReader.readAsDataURL(result);

                  ////console.log(filename)
                  //console.log(result.size)
                  //console.log('image is',result)
                });
              } else {
                //  const reader = new FileReader();

                //     // This fires after the blob has been read/loaded.
                //     reader.addEventListener('loadend', (e) => {
                //       this.image2 = e.srcElement.result;
                //      //console.log('else image is',this.image2)
                //     });

                //     // Start reading the blob as text.
                //     reader.readAsText(result);
                var fileReader = new FileReader();
                fileReader.addEventListener("load", function () {
                  _this2.imgfiles.push(fileReader.result);
                  var otherimg = fileReader.result;
                  _this2.otherimgs.push(otherimg);
                  //console.log('else image is',this.otherimgs)
                });
                fileReader.readAsDataURL(result);
                ////console.log(filename)
                //console.log('else',result.size)
                //console.log('ekse image is',result)
              }
            }).catch(function (err) {
              // Handle the error
              //console.log("error is" + err)
            });
          }
        }
      }
    },
    removeimg: function removeimg(i) {
      if (i > -1) {
        this.otherimgs.splice(i, 1);
        this.imgfiles.splice(i, 1);
      }
      //console.log('img files is', this.imgfiles)
      //console.log('otherimg is', this.otherimgs)
    },
    checkBarcode: function checkBarcode() {
      var _this3 = this;

      if (this.formdata.barcode) {
        this.$store.state.secondaryDatabase.collection("products").where("barcode", "==", this.formdata.barcode).limit(1).get().then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            if (_this3.$route.params.product_id !== doc.id) {
              var barcode = _this3.formdata.barcode;
              _this3.formdata.barcode = "";
              return _this3.$notify.error({
                title: "Error",
                message: "Barcode " + barcode + " is already used",
                type: "error"
              });
            }
          });
        }).catch(function (error) {
          return alert(error.message);
        });
      }
    },
    updateForm: function updateForm(fdata) {
      var _this4 = this;

      this.$refs[fdata].validate(function (valid) {
        if (valid) {
          _this4.backToTop();
          _this4.loading = true;
          _this4.changed = false;
          var scope = _this4;
          if (_this4.formdata.dis != _this4.dis || _this4.formdata.price != _this4.price) {
            _this4.formdata.disprice = _this4.formdata.price;
            _this4.formdata.price = _this4.formdata.price - _this4.formdata.price * _this4.formdata.dis / 100;
          } else {
            _this4.formdata.disprice = _this4.formdata.price;
          }
          _this4.$store.state.secondaryDatabase.collection("products").doc(_this4.$route.params.product_id).update({
            name: _this4.formdata.name,
            cat: _this4.category,
            subcat: _this4.subcategory,
            price: _this4.formdata.price,
            dis: _this4.formdata.dis,
            disprice: _this4.formdata.disprice,
            barcode: _this4.formdata.barcode,
            quantity: _this4.formdata.quantity,
            priceList: _this4.formdata.priceList.map(function (price) {
              return +price;
            }),
            variations: _this4.formdata.variations,
            colors: _this4.formdata.colors,
            expireDate: _this4.formdata.expireDate ? new Date(_this4.formdata.expireDate) : "",
            brand: _this4.formdata.brand,
            color: _this4.formdata.color,
            cond: _this4.formdata.cond,
            type: _this4.formdata.type,
            war: _this4.formdata.warranty,
            desc: _this4.formdata.desc,
            img: _this4.formdata.imageUrl,
            otherimgs: _this4.otherimgs,

            details: {
              model: _this4.formdata.model,
              modelcode: _this4.formdata.modelcode,
              year: _this4.formdata.manuyear,
              transmission: _this4.formdata.transmission,
              fueltype: _this4.formdata.fueltype,
              enginetype: _this4.formdata.enginetype,
              enginecapacity: _this4.formdata.enginecapacity,
              bodytype: _this4.formdata.bodytype,
              mileage: _this4.formdata.mileage
            }
          }).then(function () {
            var newitems = _this4.$store.state.items[_this4.$route.params.cat].filter(function (item) {
              //console.log('filfkkk')
              return item.id !== _this4.$route.params.product_id;
            });
            newitems.unshift({
              id: _this4.$route.params.product_id,
              name: _this4.formdata.name,
              barcode: _this4.formdata.barcode,
              quantity: _this4.formdata.quantity,
              category: _this4.category,
              subcategory: _this4.subcategory,
              price: _this4.formdata.price,
              brand: _this4.formdata.brand
              //make sure to use same property name used in store.js getItems fun
            });
            _this4.$store.state.items[_this4.$route.params.cat] = newitems;
            _this4.$router.push({
              name: "allProducts",
              params: { cat: _this4.$route.params.cat }
            });
            //console.log('prd updated')
          });
        } else {
          alert("error update");
          return false;
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    },


    backToTop: function backToTop() {
      $("html,body").stop().animate({
        scrollTop: 0
      }, "slow", "swing");
    }
  },

  created: function created() {
    var _this5 = this;

    this.backToTop();
    this.loading1 = true;
    this.changed = false;
    if (screen.width > 575) {
      this.labelPosition = "left";
    } else {
      this.labelPosition = "top";
    }
    if (__WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].auth().currentUser) {
      this.isLoggedIn = true;
      this.currentUser = __WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].auth().currentUser.email;

      //console.log(firebase.auth().currentUser.uid)
    }

    this.$store.state.secondaryDatabase.collection("shops").where("owner", "==", __WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].auth().currentUser.uid).get().then(function (querySnapshot) {
      querySnapshot.forEach(function (doc) {
        var data = {
          id: doc.id,
          categories: doc.data().categories,
          shoptype: doc.data().shoptype,
          shopcat: doc.data().cat
        };
        _this5.shops.push(data);
        _this5.shopcat = _this5.shops[0].shopcat;
        _this5.shoptype = _this5.shops[0].shoptype;
        _this5.category = _this5.$route.params.cat;
        _this5.subcategories = _this5.shops[0].categories[_this5.$route.params.cat];
        //console.log('this.subcategories is', this.subcategories)
      });
    });

    //console.log(this.$route.params.product_id)
    this.$store.state.secondaryDatabase.collection("products").doc(this.$route.params.product_id).get().then(function (doc) {
      _this5.formdata.name = doc.data().name, _this5.subcategory = doc.data().subcat, _this5.formdata.brand = doc.data().brand, _this5.formdata.price = doc.data().disprice, _this5.formdata.dis = doc.data().dis, _this5.dis = doc.data().dis, _this5.price = doc.data().disprice, _this5.formdata.barcode = doc.data().barcode, _this5.formdata.quantity = doc.data().quantity;
      _this5.formdata.priceList = doc.data().priceList;
      _this5.formdata.variations = doc.data().variations;
      _this5.formdata.colors = doc.data().colors;
      _this5.formdata.expireDate = doc.data().expireDate ? doc.data().expireDate.toDate().toLocaleString() : "";

      _this5.formdata.color = doc.data().color, _this5.formdata.cond = doc.data().cond, _this5.formdata.type = doc.data().type, _this5.formdata.warranty = doc.data().war, _this5.formdata.desc = doc.data().desc, _this5.formdata.imageUrl = doc.data().img;
      _this5.imgfiles = doc.data().otherimgs, _this5.otherimgs = doc.data().otherimgs, _this5.formdata.model = doc.data().details.model, _this5.formdata.modelcode = doc.data().details.modelcode, _this5.formdata.manuyear = doc.data().details.year, _this5.formdata.cond = doc.data().details.cond, _this5.formdata.transmission = doc.data().details.transmission, _this5.formdata.fueltype = doc.data().details.fueltype, _this5.formdata.enginetype = doc.data().details.enginetype, _this5.formdata.enginecapacity = doc.data().details.enginecapacity, _this5.formdata.bodytype = doc.data().details.bodytype, _this5.formdata.mileage = doc.data().details.mileage;

      _this5.loading1 = false;
      _this5.changed = true;
    });
  },
  mounted: function mounted() {}
});

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Admin__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_image_compressor_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_FirebaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_app__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "offers",
  components: {
    AdminPanel: __WEBPACK_IMPORTED_MODULE_0__Admin__["a" /* default */]
  },
  data: function data() {
    return {
      cat: "",
      dis: "",
      visible: "block",
      visible1: "none",
      imageUrl: "",
      image1: "",
      desc: "",
      modalShow: false,
      modalShow2: false,
      shops: [],
      loading: false,
      loading1: false,
      changed: false
    };
  },
  created: function created() {
    var _this = this;

    this.backToTop();
    this.loading = true;
    this.changed = false;
    this.$store.state.secondaryDatabase.collection("shops").where("owner", "==", __WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].auth().currentUser.uid).get().then(function (querySnapshot) {
      querySnapshot.forEach(function (doc) {
        var data = {
          id: doc.id,
          shoptype: doc.data().shoptype,
          curOffers: doc.data().curOffers,
          plan: doc.data().plan
        };
        _this.shops.push(data);
        _this.loading = false;
        _this.changed = true;
      });
    });
  },

  methods: {
    backToTop: function backToTop() {
      $("html,body").stop().animate({
        scrollTop: 0
      }, "fast", "swing");
    },
    addOffer: function addOffer() {
      var _this2 = this;

      this.loading1 = true;
      this.changed = false;
      var maxOffers;
      if (this.shops[0].plan == "Starter") {
        maxOffers = 10;
      } else {
        maxOffers = 20;
      }
      if (this.shops[0].curOffers < maxOffers) {
        //console.log('uid',firebase.auth().currentUser.uid)
        this.$store.state.secondaryDatabase.collection("offers").add({
          img: this.image1,
          dis: this.dis,
          desc: this.desc,
          owner: __WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].auth().currentUser.uid
          //shopID: this.shops[0].id
        }).then(function (doc) {
          //console.log('doc is', doc)
          // this.modalShow = true
          _this2.shops[0].curOffers += 1;
          _this2.$store.state.secondaryDatabase.collection("shops").doc(_this2.shops[0].id).update({
            curOffers: _this2.shops[0].curOffers
          }).then(function (doc) {
            //console.log('doc is', doc)
            _this2.loading1 = false;
            _this2.changed = true;
            _this2.modalShow = true;
          });
        }).catch(function (error) {
          return alert(error);
        });
      } else {
        this.loading1 = false;
        this.changed = true;
        this.modalShow2 = true;
      }
    },
    fileSelect1: function fileSelect1(event) {
      var _this3 = this;

      //console.log('event is', event)
      var files = event.target.files;
      var filename = files[0].name;
      if (files[0].type == "image/png" || files[0].type == "image/gif" || files[0].type == "image/svg+xml" || files[0].type == "image/tiff") {
        alert("File " + files[0].name + " is not type of jpeg or jpg!. You cannot upload other types of images.");
      } else if (files[0].size > 5000200) {
        alert("File " + files[0].name + " is too large!");
      } else {
        var reader = new FileReader();
        reader.addEventListener("load", function () {
          _this3.visible = "none";
          _this3.imageUrl = reader.result;
          _this3.visible1 = "block";
        });
        reader.readAsDataURL(files[0]);
        //this.image = files[0];
        var imageCompressor = new __WEBPACK_IMPORTED_MODULE_1_image_compressor_js__["a" /* default */]();
        imageCompressor.compress(files[0], { quality: 0.6, width: 720, height: 1340 }).then(function (result) {
          // Handle the compressed image file.
          if (result.size >= 1000000) {
            var _imageCompressor = new __WEBPACK_IMPORTED_MODULE_1_image_compressor_js__["a" /* default */]();
            _imageCompressor.compress(result, { quality: 0.5 }).then(function (result) {
              var fileReader = new FileReader();

              // This fires after the blob has been read/loaded.
              fileReader.addEventListener("load", function () {
                _this3.image1 = fileReader.result;

                //console.log('image is',this.image1)
              });

              // Start reading the blob as text.
              fileReader.readAsDataURL(result);

              ////console.log(filename)
              //console.log(result.size)
              //console.log('image is',result)
            });
          } else {
            var fileReader = new FileReader();
            fileReader.addEventListener("load", function () {
              _this3.image1 = fileReader.result;

              //console.log('else image is',this.image1)
            });
            fileReader.readAsDataURL(result);
            ////console.log(filename)
            //console.log('else',result.size)
            //console.log('ekse image is',result)
          }
        }).catch(function (err) {
          // Handle the error
          //console.log("error is" + err)
        });
      }
    }
  }
});

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AdminFooter__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_FirebaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_mobiles__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_ClothingAccessories__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Dashboard__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_admin_js_fastclick_js__ = __webpack_require__(772);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








// import "../../assets/admin/js/detect.js";

// import "../../assets/admin/js/pikeadmin.js";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "admin",
  components: {
    Dashboard: __WEBPACK_IMPORTED_MODULE_5__Dashboard__["a" /* default */],
    AdminFooter: __WEBPACK_IMPORTED_MODULE_0__AdminFooter__["a" /* default */]
  },
  data: function data() {
    return {
      show: true,
      show2: false,
      toggleCat: false,
      isLoggedIn: false,
      currentUser: false,
      categoriesList: [],
      subcategories: [],
      category: '',
      subcategory: '',
      shops: [],
      notices: [],
      storeid: '',
      shopcats: {},
      title: '',
      msg: "",
      modalShow1: false,
      showLSB: true,
      enlarged: '',
      plan: '',
      shopcategory: '',
      loading: false,
      fetch: true

    };
  },


  watch: {
    $route: function $route() {
      if (this.$route.fullPath == '/admin/' || this.$route.fullPath == '/admin') {
        this.show = true;
      }
    },
    show: function show() {
      //console.log('show is', this.show)
    }
  },

  methods: {
    toggle: function toggle() {
      if (this.toggleCat) {
        this.toggleCat = false;
      } else if (!this.toggleCat) {
        this.toggleCat = true;
      }
    },
    hideLSB: function hideLSB() {
      //console.log("screen.width",screen.width)
      this.show = false;
      if (screen.width < 1290) {
        //console.log('this.showLSB',this.showLSB)
        this.showLSB = false;
        this.enlarged = 'right-bar-enabled';
        //console.log('this.showLSB',this.showLSB)
      }
    },
    LSB: function LSB() {
      //console.log('this.showLSB',this.showLSB) 
      if (this.showLSB) {
        this.showLSB = false;
        this.enlarged = 'right-bar-enabled';
        //console.log('this.showLSB',this.showLSB)
      } else {
        this.showLSB = true;
        this.enlarged = '';
        //console.log('this.showLSB',this.showLSB)
      }
    },
    showMsg: function showMsg(tit, msg) {
      this.title = tit;
      this.msg = msg;
      this.modalShow1 = true;
    },
    delMsg: function delMsg() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2__config_FirebaseInit__["a" /* default */].collection("shops").doc(this.shops[0].id).collection('notify').get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          //console.log('doc id',doc.id)
          __WEBPACK_IMPORTED_MODULE_2__config_FirebaseInit__["a" /* default */].collection("shops").doc(_this.shops[0].id).collection('notify').doc(doc.id).delete().then(function () {
            //console.log('msg deleted')
          }).catch(function (error) {
            return alert(error);
          });
        });
      }).then(function () {
        _this.notices = [];
      });
    },
    logout: function logout() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().signOut().then(function () {
        _this2.$router.push('/');
      });
    }
  },
  mounted: function mounted() {
    if (this.$route.fullPath == '/admin/' || this.$route.fullPath == '/admin') {
      this.show = true;
    }
  },
  created: function created() {
    var _this3 = this;

    //console.log('route is', this.$route)
    this.loading = true;
    this.fetch = false;
    if (this.$route.fullPath != '/admin/' || this.$route.fullPath != '/admin') {
      this.show = false;
    }

    if (__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser) {
      this.isLoggedIn = true;
      this.currentUser = __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.email;
      this.storeid = __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.uid;
      //console.log(firebase.auth().currentUser.uid)

      try {
        __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].app(__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.uid);
        this.$store.state.secondaryDatabase = __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].app(__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.uid).firestore();
        this.show2 = true;
        //console.log('secondaryDB Exsits', this.$store.state.secondaryDatabase)
      } catch (err) {
        __WEBPACK_IMPORTED_MODULE_2__config_FirebaseInit__["a" /* default */].collection('shops').where('owner', '==', __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.uid).get().then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            var data = {
              'id': doc.id,
              'shoptype': doc.data().shoptype,
              'categories': doc.data().categories,
              'name': doc.data().name,
              'plan': doc.data().plan,
              'shopcat': doc.data().cat,
              'config': doc.data().config

            };
            _this3.shops.push(data);
          });
        }).then(function () {
          //console.log('this.shops[0].config', this.shops[0].config)
          if (!doc.data().noDB) {
            // having own db
            if (_this3.shops[0].config) {
              //console.log('config', this.shops[0].config)
              var secondaryAppConfig = _this3.shops[0].config;
              var secondary = __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].initializeApp(secondaryAppConfig, __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.uid);
              _this3.$store.state.secondaryDatabase = secondary.firestore();
              // this.$store.state.secondaryApp = this.$route.params.storename
              _this3.$store.state.secondaryDatabase.settings({ timestampsInSnapshots: true });
              _this3.$store.state.secondaryDatabase.enablePersistence({ experimentalTabSynchronization: true }).then(function () {
                //console.log("Woohoo! Multi-Tab Persistence!");
              });
              _this3.show2 = true;
              //console.log('secondaryDB', this.$store.state.secondaryDatabase)
            }
          } else {
            //console.log('shop config', this.shops[0].config)
            _this3.$store.state.secondaryDatabase = __WEBPACK_IMPORTED_MODULE_2__config_FirebaseInit__["a" /* default */];
            _this3.show2 = true;
          }
        });
      }

      __WEBPACK_IMPORTED_MODULE_2__config_FirebaseInit__["a" /* default */].collection('shops').where('owner', '==', __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.uid).get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          var data = {
            'id': doc.id,
            'shoptype': doc.data().shoptype,
            'categories': doc.data().categories,
            'name': doc.data().name,
            'plan': doc.data().plan,
            'shopcat': doc.data().cat,
            'config': doc.data().config

          };
          _this3.shops.push(data);
          _this3.plan = _this3.shops[0].plan;
          if (_this3.shops[0].shopcat == 'Vehicles') {
            _this3.shopcategory = _this3.shops[0].shopcat;
          }

          _this3.shopcats = _this3.shops[0].categories;
          //console.log(this.shops[0].id)
          //console.log(this.shops[0].categories)
        });
        _this3.loading = false;
        _this3.fetch = true;
      }).then(function () {
        //console.log('this.notices')
        __WEBPACK_IMPORTED_MODULE_2__config_FirebaseInit__["a" /* default */].collection('shops').doc(_this3.shops[0].id).collection('notify').get().then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            var notice = {
              'title': doc.data().notice.title,
              'msg': doc.data().notice.msg };
            _this3.notices.push(notice);
            //console.log(this.notices)
          });
        });
      });
    }

    this.$nextTick(function () {
      var resizefunc = [];

      //   $(document).ready(function() {
      //     $(function() {
      //       $(".nicescroll").niceScroll({ cursorcolor: "#858586" });
      //     });
      //   });

      !function ($) {
        "use strict";

        var Sidemenu = function Sidemenu() {
          this.$body = $("body"), this.$openLeftBtn = $(".open-left"), this.$menuItem = $("#sidebar-menu a");
        };
        Sidemenu.prototype.openLeftBar = function () {
          $("#main").toggleClass("enlarged");
          $("#main").addClass("forced");

          if ($("#main").hasClass("enlarged") && $("body").hasClass("adminbody")) {
            $("body").removeClass("adminbody").addClass("adminbody-void");
          } else if (!$("#main").hasClass("enlarged") && $("body").hasClass("adminbody-void")) {
            $("body").removeClass("adminbody-void").addClass("adminbody");
          }

          if ($("#main").hasClass("enlarged")) {
            $(".left ul").removeAttr("style");
          } else {
            $(".subdrop").siblings("ul:first").show();
          }
        },
        //menu item click
        Sidemenu.prototype.menuItemClick = function (e) {
          if (!$("#main").hasClass("enlarged")) {
            if ($(this).parent().hasClass("submenu")) {}
            if (!$(this).hasClass("subdrop")) {
              // hide any open menus and remove all other classes
              $("ul", $(this).parents("ul:first")).slideUp(350);
              $("a", $(this).parents("ul:first")).removeClass("subdrop");
              $("#sidebar-menu .pull-right i").removeClass("md-remove").addClass("md-add");

              // open our new menu and add the open class
              $(this).next("ul").slideDown(350);
              $(this).addClass("subdrop");
              $(".pull-right i", $(this).parents(".submenu:last")).removeClass("md-add").addClass("md-remove");
              $(".pull-right i", $(this).siblings("ul")).removeClass("md-remove").addClass("md-add");
            } else if ($(this).hasClass("subdrop")) {
              $(this).removeClass("subdrop");
              $(this).next("ul").slideUp(350);
              $(".pull-right i", $(this).parent()).removeClass("md-remove").addClass("md-add");
            }
          }
        },
        //init sidemenu
        Sidemenu.prototype.init = function () {
          var $this = this;

          // var ua = navigator.userAgent,
          //   event = ua.match(/iP/i) ? "touchstart" : "click";

          //bind on click
          // this.$openLeftBtn.on(event, function(e) {
          //   e.stopPropagation();
          //   $this.openLeftBar();
          // });

          // LEFT SIDE MAIN NAVIGATION
          // $this.$menuItem.on(event, $this.menuItemClick);

          // NAVIGATION HIGHLIGHT & OPEN PARENT
          $("#sidebar-menu ul li.submenu a.active").parents("li:last").children("a:first").addClass("active").trigger("click");
        },
        // init Sidemenu
        $.Sidemenu = new Sidemenu(), $.Sidemenu.Constructor = Sidemenu;
      }(window.jQuery),
      //main app module
      function ($) {
        "use strict";

        var App = function App() {
          this.pageScrollElement = "html, body", this.$body = $("body");
        };

        //on doc load
        App.prototype.onDocReady = function (e) {
          FastClick.attach(document.body);
          resizefunc.push("changeptype");

          $(".animate-number").each(function () {
            $(this).animateNumbers($(this).attr("data-value"), true, parseInt($(this).attr("data-duration")));
          });

          //RUN RESIZE ITEMS
          // $(window).resize(debounce(resizeitems, 100));
          // $("body").trigger("resize");

          // right side-bar toggle
          $(".right-bar-toggle").on("click", function (e) {
            $("#main").toggleClass("right-bar-enabled");
          });
        },
        //initilizing
        App.prototype.init = function () {
          var $this = this;
          $(document).ready($this.onDocReady);
          $.Sidemenu.init();
        }, $.App = new App(), $.App.Constructor = App;
      }(window.jQuery),
      //initializing main application module
      function ($) {
        "use strict";

        $.App.init();
      }(window.jQuery);

      function executeFunctionByName(functionName, context) {
        var args = [].slice.call(arguments).splice(2);
        var namespaces = functionName.split(".");
        var func = namespaces.pop();
        for (var i = 0; i < namespaces.length; i++) {
          context = context[namespaces[i]];
        }
        return context[func].apply(this, args);
      }
      var w, h, dw, dh;
      var changeptype = function changeptype() {
        w = $(window).width();
        h = $(window).height();
        dw = $(document).width();
        dh = $(document).height();

        if (jQuery.browser.mobile === true) {
          $("body").addClass("mobile").removeClass("adminbody");
        }

        if (!$("#main").hasClass("forced")) {
          if (w > 990) {
            $("body").removeClass("smallscreen").addClass("widescreen");
            $("#main").removeClass("enlarged");
          } else {
            $("body").removeClass("widescreen").addClass("smallscreen");
            $("#main").addClass("enlarged");
            $(".left ul").removeAttr("style");
          }
          if ($("#main").hasClass("enlarged") && $("body").hasClass("adminbody")) {
            $("body").removeClass("adminbody").addClass("adminbody-void");
          } else if (!$("#main").hasClass("enlarged") && $("body").hasClass("adminbody-void")) {
            $("body").removeClass("adminbody-void").addClass("adminbody");
          }
        }
      };

      var debounce = function debounce(func, wait, immediate) {
        var timeout, result;
        return function () {
          var context = this,
              args = arguments;
          var later = function later() {
            timeout = null;
            if (!immediate) result = func.apply(context, args);
          };
          var callNow = immediate && !timeout;
          clearTimeout(timeout);
          timeout = setTimeout(later, wait);
          if (callNow) result = func.apply(context, args);
          return result;
        };
      };

      //   function resizeitems() {
      //     if ($.isArray(resizefunc)) {
      //       for (i = 0; i < resizefunc.length; i++) {
      //         window[resizefunc[i]]();
      //       }
      //     }
      //   }
    });
  }
});

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminFooter_vue__ = __webpack_require__(235);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a331e19a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminFooter_vue__ = __webpack_require__(712);
function injectStyle (ssrContext) {
  __webpack_require__(711)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a331e19a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a331e19a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "adminfooter",
  data: function data() {
    return {
      isVisible: false
    };
  }
});

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_FirebaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_easyinvoice__ = __webpack_require__(730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_easyinvoice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_easyinvoice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Charts_BarChart_vue__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__InvoiceTemplates_OrderPrint_vue__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__data_shops__ = __webpack_require__(201);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







// import Vue from "vue";
// import "hchs-vue-charts";
// import "chart.js";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "dashboard",
  components: {
    BarChart: __WEBPACK_IMPORTED_MODULE_6__Charts_BarChart_vue__["a" /* default */],
    OrderPrint: __WEBPACK_IMPORTED_MODULE_7__InvoiceTemplates_OrderPrint_vue__["a" /* default */]
  },
  data: function data() {
    return {
      shops: [],
      plan: "",
      cat: "",
      items: "",
      curProducts: "",
      maxProducts: "",
      curOffers: "",
      visits: "",
      orders: "",
      cus: "",
      invoices: 0,
      totalSales: 0,
      totalDue: 0,
      salesToday: 0,
      profitToday: 0,
      showchart: false,
      loading: false,
      changed: true,
      width: 300,
      height: 400,
      mylabels: [],
      mydata: [],
      offset: 4,
      emptyText: "Loading Records...",
      lowStockEmptyText: "No Records",
      invoiceItems: [],
      invoicecurrentPage: 1,
      invoiceperPage: 10,
      invoicetotalRows: 0,
      pageOptions: ["Per Page", 5, 10, 15],
      sortBy: null,
      sortDesc: false,
      filter: null,
      filterLowItem: null,
      storeData: null,
      reportData: null,
      dailyData: null,
      lowItemscurrentPage: 1,
      lowItemsperPage: 10,
      lowStockItems: [],
      lowItemstotalRows: 0,
      lowItemsFields: [{ key: "store", label: "Store", sortable: true }, { key: "name", label: "Name", sortable: true }, { key: "barcode", label: "Barcode", sortable: true }, { key: "purcPr", label: "Purchased Price", sortable: true }, { key: "qty", label: "Quantity", sortable: true }],
      invoiceFields: ["index",
      //  { key: 'id', label: 'Order id', sortable: true },
      { key: "date", label: "Date", sortable: true }, { key: "invoiceNo", label: "Invoice No", sortable: true },
      // { key: "storeLocation", label: "Store" },
      { key: "customer", label: "Customer", sortable: true }, { key: "netAmount", label: "Net Amount", sortable: true }, { key: "actions", label: "Actions" }],
      invoiceProductsFields: ["index", { key: "name", label: "Name", sortable: true }, { key: "barcode", label: "Barcode", sortable: true }, { key: "category", label: "Category", sortable: true }, { key: "subcategory", label: "Sub Category", sortable: true }, { key: "quantity", label: "Quantity", sortable: true }, { key: "price", label: "Price", sortable: true }, { key: "discount", label: "Discount", sortable: true }, { key: "subTotal", label: "Sub Total", sortable: true }],

      ordersItems: [],
      ordersFields: ["index", { key: 'orderNo', label: 'Order No', sortable: true }, { key: "cusname", label: "Customer", sortable: true }, { key: "date", label: "Date", sortable: true }, { key: "cusemail", label: "Email", sortable: true }, { key: "telno", label: "Tel No" }, { key: "total", label: "Total (RS)", sortable: true }, { key: "status", label: "Status", sortable: true }, { key: "actions", label: "Actions" }],
      options: [{
        value: "Pending",
        label: "Pending"
      }, {
        value: "Processing",
        label: "Processing"
      }, {
        value: "Completed",
        label: "Completed"
      }, {
        value: "Cancelled",
        label: "Cancelled"
      }],
      orderscurrentPage: 1,
      ordersperPage: 10,
      orderstotalRows: 0,

      mydatasets: [{
        data: [],
        backgroundColor: ["#04B404", "#FF8000", "#FA5858", "#FA5882", "#F781BE", "#2E9AFE", "#FF0040", "#A901DB", "#81F781", "#FF00BF", "#2EFEF7", "#0101DF", "#80FF00", "#B40404", "#81DAF5", "#FF6384", "#36A2EB", "#FFCE56"],
        hoverBackgroundColor: ["#D8D8D8", "#D8D8D8", "#D8D8D8", "#D8D8D8", "#D8D8D8", "#D8D8D8", "#D8D8D8", "#D8D8D8", "#D8D8D8", "#D8D8D8", "#D8D8D8", "#D8D8D8", "#D8D8D8", "#D8D8D8", "#D8D8D8", "#D8D8D8", "#D8D8D8", "#D8D8D8"]
      }]
      // new data for pos
    };
  },


  computed: {
    sortOptions: function sortOptions() {
      // Create an options list from our fields
      return this.invoiceFields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return { text: f.label, value: f.key };
      });
    },
    lowItemssortOptions: function lowItemssortOptions() {
      // Create an options list from our fields
      return this.lowItemsFields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return { text: f.label, value: f.key };
      });
    },
    ordersSortOptions: function ordersSortOptions() {
      // Create an options list from our fields
      return this.ordersFields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return { text: f.label, value: f.key };
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$root.$on("storeChange", function (store) {
      _this.$store.state.selectedStore = store;
      _this.loading = true;
      _this.changed = false;
      _this.getInvoices();
      _this.getReport();
      _this.getStoreData("update");
      // this.getDailyData();
    });
  },
  created: function created() {
    var _this2 = this;

    if (screen.width <= 992) this.offset = 0;
    if (screen.width < 1200 && screen.width > 992) this.offset = 2;
    if (screen.width > 575) {
      this.width = 250, this.height = 350;
    }
    this.changed = false;
    this.loading = true;

    this.$store.state.prdNameList.forEach(function (prd) {
      if (prd.lowStock && prd.lowStock.length > 0) {
        prd.lowStock.forEach(function (item) {
          _this2.lowStockItems.push({
            name: prd.name,
            barcode: prd.barcode,
            purcPr: item.purcPr,
            qty: item.qty,
            store: _this2.$store.state.stores.find(function (str) {
              return str.id == item.store;
            }).name
          });
        });
        _this2.lowItemstotalRows = _this2.lowStockItems.length;
      }
    });

    this.getStoreData();
    // this.getDailyData();
    this.getReport();

    this.$store.state.secondaryDatabase.collection("shops").where("owner", "==", __WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].auth().currentUser.uid).get().then(function (querySnapshot) {
      querySnapshot.forEach(function (doc) {
        var data = {
          id: doc.id,
          plan: doc.data().plan,
          cat: doc.data().cat,
          curOffers: doc.data().curOffers,
          curProducts: doc.data().curProducts,
          maxProducts: doc.data().maxProducts,
          visits: doc.data().visits,
          orders: doc.data().orders,
          catValues: doc.data().catValues,
          cus: doc.data().cus,
          invoices: doc.data().invo,
          netPay: doc.data().netPay,
          totalRemain: doc.data().totalRemain
        };
        _this2.shops.push(data);
        _this2.orders = _this2.shops[0].orders;
        _this2.curProducts = _this2.shops[0].curProducts;
        _this2.maxProducts = _this2.shops[0].maxProducts;
        _this2.curOffers = _this2.shops[0].curOffers;
        _this2.visits = _this2.shops[0].visits;
        _this2.cus = _this2.shops[0].cus;
        _this2.plan = _this2.shops[0].plan;
        _this2.cat = _this2.shops[0].cat;
        _this2.invoices = _this2.shops[0].invoices ? _this2.shops[0].invoices : 0;
        _this2.totalSales = _this2.shops[0].netPay ? _this2.shops[0].netPay : 0;
        _this2.totalDue = _this2.shops[0].totalRemain ? _this2.shops[0].totalRemain : 0;
        _this2.mylabels = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(_this2.shops[0].catValues);
        _this2.mydatasets[0]["data"] = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(_this2.shops[0].catValues).map(function (k) {
          return _this2.shops[0].catValues[k];
        });
        //console.log('this.mylabels',this.mylabels)
        //console.log('this.mydata',this.mydatasets[0]['data'])
        _this2.showchart = true;
        //console.log(this.cat)
        if (_this2.cat == "Vehicles") {
          _this2.items = 5;
        } else {
          //console.log(this.cat, this.items)
          _this2.items = 10;
          //console.log(this.cat, this.items)
        }
      });

      _this2.getInvoices();

      var docRef = _this2.$store.state.secondaryDatabase.collection("orders");
      var firestoreQuery = docRef;
      if (_this2.$store.state.noDB === true) {
        firestoreQuery = firestoreQuery.where("shopid", "==", __WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].auth().currentUser.uid);
      }
      firestoreQuery
      // .where("shopid", "==", firebase.auth().currentUser.uid)
      .orderBy("date", "desc").limit(10).get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          var data = {
            id: doc.id,
            orderNo: doc.data().orderNo,
            cusname: doc.data().uname,
            telno: doc.data().telno,
            address: doc.data().address,
            date: doc.data().date.toDate().toLocaleString(),
            cusemail: doc.data().uemail,
            products: doc.data().products,
            total: doc.data().total,
            status: doc.data().status,
            refid: doc.data().refid
          };
          _this2.ordersItems.push(data);
          _this2.orderstotalRows = _this2.ordersItems.length;
        });
        if (_this2.ordersItems.length == 0) {
          _this2.emptyText = "There are no records to show";
        }
        _this2.loading = false;
        _this2.changed = true;
      }).catch(function (error) {
        return alert(error);
      });
    }).catch(function (error) {
      return alert(error);
    });

    // for (let i = 1; i <= 10; i++) {
    //   const dto = {};
    //   this.$store.state.secondaryDatabase
    //     .collection("test")
    //     .doc(`${Math.floor(Math.random() * 10000001).toString()}`)
    //     .set(dto)
    //     .then((doc) => {
    //       if (doc.exists) {
    //         const bytes = sizeof(doc.data());
    //         console.log("size of doc", bytes);
    //       } else {
    //         // doc.data() will be undefined in this case
    //         console.log("No such document!");
    //       }
    //     })
    //     .catch((error) => {
    //       console.log("Error getting document:", error);
    //     });
    // }

    // Pass an options object with `eventBus: true` to receive an eventBus back
    // which emits `start` and `finish` events
  },


  methods: {
    onFiltered: function onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    onComplete: function onComplete() {
      this.$router.push("/admin/setting");
    },
    getInvoices: function getInvoices() {
      var _this3 = this;

      this.invoiceItems = [];
      this.salesToday = 0;
      this.profitToday = 0;
      var start = new Date();
      start.setHours(0, 0, 0, 0);
      // console.log(start);

      var end = new Date();
      end.setHours(23, 59, 59, 999);
      // console.log(end);
      this.$store.state.secondaryDatabase.collection("invoices").where("date", ">=", __WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].firestore.Timestamp.fromDate(start)).where("date", "<=", __WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].firestore.Timestamp.fromDate(end)).where("storeLocation", "==", this.$store.state.selectedStore).orderBy("date", "desc").get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          var data = {
            id: doc.id,
            products: doc.data().products,
            date: doc.data().date.toDate().toLocaleString(),
            invoiceNo: doc.data().invoiceNo,
            storeLocation: doc.data().storeLocation,
            cashier: doc.data().cashier,
            customer: doc.data().customer,
            customerMobile: doc.data().customerMobile,
            grossAmount: doc.data().grossAmount,
            discount: doc.data().discount,
            otherDiscount: doc.data().otherDiscount,
            tax: doc.data().tax,
            sCharge: doc.data().sCharge,
            taxMode: doc.data().taxMode || "Percentage",
            serviceChargeMode: doc.data().serviceChargeMode || "Percentage",
            netAmount: doc.data().netAmount,
            cardPayment: doc.data().cardPayment,
            cashPayment: doc.data().cashPayment,
            chequePayment: doc.data().chequePayment,
            balance: doc.data().balance,
            profit: doc.data().profit
          };
          _this3.salesToday += data.netAmount;
          _this3.profitToday += data.profit;
          _this3.invoiceItems.push(data);
          _this3.invoicetotalRows = _this3.invoiceItems.length;
        });
        if (_this3.invoiceItems.length == 0) {
          _this3.emptyText = "There are no records to show";
        }
      }).catch(function (error) {
        return alert(error);
      });
    },
    getStoreData: function getStoreData(update) {
      var _this4 = this;

      if (this.$store.state.selectedStore) {
        // when initial project creation & login no store is available
        this.storeData = null;
        this.dailyData = null;
        this.$store.state.secondaryDatabase.collection("stores").doc(this.$store.state.selectedStore).get().then(function (doc) {
          _this4.storeData = doc.data();
          var dailyData = doc.data().dailyData;
          if (dailyData && dailyData.date == new Date().toLocaleDateString()) {
            _this4.dailyData = dailyData;
            console.log("dailyData", dailyData);
          } else {
            var _dailyData = {
              date: new Date().toLocaleDateString(),
              sales: 0,
              expenses: 0,
              profit: 0,
              due: 0
            };
            _this4.dailyData = _dailyData;
          }
          if (update) {
            _this4.loading = false;
            _this4.changed = true;
          }
          // console.log("doc is", doc);
        }).catch(function (error) {
          return alert(error);
        });
      }
    },


    // getDailyData() {
    //   const itemKey = `dailyData-${this.$store.state.selectedStore}`;
    //   const dailyData = JSON.parse(localStorage.getItem(itemKey));
    //   if (dailyData && dailyData.date == new Date().toLocaleDateString()) {
    //     this.dailyData = dailyData;
    //     console.log("dailyData", dailyData);
    //   } else {
    //     const dailyData = {
    //       date: new Date().toLocaleDateString(),
    //       sales: 0,
    //       expenses: 0,
    //       profit: 0,
    //       due: 0,
    //     };
    //     this.dailyData = dailyData;
    //     localStorage.setItem(itemKey, JSON.stringify(dailyData));
    //   }
    // },

    getReport: function getReport() {
      var _this5 = this;

      this.reportData = null;
      var date = new Date();
      var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 1);
      this.$store.state.secondaryDatabase.collection("reports").where("date", ">=", __WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].firestore.Timestamp.fromDate(firstDay)).where("date", "<=", __WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].firestore.Timestamp.fromDate(lastDay)).where("storeLocation", "==", this.$store.state.selectedStore).get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          _this5.reportData = doc.data();
        });
      }).catch(function (error) {
        return alert(error);
      });
    },
    open3: function open3() {
      this.$notify.info({
        title: "Info",
        message: "Order status is updated"
      });
    },
    upOrder: function upOrder(id, status, refid) {
      var _this6 = this;

      this.$store.state.secondaryDatabase.collection("orders").doc(id).update({
        status: status
      }).then(function () {
        _this6.open3();
        if (!_this6.$store.state.noDB) {
          __WEBPACK_IMPORTED_MODULE_4__config_FirebaseInit__["a" /* default */].collection("orders").doc(refid).update({
            status: status
          }).then(function () {}).catch(function (error) {
            return alert(error);
          });
        }
      }).catch(function (error) {
        return alert(error);
      });
    },
    createInvoice: function createInvoice() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data, result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // See documentation for all data properties
                data = _this7.getSampleData();
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_5_easyinvoice___default.a.createInvoice(data);

              case 3:
                result = _context.sent;

                _this7.invoiceBase64 = result.pdf;

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this7);
      }))();
    },
    downloadInvoice: function downloadInvoice() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var data, result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // See documentation for all data properties
                data = _this8.getSampleData();
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_5_easyinvoice___default.a.createInvoice(data);

              case 3:
                result = _context2.sent;

                __WEBPACK_IMPORTED_MODULE_5_easyinvoice___default.a.download("myInvoice.pdf", result.pdf);
                //	you can download like this as well:
                //	easyinvoice.download();
                //	easyinvoice.download('myInvoice.pdf');

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this8);
      }))();
    },
    renderInvoice: function renderInvoice() {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var data, result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                // See documentation for all data properties
                document.getElementById("pdf").innerHTML = "loading...";
                data = _this9.getSampleData();
                _context3.next = 4;
                return __WEBPACK_IMPORTED_MODULE_5_easyinvoice___default.a.createInvoice(data);

              case 4:
                result = _context3.sent;

                __WEBPACK_IMPORTED_MODULE_5_easyinvoice___default.a.render("pdf", result.pdf);

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this9);
      }))();
    },
    getSampleData: function getSampleData() {
      return this.sampleData;
    }
  }
});

/***/ }),
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BarChart_vue__ = __webpack_require__(257);
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BarChart_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(258);



/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["a" /* Bar */],
  props: ["barChartDataset", "barChartLabels"],
  mounted: function mounted() {
    this.renderChart({
      labels: this.barChartLabels,
      datasets: this.barChartDataset
    }, {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        labels: {
          fontColor: "white"
          // This more specific font property overrides the global property
          // font: {
          //   size: 14,
          // },
        }
      },
      scales: {
        yAxes: [{
          ticks: {
            fontColor: "white"
          }
        }],
        xAxes: [{
          ticks: {
            fontColor: "white"
          }
        }]
      }
    });
  }
});

/***/ }),
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderPrint_vue__ = __webpack_require__(395);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43be83fd_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderPrint_vue__ = __webpack_require__(770);
function injectStyle (ssrContext) {
  __webpack_require__(769)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-43be83fd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderPrint_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43be83fd_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderPrint_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(15);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "posprinter",
  props: [],
  data: function data() {
    return {
      order: ""
    };
  },
  created: function created() {},
  mounted: function mounted() {
    var _this = this;

    this.$root.$on("orderPrint", function (data) {
      console.log("data", data);
      _this.order = data;
      _this.print();
    });
  },

  methods: {
    print: function print(item) {
      setTimeout(function () {
        var mywindow = window.open("", "PRINT", "fullscreen=yes");

        mywindow.document.write("<html><head><title>" + document.title + "</title>");
        mywindow.document.write("<link rel=\"stylesheet\" href=\"../../../../static/pos.css\" type=\"text/css\" />");

        mywindow.document.write("</head><body >");
        mywindow.document.write(document.getElementById('orderPrint').innerHTML);
        mywindow.document.write("</body></html>");

        mywindow.document.close(); // necessary for IE >= 10
        mywindow.focus(); // necessary for IE >= 10*/

        mywindow.print();
        return true;
      }, 200);

      // if (!this.showPrintPopup) {
      //   mywindow.close();
      // }
    }
  }
});

/***/ }),
/* 396 */,
/* 397 */,
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Admin__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_image_compressor_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_FirebaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_app__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "items",
  components: {
    AdminPanel: __WEBPACK_IMPORTED_MODULE_0__Admin__["a" /* default */]
  },
  data: function data() {
    return {
      cat: "",
      shopcat: "",
      shoptype: "",
      name: "",
      price: "",
      type: "",
      visible: "block",
      visible1: "none",
      imageUrl: "",
      image1: "",
      desc: "",
      modalShow: false,
      modalShow2: false,
      shops: [],
      loading: false,
      loading1: false,
      changed: false,
      labelPosition: ""
    };
  },
  created: function created() {
    var _this = this;

    this.backToTop();
    this.loading = true;
    this.changed = false;
    if (screen.width > 575) {
      this.labelPosition = "right";
    } else {
      this.labelPosition = "top";
    }

    this.$store.state.secondaryDatabase.collection("shops").where("owner", "==", __WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].auth().currentUser.uid).get().then(function (querySnapshot) {
      querySnapshot.forEach(function (doc) {
        var data = {
          id: doc.id,
          shoptype: doc.data().shoptype,
          curProducts: doc.data().curProducts,
          loc: doc.data().location,
          shopname: doc.data().name,
          shopcat: doc.data().cat
        };
        _this.shops.push(data);
        _this.shopcat = _this.shops[0].shopcat;
        _this.shoptype = _this.shops[0].shoptype;
        _this.loading = false;
        _this.changed = true;
      });
    });
  },

  methods: {
    backToTop: function backToTop() {
      $("html,body").stop().animate({
        scrollTop: 0
      }, "fast", "swing");
    },
    addItem: function addItem() {
      var _this2 = this;

      this.loading1 = true;
      this.changed = false;
      if (this.shops[0].curProducts < 40) {
        var regExp = RegExp(/<[^>]*>/g);
        if (regExp.test(this.desc) === true) {
          //console.log('1', this.desc);
          this.$alert('You cannot use HTML tag or "<" ">" characters in product details.', "Error");
          this.loading1 = false;
          this.changed = true;
          return false;
        } else {
          //console.log('uid',firebase.auth().currentUser.uid)
          this.$store.state.secondaryDatabase.collection("products").add({
            img: this.image1,
            name: this.name,
            price: this.price,
            desc: this.desc,
            loc: this.shops[0].loc,
            sname: this.shops[0].shopname,
            type: this.type,
            owner: __WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].auth().currentUser.uid,
            shopID: this.shops[0].id
          }).then(function (doc) {
            //console.log('doc is', doc)
            // this.modalShow = true
            _this2.shops[0].curProducts += 1;
            _this2.$store.state.secondaryDatabase.collection("shops").doc(_this2.shops[0].id).update({
              curProducts: _this2.shops[0].curProducts
            }).then(function (doc) {
              //console.log('doc is', doc)
              _this2.loading1 = false;
              _this2.changed = true;
              _this2.modalShow = true;
            });
          }).catch(function (error) {
            return alert(error);
          });
        }
      } else {
        this.loading1 = false;
        this.changed = true;
        this.modalShow2 = true;
      }
    },
    fileSelect1: function fileSelect1(event) {
      var _this3 = this;

      //console.log('event is', event)
      var files = event.target.files;
      var filename = files[0].name;
      if (files[0].type == "image/png" || files[0].type == "image/gif" || files[0].type == "image/svg+xml" || files[0].type == "image/tiff") {
        alert("File " + files[0].name + " is not type of jpeg or jpg!. You cannot upload other types of images.");
      } else if (files[0].size > 5000200) {
        alert("File " + files[0].name + " is too large!");
      } else {
        var reader = new FileReader();
        reader.addEventListener("load", function () {
          _this3.visible = "none";
          _this3.imageUrl = reader.result;
          _this3.visible1 = "block";
        });
        reader.readAsDataURL(files[0]);
        //this.image = files[0];
        var imageCompressor = new __WEBPACK_IMPORTED_MODULE_1_image_compressor_js__["a" /* default */]();
        imageCompressor.compress(files[0], { quality: 0.6, width: 720, height: 1340 }).then(function (result) {
          // Handle the compressed image file.
          if (result.size >= 1000000) {
            var _imageCompressor = new __WEBPACK_IMPORTED_MODULE_1_image_compressor_js__["a" /* default */]();
            _imageCompressor.compress(result, { quality: 0.5 }).then(function (result) {
              var fileReader = new FileReader();

              // This fires after the blob has been read/loaded.
              fileReader.addEventListener("load", function () {
                _this3.image1 = fileReader.result;

                //console.log('image is',this.image1)
              });

              // Start reading the blob as text.
              fileReader.readAsDataURL(result);

              ////console.log(filename)
              //console.log(result.size)
              //console.log('image is',result)
            });
          } else {
            var fileReader = new FileReader();
            fileReader.addEventListener("load", function () {
              _this3.image1 = fileReader.result;

              //console.log('else image is',this.image1)
            });
            fileReader.readAsDataURL(result);
            ////console.log(filename)
            //console.log('else',result.size)
            //console.log('ekse image is',result)
          }
        }).catch(function (err) {
          // Handle the error
          //console.log("error is" + err)
        });
      }
    }
  }
});

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_FirebaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_app__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "alloffers",
  data: function data() {
    return {
      emptyText: "Loading Records...",
      items: [],
      fields: ["index",
      //  { key: 'id', label: 'Order id', sortable: true },
      // { key: 'id', label: 'Offer ID', sortable: true },
      { key: "dis", label: "Discount (%)", sortable: true }, { key: "actions", label: "Actions" }],
      productId: "",
      currentPage: 1,
      perPage: 10,
      totalRows: items.length,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      filter: null,
      isLoggedIn: false,
      currentUser: false,
      modalInfo: { title: "", content: "" },
      loading: false,
      loading1: false,
      loading2: false,
      changed: true,
      shops: []
    };
  },


  computed: {
    sortOptions: function sortOptions() {
      // Create an options list from our fields
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return { text: f.label, value: f.key };
      });
    }
  },
  methods: {
    open: function open(id) {
      var _this = this;

      this.$confirm("This will permanently delete the item. Continue?", "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
        center: true
      }).then(function () {
        _this.deleteOffer(id);
      }).catch(function () {
        _this.$message({
          type: "info",
          message: "Delete canceled"
        });
      });
    },
    deleteOffer: function deleteOffer(id) {
      var _this2 = this;

      this.loading2 = true;
      this.changed = false;
      this.$store.state.secondaryDatabase.collection("offers").doc(id).delete().then(function () {
        //console.log('item deleted', id)
        var newitems = _this2.items.filter(function (item) {
          //console.log('filfkkk')
          return item.id !== id;
        });
        _this2.items = newitems;
        _this2.loading2 = false;
        _this2.changed = true;
        if (_this2.items.length == 0) {
          _this2.emptyText = "There are no records to show";
        }
        //console.log(this.items)
        _this2.shops[0].curOffers -= 1;
        _this2.$store.state.secondaryDatabase.collection("shops").doc(_this2.shops[0].id).update({
          curOffers: _this2.shops[0].curOffers
        }).then(function (doc) {
          //console.log('doc is', doc)
        }).catch(function (error) {
          return alert(error);
        });
      }).catch(function (error) {
        return alert(error);
      });
    },
    info: function info(item, index, button) {
      this.modalInfo.title = "Row index: " + index;
      this.modalInfo.content = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item, null, 2);
      this.$root.$emit("bv::show::modal", "modalInfo", button);
    },
    resetModal: function resetModal() {
      this.modalInfo.title = "";
      this.modalInfo.content = "";
    },
    onFiltered: function onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getId: function getId(item) {
      //console.log('getId fun invoked')
      this.productId = item.id;
      //console.log(this.productId)
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    backToTop: function backToTop() {
      $("html,body").stop().animate({
        scrollTop: 0
      }, "fast", "swing");
    }
  },
  created: function created() {
    var _this3 = this;

    //  if(firebase.auth().currentUser) {
    //       this.isLoggedIn = true;
    //       this.currentUser = firebase.auth().currentUser.email;
    //   }
    this.backToTop();
    this.loading1 = true;
    this.changed = false;
    this.$store.state.secondaryDatabase.collection("offers").where("owner", "==", __WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].auth().currentUser.uid).get().then(function (querySnapshot) {
      querySnapshot.forEach(function (doc) {
        var data = {
          id: doc.id,
          image: doc.data().img,
          dis: doc.data().dis,
          desc: doc.data().desc
        };
        _this3.items.push(data);
      });
      if (_this3.items.length == 0) {
        _this3.emptyText = "There are no records to show";
      }
      _this3.loading1 = false;
      _this3.changed = true;
    });
    this.$store.state.secondaryDatabase.collection("shops").where("owner", "==", __WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].auth().currentUser.uid).get().then(function (querySnapshot) {
      querySnapshot.forEach(function (doc) {
        var data = {
          id: doc.id,
          curOffers: doc.data().curOffers
        };
        _this3.shops.push(data);
      });
    });
  }
});

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_FirebaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_app__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'allitems',
  data: function data() {
    return {
      emptyText: 'Loading Records...',
      items: [],
      fields: ['index',
      //  { key: 'id', label: 'Order id', sortable: true },
      { key: 'name', label: 'Name', sortable: true }, { key: 'price', label: 'Price (RS)', sortable: true }, { key: 'actions', label: 'Actions' }],
      productId: '',
      currentPage: 1,
      perPage: 10,
      totalRows: items.length,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      filter: null,
      isLoggedIn: false,
      currentUser: false,
      modalInfo: { title: '', content: '' },
      loading: false,
      loading1: false,
      loading2: false,
      changed: true,
      shops: []

    };
  },


  computed: {
    sortOptions: function sortOptions() {
      // Create an options list from our fields
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return { text: f.label, value: f.key };
      });
    }
  },
  methods: {
    open: function open(id) {
      var _this = this;

      this.$confirm('This will permanently delete the item. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
        center: true
      }).then(function () {
        _this.deleteProduct(id);
      }).catch(function () {
        _this.$message({
          type: 'info',
          message: 'Delete canceled'
        });
      });
    },
    deleteProduct: function deleteProduct(id) {
      var _this2 = this;

      this.loading2 = true;
      this.changed = false;
      this.$store.state.secondaryDatabase.collection('products').doc(id).delete().then(function () {
        //console.log('item deleted', id)
        var newitems = _this2.items.filter(function (item) {
          //console.log('filfkkk')
          return item.id !== id;
        });
        _this2.items = newitems;
        _this2.loading2 = false;
        _this2.changed = true;
        if (_this2.items.length == 0) {
          _this2.emptyText = 'There are no records to show';
        }
        //console.log(this.items)
        _this2.shops[0].curProducts -= 1;
        _this2.$store.state.secondaryDatabase.collection("shops").doc(_this2.shops[0].id).update({
          curProducts: _this2.shops[0].curProducts
        }).then(function (doc) {
          //console.log('doc is', doc)
        }).catch(function (error) {
          return alert(error);
        });
      }).catch(function (error) {
        return alert(error);
      });
    },
    info: function info(item, index, button) {
      this.modalInfo.title = 'Row index: ' + index;
      this.modalInfo.content = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item, null, 2);
      this.$root.$emit('bv::show::modal', 'modalInfo', button);
    },
    resetModal: function resetModal() {
      this.modalInfo.title = '';
      this.modalInfo.content = '';
    },
    onFiltered: function onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getId: function getId(item) {
      //console.log('getId fun invoked')
      this.productId = item.id;
      //console.log(this.productId)
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    backToTop: function backToTop() {
      $('html,body').stop().animate({
        scrollTop: 0
      }, 'fast', 'swing');
    }
  },
  created: function created() {
    var _this3 = this;

    //  if(firebase.auth().currentUser) {
    //       this.isLoggedIn = true;
    //       this.currentUser = firebase.auth().currentUser.email;
    //   }
    this.backToTop();
    this.loading1 = true;
    this.changed = false;
    this.$store.state.secondaryDatabase.collection('products').where("owner", "==", __WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].auth().currentUser.uid).get().then(function (querySnapshot) {
      querySnapshot.forEach(function (doc) {
        var data = {
          'id': doc.id,
          'image': doc.data().img,
          'price': doc.data().price,
          'name': doc.data().name
        };
        _this3.items.push(data);
      });
      if (_this3.items.length == 0) {
        _this3.emptyText = 'There are no records to show';
      }
      _this3.loading1 = false;
      _this3.changed = true;
    });
    this.$store.state.secondaryDatabase.collection('shops').where("owner", "==", __WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].auth().currentUser.uid).get().then(function (querySnapshot) {

      querySnapshot.forEach(function (doc) {
        var data = {
          'id': doc.id,
          'curProducts': doc.data().curProducts
        };
        _this3.shops.push(data);
      });
    });
  }
});

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_FirebaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'payment',

  data: function data() {
    return {
      shops: [],
      shopcat: '',
      shoptype: '',
      plan: '',
      loading: false,
      loading1: false,
      fetch: false
    };
  },

  methods: {
    backToTop: function backToTop() {
      $('html,body').stop().animate({
        scrollTop: 0
      }, 'fast', 'swing');
    }
  },
  created: function created() {
    this.backToTop();
    this.loading = true;
    this.fetch = false;
    //    db.collection('shops').where('owner', '==', firebase.auth().currentUser.uid).get()
    //   .then(querySnapshot => {
    //   querySnapshot.forEach(doc => {
    //     const data = {
    //       'id': doc.id,
    //       'plan': doc.data().plan,
    //       'shopcat' : doc.data().cat,
    //       'shoptype' : doc.data().shoptype,
    //       'curProducts':doc.data().curProducts,
    //       'date': doc.data().created

    //     }
    //     this.shops.push(data)
    //     this.shopcat = this.shops[0].shopcat
    //     this.shoptype = this.shops[0].shoptype
    //     this.plan = this.shops[0].plan
    //     console.log('date is', this.shops[0].date)
    //     console.log('date is', this.shops[0].date.toDate())
    //    this.loading = false
    //    this.fetch = true
    //   })
    // })
    this.loading = false;
    this.fetch = true;
    // db.collection('shops').doc('378CDDcbFbGnSumbcBgj').update({
    //     created: firebase.firestore.Timestamp.now()
    // })
  }
});

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_FirebaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InvoiceTemplates_OrderPrint_vue__ = __webpack_require__(394);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "orders",
  components: {
    OrderPrint: __WEBPACK_IMPORTED_MODULE_3__InvoiceTemplates_OrderPrint_vue__["a" /* default */]
  },
  data: function data() {
    return {
      emptyText: "Loading Records...",
      items: [],
      fields: ["index", { key: 'orderNo', label: 'Order No', sortable: true }, { key: "cusname", label: "Customer", sortable: true }, { key: "date", label: "Date", sortable: true }, { key: "cusemail", label: "Email", sortable: true }, { key: "telno", label: "Tel No" }, { key: "total", label: "Total (RS)", sortable: true }, { key: "status", label: "Status", sortable: true }, { key: "invoice", label: "Invoice No", sortable: true }, { key: "actions", label: "Actions" }],
      options: [{
        value: "Pending",
        label: "Pending"
      }, {
        value: "Processing",
        label: "Processing"
      }, {
        value: "Completed",
        label: "Completed"
      }, {
        value: "Cancelled",
        label: "Cancelled"
      }],
      productId: "",
      currentPage: 1,
      perPage: 10,
      totalRows: items.length,
      pageOptions: ["Per Page", 5, 10, 15],
      sortBy: null,
      sortDesc: false,
      filter: null,
      isLoggedIn: false,
      currentUser: false,
      modalInfo: { title: "", content: "" },
      loading: false,
      loading1: false,
      loading2: false,
      changed: false,
      shops: [],
      orders: ""
    };
  },


  computed: {
    sortOptions: function sortOptions() {
      // Create an options list from our fields
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return { text: f.label, value: f.key };
      });
    }
  },
  methods: {
    open: function open(id, status) {
      var _this = this;

      this.$confirm("This will permanently delete the item. Continue?", "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
        center: true
      }).then(function () {
        if (status === "Pending" || status === "Processing") {
          return _this.$notify({
            title: "Cannot Delete",
            message: "Order status is pending or processing",
            duration: 0,
            type: "error"
          });
        }
        _this.deleteOrder(id, status);
      }).catch(function () {
        _this.$message({
          type: "info",
          message: "Delete canceled"
        });
      });
    },

    // open2(id) {
    //   this.$confirm('This will change the order status. Continue?', 'Warning', {
    //     confirmButtonText: 'OK',
    //     cancelButtonText: 'Cancel',
    //     type: 'warning',
    //     center: true
    //   }).then(() => {
    //     this.upOrder(id)
    //   }).catch(() => {
    //     this.$message({
    //       type: 'info',
    //       message: 'Change canceled'
    //     });
    //   });
    // },
    open3: function open3() {
      this.$notify.info({
        title: "Info",
        message: "Order status is updated"
      });
    },
    upOrder: function upOrder(id, status, refid) {
      var _this2 = this;

      this.$store.state.secondaryDatabase.collection("orders").doc(id).update({
        status: status
      }).then(function () {
        _this2.open3();
        if (!_this2.$store.state.noDB) {
          __WEBPACK_IMPORTED_MODULE_1__config_FirebaseInit__["a" /* default */].collection("orders").doc(refid).update({
            status: status
          }).then(function () {}).catch(function (error) {
            return alert(error);
          });
        }
      }).catch(function (error) {
        return alert(error);
      });
    },
    deleteOrder: function deleteOrder(id, status) {
      var _this3 = this;

      this.loading2 = true;
      this.changed = false;
      this.$store.state.secondaryDatabase.collection("orders").doc(id).delete().then(function () {
        //console.log('item deleted', id)
        var newitems = _this3.items.filter(function (item) {
          //console.log('filfkkk')
          return item.id !== id;
        });
        _this3.items = newitems;
        _this3.totalRows = _this3.items.length;
        _this3.loading2 = false;
        _this3.changed = true;
        if (_this3.items.length == 0) {
          _this3.emptyText = "There are no records to show";
        }
        //console.log(this.items)
        if (status === "Cancelled") {
          _this3.orders -= 1;
          _this3.$store.state.secondaryDatabase.collection("shops").doc(_this3.shops[0].id).update({
            orders: _this3.orders
          }).then(function (doc) {
            //console.log('doc is', doc)
          }).catch(function (error) {
            return alert(error);
          });
        }
      }).catch(function (error) {
        return alert(error);
      });
    },
    info: function info(item, index, button) {
      this.modalInfo.title = "Row index: " + index;
      this.modalInfo.content = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item, null, 2);
      this.$root.$emit("bv::show::modal", "modalInfo", button);
    },
    resetModal: function resetModal() {
      this.modalInfo.title = "";
      this.modalInfo.content = "";
    },
    onFiltered: function onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getId: function getId(item) {
      //console.log('getId fun invoked')
      this.productId = item.id;
      //console.log(this.productId)
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    backToTop: function backToTop() {
      $("html,body").stop().animate({
        scrollTop: 0
      }, "fast", "swing");
    }
  },
  created: function created() {
    var _this4 = this;

    //  if(firebase.auth().currentUser) {
    //       this.isLoggedIn = true;
    //       this.currentUser = firebase.auth().currentUser.email;
    //   }
    //  db.collection('shops').where('owner', '==', firebase.auth().currentUser.uid).get()
    //   .then(querySnapshot => {
    //   querySnapshot.forEach(doc => {
    //     const data = {
    //       'id': doc.id,
    //     }
    //     this.shops.push(data)
    //   })
    this.backToTop();
    this.loading = true;
    this.changed = false;
    var docRef = this.$store.state.secondaryDatabase.collection("orders");
    var firestoreQuery = docRef;
    if (this.$store.state.noDB === true) {
      firestoreQuery = firestoreQuery.where("shopid", "==", __WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].auth().currentUser.uid);
    }
    firestoreQuery
    // .where("shopid", "==", firebase.auth().currentUser.uid)
    .orderBy("date", "desc").limit(100).get().then(function (querySnapshot) {
      querySnapshot.forEach(function (doc) {
        var data = {
          id: doc.id,
          orderNo: doc.data().orderNo,
          cusname: doc.data().uname,
          telno: doc.data().telno,
          address: doc.data().address,
          date: doc.data().date,
          cusemail: doc.data().uemail,
          products: doc.data().products,
          total: doc.data().total,
          status: doc.data().status,
          refid: doc.data().refid,
          invoice: doc.data().invoice || '-'
        };
        if (data.date) data.date = data.date.toDate().toLocaleString();
        _this4.items.push(data);
        _this4.totalRows = _this4.items.length;
      });
      if (_this4.items.length == 0) {
        _this4.emptyText = "There are no records to show";
      }
      _this4.loading = false;
      _this4.changed = true;
    });
    this.$store.state.secondaryDatabase.collection("shops").where("owner", "==", __WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].auth().currentUser.uid).get().then(function (querySnapshot) {
      querySnapshot.forEach(function (doc) {
        var data = {
          id: doc.id,
          orders: doc.data().orders
        };
        _this4.shops.push(data);
        _this4.orders = _this4.shops[0].orders;
      });
    });
    // })
  }
});

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Admin__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_image_compressor_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_FirebaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_app__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "admingallery",
  components: {
    AdminPanel: __WEBPACK_IMPORTED_MODULE_0__Admin__["a" /* default */]
  },
  data: function data() {
    return {
      cat: "",
      title: "",
      visible: "block",
      visible1: "none",
      imageUrl: "",
      image1: "",
      desc: "",
      service: {
        img: "",
        title: "",
        desc: ""
      },
      modalShow: false,
      modalShow2: false,
      shops: [],
      gallery: [],
      loading: false,
      loading1: false,
      changed: false
    };
  },
  created: function created() {
    var _this = this;

    this.backToTop();
    this.loading = true;
    this.changed = false;
    //alert(firebase.auth().currentUser.uid)
    this.$store.state.secondaryDatabase.collection("galleries").doc(__WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].auth().currentUser.uid).get().then(function (doc) {
      if (doc.data()) {
        var data = {
          id: doc.id,
          gallery: doc.data().gallery
        };
        _this.shops.push(data);
      }

      if (!_this.shops[0]) {
        _this.shops[0] = {};
        _this.shops[0].gallery = [];
      }
      _this.loading = false;
      _this.changed = true;
    }).catch(function (error) {
      return alert(error);
    });
  },


  methods: {
    backToTop: function backToTop() {
      $("html,body").stop().animate({
        scrollTop: 0
      }, "fast", "swing");
    },
    open: function open(i) {
      var _this2 = this;

      this.$confirm("This will permanently delete the image. Continue?", "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
        center: true
      }).then(function () {
        _this2.deleteImg(i);
      }).catch(function () {
        _this2.$message({
          type: "info",
          message: "Delete canceled"
        });
      });
    },
    deleteImg: function deleteImg(i) {
      this.shops[0].gallery.splice(i, 1);
      this.$store.state.secondaryDatabase.collection("galleries").doc(__WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].auth().currentUser.uid).set({
        gallery: this.shops[0].gallery
      }).then(function (doc) {
        //console.log('doc is', doc)
      }).catch(function (error) {
        return alert(error);
      });
    },
    Upload: function Upload() {
      var _this3 = this;

      this.loading1 = true;
      this.changed = false;
      if (this.shops[0].gallery.length < 10) {
        this.shops[0].gallery.push(this.image1);
        //console.log('uid',firebase.auth().currentUser.uid)
        this.$store.state.secondaryDatabase.collection("galleries").doc(__WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].auth().currentUser.uid).set({
          gallery: this.shops[0].gallery
        }).then(function (doc) {
          //console.log('doc is', doc)
          // this.modalShow = true
          _this3.image1 = "";
          _this3.imageUrl = "";
          _this3.loading1 = false;
          _this3.changed = true;
          _this3.modalShow = true;
        }).catch(function (error) {
          return alert(error);
        });
      } else {
        this.loading1 = false;
        this.changed = true;
        this.modalShow2 = true;
      }
    },
    fileSelect1: function fileSelect1(event) {
      var _this4 = this;

      //console.log('event is', event)
      var files = event.target.files;
      var filename = files[0].name;
      if (files[0].type == "image/png" || files[0].type == "image/gif" || files[0].type == "image/svg+xml" || files[0].type == "image/tiff") {
        alert("File " + files[0].name + " is not type of jpeg or jpg!. You cannot upload other types of images.");
      } else if (files[0].size > 5000200) {
        alert("File " + files[0].name + " is too large!");
      } else {
        var reader = new FileReader();
        reader.addEventListener("load", function () {
          _this4.visible = "none";
          _this4.imageUrl = reader.result;
          _this4.visible1 = "block";
        });
        reader.readAsDataURL(files[0]);
        //this.image = files[0];
        var imageCompressor = new __WEBPACK_IMPORTED_MODULE_1_image_compressor_js__["a" /* default */]();
        imageCompressor.compress(files[0], { quality: 0.6, width: 720, height: 480 }).then(function (result) {
          // Handle the compressed image file.
          if (result.size >= 1000000) {
            var _imageCompressor = new __WEBPACK_IMPORTED_MODULE_1_image_compressor_js__["a" /* default */]();
            _imageCompressor.compress(result, { quality: 0.5 }).then(function (result) {
              var fileReader = new FileReader();

              // This fires after the blob has been read/loaded.
              fileReader.addEventListener("load", function () {
                _this4.image1 = fileReader.result;

                //console.log('image is',this.image1)
              });

              // Start reading the blob as text.
              fileReader.readAsDataURL(result);

              //console.log(filename)
              // console.log(result.size)
              //  console.log('image is',result)
            });
          } else {
            var fileReader = new FileReader();
            fileReader.addEventListener("load", function () {
              _this4.image1 = fileReader.result;

              //console.log('else image is',this.image1)
            });
            fileReader.readAsDataURL(result);
            //console.log(filename)
            // console.log('else',result.size)
            //  console.log('ekse image is',result)
          }
        }).catch(function (err) {
          // Handle the error
          //console.log("error is" + err)
        });
      }
    }
  }
});

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_FirebaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_towns__ = __webpack_require__(199);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'myshopin',
  data: function data() {
    return {
      loading: false,
      loading1: false,
      fetch: false,
      noresults: false,
      nofavshops: false,
      shops: [],
      category: '',
      location: '',
      sortby: '',
      labelPosition: "left",
      links: [],
      isVisible: false,
      lastVisible: '',
      favshops: []
    };
  },


  methods: {
    delFavShop: function delFavShop(shop) {
      var index = this.favshops[0].favshops.indexOf(shop.id);
      //console.log(index)
      //console.log(shop.id)
      if (index > -1) {
        this.favshops[0].favshops.splice(index, 1);
        //console.log(this.favshops[0].favshops)
        __WEBPACK_IMPORTED_MODULE_0__config_FirebaseInit__["a" /* default */].collection('users').doc(this.favshops[0].docid).update({
          favshops: this.favshops[0].favshops
        }).then(function () {
          //console.log('removed fav shop')
        }).catch(function (error) {
          //console.log('error',error)
        });
        this.backToTop();
        this.shops = this.shops.filter(function (s) {
          return s.id !== shop.id;
        });
        if (this.shops.length == 0) {
          this.nofavshops = true;
        }
      }
      //console.log('shops', this.shops)
    },


    // userVisits(n){
    //   if(firebase.auth().currentUser){
    //     if(firebase.auth().currentUser.displayName == 'shop owner'){
    //       var newVisits = this.shops[n].visits
    //     }
    //     if(firebase.auth().currentUser.displayName != 'shop owner'){
    //        var newVisits = this.shops[n].visits + 1
    //   //console.log('newvists', newVisits)
    //    db.collection('shops').doc(this.shops[n].id)
    //   .update({
    //     visits: newVisits
    //   })
    //   .then(() => //console.log('newvists', newVisits))
    //   .catch(error => //console.log('error',error))
    //     }
    //   }else{
    //   var newVisits = this.shops[n].visits + 1
    //   //console.log('newvists', newVisits)
    //    db.collection('shops').doc(this.shops[n].id)
    //   .update({
    //     visits: newVisits
    //   })
    //   .then(() => //console.log('newvists', newVisits))
    //   .catch(error => //console.log('error',error))
    //   }
    // },

    initToTopButton: function initToTopButton() {
      $(document).bind('scroll', function () {
        var backToTopButton = $('.goTop');
        if ($(document).scrollTop() > 250) {
          backToTopButton.addClass('isVisible');
          this.isVisible = true;
        } else {
          backToTopButton.removeClass('isVisible');
          this.isVisible = false;
        }
      }.bind(this));
    },
    backToTop: function backToTop() {
      $('html,body').stop().animate({
        scrollTop: 0
      }, 'slow', 'swing');
    }

    // moreItems(){
    //   if(this.lastVisible != undefined){
    //    db.collection('shops').where("shoptype", "==", this.$route.query.cat)
    //   .where("location", "==", this.$route.query.loc)
    //   .orderBy('rank')
    //   .orderBy('visits', 'desc')
    //   .startAfter(this.lastVisible)
    //   .limit(20).get()
    // .then(querySnapshot => {
    //   querySnapshot.forEach(doc => {
    //     const data = {
    //       'id' : doc.id,
    //       'name': doc.data().name,
    //       'category': doc.data().shoptype,
    //       'location': doc.data().location,
    //       'owner' : doc.data().owner,
    //       'visits': doc.data().visits
    //     }
    //     this.shops.push(data)
    //     //console.log(this.shops)
    //   })
    //   	this.lastVisible = querySnapshot.docs[querySnapshot.docs.length-1];
    // 	  //console.log(" moreitems last", this.lastVisible);
    // 	  //console.log(" moreitems snapshot.length", querySnapshot.docs.length);
    // 	  if(querySnapshot.docs.length < 20){
    // 		  this.lastVisible = undefined
    // 				//console.log("last", this.lastVisible);
    // 	  }
    //   })
    //   }
    // },
  },
  created: function created() {
    var _this = this;

    this.$nextTick(function () {
      this.initToTopButton();
    });
    this.backToTop();
    this.loading1 = true;
    this.fetch = false;
    __WEBPACK_IMPORTED_MODULE_0__config_FirebaseInit__["a" /* default */].collection('users').where('uid', '==', __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.uid).get().then(function (Snapshot) {
      Snapshot.forEach(function (doc) {
        var data = {
          'favshops': doc.data().favshops,
          'docid': doc.id

        };
        _this.favshops.push(data);
        //console.log(this.favshops)
      });
    }).catch(function (error) {
      return alert(error);
    }).then(function () {
      if (_this.favshops[0].favshops.length != 0) {
        _this.favshops[0].favshops.forEach(function (shopId) {
          __WEBPACK_IMPORTED_MODULE_0__config_FirebaseInit__["a" /* default */].collection('shops').doc(shopId).get().then(function (doc) {
            var data = {
              'id': doc.id,
              'name': doc.data().name,
              'category': doc.data().cat,
              'shoptype': doc.data().shoptype,
              'location': doc.data().location,
              'owner': doc.data().owner,
              'visits': doc.data().visits,
              'homeimg': doc.data().homeimg,
              'plan': doc.data().plan,
              'details': doc.data().details,
              'isHosted': doc.data().isHosted,
              'domain': doc.data().domain,
              'isCloned': doc.data().isCloned,
              'realOwner': doc.data().realOwner
            };
            _this.shops.push(data);
            //console.log('shops',this.shops)
            _this.loading1 = false;
            _this.fetch = true;
            if (_this.shops.length == 0) {
              _this.noresults = true;
              //console.log("noresults", this.noresults);
            }
            // this.lastVisible = querySnapshot.docs[querySnapshot.docs.length-1];
            // //console.log(" moreitems last", this.lastVisible);
            // //console.log(" moreitems snapshot.length", querySnapshot.docs.length);
            // if(querySnapshot.docs.length < 1){
            //   this.lastVisible = undefined
            //     //console.log("last", this.lastVisible);
            // } 
          }).catch(function (error) {
            return alert(error);
          });
        });
      } else {
        _this.loading1 = false;
        _this.fetch = true;
        _this.noresults = true;
      }
    }).catch(function (error) {
      return alert(error);
    });
  },
  mounted: function mounted() {
    this.links = __WEBPACK_IMPORTED_MODULE_2__data_towns__["a" /* default */];
  }
});

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_FirebaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "customers",
  data: function data() {
    return {
      emptyText: "Loading Records...",
      items: [],
      fields: [{ key: "name", label: "Name", sortable: true }, { key: "telephone", label: "Telephone", sortable: false }, { key: "city", label: "City", sortable: true }, { key: "email", label: "Email", sortable: true }, { key: "totalPayment", label: "Total (Rs)", sortable: true }, { key: "totalRemaining", label: "Remaining (Rs)", sortable: true }, {
        key: "totalLoyalityPoints",
        label: "Loyalty Points (Rs)",
        sortable: true
      }, { key: "regdate", label: "Registered", sortable: true }, { key: "actions", label: "Actions" }],
      payments: [],
      amount: 0,
      dialogFormVisible: false,
      dialogFormVisible2: false,
      dialogFormVisible3: false,
      width: "50%",
      currentPage: 1,
      perPage: 10,
      totalRows: items.length,
      pageOptions: [10, 25, 50],
      sortBy: null,
      sortDesc: false,
      filter: null,
      loading: false,
      loading1: false,
      loading2: false,
      changed: true,
      cus: 0,
      pay: 0,
      formdata: {
        name: "",
        email: "",
        city: "",
        pass: "",
        checkPass: "",
        telephone: "",
        note: ""
      },
      formdata2: {
        name: "",
        email: "",
        city: "",
        telephone: "",
        id: "",
        note: ""
      },
      rules2: {},
      labelPosition: "top"
    };
  },


  computed: {
    sortOptions: function sortOptions() {
      // Create an options list from our fields
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return { text: f.label, value: f.key };
      });
    }
  },
  methods: {
    onFiltered: function onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    open1: function open1() {
      this.$notify.error({
        title: "Error",
        message: "Please Enter the Correct Details",
        type: "error"
      });
    },
    showUpdate: function showUpdate(item) {
      this.formdata2.name = item.name;
      this.formdata2.telephone = item.telephone;
      this.formdata2.email = item.email;
      this.formdata2.city = item.city;
      this.formdata2.id = item.id;
      this.dialogFormVisible3 = true;
      this.formdata2.note = item.note;
    },
    checkTelephone: function checkTelephone(form, method) {
      var _this = this;

      if (form.telephone) {
        var docRef = this.$store.state.secondaryDatabase.collection("customers");
        var firestoreQuery = docRef;
        if (this.$store.state.noDB === true) {
          firestoreQuery = firestoreQuery.where("shopOwner", "==", __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.uid);
        }
        firestoreQuery.where("telephone", "==", form.telephone).limit(1).get().then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            if (method === "update") {
              if (form.id !== doc.id) {
                var telephone = form.telephone;
                form.telephone = "";
                return _this.$notify.error({
                  title: "Error",
                  message: "Telephone no " + telephone + " is already used",
                  type: "error"
                });
              }
            } else {
              var _telephone = form.telephone;
              form.telephone = "";
              return _this.$notify.error({
                title: "Error",
                message: "Telephone no " + _telephone + " is already used",
                type: "error"
              });
            }
          });
        }).catch(function (error) {
          return alert(error.message);
        });
      }
    },
    update: function update(fdata) {
      var _this2 = this;

      this.$refs[fdata].validate(function (valid) {
        if (valid) {
          _this2.dialogFormVisible3 = false, _this2.changed = false;
          _this2.loading = true;
          ////console.log(user)
          _this2.$store.state.secondaryDatabase.collection("customers").doc(_this2.formdata2.id).update({
            name: _this2.formdata2.name,
            email: _this2.formdata2.email,
            city: _this2.formdata2.city,
            telephone: _this2.formdata2.telephone,
            note: _this2.formdata2.note
          }).then(function (docRef) {
            //console.log('docref', docRef.id)
            var newitems = _this2.items.filter(function (item) {
              ////console.log('filfkkk')
              if (item.id == _this2.formdata2.id) {
                item.name = _this2.formdata2.name;
                item.telephone = _this2.formdata2.telephone;
                item.email = _this2.formdata2.email;
                item.city = _this2.formdata2.city;
                item.note = _this2.formdata2.note;
              }
              return item;
            });
            _this2.$store.state.customers = newitems;
            _this2.formdata2.name = "";
            _this2.formdata2.telephone = "";
            _this2.formdata2.email = "";
            _this2.formdata2.city = "";
            _this2.formdata2.id = "";
            _this2.formdata2.note = "";
            _this2.loading = false;
            _this2.changed = true;
            _this2.$notify({
              title: "Success",
              message: "Customer updated",
              type: "success"
            });
          }).catch(function (error) {
            return alert(error);
          });
        } else {
          _this2.open1();
          return false;
        }
      });
    },
    submitForm: function submitForm(fdata) {
      var _this3 = this;

      this.$refs[fdata].validate(function (valid) {
        if (valid) {
          _this3.dialogFormVisible2 = false, _this3.changed = false;
          _this3.loading = true;
          ////console.log(user)
          _this3.$store.state.secondaryDatabase.collection("customers").add({
            name: _this3.formdata.name,
            email: _this3.formdata.email,
            city: _this3.formdata.city,
            regdate: __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].firestore.Timestamp.now(),
            //uid: firebase.auth().currentUser.uid,
            shopOwner: __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.uid,
            telephone: _this3.formdata.telephone,
            totalPayment: 0,
            totalRemaining: 0,
            totalLoyalityPoints: 0,
            note: _this3.formdata.note
          }).then(function (docRef) {
            //console.log('docref', docRef.id)
            _this3.$store.state.customers.push({
              id: docRef.id,
              name: _this3.formdata.name,
              note: _this3.formdata.note,
              email: _this3.formdata.email,
              city: _this3.formdata.city,
              totalPayment: 0,
              totalRemaining: 0,
              totalLoyalityPoints: 0,
              regdate: __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].firestore.Timestamp.now().toDate().toLocaleString(),
              //uid: firebase.auth().currentUser.uid,
              telephone: _this3.formdata.telephone,
              payments: []
            });
            _this3.items = _this3.$store.state.customers;
            _this3.totalRows = _this3.items.length;
            _this3.cus = _this3.cus + 1;
            _this3.$store.state.secondaryDatabase.collection("shops").doc(__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.uid).update({
              cus: _this3.cus
            }).then(function () {
              //console.log('secondaryDB shop id')
            }).catch(function (error) {
              return alert(error);
            });
            _this3.formdata.name = "";
            _this3.formdata.email = "";
            _this3.formdata.telephone = "";
            _this3.formdata.city = "";
            _this3.formdata.note = "";
            _this3.loading = false;
            _this3.changed = true;
            _this3.$notify({
              title: "Success",
              message: "Customer added",
              type: "success"
            });
          }).catch(function (error) {
            return alert(error);
          });
        } else {
          _this3.open1();
          return false;
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    addPay: function addPay(id) {
      var _this4 = this;

      this.dialogFormVisible = false;
      this.loading = true;
      this.changed = false;
      var newPay = [];
      var newitems = this.items.filter(function (item) {
        ////console.log('filfkkk')
        if (item.id == id) {
          item.payments.push({
            a: _this4.amount,
            d: __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].firestore.Timestamp.now()
          });
          newPay = item.payments;
          item.total += _this4.amount;
        }
        return item;
      });
      this.$store.state.customers = newitems;
      this.$store.state.secondaryDatabase.collection("customers").doc(id).update({
        payments: newPay
      }).then(function (docRef) {
        _this4.pay = _this4.pay + _this4.amount;
        _this4.$store.state.secondaryDatabase.collection("shops").doc(__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.uid).update({
          pay: _this4.pay
        }).then(function () {
          //console.log('secondaryDB shop id')
        }).catch(function (error) {
          return alert(error);
        });
        _this4.loading = false;
        _this4.changed = true;
        _this4.$notify({
          title: "Success",
          message: "Payment added",
          type: "success"
        });
      }).catch(function (error) {
        return alert(error);
      });
    }
  },
  created: function created() {
    var _this5 = this;

    this.loading1 = true;
    this.changed = false;
    if (screen.width > 767) {
      this.width = "50%";
    } else {
      this.width = "85%";
    }
    this.$store.state.secondaryDatabase.collection("shops").doc(__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.uid).get().then(function (doc) {
      _this5.cus = doc.data().cus;
      _this5.pay = doc.data().pay;
    }).catch(function (error) {
      return alert(error);
    });

    if (this.$store.state.customers.length != 0) {
      this.items = this.$store.state.customers;
      this.totalRows = this.items.length;
      this.loading1 = false;
      this.changed = true;
    } else {

      var docRef = this.$store.state.secondaryDatabase.collection("customers");
      var firestoreQuery = docRef;
      if (this.$store.state.noDB === true) {
        firestoreQuery = firestoreQuery.where("shopOwner", "==", __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.uid);
      }
      firestoreQuery.get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          var data = {
            id: doc.id,
            name: doc.data().name,
            email: doc.data().email,
            city: doc.data().city,
            regdate: doc.data().regdate,
            telephone: doc.data().telephone,
            payments: doc.data().payments,
            totalPayment: doc.data().totalPayment,
            totalRemaining: doc.data().totalRemaining,
            totalLoyalityPoints: doc.data().totalLoyalityPoints,
            note: doc.data().note || ''
          };
          if (data.regdate != undefined) {
            data.regdate = doc.data().regdate.toDate().toLocaleString();
          }
          if (data.payments != undefined) {
            var add = function add(a, b) {
              return a + b;
            };
            //console.log('total', data.total)


            var pays = [];
            data.payments.forEach(function (p) {
              pays.push(p.a);
            });
            data.total = pays.reduce(add, 0);
          }
          _this5.items.push(data);
          _this5.totalRows = _this5.items.length;
          _this5.$store.state.customers = _this5.items;
          _this5.$store.state.viewedCustPage = true;
        });
        if (_this5.items.length == 0) {
          _this5.emptyText = "There are no records to show";
        }
        _this5.loading1 = false;
        _this5.changed = true;
      });
    }
  }
});

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_image_compressor_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_FirebaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_color_picker_wheel__ = __webpack_require__(814);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'adminhome',
  components: {
    ColorPicker: __WEBPACK_IMPORTED_MODULE_3_vue_color_picker_wheel__["a" /* default */]
  },
  data: function data() {
    return {
      image: "",
      logoimg: '',
      modalShow1: false,
      modalShow2: false,
      dialogImageUrl: '',
      dialogVisible: false,
      visible: 'block',
      visible1: 'none',
      shops: [],
      imgfiles: [],
      otherimgs: [],
      maxFiles: 4,
      loading: false,
      loading1: false,
      fetch: false,
      changed: true,
      homeimg: '',
      color1: '#fff'
    };
  },

  methods: {
    handleRemove: function handleRemove(file, fileList) {
      //console.log(file, fileList);
    },
    handlePictureCardPreview: function handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    fileSelect1: function fileSelect1(event) {
      var _this = this;

      //console.log('event is', event)
      var files = event.target.files;
      var filename = files[0].name;
      if (files[0].type == 'image/png' || files[0].type == 'image/gif' || files[0].type == 'image/svg+xml' || files[0].type == 'image/tiff') {
        alert("File " + files[0].name + " is not type of jpeg or jpg!. You cannot upload other types of images.");
      } else if (files[0].size > 5000200) {
        alert("File " + files[0].name + " is too large! maximum file size should be 5MB");
      } else {
        var reader = new FileReader();
        reader.addEventListener("load", function () {
          _this.visible = 'none';
          _this.image = reader.result;
          _this.visible1 = 'block';
        });
        reader.readAsDataURL(files[0]);
        //this.image = files[0];
        var imageCompressor = new __WEBPACK_IMPORTED_MODULE_0_image_compressor_js__["a" /* default */]();
        imageCompressor.compress(files[0], { quality: .6, width: 1140, height: 640 }).then(function (result) {
          // Handle the compressed image file.
          if (result.size > 300000) {
            var _imageCompressor = new __WEBPACK_IMPORTED_MODULE_0_image_compressor_js__["a" /* default */]();
            _imageCompressor.compress(result, { quality: .4 }).then(function (result) {

              var fileReader = new FileReader();

              // This fires after the blob has been read/loaded.
              fileReader.addEventListener('load', function () {

                _this.image1 = fileReader.result;

                //console.log('image is',this.image1)
              });

              // Start reading the blob as text.
              fileReader.readAsDataURL(result);

              ////console.log(filename) 
              //console.log(result.size)
              //console.log('image is',result)
            });
          } else {

            var fileReader = new FileReader();
            fileReader.addEventListener('load', function () {

              _this.image1 = fileReader.result;

              //console.log('else image is',this.image1)
            });
            fileReader.readAsDataURL(result);
            ////console.log(filename) 
            //console.log('else',result.size)
            //console.log('ekse image is',result)
          }
        }).catch(function (err) {
          // Handle the error
          //console.log("error is" + err)
        });
      }
    },


    //  readLogo(event) {

    //         var files = event.target.files;
    //         //console.log('files are', files)
    //          //console.log('imgfiles.length are', this.imgfiles.length)
    //   if(files.length > this.maxFiles || this.imgfiles.length >= this.maxFiles || files.length+this.imgfiles.length > this.maxFiles){
    //      alert("You can only upload a maximum of " + this.maxFiles + " files")
    //      return 0;
    //   }else{
    //    for(var i=0; i < files.length; i++){
    //     if(files[i].size > 5000200){
    //      alert("File " + files[i].name + "is too large!");
    //     }else{

    //   var reader = new FileReader();

    //   reader.addEventListener("load", () => {
    //   //   document.getElementsByClassName('image-upload-wrap').hide();
    //       this.visible = 'none'
    //       // this.logoimg = reader.result
    //       this.visible1 = 'inline'

    //   });
    //   reader.readAsDataURL(files[i]);
    //   //console.log('files[0]', files[i])
    //   const imageCompressor = new ImageCompressor();
    //     imageCompressor.compress(files[i], {quality: .6, width:720, height:1340 })
    //     .then((result) => {
    //       // Handle the compressed image file.
    //       if(result.size >= 1000000){
    //         const imageCompressor = new ImageCompressor();
    //         imageCompressor.compress(result, {quality: .5})
    //         .then((result) => {
    //          const fileReader = new FileReader();

    //             // This fires after the blob has been read/loaded.
    //             fileReader.addEventListener('load', () => {
    //               this.imgfiles.push(fileReader.result)
    //              var otherimg = fileReader.result
    //              this.otherimgs.push(otherimg)
    //              //console.log('image is',this.otherimgs)
    //             });

    //             // Start reading the blob as text.
    //             fileReader.readAsDataURL(result);

    //         ////console.log(filename) 
    //         //console.log(result.size)
    //          //console.log('image is',result)

    //     })
    //       }else{
    //         //  const reader = new FileReader();

    //         //     // This fires after the blob has been read/loaded.
    //         //     reader.addEventListener('loadend', (e) => {
    //         //       this.image2 = e.srcElement.result;
    //         //      //console.log('else image is',this.image2)
    //         //     });

    //         //     // Start reading the blob as text.
    //         //     reader.readAsText(result);
    //         var fileReader = new FileReader();
    //         fileReader.addEventListener('load', () => {
    //               this.imgfiles.push(fileReader.result)
    //              var otherimg = fileReader.result
    //              this.otherimgs.push(otherimg)
    //              //console.log('else image is',this.otherimgs)
    //         });
    //         fileReader.readAsDataURL(result);
    //         ////console.log(filename) 
    //         //console.log('else',result.size)
    //          //console.log('ekse image is',result)
    //       }
    //     })

    //     .catch((err) => {
    //       // Handle the error
    //       //console.log("error is" + err)
    //     })
    //   }
    //   }
    //   }
    // },  

    Upload: function Upload() {
      var _this2 = this;

      //console.log('image added')
      this.loading = true;
      this.fetch = false;
      __WEBPACK_IMPORTED_MODULE_1__config_FirebaseInit__["a" /* default */].collection('shops').doc(this.shops[0].id).update({ homeimg: this.image1 }).then(function () {
        _this2.loading = false;
        _this2.changed = true;
        //this.modalShow1 = true
      });
    },
    onColorChange: function onColorChange(color) {
      //console.log('Color has changed to: ', color);
      this.color1 = color;
    },
    changecolor: function changecolor() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_1__config_FirebaseInit__["a" /* default */].collection('shops').doc(this.shops[0].id).update({ txtcolor: this.color1 }).then(function () {
        _this3.modalShow2 = true;
      });
    },
    changeimg: function changeimg() {
      this.changed = false;
      this.fetch = true;
    },
    goback: function goback() {
      this.changed = true;
      this.fetch = false;
    },
    removeimg: function removeimg(i) {
      if (i > -1) {
        this.otherimgs.splice(i, 1);
        this.imgfiles.splice(i, 1);
      }
      //console.log('img files is', this.imgfiles) 
      //console.log('otherimg is', this.otherimgs) 
    },

    backToTop: function backToTop() {
      $('html,body').stop().animate({
        scrollTop: 0
      }, 'fast', 'swing');
    }
  },

  created: function created() {
    var _this4 = this;

    this.backToTop();
    this.loading1 = true;
    this.changed = false;
    __WEBPACK_IMPORTED_MODULE_1__config_FirebaseInit__["a" /* default */].collection('shops').where('owner', '==', __WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].auth().currentUser.uid).onSnapshot(function (querySnapshot) {
      _this4.shops = [];
      querySnapshot.forEach(function (doc) {
        var data = {
          'shoptype': doc.data().shoptype,
          'id': doc.id,
          'homeimg': doc.data().homeimg

        };
        _this4.shops.push(data);
        _this4.homeimg = _this4.shops[0].homeimg;
        _this4.loading1 = false;
        _this4.changed = true;
        //console.log(this.shops[0].id)
      });
    });
  }
});

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AdminFooter__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_image_compressor_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_FirebaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_app__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'adminabout',
  components: {
    AdminFooter: __WEBPACK_IMPORTED_MODULE_0__AdminFooter__["a" /* default */]
  },
  data: function data() {
    return {
      image: "",
      modalShow1: false,
      modalShow2: false,
      dialogImageUrl: '',
      dialogVisible: false,
      visible: 'block',
      visible1: 'none',
      shops: [],
      aboutUs: '',
      loading: false,
      loading1: false,
      fetch: false,
      changed: true,
      aboutimg: '',
      about: ''
    };
  },

  methods: {
    upAbout: function upAbout() {
      var _this = this;

      //console.log(this.shops[0].id)
      //console.log('uid',firebase.auth().currentUser.uid)
      this.loading = true;
      this.changed = false;
      __WEBPACK_IMPORTED_MODULE_2__config_FirebaseInit__["a" /* default */].collection("shops").doc(this.shops[0].id).update({
        about: this.aboutUs
      }).then(function (doc) {
        _this.loading = false;
        _this.changed = true;
        //this.modalShow2 = true
        //console.log('doc is', doc)
      }).catch(function (error) {
        return alert(error);
      });
    },
    handleRemove: function handleRemove(file, fileList) {
      //console.log(file, fileList);
    },
    handlePictureCardPreview: function handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    changeimg: function changeimg() {
      this.changed = false;
      this.fetch = true;
    },
    goback: function goback() {
      this.changed = true;
      this.fetch = false;
    },
    fileSelect1: function fileSelect1(event) {
      var _this2 = this;

      //console.log('event is', event)
      var files = event.target.files;
      var filename = files[0].name;
      if (files[0].type == 'image/png' || files[0].type == 'image/gif' || files[0].type == 'image/svg+xml' || files[0].type == 'image/tiff') {
        alert("File " + files[0].name + " is not type of jpeg or jpg!. You cannot upload other types of images.");
      } else if (files[0].size > 5000200) {
        alert("File " + files[0].name + " is too large! maximum file size should be 5MB");
      } else {
        var reader = new FileReader();
        reader.addEventListener("load", function () {
          _this2.visible = 'none';
          _this2.image = reader.result;
          _this2.visible1 = 'block';
        });
        reader.readAsDataURL(files[0]);
        //this.image = files[0];
        var imageCompressor = new __WEBPACK_IMPORTED_MODULE_1_image_compressor_js__["a" /* default */]();
        imageCompressor.compress(files[0], { quality: .6, width: 720, height: 480 }).then(function (result) {
          // Handle the compressed image file.
          if (result.size >= 200000) {
            var _imageCompressor = new __WEBPACK_IMPORTED_MODULE_1_image_compressor_js__["a" /* default */]();
            _imageCompressor.compress(result, { quality: .4 }).then(function (result) {

              var fileReader = new FileReader();

              // This fires after the blob has been read/loaded.
              fileReader.addEventListener('load', function () {

                _this2.image1 = fileReader.result;

                //console.log('image is',this.image1)
              });

              // Start reading the blob as text.
              fileReader.readAsDataURL(result);

              ////console.log(filename) 
              //console.log(result.size)
              //console.log('image is',result)
            });
          } else {

            var fileReader = new FileReader();
            fileReader.addEventListener('load', function () {

              _this2.image1 = fileReader.result;

              //console.log('else image is',this.image1)
            });
            fileReader.readAsDataURL(result);
            ////console.log(filename) 
            //console.log('else',result.size)
            //console.log('ekse image is',result)
          }
        }).catch(function (err) {
          // Handle the error
          //console.log("error is" + err)
        });
      }
    },
    Upload: function Upload() {
      var _this3 = this;

      //console.log('image added')
      this.loading = true;
      this.fetch = false;
      __WEBPACK_IMPORTED_MODULE_2__config_FirebaseInit__["a" /* default */].collection('shops').doc(this.shops[0].id).update({ aboutimg: this.image1 }).then(function () {
        _this3.loading = false;
        _this3.changed = true;
        // this.modalShow1 = true
      });
    },

    backToTop: function backToTop() {
      $('html,body').stop().animate({
        scrollTop: 0
      }, 'fast', 'swing');
    }
  },

  created: function created() {
    var _this4 = this;

    this.backToTop();
    this.loading1 = true;
    this.changed = false;
    __WEBPACK_IMPORTED_MODULE_2__config_FirebaseInit__["a" /* default */].collection('shops').where('owner', '==', __WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].auth().currentUser.uid).onSnapshot(function (querySnapshot) {
      _this4.shops = [];
      querySnapshot.forEach(function (doc) {
        var data = {
          'shoptype': doc.data().shoptype,
          'id': doc.id,
          'about': doc.data().about,
          'aboutimg': doc.data().aboutimg

        };
        _this4.shops.push(data);
        _this4.aboutimg = _this4.shops[0].aboutimg;
        _this4.aboutUs = _this4.shops[0].about;
        _this4.loading1 = false;
        _this4.changed = true;
        //console.log(this.shops[0].id)
      });
    });
  }
});

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_FirebaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_geofirestore__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_geofirestore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_geofirestore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_firestore__ = __webpack_require__(119);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


;


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      condata: {
        startTime: '',
        endTime: '',
        phone1: '',
        phone2: '',
        address: '',
        email: '',
        lat: '',
        long: '',
        name: '',
        darea: ''

      },
      shops: [],
      label: '',
      loading1: false,
      loading: false,
      changed: true
    };
  },


  methods: {
    backToTop: function backToTop() {
      $('html,body').stop().animate({
        scrollTop: 0
      }, 'fast', 'swing');
    },
    getLatLon: function getLatLon() {
      var _this = this;

      //getting current postiton using HTML5 Geolocation API
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function (position) {
          _this.condata.lat = position.coords.latitude;
          _this.condata.long = position.coords.longitude;
        }, function (error) {
          if (error.code == 0) {
            alert('Unknown error occurred.');
          } else if (error.code == 1) {
            alert('Permission denied. You cannot get latitude & longitude until you allow to access your loocation.');
          } else if (error.code == 2) {
            alert('Position unavailable. Error response from location provider.');
          } else if (error.code == 3) {
            alert('Location data request timed out.');
          }
        }, { timeout: 10 * 1000 });
        // console.log('this.formdata.lat', this.formdata.lat)
        // console.log('this.formdata.lat', position.coords.latitude)
      } else {
        alert("Geolocation is not supported by this browser.");
      }
    },
    upDet: function upDet(cdata) {
      var _this2 = this;

      this.$refs[cdata].validate(function (valid) {
        if (valid) {
          _this2.loading = true;
          _this2.changed = false;
          _this2.backToTop();
          // const firestore = firebase.firestore();
          // Create a GeoFirestore reference
          //const geofirestore = new GeoFirestore(firestore);
          // Create a GeoCollection reference
          //const geoshop = geofirestore.collection('shops').doc(this.shops[0].id);
          //console.log('uid',firebase.auth().currentUser.uid)
          // geoshop
          // .update({
          //   details: {
          //     stime: this.condata.startTime,
          //     etime: this.condata.endTime,
          //     tel1: this.condata.phone1,
          //     tel2: this.condata.phone2,
          //     address: this.condata.address,
          //     email: this.condata.email,
          //     name:this.shops[0].name,
          //     perm:'allowed'
          //     //  lat: this.condata.lat,
          //     //  lng: this.condata.long
          //   },
          //   cat:this.shops[0].cat,
          //   coordinates: new firebase.firestore.GeoPoint(this.condata.lat, this.condata.long)
          // })
          //  .then(doc => {
          __WEBPACK_IMPORTED_MODULE_0__config_FirebaseInit__["a" /* default */].collection('shops').doc(_this2.shops[0].id).update({
            details: {
              stime: _this2.condata.startTime,
              etime: _this2.condata.endTime,
              tel1: _this2.condata.phone1,
              tel2: _this2.condata.phone2,
              address: _this2.condata.address,
              email: _this2.condata.email,
              darea: _this2.condata.darea,
              lat: _this2.condata.lat,
              lng: _this2.condata.long
            },
            name: _this2.condata.name
            //coordinates: new firebase.firestore.GeoPoint(this.condata.lat, this.condata.long)
          }).then(function () {
            _this2.loading = false;
            _this2.changed = true;
          }).catch(function (error) {
            return alert(error);
          });
          //console.log('doc is', doc)
          //})
          // .catch(error => alert(error));
        } else {
          alert("error update!!!");
          return false;
        }
      });
    }
  },
  created: function created() {
    var _this3 = this;

    //console.log('screen',screen.width)
    if (screen.width > 575) {
      this.label = 'right';
    } else {
      this.label = 'top';
    }
    this.backToTop();
    this.loading1 = true;
    this.changed = false;
    __WEBPACK_IMPORTED_MODULE_0__config_FirebaseInit__["a" /* default */].collection("shops").where('owner', '==', __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.uid).get().then(function (querySnapshot) {
      _this3.shops = [];
      querySnapshot.forEach(function (doc) {
        var data = {
          'id': doc.id,
          'details': doc.data().details,
          //'coordinates':doc.data().coordinates,
          'name': doc.data().name,
          'shoptype': doc.data().shoptype,
          'location': doc.data().location,
          'owner': doc.data().owner,
          'visits': doc.data().visits,
          'homeimg': doc.data().homeimg,
          'plan': doc.data().plan,
          'cat': doc.data().cat

        };
        _this3.shops.push(data);
        _this3.condata.startTime = _this3.shops[0].details.stime;
        _this3.condata.endTime = _this3.shops[0].details.etime;
        _this3.condata.phone1 = _this3.shops[0].details.tel1;
        _this3.condata.phone2 = _this3.shops[0].details.tel2;
        _this3.condata.address = _this3.shops[0].details.address;
        _this3.condata.email = _this3.shops[0].details.email;
        _this3.condata.name = _this3.shops[0].name;
        _this3.condata.darea = _this3.shops[0].details.darea;
        _this3.condata.lat = _this3.shops[0].details.lat;
        _this3.condata.long = _this3.shops[0].details.lng;
        //console.log('shop coordinates',this.shops[0].coordinates)
        _this3.loading1 = false;
        _this3.changed = true;
        //console.log('doc is',doc)
      });
      //console.log('querySnapshot is',querySnapshot)
      //console.log('querySnapshot data',querySnapshot.docs[0].data().details)
    }).catch(function (error) {
      return alert(error);
    });

    // if (navigator.geolocation) {
    //     navigator.geolocation.getCurrentPosition( (position) => {
    //          this.condata.lat = position.coords.latitude
    //          this.condata.long = position.coords.longitude
    //     }, (error) => {
    //         if(error.code == 0){
    //           alert('Unknown error occurred.');
    //           this.fetched = true
    //         }else if(error.code == 1){
    //           alert('Permission denied. You cannot find near by ' + this.value + ' until you allow to access your loocation.')
    //           this.fetched = true
    //         }else if(error.code == 2){
    //           alert('Position unavailable. Error response from location provider.')
    //           this.fetched = true
    //         }else if(error.code == 3){
    //           alert('Location data request timed out.')
    //           this.fetched = true
    //         }})
    //     //  //console.log('this.condata.lat', this.condata.lat)
    //     //   //console.log('this.condata.lat', position.coords.latitude)
    // } else {
    //    alert("Geolocation is not supported by this browser.")
    // }

    // function showPosition(position) {
    //    this.condata.lat = position.coords.latitude
    //    this.condata.long = position.coords.longitude
    // }
  }
});

/***/ }),
/* 409 */,
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_FirebaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'setting',
  components: {},
  data: function data() {
    return {
      image: "",
      modalShow1: false,
      modalShow2: false,
      dialogImageUrl: '',
      dialogVisible: false,
      visible: 'block',
      visible1: 'none',
      shops: [],
      inputObj: '',
      config: {},
      loading: false,
      loading1: false,
      fetched: false,
      changed: false,
      aboutimg: '',
      about: ''
      // fbConfig: {
      //   apiKey: "api-key",
      //   authDomain: "project-id.firebaseapp.com",
      //   databaseURL: "https://project-id.firebaseio.com",
      //   projectId: "project-id",
      //   storageBucket: "project-id.appspot.com",
      //   messagingSenderId: "sender-id",
      //   appID: "app-id",
      // }
    };
  },

  methods: {
    upConfig: function upConfig() {
      var _this = this;

      //console.log(this.shops[0].id)
      //console.log('uid',firebase.auth().currentUser.uid)
      this.loading = true;
      this.changed = false;
      this.config.projectId = this.inputObj;
      // var properties = this.inputObj.split(',\n');
      // console.log('properties',properties)
      // properties.forEach((property) => {
      //     const tup = property.split(': ');
      //     this.config[tup[0]] = tup[1];
      //     console.log('this.config[tup[0]]',this.config[tup[0]])
      // })
      // console.log('this.config', this.config)
      console.log('this.config', this.config['projectId']);
      // console.log('this.config', this.config.apiKey)
      // console.log('this.config', this.config.databaseURL)
      if (this.config.projectId) {
        this.config.authDomain = this.config.projectId + '.firebaseapp.com';
        this.config.databaseURL = 'https://' + this.config.projectId + '.firebaseio.com';
        this.config.storageBucket = this.config.projectId + '.appspot.com';
        // if(this.fbConfig.authDomain == this.config.authDomain &&
        // this.fbConfig.databaseURL == this.config.databaseURL && this.fbConfig.storageBucket == this.config.storageBucket){
        __WEBPACK_IMPORTED_MODULE_0__config_FirebaseInit__["a" /* default */].collection("shops").doc(this.shops[0].id).update({
          config: this.config
        }).then(function (doc) {
          var secondary = __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].initializeApp(_this.config, __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.uid);
          _this.$store.state.secondaryDatabase = secondary.firestore();
          // this.$store.state.secondaryApp = this.$route.params.storename
          _this.$store.state.secondaryDatabase.settings({ timestampsInSnapshots: true });
          _this.$store.state.secondaryDatabase.enablePersistence({ experimentalTabSynchronization: true }).then(function () {
            //console.log("Woohoo! Multi-Tab Persistence!");
          });
          _this.$store.state.secondaryDatabase.collection("shops").add(_this.shops[0]).then(function (id) {
            console.log('secondaryDB shop id', id);
          }).catch(function (error) {
            return alert(error);
          });
          console.log('secondaryDB', _this.$store.state.secondaryDatabase);
          _this.loading = false;
          _this.changed = false;
          _this.fetched = true;
          _this.modalShow2 = true;
          //console.log('doc is', doc)
        }).catch(function (error) {
          return alert(error);
        });
        // }else{
        //   this.modalShow1 = true
        //    this.loading = false
        //     this.changed = true
        // }
      } else {
        this.modalShow1 = true;
        this.loading = false;
        this.changed = true;
      }
    },


    backToTop: function backToTop() {
      $('html,body').stop().animate({
        scrollTop: 0
      }, 'fast', 'swing');
    }
  },

  created: function created() {
    var _this2 = this;

    this.backToTop();
    this.loading1 = true;
    this.changed = false;
    __WEBPACK_IMPORTED_MODULE_0__config_FirebaseInit__["a" /* default */].collection('shops').where('owner', '==', __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.uid).onSnapshot(function (querySnapshot) {
      _this2.shops = [];
      querySnapshot.forEach(function (doc) {
        var data = {
          'config': doc.data().config,
          'id': doc.id,
          'name': doc.data().name,
          'plan': doc.data().plan,
          'district': doc.data().district,
          'location': doc.data().location,
          'categories': doc.data().categories,
          'cat': doc.data().cat,
          'shoptype': doc.data().shoptype,
          'catValues': doc.data().catValues,
          'maxProducts': doc.data().maxProducts,
          'curProducts': doc.data().curProducts,
          'curOffers': doc.data().curOffers,
          'visits': doc.data().visits,
          'orders': doc.data().orders,
          'created': doc.data().created,
          // 'rank':doc.data().rank,
          'owner': doc.data().owner,
          //  'regemail':doc.data().email,
          // 'regtel':doc.data().telephone,
          'details': doc.data().details

        };
        _this2.shops.push(data);
        if (_this2.shops[0].config) {
          console.log('config');
          _this2.changed = false;
          _this2.fetched = true;
          console.log(_this2.changed);
        } else {
          _this2.changed = true;
        }
        _this2.loading1 = false;

        //console.log(this.shops[0].id)
      });
    });
  }
});

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_FirebaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Dashboard__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__main__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_firestore_size__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_firestore_size___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_firestore_size__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: "admin",
  components: {
    Dashboard: __WEBPACK_IMPORTED_MODULE_6__Dashboard__["a" /* default */]
  },
  data: function data() {
    var _ref;

    return _ref = {
      store: "",
      disableSelect: false,
      stores: [],
      show: true,
      show2: false,
      toggleCat: false,
      isLoggedIn: false,
      currentUser: false,
      categoriesList: [],
      subcategories: [],
      category: "",
      subcategory: "",
      shops: [],
      secondaryDBshop: [],
      notices: [],
      storeid: "",
      shopcats: {},
      title: "",
      msg: "",
      modalShow1: false,
      showLSB: true,
      enlarged: "",
      plan: "",
      shopcategory: "",
      loading: false,
      fetch: true,
      isOnline: navigator.onLine,
      permissions: [],

      openeds: [],
      isCollapse: false,
      //   display: "block",
      //   visibility: "visible",
      showfooter: true,
      asideWidth: "0px",
      elMainMargin: "0px",
      elHheaderWidth: "calc(100% - 0px)",
      menuicon: "el-icon-s-unfold"
    }, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, "show", false), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, "searchbar", true), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, "color", "#051e34"), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, "color1", "#fff"), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, "color2", "#BF88F7"), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, "color3", "#062845"), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, "color4", "#111"), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, "drawer", false), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, "sysadmin", false), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, "cashier", false), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, "manager", false), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, "predefineColors", ["#303133", "#909399", "#E4E7ED", "#F2F6FC", "#409EFF", "#E6A23C", "rgba(255, 69, 0, 0.68)", "hsva(120, 40, 94, 0.5)", "hsla(209, 100%, 56%, 0.73)", "#F56C6C"]), _ref;
  },


  watch: {
    isOnline: function isOnline() {
      var _this = this;

      if (!navigator.onLine) {
        this.isOnline = false;
        this.$notify({
          title: "You are Offline",
          message: "Creating new records may cause inaccurate report data",
          duration: 0,
          showClose: false,
          position: "bottom-right",
          type: "warning"
        });
        // const offlineData = JSON.parse(localStorage.getItem("offlineData"));
        // if (!offlineData)
        localStorage.setItem("offlineData", __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()([]));
      } else if (navigator.onLine) {
        this.isOnline = true;
        this.$notify.closeAll();
        this.$notify({
          title: "You are Online ",
          message: "You are online now",
          type: "success"
        });
        var offlineData = JSON.parse(localStorage.getItem("offlineData"));
        console.log("offlineData", offlineData);
        setTimeout(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
          var offlineData, length, i, item;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  offlineData = JSON.parse(localStorage.getItem("offlineData"));
                  length = offlineData.length;

                  console.log("offlineData outside", offlineData);
                  i = 0;

                case 4:
                  if (!(i < length)) {
                    _context.next = 13;
                    break;
                  }

                  console.log("offlineData", offlineData, "i = ", i);
                  item = offlineData[i];
                  _context.next = 9;
                  return _this.$store.state.secondaryDatabase.collection(item.collection).doc(item.id).update(item.data);

                case 9:
                  console.log("offlineData[i] is", offlineData[i]);
                  // offlineData.shift();
                  // localStorage.setItem("offlineData", JSON.stringify(offlineData));
                  // .then((doc) => {
                  //   console.log("doc is", doc);
                  //   offlineData.shift();
                  //   localStorage.setItem(
                  //     "offlineData",
                  //     JSON.stringify(offlineData)
                  //   );
                  // })
                  // .catch((error) => alert(error));

                case 10:
                  i++;
                  _context.next = 4;
                  break;

                case 13:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, _this);
        })), 4500);
      }
    },
    $route: function $route() {
      if (this.$route.fullPath == "/admin/" || this.$route.fullPath == "/admin") {
        this.show = true;
        this.disableSelect = false;
      } else {
        this.show = false;
        if (this.$route.name === "create-purchase-order" || this.$route.name === "createinvoice") {
          this.disableSelect = true;
        } else {
          this.disableSelect = false;
        }
      }
    }
  },

  methods: {
    updateOnlineStatus: function updateOnlineStatus(e) {
      var type = e.type;

      this.isOnline = type === "online";
    },
    changeStore: function changeStore(store) {
      this.$root.$emit("storeChange", store);
      this.$store.state.selectedStore = store;
    },
    setRoute: function setRoute(index, param, key) {
      if (!key) this.$router.push({ name: index });
      if (key) this.$router.push({ name: index, params: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({}, param, key) });
      this.drawer = false;
    },
    handleOpen: function handleOpen(key, keyPath) {
      //console.log(key, keyPath);
    },
    handleClose: function handleClose(key, keyPath) {
      //console.log(key, keyPath);
    },
    handleCommand: function handleCommand(command) {
      if (command === "logout") {
        this.logout();
      }
    },
    changeCollapse: function changeCollapse() {
      if (this.isCollapse == true) {
        this.isCollapse = false;
        this.searchbar = true;
        this.menuicon = "el-icon-s-fold";
        this.asideWidth = "260px";
        this.elMainMargin = "260px";
        this.elHheaderWidth = "calc(100% - 260px)";
      } else {
        this.isCollapse = true;
        this.searchbar = false;
        this.menuicon = "el-icon-s-unfold";
        if (screen.width > 550) {
          this.asideWidth = "80px";
          this.elMainMargin = "80px";
          this.elHheaderWidth = "calc(100% - 80px)";
        } else {
          this.asideWidth = "0px";
          this.elMainMargin = "0px";
          this.elHheaderWidth = "calc(100% - 0px)";
        }
      }
    },
    logout: function logout() {
      var _this2 = this;

      if (__WEBPACK_IMPORTED_MODULE_4_firebase_app__["a" /* default */].auth().currentUser) {
        if (this.cashier) {
          this.$router.go(0);
        } else {
          __WEBPACK_IMPORTED_MODULE_4_firebase_app__["a" /* default */].auth().signOut().then(function () {
            _this2.$router.push("/");
          });
        }
      }
    }
  },
  mounted: function mounted() {
    if (!this.isOnline) {
      this.$notify({
        title: "You are Offline",
        message: "Creating new records may cause inaccurate report data",
        duration: 0,
        showClose: false,
        position: "bottom-right",
        type: "warning"
      });
    }
    if (this.$route.fullPath == "/admin/" || this.$route.fullPath == "/admin") {
      this.show = true;
    }
    window.addEventListener("online", this.updateOnlineStatus);
    window.addEventListener("offline", this.updateOnlineStatus);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("online", this.updateOnlineStatus);
    window.removeEventListener("offline", this.updateOnlineStatus);
  },
  created: function created() {
    var _this3 = this;

    this.loading = true;
    this.fetch = false;
    if (screen.width < 550) {
      //   this.display = "none";
      //   this.isCollapse = true;
      //   this.visibility = "hidden";
      this.showfooter = false;
    }
    if (this.$route.fullPath == "/admin/" || this.$route.fullPath == "/admin") {
      this.show = false;
    }

    __WEBPACK_IMPORTED_MODULE_7__main__["bus"].$on("userChanged", function (data) {
      // console.log(data);
      if (data.role === "Admin") _this3.sysadmin = true;
      if (data.role === "Cashier") _this3.cashier = true;
      if (data.role === "Shop Manager") _this3.manager = true;
      _this3.permissions = data.permissions || [];

      if (!_this3.sysadmin) {
        _this3.stores = _this3.stores.filter(function (store) {
          if (_this3.$store.state.systemUser.stores.includes(store.id)) return store;
        });
      }
      console.log("userChanged", _this3.stores, _this3.$store.state.systemUser.stores, _this3.sysadmin, _this3.cashier, _this3.manager);
      _this3.$store.state.stores = _this3.stores;
      _this3.store = _this3.stores[0].id;
      _this3.$store.state.selectedStore = _this3.store;
    });
    if (this.$store.state.systemUser.role === "Admin") this.sysadmin = true;
    if (this.$store.state.systemUser.role === "Cashier") this.cashier = true;
    if (this.$store.state.systemUser.role === "Shop Manager") this.manager = true;
    if (this.$store.state.systemUser.permissions) this.permissions = this.$store.state.systemUser.permissions;

    if (__WEBPACK_IMPORTED_MODULE_4_firebase_app__["a" /* default */].auth().currentUser) {
      this.isLoggedIn = true;
      this.currentUser = __WEBPACK_IMPORTED_MODULE_4_firebase_app__["a" /* default */].auth().currentUser.email;
      this.storeid = __WEBPACK_IMPORTED_MODULE_4_firebase_app__["a" /* default */].auth().currentUser.uid;
      //console.log(firebase.auth().currentUser.uid)

      try {
        __WEBPACK_IMPORTED_MODULE_4_firebase_app__["a" /* default */].app(__WEBPACK_IMPORTED_MODULE_4_firebase_app__["a" /* default */].auth().currentUser.uid);
        this.$store.state.secondaryDatabase = __WEBPACK_IMPORTED_MODULE_4_firebase_app__["a" /* default */].app(__WEBPACK_IMPORTED_MODULE_4_firebase_app__["a" /* default */].auth().currentUser.uid).firestore();
        this.show2 = true;
        //console.log('secondaryDB Exsits', this.$store.state.secondaryDatabase)
      } catch (err) {
        __WEBPACK_IMPORTED_MODULE_5__config_FirebaseInit__["a" /* default */].collection("shops").where("owner", "==", __WEBPACK_IMPORTED_MODULE_4_firebase_app__["a" /* default */].auth().currentUser.uid).get().then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            var data = {
              id: doc.id,
              shoptype: doc.data().shoptype,
              categories: doc.data().categories,
              name: doc.data().name,
              plan: doc.data().plan,
              shopcat: doc.data().cat,
              config: doc.data().config,
              email: doc.data().regemail,
              noDB: doc.data().noDB
            };
            _this3.shops.push(data);
          });
        }).then(function () {
          _this3.$store.state.plan = _this3.shops[0].plan;
          //console.log('this.shops[0].config', this.shops[0].config)
          if (!_this3.shops[0].noDB) {
            // having own db
            if (_this3.shops[0].config) {
              // console.log("config", this.shops[0].config);
              var secondaryAppConfig = _this3.shops[0].config;
              var secondary = __WEBPACK_IMPORTED_MODULE_4_firebase_app__["a" /* default */].initializeApp(secondaryAppConfig, __WEBPACK_IMPORTED_MODULE_4_firebase_app__["a" /* default */].auth().currentUser.uid);
              _this3.$store.state.secondaryDatabase = secondary.firestore();
              // this.$store.state.secondaryApp = this.$route.params.storename
              _this3.$store.state.secondaryDatabase.settings({
                timestampsInSnapshots: true
              });
              _this3.$store.state.secondaryDatabase.enablePersistence({ synchronizeTabs: true }).then(function () {
                //console.log("Woohoo! Multi-Tab Persistence!");
              });
              if (secondaryAppConfig.apiKey) {
                __WEBPACK_IMPORTED_MODULE_4_firebase_app__["a" /* default */].auth(secondary).signInWithEmailAndPassword(_this3.shops[0].email, __WEBPACK_IMPORTED_MODULE_4_firebase_app__["a" /* default */].auth().currentUser.uid).then(function (user) {}).catch(function (err) {
                  return alert(err);
                });
              }

              _this3.show2 = true;
            }
            //console.log('secondaryDB', this.$store.state.secondaryDatabase)
          } else {
            //console.log('shop config', this.shops[0].config)
            _this3.$store.state.secondaryDatabase = __WEBPACK_IMPORTED_MODULE_5__config_FirebaseInit__["a" /* default */];
            _this3.$store.state.noDB = true;
            _this3.show2 = true;
          }
        });
      }

      __WEBPACK_IMPORTED_MODULE_5__config_FirebaseInit__["a" /* default */].collection("shops").where("owner", "==", __WEBPACK_IMPORTED_MODULE_4_firebase_app__["a" /* default */].auth().currentUser.uid).get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          var data = {
            id: doc.id,
            shoptype: doc.data().shoptype,
            categories: doc.data().categories,
            name: doc.data().name,
            plan: doc.data().plan,
            shopcat: doc.data().cat,
            config: doc.data().config
          };
          _this3.shops.push(data);
          _this3.plan = _this3.shops[0].plan;
          if (_this3.shops[0].shopcat == "Vehicles") {
            _this3.shopcategory = _this3.shops[0].shopcat;
          }

          //console.log(this.shops[0].id)
          //console.log(this.shops[0].categories)
        });
        _this3.$store.state.secondaryDatabase.collection("shops").where("owner", "==", __WEBPACK_IMPORTED_MODULE_4_firebase_app__["a" /* default */].auth().currentUser.uid).get().then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            var data = {
              id: doc.id,
              categories: doc.data().categories,
              cat: doc.data().cat
            };

            _this3.shopcategory = data.cat;
            _this3.secondaryDBshop.push(data);
            _this3.shopcats = _this3.secondaryDBshop[0].categories;
            _this3.$store.state.categories = _this3.shopcats;
          });
        }).catch(function (error) {
          return alert(error.message);
        });
        var docRef = _this3.$store.state.secondaryDatabase.collection("stores");
        var firestoreQuery = docRef;
        if (_this3.$store.state.noDB === true) {
          firestoreQuery = firestoreQuery.where("shopOwner", "==", __WEBPACK_IMPORTED_MODULE_4_firebase_app__["a" /* default */].auth().currentUser.uid);
        }
        firestoreQuery.get().then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            var data = {
              id: doc.id,
              value: doc.id,
              label: doc.data().name,
              text: doc.data().name,
              name: doc.data().name,
              logo: doc.data().logo,
              email: doc.data().email,
              city: doc.data().city,
              address: doc.data().address,
              telephone: doc.data().telephone,
              netPay: doc.data().netPay,
              invo: doc.data().invo,
              totalProfit: doc.data().totalProfit,
              totalRemain: doc.data().totalRemain,
              PORemain: doc.data().PORemain,
              POTotal: doc.data().POTotal,
              POs: doc.data().POs,
              totalExp: doc.data().totalExp,
              setting: doc.data().setting
            };
            console.log("this.sysadmin", _this3.sysadmin);
            _this3.stores.push(data);
          });
          _this3.$store.state.stores = _this3.stores;
        }).catch(function (error) {
          return alert(error.message);
        });
        var prds = 'prds';
        if (_this3.$store.state.noDB === true) {
          prds = "prds" + __WEBPACK_IMPORTED_MODULE_4_firebase_app__["a" /* default */].auth().currentUser.uid;
        }
        _this3.$store.state.secondaryDatabase.collection("prdlist").doc(prds).get().then(function (doc) {
          if (doc.exists) {
            var bytes = __WEBPACK_IMPORTED_MODULE_8_firestore_size___default()(doc.data());
            console.log("size of doc", bytes);
            _this3.$store.state.prdNameList = doc.data().data;
          } else {
            // doc.data() will be undefined in this case
            console.log("No such document!");
          }
        }).catch(function (error) {
          console.log("Error getting document:", error);
        });

        _this3.loading = false;
        _this3.fetch = true;
      }).then(function () {
        //console.log('this.notices')
        __WEBPACK_IMPORTED_MODULE_5__config_FirebaseInit__["a" /* default */].collection("shops").doc(_this3.shops[0].id).collection("notify").get().then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            var notice = {
              title: doc.data().notice.title,
              msg: doc.data().notice.msg
            };
            _this3.notices.push(notice);
            //console.log(this.notices)
          });
        });
      });
    }
  }
});

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_json_pretty__ = __webpack_require__(837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_json_pretty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_json_pretty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config_FirebaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_firebase_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__InvoiceTemplates_POSPrinter_vue__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Store__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_firestore_size__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_firestore_size___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_firestore_size__);







//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








// import DesktopPrinter from "./InvoiceTemplates/DesktopPrinter.vue";
// import vueEasyPrint from "vue-easy-print";
// import printJS from "print-js";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "createinvoice",
  components: {
    POSPrinter: __WEBPACK_IMPORTED_MODULE_10__InvoiceTemplates_POSPrinter_vue__["a" /* default */],
    VueJsonPretty: __WEBPACK_IMPORTED_MODULE_7_vue_json_pretty___default.a
    // DesktopPrinter,
    // vueEasyPrint,
  },
  data: function data() {
    return {
      displayName: __WEBPACK_IMPORTED_MODULE_9_firebase_app__["a" /* default */].auth().currentUser.displayName,
      loading1: true,
      loading2: false,
      changed: false,
      isInvoiceRendered: true,
      isInvoiceCreated: false,
      search: "",
      links: [],
      customer: "",
      referralCustomer: "",
      referralCustomerMobile: "",
      referralCustomerName: "",
      productBarcode: "",
      invoiceNo: Math.floor(Math.random() * 10000000001).toString(),
      date: "",
      invoiceDate: __WEBPACK_IMPORTED_MODULE_9_firebase_app__["a" /* default */].firestore.Timestamp.now(),
      storeLocation: this.$store.state.selectedStore,
      cashier: "",
      cashierName: "",
      customerMobile: "",
      customerName: "",
      customerTotalLoyalityPoints: 0,
      maxLoyalityPoints: 0,
      grossAmount: 0,
      discount: 0,
      otherDiscount: 0,
      tax: 0,
      loyalityPoints: 0,
      giftVouchers: 0,
      earnedLoyalityPoints: 0,
      earnedReferralPoints: 0,
      netAmount: 0,
      cardPayment: 0,
      cashPayment: 0,
      chequePayment: 0,
      balance: 0,
      remaining: 0,
      stores: [],
      shops: [],
      reports: [],
      categories: "",
      analyticsReport: {},
      dialogTableVisible: false,
      disabled: false,
      priceData: [],
      currentProduct: {},
      currentRow: null,
      priceTableWidth: "350px",
      isReportExsists: true,
      initialProducts: [],
      returnedProducts: [],
      returnedProductsInitialClone: [],
      returnInvoiceData: "",
      hasReturned: false,
      address: "",
      telephone: "",
      logo: "",
      footer: "",
      A4size: false,
      POSsize: false,
      POS80size: true,
      billCssFile: "../../../../static/pos80.css",
      showPrintPopup: false,
      products: [],
      invoTotalProfit: 0,
      card3Percent: false,
      card3PercentPay: 0,
      dialogFormVisible: false,
      reportTotalRemaining: 0,
      reportTotalSales: 0,
      reportTotalProfit: 0,
      profitReport: {},
      formdata: {
        name: "",
        telephone: ""
      },
      cus: 0,
      supplierMobile: "",
      supplier: "",
      supplierName: "",
      maxQuantityforRoute: "",
      jsonDataforTest: {}, //for testing
      showUpdatedDialog: false, //for testing,
      prdNameList: this.$store.state.prdNameList,
      printInvoType: "",
      printOnly: true,
      note: "",
      routeData: {},
      offlineSave: false,
      taxMode: "Percentage",
      sCharge: 0,
      dilCharge: 0,
      serviceChargeMode: "Percentage",
      storeName: "",
      invoOptions: [],
      defaultPay: '',
      kotItems: [],
      jobItems: [],
      orderItems: [],
      allProducts: [],
      innerVisible: false,
      cashPaymentButtonClicked: false,
      cardPaymentButtonClicked: false,
      kotOrJobOrOderId: ''
      //isOriginal:true,
    };
  },
  destroyed: function destroyed() {
    // Remove listener when component is destroyed
    // this.$barcodeScanner.destroy();
    //this.isOriginal = true;
  },
  mounted: function mounted() {
    var _this = this;

    // this not need anymore as store select is disabled
    this.$root.$on("storeChange", function (store) {
      _this.$store.state.selectedStore = store;
      _this.storeLocation = store;
      _this.handleSelect();
    });
  },
  created: function created() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var eventBus, collection, docRef, firestoreQuery, _docRef, _firestoreQuery, _docRef2, _firestoreQuery2, _docRef3, _firestoreQuery3;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (_this2.$route.name === "createinvoice") {
                _this2.maxQuantityforRoute = "invoice";
                _this2.printInvoType = "invo";
                _this2.routeData.name = "createinvoice";
                if (_this2.$route.query.invoice) {
                  _this2.routeData.invoice = _this2.$route.query.invoice;
                  _this2.routeData.return = "true";
                }
              }
              if (_this2.$route.name === "create-quotation") {
                _this2.maxQuantityforRoute = "invoice"; // same as selling
                _this2.printInvoType = "quota";
                _this2.routeData.name = "create-quotation";
                if (_this2.$route.query.Quo) {
                  _this2.routeData.Quo = _this2.$route.query.Quo;
                  _this2.routeData.return = "true";
                }
              }
              if (_this2.$route.name === "create-purchase-order") {
                _this2.maxQuantityforRoute = "PO";
                _this2.printInvoType = "po";
                _this2.routeData.name = "create-purchase-order";
                if (_this2.$route.query.PO) {
                  _this2.routeData.PO = _this2.$route.query.PO;
                  _this2.routeData.return = "true";
                }
              }

              console.log("createdd!!!!!!!!!!!!!!!!", _this2.routeData);
              if (screen.width <= 768) _this2.priceTableWidth = "74%";
              eventBus = _this2.$barcodeScanner.init(_this2.onBarcodeScanned, {
                eventBus: true
              });

              if (eventBus) {
                eventBus.$on("start", function () {
                  _this2.loading = true;
                });
                eventBus.$on("finish", function () {
                  _this2.loading = false;
                });
              }
              _this2.cashier = _this2.$store.state.systemUser.id;
              _this2.cashierName = _this2.$store.state.systemUser.name;
              // this.$store.state.secondaryDatabase
              //   .collection("testcollection")
              //   .get()
              //   .then((querySnapshot) => {
              //     querySnapshot.forEach((doc) => {
              //       const data = doc.data();
              //       if (doc.data().data) this.prdNameList = doc.data().data;
              //       const bytes = sizeof(data);
              //       console.log("size of doc", bytes);
              //     });
              //   });

              _this2.$store.state.secondaryDatabase.collection("shops").where("owner", "==", __WEBPACK_IMPORTED_MODULE_9_firebase_app__["a" /* default */].auth().currentUser.uid).get().then(function (querySnapshot) {
                querySnapshot.forEach(function (doc) {
                  var data = {
                    id: doc.id,
                    categories: doc.data().categories,
                    cus: doc.data().cus,
                    curProducts: doc.data().curProducts
                  };
                  var bytes = __WEBPACK_IMPORTED_MODULE_12_firestore_size___default()(doc.data());
                  console.log("size of doc", bytes);
                  _this2.shops.push(data);
                  console.log("this.shops is", _this2.shops, data);
                  _this2.cus = _this2.shops[0].cus;

                  if (data.curProducts <= 100) {
                    if (_this2.$store.state.allProducts != undefined && _this2.$store.state.allProducts.length !== 0) {
                      _this2.allProducts = _this2.$store.state.allProducts;

                      //console.log(' from STATE this.$store.state.allProducts', this.$store.state.allProducts)
                    } else if (_this2.$store.state.allProducts.length === 0) {
                      _this2.$store.state.secondaryDatabase.collection("products").where("owner", "==", __WEBPACK_IMPORTED_MODULE_9_firebase_app__["a" /* default */].auth().currentUser.uid).get().then(function (querySnapshot) {
                        var newitems = [];
                        querySnapshot.forEach(function (doc) {
                          // //console.log('this.items.length is', state.items.length)
                          var data = {
                            id: doc.id,
                            name: doc.data().name,
                            barcode: doc.data().barcode,
                            altertQunty: doc.data().altertQunty,
                            category: doc.data().cat,
                            price: doc.data().disprice,
                            subcategory: doc.data().subcat,
                            profitMargin: doc.data().profitMargin,
                            priceList: doc.data().priceList,
                            totalQnty: 0,
                            img: doc.data().img
                          };
                          data.priceList.forEach(function (item) {
                            return data.totalQnty += item.quantity;
                          });
                          newitems.push(data);
                          _this2.allProducts = newitems;
                          _this2.$store.state.allProducts = newitems;
                          //console.log('state.items[cat]',this.$store.state.allProducts)
                        });
                      });
                    }
                  }
                });

                _this2.storeFetch(_this2.$store.state.selectedStore);
              }).catch(function (error) {
                return alert(error.message);
              });

              if (_this2.$route.query.invoice || _this2.$route.query.PO || _this2.$route.query.Quo) {
                collection = void 0;

                if (_this2.$route.name === "createinvoice") {
                  collection = "invoices";
                }
                if (_this2.$route.name === "create-purchase-order") {
                  collection = "POs";
                }
                if (_this2.$route.name === "create-quotation") {
                  collection = "quotations";
                }
                _this2.invoiceNo = _this2.$route.query.invoice || _this2.$route.query.PO || _this2.$route.query.Quo; // only one will be there

                docRef = _this2.$store.state.secondaryDatabase.collection(collection);
                firestoreQuery = docRef;

                if (_this2.$store.state.noDB === true) {
                  firestoreQuery = firestoreQuery.where("shopOwner", "==", __WEBPACK_IMPORTED_MODULE_9_firebase_app__["a" /* default */].auth().currentUser.uid);
                }
                firestoreQuery
                // this.$store.state.secondaryDatabase.collection(collection)
                .where("invoiceNo", "==", _this2.invoiceNo).limit(1).get().then(function (querySnapshot) {
                  // console.log("querySnapshot");
                  querySnapshot.forEach(function (doc) {
                    console.log("querySnapshot", doc.data().date);
                    var data = {
                      id: doc.id,
                      data: doc.data()
                    };
                    _this2.returnInvoiceData = data.data, _this2.products = doc.data().products, _this2.initialProducts = doc.data().products, _this2.returnedProducts = doc.data().returnedProducts, _this2.returnedProductsInitialClone = doc.data().returnedProducts;
                    _this2.invoiceDate = doc.data().date, _this2.invoiceNo = doc.data().invoiceNo, _this2.storeLocation = doc.data().storeLocation, _this2.cashier = doc.data().cashier, _this2.cashierName = doc.data().cashierName || "", _this2.customerName = doc.data().customer, _this2.customerMobile = doc.data().customerMobile, _this2.referralCustomerName = doc.data().referralCustomer, _this2.referralCustomerMobile = doc.data().referralCustomerMobile, _this2.supplierMobile = doc.data().supplierMobile, _this2.supplierName = doc.data().supplierName, _this2.grossAmount = doc.data().grossAmount, _this2.discount = doc.data().discount, _this2.otherDiscount = doc.data().otherDiscount, _this2.tax = doc.data().tax, _this2.taxMode = doc.data().taxMode || "Percentage", _this2.sCharge = doc.data().sCharge, _this2.dilCharge = doc.data().dilCharge || 0, _this2.serviceChargeMode = doc.data().serviceChargeMode || "Percentage", _this2.netAmount = doc.data().netAmount, _this2.cardPayment = doc.data().cardPayment, _this2.card3Percent = doc.data().addCard3, _this2.card3PercentPay = doc.data().card3, _this2.cashPayment = doc.data().cashPayment, _this2.chequePayment = doc.data().chequePayment, _this2.balance = doc.data().balance, _this2.remaining = doc.data().remaining, _this2.invoTotalProfit = doc.data().profit, _this2.loyalityPoints = doc.data().loyalityPoints;
                    _this2.earnedLoyalityPoints = doc.data().earnedLoyalityPoints;
                    _this2.earnedReferralPoints = doc.data().earnedReferralPoints;
                    _this2.giftVouchers = doc.data().giftVouchers;
                    _this2.hasReturned = doc.data().hasReturned;
                    _this2.note = doc.data().note;

                    _this2.storeFetch(_this2.storeLocation);
                  });
                  // this.handleSelect(this.storeLocation); // need to call even for create ops as this.$root.$on("storeChange" is not using

                  if (_this2.supplierMobile) _this2.handleSupplierChange();
                  if (_this2.customerMobile) _this2.handleCustomerChange("customer");
                  if (_this2.referralCustomerMobile) _this2.handleCustomerChange("referral");
                }).catch(function (error) {
                  return alert(error.message);
                });
              }
              if (_this2.$route.query.kot) {
                _docRef = _this2.$store.state.secondaryDatabase.collection("kot");
                _firestoreQuery = _docRef;

                if (_this2.$store.state.noDB === true) {
                  _firestoreQuery = _firestoreQuery.where("shopOwner", "==", __WEBPACK_IMPORTED_MODULE_9_firebase_app__["a" /* default */].auth().currentUser.uid);
                }
                _firestoreQuery.where("kotNo", "==", _this2.$route.query.kot).limit(1).get().then(function (querySnapshot) {
                  // console.log("querySnapshot");
                  querySnapshot.forEach(function (doc) {
                    _this2.kotOrJobOrOderId = doc.id;
                    doc.data().items.forEach(function (item) {
                      _this2.handleProductChange(item);
                    });
                    _this2.kotItems = doc.data().items;
                  });
                }).catch(function (error) {
                  return alert(error.message);
                });
              }
              if (_this2.$route.query.job) {
                _docRef2 = _this2.$store.state.secondaryDatabase.collection("job");
                _firestoreQuery2 = _docRef2;

                if (_this2.$store.state.noDB === true) {
                  _firestoreQuery2 = _firestoreQuery2.where("shopOwner", "==", __WEBPACK_IMPORTED_MODULE_9_firebase_app__["a" /* default */].auth().currentUser.uid);
                }
                _firestoreQuery2.where("jobNo", "==", _this2.$route.query.job).limit(1).get().then(function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee2(querySnapshot) {
                    var items, _loop, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _ref2, _ref3, index, item;

                    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            // console.log("querySnapshot");
                            items = [];

                            querySnapshot.forEach(function (doc) {
                              _this2.kotOrJobOrOderId = doc.id;
                              items = doc.data().items;
                            });

                            _loop = function _loop(index, item) {
                              setTimeout(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee() {
                                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                                  while (1) {
                                    switch (_context.prev = _context.next) {
                                      case 0:
                                        _context.next = 2;
                                        return _this2.handleProductChange(item);

                                      case 2:
                                        console.log("item", item, index);

                                      case 3:
                                      case "end":
                                        return _context.stop();
                                    }
                                  }
                                }, _callee, _this2);
                              })), 3000 * index);
                            };

                            _iteratorNormalCompletion = true;
                            _didIteratorError = false;
                            _iteratorError = undefined;
                            _context2.prev = 6;
                            for (_iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(items.entries()); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                              _ref2 = _step.value;
                              _ref3 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_ref2, 2);
                              index = _ref3[0];
                              item = _ref3[1];

                              _loop(index, item);
                            }
                            _context2.next = 14;
                            break;

                          case 10:
                            _context2.prev = 10;
                            _context2.t0 = _context2["catch"](6);
                            _didIteratorError = true;
                            _iteratorError = _context2.t0;

                          case 14:
                            _context2.prev = 14;
                            _context2.prev = 15;

                            if (!_iteratorNormalCompletion && _iterator.return) {
                              _iterator.return();
                            }

                          case 17:
                            _context2.prev = 17;

                            if (!_didIteratorError) {
                              _context2.next = 20;
                              break;
                            }

                            throw _iteratorError;

                          case 20:
                            return _context2.finish(17);

                          case 21:
                            return _context2.finish(14);

                          case 22:
                            _this2.jobItems = items;

                          case 23:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2, _this2, [[6, 10, 14, 22], [15,, 17, 21]]);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }()).catch(function (error) {
                  return alert(error.message);
                });
              }
              if (_this2.$route.query.order) {
                _docRef3 = _this2.$store.state.secondaryDatabase.collection("orders");
                _firestoreQuery3 = _docRef3;

                if (_this2.$store.state.noDB === true) {
                  _firestoreQuery3 = _firestoreQuery3.where("shopid", "==", __WEBPACK_IMPORTED_MODULE_9_firebase_app__["a" /* default */].auth().currentUser.uid);
                }
                _firestoreQuery3.where("orderNo", "==", _this2.$route.query.order).limit(1).get().then(function (querySnapshot) {
                  // console.log("querySnapshot");
                  querySnapshot.forEach(function (doc) {
                    _this2.customerMobile = doc.data().telno;
                    _this2.kotOrJobOrOderId = doc.id;
                    _this2.handleCustomerChange('customer');
                    doc.data().products.forEach(function (item) {
                      _this2.handleProductChange(item);
                    });
                    _this2.orderItems = doc.data().products;
                  });
                }).catch(function (error) {
                  return alert(error.message);
                });
              }

              // this.$store.state.broadcastChannel = new BroadcastChannel('tab');
              // console.log('this.$store.broadcastChannel',this.$store.state.broadcastChannel)
              // this.$store.state.broadcastChannel.postMessage('another-tab');
              // // note that listener is added after posting the message

              // this.$store.state.broadcastChannel.addEventListener('message', (msg) => {
              //   console.log('msg',msg,this.$store.state.isOriginalTab)
              //     if (msg.data === 'another-tab' && this.$store.state.isOriginalTab) {
              //         // message received from 2nd tab
              //         // reply to all new tabs that the website is already open
              //         this.$store.state.broadcastChannel.postMessage('already-open');
              //     }
              //     if (msg.data === 'already-open') {
              //         this.$store.state.isOriginalTab = false;
              //         // message received from original tab
              //         // replace this with whatever logic you need
              //         alert('Cannot open multiple instances for invoice creation');

              //         this.$router.push(`/admin/createinvoice?t=${Math.floor(Math.random() * 100001).toString()}`)
              //     }
              // });

            case 14:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this2);
    }))();
  },


  methods: {
    storeFetch: function storeFetch(storeId) {
      var _this3 = this;

      this.stores = [];
      this.$store.state.secondaryDatabase.collection("stores").doc(storeId).get().then(function (doc) {
        // querySnapshot.forEach((doc) => {
        var data = {
          id: doc.id,
          value: doc.id,
          label: doc.data().name,
          name: doc.data().name,
          netPay: doc.data().netPay,
          invo: doc.data().invo,
          totalProfit: doc.data().totalProfit,
          totalRemain: doc.data().totalRemain,
          PORemain: doc.data().PORemain,
          POTotal: doc.data().POTotal,
          POs: doc.data().POs,
          loyalityPoints: doc.data().setting.loyalityPoints,
          referralPoints: doc.data().setting.referralPoints,
          footer: doc.data().setting.footer,
          logo: doc.data().logo,
          address: doc.data().address,
          telephone: doc.data().telephone,
          printPaperSize: doc.data().setting.printSize,
          printPopup: doc.data().setting.printPopup,
          printOnly: doc.data().setting.printOnly,
          taxMode: doc.data().setting.taxMode || "Percentage",
          serviceChargeMode: doc.data().setting.serviceChargeMode || "Percentage",
          invoOptions: doc.data().setting.invoOptions || [],
          dailyData: doc.data().dailyData,
          invoDigits: doc.data().setting.invoDigits,
          defaultPay: doc.data().setting.defaultPay

        };
        _this3.stores.push(data);
        _this3.jsonDataforTest.stores = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_this3.stores));
        _this3.address = _this3.stores[0].address;
        _this3.telephone = _this3.stores[0].telephone;
        _this3.logo = _this3.stores[0].logo;
        _this3.storeName = _this3.stores[0].name;
        _this3.footer = _this3.stores[0].footer;
        _this3.printOnly = _this3.stores[0].printOnly;
        _this3.taxMode = _this3.stores[0].taxMode;
        _this3.serviceChargeMode = _this3.stores[0].serviceChargeMode;
        _this3.invoOptions = _this3.stores[0].invoOptions;
        _this3.defaultPay = _this3.stores[0].defaultPay;

        if (!_this3.$route.query.invoice && !_this3.$route.query.PO && !_this3.$route.query.Quo) {
          if (_this3.stores[0].invoDigits === 8) _this3.invoiceNo = Math.floor(Math.random() * 100000001).toString();
          if (_this3.stores[0].invoDigits === 6) _this3.invoiceNo = Math.floor(Math.random() * 1000001).toString();
        }
        // console.log("this.shops[0].printPaperSize", this.shops[0].printSize);
        if (_this3.stores[0].printPaperSize === "A4" || _this3.stores[0].printPaperSize === "A5") {
          _this3.billCssFile = "../../../../static/posA4.css";
        }
        if (_this3.stores[0].printPaperSize === "POS Printer 58 mm Paper") {
          _this3.billCssFile = "../../../../static/pos.css";
        }
        if (_this3.stores[0].printPopup) _this3.showPrintPopup = true;
        _this3.handleSelect(_this3.storeLocation); // should call afert all of this. else else
        // current date will pass as invoiceDate to get reports. this.reports set to [] in handleSelect. so
        // reports wont be duplicated. this matter when updating previous months records in this month

        // });
        _this3.loading1 = false;
        _this3.changed = true;
      }).catch(function (error) {
        return alert(error.message);
      });
    },
    querySearch: function querySearch(queryString, cb) {
      var prds = this.prdNameList;
      var results = queryString ? prds.filter(this.createFilter(queryString)) : [];
      // call callback function to return suggestion objects
      cb(results);
    },
    createFilter: function createFilter(queryString) {
      return function (prd) {
        return prd.name.toLowerCase().includes(queryString.toLowerCase()) || prd.barcode.toLowerCase().includes(queryString.toLowerCase());
      };
    },
    handleSelectAutoComplete: function handleSelectAutoComplete(item) {
      console.log(item);
    },
    PrintElem: function PrintElem(elem) {
      var mywindow = window.open("", "PRINT", "fullscreen=yes");

      mywindow.document.write("<html><head><title>" + document.title + "</title>");

      mywindow.document.write("<link rel=\"stylesheet\" href=\"" + this.billCssFile + "\" type=\"text/css\" />");
      mywindow.document.write("</head><body >");
      mywindow.document.write(document.getElementById(elem).innerHTML);
      mywindow.document.write("</body></html>");

      mywindow.document.close(); // necessary for IE >= 10
      mywindow.focus(); // necessary for IE >= 10*/

      mywindow.print();
      if (!this.showPrintPopup) {
        mywindow.close();
      }

      return true;
    },

    // async print() {
    //   await this.$htmlToPaper("print");
    // },
    // printJS() {
    //   printJS({
    //     printable: "print",
    //     type: "html",
    //     css: "https://app.staticsave.com/eslkcss/pos.css",
    //   });
    // },
    // printInvoice() {
    //   // console.log("print");
    //   this.$refs.easyPrint.print();
    // },
    open3: function open3() {
      var _this4 = this;

      if (!this.cashPaymentButtonClicked && !this.cardPaymentButtonClicked) {
        this.$confirm("Going to Save as a credit invoice. Continue?", "Warning", {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
          center: true
        }).then(function () {
          _this4.createInvoice();
        }).catch(function (err) {
          alert(err);
          _this4.$message({
            type: "info",
            message: "Save & Print canceled"
          });
        });
      } else {
        this.$confirm("Going to Save & Print. Continue?", "info", {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "info",
          center: true
        }).then(function () {
          _this4.createInvoice();
        }).catch(function (err) {
          alert(err);
          _this4.$message({
            type: "info",
            message: "Save & Print canceled"
          });
        });
      }
    },
    open: function open() {
      var _this5 = this;

      this.$confirm("Going to Save & Print. Continue?", "info", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "info",
        center: true
      }).then(function () {
        _this5.createInvoice();
      }).catch(function (err) {
        alert(err);
        _this5.$message({
          type: "info",
          message: "Save & Print canceled"
        });
      });
    },
    open2: function open2() {
      var _this6 = this;

      this.$confirm("Going to Save & Print. Continue?", "info", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "info",
        center: true
      }).then(function () {
        _this6.createQuotation();
      }).catch(function (err) {
        alert(err);
        _this6.$message({
          type: "info",
          message: "Save & Print canceled"
        });
      });
    },
    createInvoice: function createInvoice() {
      var _this7 = this;

      this.loading2 = true;
      if (this.storeLocation === "" || this.storeLocation === undefined) {
        return alert("Please select store location");
      }
      if (!navigator.onLine) {
        this.offlineSave = true;
        if (!this.routeData.invoice && !this.routeData.PO) this.PrintElem("print");
      }

      // this.storeFetch(this.storeLocation); // got issues // just to update daily & monthly & total store data in case multiple tabs were opened and
      // one tab having old store data. this wont enough if user already added some products to a tab and then invoice the
      // same products in another tab and the again come back to this tab continue invoicing. its user's mistake

      var collection = void 0;
      if (this.$route.name === "createinvoice") collection = "invoices";
      if (this.$route.name === "create-purchase-order") collection = "POs";
      if (!this.$route.query.invoice && !this.$route.query.PO) this.invoiceDate = __WEBPACK_IMPORTED_MODULE_9_firebase_app__["a" /* default */].firestore.Timestamp.now();
      this.disabled = true;
      var productSaving = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.products));
      productSaving.forEach(function (prd) {
        return delete prd.priceList;
      });
      var dto = {
        products: productSaving,
        returnedProducts: this.returnedProducts,
        prdBarcodes: productSaving.map(function (prd) {
          return prd.barcode;
        }),
        date: this.invoiceDate,
        updated: __WEBPACK_IMPORTED_MODULE_9_firebase_app__["a" /* default */].firestore.Timestamp.now(),
        updatedBy: this.$store.state.systemUser.name,
        hasReturned: this.hasReturned,
        invoiceNo: this.invoiceNo,
        storeLocation: this.storeLocation,
        cashier: this.cashier || "",
        cashierName: this.cashierName,
        customer: this.customerName,
        customerMobile: this.customerMobile,
        referralCustomer: this.referralCustomerName,
        referralCustomerMobile: this.referralCustomerMobile,
        supplierMobile: this.supplierMobile,
        supplierName: this.supplierName,
        grossAmount: this.grossAmount,
        discount: this.discount,
        otherDiscount: this.otherDiscount,
        tax: this.tax,
        taxMode: this.taxMode,
        sCharge: this.sCharge,
        dilCharge: this.dilCharge,
        serviceChargeMode: this.serviceChargeMode,
        netAmount: this.netAmount,
        cardPayment: this.cardPayment,
        addCard3: this.card3Percent,
        card3: this.card3PercentPay,
        cashPayment: this.cashPayment,
        chequePayment: this.chequePayment,
        balance: this.balance,
        remaining: this.remaining,
        profit: this.invoTotalProfit,
        loyalityPoints: this.loyalityPoints,
        earnedLoyalityPoints: this.earnedLoyalityPoints,
        earnedReferralPoints: this.earnedReferralPoints,
        giftVouchers: this.giftVouchers,
        note: this.note,
        offlineSave: this.offlineSave,
        shopOwner: __WEBPACK_IMPORTED_MODULE_9_firebase_app__["a" /* default */].auth().currentUser.uid
      };
      this.jsonDataforTest.invo = dto;
      // console.log('dto',dto)
      this.$store.state.secondaryDatabase.collection(collection).doc(this.invoiceNo).set(dto).then(function (doc) {
        // console.log("doc is", doc);
        var productMap = {};
        _this7.jsonDataforTest.priceListInit = {};
        _this7.jsonDataforTest.priceList = productMap;
        var isPrdNameListShouldSave = false;
        _this7.products.forEach(function (product) {
          if (!_this7.routeData.invoice && !_this7.routeData.PO) {
            var newQuantity = 0;
            if (!productMap[product.barcode]) {
              productMap[product.barcode] = product.priceList;
              _this7.jsonDataforTest.priceListInit[product.barcode] = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(product.priceList));
            }
            _this7.jsonDataforTest.priceList = productMap;
            console.log("product", productMap[product.barcode]);
            if (_this7.routeData.name === "createinvoice") {

              var storePrdQnty = productMap[product.barcode].find(function (item) {
                return item.store === _this7.storeLocation && item.serial === product.serial && item.purcPr === product.cost;
              });
              console.log("storePrdQnty", storePrdQnty);
              newQuantity = product.availableQnty - product.quantity;
              storePrdQnty.quantity = newQuantity;

              if (storePrdQnty.quantity <= product.altertQunty) {
                isPrdNameListShouldSave = true;
                var prd = _this7.$store.state.prdNameList.find(function (p) {
                  return p.barcode == product.barcode;
                });
                if (prd.lowStock) {
                  var newLowStock = prd.lowStock.filter(function (item) {
                    return item.store !== _this7.storeLocation && item.purcPr !== product.cost;
                  });
                  console.log("prd.lowStock ", prd.lowStock, newLowStock);
                  prd.lowStock = newLowStock;
                  prd.lowStock.push({
                    store: _this7.storeLocation,
                    purcPr: product.cost,
                    qty: newQuantity
                  });
                  // ***************************Have to move this block to function bcz when returning this excute before
                  // ************************** fetching the return prd from db ****************************************************
                  _this7.savePrdNameList(isPrdNameListShouldSave);
                } else {
                  prd.lowStock = [];
                  prd.lowStock.push({
                    store: _this7.storeLocation,
                    purcPr: product.cost,
                    qty: newQuantity
                  });
                  _this7.savePrdNameList(isPrdNameListShouldSave);
                }
              }

              console.log("storePrdQnty updated", storePrdQnty);
              if (!_this7.analyticsReport[product.category] || _this7.analyticsReport[product.category] && !_this7.analyticsReport[product.category][product.subcategory]) {
                if (!_this7.analyticsReport[product.category]) {
                  _this7.analyticsReport[product.category] = {};
                  _this7.profitReport[product.category] = {};
                }
                _this7.analyticsReport[product.category][product.subcategory] = 0;
                _this7.profitReport[product.category][product.subcategory] = 0;
              }
              _this7.analyticsReport[product.category][product.subcategory] += product.subTotal;
              _this7.profitReport[product.category][product.subcategory] += product.profit;
            }
            if (_this7.routeData.name === "create-purchase-order") {
              var _storePrdQnty = productMap[product.barcode].find(function (item) {
                return item.store === _this7.storeLocation && item.serial === product.serial && item.purcPr === product.price;
              }); // product.price bcz when purchasing this can be a new purchased price
              if (_storePrdQnty) {
                newQuantity = product.availableQnty + product.quantity;
                _storePrdQnty.quantity = newQuantity;

                if (_storePrdQnty.quantity > product.altertQunty) {
                  var _prd = _this7.$store.state.prdNameList.find(function (p) {
                    return p.barcode == product.barcode;
                  });
                  if (_prd.lowStock) {
                    var foundLowStockItem = _prd.lowStock.find(function (item) {
                      return item.store === _this7.storeLocation && item.purcPr === product.cost;
                    });
                    if (foundLowStockItem) {
                      var _newLowStock = _prd.lowStock.filter(function (item) {
                        return item.store !== _this7.storeLocation && item.purcPr !== product.cost;
                      });
                      isPrdNameListShouldSave = true;
                      console.log("prd.lowStock ", _newLowStock);
                      _prd.lowStock = _newLowStock;
                      _this7.savePrdNameList(isPrdNameListShouldSave);
                    }
                  }
                }
              }
              if (!_storePrdQnty) {
                productMap[product.barcode].push({
                  store: _this7.storeLocation,
                  quantity: product.quantity,
                  sellPr: 0,
                  purcPr: product.price
                });
              }
              console.log("productMap[product.barcode]", productMap[product.barcode], _storePrdQnty);
              var foundIndex = productMap[product.barcode].findIndex(function (prd) {
                return prd.quantity === 0 && prd.sellPr === 0 && prd.purcPr === 0 && prd.store === _this7.storeLocation;
              });
              if (foundIndex !== -1) {
                productMap[product.barcode].splice(foundIndex, 1);
              }

              console.log("productMap[product.barcode]", productMap[product.barcode], foundIndex);
            }
            if (_this7.$store.state.items[product.category]) {
              var foundItem = _this7.$store.state.items[product.category].find(function (item) {
                //// console.log('filfkkk')
                return item.id === product.id;
              });
              foundItem.priceList = productMap[product.barcode];
              var newitems = _this7.$store.state.items[product.category].filter(function (item) {
                //// console.log('filfkkk')
                return item.id !== product.id;
              });
              newitems.unshift(foundItem);
              _this7.$store.state.items[product.category] = newitems;
              // console.log("new itemss", newitems, foundItem);
            }
            if (_this7.$store.state.allProducts != undefined && _this7.$store.state.allProducts.length !== 0) {
              var _foundItem = _this7.$store.state.allProducts.find(function (item) {
                return item.id === product.id;
              });
              _foundItem.priceList = productMap[product.barcode];
              var newitems = _this7.$store.state.allProducts.filter(function (item) {
                return item.id !== product.id;
              });
              var totalQnty = 0;
              _foundItem.priceList.forEach(function (item) {
                return totalQnty += item.quantity;
              });
              _foundItem.totalQnty = totalQnty;
              newitems.unshift(_foundItem);
              _this7.$store.state.allProducts = newitems;
            }
            if (!_this7.offlineSave) {
              _this7.$store.state.secondaryDatabase.collection("products").doc(product.id).update({
                priceList: productMap[product.barcode]
              }).then(function (doc) {
                console.log("doc is", doc);
              }).catch(function (error) {
                return alert(error);
              });
            } else {
              var offlineData = JSON.parse(localStorage.getItem("offlineData"));
              offlineData.push({
                collection: "products",
                id: product.id,
                ops: "update",
                data: { priceList: productMap[product.barcode] }
              });
              localStorage.setItem("offlineData", __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(offlineData));
            }
          }

          if ((_this7.routeData.invoice || _this7.routeData.PO) && _this7.routeData.return === "true") {
            var returnAlreadyOriginal = _this7.returnedProductsInitialClone.find(function (prd) {
              return prd.barcode == product.barcode && prd.serial === product.serial && prd.cost == product.cost;
            });
            var returnInvoiceDataFoundPrd = _this7.returnInvoiceData.products.find(function (prd) {
              return prd.barcode === product.barcode && prd.serial === product.serial && prd.cost === product.cost;
            });
            var jsonDataforTestPriceListInit = _this7.jsonDataforTest.priceListInit;
            var jsonDataforTestPriceList = _this7.jsonDataforTest.priceList;

            // ***************************Have to move this block to here from below bcz when returning this excute after (bcz of product fetch from db)
            // ************************** saving report data via updateInvoiceReport() in db ****************************************************

            if (_this7.routeData.name === "createinvoice") {
              console.log("this.profitReport", _this7.profitReport, _this7.analyticsReport, JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_this7.profitReport)), product.category);
              _this7.analyticsReport[product.category][product.subcategory] += product.subTotal - returnInvoiceDataFoundPrd.subTotal;
              _this7.profitReport[product.category][product.subcategory] += product.profit - returnInvoiceDataFoundPrd.profit;
            }

            _this7.$store.state.secondaryDatabase.collection("products").where("owner", "==", __WEBPACK_IMPORTED_MODULE_9_firebase_app__["a" /* default */].auth().currentUser.uid).where("barcode", "==", product.barcode).get().then(function (querySnapshot) {
              var isProductFound = void 0;
              querySnapshot.forEach(function (doc) {
                if (doc) isProductFound = true;
                var data = {
                  id: doc.id,
                  priceList: doc.data().priceList,
                  availableQnty: doc.data().priceList.find(function (item) {
                    return item.store === _this7.storeLocation && item.serial === product.serial && item.purcPr === product.cost;
                  }).quantity
                  // qntyList: doc.data().quantity,
                };
                // // console.log(
                //   "data.availableQnty + product.noOfReturns",
                //   data.availableQnty,
                //   product.noOfReturns,
                //   newQuantity
                // );
                var newQuantity = 0;
                if (!productMap[product.barcode]) {
                  productMap[product.barcode] = data.priceList;
                  jsonDataforTestPriceListInit[product.barcode] = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(data.priceList));
                }
                jsonDataforTestPriceList = productMap;
                console.log("jsonDataforTestPriceList", jsonDataforTestPriceListInit, jsonDataforTestPriceList, _this7.jsonDataforTest.priceListInit, _this7.jsonDataforTest.priceList);
                if (_this7.routeData.name === "createinvoice") {
                  var _storePrdQnty2 = productMap[product.barcode].find(function (item) {
                    return item.store === _this7.storeLocation && item.serial === product.serial && item.purcPr === product.cost;
                  });
                  newQuantity = data.availableQnty + (product.noOfReturns ? product.noOfReturns : 0) - (returnAlreadyOriginal ? returnAlreadyOriginal.quantity : 0);
                  _storePrdQnty2.quantity = newQuantity;

                  if (_storePrdQnty2.quantity > product.altertQunty) {
                    var _prd2 = _this7.$store.state.prdNameList.find(function (p) {
                      return p.barcode == product.barcode;
                    });
                    if (_prd2.lowStock) {
                      var _foundLowStockItem = _prd2.lowStock.find(function (item) {
                        return item.store === _this7.storeLocation && item.purcPr === product.cost;
                      });
                      if (_foundLowStockItem) {
                        var _newLowStock2 = _prd2.lowStock.filter(function (item) {
                          return item.store !== _this7.storeLocation && item.purcPr !== product.cost;
                        });
                        isPrdNameListShouldSave = true;
                        console.log("prd.lowStock ", _newLowStock2);
                        _prd2.lowStock = _newLowStock2;
                        // ***************************Have to move this block to function bcz when returning this excute before
                        // ************************** fetching the return prd from db ****************************************************
                        _this7.savePrdNameList(isPrdNameListShouldSave);
                      }
                    }
                  }
                }
                if (_this7.routeData.name === "create-purchase-order") {
                  var _storePrdQnty3 = productMap[product.barcode].find(function (item) {
                    return item.store === _this7.storeLocation && item.serial === product.serial && item.purcPr === product.price;
                  }); // product.price bcz when purchasing this can be a new purchased price
                  newQuantity = data.availableQnty - (product.noOfReturns ? product.noOfReturns : 0) + (returnAlreadyOriginal ? returnAlreadyOriginal.quantity : 0);
                  _storePrdQnty3.quantity = newQuantity;

                  if (_storePrdQnty3.quantity <= product.altertQunty) {
                    isPrdNameListShouldSave = true;
                    var _prd3 = _this7.$store.state.prdNameList.find(function (p) {
                      return p.barcode == product.barcode;
                    });
                    if (_prd3.lowStock) {
                      var _newLowStock3 = _prd3.lowStock.filter(function (item) {
                        return item.store !== _this7.storeLocation && item.purcPr !== product.cost;
                      });
                      console.log("prd.lowStock ", _prd3.lowStock, _newLowStock3);
                      _prd3.lowStock = _newLowStock3;
                      _prd3.lowStock.push({
                        store: _this7.storeLocation,
                        purcPr: product.cost,
                        qty: newQuantity
                      });
                      _this7.savePrdNameList(isPrdNameListShouldSave);
                    } else {
                      _prd3.lowStock = [];
                      _prd3.lowStock.push({
                        store: _this7.storeLocation,
                        purcPr: product.cost,
                        qty: newQuantity
                      });
                      _this7.savePrdNameList(isPrdNameListShouldSave);
                    }
                  }
                }
                if (_this7.$store.state.items[product.category]) {
                  var _foundItem2 = _this7.$store.state.items[product.category].find(function (item) {
                    //// console.log('filfkkk')
                    return item.id === product.id;
                  });
                  _foundItem2.priceList = productMap[product.barcode];
                  var newitems = _this7.$store.state.items[product.category].filter(function (item) {
                    //// console.log('filfkkk')
                    return item.id !== product.id;
                  });
                  newitems.push(_foundItem2);
                  _this7.$store.state.items[product.category] = newitems;
                  // console.log("new itemss", newitems, foundItem);
                }
                _this7.$store.state.secondaryDatabase.collection("products").doc(product.id).update({
                  priceList: productMap[product.barcode]
                }).then(function (doc) {
                  // console.log("doc is", doc);
                }).catch(function (error) {
                  return alert(error);
                });
              });
            }).catch(function (error) {
              return console.log(error);
            });
          }
        });

        console.log("isPrdNameListShouldSave", isPrdNameListShouldSave);

        if (_this7.$route.query.kot || _this7.$route.query.order || _this7.$route.query.job) {
          var _collection = '';
          if (_this7.$route.query.kot) _collection = 'kot';
          if (_this7.$route.query.job) _collection = 'job';
          if (_this7.$route.query.order) _collection = 'orders'; //  online orders
          _this7.$store.state.secondaryDatabase.collection(_collection).doc(_this7.kotOrJobOrOderId).update({
            invoice: _this7.invoiceNo
          }).then(function (doc) {
            // console.log("doc is", doc);
          }).catch(function (error) {
            return alert(error);
          });
        }

        if (_this7.routeData.name === "createinvoice") {
          if (!_this7.routeData.invoice && !_this7.routeData.PO) {
            var cashFlowsales = _this7.balance < 0 ? _this7.cashPayment : _this7.cashPayment - _this7.balance;
            _this7.updateCashFlow(cashFlowsales);
          }
          _this7.shopAndStoreUpdate("invoice");
          _this7.updateCustomerAndReferral();
          _this7.updateInvoiceReport();
          _this7.updateDailyData(_this7.invoiceDate.toDate());
        }
        if (_this7.routeData.name === "create-purchase-order") {
          _this7.shopAndStoreUpdate("PO");
          _this7.updateSupplier();
          _this7.updatePOReport();
        }

        // this.modalShow = true
        _this7.isInvoiceCreated = true;
        if (!_this7.routeData.invoice && !_this7.routeData.PO) {
          try {
            _this7.PrintElem("print");
          } catch (error) {
            _this7.pushToNewRoute(); // in case browser block print popup
          }
        }

        _this7.pushToNewRoute();
        // this.showUpdatedDialog = true;

        // this.resetData();
        // if (
        //   this.$route.query.invoice &&
        //   this.$route.query.return === "true"
        // ) {
        //   this.$router.push("/admin/createinvoice");
        // }
      }).catch(function (error) {
        return console.log(error);
      });
    },
    pushToNewRoute: function pushToNewRoute() {
      this.loading2 = false;
      if (this.routeData.name === "createinvoice") {
        this.$notify({
          title: "Invoice Saved",
          message: "Invoice successfully saved",
          // duration: 0,
          type: "success"
        });
        this.$router.push("/admin/createinvoice?n=" + this.invoiceNo);
      }
      if (this.routeData.name === "create-purchase-order") {
        this.$notify({
          title: "GRN Saved",
          message: "GRN successfully saved",
          // duration: 0,
          type: "success"
        });
        this.$router.push("/admin/create-purchase-order?n=" + this.invoiceNo);
      }
    },


    // ***************************Have to move this block to function bcz when returning this excute before
    // ************************** fetching the return prd from db ****************************************************
    savePrdNameList: function savePrdNameList(isPrdNameListShouldSave) {
      if (isPrdNameListShouldSave) {
        console.log("isPrdNameListShouldSave", isPrdNameListShouldSave);
        // not considering about offline as that method cannot use effectively
        var prds = 'prds';
        if (this.$store.state.noDB === true) {
          prds = "prds" + __WEBPACK_IMPORTED_MODULE_9_firebase_app__["a" /* default */].auth().currentUser.uid;
        }
        this.$store.state.secondaryDatabase.collection("prdlist").doc(prds).set({ data: this.$store.state.prdNameList }).then(function (doc) {}).catch(function (error) {
          alert(error);
        });
      }
    },
    updateDailyData: function updateDailyData(date) {
      var _this8 = this;

      if (date.toLocaleDateString() !== new Date().toLocaleDateString()) return;
      var sales = this.netAmount;
      var due = this.remaining;
      var profit = this.invoTotalProfit;
      if (this.routeData.invoice) {
        sales = this.netAmount - this.returnInvoiceData.netAmount;
        due = this.remaining - this.returnInvoiceData.remaining;
        profit = this.invoTotalProfit - this.returnInvoiceData.profit;
      }

      // const itemKey = `dailyData-${this.storeLocation}`;
      var dailyData = this.stores.find(function (store) {
        return store.id == _this8.storeLocation;
      }).dailyData;
      if (dailyData && dailyData.date == new Date().toLocaleDateString()) {
        dailyData.sales += sales;
        dailyData.profit += profit;
        dailyData.due += due;
        // localStorage.setItem(itemKey, JSON.stringify(dailyData));
        console.log("dailyData", dailyData);
      } else {
        dailyData = {
          date: new Date().toLocaleDateString(),
          sales: sales,
          expenses: 0,
          profit: profit,
          due: due
        };
        // localStorage.setItem(itemKey, JSON.stringify(dailyData));
      }
      if (!this.offlineSave) {
        this.$store.state.secondaryDatabase.collection("stores").doc(this.storeLocation).update({
          dailyData: dailyData
        }).then(function (doc) {}).catch(function (error) {
          return alert(error);
        });
      } else {
        var offlineData = JSON.parse(localStorage.getItem("offlineData"));
        offlineData.push({
          collection: "stores",
          id: this.storeLocation,
          ops: "update",
          data: { dailyData: dailyData }
        });
        localStorage.setItem("offlineData", __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(offlineData));
      }
    },
    updateCashFlow: function updateCashFlow(sales) {
      var _this9 = this;

      console.log("updateCashFlow");
      this.$store.state.secondaryDatabase.collection("cashflow").where("isCurrent", "==", true).where("store", "==", this.storeLocation).get().then(function (querySnapshot) {
        var data = {};
        var isCashFlowExsists = false;
        querySnapshot.forEach(function (doc) {
          isCashFlowExsists = true;
          data.id = doc.id;
          data.sales = doc.data().sales;
        });
        console.log("updateCashFlow", isCashFlowExsists, data);
        if (!isCashFlowExsists) {
          _this9.$store.state.secondaryDatabase.collection("cashflow").add({
            // notes: this.notesData, // will asign when updating since undefined here
            open: 0,
            store: _this9.storeLocation,
            start: __WEBPACK_IMPORTED_MODULE_9_firebase_app__["a" /* default */].firestore.Timestamp.now(),
            close: 0,
            sales: sales,
            add: 0,
            deduct: 0,
            inRegi: 0,
            diff: 0,
            desc: "",
            cashData: [],
            isCurrent: true,
            updated: __WEBPACK_IMPORTED_MODULE_9_firebase_app__["a" /* default */].firestore.Timestamp.now(),
            createdBy: _this9.$store.state.systemUser.name
          }).then(function (doc) {}).catch(function (error) {
            return alert(error);
          });
          // console.log("this.analyticsReport is", this.analyticsReport);
        } else {
          _this9.$store.state.secondaryDatabase.collection("cashflow").doc(data.id).update({
            sales: data.sales + sales,
            updated: __WEBPACK_IMPORTED_MODULE_9_firebase_app__["a" /* default */].firestore.Timestamp.now(),
            updatedBy: _this9.$store.state.systemUser.name
          }).then(function (docRef) {}).catch(function (error) {
            return alert(error);
          });
        }
      }).catch(function (error) {
        return alert(error);
      });
    },
    shopAndStoreUpdate: function shopAndStoreUpdate(type) {
      var _this10 = this,
          _updateObj;

      var netPay = "netPay";
      var totalRemain = "totalRemain";
      var invo = "invo";
      var totalProfit = "totalProfit";
      if (type === "PO") {
        netPay = "POTotal";
        totalRemain = "PORemain";
        invo = "POs";
      }
      // if (!this.shops[0][netPay]) this.shops[0][netPay] = 0;
      // if (!this.shops[0][totalRemain]) this.shops[0][totalRemain] = 0;
      // if (!this.shops[0][invo]) this.shops[0][invo] = 0;
      var storeSlct = this.stores.find(function (store) {
        return store.id == _this10.storeLocation;
      });

      if (!this.routeData.invoice && !this.routeData.PO) {
        // --cannot update shop data without transaction due to concurrency -- //

        // this.shops[0][netPay] += this.netAmount;
        // this.shops[0][totalRemain] += this.remaining;
        // this.shops[0][invo] += 1;

        storeSlct[netPay] += this.netAmount;
        storeSlct[totalRemain] += this.remaining;
        storeSlct[totalProfit] += this.invoTotalProfit;
        storeSlct[invo] += 1;

        // this.reportTotalSales, this.reportTotalProfit, this.reportTotalRemaining are used as
        // properties in both invoice and PO reports updates. no issue as they are updated in separetly and accordingly
        // in 2 reports update methods
        this.reportTotalSales += this.netAmount;
        this.reportTotalProfit += this.invoTotalProfit;
        this.reportTotalRemaining += this.remaining;
      }
      if ((this.routeData.invoice || this.routeData.PO) && this.routeData.return === "true") {
        // this.shops[0][netPay] +=
        //   this.netAmount - this.returnInvoiceData.netAmount;
        // this.shops[0][totalRemain] +=
        //   this.remaining - this.returnInvoiceData.remaining;
        // this.shops[0][invo] = this.shops[0][invo];

        storeSlct[netPay] += this.netAmount - this.returnInvoiceData.netAmount;
        storeSlct[totalRemain] += this.remaining - this.returnInvoiceData.remaining;
        storeSlct[totalProfit] += this.invoTotalProfit - this.returnInvoiceData.profit;
        storeSlct[invo] = storeSlct[invo];

        this.reportTotalSales += this.netAmount - this.returnInvoiceData.netAmount;
        this.reportTotalProfit += this.invoTotalProfit - this.returnInvoiceData.profit;
        this.reportTotalRemaining += this.remaining - this.returnInvoiceData.remaining;
      }
      // this.$store.state.secondaryDatabase
      //   .collection("shops")
      //   .doc(this.shops[0].id)
      //   .update({
      //     netPay: this.shops[0][netPay],
      //     totalRemain: this.shops[0][totalRemain],
      //     invo: this.shops[0][invo],
      //   })
      //   .then((doc) => {
      //     // console.log("doc is", doc);
      //   })
      //   .catch((error) => alert(error));

      var updateObj = (_updateObj = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_updateObj, netPay, storeSlct[netPay]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_updateObj, totalRemain, storeSlct[totalRemain]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_updateObj, invo, storeSlct[invo]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_updateObj, totalProfit, storeSlct[totalProfit]), _updateObj);
      if (type === "PO") delete updateObj[totalProfit];
      this.jsonDataforTest.store = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, this.storeLocation, updateObj);
      if (!this.offlineSave) {
        this.$store.state.secondaryDatabase.collection("stores").doc(this.storeLocation).update(updateObj).then(function (doc) {
          // console.log("doc is", doc);
        }).catch(function (error) {
          return alert(error);
        });
      } else {
        var offlineData = JSON.parse(localStorage.getItem("offlineData"));
        offlineData.push({
          collection: "stores",
          id: this.storeLocation,
          ops: "update",
          data: updateObj
        });
        localStorage.setItem("offlineData", __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(offlineData));
      }
    },
    updateInvoiceReport: function updateInvoiceReport() {
      var _this11 = this;

      if (!this.isReportExsists) {
        this.$store.state.secondaryDatabase.collection("reports").add({
          date: __WEBPACK_IMPORTED_MODULE_9_firebase_app__["a" /* default */].firestore.Timestamp.now(),
          storeLocation: this.storeLocation,
          reportData: this.analyticsReport,
          profitData: this.profitReport,
          totalSales: this.reportTotalSales,
          totalProfit: this.reportTotalProfit,
          totalRemaining: this.reportTotalRemaining,
          totalPurcCost: 0,
          totalPurcDue: 0,
          totalExp: 0
        }).then(function (doc) {
          // console.log("doc is", doc);
          // geting the updated report data and update properties accordingly as paged wont be reload
          // when invoice and PO creation. this part is not needed if page reload after creation like in returns saving
          if (!_this11.reports[0]) {
            _this11.$store.state.secondaryDatabase.collection("reports").doc(doc.id).get().then(function (doc) {
              var data = {
                id: doc.id,
                categories: doc.data().reportData,
                profitData: doc.data().profitData,
                totalPurcCost: doc.data().totalPurcCost,
                totalPurcDue: doc.data().totalPurcDue,
                totalSales: doc.data().totalSales,
                totalProfit: doc.data().totalProfit,
                totalRemaining: doc.data().totalRemaining
              };
              _this11.reports.push(data);
              _this11.analyticsReport = _this11.reports[0].categories; // report's reportData property is assigned as categories
              // in the data obj that is pushed to the this.reports array
              _this11.profitReport = _this11.reports[0].profitData;
              _this11.reportTotalSales = _this11.reports[0].totalSales;
              _this11.reportTotalProfit = _this11.reports[0].totalProfit;
              _this11.reportTotalRemaining = _this11.reports[0].totalRemaining;
              _this11.isReportExsists = true;
            }).catch(function (error) {
              return alert(error);
            });
          }
        }).catch(function (error) {
          return alert(error);
        });
      }
      if (this.isReportExsists) {
        var updateObj = {
          reportData: this.analyticsReport,
          profitData: this.profitReport,
          totalSales: this.reportTotalSales,
          totalProfit: this.reportTotalProfit,
          totalRemaining: this.reportTotalRemaining
        };
        if (!this.offlineSave) {
          this.$store.state.secondaryDatabase.collection("reports").doc(this.reports[0].id).update(updateObj).then(function (doc) {
            // console.log("doc is", doc);
          }).catch(function (error) {
            return alert(error);
          });
        } else {
          var offlineData = JSON.parse(localStorage.getItem("offlineData"));
          offlineData.push({
            collection: "reports",
            id: this.reports[0].id,
            ops: "update",
            data: updateObj
          });
          localStorage.setItem("offlineData", __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(offlineData));
        }
      }
    },
    updatePOReport: function updatePOReport() {
      var _this12 = this;

      if (!this.isReportExsists) {
        this.$store.state.secondaryDatabase.collection("reports").add({
          date: __WEBPACK_IMPORTED_MODULE_9_firebase_app__["a" /* default */].firestore.Timestamp.now(),
          storeLocation: this.storeLocation,
          reportData: this.analyticsReport,
          profitData: this.profitReport,
          totalPurcCost: this.reportTotalSales,
          totalPurcDue: this.reportTotalRemaining,
          totalSales: 0,
          totalProfit: 0,
          totalRemaining: 0,
          totalExp: 0
        }).then(function (doc) {
          // console.log("doc is", doc);
          // geting the updated report data and update properties accordingly as paged wont be reload
          // when invoice and PO creation. this part is not needed if page reload after creation like in returns saving
          if (!_this12.reports[0]) {
            _this12.$store.state.secondaryDatabase.collection("reports").doc(doc.id).get().then(function (doc) {
              var data = {
                id: doc.id,
                categories: doc.data().reportData,
                profitData: doc.data().profitData,
                totalPurcCost: doc.data().totalPurcCost,
                totalPurcDue: doc.data().totalPurcDue,
                totalSales: doc.data().totalSales,
                totalProfit: doc.data().totalProfit,
                totalRemaining: doc.data().totalRemaining
              };
              _this12.reports.push(data);
              _this12.analyticsReport = _this12.reports[0].categories; // report's reportData property is assigned as categories
              // in the data obj that is pushed to the this.reports array
              _this12.profitReport = _this12.reports[0].profitData;
              _this12.reportTotalSales = _this12.reports[0].totalPurcCost;
              _this12.reportTotalProfit = 0; // this wont be updated in report as this is PO report update
              _this12.reportTotalRemaining = _this12.reports[0].totalPurcDue;
              _this12.isReportExsists = true;
            }).catch(function (error) {
              return alert(error);
            });
          }
        }).catch(function (error) {
          return alert(error);
        });
      }
      if (this.isReportExsists) {
        this.$store.state.secondaryDatabase.collection("reports").doc(this.reports[0].id).update({
          reportData: this.analyticsReport,
          profitData: this.profitReport,
          totalPurcCost: this.reportTotalSales,
          totalPurcDue: this.reportTotalRemaining
        }).then(function (doc) {
          // console.log("doc is", doc);
        }).catch(function (error) {
          return alert(error);
        });
      }
    },
    updateCustomerAndReferral: function updateCustomerAndReferral() {
      var _this13 = this;

      if (this.customer) {
        if (!this.routeData.invoice) {
          this.customer.totalPayment += this.netAmount - this.remaining;
          this.customer.totalRemaining += this.remaining;
          this.customer.totalLoyalityPoints += this.earnedLoyalityPoints;
        }
        if ((this.routeData.invoice || this.routeData.PO) && this.routeData.return === "true") {
          this.customer.totalPayment += this.netAmount - this.remaining - (this.returnInvoiceData.netAmount - this.returnInvoiceData.remaining);
          this.customer.totalRemaining += this.remaining - this.returnInvoiceData.remaining;
          this.customer.totalLoyalityPoints += this.earnedLoyalityPoints - this.returnInvoiceData.earnedLoyalityPoints;
        }
        if (!this.offlineSave) {
          this.$store.state.secondaryDatabase.collection("customers").doc(this.customer.id).update({
            totalPayment: this.customer.totalPayment,
            totalRemaining: this.customer.totalRemaining,
            totalLoyalityPoints: this.customer.totalLoyalityPoints
          }).then(function (doc) {
            if (_this13.$store.state.viewedCustPage) {
              var foundCus = _this13.$store.state.customers.find(function (cus) {
                return cus.id === _this13.customer.id;
              });
              if (foundCus) {
                foundCus.totalLoyalityPoints = _this13.customer.totalLoyalityPoints;
                foundCus.totalPayment = _this13.customer.totalPayment;
                foundCus.totalRemaining = _this13.customer.totalRemaining;
              } else _this13.$store.state.customers.push(_this13.customer);
            }
          }).catch(function (error) {
            return alert(error);
          });
        } else {
          var offlineData = JSON.parse(localStorage.getItem("offlineData"));
          offlineData.push({
            collection: "customers",
            id: this.customer.id,
            ops: "update",
            data: {
              totalPayment: this.customer.totalPayment,
              totalRemaining: this.customer.totalRemaining,
              totalLoyalityPoints: this.customer.totalLoyalityPoints
            }
          });
          localStorage.setItem("offlineData", __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(offlineData));
        }
      }
      if (this.referralCustomer) {
        if (!this.routeData.invoice) {
          this.referralCustomer.totalLoyalityPoints += this.earnedReferralPoints;
        }
        if ((this.routeData.invoice || this.routeData.PO) && this.routeData.return === "true") {
          this.referralCustomer.totalLoyalityPoints += this.earnedReferralPoints - this.returnInvoiceData.earnedReferralPoints;
        }
        if (!this.offlineSave) {
          this.$store.state.secondaryDatabase.collection("customers").doc(this.referralCustomer.id).update({
            totalLoyalityPoints: this.referralCustomer.totalLoyalityPoints
          }).then(function (doc) {
            if (_this13.$store.state.viewedCustPage) {
              var foundCus = _this13.$store.state.customers.find(function (cus) {
                return cus.id === _this13.referralCustomer.id;
              });
              if (foundCus) {
                foundCus.totalLoyalityPoints = _this13.referralCustomer.totalLoyalityPoints;
              } else _this13.$store.state.customers.push(_this13.referralCustomer);
            }
          }).catch(function (error) {
            return alert(error);
          });
        } else {
          var _offlineData = JSON.parse(localStorage.getItem("offlineData"));
          _offlineData.push({
            collection: "customers",
            id: this.referralCustomer.id,
            ops: "update",
            data: {
              totalLoyalityPoints: this.referralCustomer.totalLoyalityPoints
            }
          });
          localStorage.setItem("offlineData", __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_offlineData));
        }
      }
    },
    updateSupplier: function updateSupplier() {
      var _this14 = this;

      // console.log('ttttttttttttttttttttttttttt5',this.routeData,this.supplier)
      if (this.supplier) {
        if (!this.routeData.PO) {
          this.supplier.totalPayment += this.netAmount - this.remaining;
          this.supplier.totalRemaining += this.remaining;
          // this.customer.totalLoyalityPoints += this.earnedLoyalityPoints;
        }

        if (this.routeData.PO && this.routeData.return === "true") {
          console.log('ttttttttttttttttttttttttttt5');
          this.supplier.totalPayment += this.netAmount - this.remaining - (this.returnInvoiceData.netAmount - this.returnInvoiceData.remaining);
          this.supplier.totalRemaining += this.remaining - this.returnInvoiceData.remaining;
          // this.customer.totalLoyalityPoints +=
          //   this.earnedLoyalityPoints -
          //   this.returnInvoiceData.earnedLoyalityPoints;
        }
        this.$store.state.secondaryDatabase.collection("suppliers").doc(this.supplier.id).update({
          totalPayment: this.supplier.totalPayment,
          totalRemaining: this.supplier.totalRemaining
          // totalLoyalityPoints: this.customer.totalLoyalityPoints,
        }).then(function (doc) {
          if (_this14.$store.state.viewedSupplierPage) {
            var foundSup = _this14.$store.state.suppliers.find(function (sup) {
              return sup.id === _this14.supplier.id;
            });
            foundSup.totalPayment = _this14.supplier.totalPayment;
            foundSup.totalRemaining = _this14.supplier.totalRemaining;
          }
        }).catch(function (error) {
          return alert(error);
        });
      }
    },
    checkTelephone: function checkTelephone(form, method) {
      var _this15 = this;

      if (form.telephone) {
        var docRef = this.$store.state.secondaryDatabase.collection("customers");
        var firestoreQuery = docRef;
        if (this.$store.state.noDB === true) {
          firestoreQuery = firestoreQuery.where("shopOwner", "==", __WEBPACK_IMPORTED_MODULE_9_firebase_app__["a" /* default */].auth().currentUser.uid);
        }
        firestoreQuery.where("telephone", "==", form.telephone).limit(1).get().then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            var telephone = form.telephone;
            form.telephone = "";
            return _this15.$notify.error({
              title: "Error",
              message: "Telephone no " + telephone + " is already used",
              type: "error"
            });
          });
        }).catch(function (error) {
          return alert(error.message);
        });
      }
    },
    submitCustomerForm: function submitCustomerForm(fdata) {
      var _this16 = this;

      this.$refs[fdata].validate(function (valid) {
        if (valid) {
          _this16.dialogFormVisible2 = false;
          var dto = {
            name: _this16.formdata.name,
            email: "",
            city: "",
            regdate: __WEBPACK_IMPORTED_MODULE_9_firebase_app__["a" /* default */].firestore.Timestamp.now(),
            telephone: _this16.formdata.telephone,
            totalPayment: 0,
            totalRemaining: 0,
            totalLoyalityPoints: 0,
            shopOwner: __WEBPACK_IMPORTED_MODULE_9_firebase_app__["a" /* default */].auth().currentUser.uid
          };
          _this16.$store.state.secondaryDatabase.collection("customers").add(dto).then(function (docRef) {
            dto.id = docRef.id;
            _this16.customerMobile = _this16.formdata.telephone;
            _this16.customer = dto;
            _this16.customerName = _this16.formdata.name;
            _this16.customerTotalLoyalityPoints = 0;
            _this16.maxLoyalityPoints = 0;
            if (_this16.$store.state.viewedCustPage) {
              dto.id = docRef.id;
              dto.regdate = __WEBPACK_IMPORTED_MODULE_9_firebase_app__["a" /* default */].firestore.Timestamp.now().toDate().toLocaleString();
              _this16.$store.state.customers.push({ dto: dto });
            }

            _this16.cus = _this16.cus + 1;
            _this16.$store.state.secondaryDatabase.collection("shops").doc(__WEBPACK_IMPORTED_MODULE_9_firebase_app__["a" /* default */].auth().currentUser.uid).update({
              cus: _this16.cus
            }).then(function () {
              //console.log('secondaryDB shop id')
            }).catch(function (error) {
              return alert(error);
            });
            _this16.formdata.name = "";
            _this16.formdata.telephone = "";
            _this16.dialogFormVisible = false;
            _this16.$notify({
              title: "Success",
              message: "Customer added",
              type: "success"
            });
          }).catch(function (error) {
            return alert(error);
          });
        } else {
          return _this16.$notify.error({
            title: "Error",
            message: "Please Enter the Correct Details",
            type: "error"
          });
        }
      });
    },
    createQuotation: function createQuotation() {
      var _this17 = this;

      if (this.storeLocation === "" || this.storeLocation === undefined) {
        return alert("Please select store location");
      }
      if (!this.routeData.Quo) this.invoiceDate = __WEBPACK_IMPORTED_MODULE_9_firebase_app__["a" /* default */].firestore.Timestamp.now();
      this.disabled = true;
      var productSaving = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.products));
      productSaving.forEach(function (prd) {
        return delete prd.priceList;
      });
      this.$store.state.secondaryDatabase.collection("quotations").doc(this.invoiceNo).set({
        products: productSaving,
        returnedProducts: this.returnedProducts,
        date: this.invoiceDate,
        updated: __WEBPACK_IMPORTED_MODULE_9_firebase_app__["a" /* default */].firestore.Timestamp.now(),
        updatedBy: this.$store.state.systemUser.name,
        hasReturned: this.hasReturned,
        invoiceNo: this.invoiceNo,
        storeLocation: this.storeLocation,
        cashier: this.cashier || "",
        cashierName: this.cashierName,
        customer: this.customerName,
        customerMobile: this.customerMobile,
        referralCustomer: this.referralCustomerName,
        referralCustomerMobile: this.referralCustomerMobile,
        supplierMobile: this.supplierMobile,
        supplierName: this.supplierName,
        grossAmount: this.grossAmount,
        discount: this.discount,
        otherDiscount: this.otherDiscount,
        tax: this.tax,
        taxMode: this.taxMode,
        sCharge: this.sCharge,
        dilCharge: this.dilCharge,
        serviceChargeMode: this.serviceChargeMode,
        netAmount: this.netAmount,
        cardPayment: this.cardPayment,
        addCard3: this.card3Percent,
        card3: this.card3PercentPay,
        cashPayment: this.cashPayment,
        chequePayment: this.chequePayment,
        balance: this.balance,
        remaining: this.remaining,
        profit: this.invoTotalProfit,
        loyalityPoints: this.loyalityPoints,
        earnedLoyalityPoints: this.earnedLoyalityPoints,
        earnedReferralPoints: this.earnedReferralPoints,
        giftVouchers: this.giftVouchers,
        note: this.note,
        shopOwner: __WEBPACK_IMPORTED_MODULE_9_firebase_app__["a" /* default */].auth().currentUser.uid
      }).then(function (doc) {
        // console.log("doc is", doc);

        // this.modalShow = true
        _this17.isInvoiceCreated = true;
        _this17.$notify({
          title: "Quotation Saved",
          message: "Quotation successfully saved",
          // duration: 0,
          type: "success"
        });
        if (!_this17.routeData.invoice) {
          _this17.PrintElem("print");
        }
        // this.resetData();
        _this17.$router.push("/admin/create-quotation?n=" + _this17.invoiceNo);
      }).catch(function (error) {
        return alert(error);
      });
    },
    updateCardPayment: function updateCardPayment() {
      if (this.card3Percent) {
        this.cardPayment -= this.card3PercentPay;
        this.card3PercentPay = this.cardPayment * 3 / 100;
        this.cardPayment += this.card3PercentPay;
        this.updatePaymentDetails();
      }
      if (!this.card3Percent) {
        this.cardPayment -= this.card3PercentPay;
        this.card3PercentPay = 0;
        this.updatePaymentDetails();
      }
    },
    updatePaymentDetails: function updatePaymentDetails() {
      var _this18 = this;

      console.log("card3", this.card3Percent);
      this.grossAmount = 0;
      this.discount = 0;
      this.netAmount = 0;

      this.balance = +(this.cardPayment + this.cashPayment + this.chequePayment + this.loyalityPoints + this.giftVouchers - this.netAmount - this.card3PercentPay).toFixed(2);
      this.remaining = 0;
      this.earnedLoyalityPoints = 0;
      this.earnedReferralPoints = 0;
      this.invoTotalProfit = 0;

      var totalPrdCost = 0;

      this.products.forEach(function (product) {
        //****************previous calculation in which discount is deducted from gross amount that is bit unusual way even the
        // calculation is correct */

        // this.grossAmount += product.subTotal;
        // this.discount += +(
        //   (product.price * product.quantity * (product.discount || 0)) /
        //   100
        // ).toFixed(2);

        // // console.log("grossAmount", this.grossAmount, this.discount);
        // this.netAmount = +(this.grossAmount + this.tax - this.otherDiscount)
        //   // - this.discount // already deducted in sub total

        //   .toFixed(2);
        // *****************************************//

        _this18.grossAmount += +(product.subTotal + product.price * product.quantity * (product.discount || 0) / 100).toFixed(2); // adding discount bcz prd subtotal is calculated deducting discount.
        // normally gross amount should be the value without that discount
        _this18.discount += +(product.price * product.quantity * (product.discount || 0) / 100).toFixed(2);

        // console.log("grossAmount", this.grossAmount, this.discount);

        if (_this18.serviceChargeMode === "Percentage") {
          _this18.netAmount = +(_this18.grossAmount + _this18.grossAmount * _this18.sCharge / 100 - _this18.discount - _this18.otherDiscount).toFixed(2);
        } else {
          _this18.netAmount = +(_this18.grossAmount + _this18.sCharge - _this18.discount - _this18.otherDiscount).toFixed(2);
        }

        // if (!this.$route.query.invoice && !this.$route.query.PO) {
        //   if (this.defaultPay && this.defaultPay === 'Cash' ) {
        //     this.cashPayment = this.netAmount
        //   }
        //   if (this.defaultPay && this.defaultPay === 'Card') {
        //     this.cardPayment = this.netAmount
        //   }
        // }

        var taxAmount = _this18.taxMode === 'Percentage' ? _this18.netAmount * _this18.tax / 100 : _this18.tax;
        console.log("taxAmount", taxAmount, _this18.tax, _this18.cashPayment);
        _this18.balance = +(_this18.cardPayment + _this18.cashPayment + _this18.chequePayment + _this18.loyalityPoints + _this18.giftVouchers - _this18.netAmount - _this18.card3PercentPay - taxAmount).toFixed(2);

        _this18.remaining = _this18.balance < 0 ? -1 * _this18.balance : 0;
        totalPrdCost += product.cost * product.quantity;
        _this18.invoTotalProfit = _this18.netAmount - totalPrdCost;

        _this18.earnedLoyalityPoints = (_this18.netAmount - _this18.remaining) / 1000 * _this18.stores[0].loyalityPoints;
        _this18.earnedReferralPoints = (_this18.netAmount - _this18.remaining) / 1000 * _this18.stores[0].referralPoints;
      });
    },
    updateProducts: function updateProducts(index, row) {
      var foundPrd = this.products[index];
      foundPrd.subTotal = +(foundPrd.price * foundPrd.quantity - foundPrd.price * foundPrd.quantity * (foundPrd.discount || 0) / 100).toFixed(2);
      var prdTotalCost = foundPrd.quantity * foundPrd.cost;
      foundPrd.profit = foundPrd.subTotal - prdTotalCost;
      console.log("foundPrd", foundPrd);
      // if (!this.$route.query.invoice && !this.$route.query.return) {
      //   foundPrd.availableQnty = foundPrd.availableQnty - row.quantity;
      // }
      this.updatePaymentDetails();
      if ((this.$route.query.invoice || this.$route.query.PO) && this.$route.query.return === "true") {
        var returnAlready = this.returnedProducts.find(function (product) {
          return product.barcode === row.barcode && product.serial === row.serial && product.cost === row.cost;
        });
        var returnAlreadyOriginal = this.returnedProductsInitialClone.find(function (product) {
          return product.barcode === row.barcode && product.serial === row.serial && product.cost === row.cost;
        });
        var initialPrd = this.initialProducts.find(function (product) {
          return product.barcode === row.barcode && product.serial === row.serial && product.cost === row.cost;
        });
        if (returnAlready) {
          // console.log(returnAlready.quantity, initialPrd.quantity, row.quantity)
          // returnAlready.quantity - no of items returned
          returnAlready.quantity = +(initialPrd.quantity - row.quantity + (returnAlreadyOriginal ? returnAlreadyOriginal.quantity : 0)).toFixed(2);
          returnAlready.subTotal = +(returnAlready.price * returnAlready.quantity - returnAlready.price * returnAlready.quantity * (returnAlready.discount || 0) / 100).toFixed(2);
          // foundPrd.availableQnty =
          //   initialPrd.availableQnty + returnAlready.quantity;
          foundPrd.noOfReturns = returnAlready.quantity;
          // console.log("already this.returnedProducts", this.returnedProducts);
        } else {
          // console.log(foundPrd.availableQnty, row.availableQnty);
          var quantity = +(initialPrd.quantity - row.quantity).toFixed(2);
          // foundPrd.availableQnty = foundPrd.availableQnty + quantity;
          foundPrd.noOfReturns = quantity;
          this.returnedProducts.push({
            quantity: quantity,
            name: row.name,
            barcode: row.barcode,
            discount: row.discount,
            subTotal: +(row.price * quantity - row.price * quantity * (row.discount || 0) / 100).toFixed(2),
            price: row.price,
            category: row.category,
            subcategory: row.subcategory,
            cost: row.cost
          });
          this.hasReturned = true;
          // console.log("this.returnedProducts", this.returnedProducts);
        }
      }
      // console.log("prds", this.products);
    },

    // Create callback function to receive barcode when the scanner is already done
    onBarcodeScanned: function onBarcodeScanned(barcode) {
      if (this.$route.query.invoice || this.$route.query.PO) {
        return this.$notify.error({
          title: "Error",
          message: "Cannot add items when returning",
          type: "error"
        });
      }
      // console.log("barcode", barcode);
      this.productBarcode = barcode;
      this.fetchProducts(barcode);
      // if (!this.isInvoiceRendered) this.renderInvoice()
      this.isInvoiceRendered = true;
      // do something...
    },

    // Reset to the last barcode before hitting enter (whatever anything in the input box)
    resetBarcode: function resetBarcode() {
      var barcode = this.$barcodeScanner.getPreviousCode();
      // do something...
    },


    // invoice table
    handleEdit: function handleEdit(index, row) {
      // console.log(index, row);
    },
    handleDelete: function handleDelete(index, row) {
      // console.log("row", row);
      var oldProducts = this.products;
      this.products.splice(index, 1);
      if ((this.$route.query.invoice || this.$route.query.PO) && this.$route.query.return === "true") {
        this.returnedProducts.push(row);
        this.hasReturned = true;
      }
      // console.log("this.returnedProducts", this.returnedProducts);
      this.updatePaymentDetails();
    },
    resetData: function resetData() {
      this.isInvoiceRendered = true;
      this.isInvoiceCreated = false;
      this.search = "";
      this.customer = "";
      this.referralCustomer = "";
      this.referralCustomerMobile = "";
      this.referralCustomerName = "";
      this.productBarcode = "";
      this.invoiceNo = Math.floor(Math.random() * 10000000001).toString();
      this.date = "";
      this.invoiceDate = __WEBPACK_IMPORTED_MODULE_9_firebase_app__["a" /* default */].firestore.Timestamp.now();
      this.customerMobile = "";
      this.customerName = "";
      this.customerTotalLoyalityPoints = 0;
      this.maxLoyalityPoints = 0;
      this.grossAmount = 0;
      this.discount = 0;
      this.otherDiscount = 0;
      this.tax = 0;
      this.loyalityPoints = 0;
      this.giftVouchers = 0;
      this.earnedLoyalityPoints = 0;
      this.earnedReferralPoints = 0;
      this.netAmount = 0;
      this.cardPayment = 0;
      this.cashPayment = 0;
      this.chequePayment = 0;
      this.balance = 0;
      this.remaining = 0;
      this.dialogTableVisible = false;
      this.disabled = false;
      this.priceData = [];
      this.currentProduct = {};
      this.currentRow = null;
      this.initialProducts = [];
      this.returnedProducts = [];
      this.returnedProductsInitialClone = [];
      this.returnInvoiceData = "";
      this.hasReturned = false;
      this.products = [];
      this.card3Percent = false;
      this.card3PercentPay = 0;
      this.reportTotalRemaining = 0;
      this.reportTotalSales = 0;
      this.reportTotalProfit = 0;
      this.invoTotalProfit = 0;
      // this.profitReport = {}; this get reset before updating the report data
      this.formdata = {
        name: "",
        telephone: ""
      };
    },
    handleSelect: function handleSelect(item) {
      var _this19 = this;

      // console.log(item);
      this.reports = [];
      if (!this.$route.query.invoice && !this.$route.query.PO) {
        this.products = []; // bcz already added item may not available for the newly selected store
      }
      this.categories = "";
      this.analyticsReport = {};
      this.profitReport = {};
      var date = new Date(this.invoiceDate.toDate().toISOString());
      var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 1);
      console.log("dates", firstDay, lastDay, date, this.invoiceDate);
      // console.log("storeeee", this.storeLocation);
      this.$store.state.secondaryDatabase.collection("reports").where("date", ">=", __WEBPACK_IMPORTED_MODULE_9_firebase_app__["a" /* default */].firestore.Timestamp.fromDate(firstDay)).where("date", "<=", __WEBPACK_IMPORTED_MODULE_9_firebase_app__["a" /* default */].firestore.Timestamp.fromDate(lastDay)).where("storeLocation", "==", this.storeLocation).get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          var data = {
            id: doc.id,
            categories: doc.data().reportData,
            profitData: doc.data().profitData,
            totalPurcCost: doc.data().totalPurcCost,
            totalPurcDue: doc.data().totalPurcDue,
            totalSales: doc.data().totalSales,
            totalProfit: doc.data().totalProfit,
            totalRemaining: doc.data().totalRemaining
          };
          _this19.reports.push(data);
          console.log("report", data);
          _this19.jsonDataforTest.reportInit = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_this19.reports[0]));
          _this19.analyticsReport = _this19.reports[0].categories;
          _this19.profitReport = _this19.reports[0].profitData;
          if (_this19.$route.name === "create-purchase-order") {
            _this19.reportTotalSales = _this19.reports[0].totalPurcCost;
            _this19.reportTotalRemaining = _this19.reports[0].totalPurcDue;
          }
          if (_this19.$route.name === "createinvoice") {
            _this19.reportTotalSales = _this19.reports[0].totalSales;
            _this19.reportTotalProfit = _this19.reports[0].totalProfit;
            _this19.reportTotalRemaining = _this19.reports[0].totalRemaining;
          }
          _this19.isReportExsists = true;

          console.log("this.categories is", _this19.analyticsReport, _this19.profitReport);
        });
        if (!_this19.reports[0]) {
          _this19.isReportExsists = false;
          console.log("this.shops[0]t is", _this19.shops[0]);
          _this19.categories = _this19.shops[0].categories;
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this19.categories).forEach(function (key, index) {
            _this19.analyticsReport[key] = {};
            _this19.profitReport[key] = {};
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this19.categories[key]).forEach(function (subcat, index) {
              _this19.analyticsReport[key][subcat] = 0;
              _this19.profitReport[key][subcat] = 0;
            });
          });
          // console.log("this.analyticsReport is", this.analyticsReport);
        }
      }).catch(function (error) {
        return console.log(error);
      });
    },
    handleSupplierChange: function handleSupplierChange() {
      var _this20 = this;

      if (this.supplierMobile) {
        // console.log(customerType);
        var telephone = this.supplierMobile;

        var docRef = this.$store.state.secondaryDatabase.collection("suppliers");
        var firestoreQuery = docRef;
        if (this.$store.state.noDB === true) {
          firestoreQuery = firestoreQuery.where("shopOwner", "==", __WEBPACK_IMPORTED_MODULE_9_firebase_app__["a" /* default */].auth().currentUser.uid);
        }
        firestoreQuery.where("telephone", "==", +telephone).get().then(function (querySnapshot) {
          var isCustomerFound = void 0;
          querySnapshot.forEach(function (doc) {
            if (doc) isCustomerFound = true;
            var data = {
              id: doc.id,
              name: doc.data().name,
              // totalLoyalityPoints: doc.data().totalLoyalityPoints,
              totalPayment: doc.data().totalPayment,
              totalRemaining: doc.data().totalRemaining
            };
            _this20.supplier = data;
            _this20.jsonDataforTest.supInit = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(data));
            _this20.supplierName = data.name;
          });
          _this20.$notify({
            title: "Supplier Found",
            message: "Supplier found for telephone no " + telephone,
            type: "success"
          });
          if (!isCustomerFound) {
            return _this20.$notify.error({
              title: "Error",
              message: "Supplier not found for telephone no " + telephone,
              type: "error"
            });
          }
        }).catch(function (error) {
          return alert(error.message);
        });
      }
    },
    handleCustomerChange: function handleCustomerChange(customerType) {
      var _this21 = this;

      if (this.customerMobile || this.referralCustomerMobile) {
        // console.log(customerType);
        var telephone = void 0;
        if (customerType === "customer") {
          telephone = this.customerMobile;
          this.customer = "";
          this.customerName = "";
        }
        if (customerType === "referral") {
          telephone = this.referralCustomerMobile;
          this.referralCustomer = "";
          this.referralCustomerName = "";
        }
        var docRef = this.$store.state.secondaryDatabase.collection("customers");
        var firestoreQuery = docRef;
        if (this.$store.state.noDB === true) {
          firestoreQuery = firestoreQuery.where("shopOwner", "==", __WEBPACK_IMPORTED_MODULE_9_firebase_app__["a" /* default */].auth().currentUser.uid);
        }
        firestoreQuery.where("telephone", "==", +telephone).get().then(function (querySnapshot) {
          var isCustomerFound = void 0;
          querySnapshot.forEach(function (doc) {
            if (doc) isCustomerFound = true;
            var data = {
              id: doc.id,
              name: doc.data().name,
              totalLoyalityPoints: doc.data().totalLoyalityPoints,
              totalPayment: doc.data().totalPayment,
              totalRemaining: doc.data().totalRemaining
            };
            if (customerType === "customer") {
              _this21.customer = data;
              _this21.jsonDataforTest.cusInit = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(data));
              _this21.customerName = data.name;
              _this21.customerTotalLoyalityPoints = data.totalLoyalityPoints;
              _this21.maxLoyalityPoints = data.totalLoyalityPoints;
            }
            if (customerType === "referral") {
              _this21.referralCustomer = data;
              _this21.jsonDataforTest.refCusInit = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(data));
              _this21.referralCustomerName = data.name;
              // console.log("this.referralCustomer", this.referralCustomer);
            }
          });
          _this21.$notify({
            title: "Customer Found",
            message: "Customer found for telephone no " + telephone,
            type: "success"
          });
          if (!isCustomerFound) {
            return _this21.$notify.error({
              title: "Error",
              message: "Customer not found for telephone no " + telephone,
              type: "error"
            });
          }
        }).catch(function (error) {
          return alert(error.message);
        });
      }
    },
    handleProductChange: function handleProductChange(item) {
      var _this22 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                console.log(_this22.productBarcode);
                _this22.productBarcode = item.barcode;
                console.log(_this22.productBarcode);

                if (!(_this22.$route.query.invoice || _this22.$route.query.PO)) {
                  _context4.next = 5;
                  break;
                }

                return _context4.abrupt("return", _this22.$notify.error({
                  title: "Error",
                  message: "Cannot add items when returning",
                  type: "error"
                }));

              case 5:
                if (!item) {
                  _context4.next = 8;
                  break;
                }

                _context4.next = 8;
                return _this22.fetchProducts(item.barcode);

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this22);
      }))();
    },
    fetchProducts: function fetchProducts(barcode) {
      var _this23 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var foundPrd;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(_this23.storeLocation === "" || _this23.storeLocation === undefined)) {
                  _context5.next = 2;
                  break;
                }

                return _context5.abrupt("return", alert("Please select store location"));

              case 2:
                foundPrd = _this23.products.find(function (product) {
                  return product.barcode === barcode;
                });

                if (foundPrd) {
                  _this23.currentProduct = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(foundPrd));
                  // foundPrd.quantity += 1;
                  // this.updateProducts(1, foundPrd); // 1 is table index passed and its not used
                  _this23.updatePriceData(foundPrd);
                }
                if (!foundPrd) {
                  _this23.$store.state.secondaryDatabase.collection("products").where("owner", "==", __WEBPACK_IMPORTED_MODULE_9_firebase_app__["a" /* default */].auth().currentUser.uid).where("barcode", "==", barcode).get().then(function (querySnapshot) {
                    var isProductFound = void 0;
                    querySnapshot.forEach(function (doc) {
                      if (doc) isProductFound = true;
                      var data = {
                        id: doc.id,
                        name: doc.data().name,
                        barcode: doc.data().barcode,
                        category: doc.data().cat,
                        altertQunty: doc.data().altertQunty,
                        price: +doc.data().disprice.toFixed(2),
                        priceList: doc.data().priceList,
                        subcategory: doc.data().subcat,
                        discount: +doc.data().dis.toFixed(2),
                        // qntyList: doc.data().quantity,
                        quantity: 1,
                        //*********** not using as subtotal get updated correctly in handleCurrentChange(val) */
                        subTotal: +(doc.data().disprice * 1 - doc.data().disprice * (doc.data().dis || 0) / 100).toFixed(2) //*********** not using as subtotal get updated correctly in handleCurrentChange(val) */
                      };
                      _this23.currentProduct = data;
                      _this23.updatePriceData(data);
                    });
                    if (!isProductFound) {
                      return _this23.$notify.error({
                        title: "Error",
                        message: "Product not found for barcode " + barcode,
                        type: "error"
                      });
                    }
                  }).catch(function (error) {
                    return alert(error.message);
                  });
                }

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this23);
      }))();
    },
    updatePriceData: function updatePriceData(data) {
      var _this24 = this;

      this.priceData = [];
      if (data.priceList && data.priceList.length > 0) {
        var storePriceList = [];
        data.priceList.forEach(function (price) {
          if (price.store === _this24.storeLocation) storePriceList.push(price);
        });
        if (storePriceList.length === 0 && this.$route.name === "createinvoice") {
          return this.$notify.error({
            title: "Error",
            message: data.name + " not available in the system's stock for the store",
            type: "error"
          });
        }
        if (storePriceList.length === 0 && this.$route.name === "create-purchase-order") {
          var priceForStore = {
            sellPr: 0,
            purcPr: 0,
            quantity: 0,
            serial: "",
            store: this.storeLocation
          };
          storePriceList.push(priceForStore);
          this.currentProduct.priceList.push(priceForStore);
        }
        storePriceList.forEach(function (price) {
          if (_this24.$route.name === "createinvoice" || _this24.$route.name === "create-quotation") {
            _this24.priceData.push({
              name: data.name,
              price: +price.sellPr.toFixed(2),
              cost: +price.purcPr.toFixed(2),
              serial: price.serial,
              quantity: price.quantity
            });
          }
          if (_this24.$route.name === "create-purchase-order") {
            _this24.priceData.push({
              name: data.name,
              price: +price.purcPr.toFixed(2), // when adding PO price should be purcPr in prodUpdates methods
              cost: +price.purcPr.toFixed(2),
              serial: price.serial
            });
          }
        });
        if (this.priceData.length === 1) {
          if (storePriceList[0].quantity === 0 && this.$route.name === "createinvoice") {
            return this.$notify.error({
              title: "Error",
              message: data.name + " not available in the system's stock for the store",
              type: "error"
            });
          }
          this.handleCurrentChange(this.priceData[0]);
        } else this.dialogTableVisible = true;
      } else {
        // *************no need & not using as always having pricelist
        // this.products.push(data);
        // this.updatePaymentDetails();

        return this.$notify.error({
          title: "Error",
          message: data.name + " not available in the system's stock for the store",
          type: "error"
        });
        // console.log("this.categories is", this.products);
      }
    },
    handleCurrentChange: function handleCurrentChange(val) {
      var _this25 = this;

      if (val) {
        console.log("vallll", val);
        if (this.$route.name === "createinvoice" && val.quantity <= 0) {
          this.dialogTableVisible = false;
          return this.$notify.error({
            title: "Error",
            message: val.name + " not available in the system's stock for the store",
            type: "error"
          });
        }

        this.currentRow = val.price;
        //this.currentProduct.name = `${this.currentProduct.name} - ${val.serial}`
        this.currentProduct.price = val.price;
        this.currentProduct.cost = val.cost;
        this.currentProduct.serial = val.serial;
        this.currentProduct.subTotal = +(val.price * 1 - val.price * (this.currentProduct.discount || 0) / 100).toFixed(2);
        this.currentProduct.profit = this.currentProduct.subTotal - val.cost;

        this.currentProduct.availableQnty = this.currentProduct.priceList.find(function (item) {
          return item.store === _this25.storeLocation && item.serial === val.serial && item.purcPr === val.cost;
        }).quantity;

        var foundPrdWithSamePrice = this.products.find(function (product) {
          return product.barcode === _this25.productBarcode && product.cost === val.cost && product.serial === val.serial && product.price === val.price;
        } // compare with cost bcz qantity count on purcPr
        );
        console.log("foundPrdWithSamePrice", foundPrdWithSamePrice, val);
        if (foundPrdWithSamePrice) {
          var index = this.products.findIndex(function (product) {
            return product.barcode === _this25.productBarcode && product.serial === val.serial && product.cost === val.cost && product.price === val.price;
          });
          foundPrdWithSamePrice.quantity += 1;
          this.updateProducts(index, foundPrdWithSamePrice);
        } else {
          this.currentProduct.quantity = 1;
          if (this.$route.query.kot || this.$route.query.order || this.$route.query.job) {
            var itemList = [];
            if (this.$route.query.kot) itemList = this.kotItems;
            if (this.$route.query.job) itemList = this.jobItems;
            if (this.$route.query.order) itemList = this.orderItems;
            console.log("kotItems", itemList, this.productBarcode);
            var isPrdInList = itemList.find(function (kotItem) {
              return kotItem.barcode === _this25.currentProduct.barcode;
            });
            this.currentProduct.quantity = isPrdInList ? isPrdInList.quantity : 1;
            this.currentProduct.subTotal = +(val.price * this.currentProduct.quantity - val.price * (this.currentProduct.discount || 0) / 100).toFixed(2);
            this.currentProduct.profit = this.currentProduct.subTotal - this.currentProduct.quantity * val.cost;
          }
          this.products.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.currentProduct)));
          console.log("this.products", this.products);
          this.updatePaymentDetails();
        }

        this.currentProduct = {};
        this.productBarcode = "";
        console.log("this.products", this.products);
        this.dialogTableVisible = false;
      }
    }
  }
});

/***/ }),
/* 413 */,
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_os__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_os___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_os__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "posprinter",
  props: ["products", "invoiceNo", "cashier", "grossAmount", "discount", "otherDiscount", "tax", "sCharge", "dilCharge", "netAmount", "cardPayment", "cashPayment", "chequePayment", "giftVouchers", "balance", "remaining", "loyalityPoints", "earnedLoyalityPoints", "totalLoyalityPoints", "address", "telephone", "logo", "name", "footer", "customer", "customerName", "supplierName", "type", "date"],
  data: function data() {
    return {};
  },
  created: function created() {},

  methods: {}
});

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_barcode__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_barcode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_barcode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InvoiceTemplates_POSPrinter_vue__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_easy_print__ = __webpack_require__(123);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "createbarcode",
  components: {
    barcode: __WEBPACK_IMPORTED_MODULE_2_vue_barcode___default.a,
    POSPrinter: __WEBPACK_IMPORTED_MODULE_3__InvoiceTemplates_POSPrinter_vue__["a" /* default */],
    vueEasyPrint: __WEBPACK_IMPORTED_MODULE_4_vue_easy_print__["a" /* default */]
  },
  data: function data() {
    return {
      barcodeValue: "test",
      text: '<p>text here</p> <p>more text</p>'
    };
  },
  created: function created() {},

  methods: {
    printDemo: function printDemo() {
      // console.log("print");
      this.$refs.easyPrint.print();
    },
    print: function print() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$htmlToPaper("pdf");

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }
});

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_FirebaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PrintInvo_vue__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TableHeader_vue__ = __webpack_require__(91);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "invoicelist",
  components: { PrintInvo: __WEBPACK_IMPORTED_MODULE_3__PrintInvo_vue__["a" /* default */], TableHeader: __WEBPACK_IMPORTED_MODULE_4__TableHeader_vue__["a" /* default */] },
  data: function data() {
    return {
      emptyText: "Loading Records...",
      items: [],
      visibleFields: ["index", "date", "invoiceNo", "customer", "netAmount", "soldItems", "updatedBy", "updated", "note", "actions"],
      fields: [
      // "index",
      //  { key: 'id', label: 'Order id', sortable: true },
      { key: "date", label: "Date", sortable: true }, { key: "invoiceNo", label: "Invoice No", sortable: true },
      // { key: "storeLocation", label: "Store" },
      { key: "customer", label: "Customer", sortable: true }, { key: "grossAmount", label: "Gross Amount", sortable: true }, { key: "discount", label: "Discount", sortable: true }, { key: "otherDiscount", label: "Other Discount", sortable: true },
      // { key: "tax", label: "tax", sortable: true },
      { key: "netAmount", label: "Net Amount", sortable: true }, { key: "soldItems", label: "Sold Items", sortable: true }, { key: "cardPayment", label: "Card Payment", sortable: true }, { key: "cashPayment", label: "Cash Payment", sortable: true }, { key: "credit", label: "Credit", sortable: true }, { key: "balance", label: "Balance", sortable: true }, { key: "note", label: "Note", sortable: false }, { key: "sCharge", label: "Service Charge", sortable: true }, { key: "dilCharge", label: "Delivery Charge", sortable: true },
      // { key: "status", label: "Status", sortable: true },
      { key: "updatedBy", label: "Updated By", sortable: true }, { key: "updated", label: "Updated", sortable: true }, { key: "actions", label: "Actions" }],
      productsFields: ["index", { key: "name", label: "Name", sortable: true }, { key: "barcode", label: "Barcode", sortable: true }, { key: "category", label: "Category", sortable: true }, { key: "subcategory", label: "Sub Category", sortable: true }, { key: "quantity", label: "Quantity", sortable: true }, { key: "price", label: "Price", sortable: true }, { key: "discount", label: "Discount", sortable: true }, { key: "subTotal", label: "Sub Total", sortable: true }],
      stores: this.$store.state.stores, // [{ value: null, text: "Select Store Location", disabled: true }],
      storeLocation: this.$store.state.selectedStore,
      month: new Date(),
      invoiceNo: "",
      customer: "",
      cashier: null,
      productId: "",
      currentPage: 1,
      perPage: 10,
      totalRows: items.length,
      pageOptions: ["Per Page", 5, 10, 15],
      sortBy: null,
      sortDesc: false,
      filter: null,
      isLoggedIn: false,
      currentUser: false,
      modalInfo: { title: "", content: "" },
      loading: false,
      loading1: false,
      loading2: false,
      changed: false,
      shops: [],
      orders: "",
      showDetails: false,
      shopCategory: ''
    };
  },


  computed: {
    sortOptions: function sortOptions() {
      // Create an options list from our fields
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return { text: f.label, value: f.key };
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$root.$on("columnChanged", function (data) {
      console.log("columnChanged", data);
      // data.splice(data.length - 2, 1, );
      // data.push('actions');
      _this.visibleFields = data;
    });
    // this.$root.$on("storeChange", (store) => {
    //   this.$store.state.selectedStore = store;
    //   this.storeLocation = store
    // });
  },

  methods: {
    changeStore: function changeStore() {
      //this.$root.$emit("storeChange", this.storeLocation);
      //this.$store.state.selectedStore = this.storeLocation
      console.log(this.storeLocation);
    },
    printInvoice: function printInvoice(storeLocation, item) {
      var store = this.$store.state.stores.find(function (store) {
        return store.id === storeLocation;
      });
      this.$root.$emit("printClicked", store, item);
    },
    disabledDate: function disabledDate(date) {
      return date > new Date();
    },
    searchInvoices: function searchInvoices() {
      var _this2 = this;

      if (!this.month && this.customer === "" && this.invoiceNo === "" && !this.cashier) {
        return alert("Please select month");
      }
      if (!this.storeLocation && this.customer === "" && this.invoiceNo === "") {
        return alert("Please select store location");
      }
      this.loading = true;
      this.changed = false;
      this.items = [];
      // console.log(
      //   "values",
      //   this.month,
      //   this.storeLocation,
      //   this.invoiceNo,
      //   this.customer
      // );
      var docRef = this.$store.state.secondaryDatabase.collection("invoices");
      var firestoreQuery = docRef;
      if (this.month) {
        var date = new Date(this.month);
        var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
        var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 1);
        // console.log("dates", firstDay, lastDay);
        firestoreQuery = firestoreQuery.where("date", ">=", __WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].firestore.Timestamp.fromDate(firstDay));
        firestoreQuery = firestoreQuery.where("date", "<=", __WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].firestore.Timestamp.fromDate(lastDay));
      }
      if (this.storeLocation) {
        firestoreQuery = firestoreQuery.where("storeLocation", "==", this.storeLocation);
      }
      if (this.invoiceNo) {
        firestoreQuery = firestoreQuery.where("invoiceNo", "==", this.invoiceNo);
      }
      if (this.cashier) {
        firestoreQuery = firestoreQuery.where("cashier", "==", this.cashier);
      }
      if (this.customer) {
        firestoreQuery = firestoreQuery.where("customerMobile", "==", this.customer);
      }
      // console.log('query',firestoreQuery)
      firestoreQuery.orderBy("date", "desc").get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          var data = {
            id: doc.id,
            products: doc.data().products,
            date: doc.data().date.toDate().toLocaleString(),
            invoiceNo: doc.data().invoiceNo,
            storeLocation: doc.data().storeLocation,
            cashier: doc.data().cashier,
            cashierName: doc.data().cashierName,
            customer: doc.data().customer,
            customerMobile: doc.data().customerMobile,
            grossAmount: doc.data().grossAmount,
            discount: doc.data().discount,
            otherDiscount: doc.data().otherDiscount,
            tax: doc.data().tax,
            sCharge: doc.data().sCharge,
            dilCharge: doc.data().dilCharge || 0,
            taxMode: doc.data().taxMode || "Percentage",
            serviceChargeMode: doc.data().serviceChargeMode || "Percentage",
            netAmount: doc.data().netAmount,
            cardPayment: doc.data().cardPayment,
            cashPayment: doc.data().cashPayment,
            chequePayment: doc.data().chequePayment,
            balance: doc.data().balance,
            updated: doc.data().updated.toDate().toLocaleString(),
            updatedBy: doc.data().updatedBy,
            profit: doc.data().profit,
            note: doc.data().note,
            _showDetails: false // toggle row details
          };
          data.sCharge = data.serviceChargeMode === 'Percentage' ? data.grossAmount * data.sCharge / 100 : data.sCharge;
          var totalSold = 0;
          data.products.forEach(function (p) {
            return totalSold += p.quantity;
          });
          data.soldItems = totalSold;
          _this2.items.push(data);
          _this2.totalRows = _this2.items.length;
        });
        if (_this2.items.length == 0) {
          _this2.emptyText = "There are no records to show";
        }
        _this2.loading = false;
        _this2.changed = true;
      });
    },
    open: function open(id) {
      var _this3 = this;

      this.$confirm("This will permanently delete the item. Continue?", "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
        center: true
      }).then(function () {
        _this3.deleteOrder(id);
      }).catch(function () {
        _this3.$message({
          type: "info",
          message: "Delete canceled"
        });
      });
    },

    // open2(id) {
    //   this.$confirm('This will change the order status. Continue?', 'Warning', {
    //     confirmButtonText: 'OK',
    //     cancelButtonText: 'Cancel',
    //     type: 'warning',
    //     center: true
    //   }).then(() => {
    //     this.upOrder(id)
    //   }).catch(() => {
    //     this.$message({
    //       type: 'info',
    //       message: 'Change canceled'
    //     });
    //   });
    // },
    open3: function open3() {
      this.$notify.info({
        title: "Info",
        message: "Order status is updated"
      });
    },
    upOrder: function upOrder(id, status, refid) {
      var _this4 = this;

      this.$store.state.secondaryDatabase.collection("orders").doc(id).update({
        status: status
      }).then(function () {
        _this4.open3();
        __WEBPACK_IMPORTED_MODULE_1__config_FirebaseInit__["a" /* default */].collection("orders").doc(refid).update({
          status: status
        }).then(function () {}).catch(function (error) {
          return alert(error);
        });
      }).catch(function (error) {
        return alert(error);
      });
    },
    info: function info(item, index, button) {
      this.modalInfo.title = "Row index: " + index;
      this.modalInfo.content = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item, null, 2);
      this.$root.$emit("bv::show::modal", "modalInfo", button);
    },
    resetModal: function resetModal() {
      this.modalInfo.title = "";
      this.modalInfo.content = "";
    },
    onFiltered: function onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getId: function getId(item) {
      //console.log('getId fun invoked')
      this.productId = item.id;
      //console.log(this.productId)
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    backToTop: function backToTop() {
      $("html,body").stop().animate({
        scrollTop: 0
      }, "fast", "swing");
    }
  },
  created: function created() {
    var _this5 = this;

    //  if(firebase.auth().currentUser) {
    //       this.isLoggedIn = true;
    //       this.currentUser = firebase.auth().currentUser.email;
    //   }
    __WEBPACK_IMPORTED_MODULE_1__config_FirebaseInit__["a" /* default */].collection('shops').where('owner', '==', __WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].auth().currentUser.uid).get().then(function (querySnapshot) {
      querySnapshot.forEach(function (doc) {
        var data = {
          'id': doc.id
        };
        _this5.shops.push(data);
        _this5.shopCategory = doc.data().cat;
      });
    });
    this.backToTop();
    this.loading = true;
    this.changed = false;
    this.$store.state.secondaryDatabase.collection("invoices").where("storeLocation", "==", this.$store.state.selectedStore).orderBy("date", "desc").limit(10).get().then(function (querySnapshot) {
      querySnapshot.forEach(function (doc) {
        var data = {
          id: doc.id,
          products: doc.data().products,
          date: doc.data().date.toDate().toLocaleString(),
          invoiceNo: doc.data().invoiceNo,
          storeLocation: doc.data().storeLocation,
          cashier: doc.data().cashier,
          cashierName: doc.data().cashierName,
          customer: doc.data().customer,
          customerMobile: doc.data().customerMobile,
          grossAmount: doc.data().grossAmount,
          discount: doc.data().discount,
          otherDiscount: doc.data().otherDiscount,
          tax: doc.data().tax,
          sCharge: doc.data().sCharge,
          dilCharge: doc.data().dilCharge || 0,
          taxMode: doc.data().taxMode || "Percentage",
          serviceChargeMode: doc.data().serviceChargeMode || "Percentage",
          netAmount: doc.data().netAmount,
          cardPayment: doc.data().cardPayment,
          cashPayment: doc.data().cashPayment,
          chequePayment: doc.data().chequePayment,
          balance: doc.data().balance,
          updated: doc.data().updated.toDate().toLocaleString(),
          updatedBy: doc.data().updatedBy,
          profit: doc.data().profit,
          note: doc.data().note,
          _showDetails: false // toggle row details
        };
        data.sCharge = data.serviceChargeMode === 'Percentage' ? data.grossAmount * data.sCharge / 100 : data.sCharge;
        var totalSold = 0;
        data.products.forEach(function (p) {
          return totalSold += p.quantity;
        });
        data.soldItems = totalSold;
        _this5.items.push(data);
        //console.log("doc.data()", doc.data());
        _this5.totalRows = _this5.items.length;
      });
      if (_this5.items.length == 0) {
        _this5.emptyText = "There are no records to show";
      }
      // const docRef = this.$store.state.secondaryDatabase.collection("stores");
      // let firestoreQuery = docRef;
      // if(this.$store.state.noDB === true) {
      //   firestoreQuery = firestoreQuery.where("shopOwner", "==", firebase.auth().currentUser.uid)
      // }
      // firestoreQuery
      //   .get()
      //   .then((querySnapshot) => {
      //     querySnapshot.forEach((doc) => {
      //       const data = {
      //         id: doc.id,
      //         value: doc.id,
      //         text: doc.data().name,
      //         name: doc.data().name,
      //       };
      //       this.stores.push(data);
      //     });
      //   })
      //   .catch((error) => alert(error.message));
      _this5.loading = false;
      _this5.changed = true;
    });
    // this.$store.state.secondaryDatabase
    //   .collection("shops")
    //   .where("owner", "==", firebase.auth().currentUser.uid)
    //   .get()
    //   .then((querySnapshot) => {
    //     querySnapshot.forEach((doc) => {
    //       const data = {
    //         id: doc.id,
    //         orders: doc.data().orders,
    //       };
    //       this.shops.push(data);
    //       this.orders = this.shops[0].orders;
    //     });
    //   });
    // })
  }
});

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__InvoiceTemplates_POSPrinter_vue__ = __webpack_require__(139);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "printInvo",
  components: { POSPrinter: __WEBPACK_IMPORTED_MODULE_1__InvoiceTemplates_POSPrinter_vue__["a" /* default */] },
  props: ["printInvoType"],
  data: function data() {
    return {
      address: "",
      telephone: "",
      logo: "",
      name: "",
      footer: "",
      printOnly: "",
      taxMode: "",
      serviceChargeMode: "",
      billCssFile: "../../../../static/pos.css",
      showPrintPopup: "",
      store: "",
      invoData: "",
      invoiceItem: ""
    };
  },

  watch: {
    // invoiceItem() {
    //   this.invoData = this.invoiceItem;
    // },
  },
  mounted: function mounted() {
    var _this = this;

    this.$root.$on("printClicked", function (store, item) {
      _this.invoData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item);
      _this.store = store;
      console.log("this.stores ", _this.store, item, _this.invoData);
      _this.updateSettings();
      if (_this.invoData) {
        setTimeout(function () {
          _this.PrintElem("print");
        }, 200);
      }
    });
  },
  created: function created() {},

  methods: {
    updateSettings: function updateSettings() {
      this.address = this.store.address;
      this.telephone = this.store.telephone;
      this.logo = this.store.logo;
      this.name = this.store.name;
      this.footer = this.store.setting.footer;
      this.printOnly = this.store.setting.printOnly;
      this.taxMode = this.store.setting.taxMode || "Percentage";
      this.serviceChargeMode = this.store.setting.serviceChargeMode || "Percentage";
      // console.log("this.shops[0].printPaperSize", this.shops[0].printSize);
      if (this.store.setting.printSize === "A4" || this.store.setting.printSize === "A5") {
        this.billCssFile = "../../../../static/posA4.css";
      }
      if (this.store.setting.printSize === "POS Printer 58 mm Paper") {
        this.billCssFile = "../../../../static/pos.css";
        console.log("ifffffffffff this.billCssFile");
      }
      console.log("this.billCssFile", this.store.setting.printSize, this.billCssFile);
      if (this.store.setting.printPopup) this.showPrintPopup = true;
    },
    PrintElem: function PrintElem(elem) {
      var mywindow = window.open("", "PRINT", "fullscreen=yes");

      mywindow.document.write("<html><head><title>" + document.title + "</title>");

      mywindow.document.write("<link rel=\"stylesheet\" href=\"" + this.billCssFile + "\" type=\"text/css\" />");
      mywindow.document.write("</head><body >");
      mywindow.document.write(document.getElementById(elem).innerHTML);
      mywindow.document.write("</body></html>");

      mywindow.document.close(); // necessary for IE >= 10
      mywindow.focus(); // necessary for IE >= 10*/

      mywindow.print();
      if (!this.showPrintPopup) {
        mywindow.close();
      }

      return true;
    }
  }
});

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_FirebaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_app__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "managecategories",
  data: function data() {
    return {
      inputVisible: false,
      inputValue: "",
      shops: [],
      categories: "",
      tableData: []
    };
  },
  created: function created() {
    var _this = this;

    this.$store.state.secondaryDatabase.collection("shops").where("owner", "==", __WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].auth().currentUser.uid).get().then(function (querySnapshot) {
      querySnapshot.forEach(function (doc) {
        var data = {
          id: doc.id,
          categories: doc.data().categories,
          shopcat: doc.data().cat,
          shoptype: doc.data().shoptype,
          curProducts: doc.data().curProducts,
          maxProducts: doc.data().maxProducts,
          loc: doc.data().location,
          shopname: doc.data().name,
          catValues: doc.data().catValues,
          cansearch: doc.data().search
        };
        _this.shops.push(data);
        _this.categories = _this.shops[0].categories;
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this.categories).sort().forEach(function (key, index) {
          var subcategories = [];
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this.categories[key]).sort().forEach(function (subcat, index) {
            return subcategories.push(subcat);
          });
          _this.tableData.push({
            mainCategory: key,
            subCategories: subcategories,
            newCategory: "",
            inputVisible: false
          });
        });
        // console.log("this.categories is", this.categories, this.tableData);
      });
    }).catch(function (error) {
      return alert(error);
    });
  },

  methods: {
    openDelete: function openDelete(category) {
      var _this2 = this;

      this.$confirm("This will permanently delete the category. Continue?", "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
        center: true
      }).then(function () {
        _this2.deleteMainCat(category);
      }).catch(function () {
        _this2.$message({
          type: "info",
          message: "Delete canceled"
        });
      });
    },
    openDelete2: function openDelete2(tag, index, row) {
      var _this3 = this;

      this.$confirm("This will permanently delete the category. Continue?", "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
        center: true
      }).then(function () {
        _this3.handleClose(tag, index, row);
      }).catch(function () {
        _this3.$message({
          type: "info",
          message: "Delete canceled"
        });
      });
    },

    // tag table tags
    handleClose: function handleClose(tag, index, row) {
      if (this.categories[row.mainCategory][tag] && this.categories[row.mainCategory][tag] !== 0) {
        // console.log(this.categories[row.mainCategory][tag]);
        this.$notify({
          title: "Error",
          message: "Delete all products in this category first to delete the category",
          type: "error",
          duration: 0
        });
      } else {
        row.subCategories.splice(row.subCategories.indexOf(tag), 1);
        delete this.categories[row.mainCategory][tag];
        // console.log("this.categories", this.categories);
        this.$store.state.secondaryDatabase.collection("shops").doc(this.shops[0].id).update({
          categories: this.categories
        }).then(function (doc) {}).catch(function (error) {
          return alert(error);
        });
      }
    },
    showInput: function showInput(index, row) {
      // console.log(index);
      row.inputVisible = true;
      // this.$nextTick(_ => {
      //   this.$refs[index].$refs.input.focus();
      // });
    },
    handleInputConfirm: function handleInputConfirm(index, row) {
      var inputValue = this.inputValue;
      if (row.newCategory) {
        // console.log(row.newCategory);
        row.subCategories.push(row.newCategory);
        this.categories[row.mainCategory][row.newCategory] = 0;
        this.$store.state.secondaryDatabase.collection("shops").doc(this.shops[0].id).update({
          categories: this.categories
        }).then(function (doc) {}).catch(function (error) {
          return alert(error);
        });
        // console.log("this.categories", this.categories);
      }
      row.inputVisible = false;
      // console.log(row.subCategories);
      row.newCategory = "";
    },
    deleteMainCat: function deleteMainCat(category) {
      // console.log(this.shops[0].catValues[category]);
      if (this.shops[0].catValues[category] && this.shops[0].catValues[category] !== 0) {
        // console.log(this.shops[0].catValues[category]);
        this.$notify({
          title: "Error",
          message: "Delete all products in this category first to delete the category",
          type: "error",
          duration: 0
        });
      } else {
        this.tableData = this.tableData.filter(function (data) {
          return data.mainCategory !== category;
        });
        delete this.categories[category];
        this.$store.state.secondaryDatabase.collection("shops").doc(this.shops[0].id).update({
          categories: this.categories
        }).then(function (doc) {}).catch(function (error) {
          return alert(error);
        });
      }
    },
    open: function open() {
      var _this4 = this;

      this.$prompt("Enter main category", "Main Category", {
        confirmButtonText: "Create",
        cancelButtonText: "Cancel",
        inputPattern: /^[a-zA-Z ]*$/,
        inputErrorMessage: "Invalid Input"
      }).then(function (_ref) {
        var value = _ref.value;

        if (value === "" || value === undefined || value === null) {
          return _this4.$message({
            type: "error",
            message: "Input invalid"
          });
        }
        _this4.categories[value] = {};
        _this4.$store.state.categories[value] = {};
        _this4.tableData.push({
          mainCategory: value,
          subCategories: [],
          newCategory: "",
          inputVisible: false
        });
        // console.log(this.categories);
        _this4.$store.state.secondaryDatabase.collection("shops").doc(_this4.shops[0].id).update({
          categories: _this4.categories
        }).then(function (doc) {}).catch(function (error) {
          return alert(error);
        });
        _this4.$message({
          type: "success",
          message: "Main category created"
        });
      }).catch(function () {
        _this4.$message({
          type: "info",
          message: "Input canceled"
        });
      });
    }
  }
});

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_FirebaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Charts_AreaChart_vue__ = __webpack_require__(853);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Charts_BarChart_vue__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_month_picker__ = __webpack_require__(854);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "analytics",
  components: {
    AreaChart: __WEBPACK_IMPORTED_MODULE_6__Charts_AreaChart_vue__["a" /* default */],
    BarChart: __WEBPACK_IMPORTED_MODULE_7__Charts_BarChart_vue__["a" /* default */],
    MonthPickerInput: __WEBPACK_IMPORTED_MODULE_8_vue_month_picker__["a" /* MonthPickerInput */]
  },
  data: function data() {
    var _ref;

    return _ref = {
      loading: false,
      changed: true,
      offset: 4,
      year: new Date().getFullYear().toString(),
      storeLocation: null,
      mainCategory: null,
      subCategory: null,
      shops: [],
      categories: {},
      reports: [],
      isReportExsists: true,
      analyticsReport: {}
    }, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, "categories", ""), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, "gradient", null), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, "gradient2", null), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, "tableData", []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, "mainCategories", [{ value: null, text: "Select Main Category", disabled: true }]), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, "subCategories", [{ value: null, text: "Select Sub Category", disabled: true }]), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, "stores", [{ value: null, text: "Select Store Location", disabled: true }]), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, "labels", []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, "datasets", []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, "barChartDataset", [{
      label: "Sales",
      backgroundColor: "#f87979",
      data: []
    }]), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, "summaryFields", [{ key: "month", label: "Month", sortable: false }, { key: "totalPurcCost", label: "Total Purchase Cost", sortable: true }, { key: "totalPurcDue", label: "Total Credit", sortable: true }, { key: "totalRemaining", label: "Total Due", sortable: true }, { key: "totalSales", label: "Total Sales", sortable: true }, { key: "totalProfit", label: "Gross Profit", sortable: true }, { key: "totalExp", label: "Total Expenses", sortable: true }, { key: "netProfit", label: "Net Profit", sortable: true }]), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, "months", ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, "colorArray", ["rgba(208, 156, 221, 0.5)", "rgba(201, 246, 175, 0.5)", "rgba(213, 191, 255, 0.5)", "rgba(208, 230, 205, 0.5)", "rgba(226, 246, 169, 0.5)", "rgba(136, 173, 231, 0.5)", "rgba(255, 245, 169, 0.5)", "rgba(250, 199, 255, 0.5)", "rgba(103, 198, 156, 0.5)", "rgba(255, 162, 164, 0.5)", "rgba(82, 234, 244, 0.5)", "rgba(246, 160, 133, 0.5)", "rgba(96, 238, 234, 0.5)", "rgba(223, 159, 109, 0.5)", "rgba(105, 235, 255, 0.5)", "rgba(255, 190, 138, 0.5)", "rgba(50, 198, 189, 0.5)", "rgba(230, 151, 144, 0.5)", "rgba(166, 255, 222, 0.5)", "rgba(227, 150, 162, 0.5)", "rgba(179, 255, 208, 0.5)", "rgba(255, 193, 221, 0.5)", "rgba(160, 220, 157, 0.5)", "rgba(255, 191, 200, 0.5)", "rgba(102, 186, 168, 0.5)", "rgba(253, 211, 143, 0.5)", "rgba(128, 217, 255, 0.5)", "rgba(205, 195, 120, 0.5)", "rgba(185, 218, 255, 0.5)", "rgba(188, 205, 130, 0.5)", "rgba(128, 178, 205, 0.5)", "rgba(243, 255, 191, 0.5)", "rgba(100, 185, 182, 0.5)", "rgba(219, 157, 132, 0.5)", "rgba(165, 255, 249, 0.5)", "rgba(191, 170, 109, 0.5)", "rgba(193, 234, 255, 0.5)", "rgba(160, 179, 117, 0.5)", "rgba(185, 242, 255, 0.5)", "rgba(255, 213, 181, 0.5)", "rgba(124, 182, 173, 0.5)", "rgba(255, 236, 190, 0.5)", "rgba(160, 203, 211, 0.5)", "rgba(140, 183, 133, 0.5)", "rgba(223, 184, 179, 0.5)", "rgba(208, 255, 216, 0.5)", "rgba(206, 183, 160, 0.5)", "rgba(139, 180, 171, 0.5)", "rgba(249, 232, 205, 0.5)", "rgba(173, 174, 137, 0.5)"]), _ref;
  },
  created: function created() {
    var _this = this;

    if (screen.width <= 992) this.offset = 0;
    if (screen.width < 1200 && screen.width > 992) this.offset = 2;
    this.changed = false;
    this.loading = true;
    this.$store.state.secondaryDatabase.collection("shops").where("owner", "==", __WEBPACK_IMPORTED_MODULE_5_firebase_app__["a" /* default */].auth().currentUser.uid).get().then(function (querySnapshot) {
      querySnapshot.forEach(function (doc) {
        var data = {
          id: doc.id,
          categories: doc.data().categories
        };
        _this.shops.push(data);
        _this.categories = _this.shops[0].categories;
        _this.mainCategory = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(_this.categories)[0];
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(_this.categories).sort().forEach(function (key, index) {
          return _this.mainCategories.push(key);
        });
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(_this.categories[_this.mainCategory]).sort().forEach(function (subcat, index) {
          return _this.subCategories.push(subcat);
        });

        var docRef = _this.$store.state.secondaryDatabase.collection("stores");
        var firestoreQuery = docRef;
        if (_this.$store.state.noDB === true) {
          firestoreQuery = firestoreQuery.where("shopOwner", "==", __WEBPACK_IMPORTED_MODULE_5_firebase_app__["a" /* default */].auth().currentUser.uid);
        }
        firestoreQuery.get().then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            var data = {
              id: doc.id,
              value: doc.id,
              text: doc.data().name,
              name: doc.data().name
            };
            _this.stores.push(data);
            _this.storeLocation = _this.$store.state.selectedStore; //this.stores[1].id; // store[1] bcz record with null values is added above
            console.log(_this.stores, _this.storeLocation);
          });
          _this.getGraphData();
        }).catch(function (error) {
          return alert(error.message);
        });
        // handle inside getGraphData
        // this.changed = true;
        // this.loading = false;
      });
    }).catch(function (error) {
      return alert(error.message);
    });
  },

  methods: {
    handleMonth: function handleMonth(date) {
      // console.log("date", date);
    },
    disabledDate: function disabledDate(date) {
      return date > new Date();
    },
    getGraphData: function getGraphData() {
      var _this2 = this;

      this.changed = false;
      this.loading = true;
      this.reports = [];
      this.datasets = [];
      this.labels = [];
      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(this.year) === "object") {
        this.year = this.year.getFullYear().toString();
      }
      // console.log("values", this.year, this.storeLocation, this.mainCategory);
      var date = new Date(this.year);
      var endDate = new Date(this.year, "11");
      var firstDay = new Date(date.getFullYear(), 0, 1);
      var firstDayClone = new Date(date.getFullYear(), 0, 1);
      var lastDay = new Date(date.getFullYear(), endDate.getMonth() + 1, 0);
      // console.log("dates", firstDay, lastDay);
      var dateStart = firstDayClone;
      var dateEnd = new Date();
      while (dateEnd > dateStart || dateStart.toLocaleString("default", { month: "long" }) === dateEnd.toLocaleString("default", { month: "long" })) {
        this.labels.push(dateStart.toLocaleString("default", { month: "long" }));
        dateStart.setMonth(dateStart.getMonth() + 1);
      }
      // console.log("months", this.labels);
      this.$store.state.secondaryDatabase.collection("reports").where("date", ">=", __WEBPACK_IMPORTED_MODULE_5_firebase_app__["a" /* default */].firestore.Timestamp.fromDate(firstDay)).where("date", "<=", __WEBPACK_IMPORTED_MODULE_5_firebase_app__["a" /* default */].firestore.Timestamp.fromDate(lastDay)).where("storeLocation", "==", this.storeLocation).get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          var data = {
            id: doc.id,
            date: doc.data().date,
            categories: doc.data().reportData,
            profitData: doc.data().profitData,
            totalPurcCost: +doc.data().totalPurcCost.toFixed(2).toLocaleString(),
            totalPurcDue: +doc.data().totalPurcDue.toFixed(2).toLocaleString(),
            totalSales: +doc.data().totalSales.toFixed(2).toLocaleString(),
            totalProfit: +doc.data().totalProfit.toFixed(2).toLocaleString(),
            totalRemaining: +doc.data().totalRemaining.toFixed(2).toLocaleString(),
            totalExp: +doc.data().totalExp.toFixed(2).toLocaleString(),
            month: doc.data().date.toDate().toLocaleString("default", { month: "long" }),
            netProfit: +(doc.data().totalProfit - doc.data().totalExp).toFixed(2).toLocaleString()
          };
          _this2.reports.push(data);

          _this2.analyticsReport = _this2.reports[0].categories;
        });
        // Object.keys(this.categories).forEach((key, index) => {
        if (!_this2.subCategory) {
          __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(_this2.categories[_this2.mainCategory]).forEach(function (subcat, index) {
            _this2.datasets.push({
              label: subcat,
              borderColor: _this2.colorArray[index],
              pointBackgroundColor: "white",
              pointBorderColor: "white",
              borderWidth: 1,
              backgroundColor: _this2.colorArray[index],
              data: _this2.getDataset(subcat)
            });

            // // console.log("this.datasets", this.datasets);
          });
        }
        if (_this2.subCategory) {
          _this2.datasets.push({
            label: _this2.subCategory,
            borderColor: _this2.colorArray[0],
            pointBackgroundColor: "white",
            pointBorderColor: "white",
            borderWidth: 1,
            backgroundColor: _this2.colorArray[0],
            data: _this2.getDataset(_this2.subCategory)
          });
        }
        // });
        _this2.getSalesData();
        // console.log("this.reports[0]", this.reports);
        if (!_this2.reports[0]) {
          _this2.isReportExsists = false;
          // this.categories = this.shops[0].categories;
          // Object.keys(this.categories).forEach((key, index) => {
          //   this.analyticsReport[key] = {};
          //   Object.keys(this.categories[key]).forEach(
          //     (subcat, index) => (this.analyticsReport[key][subcat] = 0)
          //   );
          // });
          // console.log("this.analyticsReport is", this.analyticsReport);
        }

        var monthlySalesByCategoryData = [];
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(_this2.categories).sort().forEach(function (key, index) {
          var monthlySalesByCategory = {};
          monthlySalesByCategory.id = index + 1;
          monthlySalesByCategory.category = key;
          // monthlySalesByCategory.sales = 0;
          // monthlySalesByCategory.profit = 0;
          monthlySalesByCategory.children = [];
          __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(_this2.categories[key]).sort().forEach(function (subcat, subindex) {
            var monthlyData = {};
            _this2.reports.forEach(function (report) {
              monthlyData[report.date.toDate().toLocaleString("default", { month: "long" })] = {
                sales: report.categories[key] ? report.categories[key][subcat] ? report.categories[key][subcat] : 0 : 0,
                profit: report.profitData[key] ? report.profitData[key][subcat] ? report.profitData[key][subcat] : 0 : 0
              };
            });
            monthlySalesByCategory.children.push({
              id: index + 1 + "-" + subindex,
              category: subcat,
              salesProfit: monthlyData
              // sales: data.categories[key][subcat] ? data.categories[key][subcat] : 0,
              // profit: data.profitData[key][subcat] ? data.profitData[key][subcat] : 0,
            });
          });
          monthlySalesByCategoryData.push(monthlySalesByCategory);
        });
        monthlySalesByCategoryData.forEach(function (record) {
          var monthlyData = {};

          _this2.reports.forEach(function (report) {
            var month = report.date.toDate().toLocaleString("default", { month: "long" });
            var totalSales = 0;
            record.children.forEach(function (item) {
              totalSales += item.salesProfit[month].sales;
            });
            var totalProfit = 0;
            record.children.forEach(function (item) {
              totalProfit += item.salesProfit[month].profit;
            });
            monthlyData[month] = {
              sales: totalSales,
              profit: totalProfit
            };
          });
          record.salesProfit = monthlyData;
        });
        _this2.tableData = monthlySalesByCategoryData;
        console.log("monthlySalesByCategory", monthlySalesByCategoryData);

        _this2.changed = true;
        _this2.loading = false;
      }).catch(function (error) {
        return console.log(error);
      });
    },
    getSalesData: function getSalesData() {
      var _this3 = this;

      this.barChartDataset[0].data = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.labels.map(function (month) {
        // console.log("reportFor", this.reports, month);
        var reportForMonth = _this3.reports.find(function (report) {
          return report.date.toDate().toLocaleString("default", { month: "long" }) === month;
        });
        if (reportForMonth) {
          var totalSales = 0;
          __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(_this3.categories).forEach(function (key, index) {
            __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(_this3.categories[key]).forEach(function (subcat, index) {
              if (reportForMonth.categories[key]) {
                totalSales += reportForMonth.categories[key][subcat];
              }
            });
          });
          return totalSales;
        }
        return 0;
      })));
      // console.log("this.barChartDataset", this.barChartDataset);
      return this.barChartDataset;
    },
    getDataset: function getDataset(subcat) {
      var _this4 = this;

      return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.labels.map(function (month) {
        var reportForMonth = _this4.reports.find(function (report) {
          return report.date.toDate().toLocaleString("default", { month: "long" }) === month;
        });
        console.log("reportForMonth", reportForMonth);
        if (reportForMonth && reportForMonth.categories[_this4.mainCategory]) {
          return reportForMonth.categories[_this4.mainCategory][subcat];
        }
        return 0;
      })));
    }
  }
});

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(258);



/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["b" /* Line */],
  props: ["areaChartDataset", "areaChartLabels"],
  data: function data() {
    return {
      gradient: null,
      gradient2: null
    };
  },
  mounted: function mounted() {
    this.gradient = this.$refs.canvas.getContext("2d").createLinearGradient(0, 0, 0, 450);
    this.gradient2 = this.$refs.canvas.getContext("2d").createLinearGradient(0, 0, 0, 450);

    this.gradient.addColorStop(0, "rgba(255, 0,0, 0.5)");
    this.gradient.addColorStop(0.5, "rgba(255, 0, 0, 0.25)");
    this.gradient.addColorStop(1, "rgba(255, 0, 0, 0)");

    this.gradient2.addColorStop(0, "rgba(0, 231, 255, 0.9)");
    this.gradient2.addColorStop(0.5, "rgba(0, 231, 255, 0.25)");
    this.gradient2.addColorStop(1, "rgba(0, 231, 255, 0)");
    this.renderChart({
      labels: this.areaChartLabels,
      datasets: this.areaChartDataset
    }, {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        labels: {
          fontColor: "white"
          // This more specific font property overrides the global property
          // font: {
          //   size: 14,
          // },
        }
      },
      scales: {
        yAxes: [{
          ticks: {
            fontColor: "white"
          }
        }],
        xAxes: [{
          ticks: {
            fontColor: "white"
          }
        }]
      }
    });
  }
});

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_MonthPicker_vue__ = __webpack_require__(422);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_228c49d2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_MonthPicker_vue__ = __webpack_require__(861);
function injectStyle (ssrContext) {
  __webpack_require__(855)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_MonthPicker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_228c49d2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_MonthPicker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_int__ = __webpack_require__(856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__languages__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__month_picker__ = __webpack_require__(425);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "MonthPicker",
  mixins: [__WEBPACK_IMPORTED_MODULE_4__month_picker__["a" /* default */]],
  emits: ["change", "clear", "input", "change-year"],
  data: function data() {
    return {
      currentMonthIndex: null,
      firstRangeMonthIndex: null,
      secondRangeMonthIndex: null,
      year: new Date().getFullYear(),
      selectedYear: new Date().getFullYear()
    };
  },
  computed: {
    currentMonth: function currentMonth() {
      if (this.currentMonthIndex !== null) {
        return this.monthsByLang[this.currentMonthIndex];
      }

      return null;
    },
    firstRangemonth: function firstRangemonth() {
      if (this.firstRangeMonthIndex !== null) {
        return this.monthsByLang[this.firstRangeMonthIndex];
      }

      return null;
    },
    secondRangemonth: function secondRangemonth() {
      if (this.secondRangeMonthIndex !== null) {
        return this.monthsByLang[this.secondRangeMonthIndex];
      }

      return null;
    },
    date: function date() {
      var month = this.monthsByLang.indexOf(this.currentMonth) + 1;
      var dateFrom = new Date(this.year + "/" + month + "/01");
      var dateTo = new Date(this.year, month, 1);

      var dateResult = {
        from: dateFrom,
        to: dateTo,
        month: this.monthsByLang[month - 1],
        monthIndex: month,
        year: this.year,
        selectedYear: this.selectedYear,
        rangeFrom: null,
        rangeTo: null,
        rangeFromMonth: null,
        rangeToMonth: null
      };

      if (this.range) {
        var monthRangeFrom = this.monthsByLang.indexOf(this.firstRangeMonthIndex) + 1;
        var monthRangeTo = this.monthsByLang.indexOf(this.secondRangeMonthIndex) + 1;

        dateFrom = new Date(this.year + "/" + monthRangeFrom + "/01");
        dateTo = new Date(this.year + "/" + monthRangeTo + "/01");

        dateResult.rangeFrom = this.firstRangeMonthIndex;
        dateResult.rangeTo = this.secondRangeMonthIndex;
        dateResult.rangeFromMonth = this.monthsByLang[this.firstRangeMonthIndex];
        dateResult.rangeToMonth = this.monthsByLang[this.secondRangeMonthIndex];
      }

      return dateResult;
    }
  },
  watch: {
    defaultMonth: function defaultMonth(newVal) {
      this.currentMonthIndex = newVal - 1;
    },
    defaultYear: function defaultYear(newVal) {
      this.year = newVal;
      this.selectedYear = newVal;
    }
  },
  mounted: function mounted() {
    if (this.defaultYear) {
      this.year = this.defaultYear;
      this.selectedYear = this.defaultYear;
    }

    if (this.range) {
      this.setDefaultMonthRange();
      return;
    }

    if (this.defaultMonth) {
      this.selectMonth(this.defaultMonth - 1);
    } else if (!this.noDefault) {
      this.selectMonth(0);
    }
  },

  methods: {
    onChange: function onChange() {
      if (!__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_int___default()(this.year)) {
        this.year = this.defaultYear || new Date().getFullYear();
      }
      this.$emit("change", this.date);
    },
    selectMonth: function selectMonth(index) {
      var input = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (this.isInactive(index)) {
        return;
      }

      if (this.range) {
        return this.selectMonthRange(index, input);
      }

      var isAlreadySelected = this.currentMonthIndex === index;
      if (this.clearable && isAlreadySelected) {
        this.currentMonthIndex = null;
        this.$emit("clear");
        return;
      }

      if (this.isAlreadySelected) {
        return;
      }

      this.currentMonthIndex = index;
      this.selectedYear = this.year;
      this.onChange();

      if (input) {
        this.$emit("input", this.date);
      }
    },
    selectMonthRange: function selectMonthRange(index, input) {
      if (this.firstRangeMonthIndex === null) {
        this.firstRangeMonthIndex = index;
        return;
      }

      if (this.firstRangeMonthIndex !== null && this.secondRangeMonthIndex !== null) {
        this.firstRangeMonthIndex = index;
        this.secondRangeMonthIndex = null;
        return;
      }

      if (index >= this.firstRangeMonthIndex) {
        this.secondRangeMonthIndex = index;
        this.onChange();

        if (input) {
          this.$emit("input", this.date);
        }
        return;
      }

      this.firstRangeMonthIndex = index;
    },
    setDefaultMonthRange: function setDefaultMonthRange() {
      if (this.defaultMonthRange === null || this.defaultMonthRange.length !== 2) {
        return;
      }

      var _defaultMonthRange = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(this.defaultMonthRange, 2),
          firstRange = _defaultMonthRange[0],
          secondRange = _defaultMonthRange[1];

      if (secondRange <= firstRange) {
        return;
      }

      this.firstRangeMonthIndex = firstRange;
      this.secondRangeMonthIndex = secondRange;
    },
    changeYear: function changeYear(value) {
      this.year += value;

      if (this.isInactive(0)) {
        return;
      }

      this.onChange();
      this.$emit("change-year", this.year);
    },
    isInactive: function isInactive(month) {
      var monthValue = month;
      if (this.minDate === null && this.maxDate === null) {
        return false;
      }

      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(monthValue)) {
        monthValue = this.monthsByLang[monthValue];
      }

      var monthKey = this.monthsByLang.indexOf(monthValue) + 1;
      var date = new Date(this.year + "/" + monthKey + "/01");
      var isValidDate = function isValidDate(date) {
        return date !== null && date instanceof Date;
      };

      if (isValidDate(this.minDate) && date < this.minDate) {
        return true;
      }

      if (isValidDate(this.maxDate) && date > this.maxDate) {
        return true;
      }

      return false;
    }
  }
});

/***/ }),
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MonthPicker_vue__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__month_picker__ = __webpack_require__(425);


var _name$directives$comp;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = (_name$directives$comp = {
  name: "MonthPickerInput",
  directives: {
    clickOutside: {
      bind: function bind(el, binding, vnode) {
        el.event = function (event) {
          if (!(el === event.target || el.contains(event.target))) {
            vnode.context[binding.expression](event);
          }
        };
        document.body.addEventListener("click", el.event);
      },
      unbind: function unbind(el) {
        document.body.removeEventListener("click", el.event);
      },
      beforeMount: function beforeMount(el, binding) {
        el.clickOutsideEvent = function (event) {
          if (!(el == event.target || el.contains(event.target))) {
            binding.value();
          }
        };
        document.addEventListener("click", el.clickOutsideEvent);
      },
      unmounted: function unmounted(el) {
        document.removeEventListener("click", el.clickOutsideEvent);
      }
    }
  },
  components: {
    MonthPicker: __WEBPACK_IMPORTED_MODULE_1__MonthPicker_vue__["a" /* default */]
  }
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$directives$comp, "components", {
  MonthPicker: __WEBPACK_IMPORTED_MODULE_1__MonthPicker_vue__["a" /* default */]
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$directives$comp, "mixins", [__WEBPACK_IMPORTED_MODULE_2__month_picker__["a" /* default */]]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$directives$comp, "mixins", [__WEBPACK_IMPORTED_MODULE_2__month_picker__["a" /* default */]]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$directives$comp, "props", {
  placeholder: {
    type: String,
    default: null
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$directives$comp, "emits", ["change", "input"]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$directives$comp, "data", function data() {
  return {
    monthPickerVisible: false,
    selectedDate: null
  };
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$directives$comp, "watch", {
  defaultYear: {
    immediate: true,
    handler: function handler(value) {
      if (!value || !this.inputPreFilled) return;
      this.selectedDate = this.monthsByLang[this.defaultMonth - 1] + ", " + value;
    }
  },
  defaultMonth: {
    immediate: true,
    handler: function handler(value) {
      if (!value || !this.inputPreFilled) return;
      this.selectedDate = this.monthsByLang[value - 1] + ", " + this.defaultYear;
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$directives$comp, "methods", {
  populateInput: function populateInput(date) {
    if (this.range) {
      this.selectedDate = date.rangeFromMonth + " - " + date.rangeToMonth + ", " + date.year;
    } else {
      this.selectedDate = date.month + ", " + date.year;
    }

    this.monthPickerVisible = false;
    this.$emit("input", date);
  },
  showMonthPicker: function showMonthPicker() {
    this.monthPickerVisible = !this.monthPickerVisible;
  },
  hide: function hide() {
    this.monthPickerVisible = false;
  },
  updateDate: function updateDate(date) {
    if (this.range) {
      this.selectedDate = date.rangeFromMonth + " - " + date.rangeToMonth + ", " + date.year;
    } else {
      this.selectedDate = date.month + ", " + date.year;
    }
    this.$emit("change", date);
  }
}), _name$directives$comp);

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app__ = __webpack_require__(2);
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "returns",
  data: function data() {
    return {
      invoices: []
    };
  },
  created: function created() {
    this.open();
  },

  methods: {
    open: function open() {
      var _this = this;

      this.$prompt("Please input invoice no", "Find Invoice", {
        confirmButtonText: "Find",
        cancelButtonText: "Cancel",
        closeOnClickModal: true,
        showCancelButton: false,
        showClose: true,
        center: true,
        customClass: ".promptBox",
        inputErrorMessage: "Invalid No"
      }).then(function (_ref) {
        var value = _ref.value;

        var docRef = _this.$store.state.secondaryDatabase.collection("invoices");
        var firestoreQuery = docRef;
        if (_this.$store.state.noDB === true) {
          firestoreQuery = firestoreQuery.where("shopOwner", "==", __WEBPACK_IMPORTED_MODULE_0_firebase_app__["a" /* default */].auth().currentUser.uid);
        }
        firestoreQuery.where("invoiceNo", "==", value).limit(1).get().then(function (querySnapshot) {

          querySnapshot.forEach(function (doc) {
            var data = {
              id: doc.id,
              data: doc.data()
            };
            _this.invoices.push(data);
          });
          if (!_this.invoices[0]) {
            _this.$notify({
              type: "error",
              message: "Invoice not found for no " + value
            });
            return _this.open();
          } else _this.$router.push("/admin/createinvoice?invoice=" + value + "&return=true");
        }).catch(function (error) {
          return alert(error.message);
        });
      }).catch(function (error) {
        _this.$message({
          type: "info",
          message: error.message
        });
      });
    }
  }
});

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app__ = __webpack_require__(2);
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "returnsGRN",
  data: function data() {
    return {
      invoices: []
    };
  },
  created: function created() {
    this.open();
  },

  methods: {
    open: function open() {
      var _this = this;

      this.$prompt("Please input GRN no", "Find GRN", {
        confirmButtonText: "Find",
        cancelButtonText: "Cancel",
        closeOnClickModal: true,
        showCancelButton: false,
        showClose: true,
        center: true,
        customClass: ".promptBox",
        inputErrorMessage: "Invalid No"
      }).then(function (_ref) {
        var value = _ref.value;

        var docRef = _this.$store.state.secondaryDatabase.collection("POs");
        var firestoreQuery = docRef;
        if (_this.$store.state.noDB === true) {
          firestoreQuery = firestoreQuery.where("shopOwner", "==", __WEBPACK_IMPORTED_MODULE_0_firebase_app__["a" /* default */].auth().currentUser.uid);
        }
        firestoreQuery.where("invoiceNo", "==", value).limit(1).get().then(function (querySnapshot) {
          // console.log("querySnapshot");
          querySnapshot.forEach(function (doc) {
            var data = {
              id: doc.id,
              data: doc.data()
            };
            _this.invoices.push(data);
          });
          if (!_this.invoices[0]) {
            _this.$notify({
              type: "error",
              message: "GRN not found for no " + value
            });
            return _this.open();
          } else _this.$router.push("/admin/create-purchase-order?PO=" + value + "&return=true");
        }).catch(function (error) {
          return alert(error.message);
        });
      }).catch(function (error) {
        _this.$message({
          type: "info",
          message: error.message
        });
      });
    }
  }
});

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_FirebaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "users",
  data: function data() {
    var _this = this;

    var validatePass = function validatePass(rule, value, callback) {
      if (value === "") {
        callback(new Error("Please input the password"));
      } else {
        if (_this.formdata.checkPass !== "") {
          _this.$refs.formdata.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = function validatePass2(rule, value, callback) {
      if (value === "") {
        callback(new Error("Please input the password again"));
      } else if (value !== _this.formdata.pass) {
        callback(new Error("Two inputs don't match!"));
      } else {
        callback();
      }
    };
    var defaultPermissions = ["invoice list", "invoice write", "quotation list", "quotation write", "cash flow", "expenses"];
    return {
      emptyText: "Loading Records...",
      items: [],
      fields: [{ key: "name", label: "Name", sortable: true }, { key: "id", label: "User Id", sortable: true }, { key: "sysid", label: "System ID", sortable: false }, { key: "telephone", label: "Telephone", sortable: false }, { key: "role", label: "Role", sortable: true }, { key: "city", label: "City", sortable: true }, { key: "email", label: "Email", sortable: true }, { key: "regdate", label: "Registered", sortable: true }, { key: "actions", label: "Actions" }],
      permissionsList: ["dashboard", "analytics", "invoice list", "invoice write", "invoice return", "GRN list", "GRN return", "GRN write", "quotation list", "quotation write", "cash flow", "expenses", "suppliers", "customers", "users", "online store", "stores", "settings", "products", "categories"],

      displayName: __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.displayName,
      payments: [],
      amount: 0,
      dialogFormVisible: false,
      dialogFormVisible2: false,
      dialogFormVisible3: false,
      width: "50%",
      currentPage: 1,
      perPage: 10,
      totalRows: items.length,
      pageOptions: [10, 25, 50],
      sortBy: null,
      sortDesc: false,
      filter: null,
      loading: false,
      loading1: false,
      loading2: false,
      changed: true,
      cus: 0,
      pay: 0,
      shopCategory: "",
      formdata: {
        name: "",
        telephone: "",
        email: "",
        sysid: "",
        role: "",
        store: [],
        city: "",
        note: "",
        permissions: defaultPermissions
      },
      rules2: {
        pass: [{ validator: validatePass, trigger: "blur" }],
        checkPass: [{ validator: validatePass2, trigger: "blur" }]
      },
      formdata2: {
        name: "",
        email: "",
        city: "",
        telephone: "",
        id: "",
        sysid: "",
        role: "",
        store: [],
        note: "",
        permissions: defaultPermissions
      },
      labelPosition: "top"
    };
  },


  computed: {
    sortOptions: function sortOptions() {
      // Create an options list from our fields
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return { text: f.label, value: f.key };
      });
    }
  },
  methods: {
    onFiltered: function onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    open1: function open1() {
      this.$notify.error({
        title: "Error",
        message: "Please Enter the Correct Details",
        type: "error"
      });
    },
    open2: function open2() {
      this.$notify.error({
        title: "Error",
        message: "System ID already taken",
        type: "error"
      });
    },
    showUpdate: function showUpdate(item) {
      this.formdata2.name = item.name || "";
      this.formdata2.telephone = item.telephone || "";
      this.formdata2.email = item.email || "";
      this.formdata2.city = item.city || "";
      this.formdata2.id = item.id;
      this.formdata2.sysid = item.sysid;
      this.formdata2.role = item.role;
      this.formdata2.store = item.store;
      this.formdata2.note = item.note;
      this.formdata2.permissions = item.permissions;
      this.dialogFormVisible3 = true;
    },
    update: function update(fdata) {
      var _this2 = this;

      this.$refs[fdata].validate(function (valid) {
        if (valid) {
          _this2.dialogFormVisible3 = false, _this2.changed = false;
          _this2.loading = true;
          var sysidTaken = void 0;
          var userId = void 0;
          var docRef = _this2.$store.state.secondaryDatabase.collection("sysusers");
          var firestoreQuery = docRef;
          if (_this2.$store.state.noDB === true) {
            firestoreQuery = firestoreQuery.where("shopOwner", "==", __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.uid);
          }
          firestoreQuery.where("sysid", "==", _this2.formdata2.sysid).get().then(function (querySnapshot) {
            querySnapshot.forEach(function (doc) {
              sysidTaken = doc.data().sysid;
              userId = doc.id;
            });
            // console.log(sysidTaken, userId);
            if (sysidTaken === _this2.formdata2.sysid && userId !== _this2.formdata2.id) {
              _this2.loading = false;
              _this2.changed = true;
              return _this2.open2();
            }
            if (_this2.formdata2.role === "Admin" && __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.displayName === 'shop owner') _this2.formdata2.permissions = _this2.permissionsList;
            if (_this2.formdata2.role === "Admin" && __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.displayName === 'starterplan shop owner') _this2.formdata2.permissions = _this2.$store.state.starterPlanPermissionsList;
            _this2.$store.state.secondaryDatabase.collection("sysusers").doc(_this2.formdata2.id).update({
              name: _this2.formdata2.name,
              email: _this2.formdata2.email,
              sysid: _this2.formdata2.sysid,
              role: _this2.formdata2.role,
              store: _this2.formdata2.store,
              city: _this2.formdata2.city,
              telephone: _this2.formdata2.telephone,
              note: _this2.formdata2.note,
              permissions: _this2.formdata2.permissions
            }).then(function (docRef) {
              //console.log('docref', docRef.id)
              var newitems = _this2.items.filter(function (item) {
                ////console.log('filfkkk')
                if (item.id == _this2.formdata2.id) {
                  item.name = _this2.formdata2.name;
                  item.telephone = _this2.formdata2.telephone;
                  item.email = _this2.formdata2.email;
                  item.city = _this2.formdata2.city;
                  item.sysid = _this2.formdata2.sysid;
                  item.role = _this2.formdata2.role;
                  item.store = _this2.formdata2.store;
                  item.note = _this2.formdata2.note;
                  item.permissions = _this2.formdata2.permissions;
                }
                return item;
              });
              _this2.$store.state.users = newitems;
              _this2.formdata2.name = "";
              _this2.formdata2.telephone = "";
              _this2.formdata2.email = "";
              _this2.formdata2.city = "";
              _this2.formdata2.id = "";
              _this2.formdata2.sysid = "";
              _this2.formdata2.role = "";
              _this2.formdata2.store = "";
              _this2.formdata2.note = "";
              _this2.formdata2.permissions = [];
              _this2.loading = false;
              _this2.changed = true;
              _this2.$notify({
                title: "Success",
                message: "User updated",
                type: "success"
              });
            }).catch(function (error) {
              return alert(error);
            });
          }).catch(function (error) {
            return alert(error.message);
          });
        } else {
          _this2.open1();
          return false;
        }
      });
    },
    handleSelect: function handleSelect(value) {
      this.formdata.role = value;
    },
    submitForm: function submitForm(fdata) {
      var _this3 = this;

      this.$refs[fdata].validate(function (valid) {
        if (valid) {
          _this3.dialogFormVisible2 = false;
          _this3.changed = false;
          _this3.loading = true;
          var sysidTaken = void 0;
          var docRef = _this3.$store.state.secondaryDatabase.collection("sysusers");
          var firestoreQuery = docRef;
          if (_this3.$store.state.noDB === true) {
            firestoreQuery = firestoreQuery.where("shopOwner", "==", __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.uid);
          }
          firestoreQuery.where("sysid", "==", _this3.formdata.sysid).get().then(function (querySnapshot) {
            querySnapshot.forEach(function (doc) {
              sysidTaken = doc.data().sysid;
              // console.log(sysidTaken);
            });
            if (sysidTaken === _this3.formdata.sysid) {
              _this3.loading = false;
              _this3.changed = true;
              return _this3.open2();
            }
            ////console.log(user)
            if (_this3.formdata2.role === "Admin" && __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.displayName === 'shop owner') _this3.formdata2.permissions = _this3.permissionsList;
            if (_this3.formdata2.role === "Admin" && __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.displayName === 'starterplan shop owner') _this3.formdata2.permissions = _this3.$store.state.starterPlanPermissionsList;
            _this3.$store.state.secondaryDatabase.collection("sysusers").add({
              name: _this3.formdata.name,
              email: _this3.formdata.email,
              city: _this3.formdata.city,
              regdate: __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].firestore.Timestamp.now(),
              //uid: firebase.auth().currentUser.uid,
              shopOwner: __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.uid,
              telephone: _this3.formdata.telephone,
              sysid: _this3.formdata.sysid,
              role: _this3.formdata.role,
              store: _this3.formdata.store,
              note: _this3.formdata.note,
              permissions: _this3.formdata.permissions
            }).then(function (docRef) {
              //console.log('docref', docRef.id)
              _this3.$store.state.users.push({
                id: docRef.id,
                name: _this3.formdata.name,
                note: _this3.formdata.note,
                email: _this3.formdata.email,
                city: _this3.formdata.city,
                sysid: _this3.formdata.sysid,
                role: _this3.formdata.role,
                store: _this3.formdata.store,
                permissions: _this3.formdata.permissions,
                regdate: __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].firestore.Timestamp.now().toDate().toLocaleString(),
                //uid: firebase.auth().currentUser.uid,
                telephone: _this3.formdata.telephone
              });
              _this3.items = _this3.$store.state.users;
              _this3.totalRows = _this3.items.length;
              _this3.users = _this3.users + 1;
              _this3.$store.state.secondaryDatabase.collection("shops").doc(__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.uid).update({
                users: _this3.users
              }).then(function () {
                //console.log('secondaryDB shop id')
              }).catch(function (error) {
                return alert(error);
              });
              _this3.formdata.name = "";
              _this3.formdata.email = "";
              _this3.formdata.telephone = "";
              _this3.formdata.city = "";
              _this3.formdata.role = "";
              _this3.formdata.store = "";
              _this3.formdata.sysid = "";
              _this3.formdata.note = "";
              _this3.formdata.permissions = [];
              _this3.loading = false;
              _this3.changed = true;
              _this3.$notify({
                title: "Success",
                message: "User added",
                type: "success"
              });
            }).catch(function (error) {
              return alert(error);
            });
          }).catch(function (error) {
            return alert(error);
          });
        } else {
          _this3.open1();
          return false;
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  },
  created: function created() {
    var _this4 = this;

    this.loading1 = true;
    this.changed = false;
    if (screen.width > 767) {
      this.width = "50%";
    } else {
      this.width = "85%";
    }
    this.$store.state.secondaryDatabase.collection("shops").doc(__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.uid).get().then(function (doc) {
      _this4.users = doc.data().users || 0;
      _this4.shopCategory = doc.data().cat;
    }).catch(function (error) {
      return alert(error);
    });

    if (this.$store.state.users.length != 0) {
      this.items = this.$store.state.users;
      this.loading1 = false;
      this.changed = true;
    } else {
      var docRef = this.$store.state.secondaryDatabase.collection("sysusers");
      var firestoreQuery = docRef;
      if (this.$store.state.noDB === true) {
        firestoreQuery = firestoreQuery.where("shopOwner", "==", __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.uid);
      }
      firestoreQuery.get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          var data = {
            id: doc.id,
            name: doc.data().name,
            email: doc.data().email,
            city: doc.data().city,
            regdate: doc.data().regdate,
            telephone: doc.data().telephone,
            sysid: doc.data().sysid,
            role: doc.data().role,
            store: doc.data().store,
            note: doc.data().note,
            permissions: doc.data().permissions
          };
          if (data.regdate != undefined) {
            data.regdate = doc.data().regdate.toDate().toLocaleString();
          }
          _this4.items.push(data);
          _this4.$store.state.users = _this4.items;
        });
        if (_this4.items.length == 0) {
          _this4.emptyText = "There are no records to show";
        }
        _this4.loading1 = false;
        _this4.changed = true;
      });
    }
  }
});

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_FirebaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__(15);
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "verifyuser",
  data: function data() {
    return {
      users: []
    };
  },
  mounted: function mounted() {
    this.open();
  },

  methods: {
    open: function open() {
      var _this = this;

      this.$prompt("Please input your system ID", "User Verification", {
        confirmButtonText: "Verify",
        cancelButtonText: "Cancel",
        closeOnClickModal: false,
        showCancelButton: false,
        showClose: false,
        center: true,
        customClass: ".promptBox",
        inputErrorMessage: "Invalid ID"
      }).then(function (_ref) {
        var value = _ref.value;

        var docRef = _this.$store.state.secondaryDatabase.collection("sysusers");
        var firestoreQuery = docRef;
        if (_this.$store.state.noDB === true) {
          firestoreQuery = firestoreQuery.where("shopOwner", "==", __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.uid);
        }
        firestoreQuery.where("sysid", "==", value).limit(1).get().then(function (querySnapshot) {
          // console.log("querySnapshot");
          querySnapshot.forEach(function (doc) {
            var data = {
              id: doc.id,
              data: doc.data()
            };
            _this.users.push(data);
          });
          if (!_this.users[0]) {
            _this.$notify({
              type: "error",
              message: "User not found for ID " + value
            });
            return _this.open();
          }

          _this.$store.state.systemUser.isLogedIn = true;
          _this.$store.state.systemUser.role = _this.users[0].data.role;
          _this.$store.state.systemUser.permissions = _this.users[0].data.permissions || [];
          _this.$store.state.systemUser.stores = _this.users[0].data.store || [];
          __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit("userChanged", _this.users[0].data);
          _this.$store.state.systemUser.name = _this.users[0].data.name;
          _this.$store.state.systemUser.id = _this.users[0].id;
          if (_this.users[0].data.role === "Cashier" || _this.users[0].data.role === 'Shop Manager') _this.$router.push("/admin/createinvoice");else if (_this.users[0].data.role === "Kitchen Staff" || _this.users[0].data.role === "Service Staff") _this.$router.push("/admin/kot");else _this.$router.push("/admin");
        }).catch(function (error) {
          return alert(error.message);
        });
      }).catch(function (error) {
        _this.$message({
          type: "info",
          message: error.message
        });
      });
    }
  }
});

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_image_compressor_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_FirebaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_geofirestore__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_geofirestore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_geofirestore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_firestore__ = __webpack_require__(119);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "setting",
  data: function data() {
    return {
      setting: {
        printSize: "",
        printPopup: true,
        // discountMode: "",
        taxMode: "Percentage",
        serviceChargeMode: "Percentage",
        // lowStockAlertQuantity: 1,
        loyalityPoints: 0,
        referralPoints: 0,
        // header: "",
        footer: "",
        printOnly: true,
        invoOptions: [],
        invoDigits: 8,
        defaultPay: 'Cash'
      },
      invoOptionsList: ["Card Payment", "Cheque Payment", "Gift Vouchers", "Loyalty Points", "Service Charge", "Tax", "Delivery Charge"],
      printSizes: [{
        value: "A4",
        label: "A4"
      }, {
        value: "A5",
        label: "A5"
      }, {
        value: "POS Printer 58 mm Paper",
        label: "POS Printer 58 mm Paper"
      }, {
        value: "POS Printer 80 mm Paper",
        label: "POS Printer 80 mm Paper"
      }],
      discountModes: [{
        value: "Percentage",
        label: "Percentage %"
      }, {
        value: "Amount",
        label: "Amount"
      }],
      defaultPayOptions: [{
        value: "Cash",
        label: "Cash"
      }, {
        value: "Card",
        label: "Card"
      }],
      printPopupMode: [{
        value: true,
        label: "Show Popup"
      }, {
        value: false,
        label: "Hide Popup"
      }],
      invoDigitsOptions: [{ value: 8, label: 8 }, { value: 10, label: 10 }],
      shops: [],
      stores: [],
      label: "",
      image1: "",
      loading1: false,
      loading: false,
      changed: true
    };
  },


  methods: {
    backToTop: function backToTop() {
      $("html,body").stop().animate({
        scrollTop: 0
      }, "fast", "swing");
    },

    handleChange: function handleChange() {},
    clearFiles: function clearFiles() {
      this.$refs.upload.clearFiles();
    },
    fileSelect1: function fileSelect1(event) {
      var _this = this;

      // console.log("event is", event);
      var files = [];
      files[0] = event.raw;
      var filename = files[0].name;
      if (files[0].type !== "image/png" && files[0].type !== "image/jpeg" && files[0].type !== "image/jpg") {
        alert("File " + files[0].name + " is not type of jpeg or jpg or png!. You cannot upload other types of images.");
        this.clearFiles();
      } else if (files[0].size > 500200) {
        alert("File " + files[0].name + " is too large! maximum file size should be 500 kb");
        this.clearFiles();
      } else {
        var reader = new FileReader();
        reader.addEventListener("load", function () {
          _this.visible = "none";
          _this.image = reader.result;
          _this.visible1 = "block";
        });
        reader.readAsDataURL(files[0]);
        //this.image = files[0];
        var imageCompressor = new __WEBPACK_IMPORTED_MODULE_0_image_compressor_js__["a" /* default */]();
        imageCompressor.compress(files[0], { quality: 0.4 }).then(function (result) {
          // Handle the compressed image file.
          if (result.size > 100000) {
            var _imageCompressor = new __WEBPACK_IMPORTED_MODULE_0_image_compressor_js__["a" /* default */]();
            _imageCompressor.compress(result, { quality: 0.6, width: 720, height: 140 }).then(function (result) {
              var fileReader = new FileReader();

              // This fires after the blob has been read/loaded.
              fileReader.addEventListener("load", function () {
                _this.image1 = fileReader.result;

                // console.log("image is", this.image1);
              });

              // Start reading the blob as text.
              fileReader.readAsDataURL(result);

              ////console.log(filename)
              // console.log(result.size);
              //console.log('image is',result)
            });
          } else {
            var fileReader = new FileReader();
            fileReader.addEventListener("load", function () {
              _this.image1 = fileReader.result;

              // console.log("else image is", this.image1);
            });
            fileReader.readAsDataURL(result);
            ////console.log(filename)
            // console.log("else", result.size);
            //console.log('ekse image is',result)
          }
        }).catch(function (err) {
          // Handle the error
          //console.log("error is" + err)
        });
      }
    },
    resetPassword: function resetPassword() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].auth().sendPasswordResetEmail(this.shops[0].regemail).then(function () {
        // Password reset email sent!
        _this2.$notify({
          title: "Success",
          message: "Password reset link is sent to your email",
          type: "success"
        });
      }).catch(function (error) {
        alert(error.message);
      });
    },
    upDet: function upDet(cdata) {
      var _this3 = this;

      this.$refs[cdata].validate(function (valid) {
        if (valid) {
          _this3.loading = true;
          _this3.changed = false;
          _this3.backToTop();
          // const firestore = firebase.firestore();
          // Create a GeoFirestore reference
          //const geofirestore = new GeoFirestore(firestore);
          // Create a GeoCollection reference
          //const geoshop = geofirestore.collection('shops').doc(this.shops[0].id);
          //console.log('uid',firebase.auth().currentUser.uid)
          // geoshop
          // .update({
          //   details: {
          //     stime: this.setting.startTime,
          //     etime: this.setting.endTime,
          //     tel1: this.setting.phone1,
          //     tel2: this.setting.phone2,
          //     address: this.setting.address,
          //     email: this.setting.email,
          //     name:this.shops[0].name,
          //     perm:'allowed'
          //     //  lat: this.setting.lat,
          //     //  lng: this.setting.long
          //   },
          //   cat:this.shops[0].cat,
          //   coordinates: new firebase.firestore.GeoPoint(this.setting.lat, this.setting.long)
          // })
          //  .then(doc => {
          _this3.$store.state.secondaryDatabase.collection("stores").doc(_this3.$store.state.selectedStore).update({
            setting: _this3.setting,
            logo: _this3.image1
            //coordinates: new firebase.firestore.GeoPoint(this.setting.lat, this.setting.long)
          }).then(function () {
            _this3.loading = false;
            _this3.changed = true;
            _this3.$notify({
              title: "Success",
              message: "Settings updated",
              type: "success"
            });
          }).catch(function (error) {
            return console.log(error);
          });
          //console.log('doc is', doc)
          //})
          // .catch(error => alert(error));
        } else {
          alert("error update!!!");
          return false;
        }
      });
    },
    getStoreData: function getStoreData(id) {
      var _this4 = this;

      this.$store.state.secondaryDatabase.collection("stores").doc(id).get().then(function (doc) {
        var data = {
          id: doc.id,
          setting: doc.data().setting || {},
          logo: doc.data().logo
        };
        _this4.stores.push(data);
        _this4.setting.printSize = data.setting.printSize;
        _this4.setting.printPopup = data.setting.printPopup;
        _this4.setting.taxMode = data.setting.taxMode;
        _this4.setting.invoOptions = data.setting.invoOptions || [];
        _this4.setting.invoDigits = data.setting.invoDigits || 8;
        _this4.setting.serviceChargeMode = data.setting.serviceChargeMode || 'Percentage';
        // this.setting.discountMode = data.setting.discountMode;
        // this.setting.lowStockAlertQuantity =
        //   data.setting.lowStockAlertQuantity;
        _this4.setting.referralPoints = data.setting.referralPoints;
        _this4.setting.loyalityPoints = data.setting.loyalityPoints;
        // this.setting.header = data.setting.header;
        _this4.setting.footer = data.setting.footer;
        _this4.setting.printOnly = data.setting.printOnly;
        _this4.setting.defaultPay = data.setting.defaultPay || 'Cash';
        _this4.image1 = data.logo || "";
        _this4.loading1 = false;
        _this4.changed = true;
      }).catch(function (error) {
        return alert(error.message);
      });
    }
  },
  mounted: function mounted() {
    var _this5 = this;

    this.$root.$on("storeChange", function (store) {
      _this5.$store.state.selectedStore = store;
      _this5.loading1 = true;
      _this5.changed = false;
      _this5.getStoreData(_this5.$store.state.selectedStore);
    });
  },
  created: function created() {
    var _this6 = this;

    //console.log('screen',screen.width)
    if (screen.width > 575) {
      this.label = "right";
    } else {
      this.label = "top";
    }
    this.backToTop();
    this.loading1 = true;
    this.changed = false;
    this.$store.state.secondaryDatabase.collection("shops").where("owner", "==", __WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].auth().currentUser.uid).get().then(function (querySnapshot) {
      _this6.shops = [];
      querySnapshot.forEach(function (doc) {
        var data = {
          id: doc.id,
          setting: doc.data().setting || {},
          logo: doc.data().logo,
          regemail: doc.data().regemail
        };
        _this6.shops.push(data);

        //console.log('shop coordinates',this.shops[0].coordinates)

        //console.log('doc is',doc)
      });
      _this6.getStoreData(_this6.$store.state.selectedStore);

      //console.log('querySnapshot is',querySnapshot)
      //console.log('querySnapshot data',querySnapshot.docs[0].data().details)
    }).catch(function (error) {
      return alert(error);
    });

    // if (navigator.geolocation) {
    //     navigator.geolocation.getCurrentPosition( (position) => {
    //          this.setting.lat = position.coords.latitude
    //          this.setting.long = position.coords.longitude
    //     }, (error) => {
    //         if(error.code == 0){
    //           alert('Unknown error occurred.');
    //           this.fetched = true
    //         }else if(error.code == 1){
    //           alert('Permission denied. You cannot find near by ' + this.value + ' until you allow to access your loocation.')
    //           this.fetched = true
    //         }else if(error.code == 2){
    //           alert('Position unavailable. Error response from location provider.')
    //           this.fetched = true
    //         }else if(error.code == 3){
    //           alert('Location data request timed out.')
    //           this.fetched = true
    //         }})
    //     //  //console.log('this.setting.lat', this.setting.lat)
    //     //   //console.log('this.setting.lat', position.coords.latitude)
    // } else {
    //    alert("Geolocation is not supported by this browser.")
    // }

    // function showPosition(position) {
    //    this.setting.lat = position.coords.latitude
    //    this.setting.long = position.coords.longitude
    // }
  }
});

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_FirebaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "storelocations",
  data: function data() {
    return {
      emptyText: "Loading Records...",
      items: [],
      fields: [{ key: "name", label: "Name", sortable: true }, { key: "address", label: "Address", sortable: false }, { key: "telephone", label: "Telephone", sortable: false }, { key: "city", label: "City", sortable: true }, { key: "email", label: "Email", sortable: true }, { key: "actions", label: "Actions" }],
      displayName: __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.displayName,
      payments: [],
      amount: 0,
      dialogFormVisible: false,
      dialogFormVisible2: false,
      dialogFormVisible3: false,
      width: "50%",
      currentPage: 1,
      perPage: 10,
      totalRows: items.length,
      pageOptions: [10, 25, 50],
      sortBy: null,
      sortDesc: false,
      filter: null,
      loading: false,
      loading1: false,
      loading2: false,
      changed: true,
      cus: 0,
      pay: 0,
      formdata: {
        name: "",
        email: "",
        city: "",
        address: "",
        telephone: ""
      },
      formdata2: {
        name: "",
        email: "",
        address: "",
        city: "",
        telephone: "",
        id: ""
      },
      setting: {
        printSize: "POS Printer 80 mm Paper",
        printPopup: true,
        // discountMode: "",
        taxMode: "Percentage",
        // lowStockAlertQuantity: 1,
        loyalityPoints: 0,
        referralPoints: 0,
        // header: "",
        footer: "",
        printOnly: true
      },
      rules2: {},
      labelPosition: "top"
    };
  },


  computed: {
    sortOptions: function sortOptions() {
      // Create an options list from our fields
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return { text: f.label, value: f.key };
      });
    }
  },
  methods: {
    onFiltered: function onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    open1: function open1() {
      this.$notify.error({
        title: "Error",
        message: "Please Enter the Correct Details",
        type: "error"
      });
    },
    checkStoreName: function checkStoreName(form, method) {
      var _this = this;

      if (form.name) {
        var docRef = this.$store.state.secondaryDatabase.collection("stores");
        var firestoreQuery = docRef;
        if (this.$store.state.noDB === true) {
          firestoreQuery = firestoreQuery.where("shopOwner", "==", __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.uid);
        }
        firestoreQuery.where("name", "==", form.name).limit(1).get().then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            if (method === "update") {
              if (form.id !== doc.id) {
                var name = form.name;
                form.name = "";
                return _this.$notify.error({
                  title: "Error",
                  message: "Store name " + name + " is already used",
                  type: "error"
                });
              }
            } else {
              var _name = form.name;
              form.name = "";
              return _this.$notify.error({
                title: "Error",
                message: "Store name " + _name + " is already used",
                type: "error"
              });
            }
          });
        }).catch(function (error) {
          return alert(error.message);
        });
      }
    },
    showUpdate: function showUpdate(item) {
      this.formdata2.name = item.name;
      this.formdata2.telephone = item.telephone;
      this.formdata2.email = item.email;
      this.formdata2.city = item.city;
      this.formdata2.id = item.id;
      this.formdata2.address = item.address;
      this.dialogFormVisible3 = true;
    },
    update: function update(fdata) {
      var _this2 = this;

      this.$refs[fdata].validate(function (valid) {
        if (valid) {
          _this2.dialogFormVisible3 = false, _this2.changed = false;
          _this2.loading = true;
          ////console.log(user)
          _this2.$store.state.secondaryDatabase.collection("stores").doc(_this2.formdata2.id).update({
            name: _this2.formdata2.name,
            email: _this2.formdata2.email,
            city: _this2.formdata2.city,
            telephone: _this2.formdata2.telephone,
            address: _this2.formdata2.address
          }).then(function (docRef) {
            //console.log('docref', docRef.id)
            var newitems = _this2.items.filter(function (item) {
              ////console.log('filfkkk')
              if (item.id == _this2.formdata2.id) {
                item.name = _this2.formdata2.name;
                item.telephone = _this2.formdata2.telephone;
                item.email = _this2.formdata2.email;
                item.city = _this2.formdata2.city;
                item.address = _this2.formdata2.address;
              }
              return item;
            });
            // this.$store.state.stores = newitems;  // handle in adminView with requried properties like in adding new one here
            _this2.formdata2.name = "";
            _this2.formdata2.telephone = "";
            _this2.formdata2.email = "";
            _this2.formdata2.city = "";
            _this2.formdata2.id = "";
            _this2.formdata2.address = "";
            _this2.loading = false;
            _this2.changed = true;
            _this2.$notify({
              title: "Success",
              message: "Store updated",
              type: "success"
            });
          }).catch(function (error) {
            return alert(error);
          });
        } else {
          _this2.open1();
          return false;
        }
      });
    },
    submitForm: function submitForm(fdata) {
      var _this3 = this;

      this.$refs[fdata].validate(function (valid) {
        if (valid) {
          _this3.dialogFormVisible2 = false, _this3.changed = false;
          _this3.loading = true;
          ////console.log(user)
          _this3.$store.state.secondaryDatabase.collection("stores").add({
            name: _this3.formdata.name,
            email: _this3.formdata.email,
            city: _this3.formdata.city,
            address: _this3.formdata.address,
            telephone: _this3.formdata.telephone,
            invo: 0,
            netPay: 0,
            totalRemain: 0,
            totalProfit: 0,
            POTotal: 0,
            POs: 0,
            PORemain: 0,
            totalExp: 0,
            setting: _this3.setting,
            shopOwner: __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.uid
          }).then(function (docRef) {
            //console.log('docref', docRef.id)
            _this3.$store.state.stores.push({
              id: docRef.id,
              value: docRef.id,
              label: _this3.formdata.name,
              text: _this3.formdata.name,
              name: _this3.formdata.name,
              email: _this3.formdata.email,
              city: _this3.formdata.city,
              address: _this3.formdata.address,
              telephone: _this3.formdata.telephone,
              invo: 0,
              netPay: 0,
              totalRemain: 0,
              totalProfit: 0,
              POTotal: 0,
              POs: 0,
              PORemain: 0,
              totalExp: 0,
              setting: _this3.setting
            });
            _this3.items = _this3.$store.state.stores;

            _this3.formdata.name = "";
            _this3.formdata.email = "";
            _this3.formdata.telephone = "";
            _this3.formdata.city = "";
            _this3.formdata.address = "";
            _this3.loading = false;
            _this3.changed = true;
            _this3.$notify({
              title: "Success",
              message: "Store added",
              type: "success"
            });
          }).catch(function (error) {
            return alert(error);
          });
        } else {
          _this3.open1();
          return false;
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  },
  created: function created() {
    var _this4 = this;

    this.loading1 = true;
    this.changed = false;
    if (screen.width > 767) {
      this.width = "50%";
    } else {
      this.width = "85%";
    }

    if (this.$store.state.stores.length != 0) {
      this.items = this.$store.state.stores;
      this.loading1 = false;
      this.changed = true;
    } else {
      var docRef = this.$store.state.secondaryDatabase.collection("stores");
      var firestoreQuery = docRef;
      if (this.$store.state.noDB === true) {
        firestoreQuery = firestoreQuery.where("shopOwner", "==", __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.uid);
      }
      firestoreQuery.get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          var data = {
            id: doc.id,
            name: doc.data().name,
            email: doc.data().email,
            city: doc.data().city,
            address: doc.data().address,
            telephone: doc.data().telephone
          };

          _this4.items.push(data);
          // this.$store.state.stores = this.items; // handle in adminView with requried properties like in adding new one here
        });
        if (_this4.items.length == 0) {
          _this4.emptyText = "There are no records to show";
        }
        _this4.loading1 = false;
        _this4.changed = true;
      });
    }
  }
});

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_FirebaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "suppliers",
  data: function data() {
    return {
      emptyText: "Loading Records...",
      items: [],
      fields: [{ key: "name", label: "Name", sortable: true }, { key: "telephone", label: "Telephone", sortable: false }, { key: "city", label: "City", sortable: true }, { key: "email", label: "Email", sortable: true }, { key: "totalPayment", label: "Total (Rs)", sortable: true }, { key: "totalRemaining", label: "Remaining (Rs)", sortable: true },
      // {
      //   key: "totalLoyalityPoints",
      //   label: "Loyalty Points (Rs)",
      //   sortable: true,
      // },
      { key: "regdate", label: "Registered", sortable: true }, { key: "actions", label: "Actions" }],
      payments: [],
      amount: 0,
      dialogFormVisible: false,
      dialogFormVisible2: false,
      dialogFormVisible3: false,
      width: "50%",
      currentPage: 1,
      perPage: 10,
      totalRows: items.length,
      pageOptions: [10, 25, 50],
      sortBy: null,
      sortDesc: false,
      filter: null,
      loading: false,
      loading1: false,
      loading2: false,
      changed: true,
      cus: 0,
      pay: 0,
      formdata: {
        name: "",
        email: "",
        city: "",
        pass: "",
        checkPass: "",
        telephone: "",
        note: ""
      },
      formdata2: {
        name: "",
        email: "",
        city: "",
        telephone: "",
        id: "",
        note: ""
      },
      rules2: {},
      labelPosition: "top"
    };
  },


  computed: {
    sortOptions: function sortOptions() {
      // Create an options list from our fields
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return { text: f.label, value: f.key };
      });
    }
  },
  methods: {
    onFiltered: function onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    open1: function open1() {
      this.$notify.error({
        title: "Error",
        message: "Please Enter the Correct Details",
        type: "error"
      });
    },
    showUpdate: function showUpdate(item) {
      this.formdata2.name = item.name;
      this.formdata2.telephone = item.telephone;
      this.formdata2.email = item.email;
      this.formdata2.city = item.city;
      this.formdata2.id = item.id;
      this.dialogFormVisible3 = true;
      this.formdata2.note = item.note;
    },
    checkTelephone: function checkTelephone(form, method) {
      var _this = this;

      if (form.telephone) {
        var docRef = this.$store.state.secondaryDatabase.collection("suppliers");
        var firestoreQuery = docRef;
        if (this.$store.state.noDB === true) {
          firestoreQuery = firestoreQuery.where("shopOwner", "==", __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.uid);
        }
        firestoreQuery.where("telephone", "==", form.telephone).limit(1).get().then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            if (method === "update") {
              if (form.id !== doc.id) {
                var telephone = form.telephone;
                form.telephone = "";
                return _this.$notify.error({
                  title: "Error",
                  message: "Telephone no " + telephone + " is already used",
                  type: "error"
                });
              }
            } else {
              var _telephone = form.telephone;
              form.telephone = "";
              return _this.$notify.error({
                title: "Error",
                message: "Telephone no " + _telephone + " is already used",
                type: "error"
              });
            }
          });
        }).catch(function (error) {
          return alert(error.message);
        });
      }
    },
    update: function update(fdata) {
      var _this2 = this;

      this.$refs[fdata].validate(function (valid) {
        if (valid) {
          _this2.dialogFormVisible3 = false, _this2.changed = false;
          _this2.loading = true;
          ////console.log(user)
          _this2.$store.state.secondaryDatabase.collection("suppliers").doc(_this2.formdata2.id).update({
            name: _this2.formdata2.name,
            email: _this2.formdata2.email,
            city: _this2.formdata2.city,
            telephone: _this2.formdata2.telephone,
            note: _this2.formdata2.note
          }).then(function (docRef) {
            //console.log('docref', docRef.id)
            var newitems = _this2.items.filter(function (item) {
              ////console.log('filfkkk')
              if (item.id == _this2.formdata2.id) {
                item.name = _this2.formdata2.name;
                item.telephone = _this2.formdata2.telephone;
                item.email = _this2.formdata2.email;
                item.city = _this2.formdata2.city;
                item.note = _this2.formdata2.note;
              }
              return item;
            });
            _this2.$store.state.suppliers = newitems;
            _this2.formdata2.name = "";
            _this2.formdata2.telephone = "";
            _this2.formdata2.email = "";
            _this2.formdata2.city = "";
            _this2.formdata2.id = "";
            _this2.formdata2.note = "";
            _this2.loading = false;
            _this2.changed = true;
            _this2.$notify({
              title: "Success",
              message: "Supplier updated",
              type: "success"
            });
          }).catch(function (error) {
            return alert(error);
          });
        } else {
          _this2.open1();
          return false;
        }
      });
    },
    submitForm: function submitForm(fdata) {
      var _this3 = this;

      this.$refs[fdata].validate(function (valid) {
        if (valid) {
          _this3.dialogFormVisible2 = false, _this3.changed = false;
          _this3.loading = true;
          ////console.log(user)
          _this3.$store.state.secondaryDatabase.collection("suppliers").add({
            name: _this3.formdata.name,
            email: _this3.formdata.email,
            city: _this3.formdata.city,
            regdate: __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].firestore.Timestamp.now(),
            //uid: firebase.auth().currentUser.uid,
            shopOwner: __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.uid,
            telephone: _this3.formdata.telephone,
            totalPayment: 0,
            totalRemaining: 0,
            totalLoyalityPoints: 0,
            note: _this3.formdata.note
          }).then(function (docRef) {
            //console.log('docref', docRef.id)
            _this3.$store.state.suppliers.push({
              id: docRef.id,
              name: _this3.formdata.name,
              note: _this3.formdata.note,
              email: _this3.formdata.email,
              city: _this3.formdata.city,
              totalPayment: 0,
              totalRemaining: 0,
              totalLoyalityPoints: 0,
              regdate: __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].firestore.Timestamp.now().toDate().toLocaleString(),
              //uid: firebase.auth().currentUser.uid,
              telephone: _this3.formdata.telephone,
              payments: []
            });
            _this3.items = _this3.$store.state.suppliers;
            _this3.totalRows = _this3.items.length;
            _this3.cus = _this3.cus + 1;
            _this3.$store.state.secondaryDatabase.collection("shops").doc(__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.uid).update({
              supp: _this3.cus
            }).then(function () {
              //console.log('secondaryDB shop id')
            }).catch(function (error) {
              return alert(error);
            });
            _this3.formdata.name = "";
            _this3.formdata.email = "";
            _this3.formdata.telephone = "";
            _this3.formdata.city = "";
            _this3.formdata.note = "";
            _this3.loading = false;
            _this3.changed = true;
            _this3.$notify({
              title: "Success",
              message: "Supplier added",
              type: "success"
            });
          }).catch(function (error) {
            return alert(error);
          });
        } else {
          _this3.open1();
          return false;
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    addPay: function addPay(id) {
      var _this4 = this;

      this.dialogFormVisible = false;
      this.loading = true;
      this.changed = false;
      var newPay = [];
      var newitems = this.items.filter(function (item) {
        ////console.log('filfkkk')
        if (item.id == id) {
          item.payments.push({
            a: _this4.amount,
            d: __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].firestore.Timestamp.now()
          });
          newPay = item.payments;
          item.total += _this4.amount;
        }
        return item;
      });
      this.$store.state.suppliers = newitems;
      this.$store.state.secondaryDatabase.collection("suppliers").doc(id).update({
        payments: newPay
      }).then(function (docRef) {
        _this4.pay = _this4.pay + _this4.amount;
        _this4.$store.state.secondaryDatabase.collection("shops").doc(__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.uid).update({
          pay: _this4.pay
        }).then(function () {
          //console.log('secondaryDB shop id')
        }).catch(function (error) {
          return alert(error);
        });
        _this4.loading = false;
        _this4.changed = true;
        _this4.$notify({
          title: "Success",
          message: "Payment added",
          type: "success"
        });
      }).catch(function (error) {
        return alert(error);
      });
    }
  },
  created: function created() {
    var _this5 = this;

    this.loading1 = true;
    this.changed = false;
    if (screen.width > 767) {
      this.width = "50%";
    } else {
      this.width = "85%";
    }
    this.$store.state.secondaryDatabase.collection("shops").doc(__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.uid).get().then(function (doc) {
      _this5.cus = doc.data().supp || 0;
      _this5.pay = doc.data().pay;
    }).catch(function (error) {
      return alert(error);
    });

    if (this.$store.state.suppliers.length != 0) {
      this.items = this.$store.state.suppliers;
      this.totalRows = this.items.length;
      this.loading1 = false;
      this.changed = true;
    } else {
      var docRef = this.$store.state.secondaryDatabase.collection("suppliers");
      var firestoreQuery = docRef;
      if (this.$store.state.noDB === true) {
        firestoreQuery = firestoreQuery.where("shopOwner", "==", __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().currentUser.uid);
      }
      firestoreQuery.get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          var data = {
            id: doc.id,
            name: doc.data().name,
            email: doc.data().email,
            city: doc.data().city,
            regdate: doc.data().regdate,
            telephone: doc.data().telephone,
            payments: doc.data().payments,
            totalPayment: doc.data().totalPayment,
            totalRemaining: doc.data().totalRemaining,
            totalLoyalityPoints: doc.data().totalLoyalityPoints,
            note: doc.data().note
          };
          if (data.regdate != undefined) {
            data.regdate = doc.data().regdate.toDate().toLocaleString();
          }
          if (data.payments != undefined) {
            var add = function add(a, b) {
              return a + b;
            };
            //console.log('total', data.total)


            var pays = [];
            data.payments.forEach(function (p) {
              pays.push(p.a);
            });
            data.total = pays.reduce(add, 0);
          }
          _this5.items.push(data);
          _this5.totalRows = _this5.items.length;
          _this5.$store.state.suppliers = _this5.items;
          _this5.$store.state.viewedSupplierPage = true;
        });
        if (_this5.items.length == 0) {
          _this5.emptyText = "There are no records to show";
        }
        _this5.loading1 = false;
        _this5.changed = true;
      });
    }
  }
});

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_FirebaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CFAddDeductTable_vue__ = __webpack_require__(889);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "createinvoice",
  components: {
    CFAddDeductTable: __WEBPACK_IMPORTED_MODULE_4__CFAddDeductTable_vue__["a" /* default */]
  },
  data: function data() {
    return {
      open: 0,
      close: 0,
      end: "",
      add: 0,
      deduct: 0,
      inRegi: 0,
      diff: 0,
      sales: 0,
      cashData: [],
      desc: "",
      loading: false,
      loading1: false,
      changed: true, // otherwise create page will be blank
      notesData: [{ note: "5000", openCount: 0, closeCount: 0 },
      // { note: "2000", openCount: 0, closeCount: 0 },
      { note: "1000", openCount: 0, closeCount: 0 }, { note: "500", openCount: 0, closeCount: 0 }, { note: "100", openCount: 0, closeCount: 0 }, { note: "50", openCount: 0, closeCount: 0 }, { note: "20", openCount: 0, closeCount: 0 }, { note: "10", openCount: 0, closeCount: 0 }, { note: "5", openCount: 0, closeCount: 0 }, { note: "2", openCount: 0, closeCount: 0 }, { note: "1", openCount: 0, closeCount: 0 }]
    };
  },
  destroyed: function destroyed() {
    // Remove listener when component is destroyed
    // this.$barcodeScanner.destroy();
  },

  methods: {
    updateCashData: function updateCashData() {
      console.log("this.cashData", this.cashData);
      this.add = 0;
      this.deduct = 0;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.cashData), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var row = _step.value;

          if (row.type === "add") this.add += row.amount;
          if (row.type === "deduct") this.deduct += row.amount;
          this.updateSummary();
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    updateOpenAmount: function updateOpenAmount(index, row) {
      var _this = this;

      this.open = 0;
      this.notesData.forEach(function (data) {
        _this.open += +data.note * data.openCount;
      });
      this.updateSummary();
    },
    updateCloseAmount: function updateCloseAmount(index, row) {
      var _this2 = this;

      this.close = 0;
      this.notesData.forEach(function (data) {
        _this2.close += +data.note * data.closeCount;
      });
      this.updateSummary();
    },
    updateSummary: function updateSummary() {
      this.inRegi = this.open + this.sales + this.add - this.deduct;
      this.diff = this.close - this.inRegi;
    },
    saveCashFlow: function saveCashFlow() {
      var _this3 = this;

      this.loading1 = true;
      this.changed = false;
      if (this.$route.query.create) {
        this.$store.state.secondaryDatabase.collection("cashflow").add({
          notes: this.notesData,
          open: this.open,
          store: this.$store.state.selectedStore,
          start: __WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].firestore.Timestamp.now(),
          close: this.close,
          sales: this.sales,
          add: this.add,
          deduct: this.deduct,
          inRegi: this.inRegi,
          diff: 0, // this.diff - only setting value when closing cashflow,
          desc: this.desc,
          cashData: this.cashData,
          isCurrent: true,
          updated: __WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].firestore.Timestamp.now(),
          createdBy: this.$store.state.systemUser.name
        }).then(function (doc) {
          _this3.$notify({
            title: "Success",
            message: "Cash Flow created",
            type: "success"
          });
          _this3.loading1 = false;
          _this3.changed = true;
        }).catch(function (error) {
          return alert(error);
        });
      }
      if (this.$route.query.update) {
        var _$store$state$seconda;

        this.cashData.forEach(function (item) {
          return item.date = new Date(item.date);
        });
        this.$store.state.secondaryDatabase.collection("cashflow").doc(this.$route.query.id).update((_$store$state$seconda = {
          notes: this.notesData,
          open: this.open,
          end: this.end ? this.end : this.close || this.inRegi === 0 // this.inRegi === 0 means all balance to 0
          ? __WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].firestore.Timestamp.now() : "",
          updated: __WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].firestore.Timestamp.now(),
          close: this.close,
          sales: this.sales,
          add: this.add,
          deduct: this.deduct,
          inRegi: this.inRegi,
          diff: this.close || this.inRegi === 0 ? this.diff : 0, // this.diff - only setting value when closing cashflow
          desc: this.desc,
          cashData: this.cashData,
          isCurrent: this.end ? false : this.close || this.inRegi === 0 ? false : true
        }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_$store$state$seconda, "updated", __WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].firestore.Timestamp.now()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_$store$state$seconda, "updatedBy", this.$store.state.systemUser.name), _$store$state$seconda)).then(function (doc) {
          // this.$store.state.secondaryDatabase
          //   .collection("shops")
          //   .doc(this.shops[0].id)
          //   .update({
          //     curSales: 0,
          //   })
          //   .then((doc) => {

          //   });
          _this3.$notify({
            title: "Success",
            message: "Cash Flow updated",
            type: "success"
          });
          _this3.loading1 = false;
          _this3.changed = true;
        }).catch(function (error) {
          return alert(error);
        });
      }
    }
  },
  created: function created() {
    var _this4 = this;

    if (this.$route.query.update) {
      this.loading = true;
      this.changed = false;
      this.$store.state.secondaryDatabase.collection("cashflow").doc(this.$route.query.id).get().then(function (doc) {
        _this4.open = doc.data().open;
        _this4.close = doc.data().close;
        _this4.end = doc.data().end;
        _this4.add = doc.data().add;
        _this4.deduct = doc.data().deduct;
        _this4.inRegi = doc.data().inRegi;
        _this4.diff = doc.data().diff;
        _this4.sales = doc.data().sales;
        _this4.cashData = doc.data().cashData;
        _this4.desc = doc.data().desc;
        _this4.notesData = doc.data().notes || _this4.notesData;
        _this4.cashData.forEach(function (item) {
          return item.date = item.date.toDate().toLocaleString();
        });
        _this4.updateSummary();
        _this4.loading = false;
        _this4.changed = true;
      }).catch(function (error) {
        return alert(error);
      });
    }
  }
});

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "CFAddDeductTable",
  props: ["cashData", "updateCashData"],
  data: function data() {
    return {
      currentRow: null,
      store: "",
      tableData: []
    };
  },
  created: function created() {},


  methods: {
    // updatePriceData(store) {
    //   // this.tableData = this.priceData;
    //   // this.tableData = this.tableData.filter((data) => data.store === store);
    //   console.log(this.priceData, this.tableData);
    // },
    addRow: function addRow() {
      this.cashData.push({
        date: new Date(),
        type: "",
        amount: 0,
        note: ""
      });
      this.updateCashData();
      console.log(this.cashData);
    },
    disabledDate: function disabledDate(date) {
      return date > new Date();
    },
    handleDelete: function handleDelete(index, row) {
      this.cashData.splice(index, 1);
      this.updateCashData();
      console.log(this.cashData);
    }
  }
});

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_FirebaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TableHeader_vue__ = __webpack_require__(91);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "cashFlowlist",
  components: { TableHeader: __WEBPACK_IMPORTED_MODULE_2__TableHeader_vue__["a" /* default */] },
  data: function data() {
    return {
      emptyText: "Loading Records...",
      items: [],
      fields: ["index",
      //  { key: 'id', label: 'Order id', sortable: true },
      { key: "start", label: "Start Date", sortable: true }, { key: "end", label: "End Date", sortable: true }, { key: "open", label: "Open Amount", sortable: true }, { key: "close", label: "Close Amount", sortable: true }, { key: "sales", label: "Sales", sortable: true }, { key: "add", label: "Additions", sortable: true }, { key: "deduct", label: "Deductions", sortable: true }, { key: "diff", label: "Difference", sortable: true }, { key: "createdBy", label: "Created By", sortable: true }, { key: "updatedBy", label: "Updated By", sortable: true }, { key: "updated", label: "Updated", sortable: true }],

      stores: this.$store.state.stores,
      storeLocation: this.$store.state.selectedStore,
      month: new Date(),
      currentCashFlow: undefined,
      invoiceNo: "",
      customer: "",
      cashier: null,
      productId: "",
      currentPage: 1,
      perPage: 10,
      totalRows: items.length,
      pageOptions: ["Per Page", 5, 10, 15],
      sortBy: null,
      sortDesc: false,
      filter: null,
      isLoggedIn: false,
      currentUser: false,
      modalInfo: { title: "", content: "" },
      loading: false,
      loading1: false,
      loading2: false,
      changed: false,
      shops: [],
      orders: ""
    };
  },


  computed: {
    sortOptions: function sortOptions() {
      // Create an options list from our fields
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return { text: f.label, value: f.key };
      });
    }
  },
  methods: {
    disabledDate: function disabledDate(date) {
      return date > new Date();
    },
    searchCashFlows: function searchCashFlows() {
      console.log("month", this.month);
      if (this.month === "") {
        return alert("Please select month");
      }
      if (!this.storeLocation) {
        return alert("Please select store location");
      }
      this.loading = true;
      this.changed = false;
      this.items = [];
      this.getCashFlows(this.month, this.storeLocation);
    },
    getCashFlows: function getCashFlows(dateToGetRecord, storeToGet) {
      var _this = this;

      var store = storeToGet ? storeToGet : this.$store.state.selectedStore;
      var date = dateToGetRecord ? new Date(dateToGetRecord) : new Date();
      var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 1);
      console.log("store", store, date, firstDay, lastDay);
      this.$store.state.secondaryDatabase.collection("cashflow").where("start", ">=", __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].firestore.Timestamp.fromDate(firstDay)).where("start", "<=", __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].firestore.Timestamp.fromDate(lastDay)).where("store", "==", store).orderBy("start", "desc").get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          var data = doc.data();
          if (!doc.data().end) {
            data.diff = 'Not closed yet';
          }
          data.id = doc.id;
          data.start = doc.data().start.toDate().toLocaleDateString();
          data.updated = doc.data().updated ? doc.data().updated.toDate().toLocaleString() : "";
          if (data.end) {
            data.end = doc.data().end.toDate().toLocaleDateString();
          }
          _this.items.push(data);
          _this.currentCashFlow = _this.items.find(function (item) {
            return !item.end;
          });
          _this.totalRows = _this.items.length;
          // this.$store.state.expenses = this.items;
        });
        if (_this.items.length == 0) {
          _this.emptyText = "There are no records to show";
        }
        _this.loading = false;
        _this.changed = true;
      }).catch(function (error) {
        return console.log(error);
      });
    },
    onFiltered: function onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },


    backToTop: function backToTop() {
      $("html,body").stop().animate({
        scrollTop: 0
      }, "fast", "swing");
    }
  },
  created: function created() {
    this.backToTop();
    this.loading = true;
    this.changed = false;
    this.getCashFlows();
  }
});

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_FirebaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_app__ = __webpack_require__(2);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "expenses",
  data: function data() {
    return {
      emptyText: "Loading Records...",
      items: [],
      fields: [{ key: "name", label: "Name", sortable: true }, {
        key: "date",
        label: "Date",
        sortable: false
        // formatter: value => {
        //   return value.toLocaleString()
        // }
      }, { key: "cat", label: "Category", sortable: true }, { key: "subcat", label: "Sub Category", sortable: true }, { key: "amount", label: "Amount (Rs)", sortable: true }, { key: "pay", label: "Payment Method", sortable: true }, { key: "createdBy", label: "Created By", sortable: true }, { key: "updatedBy", label: "Updated By", sortable: true }, { key: "updated", label: "Updated", sortable: true }, { key: "note", label: "Note", sortable: false }, { key: "actions", label: "Actions" }],
      payments: [],
      amount: 0,
      stores: this.$store.state.stores,
      dialogFormVisible: false,
      dialogFormVisible2: false,
      dialogFormVisible3: false,
      width: "50%",
      currentPage: 1,
      perPage: 10,
      totalRows: items.length,
      pageOptions: [10, 25, 50],
      sortBy: null,
      sortDesc: false,
      filter: null,
      loading: false,
      loading1: false,
      loading2: false,
      changed: true,
      cus: 0,
      pay: 0,
      expenseCategories: {},
      initExpAmount: 0,
      categories: {},
      mainCategories: [],
      mainCategory: "",
      subCategories: [],
      subCategory: "",
      month: new Date(),
      storeLocation: this.$store.state.selectedStore,
      formdata: {
        name: "",
        cat: "",
        subcat: "",
        date: "",
        note: "",
        pay: "",
        cashflow: false,
        amount: 0,
        store: this.$store.state.selectedStore
      },
      formdata2: {
        name: "",
        cat: "",
        subcat: "",
        date: "",
        note: "",
        pay: "",
        cashflow: false,
        amount: 0,
        store: "",
        id: ""
      },
      rules2: {
        store: [{ required: true, message: "Please select store", trigger: "change" }],
        amount: [{ required: true, message: "Please input amount", trigger: "blur" }, {
          min: 0.0,
          type: "number",
          message: "Minimum amount is 0",
          trigger: "blur"
        }],
        cat: [{
          required: true,
          message: "Please select main category",
          trigger: "change"
        }],
        subcat: [{
          required: true,
          message: "Please select sub category",
          trigger: "change"
        }],
        pay: [{
          required: true,
          message: "Please select payment method",
          trigger: "change"
        }],
        date: [{ required: true, message: "Please select date", trigger: "change" }]
      },
      labelPosition: "top"
    };
  },


  computed: {
    sortOptions: function sortOptions() {
      // Create an options list from our fields
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return { text: f.label, value: f.key };
      });
    }
  },
  methods: {
    onFiltered: function onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    open1: function open1() {
      this.$notify.error({
        title: "Error",
        message: "Please Enter the Correct Details",
        type: "error"
      });
    },
    showUpdate: function showUpdate(item) {
      this.formdata2.name = item.name;
      this.formdata2.cat = item.cat;
      this.formdata2.subcat = item.subcat;
      this.formdata2.amount = item.amount;
      this.formdata2.pay = item.pay;
      this.formdata2.cashflow = item.cashflow;
      this.formdata2.store = item.store;
      this.formdata2.note = item.note;
      this.formdata2.date = item.date;
      this.dialogFormVisible3 = true;
      this.formdata2.id = item.id;
      this.initExpAmount = item.amount;
    },
    updateStore: function updateStore(store, expense, date) {
      var _this = this;

      date = new Date(date);
      this.$store.state.secondaryDatabase.collection("stores").doc(store).get().then(function (doc) {
        if (doc.exists) {
          var dailyData = void 0;
          if (date.toLocaleDateString() == new Date().toLocaleDateString()) {
            dailyData = doc.data().dailyData;
            if (dailyData && dailyData.date == new Date().toLocaleDateString()) {
              dailyData.expenses += expense;
              console.log("dailyData", dailyData);
            } else {
              dailyData = {
                date: new Date().toLocaleDateString(),
                sales: 0,
                expenses: expense,
                profit: 0,
                due: 0
              };
            }
          }
          var updateObj = { totalExp: doc.data().totalExp + expense };
          if (dailyData) updateObj.dailyData = dailyData;
          _this.$store.state.secondaryDatabase.collection("stores").doc(store).update(updateObj).then(function (doc) {}).catch(function (error) {
            return alert(error);
          });
        } else {}
      }).catch(function (error) {
        return alert(error);
      });
    },
    updateReport: function updateReport(expDate, store, expense) {
      var _this2 = this;

      var date = new Date(expDate);
      var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      this.$store.state.secondaryDatabase.collection("reports").where("date", ">=", __WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].firestore.Timestamp.fromDate(firstDay)).where("date", "<=", __WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].firestore.Timestamp.fromDate(lastDay)).where("storeLocation", "==", store).get().then(function (querySnapshot) {
        var data = {};
        var isReportExsists = false;
        querySnapshot.forEach(function (doc) {
          isReportExsists = true;
          data.id = doc.id;
          data.totalExp = doc.data().totalExp;
        });
        if (!isReportExsists) {
          var analyticsReport = {};
          var profitReport = {};
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this2.categories).forEach(function (key, index) {
            analyticsReport[key] = {};
            profitReport[key] = {};
            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this2.categories[key]).forEach(function (subcat, index) {
              analyticsReport[key][subcat] = 0;
              profitReport[key][subcat] = 0;
            });
          });
          _this2.$store.state.secondaryDatabase.collection("reports").add({
            date: __WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].firestore.Timestamp.fromDate(new Date(expDate)),
            storeLocation: store,
            reportData: analyticsReport,
            profitData: profitReport,
            totalSales: 0,
            totalProfit: 0,
            totalRemaining: 0,
            totalPurcCost: 0,
            totalPurcDue: 0,
            totalExp: expense
          }).then(function (doc) {}).catch(function (error) {
            return alert(error);
          });
          // console.log("this.analyticsReport is", this.analyticsReport);
        } else {
          _this2.$store.state.secondaryDatabase.collection("reports").doc(data.id).update({ totalExp: data.totalExp + expense }).then(function (docRef) {}).catch(function (error) {
            return alert(error);
          });
        }
      }).catch(function (error) {
        return alert(error);
      });
    },
    updateCashFlow: function updateCashFlow(store, expense, expenseName) {
      var _this3 = this;

      this.$store.state.secondaryDatabase.collection("cashflow").where("isCurrent", "==", true).where("store", "==", store).get().then(function (querySnapshot) {
        var data = {};
        var isCashFlowExsists = false;
        querySnapshot.forEach(function (doc) {
          isCashFlowExsists = true;
          data.id = doc.id;
          data.cashData = doc.data().cashData;
          data.deduct = doc.data().deduct;
        });
        var dataRow = {
          type: "deduct",
          amount: expense,
          date: __WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].firestore.Timestamp.now(),
          note: expenseName
        };
        if (!isCashFlowExsists) {
          _this3.$store.state.secondaryDatabase.collection("cashflow").add({
            // notes: this.notesData, // will asign when updating since undefined here
            open: 0,
            store: store,
            start: __WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].firestore.Timestamp.now(),
            close: 0,
            sales: 0,
            add: 0,
            deduct: expense,
            inRegi: 0,
            diff: 0,
            desc: "",
            cashData: [dataRow],
            isCurrent: true,
            updated: __WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].firestore.Timestamp.now(),
            createdBy: _this3.$store.state.systemUser.name
          }).then(function (doc) {}).catch(function (error) {
            return alert(error);
          });
          // console.log("this.analyticsReport is", this.analyticsReport);
        } else {
          data.cashData.push(dataRow);
          data.deduct += expense;
          _this3.$store.state.secondaryDatabase.collection("cashflow").doc(data.id).update({
            deduct: data.deduct,
            cashData: data.cashData,
            updated: __WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].firestore.Timestamp.now(),
            updatedBy: _this3.$store.state.systemUser.name
          }).then(function (docRef) {}).catch(function (error) {
            return alert(error);
          });
        }
      }).catch(function (error) {
        return alert(error);
      });
    },


    // updateDailyData(date, expense, store) {
    //   if (date.toLocaleDateString() !== new Date().toLocaleDateString()) return;

    //   const itemKey = `dailyData-${store}`;
    //   const dailyData = JSON.parse(localStorage.getItem(itemKey));
    //   if (dailyData && dailyData.date == new Date().toLocaleDateString()) {
    //     dailyData.expenses += expense;
    //     localStorage.setItem(itemKey, JSON.stringify(dailyData));
    //     console.log("dailyData", dailyData);
    //   } else {
    //     const dailyData = {
    //       date: new Date().toLocaleDateString(),
    //       sales: 0,
    //       expenses: expense,
    //       profit: 0,
    //       due: 0,
    //     };
    //     localStorage.setItem(itemKey, JSON.stringify(dailyData));
    //   }
    // },

    update: function update(fdata) {
      var _this4 = this;

      this.$refs[fdata].validate(function (valid) {
        if (valid) {
          _this4.dialogFormVisible3 = false, _this4.changed = false;
          _this4.loading = true;
          ////console.log(user)
          _this4.$store.state.secondaryDatabase.collection("expenses").doc(_this4.formdata2.id).update({
            name: _this4.formdata2.name,
            cat: _this4.formdata2.cat,
            subcat: _this4.formdata2.subcat,
            amount: _this4.formdata2.amount,
            pay: _this4.formdata2.pay,
            cashflow: _this4.formdata2.cashflow,
            store: _this4.formdata2.store,
            note: _this4.formdata2.note,
            date: new Date(_this4.formdata2.date),
            updated: __WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].firestore.Timestamp.now(),
            updatedBy: _this4.$store.state.systemUser.name
          }).then(function (docRef) {
            //console.log('docref', docRef.id)
            var newItems = _this4.items.filter(function (item) {
              ////console.log('filfkkk')
              if (item.id == _this4.formdata2.id) {
                // console.log('hjghkhjhjghjg', this.formdata2)
                item.name = _this4.formdata2.name, item.cat = _this4.formdata2.cat, item.subcat = _this4.formdata2.subcat, item.amount = _this4.formdata2.amount, item.pay = _this4.formdata2.pay, item.store = _this4.formdata2.store, item.note = _this4.formdata2.note, item.date = _this4.formdata2.date.toLocaleString();
                // item.id = this.formdata2 // bcz formdata2.id is deleted
                item.updated = __WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].firestore.Timestamp.now().toDate().toLocaleString(), item.updatedBy = _this4.$store.state.systemUser.name;
              }
              // console.log('item',item)
              return item;
            });
            // console.log('newItems', newItems)
            _this4.items = newItems;
            if (_this4.initExpAmount !== _this4.formdata2.amount) {
              var amount = _this4.formdata2.amount - _this4.initExpAmount;
              _this4.updateStore(_this4.formdata2.store, amount, _this4.formdata2.date);
              _this4.updateReport(_this4.formdata2.date, _this4.formdata2.store, amount);
              // this.updateDailyData(
              //   this.formdata2.date,
              //   amount,
              //   this.formdata2.store
              // );
            } else {}
              // this.updateStore(this.formdata2.store, this.formdata2.amount,this.formdata2.date);
              // this.updateReport(
              //   this.formdata2.date,
              //   this.formdata2.store,
              //   this.formdata2.amount
              // );


              // this.formdata2.id = expId
              // this.items.push(this.formdata2)

              // this.$store.state.expenses = this.items;
            _this4.resetForm(_this4.formdata);
            _this4.loading = false;
            _this4.changed = true;
            _this4.$notify({
              title: "Success",
              message: "Expense updated",
              type: "success"
            });
          }).catch(function (error) {
            return alert(error);
          });
        } else {
          _this4.open1();
          return false;
        }
      });
    },
    submitForm: function submitForm(fdata) {
      var _this5 = this;

      this.$refs[fdata].validate(function (valid) {
        if (valid) {
          _this5.dialogFormVisible2 = false, _this5.changed = false;
          _this5.loading = true;
          ////console.log(user)
          _this5.$store.state.secondaryDatabase.collection("expenses").add(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this5.formdata, {
            updated: __WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].firestore.Timestamp.now(),
            createdBy: _this5.$store.state.systemUser.name
          })).then(function (docRef) {
            //console.log('docref', docRef.id)
            var item = { id: docRef.id };
            item.name = _this5.formdata.name;
            item.cat = _this5.formdata.cat;
            item.subcat = _this5.formdata.subcat;
            item.amount = _this5.formdata.amount;
            item.pay = _this5.formdata.pay;
            item.store = _this5.formdata.store;
            item.note = _this5.formdata.note;
            item.date = _this5.formdata.date.toLocaleString();
            item.cashflow = _this5.formdata.cashflow;
            item.updated = __WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].firestore.Timestamp.now().toDate().toLocaleString();
            item.createddBy = _this5.$store.state.systemUser.name;
            _this5.items.push(item);
            // this.items = this.$store.state.expenses;
            _this5.totalRows = _this5.items.length;
            _this5.updateStore(_this5.formdata.store, _this5.formdata.amount, _this5.formdata.date);
            _this5.updateReport(_this5.formdata.date, _this5.formdata.store, _this5.formdata.amount);
            // this.updateDailyData(
            //   this.formdata.date,
            //   this.formdata.amount,
            //   this.formdata.store
            // );
            if (_this5.formdata.cashflow) {
              _this5.updateCashFlow(_this5.formdata.store, _this5.formdata.amount, _this5.formdata.name);
            }
            // this.$store.state.secondaryDatabase
            //   .collection("shops")
            //   .doc(firebase.auth().currentUser.uid)
            //   .update({
            //     cus: this.cus,
            //   })
            //   .then(() => {
            //     //console.log('secondaryDB shop id')
            //   })
            //   .catch((error) => alert(error));
            _this5.resetForm(_this5.formdata);
            _this5.loading = false;
            _this5.changed = true;
            _this5.$notify({
              title: "Success",
              message: "Expense added",
              type: "success"
            });
          }).catch(function (error) {
            return alert(error);
          });
        } else {
          _this5.open1();
          return false;
        }
      });
    },
    disabledDate: function disabledDate(date) {
      return date > new Date();
    },
    searchExpenses: function searchExpenses() {
      if (this.month === "") {
        return alert("Please select month");
      }
      if (!this.storeLocation) {
        return alert("Please select store location");
      }
      this.loading1 = true;
      this.changed = false;
      this.items = [];
      this.getExpenses(this.month, this.storeLocation);
    },
    getExpenses: function getExpenses(dateToGetRecord, storeToGet) {
      var _this6 = this;

      var store = storeToGet ? storeToGet : this.$store.state.selectedStore;
      var date = dateToGetRecord ? new Date(dateToGetRecord) : new Date();
      var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      console.log("store", store, date, firstDay, lastDay);
      var docRef = this.$store.state.secondaryDatabase.collection("expenses");
      var firestoreQuery = docRef;
      if (!dateToGetRecord) firestoreQuery = firestoreQuery.limit(10);
      firestoreQuery.where("date", ">=", __WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].firestore.Timestamp.fromDate(firstDay)).where("date", "<=", __WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].firestore.Timestamp.fromDate(lastDay)).where("store", "==", store).orderBy("date", "desc")
      // .where("date", ">=", firebase.firestore.Timestamp.fromDate(firstDay))
      // .where("date", "<=", firebase.firestore.Timestamp.fromDate(lastDay))
      // .where("store", "==", store)
      // .orderBy("date", "desc")
      .get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          var data = doc.data();
          data.id = doc.id;
          data.date = doc.data().date.toDate().toLocaleDateString();
          data.updated = doc.data().updated ? doc.data().updated.toDate().toLocaleString() : "";
          // if (data.date != undefined) {
          //   data.date = doc.data().date.toDate().toLocaleString();
          // }
          _this6.items.push(data);

          _this6.totalRows = _this6.items.length;
          // this.$store.state.expenses = this.items;
        });
        if (_this6.items.length == 0) {
          _this6.emptyText = "There are no records to show";
        }
        _this6.loading1 = false;
        _this6.changed = true;
      }).catch(function (error) {
        return console.log(error);
      });
    },
    resetForm: function resetForm(formName, reset) {
      if (reset) this.$refs[formName].resetFields();
      if (!reset) {
        formName.name = "";
        formName.cat = "";
        formName.subcatubcat = "";
        formName.amountmount = "";
        formName.pay = "";
        formName.store = "";
        formName.note = "";
        formName.date = "";

        formName.id = formName.id ? "" : delete formName.id;
      }
    }
  },
  created: function created() {
    var _this7 = this;

    this.loading1 = true;
    this.changed = false;
    if (screen.width > 767) {
      this.width = "50%";
    } else {
      this.width = "85%";
    }
    this.$store.state.secondaryDatabase.collection("shops").doc(__WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].auth().currentUser.uid).get().then(function (doc) {
      _this7.cus = doc.data().cus;
      _this7.pay = doc.data().pay;
      _this7.expenseCategories = doc.data().expenseCategories || {};
      _this7.categories = doc.data().categories;
      _this7.mainCategory = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this7.expenseCategories)[0];
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this7.expenseCategories).sort().forEach(function (key, index) {
        return _this7.mainCategories.push(key);
      });
      if (_this7.mainCategory) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this7.expenseCategories[_this7.mainCategory]).sort().forEach(function (subcat, index) {
          return _this7.subCategories.push(subcat);
        });
      }
    }).catch(function (error) {
      return console.log(error);
    });
    // this.$store.state.secondaryDatabase
    //   .collection("stores")
    //   .get()
    //   .then((querySnapshot) => {
    //     querySnapshot.forEach((doc) => {
    //       const data = {
    //         id: doc.id,
    //         value: doc.data().name,
    //         text: doc.data().name,
    //         name: doc.data().name,
    //       };
    //       this.stores.push(data);
    //     });
    //   })
    //   .catch((error) => alert(error.message));
    this.getExpenses();
    // if (this.$store.state.expenses.length != 0) {
    //   this.items = this.$store.state.expenses;
    //   this.totalRows = this.items.length;
    //   this.loading1 = false;
    //   this.changed = true;
    // } else {

    //}
  }
});

/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_FirebaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_app__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "managecategories",
  data: function data() {
    return {
      inputVisible: false,
      inputValue: "",
      shops: [],
      categories: "",
      tableData: []
    };
  },
  created: function created() {
    var _this = this;

    this.$store.state.secondaryDatabase.collection("shops").where("owner", "==", __WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].auth().currentUser.uid).get().then(function (querySnapshot) {
      querySnapshot.forEach(function (doc) {
        var data = {
          id: doc.id,
          categories: doc.data().expenseCategories || {},
          shopcat: doc.data().cat,
          shoptype: doc.data().shoptype,
          curProducts: doc.data().curProducts,
          maxProducts: doc.data().maxProducts,
          loc: doc.data().location,
          shopname: doc.data().name,
          catValues: doc.data().catValues,
          cansearch: doc.data().search
        };
        _this.shops.push(data);
        _this.categories = _this.shops[0].categories;
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this.categories).sort().forEach(function (key, index) {
          var subcategories = [];
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this.categories[key]).sort().forEach(function (subcat, index) {
            return subcategories.push(subcat);
          });
          _this.tableData.push({
            mainCategory: key,
            subCategories: subcategories,
            newCategory: "",
            inputVisible: false
          });
        });
        // console.log("this.categories is", this.categories, this.tableData);
      });
    }).catch(function (error) {
      return alert(error);
    });
  },

  methods: {
    openDelete: function openDelete(category) {
      var _this2 = this;

      this.$confirm("This will permanently delete the category. Continue?", "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
        center: true
      }).then(function () {
        _this2.deleteMainCat(category);
      }).catch(function () {
        _this2.$message({
          type: "info",
          message: "Delete canceled"
        });
      });
    },
    openDelete2: function openDelete2(tag, index, row) {
      var _this3 = this;

      this.$confirm("This will permanently delete the category. Continue?", "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
        center: true
      }).then(function () {
        _this3.handleClose(tag, index, row);
      }).catch(function () {
        _this3.$message({
          type: "info",
          message: "Delete canceled"
        });
      });
    },

    // tag table tags
    handleClose: function handleClose(tag, index, row) {
      if (this.categories[row.mainCategory][tag] && this.categories[row.mainCategory][tag] !== 0) {
        // console.log(this.categories[row.mainCategory][tag]);
        this.$notify({
          title: "Error",
          message: "Delete all products in this category first to delete the category",
          type: "error",
          duration: 0
        });
      } else {
        row.subCategories.splice(row.subCategories.indexOf(tag), 1);
        delete this.categories[row.mainCategory][tag];
        // console.log("this.categories", this.categories);
        this.$store.state.secondaryDatabase.collection("shops").doc(this.shops[0].id).update({
          expenseCategories: this.categories
        }).then(function (doc) {}).catch(function (error) {
          return alert(error);
        });
      }
    },
    showInput: function showInput(index, row) {
      // console.log(index);
      row.inputVisible = true;
      // this.$nextTick(_ => {
      //   this.$refs[index].$refs.input.focus();
      // });
    },
    handleInputConfirm: function handleInputConfirm(index, row) {
      var inputValue = this.inputValue;
      if (row.newCategory) {
        // console.log(row.newCategory);
        row.subCategories.push(row.newCategory);
        this.categories[row.mainCategory][row.newCategory] = 0;
        this.$store.state.secondaryDatabase.collection("shops").doc(this.shops[0].id).update({
          expenseCategories: this.categories
        }).then(function (doc) {}).catch(function (error) {
          return alert(error);
        });
        // console.log("this.categories", this.categories);
      }
      row.inputVisible = false;
      // console.log(row.subCategories);
      row.newCategory = "";
    },
    deleteMainCat: function deleteMainCat(category) {
      // console.log(this.shops[0].catValues[category]);
      if (this.shops[0].catValues[category] && this.shops[0].catValues[category] !== 0) {
        // console.log(this.shops[0].catValues[category]);
        this.$notify({
          title: "Error",
          message: "Delete all products in this category first to delete the category",
          type: "error",
          duration: 0
        });
      } else {
        this.tableData = this.tableData.filter(function (data) {
          return data.mainCategory !== category;
        });
        delete this.categories[category];
        this.$store.state.secondaryDatabase.collection("shops").doc(this.shops[0].id).update({
          expenseCategories: this.categories
        }).then(function (doc) {}).catch(function (error) {
          return alert(error);
        });
      }
    },
    open: function open() {
      var _this4 = this;

      this.$prompt("Enter main category", "Main Category", {
        confirmButtonText: "Create",
        cancelButtonText: "Cancel",
        inputPattern: /^[a-zA-Z ]*$/,
        inputErrorMessage: "Invalid Input"
      }).then(function (_ref) {
        var value = _ref.value;

        if (value === "" || value === undefined || value === null) {
          return _this4.$message({
            type: "error",
            message: "Input invalid"
          });
        }
        _this4.categories[value] = {};
        _this4.tableData.push({
          mainCategory: value,
          subCategories: [],
          newCategory: "",
          inputVisible: false
        });
        // console.log(this.categories);
        _this4.$store.state.secondaryDatabase.collection("shops").doc(_this4.shops[0].id).update({
          expenseCategories: _this4.categories
        }).then(function (doc) {}).catch(function (error) {
          return alert(error);
        });
        _this4.$message({
          type: "success",
          message: "Main category created"
        });
      }).catch(function () {
        _this4.$message({
          type: "info",
          message: "Input canceled"
        });
      });
    }
  }
});

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_FirebaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PrintInvo_vue__ = __webpack_require__(140);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "invoicelist",
  components: { PrintInvo: __WEBPACK_IMPORTED_MODULE_3__PrintInvo_vue__["a" /* default */] },
  data: function data() {
    return {
      emptyText: "Loading Records...",
      items: [],
      fields: ["index",
      //  { key: 'id', label: 'Order id', sortable: true },
      { key: "date", label: "Date", sortable: true }, { key: "invoiceNo", label: "Quotations No", sortable: true },
      // { key: "storeLocation", label: "Store" },
      { key: "customer", label: "Customer", sortable: true },
      // { key: "grossAmount", label: "Gross Amount", sortable: true },
      // { key: "discount", label: "Discount", sortable: true },
      // { key: "otherDiscount", label: "Other Discount", sortable: true },
      // { key: "tax", label: "tax", sortable: true },
      { key: "netAmount", label: "Net Amount", sortable: true },
      // { key: "cardPayment", label: "Card Payment", sortable: true },
      // { key: "cashPayment", label: "Cash Payment", sortable: true },
      // { key: "balance", label: "Balance", sortable: true },
      // { key: "status", label: "Status", sortable: true },
      { key: "updatedBy", label: "Updated By", sortable: true }, { key: "updated", label: "Updated", sortable: true }, { key: "actions", label: "Actions" }],
      productsFields: ["index", { key: "name", label: "Name", sortable: true }, { key: "barcode", label: "Barcode", sortable: true }, { key: "category", label: "Category", sortable: true }, { key: "subcategory", label: "Sub Category", sortable: true }, { key: "quantity", label: "Quantity", sortable: true }, { key: "price", label: "Price", sortable: true }, { key: "discount", label: "Discount", sortable: true }, { key: "subTotal", label: "Sub Total", sortable: true }],
      stores: this.$store.state.stores,
      storeLocation: this.$store.state.selectedStore,
      month: new Date(),
      invoiceNo: "",
      customer: "",
      cashier: null,
      productId: "",
      currentPage: 1,
      perPage: 10,
      totalRows: items.length,
      pageOptions: ["Per Page", 5, 10, 15],
      sortBy: null,
      sortDesc: false,
      filter: null,
      isLoggedIn: false,
      currentUser: false,
      modalInfo: { title: "", content: "" },
      loading: false,
      loading1: false,
      loading2: false,
      changed: false,
      shops: [],
      orders: ""
    };
  },


  computed: {
    sortOptions: function sortOptions() {
      // Create an options list from our fields
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return { text: f.label, value: f.key };
      });
    }
  },
  methods: {
    printInvoice: function printInvoice(storeLocation, item) {
      var store = this.$store.state.stores.find(function (store) {
        return store.id === storeLocation;
      });
      this.$root.$emit("printClicked", store, item);
    },
    disabledDate: function disabledDate(date) {
      return date > new Date();
    },
    searchInvoices: function searchInvoices() {
      var _this = this;

      console.log("month", this.month);
      if (!this.month && this.customer === "" && this.invoiceNo === "") {
        return alert("Please select month");
      }
      if (!this.storeLocation && this.customer === "" && this.invoiceNo === "") {
        return alert("Please select store location");
      }
      this.loading = true;
      this.changed = false;
      this.items = [];
      // console.log(
      //   "values",
      //   this.month,
      //   this.storeLocation,
      //   this.invoiceNo,
      //   this.customer
      // );
      var docRef = this.$store.state.secondaryDatabase.collection("quotations");
      var firestoreQuery = docRef;
      if (this.month) {
        var date = new Date(this.month);
        var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
        var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 1);
        console.log("dates", firstDay, lastDay);
        firestoreQuery = firestoreQuery.where("date", ">=", __WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].firestore.Timestamp.fromDate(firstDay));
        firestoreQuery = firestoreQuery.where("date", "<=", __WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].firestore.Timestamp.fromDate(lastDay));
      }
      if (this.storeLocation) {
        firestoreQuery = firestoreQuery.where("storeLocation", "==", this.storeLocation);
      }
      if (this.invoiceNo) {
        firestoreQuery = firestoreQuery.where("invoiceNo", "==", this.invoiceNo);
      }
      if (this.customer) {
        firestoreQuery = firestoreQuery.where("customerMobile", "==", this.customer);
      }
      firestoreQuery.orderBy("date", "desc").get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          var data = {
            id: doc.id,
            products: doc.data().products,
            date: doc.data().date.toDate().toLocaleString(),
            invoiceNo: doc.data().invoiceNo,
            storeLocation: doc.data().storeLocation,
            cashier: doc.data().cashier,
            cashierName: doc.data().cashierName,
            customer: doc.data().customer,
            customerMobile: doc.data().customerMobile,
            grossAmount: doc.data().grossAmount,
            discount: doc.data().discount,
            otherDiscount: doc.data().otherDiscount,
            tax: doc.data().tax,
            netAmount: doc.data().netAmount,
            cardPayment: doc.data().cardPayment,
            cashPayment: doc.data().cashPayment,
            chequePayment: doc.data().chequePayment,
            balance: doc.data().balance,
            updated: doc.data().updated.toDate().toLocaleString(),
            updatedBy: doc.data().updatedBy
          };
          _this.items.push(data);
          _this.totalRows = _this.items.length;
        });
        if (_this.items.length == 0) {
          _this.emptyText = "There are no records to show";
        }
        _this.loading = false;
        _this.changed = true;
      });
    },
    open: function open(id) {
      var _this2 = this;

      this.$confirm("This will permanently delete the item. Continue?", "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
        center: true
      }).then(function () {
        _this2.deleteOrder(id);
      }).catch(function () {
        _this2.$message({
          type: "info",
          message: "Delete canceled"
        });
      });
    },

    // open2(id) {
    //   this.$confirm('This will change the order status. Continue?', 'Warning', {
    //     confirmButtonText: 'OK',
    //     cancelButtonText: 'Cancel',
    //     type: 'warning',
    //     center: true
    //   }).then(() => {
    //     this.upOrder(id)
    //   }).catch(() => {
    //     this.$message({
    //       type: 'info',
    //       message: 'Change canceled'
    //     });
    //   });
    // },
    open3: function open3() {
      this.$notify.info({
        title: "Info",
        message: "Order status is updated"
      });
    },
    upOrder: function upOrder(id, status, refid) {
      var _this3 = this;

      this.$store.state.secondaryDatabase.collection("orders").doc(id).update({
        status: status
      }).then(function () {
        _this3.open3();
        __WEBPACK_IMPORTED_MODULE_1__config_FirebaseInit__["a" /* default */].collection("orders").doc(refid).update({
          status: status
        }).then(function () {}).catch(function (error) {
          return alert(error);
        });
      }).catch(function (error) {
        return alert(error);
      });
    },
    info: function info(item, index, button) {
      this.modalInfo.title = "Row index: " + index;
      this.modalInfo.content = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item, null, 2);
      this.$root.$emit("bv::show::modal", "modalInfo", button);
    },
    resetModal: function resetModal() {
      this.modalInfo.title = "";
      this.modalInfo.content = "";
    },
    onFiltered: function onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getId: function getId(item) {
      //console.log('getId fun invoked')
      this.productId = item.id;
      //console.log(this.productId)
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    backToTop: function backToTop() {
      $("html,body").stop().animate({
        scrollTop: 0
      }, "fast", "swing");
    }
  },
  created: function created() {
    var _this4 = this;

    //  if(firebase.auth().currentUser) {
    //       this.isLoggedIn = true;
    //       this.currentUser = firebase.auth().currentUser.email;
    //   }
    //  db.collection('shops').where('owner', '==', firebase.auth().currentUser.uid).get()
    //   .then(querySnapshot => {
    //   querySnapshot.forEach(doc => {
    //     const data = {
    //       'id': doc.id,
    //     }
    //     this.shops.push(data)
    //   })
    this.backToTop();
    this.loading = true;
    this.changed = false;
    this.$store.state.secondaryDatabase.collection("quotations").where("storeLocation", "==", this.$store.state.selectedStore).orderBy("date", "desc").limit(10).get().then(function (querySnapshot) {
      querySnapshot.forEach(function (doc) {
        var data = {
          id: doc.id,
          products: doc.data().products,
          date: doc.data().date.toDate().toLocaleString(),
          invoiceNo: doc.data().invoiceNo,
          storeLocation: doc.data().storeLocation,
          cashier: doc.data().cashier,
          cashierName: doc.data().cashierName,
          customer: doc.data().customer,
          customerMobile: doc.data().customerMobile,
          grossAmount: doc.data().grossAmount,
          discount: doc.data().discount,
          otherDiscount: doc.data().otherDiscount,
          tax: doc.data().tax,
          netAmount: doc.data().netAmount,
          cardPayment: doc.data().cardPayment,
          cashPayment: doc.data().cashPayment,
          chequePayment: doc.data().chequePayment,
          balance: doc.data().balance,
          updated: doc.data().updated.toDate().toLocaleString(),
          updatedBy: doc.data().updatedBy
        };
        _this4.items.push(data);
        _this4.totalRows = _this4.items.length;
      });
      if (_this4.items.length == 0) {
        _this4.emptyText = "There are no records to show";
      }

      _this4.loading = false;
      _this4.changed = true;
    });
    // this.$store.state.secondaryDatabase
    //   .collection("shops")
    //   .where("owner", "==", firebase.auth().currentUser.uid)
    //   .get()
    //   .then((querySnapshot) => {
    //     querySnapshot.forEach((doc) => {
    //       const data = {
    //         id: doc.id,
    //         orders: doc.data().orders,
    //       };
    //       this.shops.push(data);
    //       this.orders = this.shops[0].orders;
    //     });
    //   });
    // })
  }
});

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_FirebaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PrintInvo_vue__ = __webpack_require__(140);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "invoicelist",
  components: { PrintInvo: __WEBPACK_IMPORTED_MODULE_3__PrintInvo_vue__["a" /* default */] },
  data: function data() {
    return {
      emptyText: "Loading Records...",
      items: [],
      fields: ["index",
      //  { key: 'id', label: 'Order id', sortable: true },
      { key: "date", label: "Date", sortable: true }, { key: "invoiceNo", label: "GRN No", sortable: true },
      // { key: "storeLocation", label: "Store" },
      { key: "supplier", label: "Supplier", sortable: true },
      // { key: "grossAmount", label: "Gross Amount", sortable: true },
      // { key: "discount", label: "Discount", sortable: true },
      // { key: "otherDiscount", label: "Other Discount", sortable: true },
      // { key: "tax", label: "tax", sortable: true },
      { key: "netAmount", label: "Net Amount", sortable: true },
      // { key: "cardPayment", label: "Card Payment", sortable: true },
      // { key: "cashPayment", label: "Cash Payment", sortable: true },
      // { key: "balance", label: "Balance", sortable: true },
      // { key: "status", label: "Status", sortable: true },
      { key: "updatedBy", label: "Updated By", sortable: true }, { key: "updated", label: "Updated", sortable: true }, { key: "actions", label: "Actions" }],
      productsFields: ["index", { key: "name", label: "Name", sortable: true }, { key: "barcode", label: "Barcode", sortable: true }, { key: "category", label: "Category", sortable: true }, { key: "subcategory", label: "Sub Category", sortable: true }, { key: "quantity", label: "Quantity", sortable: true }, { key: "price", label: "Price", sortable: true }, { key: "discount", label: "Discount", sortable: true }, { key: "subTotal", label: "Sub Total", sortable: true }],
      stores: this.$store.state.stores, //[{ value: null, text: "Select Store Location", disabled: true }],
      storeLocation: this.$store.state.selectedStore,
      month: new Date(),
      invoiceNo: "",
      supplier: "",
      cashier: null,
      productId: "",
      currentPage: 1,
      perPage: 10,
      totalRows: items.length,
      pageOptions: ["Per Page", 5, 10, 15],
      sortBy: null,
      sortDesc: false,
      filter: null,
      isLoggedIn: false,
      currentUser: false,
      modalInfo: { title: "", content: "" },
      loading: false,
      loading1: false,
      loading2: false,
      changed: false,
      shops: [],
      orders: ""
    };
  },


  computed: {
    sortOptions: function sortOptions() {
      // Create an options list from our fields
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return { text: f.label, value: f.key };
      });
    }
  },
  methods: {
    printInvoice: function printInvoice(storeLocation, item) {
      var store = this.$store.state.stores.find(function (store) {
        return store.id === storeLocation;
      });
      this.$root.$emit("printClicked", store, item);
    },
    disabledDate: function disabledDate(date) {
      return date > new Date();
    },
    searchInvoices: function searchInvoices() {
      var _this = this;

      if (!this.month && this.supplier === "" && this.invoiceNo === "") {
        return alert("Please select month");
      }
      if (!this.storeLocation && this.supplier === "" && this.invoiceNo === "") {
        return alert("Please select store location");
      }
      this.loading = true;
      this.changed = false;
      this.items = [];
      // console.log(
      //   "values",
      //   this.month,
      //   this.storeLocation,
      //   this.invoiceNo,
      //   this.supplier
      // );
      var docRef = this.$store.state.secondaryDatabase.collection("POs");
      var firestoreQuery = docRef;
      if (this.month) {
        var date = new Date(this.month);
        var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
        var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 1);
        // console.log("dates", firstDay, lastDay);
        firestoreQuery = firestoreQuery.where("date", ">=", __WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].firestore.Timestamp.fromDate(firstDay));
        firestoreQuery = firestoreQuery.where("date", "<=", __WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].firestore.Timestamp.fromDate(lastDay));
      }
      if (this.storeLocation) {
        firestoreQuery = firestoreQuery.where("storeLocation", "==", this.storeLocation);
      }
      if (this.invoiceNo) {
        firestoreQuery = firestoreQuery.where("invoiceNo", "==", this.invoiceNo);
      }
      if (this.supplier) {
        firestoreQuery = firestoreQuery.where("supplierMobile", "==", this.supplier);
      }
      firestoreQuery.orderBy("date", "desc").get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          var data = {
            id: doc.id,
            products: doc.data().products,
            date: doc.data().date.toDate().toLocaleString(),
            invoiceNo: doc.data().invoiceNo,
            storeLocation: doc.data().storeLocation,
            cashier: doc.data().cashier,
            cashierName: doc.data().cashierName,
            supplier: doc.data().supplierName,
            supplierMobile: doc.data().supplierMobile,
            grossAmount: doc.data().grossAmount,
            discount: doc.data().discount,
            otherDiscount: doc.data().otherDiscount,
            tax: doc.data().tax,
            netAmount: doc.data().netAmount,
            cardPayment: doc.data().cardPayment,
            cashPayment: doc.data().cashPayment,
            chequePayment: doc.data().chequePayment,
            balance: doc.data().balance,
            updated: doc.data().updated.toDate().toLocaleString(),
            updatedBy: doc.data().updatedBy
          };
          _this.items.push(data);
          _this.totalRows = _this.items.length;
        });
        if (_this.items.length == 0) {
          _this.emptyText = "There are no records to show";
        }
        _this.loading = false;
        _this.changed = true;
      });
    },
    open: function open(id) {
      var _this2 = this;

      this.$confirm("This will permanently delete the item. Continue?", "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
        center: true
      }).then(function () {
        _this2.deleteOrder(id);
      }).catch(function () {
        _this2.$message({
          type: "info",
          message: "Delete canceled"
        });
      });
    },

    // open2(id) {
    //   this.$confirm('This will change the order status. Continue?', 'Warning', {
    //     confirmButtonText: 'OK',
    //     cancelButtonText: 'Cancel',
    //     type: 'warning',
    //     center: true
    //   }).then(() => {
    //     this.upOrder(id)
    //   }).catch(() => {
    //     this.$message({
    //       type: 'info',
    //       message: 'Change canceled'
    //     });
    //   });
    // },
    open3: function open3() {
      this.$notify.info({
        title: "Info",
        message: "Order status is updated"
      });
    },
    upOrder: function upOrder(id, status, refid) {
      var _this3 = this;

      this.$store.state.secondaryDatabase.collection("orders").doc(id).update({
        status: status
      }).then(function () {
        _this3.open3();
        __WEBPACK_IMPORTED_MODULE_1__config_FirebaseInit__["a" /* default */].collection("orders").doc(refid).update({
          status: status
        }).then(function () {}).catch(function (error) {
          return alert(error);
        });
      }).catch(function (error) {
        return alert(error);
      });
    },
    info: function info(item, index, button) {
      this.modalInfo.title = "Row index: " + index;
      this.modalInfo.content = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item, null, 2);
      this.$root.$emit("bv::show::modal", "modalInfo", button);
    },
    resetModal: function resetModal() {
      this.modalInfo.title = "";
      this.modalInfo.content = "";
    },
    onFiltered: function onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getId: function getId(item) {
      //console.log('getId fun invoked')
      this.productId = item.id;
      //console.log(this.productId)
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    backToTop: function backToTop() {
      $("html,body").stop().animate({
        scrollTop: 0
      }, "fast", "swing");
    }
  },
  created: function created() {
    var _this4 = this;

    //  if(firebase.auth().currentUser) {
    //       this.isLoggedIn = true;
    //       this.currentUser = firebase.auth().currentUser.email;
    //   }
    //  db.collection('shops').where('owner', '==', firebase.auth().currentUser.uid).get()
    //   .then(querySnapshot => {
    //   querySnapshot.forEach(doc => {
    //     const data = {
    //       'id': doc.id,
    //     }
    //     this.shops.push(data)
    //   })
    this.backToTop();
    this.loading = true;
    this.changed = false;
    this.$store.state.secondaryDatabase.collection("POs").where("storeLocation", "==", this.$store.state.selectedStore).orderBy("date", "desc").limit(10).get().then(function (querySnapshot) {
      querySnapshot.forEach(function (doc) {
        var data = {
          id: doc.id,
          products: doc.data().products,
          date: doc.data().date.toDate().toLocaleString(),
          invoiceNo: doc.data().invoiceNo,
          storeLocation: doc.data().storeLocation,
          cashier: doc.data().cashier,
          cashierName: doc.data().cashierName,
          supplier: doc.data().supplierName,
          supplierMobile: doc.data().supplierMobile,
          grossAmount: doc.data().grossAmount,
          discount: doc.data().discount,
          otherDiscount: doc.data().otherDiscount,
          tax: doc.data().tax,
          netAmount: doc.data().netAmount,
          cardPayment: doc.data().cardPayment,
          cashPayment: doc.data().cashPayment,
          chequePayment: doc.data().chequePayment,
          balance: doc.data().balance,
          updated: doc.data().updated.toDate().toLocaleString(),
          updatedBy: doc.data().updatedBy
        };
        _this4.items.push(data);
        _this4.totalRows = _this4.items.length;
      });
      if (_this4.items.length == 0) {
        _this4.emptyText = "There are no records to show";
      }

      _this4.loading = false;
      _this4.changed = true;
    });
    // this.$store.state.secondaryDatabase
    //   .collection("shops")
    //   .where("owner", "==", firebase.auth().currentUser.uid)
    //   .get()
    //   .then((querySnapshot) => {
    //     querySnapshot.forEach((doc) => {
    //       const data = {
    //         id: doc.id,
    //         orders: doc.data().orders,
    //       };
    //       this.shops.push(data);
    //       this.orders = this.shops[0].orders;
    //     });
    //   });
    // })
  }
});

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_FirebaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__KOTItemTable_vue__ = __webpack_require__(909);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InvoiceTemplates_KOTPrint_vue__ = __webpack_require__(912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__main__ = __webpack_require__(15);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "kot",
  components: {
    KOTItemTable: __WEBPACK_IMPORTED_MODULE_4__KOTItemTable_vue__["a" /* default */],
    KOTPrint: __WEBPACK_IMPORTED_MODULE_5__InvoiceTemplates_KOTPrint_vue__["a" /* default */]
  },
  data: function data() {
    return {
      BUS: __WEBPACK_IMPORTED_MODULE_6__main__["bus"],
      emptyText: "Loading Records...",
      items: [],
      fields: ["index",
      //  { key: 'id', label: 'Order id', sortable: true },
      { key: "kotNo", label: "KOT No", sortable: true }, { key: "date", label: "Date", sortable: true }, { key: "table", label: "Table", sortable: true }, { key: "createdBy", label: "Created By", sortable: true }, { key: "status", label: "Status", sortable: true }, { key: "invoice", label: "Invoice No", sortable: true }, { key: "actions", label: "Actions" }],
      options: [{
        value: "Pending",
        label: "Pending"
      }, {
        value: "Processing",
        label: "Processing"
      }, {
        value: "Cooked",
        label: "Cooked"
      }],
      serviceStaffOptions: [{
        value: "Served",
        label: "Served"
      }, {
        value: "Cancelled",
        label: "Cancelled"
      }],
      productId: "",
      currentPage: 1,
      perPage: 10,
      totalRows: items.length,
      pageOptions: ["Per Page", 5, 10, 15],
      sortBy: null,
      sortDesc: false,
      filter: null,
      isLoggedIn: false,
      currentUser: false,
      modalInfo: { title: "", content: "" },
      loading: false,
      loading1: false,
      loading2: false,
      changed: false,
      shops: [],
      orders: "",
      dialogFormVisible2: false,
      dialogFormVisible: false,
      kotItems: [],
      tableNo: '',
      width: '',
      kotNote: "",
      kot: '',
      printKot: '',
      printBot: '',
      allProducts: []
    };
  },


  computed: {
    sortOptions: function sortOptions() {
      // Create an options list from our fields
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return { text: f.label, value: f.key };
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_6__main__["bus"].$on("kotSaved", function (data) {
      _this.dialogFormVisible2 = false;
      _this.dialogFormVisible = false;
    });
  },

  methods: {
    managePrint: function managePrint(item, type) {
      var _this2 = this;

      var kotItems = item.items.filter(function (itm) {
        return itm.cat !== 'Beverage' && itm.cat !== 'Beverages' && itm.cat.toLowerCase() !== 'bot';
      });
      var botItems = item.items.filter(function (itm) {
        return itm.cat === 'Beverage' || itm.cat === 'Beverages' || itm.cat.toLowerCase() === 'bot';
      });
      var kot = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item)), { items: kotItems });
      var bot = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item)), { items: botItems });
      console.log("kotItems", kotItems, botItems, kot, bot);
      if (type == 'both') {
        this.print(kot, 'printKOT');
        if (botItems && botItems.length > 0) {
          setTimeout(function () {
            _this2.print(bot, 'printBOT'), 500;
          });
        }
      }
      if (type == 'kot') this.print(kot, 'printKOT');
      if (type == 'bot') this.print(bot, 'printBOT');
    },
    print: function print(item, printId) {
      var delay = 200;
      if (printId === 'printBOT') delay = 1000;
      if (printId === 'printKOT') this.printKot = item;
      if (printId === 'printBOT') this.printBot = item;
      console.log('printId', printId, item, this.printKot);
      setTimeout(function () {
        var mywindow = window.open("", "PRINT", "fullscreen=yes");

        mywindow.document.write("<html><head><title>" + document.title + "</title>");
        mywindow.document.write("<link rel=\"stylesheet\" href=\"../../../../static/pos.css\" type=\"text/css\" />");

        mywindow.document.write("</head><body >");
        mywindow.document.write(document.getElementById(printId).innerHTML);
        mywindow.document.write("</body></html>");

        mywindow.document.close(); // necessary for IE >= 10
        mywindow.focus(); // necessary for IE >= 10*/

        mywindow.print();
        return true;
      }, delay);

      // if (!this.showPrintPopup) {
      //   mywindow.close();
      // }
    },
    showUpdateKOT: function showUpdateKOT(item) {
      this.kot = item;
      this.dialogFormVisible = true;
    },
    open: function open(id, status) {
      var _this3 = this;

      this.$confirm("This will permanently delete the item. Continue?", "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
        center: true
      }).then(function () {
        if (status === "Pending" || status === "Processing") {
          return _this3.$notify({
            title: "Cannot Delete",
            message: "Order status is pending or processing",
            duration: 0,
            type: "error"
          });
        }
        _this3.deleteOrder(id, status);
      }).catch(function () {
        _this3.$message({
          type: "info",
          message: "Delete canceled"
        });
      });
    },

    // open2(id) {
    //   this.$confirm('This will change the order status. Continue?', 'Warning', {
    //     confirmButtonText: 'OK',
    //     cancelButtonText: 'Cancel',
    //     type: 'warning',
    //     center: true
    //   }).then(() => {
    //     this.upOrder(id)
    //   }).catch(() => {
    //     this.$message({
    //       type: 'info',
    //       message: 'Change canceled'
    //     });
    //   });
    // },
    open3: function open3() {
      this.$notify.info({
        title: "Success",
        type: "success",
        message: "KOT status is updated"
      });
    },
    upOrder: function upOrder(id, status, refid) {
      var _this4 = this;

      this.$store.state.secondaryDatabase.collection("kot").doc(id).update({
        status: status
      }).then(function () {
        _this4.open3();
      }).catch(function (error) {
        return alert(error);
      });
    },
    deleteOrder: function deleteOrder(id, status) {
      var _this5 = this;

      this.loading2 = true;
      this.changed = false;
      this.$store.state.secondaryDatabase.collection("kot").doc(id).delete().then(function () {
        //console.log('item deleted', id)
        var newitems = _this5.items.filter(function (item) {
          //console.log('filfkkk')
          return item.id !== id;
        });
        _this5.items = newitems;
        _this5.totalRows = _this5.items.length;
        _this5.loading2 = false;
        _this5.changed = true;
        if (_this5.items.length == 0) {
          _this5.emptyText = "There are no records to show";
        }
        //console.log(this.items)
      }).catch(function (error) {
        return alert(error);
      });
    },
    info: function info(item, index, button) {
      this.modalInfo.title = "Row index: " + index;
      this.modalInfo.content = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item, null, 2);
      this.$root.$emit("bv::show::modal", "modalInfo", button);
    },
    resetModal: function resetModal() {
      this.modalInfo.title = "";
      this.modalInfo.content = "";
    },
    onFiltered: function onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getId: function getId(item) {
      //console.log('getId fun invoked')
      this.productId = item.id;
      //console.log(this.productId)
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    backToTop: function backToTop() {
      $("html,body").stop().animate({
        scrollTop: 0
      }, "fast", "swing");
    }
  },
  created: function created() {
    var _this6 = this;

    if (screen.width > 767) {
      this.width = "50%";
    } else {
      this.width = "85%";
    }
    //  if(firebase.auth().currentUser) {
    //       this.isLoggedIn = true;
    //       this.currentUser = firebase.auth().currentUser.email;
    //   }
    //  db.collection('shops').where('owner', '==', firebase.auth().currentUser.uid).get()
    //   .then(querySnapshot => {
    //   querySnapshot.forEach(doc => {
    //     const data = {
    //       'id': doc.id,
    //     }
    //     this.shops.push(data)
    //   })
    this.backToTop();
    this.loading = true;
    this.changed = false;

    if (this.$store.state.allProducts != undefined && this.$store.state.allProducts.length !== 0) {
      this.allProducts = this.$store.state.allProducts;
    } else if (this.$store.state.allProducts.length === 0) {
      this.$store.state.secondaryDatabase.collection("products").where("owner", "==", __WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].auth().currentUser.uid).get().then(function (querySnapshot) {
        var newitems = [];
        querySnapshot.forEach(function (doc) {
          // //console.log('this.items.length is', state.items.length)
          var data = {
            id: doc.id,
            name: doc.data().name,
            barcode: doc.data().barcode,
            altertQunty: doc.data().altertQunty,
            category: doc.data().cat,
            brand: doc.data().brand,
            price: doc.data().disprice,
            subcategory: doc.data().subcat,
            desc: doc.data().desc,
            priceList: doc.data().priceList,
            totalQnty: 0,
            rack: doc.data().rack || '',
            img: doc.data().img
            // 'otherimgs': doc.data().otherimgs,
          };
          // const bytes = sizeof(doc.data());
          // console.log("size of doc", bytes, doc.data().name);
          newitems.push(data);
          _this6.allProducts = newitems;
          _this6.$store.state.allProducts = newitems;
        });
        if (_this6.items.length == 0) {
          _this6.emptyText = "There are no records to show";
        }
        _this6.loading1 = false;
        _this6.changed = true;
        console.log('kot', newitems);
        //console.log('state.items',this.$store.state.items)
      });
    }

    var docRef = this.$store.state.secondaryDatabase.collection("kot");
    var firestoreQuery = docRef;
    var start = new Date();
    start.setHours(0, 0, 0, 0);
    console.log(start);

    var end = new Date();
    end.setHours(23, 59, 59, 999);
    console.log(end);
    firestoreQuery = firestoreQuery.where("date", ">=", __WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].firestore.Timestamp.fromDate(start));
    firestoreQuery = firestoreQuery.where("date", "<=", __WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].firestore.Timestamp.fromDate(end));
    if (this.$store.state.systemUser.role === 'Service Staff') {
      firestoreQuery = firestoreQuery.where("user", "==", this.$store.state.systemUser.id);
      this.options = this.serviceStaffOptions;
    }
    if (this.$store.state.systemUser.role === 'Kitchen Staff') {
      console.log("Kitchen Staff", this.$store.state.systemUser.role);
      // firestoreQuery.where("user", "==", this.$store.state.systemUser.id)
      firestoreQuery = firestoreQuery.where("status", "in", ['Received', 'Pending', 'Processing']);
    }
    var pageRendered = false;
    firestoreQuery.where("store", "==", this.$store.state.selectedStore).orderBy("date", "desc").onSnapshot(function (querySnapshot) {
      _this6.items = [];
      if (pageRendered) {
        querySnapshot.docChanges().forEach(function (change) {
          if (change.type === "added" && _this6.$store.state.systemUser.role === 'Kitchen Staff') {
            _this6.$notify.info({
              title: "New KOT",
              type: "success",
              duration: 0,
              message: "New KOT is Added"
            });
          }
          if (change.type === "modified") {
            console.log("Modified city: ", change.doc.data());
            _this6.$notify.info({
              title: "KOT Updated",
              type: "warning",
              duration: 0,
              message: "KOT " + change.doc.data().kotNo + " is Updated"
            });
          }
          if (change.type === "removed") {
            // console.log("Removed city: ", change.doc.data());
          }
        });
      }
      querySnapshot.forEach(function (doc) {
        var data = {
          id: doc.id,
          date: doc.data().date,
          note: doc.data().note,
          items: doc.data().items,
          table: doc.data().table,
          status: doc.data().status,
          createdBy: doc.data().createdBy,
          kotNo: doc.data().kotNo,
          invoice: doc.data().invoice || '-'
        };
        if (data.date) data.date = data.date.toDate().toLocaleString();
        _this6.items.push(data);
        _this6.totalRows = _this6.items.length;
      });
      pageRendered = true;
      if (_this6.items.length == 0) {
        _this6.emptyText = "There are no records to show";
      }
      _this6.loading = false;
      _this6.changed = true;
    }, function (error) {
      console.log(error);
    });

    // })
  }
});

/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_FirebaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main__ = __webpack_require__(15);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "VariationsTable",
  props: ["KOTItemData", "tableNo", "kotNote", "method", "kotid", "allProducts"],
  data: function data() {
    return {
      currentRow: null,
      store: this.$store.state.selectedStore,
      tableData: [],
      stores: [{ id: "all", value: "all", label: "All Stores" }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.$store.state.stores)),
      prdNameList: this.$store.state.allProducts,
      itemName: '',
      table: "",
      note: "",
      disabled: false,
      innerVisible: false
    };
  },
  created: function created() {
    this.tableData = this.KOTItemData;
    this.table = this.tableNo;
    this.note = this.kotNote;
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3__main__["bus"].$on("kotdialogClosed", function (data) {
      console.log('kotdialogClosed');
      _this.table = '';
      _this.note = '';
    });
    __WEBPACK_IMPORTED_MODULE_3__main__["bus"].$on("kotdialogOpen", function (data) {
      console.log('kotdialogOpen');
      _this.table = data.table;
      _this.note = data.note;
    });
  },


  methods: {
    saveKOT: function saveKOT(method, kotid) {
      var _this2 = this;

      if (method === 'create') {
        this.disabled = true;
        this.$store.state.secondaryDatabase.collection("kot").add({
          note: this.note,
          table: this.table,
          items: this.KOTItemData,
          status: 'Received',
          store: this.$store.state.selectedStore,
          date: __WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].firestore.Timestamp.now(),
          kotNo: Math.floor(Math.random() * 100000001).toString(),
          updated: __WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].firestore.Timestamp.now(),
          user: this.$store.state.systemUser.id,
          createdBy: this.$store.state.systemUser.name,
          shopOwner: __WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].auth().currentUser.uid
        }).then(function (doc) {
          _this2.note = '';
          _this2.table = '';
          _this2.KOTItemData.splice(0, _this2.KOTItemData.length);
          __WEBPACK_IMPORTED_MODULE_3__main__["bus"].$emit("kotSaved", []);
          _this2.$notify({
            title: "Success",
            message: "KOT created",
            type: "success"
          });
          _this2.disabled = false;
          // this.loading1 = false;
          // this.changed = true;
        }).catch(function (error) {
          return alert(error);
        });
      }
      if (method === 'update') {
        // this.cashData.forEach((item) => (item.date = new Date(item.date)));
        this.$store.state.secondaryDatabase.collection("kot").doc(kotid).update({
          note: this.note,
          table: this.table,
          items: this.KOTItemData,
          updated: __WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].firestore.Timestamp.now(),
          updatedBy: this.$store.state.systemUser.name
        }).then(function (doc) {
          // this.$store.state.secondaryDatabase
          //   .collection("shops")
          //   .doc(this.shops[0].id)
          //   .update({
          //     curSales: 0,
          //   })
          //   .then((doc) => {

          //   });
          __WEBPACK_IMPORTED_MODULE_3__main__["bus"].$emit("kotSaved", []);
          _this2.$notify({
            title: "Success",
            message: "KOT updated",
            type: "success"
          });
          // this.loading1 = false;
          // this.changed = true;
        }).catch(function (error) {
          return alert(error);
        });
      }
    },
    updatePriceData: function updatePriceData(store) {
      // this.tableData = this.KOTItemData;
      // this.tableData = this.tableData.filter((data) => data.store === store);
      console.log(this.KOTItemData, this.tableData);
    },
    querySearch: function querySearch(queryString, cb) {
      var prds = this.prdNameList;
      var results = queryString ? prds.filter(this.createFilter(queryString)) : [];
      // call callback function to return suggestion objects
      cb(results);
    },
    createFilter: function createFilter(queryString) {
      return function (prd) {
        return prd.name.toLowerCase().includes(queryString.toLowerCase()) || prd.barcode.toLowerCase().includes(queryString.toLowerCase());
      };
    },
    handleProductChange: function handleProductChange(item) {
      this.itemName = item.name;
      var foundItem = this.KOTItemData.find(function (product) {
        return product.barcode === item.barcode && product.item === item.name;
      });
      if (foundItem) {
        foundItem.quantity++;
      } else {
        this.KOTItemData.push({
          item: item.name,
          barcode: item.barcode,
          quantity: 1,
          cat: item.category
        });
      }

      this.itemName = '';
      console.log(this.KOTItemData, this.tableData);
    },
    handleDelete: function handleDelete(index, row) {
      var foundIndex = this.KOTItemData.findIndex(function (pr) {
        return pr.name === row.name && pr.barcode === row.barcode && pr.quantity === row.quantity;
      });
      this.KOTItemData.splice(foundIndex, 1);
      console.log(this.KOTItemData, this.tableData);
    },
    open: function open(index, row) {
      var _this3 = this;

      this.$confirm("This will permanently delete the item. Continue?", "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
        center: true
      }).then(function () {
        _this3.handleDelete(index, row);
      }).catch(function () {
        _this3.$message({
          type: "info",
          message: "Delete canceled"
        });
      });
    }
  }
});

/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "posprinter",
  props: ["products", "kotNo", "table", "date",
  // "name",
  "note"],
  data: function data() {
    return {};
  },
  created: function created() {},

  methods: {}
});

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_FirebaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_easy_print__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firestore_size__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firestore_size___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_firestore_size__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PriceTable_vue__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PrintLabels_vue__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__TableHeader_vue__ = __webpack_require__(91);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var items = [];

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "allProducts",
  components: {
    PriceTable: __WEBPACK_IMPORTED_MODULE_7__PriceTable_vue__["a" /* default */],
    vueEasyPrint: __WEBPACK_IMPORTED_MODULE_4_vue_easy_print__["a" /* default */],
    PrintLabels: __WEBPACK_IMPORTED_MODULE_8__PrintLabels_vue__["a" /* default */],
    TableHeader: __WEBPACK_IMPORTED_MODULE_9__TableHeader_vue__["a" /* default */]
  },
  data: function data() {

    return {
      emptyText: "Loading Records...",
      items: [],
      month: new Date(),
      printPrd: '',
      printItemPrice: '',
      printItemName: '',
      fields: ["index", { key: "name", label: "Name", sortable: true }, { key: "barcode", label: "Barcode", sortable: true }, { key: "totalQnty", label: "Total Qty", sortable: true }, { key: "altertQunty", label: "Low Alert Qty", sortable: true }, { key: "subcategory", label: "Sub Category", sortable: true }, { key: "brand", label: "Brand", sortable: true }, { key: "price", label: "Price (RS)", sortable: true }, { key: "rack", label: "Bin/Rack", sortable: true }, { key: "actions", label: "Actions" }],

      labelPosition: "top",
      imgfiles: [],
      otherimgs: [],
      maxFiles: 4,
      category: "",
      subcategory: "",
      shops: [],
      shopcat: "",

      loading: false,
      loading1: false,
      loading2: false,
      changed: true,

      productId: "",
      currentPage: 1,
      perPage: 25,
      totalRows: items.length,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      filter: null,
      isLoggedIn: false,
      currentUser: false,
      modalInfo: { title: "", content: "" },
      selectedStore: 'all',
      stores: [{ id: "all", value: "all", label: "All Stores" }].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.$store.state.stores))
    };
  },

  computed: {
    sortOptions: function sortOptions() {
      // Create an options list from our fields
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return { text: f.label, value: f.key };
      });
    }
  },
  watch: {
    // items(){
    //     return this.$store.state.allProducts
    // }
  },
  methods: {
    // refresh(){
    //     this.loading1 = true
    //     this.changed = false
    //    setTimeout( () => {
    //        this.items = this.$store.state.allProducts
    //     this.loading1 = false
    //     this.changed = true
    //      //console.log('this.items]', this.items)
    //     },3000)
    // },
    print: function print(item, row) {
      this.printPrd = item;
      this.printItemPrice = row.sellPr;
      this.printItemName = item.name + " " + (row.serial ? row.serial : '');
      // Pass the element id here
      setTimeout(function () {
        var mywindow = window.open("", "PRINT", "fullscreen=yes");

        mywindow.document.write("<html><head><title>" + document.title + "</title>");

        mywindow.document.write("</head><body >");
        mywindow.document.write(document.getElementById(item.id).innerHTML);
        mywindow.document.write("</body></html>");

        mywindow.document.close(); // necessary for IE >= 10
        mywindow.focus(); // necessary for IE >= 10*/

        mywindow.print();
        return true;
      }, 300);

      // if (!this.showPrintPopup) {
      //   mywindow.close();
      // }
    },
    updateProducts: function updateProducts() {
      var _this = this;

      if (this.selectedStore === 'all') this.items = this.$store.state.allProducts;else {
        console.log(this.selectedStore, this.$store.state.stores);
        this.items = this.$store.state.allProducts.map(function (prd) {
          var newPriceList = prd.priceList.filter(function (pri) {
            return pri.store === _this.selectedStore;
          });
          var totalQnty = 0;
          newPriceList.forEach(function (item) {
            return totalQnty += item.quantity;
          });
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, prd, { priceList: newPriceList, totalQnty: totalQnty });
        });
        this.items = this.items.filter(function (item) {
          return item.totalQnty > 0;
        });
      }
    },
    info: function info(item, index, button) {
      this.modalInfo.title = "Row index: " + index;
      this.modalInfo.content = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item, null, 2);
      this.$root.$emit("bv::show::modal", "modalInfo", button);
    },
    resetModal: function resetModal() {
      this.modalInfo.title = "";
      this.modalInfo.content = "";
    },
    onFiltered: function onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getId: function getId(item) {
      //console.log('getId fun invoked')
      this.productId = item.id;
      //console.log(this.productId)
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    },


    backToTop: function backToTop() {
      $("html,body").stop().animate({
        scrollTop: 0
      }, "fast", "swing");
    },
    open: function open(id) {
      var _this2 = this;

      this.$confirm("This will permanently delete the item. Continue?", "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
        center: true
      }).then(function () {
        _this2.deleteItem(id);
      }).catch(function () {
        _this2.$message({
          type: "info",
          message: "Delete canceled"
        });
      });
    },
    savePriceDetails: function savePriceDetails(item) {
      var _this3 = this;

      this.$store.state.secondaryDatabase.collection("products").doc(item.id).update({
        priceList: item.priceList
      }).then(function () {
        _this3.$store.state.allProducts.find(function (_ref) {
          var id = _ref.id;

          //console.log('filfkkk')
          return id === item.id;
        }).priceList = item.priceList;
        if (_this3.$store.state.items[item.category]) {
          _this3.$store.state.items[item.category].find(function (_ref2) {
            var id = _ref2.id;
            return id === item.id;
          }).priceList = item.priceList;
        }

        _this3.$notify({
          title: "Success",
          message: "Price data updated",
          type: "success"
        });
      }).catch(function (error) {
        return alert(error);
      });
    },
    deleteItem: function deleteItem(itm) {
      var _this4 = this;

      this.loading2 = true;
      this.changed = false;
      this.$store.state.secondaryDatabase.collection("products").doc(itm.id).delete().then(function () {
        //console.log('item deleted', itm.id)
        var newitems = _this4.items.filter(function (item) {
          //console.log('filfkkk')
          return item.id !== itm.id;
        });
        _this4.items = newitems;
        _this4.totalRows = _this4.items.length;
        _this4.$store.state.allProducts = _this4.$store.state.allProducts.filter(function (item) {
          return item.id !== itm.id;
        });
        if (_this4.items.length == 0) {
          //console.log('this.items.length is', this.items.length)
          _this4.emptyText = "There are no records to show";
        }
        // this.prdstat[firebase.auth().currentUser.uid] -= 1;
        // db.collection("aaa").doc("prdstat").update({
        //   prdno: this.prdstat,
        // });
        //console.log(this.items)
        _this4.shops[0].catValues[itm.category] -= 1;
        _this4.shops[0].categories[itm.category][itm.subcategory] -= 1;
        _this4.shops[0].curProducts -= 1;
        if (_this4.shops[0].curProducts < 5 && _this4.shops[0].shopcat == "Vehicles") {
          _this4.shops[0].cansearch = "no";
        } else if (_this4.shops[0].curProducts < 10 && _this4.shops[0].shopcat != "Vehicles") {
          _this4.shops[0].cansearch = "no";
        }
        _this4.$store.state.secondaryDatabase.collection("shops").doc(_this4.shops[0].id).update({
          categories: _this4.shops[0].categories,
          curProducts: _this4.shops[0].curProducts,
          search: _this4.shops[0].cansearch,
          catValues: _this4.shops[0].catValues
        }).then(function (doc) {
          _this4.loading2 = false;
          _this4.changed = true;
          //console.log('doc is', doc)
        }).catch(function (error) {
          return alert("shop error", error);
        });
        _this4.$store.state.prdNameList = _this4.$store.state.prdNameList.filter(function (p) {
          return p.barcode !== itm.barcode;
        });
        var prds = 'prds';
        if (_this4.$store.state.noDB === true) {
          prds = "prds" + __WEBPACK_IMPORTED_MODULE_5_firebase_app__["a" /* default */].auth().currentUser.uid;
        }
        _this4.$store.state.secondaryDatabase.collection("prdlist").doc(prds).set({ data: _this4.$store.state.prdNameList }).then(function (doc) {}).catch(function (error) {
          alert(error);
        });
      }).catch(function (error) {
        return alert("prd error", error);
      });
    }
  },
  mounted: function mounted() {},
  created: function created() {
    var _this5 = this;

    this.backToTop();
    this.loading1 = true;
    this.changed = false;
    if (__WEBPACK_IMPORTED_MODULE_5_firebase_app__["a" /* default */].auth().currentUser) {
      this.isLoggedIn = true;
      this.currentUser = __WEBPACK_IMPORTED_MODULE_5_firebase_app__["a" /* default */].auth().currentUser.email;
    }
    this.$store.state.secondaryDatabase.collection("shops").where("owner", "==", __WEBPACK_IMPORTED_MODULE_5_firebase_app__["a" /* default */].auth().currentUser.uid).get().then(function (querySnapshot) {
      querySnapshot.forEach(function (doc) {
        var data = {
          id: doc.id,
          categories: doc.data().categories,
          shoptype: doc.data().shoptype,
          shopcat: doc.data().cat,
          curProducts: doc.data().curProducts,
          catValues: doc.data().catValues,
          cansearch: doc.data().search,
          loc: doc.data().location,
          shopname: doc.data().name
        };
        _this5.shops.push(data);
        if (_this5.shops[0].shopcat == "Vehicles") {
          _this5.shopcat = _this5.shops[0].shopcat;
        }
        _this5.category = _this5.$route.params.cat;
        _this5.subcategories = _this5.shops[0].categories[_this5.$route.params.cat];
        //console.log('this.subcategories is', this.subcategories)
      });
    });
    if (this.$store.state.allProducts != undefined && this.$store.state.allProducts.length !== 0) {
      this.items = this.$store.state.allProducts.map(function (a) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, a);
      }).map(function (p) {
        delete p.img;
        return p;
      }); // this wont deep copy the nested pricelist obj
      this.totalRows = this.items.length;
      this.loading1 = false;
      this.changed = true;
      //console.log(' from STATE this.$store.state.allProducts', this.$store.state.allProducts)
    } else if (this.$store.state.allProducts.length === 0) {
      //   var loadedItems = []
      //    //console.log(' before getter this.items]', this.items)
      //  loadedItems = this.$store.getters.getItems(this.$route.params.cat)
      //   setTimeout( () => {
      //      this.items = this.$store.state.allProducts
      //   this.loading1 = false
      //   this.changed = true
      //   //console.log(' from getter this.$store.getters.getItems(this.$route.params.cat)', this.$store.getters.getItems(this.$route.params.cat))
      //   //console.log(' from getter loadedItems]', loadedItems)
      //    //console.log(' from getter this.items]', this.items)
      //   },4000)

      this.$store.state.secondaryDatabase.collection("products").where("owner", "==", __WEBPACK_IMPORTED_MODULE_5_firebase_app__["a" /* default */].auth().currentUser.uid).get().then(function (querySnapshot) {
        var newitems = [];
        querySnapshot.forEach(function (doc) {
          // //console.log('this.items.length is', state.items.length)
          var data = {
            id: doc.id,
            name: doc.data().name,
            barcode: doc.data().barcode,
            altertQunty: doc.data().altertQunty,
            category: doc.data().cat,
            brand: doc.data().brand,
            price: doc.data().disprice,
            subcategory: doc.data().subcat,
            desc: doc.data().desc,
            profitMargin: doc.data().profitMargin,
            priceList: doc.data().priceList,
            totalQnty: 0,
            rack: doc.data().rack || '',
            img: doc.data().img,
            _showDetails: false // toggle row details
            // 'img': doc.data().img,
            // 'otherimgs': doc.data().otherimgs,
          };
          data.priceList.forEach(function (item) {
            return data.totalQnty += item.quantity;
          });
          var bytes = __WEBPACK_IMPORTED_MODULE_6_firestore_size___default()(doc.data());
          console.log("size of doc", bytes, doc.data().name);
          newitems.push(data);
          _this5.items = newitems.map(function (a) {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, a);
          }).map(function (p) {
            delete p.img;
            return p;
          }).sort(function (a, b) {
            return a.name > b.name ? 1 : b.name > a.name ? -1 : 0;
          });
          _this5.totalRows = _this5.items.length;
          _this5.$store.state.allProducts = newitems.sort(function (a, b) {
            return a.name > b.name ? 1 : b.name > a.name ? -1 : 0;
          });
          //console.log('state.items[cat]',this.$store.state.allProducts)
        });
        if (_this5.items.length == 0) {
          _this5.emptyText = "There are no records to show";
        }
        _this5.loading1 = false;
        _this5.changed = true;
        //console.log('newitems', newitems)
        //console.log('state.items',this.$store.state.items)
      });
    }
    // db.collection("aaa")
    //   .doc("prdstat")
    //   .get()
    //   .then((doc) => {
    //     this.prdstat = doc.data().prdno;
    //   });
    // //console.log('this.items.length is', this.items.length)
    // if(this.items.length == 0){
    //     this.emptyText = 'There are no records to show'
    // }
  }
});

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_FirebaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__JobNoteDialog_vue__ = __webpack_require__(921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InvoiceTemplates_JobPrint_vue__ = __webpack_require__(924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__main__ = __webpack_require__(15);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "job",
  components: {
    JobNoteDialog: __WEBPACK_IMPORTED_MODULE_3__JobNoteDialog_vue__["a" /* default */],
    JobPrint: __WEBPACK_IMPORTED_MODULE_4__InvoiceTemplates_JobPrint_vue__["a" /* default */]
  },
  data: function data() {
    return {
      BUS: __WEBPACK_IMPORTED_MODULE_5__main__["bus"],
      emptyText: "Loading Records...",
      items: [],
      fields: ["index",
      //  { key: 'id', label: 'Order id', sortable: true },
      { key: "jobNo", label: this.$route.name === 'jobNotes' ? "job No" : 'Order No', sortable: true }, { key: "date", label: "Date", sortable: true }, { key: "name", label: "Customer", sortable: true }, { key: "tel", label: "Telephone", sortable: true }, this.$route.name === 'jobNotes' ? { key: "device", label: "Device", sortable: true } : "", this.$route.name === 'jobNotes' ? { key: "techName", label: "Technician", sortable: true } : '', { key: "adv", label: "Advance(Rs)", sortable: true }, { key: "status", label: "Status", sortable: true }, { key: "invoice", label: "Invoice No", sortable: true }, { key: "actions", label: "Actions" }],
      options: [{
        value: "Pending",
        label: "Pending"
      }, {
        value: "Working",
        label: "Working"
      }, {
        value: "Completed",
        label: "Completed"
      }],
      serviceStaffOptions: [{
        value: "Served",
        label: "Served"
      }, {
        value: "Cancelled",
        label: "Cancelled"
      }],
      stores: this.$store.state.stores, // [{ value: null, text: "Select Store Location", disabled: true }],
      storeLocation: this.$store.state.selectedStore,
      month: new Date(),
      jobNo: "",
      customer: "",
      cashier: null,
      productId: "",
      currentPage: 1,
      perPage: 10,
      totalRows: items.length,
      pageOptions: ["Per Page", 5, 10, 15],
      sortBy: null,
      sortDesc: false,
      filter: null,
      isLoggedIn: false,
      currentUser: false,
      modalInfo: { title: "", content: "" },
      loading: false,
      loading1: false,
      loading2: false,
      changed: false,
      shops: [],
      orders: "",
      dialogFormVisible2: false,
      dialogFormVisible: false,
      jobItems: [],
      tableNo: '',
      width: '',
      jobNote: "",
      job: {},
      printjob: '',
      printBot: '',
      allProducts: [],
      users: [],
      storeDetails: {}
    };
  },


  computed: {
    sortOptions: function sortOptions() {
      // Create an options list from our fields
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return { text: f.label, value: f.key };
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.storeDetails = this.stores.find(function (str) {
      return str.id === _this.storeLocation;
    });
    console.log('storeDetails', this.storeDetails);
    var saveType = this.$route.name === 'jobNotes' ? 'jobSaved' : 'orderSaved';
    __WEBPACK_IMPORTED_MODULE_5__main__["bus"].$on(saveType, function (data) {
      _this.dialogFormVisible2 = false;
      _this.dialogFormVisible = false;
      console.log('data', data, saveType);
      data.date && typeof data.date !== 'string' ? data.date = data.date.toDate().toLocaleString() : '';
      data.date ? _this.items.unshift(data) : '';
    });
  },

  methods: {
    showUpdatejob: function showUpdatejob(item) {
      console.log("job", item);
      this.job = item;
      this.dialogFormVisible = true;
    },
    open: function open(id, status) {
      var _this2 = this;

      this.$confirm("This will permanently delete the item. Continue?", "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
        center: true
      }).then(function () {
        if (status === "Pending" || status === "Working") {
          return _this2.$notify({
            title: "Cannot Delete",
            message: "Job status is pending or working",
            duration: 0,
            type: "error"
          });
        }
        _this2.deleteOrder(id, status);
      }).catch(function () {
        _this2.$message({
          type: "info",
          message: "Delete canceled"
        });
      });
    },

    // open2(id) {
    //   this.$confirm('This will change the order status. Continue?', 'Warning', {
    //     confirmButtonText: 'OK',
    //     cancelButtonText: 'Cancel',
    //     type: 'warning',
    //     center: true
    //   }).then(() => {
    //     this.upOrder(id)
    //   }).catch(() => {
    //     this.$message({
    //       type: 'info',
    //       message: 'Change canceled'
    //     });
    //   });
    // },
    open3: function open3() {
      this.$notify.info({
        title: "Success",
        type: "success",
        message: "job status is updated"
      });
    },
    upOrder: function upOrder(id, status, refid) {
      var _this3 = this;

      this.$store.state.secondaryDatabase.collection("job").doc(id).update({
        status: status
      }).then(function () {
        _this3.open3();
      }).catch(function (error) {
        return alert(error);
      });
    },
    deleteOrder: function deleteOrder(id, status) {
      var _this4 = this;

      this.loading2 = true;
      this.changed = false;
      this.$store.state.secondaryDatabase.collection("job").doc(id).delete().then(function () {
        //console.log('item deleted', id)
        var newitems = _this4.items.filter(function (item) {
          //console.log('filfkkk')
          return item.id !== id;
        });
        _this4.items = newitems;
        _this4.totalRows = _this4.items.length;
        _this4.loading2 = false;
        _this4.changed = true;
        if (_this4.items.length == 0) {
          _this4.emptyText = "There are no records to show";
        }
        //console.log(this.items)
      }).catch(function (error) {
        return alert(error);
      });
    },
    info: function info(item, index, button) {
      this.modalInfo.title = "Row index: " + index;
      this.modalInfo.content = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item, null, 2);
      this.$root.$emit("bv::show::modal", "modalInfo", button);
    },
    resetModal: function resetModal() {
      this.modalInfo.title = "";
      this.modalInfo.content = "";
    },
    onFiltered: function onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getId: function getId(item) {
      //console.log('getId fun invoked')
      this.productId = item.id;
      //console.log(this.productId)
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    backToTop: function backToTop() {
      $("html,body").stop().animate({
        scrollTop: 0
      }, "fast", "swing");
    },

    searchJobs: function searchJobs() {
      var _this5 = this;

      if (!this.month && this.customer === "" && this.jobNo === "" && !this.cashier) {
        return alert("Please select month");
      }
      if (!this.storeLocation && this.customer === "" && this.jobNo === "") {
        return alert("Please select store location");
      }
      this.loading = true;
      this.changed = false;
      this.items = [];
      console.log("values", this.month, this.storeLocation, this.invoiceNo, this.customer);
      var docRef = this.$store.state.secondaryDatabase.collection("job");
      var firestoreQuery = docRef;
      var type = this.$route.name === 'jobNotes' ? 'job' : 'order';
      firestoreQuery = firestoreQuery.where("type", "==", type);
      if (this.month) {
        var date = new Date(this.month);
        var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
        var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 1);
        // console.log("dates", firstDay, lastDay);
        firestoreQuery = firestoreQuery.where("date", ">=", __WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].firestore.Timestamp.fromDate(firstDay));
        firestoreQuery = firestoreQuery.where("date", "<=", __WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].firestore.Timestamp.fromDate(lastDay));
      }
      if (this.storeLocation) {
        firestoreQuery = firestoreQuery.where("store", "==", this.storeLocation);
      }
      if (this.jobNo) {
        firestoreQuery = firestoreQuery.where("jobNo", "==", this.jobNo);
      }
      if (this.cashier) {
        firestoreQuery = firestoreQuery.where("techId", "==", this.cashier);
      }
      if (this.customer) {
        firestoreQuery = firestoreQuery.where("tel", "==", +this.customer);
      }
      // console.log('query',firestoreQuery)
      firestoreQuery.orderBy("date", "desc").get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          var data = {
            id: doc.id,
            items: doc.data().items,
            date: doc.data().date.toDate().toLocaleString(),
            jobNo: doc.data().jobNo,
            store: doc.data().store,
            techId: doc.data().techId,
            techName: doc.data().techName,
            user: doc.data().user,
            name: doc.data().name,
            tel: doc.data().tel,
            adv: doc.data().adv,
            status: doc.data().status,
            invoice: doc.data().invoice || 'Not invoiced',
            device: doc.data().device,
            updated: doc.data().updated.toDate().toLocaleString(),
            updatedBy: doc.data().updatedBy,
            note: doc.data().note,
            _showDetails: false // toggle row details
          };

          _this5.items.push(data);
          _this5.totalRows = _this5.items.length;
        });
        if (_this5.items.length == 0) {
          _this5.emptyText = "There are no records to show";
        }
        _this5.loading = false;
        _this5.changed = true;
      });
    }
  },
  created: function created() {
    var _this6 = this;

    if (screen.width > 767) {
      this.width = "50%";
    } else {
      this.width = "85%";
    }
    //  if(firebase.auth().currentUser) {
    //       this.isLoggedIn = true;
    //       this.currentUser = firebase.auth().currentUser.email;
    //   }
    //  db.collection('shops').where('owner', '==', firebase.auth().currentUser.uid).get()
    //   .then(querySnapshot => {
    //   querySnapshot.forEach(doc => {
    //     const data = {
    //       'id': doc.id,
    //     }
    //     this.shops.push(data)
    //   })
    this.backToTop();
    this.loading = true;
    this.changed = false;
    this.searchJobs();

    if (this.$store.state.users.length != 0) {
      this.users = this.$store.state.users;
    } else {
      var docRef = this.$store.state.secondaryDatabase.collection("sysusers");
      var firestoreQuery = docRef;
      if (this.$store.state.noDB === true) {
        firestoreQuery = firestoreQuery.where("shopOwner", "==", __WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].auth().currentUser.uid);
      }
      firestoreQuery.get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          var data = {
            id: doc.id,
            name: doc.data().name,
            email: doc.data().email,
            city: doc.data().city,
            regdate: doc.data().regdate,
            telephone: doc.data().telephone,
            sysid: doc.data().sysid,
            role: doc.data().role,
            store: doc.data().store,
            note: doc.data().note,
            permissions: doc.data().permissions
          };
          if (data.regdate != undefined) {
            data.regdate = doc.data().regdate.toDate().toLocaleString();
          }
          _this6.users.push(data);
          _this6.$store.state.users = _this6.users;
        });
      });
    }

    if (this.$store.state.allProducts != undefined && this.$store.state.allProducts.length !== 0) {
      this.allProducts = this.$store.state.allProducts;
    } else if (this.$store.state.allProducts.length === 0) {
      this.$store.state.secondaryDatabase.collection("products").where("owner", "==", __WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].auth().currentUser.uid).get().then(function (querySnapshot) {
        var newitems = [];
        querySnapshot.forEach(function (doc) {
          // //console.log('this.items.length is', state.items.length)
          var data = {
            id: doc.id,
            name: doc.data().name,
            barcode: doc.data().barcode,
            altertQunty: doc.data().altertQunty,
            category: doc.data().cat,
            brand: doc.data().brand,
            price: doc.data().disprice,
            subcategory: doc.data().subcat,
            desc: doc.data().desc,
            priceList: doc.data().priceList,
            totalQnty: 0,
            rack: doc.data().rack || '',
            img: doc.data().img
            // 'otherimgs': doc.data().otherimgs,
          };
          // const bytes = sizeof(doc.data());
          // console.log("size of doc", bytes, doc.data().name);
          newitems.push(data);
          _this6.allProducts = newitems;
          _this6.$store.state.allProducts = newitems;
        });

        _this6.loading1 = false;
        _this6.changed = true;
        console.log('job', newitems);
        //console.log('state.items',this.$store.state.items)
      });
    }

    // })
  }
});

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_FirebaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__main__ = __webpack_require__(15);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "VariationsTable",
  props: ["jobItemData", "jobData", "method", "jobid", "allProducts", 'users'],
  data: function data() {
    return {
      currentRow: null,
      store: this.$store.state.selectedStore,
      tableData: [],
      stores: [{ id: "all", value: "all", label: "All Stores" }].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.$store.state.stores)),
      prdNameList: this.$store.state.allProducts,
      itemName: '',
      table: "",
      note: "",
      disabled: false,
      innerVisible: false,
      formdata: {
        name: "",
        tel: "",
        id: "",
        device: "",
        status: "Pending",
        user: "",
        items: [],
        note: "",
        techId: '',
        techName: '',
        adv: 0
      },
      type: this.$route.name === 'jobNotes' ? 'job' : 'order',
      labelPosition: "top"
    };
  },
  created: function created() {
    this.tableData = this.jobItemData;
    this.jobData ? this.formdata = this.jobData : '';
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_4__main__["bus"].$on("dialogClosed", function (data) {
      console.log('dialogClosed');
      _this.formdata = {
        name: "",
        tel: "",
        id: "",
        device: "",
        status: "",
        user: "",
        items: [],
        note: "",
        techId: '',
        techName: '',
        adv: 0
      };
    });
    __WEBPACK_IMPORTED_MODULE_4__main__["bus"].$on("dialogOpen", function (data) {
      console.log('dialogOpen');
      _this.formdata = data;
    });
  },


  methods: {
    savejob: function savejob(method, jobid) {
      var _this2 = this;

      var saveType = this.$route.name === 'jobNotes' ? 'jobSaved' : 'orderSaved';
      if (method === 'create') {
        this.disabled = true;
        var jobData = {
          note: this.formdata.note,
          name: this.formdata.name,
          device: this.formdata.device,
          tel: this.formdata.tel,
          items: [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.jobItemData)),
          status: 'Pending',
          store: this.$store.state.selectedStore,
          techId: this.formdata.techId,
          techName: this.formdata.techName,
          adv: this.formdata.adv,
          type: this.type,
          date: __WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].firestore.Timestamp.now(),
          jobNo: Math.floor(Math.random() * 100000001).toString(),
          updated: __WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].firestore.Timestamp.now(),
          user: this.$store.state.systemUser.id,
          createdBy: this.$store.state.systemUser.name,
          shopOwner: __WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].auth().currentUser.uid
        };
        this.$store.state.secondaryDatabase.collection("job").add(jobData).then(function (doc) {
          _this2.formdata = {};
          console.log("saveType", saveType);
          __WEBPACK_IMPORTED_MODULE_4__main__["bus"].$emit(saveType, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, jobData, { id: doc.id }));
          _this2.jobItemData.splice(0, _this2.jobItemData.length);
          _this2.$notify({
            title: "Success",
            message: "job created",
            type: "success"
          });
          _this2.disabled = false;
          // this.loading1 = false;
          // this.changed = true;
        }).catch(function (error) {
          return alert(error);
        });
      }
      if (method === 'update') {
        // this.cashData.forEach((item) => (item.date = new Date(item.date)));
        this.$store.state.secondaryDatabase.collection("job").doc(jobid).update({
          note: this.formdata.note,
          name: this.formdata.name,
          device: this.formdata.device,
          tel: this.formdata.tel,
          items: this.jobItemData,
          status: this.formdata.status,
          adv: this.formdata.adv,
          updated: __WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].firestore.Timestamp.now(),
          updatedBy: this.$store.state.systemUser.name
        }).then(function (doc) {
          // this.$store.state.secondaryDatabase
          //   .collection("shops")
          //   .doc(this.shops[0].id)
          //   .update({
          //     curSales: 0,
          //   })
          //   .then((doc) => {

          //   });
          __WEBPACK_IMPORTED_MODULE_4__main__["bus"].$emit(saveType, {});
          _this2.$notify({
            title: "Success",
            message: "job updated",
            type: "success"
          });
          // this.loading1 = false;
          // this.changed = true;
        }).catch(function (error) {
          return alert(error);
        });
      }
    },
    updatePriceData: function updatePriceData(store) {
      // this.tableData = this.jobItemData;
      // this.tableData = this.tableData.filter((data) => data.store === store);
      console.log(this.jobItemData, this.tableData);
    },
    querySearch: function querySearch(queryString, cb) {
      var prds = this.prdNameList;
      var results = queryString ? prds.filter(this.createFilter(queryString)) : [];
      // call callback function to return suggestion objects
      cb(results);
    },
    createFilter: function createFilter(queryString) {
      return function (prd) {
        return prd.name.toLowerCase().includes(queryString.toLowerCase()) || prd.barcode.toLowerCase().includes(queryString.toLowerCase());
      };
    },
    handleProductChange: function handleProductChange(item) {
      this.itemName = item.name;
      var foundItem = this.jobItemData.find(function (product) {
        return product.barcode === item.barcode && product.item === item.name;
      });
      if (foundItem) {
        foundItem.quantity++;
      } else {
        this.jobItemData.push({
          item: item.name,
          barcode: item.barcode,
          quantity: 1,
          cat: item.category
        });
      }

      this.itemName = '';
      console.log(this.jobItemData, this.tableData);
    },
    handleDelete: function handleDelete(index, row) {
      var foundIndex = this.jobItemData.findIndex(function (pr) {
        return pr.name === row.name && pr.barcode === row.barcode && pr.quantity === row.quantity;
      });
      this.jobItemData.splice(foundIndex, 1);
      console.log(this.jobItemData, this.tableData);
    },
    open: function open(index, row) {
      var _this3 = this;

      this.$confirm("This will permanently delete the item. Continue?", "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
        center: true
      }).then(function () {
        _this3.handleDelete(index, row);
      }).catch(function () {
        _this3.$message({
          type: "info",
          message: "Delete canceled"
        });
      });
    }
  }
});

/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(15);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "posprinter",
  props: [],
  data: function data() {
    return {
      job: "",
      store: "",
      name: ''
    };
  },
  created: function created() {},
  mounted: function mounted() {
    var _this = this;

    this.$root.$on("jobPrint", function (data) {
      console.log("data", data);
      _this.job = data.job;
      _this.store = data.store;
      _this.name = data.name;
      _this.print();
    });
  },

  methods: {
    print: function print(item) {
      setTimeout(function () {
        var mywindow = window.open("", "PRINT", "fullscreen=yes");

        mywindow.document.write("<html><head><title>" + document.title + "</title>");
        mywindow.document.write("<link rel=\"stylesheet\" href=\"../../../../static/pos80.css\" type=\"text/css\" />");

        mywindow.document.write("</head><body >");
        mywindow.document.write(document.getElementById('jobPrint').innerHTML);
        mywindow.document.write("</body></html>");

        mywindow.document.close(); // necessary for IE >= 10
        mywindow.focus(); // necessary for IE >= 10*/

        mywindow.print();
        return true;
      }, 200);

      // if (!this.showPrintPopup) {
      //   mywindow.close();
      // }
    }
  }
});

/***/ }),
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BackToTop',
  props: {
    text: {
      type: String,
      default: 'Voltar ao topo'
    },
    visibleoffset: {
      type: [String, Number],
      default: 600
    },
    visibleoffsetbottom: {
      type: [String, Number],
      default: 0
    },
    right: {
      type: String,
      default: '30px'
    },
    bottom: {
      type: String,
      default: '40px'
    },
    scrollFn: {
      type: Function,
      default: function _default(eventObject) {}
    }
  },
  data: function data() {
    return {
      visible: false
    };
  },
  mounted: function mounted() {
    window.smoothscroll = function () {
      var currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
      if (currentScroll > 0) {
        window.requestAnimationFrame(window.smoothscroll);
        window.scrollTo(0, Math.floor(currentScroll - currentScroll / 5));
      }
    };
    window.addEventListener('scroll', this.catchScroll);
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.catchScroll);
  },

  methods: {
    /**
     * Catch window scroll event 
     * @return {void}
     */
    catchScroll: function catchScroll() {
      var pastTopOffset = window.pageYOffset > parseInt(this.visibleoffset);
      var pastBottomOffset = window.innerHeight + window.pageYOffset >= document.body.offsetHeight - parseInt(this.visibleoffsetbottom);
      this.visible = parseInt(this.visibleoffsetbottom) > 0 ? pastTopOffset && !pastBottomOffset : pastTopOffset;
      this.scrollFn(this);
    },

    /**
     * The function who make the magics
     * @return {void}
     */
    backToTop: function backToTop() {
      window.smoothscroll();
      this.$emit('scrolled');
    }
  }
});

/***/ }),
/* 491 */,
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(161);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14f36d08_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(509);
function injectStyle (ssrContext) {
  __webpack_require__(493)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-14f36d08"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14f36d08_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 493 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    //    apiKey: "AIzaSyByuM-kbhj57L0U4aRqe393xEEnlPi__RM",
    //     authDomain: "eshops.lk",
    //     databaseURL: "https://eshops-app.firebaseio.com",
    //     projectId: "eshops-app",
    //     storageBucket: "eshops-app.appspot.com",
    //     messagingSenderId: "789798668379"
    apiKey: "AIzaSyCuuV3HOuI_73rZiieYlLRIWOnO0y0FHyQ",
    authDomain: "eshops.lk",
    databaseURL: "https://eshopsapp.firebaseio.com",
    projectId: "eshopsapp",
    storageBucket: "eshopsapp.appspot.com",
    messagingSenderId: "591783300047",
    appId: "1:591783300047:web:8ff6f52aeb8ecc5b2220ba",
    measurementId: "G-ET8GNPSWL6"
});

/***/ }),
/* 508 */,
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{attrs:{"id":"app"}},[_c('main',[_c('router-view'),_vm._v(" "),_c('back-to-top',{attrs:{"bottom":"90px","right":"25px"}},[_c('button',{staticClass:"btn btn-info btn-to-top",attrs:{"type":"button"}},[_c('i',{staticClass:"fa fa-chevron-up"})])])],1)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 510 */,
/* 511 */,
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Manage_vue__ = __webpack_require__(175);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_490d55e2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Manage_vue__ = __webpack_require__(514);
function injectStyle (ssrContext) {
  __webpack_require__(513)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-490d55e2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Manage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_490d55e2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Manage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 513 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background-color":"rgb(246, 247, 248)","min-height":"100vh","padding-bottom":"25px"}},[(_vm.loading)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Updating")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.loading1)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Loading")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.loading2)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Deleting")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.changed)?_c('div',[_c('b-container',{staticClass:"col-lg-10 pt-5"},[_c('h3',{staticClass:"text-info text-center pt-4 my-4"},[_vm._v("Customers")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.getStat()}}},[_vm._v("Stat")]),_vm._v(" "),_c('el-button',{staticClass:"mt-3 d-block mx-auto",attrs:{"type":"primary","size":"small"},on:{"click":function($event){_vm.dialogFormVisible = true}}},[_vm._v("Update Stat")]),_vm._v(" "),_c('el-dialog',{attrs:{"title":"Update","visible":_vm.dialogFormVisible,"width":_vm.width},on:{"update:visible":function($event){_vm.dialogFormVisible=$event}}},[_c('p',[_vm._v("Enter PidNo")]),_vm._v(" "),_c('el-input-number',{attrs:{"placeholder":"Enter PidNo","max":1000000000},model:{value:(_vm.pidNO),callback:function ($$v) {_vm.pidNO=$$v},expression:"pidNO"}}),_vm._v(" "),_c('p',[_vm._v("Enter CusNo")]),_vm._v(" "),_c('el-input-number',{attrs:{"placeholder":"Enter CusNo","max":1000000000},model:{value:(_vm.cusNO),callback:function ($$v) {_vm.cusNO=$$v},expression:"cusNO"}}),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.dialogFormVisible = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.upStat()}}},[_vm._v("Update")])],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"my-1",attrs:{"sm":"4"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":""}},[_c('b-input-group',[_c('b-form-input',{attrs:{"placeholder":"Search"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),_c('b-input-group-append',[_c('b-btn',{attrs:{"disabled":!_vm.filter},on:{"click":function($event){_vm.filter = ''}}},[_vm._v("Clear")])],1)],1)],1)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"sm":"5"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":""}},[_c('b-input-group',[_c('b-form-select',{attrs:{"options":_vm.sortOptions},model:{value:(_vm.sortBy),callback:function ($$v) {_vm.sortBy=$$v},expression:"sortBy"}},[_c('option',{attrs:{"slot":"first"},domProps:{"value":null},slot:"first"},[_vm._v("Sort By")])]),_vm._v(" "),_c('b-form-select',{attrs:{"slot":"append","disabled":!_vm.sortBy},slot:"append",model:{value:(_vm.sortDesc),callback:function ($$v) {_vm.sortDesc=$$v},expression:"sortDesc"}},[_c('option',{domProps:{"value":false}},[_vm._v("Asc")]),_vm._v(" "),_c('option',{domProps:{"value":true}},[_vm._v("Desc")])])],1)],1)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"sm":"3"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"horizontal":""}},[_c('b-form-select',{model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}},[_c('option',{attrs:{"disabled":""}},[_vm._v("per page")]),_vm._v(" "),_c('option',{domProps:{"value":10}},[_vm._v("10")]),_vm._v(" "),_c('option',{domProps:{"value":25}},[_vm._v("25")]),_vm._v(" "),_c('option',{domProps:{"value":50}},[_vm._v("50")]),_vm._v(" "),_c('option',{domProps:{"value":100}},[_vm._v("100")]),_vm._v(" "),_c('option',{domProps:{"value":300}},[_vm._v("300")]),_vm._v(" "),_c('option',{domProps:{"value":500}},[_vm._v("500")]),_vm._v(" "),_c('option',{domProps:{"value":1000}},[_vm._v("1000")])])],1)],1)],1),_vm._v(" "),_c('b-table',{staticClass:"mt-4",attrs:{"show-empty":"","stacked":"sm","items":_vm.items,"fields":_vm.fields,"hover":true,"head-variant":"dark","current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter,"empty-text":_vm.emptyText,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event},"filtered":_vm.onFiltered},scopedSlots:_vm._u([{key:"index",fn:function(data){return [_vm._v("\n          "+_vm._s(data.index + 1)+"\n        ")]}},{key:"id",fn:function(row){return [_c('div',[_vm._v(_vm._s(row.value))])]}},{key:"products",fn:function(row){return [_c('div',[_vm._v(_vm._s(_vm.prdstat[row.item.owner]))])]}},{key:"cell(actions)",fn:function(row){return [_c('div',{staticClass:"btn-group",attrs:{"role":"group","aria-label":"Basic example"}},[_c('a',{staticClass:"btn btn-sm btn-primary text-white",attrs:{"size":"sm"},on:{"click":function($event){$event.stopPropagation();row.toggleDetails($event)}}},[_vm._v("\n              View\n            ")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.getprd(row.item.id, row.item.owner, row.item)}}},[_vm._v("#prd")]),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-primary text-white",attrs:{"size":"sm","tabindex":"blank"}},[_c('router-link',{attrs:{"to":{
                  name: 'storehome',
                  params: { storename: row.item.owner },
                }}},[_c('span',{staticClass:"text-white"},[_vm._v("Shop")])])],1),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-success text-white",attrs:{"href":("tel:" + (row.item.telephone)),"size":"sm"}},[_vm._v("\n              Call\n            ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-info text-white",attrs:{"href":("sms:" + (row.item.telephone)),"size":"sm"}},[_vm._v("\n              SMS\n            ")])],1)]}},{key:"row-details",fn:function(row){return [_c('div',{staticClass:"container"},[_c('div',{staticClass:"col-sm-12 col-md-6 m-auto"},[_c('p',[_vm._v("Owner "+_vm._s(row.item.owner))]),_vm._v(" "),_c('h4',{staticClass:"m-auto text-info text-center pt-4 pb-4"},[_vm._v("\n                Enter Project Id\n              ")]),_vm._v(" "),_c('el-input',{attrs:{"requried":"","placeholder":"Project Id"},model:{value:(_vm.inputObj),callback:function ($$v) {_vm.inputObj=$$v},expression:"inputObj"}}),_vm._v(" "),_c('el-button',{staticClass:"mt-3",attrs:{"type":"primary"},on:{"click":function($event){_vm.upConfig(row.item.id, row.item.owner, row.item)}}},[_vm._v("Update")]),_vm._v(" "),_c('p',[_vm._v("Rank")]),_vm._v(" "),_c('el-input-number',{attrs:{"precision":2,"step":0.1,"placeholder":"Rank","max":100},model:{value:(row.item.rank),callback:function ($$v) {_vm.$set(row.item, "rank", $$v)},expression:"row.item.rank"}}),_vm._v(" "),_c('p',[_vm._v("Search")]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":"Search"},model:{value:(row.item.search),callback:function ($$v) {_vm.$set(row.item, "search", $$v)},expression:"row.item.search"}}),_vm._v(" "),_c('el-button',{staticClass:"mt-3",attrs:{"type":"warning"},on:{"click":function($event){_vm.upShop(row.item.id, row.item)}}},[_vm._v("Update Shop")])],1)])]}}])}),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"md":"6"}},[_c('b-pagination',{staticClass:"my-0",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__ = __webpack_require__(176);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e072885_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__ = __webpack_require__(517);
function injectStyle (ssrContext) {
  __webpack_require__(516)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3e072885"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e072885_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 516 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-modal',{staticClass:"text-center text-info",attrs:{"centered":"","ok-only":"","centered":""},model:{value:(_vm.modalShow),callback:function ($$v) {_vm.modalShow=$$v},expression:"modalShow"}},[_vm._v("\n      Please Select Category and City\n    ")]),_vm._v(" "),_c('b-modal',{staticClass:"text-center text-info",attrs:{"ok-only":"","centered":""},model:{value:(_vm.modalShow0),callback:function ($$v) {_vm.modalShow0=$$v},expression:"modalShow0"}},[_vm._v("\n      You are not logged in as a user or your email is not verified!\n    ")]),_vm._v(" "),_c('b-modal',{staticClass:"text-center text-info",attrs:{"ok-only":"","centered":""},model:{value:(_vm.modalShow1),callback:function ($$v) {_vm.modalShow1=$$v},expression:"modalShow1"}},[_vm._v("\n      You can't add more shops to My SHOPiN!\n    ")]),_vm._v(" "),_c('b-modal',{staticClass:"text-center text-info",attrs:{"ok-only":"","centered":""},model:{value:(_vm.modalShow2),callback:function ($$v) {_vm.modalShow2=$$v},expression:"modalShow2"}},[_vm._v("\n      Shop is added to My SHOPiN.\n    ")]),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"loading"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.loading1 == false)?_c('div',{staticClass:"anim",attrs:{"id":"admin-preloader"}},[_vm._m(1)]):_vm._e(),_vm._v(" "),(_vm.fetch)?_c('div',[_c('section',[_c('nav',{staticClass:"navbar navbar-expand-lg navbar-dark bg-dark m-nav"},[_c('router-link',{staticClass:"navbar-brand",attrs:{"to":"/"}},[_c('img',{attrs:{"src":__webpack_require__(65),"alt":"eshops-logo"}})]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse",attrs:{"id":"navbarSupportedContent"}},[_c('ul',{staticClass:"navbar-nav mr-auto"},[_c('li',{staticClass:"nav-item mt-2"},[_c('router-link',{staticClass:"m-link nav-link text-white",attrs:{"to":{ name: 'home' }}},[_vm._v("Home")])],1),_vm._v(" "),_c('li',{staticClass:"nav-item"},[(_vm.admin)?_c('router-link',{staticClass:"m-link nav-link text-white",attrs:{"to":{ name: 'admin' }}},[_vm._v("Admin")]):_vm._e()],1),_vm._v(" "),_c('li',{staticClass:"nav-item"},[(_vm.pageadmin)?_c('router-link',{staticClass:"m-link nav-link text-white",attrs:{"to":{ name: 'admin-services' }}},[_vm._v("Admin")]):_vm._e()],1),_vm._v(" "),_c('li',{staticClass:"nav-item"},[(_vm.visitor)?_c('router-link',{staticClass:"m-link nav-link text-white",attrs:{"to":{ name: 'signin' }}},[_vm._v("Sign in")]):_vm._e()],1),_vm._v(" "),_c('li',{staticClass:"nav-item"},[(_vm.visitor)?_c('router-link',{staticClass:"m-link nav-link text-white",attrs:{"to":{ name: 'usersignup' }}},[_vm._v("Sign up")]):_vm._e()],1),_vm._v(" "),_c('li',{staticClass:"nav-item"},[(_vm.user)?_c('router-link',{staticClass:"m-link nav-link text-white",attrs:{"to":{ name: 'myaccount' }}},[_vm._v("My Account")]):_vm._e()],1),_vm._v(" "),_c('li',{staticClass:"nav-item"},[(_vm.user || _vm.admin || _vm.pageadmin)?_c('a',{staticClass:"m-link nav-link text-white",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.logout()}}},[_vm._v("Sign out")]):_vm._e()])])])],1),_vm._v(" "),_c('nav',{staticClass:"navbar navbar-dark bg-dark d-nav"},[_c('router-link',{staticClass:"navbar-brand",attrs:{"to":"/"}},[_c('img',{attrs:{"src":__webpack_require__(65),"alt":"eshops-logo"}})]),_vm._v(" "),_c('div',[_c('router-link',{staticClass:"text-white mr-5",attrs:{"to":{ name: 'home' }}},[_vm._v("\n              Home\n            ")]),_vm._v(" "),(_vm.admin)?_c('router-link',{staticClass:"m-link text-white mr-5",attrs:{"to":{ name: 'admin' }}},[_vm._v("Admin")]):_vm._e(),_vm._v(" "),(_vm.pageadmin)?_c('router-link',{staticClass:"m-link text-white mr-5",attrs:{"to":{ name: 'admin-services' }}},[_vm._v("Admin")]):_vm._e(),_vm._v(" "),(_vm.visitor)?_c('router-link',{staticClass:"m-link text-white mr-5",attrs:{"to":{ name: 'signin' }}},[_vm._v("Sign in")]):_vm._e(),_vm._v(" "),(_vm.visitor)?_c('router-link',{staticClass:"m-link text-white mr-5",attrs:{"to":{ name: 'usersignup' }}},[_vm._v("Sign up")]):_vm._e(),_vm._v(" "),(_vm.user)?_c('router-link',{staticClass:"m-link text-white mr-5",attrs:{"to":{ name: 'myaccount' }}},[_vm._v("My Account")]):_vm._e(),_vm._v(" "),(_vm.user || _vm.admin || _vm.pageadmin)?_c('a',{staticClass:"text-white mr-5",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.logout()}}},[_vm._v("Sign out")]):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticClass:"outer-menu d-nav"},[_c('input',{staticClass:"checkbox-toggle",attrs:{"type":"checkbox"}}),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"menu"},[_c('div',[_c('div',[_c('ul',[_c('li',[_c('router-link',{staticClass:"text-white",attrs:{"to":{ name: 'home' }}},[_vm._v("\n                      Home\n                    ")])],1),_vm._v(" "),_c('li',[(_vm.admin)?_c('router-link',{staticClass:"text-white",attrs:{"to":{ name: 'admin' }}},[_vm._v("\n                      Admin")]):_vm._e()],1),_vm._v(" "),_c('li',[(_vm.pageadmin)?_c('router-link',{staticClass:"text-white",attrs:{"to":{ name: 'admin-services' }}},[_vm._v("\n                      Admin")]):_vm._e()],1),_vm._v(" "),_c('li',[(_vm.visitor)?_c('router-link',{staticClass:"text-white",attrs:{"to":{ name: 'signin' }}},[_vm._v("\n                      Sign in")]):_vm._e()],1),_vm._v(" "),_c('li',[(_vm.visitor)?_c('router-link',{staticClass:"text-white",attrs:{"to":{ name: 'usersignup' }}},[_vm._v("\n                      Sign up")]):_vm._e()],1),_vm._v(" "),_c('li',[(_vm.user)?_c('router-link',{staticClass:"text-white",attrs:{"to":{ name: 'myaccount' }}},[_vm._v("\n                      My Account")]):_vm._e()],1),_vm._v(" "),_c('li',[(_vm.user || _vm.admin || _vm.pageadmin)?_c('a',{staticClass:"text-white",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.logout()}}},[_vm._v("\n                      Sign out")]):_vm._e()])])])])])])]),_vm._v(" "),_c('section',{staticClass:"section-sm",staticStyle:{"padding-top":"0px"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"search-result bg-gray text-center"},[(
                    this.$route.query.loc != undefined &&
                    this.$route.query.cat != undefined
                  )?_c('h2',{staticClass:"mb-0 m-size text-info"},[_vm._v("\n                  Results for \""+_vm._s(this.$route.query.cat)+"\" Shops in\n                  "+_vm._s(this.$route.query.loc)+"\n                ")]):_vm._e(),_vm._v(" "),(
                    this.$route.query.loc == undefined &&
                    this.$route.query.cat == undefined &&
                    this.$route.fullPath == '/search'
                  )?_c('h2',{staticClass:"text-danger mb-0 m-size"},[_vm._v("\n                  Please Select the Category & City\n                ")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"category-search-filter"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 form-row m-auto"},[_c('el-form',{staticClass:"m-auto el-form",attrs:{"inline":true,"status-icon":"","label-width":"120px","label-position":_vm.labelPosition,"size":"medium"}},[_c('el-cascader',{staticClass:"form-item form-item2",attrs:{"clearable":"","placeholder":"Store category","size":"medium","options":_vm.categories,"show-all-levels":false},on:{"change":_vm.selectCat},model:{value:(_vm.cat),callback:function ($$v) {_vm.cat=$$v},expression:"cat"}}),_vm._v(" "),_c('el-cascader',{staticClass:"form-item form-item2",attrs:{"clearable":"","placeholder":"City","size":"medium","options":_vm.cities,"show-all-levels":false},on:{"change":_vm.handleChange},model:{value:(_vm.city),callback:function ($$v) {_vm.city=$$v},expression:"city"}}),_vm._v(" "),_c('el-form-item',{staticClass:"form-item form-item1"},[_c('el-button',{staticClass:"form-item form-item3",attrs:{"type":"primary"},on:{"click":function($event){_vm.showme()}}},[_vm._v("Search")])],1)],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"product-grid-list"},[_c('div',{staticClass:"row mt-30 justify-content-around"},[(_vm.noresults)?_c('div',{staticClass:"mt-3 mb-2 text-center text-danger h4"},[_vm._v("\n                    No "+_vm._s(this.$route.query.cat)+" Shops in\n                    "+_vm._s(this.$route.query.loc)+"\n                  ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.shops),function(shop,i){return [_c('div',{key:shop.id,staticClass:"col-12 col-sm-6 col-md-6 col-lg-4"},[_c('div',{staticClass:"product-item bg-light"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"block2-pic hov-img0"},[(
                                shop.isHosted != true && shop.isCloned != true
                              )?_c('router-link',{attrs:{"to":{
                                name: 'storehome',
                                params: { storename: shop.owner },
                              }}},[_c('img',{attrs:{"src":shop.homeimg,"alt":"","width":"100%","height":"200px"},on:{"click":function($event){_vm.userVisits(i)}}})]):_vm._e(),_vm._v(" "),(shop.isCloned == true)?_c('router-link',{attrs:{"to":{
                                name: 'storehome',
                                params: { storename: shop.realOwner },
                              }}},[_c('img',{attrs:{"src":shop.homeimg,"alt":""},on:{"click":function($event){_vm.userVisits(i)}}})]):_vm._e(),_vm._v(" "),(shop.isHosted == true)?_c('a',{attrs:{"target":"blank","href":shop.domain}},[_c('img',{attrs:{"src":shop.homeimg,"alt":""},on:{"click":function($event){_vm.userVisits(i)}}})]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"card-body"},[(!shop.isfavshop)?_c('span',{staticClass:"float-right mr-3 tooltip100",attrs:{"data-tooltip":"Add to My SHOPiN"}},[_c('i',{staticClass:"fa fa-heart-o",staticStyle:{"cursor":"pointer","font-size":"22px"},on:{"click":function($event){_vm.addToFavourite(shop)}}})]):_vm._e(),_vm._v(" "),(shop.isfavshop)?_c('span',{staticClass:"float-right mr-3 tooltip100",attrs:{"data-tooltip":"Added to My SHOPiN"}},[_c('i',{staticClass:"fa fa-heart-o",staticStyle:{"cursor":"default","font-size":"22px","color":"red"}})]):_vm._e(),_vm._v(" "),(
                                shop.isHosted != true && shop.isCloned != true
                              )?_c('span',{staticClass:"card-title",on:{"click":function($event){_vm.userVisits(i)}}},[_c('router-link',{staticClass:"text-primary",attrs:{"to":{
                                  name: 'storehome',
                                  params: { storename: shop.owner },
                                }}},[_vm._v(_vm._s(shop.name))])],1):_vm._e(),_vm._v(" "),(shop.isCloned == true)?_c('span',{staticClass:"card-title",on:{"click":function($event){_vm.userVisits(i)}}},[_c('router-link',{staticClass:"text-primary",attrs:{"to":{
                                  name: 'storehome',
                                  params: { storename: shop.realOwner },
                                }}},[_vm._v(_vm._s(shop.name))])],1):_vm._e(),_vm._v(" "),(shop.isHosted == true)?_c('span',{staticClass:"card-title",on:{"click":function($event){_vm.userVisits(i)}}},[_c('a',{staticClass:"text-primary",attrs:{"href":shop.domain,"target":"blank"}},[_vm._v(_vm._s(shop.name))])]):_vm._e(),_vm._v(" "),(shop.shoptype != '')?_c('ul',{staticClass:"list-inline product-meta mb-1"},[_c('li',{staticClass:"list-inline-item"},[_c('a',{},[_c('i',{staticClass:"fa fa-tag",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(shop.shoptype))])])]):_vm._e(),_vm._v(" "),_c('ul',{staticClass:"list-inline product-meta mb-1"},[_c('li',{staticClass:"list-inline-item"},[_c('a',[_c('i',{staticClass:"fa fa-map-marker",attrs:{"aria-hidden":"true"}}),_vm._v("City : "+_vm._s(shop.location))])])]),_vm._v(" "),(shop.details.tel1)?_c('ul',{staticClass:"list-inline product-meta mb-1"},[_c('li',{staticClass:"list-inline-item"},[_c('a',{attrs:{"href":("tel:" + (shop.details.tel1))}},[_c('i',{staticClass:"fa fa-phone-square",attrs:{"aria-hidden":"true"}}),_vm._v("+94 "+_vm._s(shop.details.tel1))])])]):_vm._e(),_vm._v(" "),(!shop.details.tel1)?_c('ul',{staticClass:"list-inline product-meta mb-1"},[_c('li',{staticClass:"list-inline-item"},[_c('a',{attrs:{"href":("tel:" + (shop.regtel))}},[_c('i',{staticClass:"fa fa-phone-square",attrs:{"aria-hidden":"true"}}),_vm._v("+94 "+_vm._s(shop.regtel))])])]):_vm._e(),_vm._v(" "),(shop.details.etime && shop.details.stime)?_c('ul',{staticClass:"list-inline product-meta mb-1"},[_c('li',{staticClass:"list-inline-item mr-2"},[_c('a',{},[_c('i',{staticClass:"fa fa-clock-o",attrs:{"aria-hidden":"true"}}),_vm._v("Open - Close : "+_vm._s(shop.details.stime)+"AM -\n                                  "+_vm._s(shop.details.etime)+"PM\n                                ")])])]):_vm._e(),_vm._v(" "),(shop.details.address)?_c('ul',{staticClass:"list-inline product-meta mb-2"},[_c('li',{staticClass:"list-inline-item"},[_c('a',[_c('i',{staticClass:"fa fa-address-card",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(shop.details.address))])])]):_vm._e(),_vm._v(" "),(shop.details.lat && shop.details.lng)?_c('a',{attrs:{"href":("https://maps.google.com/?q=" + (shop.details.lat) + ", " + (shop.details.lng)),"target":"_blank","rel":"noopener noreferrer"}},[_c('el-button',{staticClass:"my-2",attrs:{"size":"mini","type":"primary"}},[_vm._v("Get Direction")])],1):_vm._e()])])])])]})],2)])])])])]),_vm._v(" "),_c('div',{staticClass:"flex-c-m flex-w w-full pb-5"},[(_vm.moreshops != undefined)?_c('button',{staticClass:"flex-c-m stext-101 cl5 size-103 bg2 bor1",on:{"click":function($event){_vm.moreItems()}}},[_vm._v("\n          More Shops\n        ")]):_vm._e()]),_vm._v(" "),_c('footer',{staticClass:"footer section section-sm"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-around"},[_c('div',{staticClass:"col-sm-6 col-lg-3"},[_c('div',{staticClass:"block block-link"},[_c('h4',[_vm._v("Site Pages")]),_vm._v(" "),_c('ul',[_c('li',{staticClass:"px-0"},[_c('router-link',{attrs:{"to":{ name: 'home' }}},[_vm._v("Home")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'about' }}},[_vm._v("About Us")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'termsofuse' }}},[_vm._v("Terms of Use")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'privacypolicy' }}},[_vm._v("Privacy Policy")])],1)])])]),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5)])])]),_vm._v(" "),_c('footer',{staticClass:"footer-bottom"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 mx-auto mt-5"},[_c('div',{staticClass:"copyright text-center"},[_c('img',{attrs:{"src":__webpack_require__(25),"alt":"eshops-logo"}}),_vm._v(" "),_c('p',{staticClass:"m-f-text mt-2"},[_vm._v("\n                  © "+_vm._s(new Date().getFullYear())+" eshops.lk | All Rights\n                  Reserved\n                ")])])])])])])]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader"},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner"},[_c('div',{staticClass:"dot1"}),_vm._v(" "),_c('div',{staticClass:"dot2"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"navbar-toggler float-right",attrs:{"type":"button","data-toggle":"collapse","data-target":"#navbarSupportedContent","aria-controls":"navbarSupportedContent","aria-expanded":"false","aria-label":"Toggle navigation"}},[_c('span',{staticClass:"navbar-toggler-icon"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hamburger"},[_c('div')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-6 col-lg-4"},[_c('div',{staticClass:"block block-info"},[_c('h4',[_vm._v("Contact Us")]),_vm._v(" "),_c('ul',[_c('li',[_c('a',[_c('i',{staticClass:"fa fa-phone mr-2",attrs:{"aria-hidden":"true"}}),_vm._v("0719\n                      500 600")])]),_vm._v(" "),_c('li',[_c('a',[_c('i',{staticClass:"fa fa-envelope mr-2",attrs:{"aria-hidden":"true"}}),_vm._v("info@eshops.lk")])])]),_vm._v(" "),_c('ul',{staticClass:"social-media-icons mb-2 d-inline"},[_c('li',{},[_c('a',{staticClass:"px-0 ml-0 mr-2",attrs:{"href":"https://www.facebook.com/Eshopslk-2212428785713128/"}},[_c('i',{staticClass:"fa fa-facebook-official f-sm-link",staticStyle:{"font-size":"34px","color":"#3b5998","background-color":"#fff","width":"30px","height":"30px","border-radius":"4px","text-align":"center","vertical-align":"middle"}})])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"px-0 mx-2",attrs:{"href":"https://www.instagram.com/eshops.lk/"}},[_c('i',{staticClass:"fa fa-instagram f-sm-link",staticStyle:{"font-size":"30px","color":"#fff","background":"radial-gradient(","width":"32px","height":"32px","border-radius":"4px","text-align":"center","vertical-align":"middle"}})])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"px-0 mx-2",attrs:{"href":"https://www.youtube.com/channel/UCJhY3IfJD3T2bA5PJ3SrMZw"}},[_c('i',{staticClass:"fa fa-youtube-square f-sm-link",staticStyle:{"font-size":"35px","color":"#ff0000","background-color":"#fff","width":"30px","height":"30px","border-radius":"6px","text-align":"center","vertical-align":"middle"}})])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm col-md-8 col-lg-5"},[_c('div',{staticClass:"block-2 app-promotion"},[_c('a',[_c('img',{attrs:{"src":__webpack_require__(38),"alt":"mobile-icon"}})]),_vm._v(" "),_c('p',{staticClass:"m-f-text"},[_vm._v("\n                  Tap the Add to Home Screen Tab in Chrome Browser on Android or\n                  Safari Browser on IOS to Get the Splendid\n                  "),_c('span',{staticStyle:{"color":"#fd6a02","font-size":"20px"}},[_vm._v("Mobile App")]),_vm._v("\n                  Directly\n                ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StartStore_vue__ = __webpack_require__(177);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9d18affe_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StartStore_vue__ = __webpack_require__(520);
function injectStyle (ssrContext) {
  __webpack_require__(519)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9d18affe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StartStore_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9d18affe_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StartStore_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 519 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-modal',{staticClass:"text-center text-info",attrs:{"centered":"","ok-only":""},model:{value:(_vm.modalShow),callback:function ($$v) {_vm.modalShow=$$v},expression:"modalShow"}},[_vm._v("\n      Please Select Category and City\n    ")]),_vm._v(" "),(_vm.deferredPrompt)?_c('div',{staticClass:"alert alert-info alert-dismissible fade show",staticStyle:{"margin-bottom":"0px","background-color":"#fa9b47","border":"none","border-radius":"0px","color":"#fff"},attrs:{"role":"alert"}},[_vm._v("\n      Get the App. It's less than 1 MB\n      "),_c('a',{staticClass:"alert-link",staticStyle:{"cursor":"pointer","color":"#031c35"},on:{"click":function($event){_vm.promptInstall()}}},[_vm._v("INSTALL NOW")]),_vm._v(" "),_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"loading"},[_vm._m(1)]):_vm._e(),_vm._v(" "),(_vm.fetched)?_c('div',{staticClass:"infobox"},[_c('div',{staticClass:"cont",staticStyle:{"background-color":"#fff"}},[_c('div',{staticClass:"container d-flex align-items-center justify-content-center fx"}),_vm._v(" "),_c('section',{staticClass:"pb_cover_v3 overflow-hidden text-left pb_slant-light",staticStyle:{"background-image":"url(../../../../static/img/27.jpg)","background-size":"cover","background-position":"35% 60%","background-attachment":"fixed","background-repeat":"no-repeat","height":"100vh"},attrs:{"id":"section-home"}},[_c('div',{staticStyle:{"background-color":"#3232322e","height":"100%"}},[_c('nav',{staticClass:"navbar navbar-expand-lg navbar-dark bg-dark m-nav",staticStyle:{"z-index":"10"}},[_c('router-link',{staticClass:"navbar-brand",attrs:{"to":"/"}},[_c('img',{attrs:{"src":__webpack_require__(13),"width":"50","height":"50","alt":"eshops-logo"}})]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse",attrs:{"id":"navbarSupportedContent"}},[_c('ul',{staticClass:"navbar-nav mr-auto"},[_c('li',{staticClass:"nav-item mt-2"},[_c('router-link',{staticClass:"m-link nav-link text-white",attrs:{"to":{ name: 'home' }}},[_vm._v("Home")])],1),_vm._v(" "),_c('li',{staticClass:"nav-item"},[(_vm.admin)?_c('router-link',{staticClass:"m-link nav-link text-white",attrs:{"to":{ name: 'admin' }}},[_vm._v("Admin")]):_vm._e()],1),_vm._v(" "),_c('li',{staticClass:"nav-item"},[(_vm.pageadmin)?_c('router-link',{staticClass:"m-link nav-link text-white",attrs:{"to":{ name: 'admin-services' }}},[_vm._v("Admin")]):_vm._e()],1),_vm._v(" "),_c('li',{staticClass:"nav-item"},[(_vm.visitor)?_c('router-link',{staticClass:"m-link nav-link text-white",attrs:{"to":{ name: 'signin' }}},[_vm._v("Sign in")]):_vm._e()],1),_vm._v(" "),_c('li',{staticClass:"nav-item"},[(_vm.visitor)?_c('router-link',{staticClass:"m-link nav-link text-white",attrs:{"to":{ name: 'usersignup' }}},[_vm._v("Sign up")]):_vm._e()],1),_vm._v(" "),_c('li',{staticClass:"nav-item"},[(_vm.user)?_c('router-link',{staticClass:"m-link nav-link text-white",attrs:{"to":{ name: 'myaccount' }}},[_vm._v("My Account")]):_vm._e()],1),_vm._v(" "),_c('li',{staticClass:"nav-item"},[(_vm.user || _vm.admin || _vm.pageadmin || _vm.editor)?_c('a',{staticClass:"m-link nav-link text-white",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.logout()}}},[_vm._v("Sign out")]):_vm._e()])])])],1),_vm._v(" "),_c('nav',{staticClass:"navbar navbar-dark bg-dark d-nav",staticStyle:{"background-color":"#444444b8 !important"}},[_c('router-link',{staticClass:"navbar-brand",attrs:{"to":"/"}},[_c('img',{attrs:{"src":__webpack_require__(13),"width":"50","height":"50","alt":"eshops-logo"}})]),_vm._v(" "),_c('div',[_c('router-link',{staticClass:"text-white mr-5",attrs:{"to":{ name: 'home' }}},[_vm._v("\n                  Home\n                ")]),_vm._v(" "),(_vm.admin)?_c('router-link',{staticClass:"m-link text-white mr-5",attrs:{"to":{ name: 'admin' }}},[_vm._v("Admin")]):_vm._e(),_vm._v(" "),(_vm.pageadmin)?_c('router-link',{staticClass:"m-link text-white mr-5",attrs:{"to":{ name: 'admin-services' }}},[_vm._v("Admin")]):_vm._e(),_vm._v(" "),(_vm.visitor)?_c('router-link',{staticClass:"m-link text-white mr-5",attrs:{"to":{ name: 'signin' }}},[_vm._v("Sign in")]):_vm._e(),_vm._v(" "),(_vm.visitor)?_c('router-link',{staticClass:"m-link text-white mr-5",attrs:{"to":{ name: 'usersignup' }}},[_vm._v("Sign up")]):_vm._e(),_vm._v(" "),(_vm.user)?_c('router-link',{staticClass:"m-link text-white mr-5",attrs:{"to":{ name: 'myaccount' }}},[_vm._v("My Account")]):_vm._e(),_vm._v(" "),(_vm.user || _vm.admin || _vm.pageadmin || _vm.editor)?_c('a',{staticClass:"text-white mr-5",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.logout()}}},[_vm._v("Sign out")]):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticClass:"container",staticStyle:{"padding-top":"10%","position":"absolute"}},[_c('div',{staticClass:"row",staticStyle:{"margin-top":"-80px"}},[_c('div',{staticClass:"col-sm-12 col-md-4 text-center ml-auto"},[_vm._m(3),_vm._v(" "),_c('el-form',{ref:"searchForm",staticClass:"el-form m-auto",attrs:{"inline":true,"model":_vm.searchForm,"status-icon":"","label-width":"120px","label-position":_vm.labelPosition,"size":"medium"}},[_c('div',{staticClass:"col-sm-12 text-center mx-auto",staticStyle:{"margin-top":"30px"}},[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:({
                          el: '#benefits',
                          duration: 900,
                          easing: 'linear',
                          force: true,
                        }),expression:"{\n                          el: '#benefits',\n                          duration: 900,\n                          easing: 'linear',\n                          force: true,\n                        }"}]},[_c('el-button',{staticClass:"text-white mb-3",staticStyle:{"text-decoration":"none","background-color":"#702ef1"},attrs:{"type":"warning"}},[_c('h5',[_vm._v("Explore Benefits")])])],1),_vm._v(" "),_c('a',{attrs:{"href":"tel:0719500600"}},[_c('el-button',{staticClass:"text-white",staticStyle:{"text-decoration":"none","background-color":"#0ea53c"},attrs:{"type":"success"}},[_c('h5',[_vm._v("0719 500 600")])])],1)])])],1)])])])])]),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('section',{attrs:{"id":""}},[_c('div',{staticClass:"container pb-5",staticStyle:{"background-color":"#f8f8f8","border-radius":"0px"}},[_c('h2',{staticClass:"display-5 pb-3 pl-3 text-center mquery-h d-block pt-5",staticStyle:{"color":"#787878"}},[_vm._v("\n            New Customers\n          ")]),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.topshops),function(p,i){return _c('div',{key:i,staticClass:"col-md-6 col-lg-4 col-xl-4 my-2"},[_c('el-card',{attrs:{"body-style":{ padding: '0px' }}},[(p.homeimg != '' && p.homeimg != undefined)?_c('div',{staticStyle:{"width":"100%","height":"200px","overflow":"hidden","display":"block","background-position":"50%","background-repeat":"no-repeat","background-size":"cover","cursor":"pointer"},style:({ backgroundImage: 'url(' + p.homeimg + ')' }),on:{"click":function($event){_vm.showDialog(p)}}}):_vm._e(),_vm._v(" "),(p.homeimg == '' || p.homeimg == undefined)?_c('div',{staticStyle:{"background-image":"url(../../../../static/images/ecommerce.jpg)","width":"100%","height":"200px","overflow":"hidden","display":"block","background-position":"50%","background-repeat":"no-repeat","background-size":"cover","cursor":"pointer"},on:{"click":function($event){_vm.showDialog(p)}}}):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"padding":"14px"}},[_c('span',{staticClass:"text-primary"},[_vm._v(" "+_vm._s(p.name))]),_vm._v(" "),_c('p',{staticClass:"my-1"},[_c('i',{staticClass:"fa fa-tag text-primary"}),_vm._v(" "+_vm._s(p.cat)+"\n                  ")]),_vm._v(" "),(p.loctype == 'shop' && p.shoptype != '')?_c('p',{staticClass:"my-1"},[_c('i',{staticClass:"fa fa-tag text-primary"}),_vm._v(" "+_vm._s(p.shoptype)+"\n                  ")]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"my-1"},[_c('i',{staticClass:"el-icon-location-outline text-primary"}),_vm._v("\n                    "+_vm._s(p.location)+"\n                  ")]),_vm._v(" "),(p.details.tel1)?_c('p',{staticClass:"my-1"},[_c('a',{attrs:{"href":("tel:" + (p.details.tel1))}},[_c('i',{staticClass:"el-icon-phone text-primary"}),_vm._v(" 0"+_vm._s(p.details.tel1))])]):_vm._e(),_vm._v(" "),(!p.details.tel1)?_c('p',{staticClass:"my-1"},[_c('a',{attrs:{"href":("tel:" + (p.regtel))}},[_c('i',{staticClass:"el-icon-phone text-primary"}),_vm._v(" 0"+_vm._s(p.regtel))])]):_vm._e()])])],1)}))])]),_vm._v(" "),_c('div',{staticClass:"container section-why",attrs:{"id":"section-why"}},[_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 d-flex mx-auto align-items-center"},[_c('div',{staticClass:"m-q-a-768"},[_c('h1',{staticClass:"\n                    text-white\n                    display-4\n                    pb-2\n                    pl-5\n                    mquery-h\n                    m-q-a-768-h m-q-850\n                  "},[_vm._v("\n                  It’s All About the Success of Your Business.\n                ")]),_vm._v(" "),_c('p',{staticClass:"mb-2 h4 pb-2 mquery-p pl-5 m-q-a-768-p",staticStyle:{"color":"#eee"}},[_vm._v("\n                  The straightforward and timely way to grow your business in\n                  the modern world is an online business. Contact us to grow\n                  your business now.\n                ")]),_vm._v(" "),_c('a',{attrs:{"href":"tel:0719500600"}},[_c('el-button',{staticClass:"text-white ml-5 mx-auto mb-3",staticStyle:{"text-decoration":"none","display":"block","margin":"0 auto"},attrs:{"type":"success"}},[_c('h5',[_vm._v("0719 500 600")])])],1),_vm._v(" "),_c('p',{staticClass:"mb-2 h4 pb-2 mquery-p pl-5 m-q-a-768-p",staticStyle:{"color":"#eee"}},[_vm._v("\n                  Need your own domain name? We can provide that too, Just call\n                  us now.\n                ")]),_vm._v(" "),_c('a',{attrs:{"href":"tel:0719500600"}},[_c('el-button',{staticClass:"text-white ml-5 mx-auto",staticStyle:{"text-decoration":"none","display":"block","margin":"0 auto"},attrs:{"type":"success"}},[_c('h5',[_vm._v("0719 500 600")])])],1)])])])]),_vm._v(" "),_c('div',{staticStyle:{"padding-bottom":"40px"}})])]):_vm._e(),_vm._v(" "),(_vm.fetched)?_c('div',[_c('footer',{staticClass:"footer section section-sm footer-search",staticStyle:{"padding-bottom":"0px"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-around"},[_c('div',{staticClass:"col-sm-6 col-lg-3"},[_c('div',{staticClass:"block block-link"},[_c('h4',[_vm._v("Site Pages")]),_vm._v(" "),_c('ul',[_c('li',{staticClass:"px-0"},[_c('router-link',{attrs:{"to":{ name: 'home' }}},[_vm._v("Home")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'about' }}},[_vm._v("About Us")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'termsofuse' }}},[_vm._v("Terms of Use")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'privacypolicy' }}},[_vm._v("Privacy Policy")])],1)])])]),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11)])])]),_vm._v(" "),_c('footer',{staticClass:"footer-bottom"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 mx-auto mt-5"},[_c('div',{staticClass:"copyright text-center"},[_c('img',{attrs:{"src":__webpack_require__(25),"alt":"eshops-logo"}}),_vm._v(" "),_c('p',{staticClass:"m-f-text mt-2"},[_vm._v("\n                  © "+_vm._s(new Date().getFullYear())+" eshops.lk | All Rights\n                  Reserved\n                ")])])])])])])]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"alert","aria-label":"Close"}},[_c('span',{staticStyle:{"color":"#fff"},attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader"},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"navbar-toggler float-right",attrs:{"type":"button","data-toggle":"collapse","data-target":"#navbarSupportedContent","aria-controls":"navbarSupportedContent","aria-expanded":"false","aria-label":"Toggle navigation"}},[_c('span',{staticClass:"navbar-toggler-icon"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-4",staticStyle:{"background":"#ffffff70","border-radius":"5px"}},[_c('h1',{staticClass:"displayh-4 text-dark ml-auto mb-5 pt-4",attrs:{"id":"typed"}},[_vm._v("\n                      It’s All About the Success of Your Business.\n                    ")]),_vm._v(" "),_c('h5',{staticClass:"text-dark mr-3 display-5 mb-4 pb-4",staticStyle:{"font-weight":"bold"}},[_vm._v("\n                      Explore benefits and contact us to grow your business.\n                    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"benefits"}},[_c('div',{staticClass:"timeline"},[_c('h2',{staticClass:"display-5 pb-3 pl-3 text-center mquery-h d-block pt-5",staticStyle:{"color":"#787878"}},[_vm._v("\n            Explore Features and Benefits\n          ")]),_vm._v(" "),_c('div',{staticClass:"\n              timeline__event\n              animated\n              fadeInUp\n              delay-3s\n              timeline__event--type1\n            "},[_c('div',{staticClass:"timeline__event__icon"},[_c('i',{staticClass:"el-icon-s-platform"})]),_vm._v(" "),_c('div',{staticClass:"timeline__event__date"},[_vm._v("POS System")]),_vm._v(" "),_c('div',{staticClass:"timeline__event__content"},[_c('div',{staticClass:"timeline__event__title"},[_vm._v("Benefits")]),_vm._v(" "),_c('div',{staticClass:"timeline__event__description"},[_c('ul',{staticClass:"benefits-list"},[_c('li',[_vm._v("Simple Invoicing")]),_vm._v(" "),_c('li',[_vm._v("Better Security & Service")]),_vm._v(" "),_c('li',[_vm._v("Improve Company Image")]),_vm._v(" "),_c('li',[_vm._v("Increased Efficiency & Saving Time")]),_vm._v(" "),_c('li',[_vm._v("Increased Revenues")])])])])]),_vm._v(" "),_c('div',{staticClass:"\n              timeline__event\n              animated\n              fadeInUp\n              delay-2s\n              timeline__event--type2\n            "},[_c('div',{staticClass:"timeline__event__icon"},[_c('i',{staticClass:"el-icon-s-data"})]),_vm._v(" "),_c('div',{staticClass:"timeline__event__date"},[_vm._v("Inventory Management")]),_vm._v(" "),_c('div',{staticClass:"timeline__event__content"},[_c('div',{staticClass:"timeline__event__title"},[_vm._v("Benefits")]),_vm._v(" "),_c('div',{staticClass:"timeline__event__description"},[_c('ul',{staticClass:"benefits-list"},[_c('li',[_vm._v("Prevent stock outs and overselling")]),_vm._v(" "),_c('li',[_vm._v("No More Manual Work")]),_vm._v(" "),_c('li',[_vm._v("Better Inventory Accuracy")]),_vm._v(" "),_c('li',[_vm._v("Increased Profits & Cost Saving")]),_vm._v(" "),_c('li',[_vm._v("More Productivity")])])])])]),_vm._v(" "),_c('div',{staticClass:"\n              timeline__event\n              animated\n              fadeInUp\n              delay-1s\n              timeline__event--type3\n            "},[_c('div',{staticClass:"timeline__event__icon"},[_c('i',{staticClass:"el-icon-shopping-cart-full"})]),_vm._v(" "),_c('div',{staticClass:"timeline__event__date"},[_vm._v("Online Store")]),_vm._v(" "),_c('div',{staticClass:"timeline__event__content"},[_c('div',{staticClass:"timeline__event__title"},[_vm._v("Benefits")]),_vm._v(" "),_c('div',{staticClass:"timeline__event__description"},[_c('ul',{staticClass:"benefits-list"},[_c('li',[_vm._v("You are open to the world")]),_vm._v(" "),_c('li',[_vm._v("New Customers")]),_vm._v(" "),_c('li',[_vm._v("New sales options")]),_vm._v(" "),_c('li',[_vm._v("Easy access to market")]),_vm._v(" "),_c('li',[_vm._v("Lower costs")])])])])]),_vm._v(" "),_c('div',{staticClass:"\n              timeline__event\n              animated\n              fadeInUp\n              delay-3s\n              timeline__event--type1\n            "},[_c('div',{staticClass:"timeline__event__icon"},[_c('i',{staticClass:"el-icon-data-analysis"})]),_vm._v(" "),_c('div',{staticClass:"timeline__event__date"},[_vm._v("Sales Analytics")]),_vm._v(" "),_c('div',{staticClass:"timeline__event__content"},[_c('div',{staticClass:"timeline__event__title"},[_vm._v("Benefits")]),_vm._v(" "),_c('div',{staticClass:"timeline__event__description"},[_c('ul',{staticClass:"benefits-list"},[_c('li',[_vm._v("Promotes Better Decision-making")]),_vm._v(" "),_c('li',[_vm._v("Keeps Your Business Updated")]),_vm._v(" "),_c('li',[_vm._v("Provides Better Insights Via Data Visualization")]),_vm._v(" "),_c('li',[_vm._v("Transparency Of Sales Data")]),_vm._v(" "),_c('li',[_vm._v("Better Accessibility & Boosts Efficiency")])])])])]),_vm._v(" "),_c('div',{staticClass:"\n              timeline__event\n              animated\n              fadeInUp\n              delay-2s\n              timeline__event--type2\n            "},[_c('div',{staticClass:"timeline__event__icon"},[_c('i',{staticClass:"el-icon-s-custom"})]),_vm._v(" "),_c('div',{staticClass:"timeline__event__date"},[_vm._v("CRM System")]),_vm._v(" "),_c('div',{staticClass:"timeline__event__content"},[_c('div',{staticClass:"timeline__event__title"},[_vm._v("Benefits")]),_vm._v(" "),_c('div',{staticClass:"timeline__event__description"},[_c('ul',{staticClass:"benefits-list"},[_c('li',[_vm._v("Maintain a centralized database of customers")]),_vm._v(" "),_c('li',[_vm._v("Better customer communication")]),_vm._v(" "),_c('li',[_vm._v("Better customer service")]),_vm._v(" "),_c('li',[_vm._v("Increased sales")]),_vm._v(" "),_c('li',[_vm._v("Improved customer retention")])])])])]),_vm._v(" "),_c('div',{staticClass:"\n              timeline__event\n              animated\n              fadeInUp\n              delay-1s\n              timeline__event--type3\n            "},[_c('div',{staticClass:"timeline__event__icon"},[_c('i',{staticClass:"el-icon-s-marketing"})]),_vm._v(" "),_c('div',{staticClass:"timeline__event__date"},[_vm._v("Loyalty Program")]),_vm._v(" "),_c('div',{staticClass:"timeline__event__content"},[_c('div',{staticClass:"timeline__event__title"},[_vm._v("Benefits")]),_vm._v(" "),_c('div',{staticClass:"timeline__event__description"},[_c('ul',{staticClass:"benefits-list"},[_c('li',[_vm._v("Improved Customer Engagement")]),_vm._v(" "),_c('li',[_vm._v("Improves Customer Experience")]),_vm._v(" "),_c('li',[_vm._v("Increased Customer Retention")]),_vm._v(" "),_c('li',[_vm._v("Increase in Sales and Revenue")]),_vm._v(" "),_c('li',[_vm._v("Increased Customer Lifetime Value")])])])])]),_vm._v(" "),_c('div',{staticClass:"\n              timeline__event\n              animated\n              fadeInUp\n              delay-3s\n              timeline__event--type1\n            "},[_c('div',{staticClass:"timeline__event__icon"},[_c('i',{staticClass:"el-icon-s-promotion"})]),_vm._v(" "),_c('div',{staticClass:"timeline__event__date"},[_vm._v("Referral Program")]),_vm._v(" "),_c('div',{staticClass:"timeline__event__content"},[_c('div',{staticClass:"timeline__event__title"},[_vm._v("Benefits")]),_vm._v(" "),_c('div',{staticClass:"timeline__event__description"},[_c('ul',{staticClass:"benefits-list"},[_c('li',[_vm._v("Word-of-mouth improves customer retention")]),_vm._v(" "),_c('li',[_vm._v("Referred customers are more valuable")]),_vm._v(" "),_c('li',[_vm._v("Increase brand awareness & reputation")]),_vm._v(" "),_c('li',[_vm._v("Customers trust referrals")]),_vm._v(" "),_c('li',[_vm._v("Reward current customers & Find new")])])])])]),_vm._v(" "),_c('div',{staticClass:"\n              timeline__event\n              animated\n              fadeInUp\n              delay-2s\n              timeline__event--type2\n            "},[_c('div',{staticClass:"timeline__event__icon"},[_c('i',{staticClass:"el-icon-user-solid"})]),_vm._v(" "),_c('div',{staticClass:"timeline__event__date"},[_vm._v("User Management")]),_vm._v(" "),_c('div',{staticClass:"timeline__event__content"},[_c('div',{staticClass:"timeline__event__title"},[_vm._v("Benefits")]),_vm._v(" "),_c('div',{staticClass:"timeline__event__description"},[_c('ul',{staticClass:"benefits-list"},[_c('li',[_vm._v("Improved security")]),_vm._v(" "),_c('li',[_vm._v("Information sharing")]),_vm._v(" "),_c('li',[_vm._v("Ease of use")]),_vm._v(" "),_c('li',[_vm._v("Productivity gains")]),_vm._v(" "),_c('li',[_vm._v("Improve employee productivity")])])])])]),_vm._v(" "),_c('div',{staticClass:"\n              timeline__event\n              animated\n              fadeInUp\n              delay-1s\n              timeline__event--type3\n            "},[_c('div',{staticClass:"timeline__event__icon"},[_c('i',{staticClass:"el-icon-price-tag"})]),_vm._v(" "),_c('div',{staticClass:"timeline__event__date"},[_vm._v("Barcodes")]),_vm._v(" "),_c('div',{staticClass:"timeline__event__content"},[_c('div',{staticClass:"timeline__event__title"},[_vm._v("Benefits")]),_vm._v(" "),_c('div',{staticClass:"timeline__event__description"},[_c('ul',{staticClass:"benefits-list"},[_c('li',[_vm._v("Barcodes are efficient")]),_vm._v(" "),_c('li',[_vm._v("Save time")]),_vm._v(" "),_c('li',[_vm._v("Reduce errors")]),_vm._v(" "),_c('li',[_vm._v("Inventory control improves")]),_vm._v(" "),_c('li',[_vm._v("Inexpensive to design and print")])])])])]),_vm._v(" "),_c('div',{staticClass:"\n              timeline__event\n              animated\n              fadeInUp\n              delay-3s\n              timeline__event--type1\n            "},[_c('div',{staticClass:"timeline__event__icon"},[_c('i',{staticClass:"el-icon-cloudy"})]),_vm._v(" "),_c('div',{staticClass:"timeline__event__date"},[_vm._v("Cloud Based System")]),_vm._v(" "),_c('div',{staticClass:"timeline__event__content"},[_c('div',{staticClass:"timeline__event__title"},[_vm._v("Benefits")]),_vm._v(" "),_c('div',{staticClass:"timeline__event__description"},[_c('ul',{staticClass:"benefits-list"},[_c('li',[_vm._v("Cost Savings & High speed")]),_vm._v(" "),_c('li',[_vm._v("24/7 Access to Data")]),_vm._v(" "),_c('li',[_vm._v("Automatic Software Updates")]),_vm._v(" "),_c('li',[_vm._v("Better Security")]),_vm._v(" "),_c('li',[_vm._v("Data Loss Prevention")])])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"py-5 mt-5",staticStyle:{"background-color":"#f8f8f8","border-radius":"5px"},attrs:{"id":"icon-boxes"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row mb-1"},[_c('div',{staticClass:"col-md-6 d-flex mx-auto align-items-center"},[_c('div',[_c('h2',{staticClass:"display-5 pb-2 pl-3 text-center mquery-h",staticStyle:{"color":"#787878"}},[_vm._v("\n                    Premium Customer Experience\n                  ")]),_vm._v(" "),_c('p',{staticClass:"mb-2 h5 pb-2 txt-g mquery-p text-center"},[_vm._v("\n                    Customers are the biggest asset of any business. Make them\n                    feel proud about your business, give them a better and\n                    comfortable shopping experience with eshops.lk\n                  ")])])])]),_vm._v(" "),_c('div',{staticClass:"row mb-4"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"bg-light text-center text-secondary"},[_c('div',{staticClass:"card-block py-4"},[_c('i',{staticClass:"fa fa-signal fa-3x mb-2",attrs:{"aria-hidden":"true"}},[_c('span',{staticStyle:{"margin-top":"-40px","margin-left":"-0px","font-weight":"900","display":"block"}},[_vm._v("\\")])]),_vm._v(" "),_c('h3',{staticClass:"mb-1"},[_vm._v("Offline Access")]),_vm._v(" "),_c('p',{staticClass:"text-left"},[_vm._v("\n                      Offline access is a critical feature for nowaday web\n                      applications. Eshops.lk uses the cutting edge technology\n                      to provide offline access to the service and to minimize\n                      the data usage of customers. After visiting your store for\n                      the first time, it takes only a second to come back again.\n                    ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"bg-light text-center text-secondary"},[_c('div',{staticClass:"card-block py-4"},[_c('i',{staticClass:"fa fa-clock-o fa-3x mb-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('h3',{staticClass:"mb-1"},[_vm._v("Real Time Updating")]),_vm._v(" "),_c('p',{staticClass:"text-left"},[_vm._v("\n                      Your contents will be updated automatically real-time\n                      without any page reloading. Even if the user is on the\n                      offline mode the contents will get updated automatically\n                      once the user turns the internet connection on.\n                    ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"bg-light text-center text-secondary"},[_c('div',{staticClass:"card-block py-4"},[_c('i',{staticClass:"fa fa-fighter-jet fa-3x mb-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('h3',{staticClass:"mb-1"},[_vm._v("Incredible Speed")]),_vm._v(" "),_c('p',{staticClass:"text-left"},[_vm._v("\n                      Speed is one of the most important metrics people use to\n                      assess the quality and web application performance of\n                      solutions today. Our technology provides an incredible\n                      speed to all your activities.\n                    ")])])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h1',{staticClass:"display-4 pb-2 pl-3 mquery-h text-center text-white"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('img',{staticClass:"\n                  img-fluid\n                  animated\n                  infinite\n                  pulse\n                  delay-3s\n                  slower\n                  m-q-a-i-768-2\n                ",attrs:{"src":__webpack_require__(521),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"col-md-6 d-flex align-items-center"},[_c('div',[_c('h2',{staticClass:"text-white display-4 pb-2 mquery-h m-q-a-768-h"},[_vm._v("\n                  Modern Ecommerce Solution.\n                ")]),_vm._v(" "),_c('p',{staticClass:"mb-2 h4 pb-2 mquery-p m-q-a-768-p",staticStyle:{"color":"#eee"}},[_vm._v("\n                  With our ecommerce solution you can grow your business very\n                  easily. Your store will be met by more and more customers. We\n                  offer you almost all features in a standard paid e-commerce\n                  service. We assure that your customers will experience a great\n                  online shopping enjoyment.\n                ")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticStyle:{"background-color":"#f8f8f8","border-radius":"5px"},attrs:{"id":""}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center align-items-center"},[_c('div',{staticClass:"col-md-6 mquery-div"},[_c('h2',{staticClass:"display-5 pb-4 pl-3 mquery-h",staticStyle:{"color":"#787878"}},[_vm._v("\n                  The Easy to Use Admin Panel\n                ")]),_vm._v(" "),_c('p',{staticClass:"h5 pb-2 txt-g pl-3 mquery-p"},[_vm._v("\n                  A user friendly admin panel with all the functionalities you\n                  need. You can manage your store anytime anywhere, easily by\n                  yourself. And on top of all that, our site is responsive. You\n                  can use any device like laptop, tablet or even your mobile\n                  phone to manage your store.\n                ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6",staticStyle:{"overflow":"hidden !important"}},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(522),"alt":""}})])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('div',{staticClass:"container"},[_c('h1',{staticClass:"display-4 pb-2 pl-3 mquery-h text-center text-white"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('img',{staticClass:"\n                    img-fluid\n                    animated\n                    infinite\n                    pulse\n                    delay-3s\n                    slower\n                    m-q-a-i-768-3\n                  ",attrs:{"src":__webpack_require__(523),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"col-md-6 d-flex align-items-center"},[_c('div',[_c('h2',{staticClass:"text-white display-4 pb-2 mquery-h m-q-a-768-h"},[_vm._v("\n                    Get the App by Single Tap.\n                  ")]),_vm._v(" "),_c('p',{staticClass:"mb-2 h4 pb-2 mquery-p m-q-a-768-p",staticStyle:{"color":"#eee"}},[_vm._v("\n                    We introduced the first ever,\n                    "),_c('b',{staticClass:"text-danger"},[_vm._v("\n                      Single Page & Serverless, Real-Time Updating and\n                      Offline-Capable Web App\n                    ")]),_vm._v("\n                    in Sri Lanka. It is incredibly easy to get and use. Getting\n                    the app is a single tap/click away. Users will be prompted\n                    with a cool notification to add the app and just a tap from\n                    the user will add it to the home screen of the mobile\n                    device. Also users can get the app by tapping the add to\n                    home screen tab in the web browser after visiting eshops.lk.\n                  ")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container mt-5",staticStyle:{"background-color":"#f8f8f8","border-radius":"5px"}},[_c('div',{staticClass:"pt-3 mx-auto text-center"},[_c('h2',{staticClass:"display-5 text-center mt-3 mb-3 m-h2-txt",staticStyle:{"color":"#787878"}},[_vm._v("\n              The Best Investment You Can Make Today.\n            ")])]),_vm._v(" "),_c('div',{staticClass:"\n              row\n              justify-content-center\n              col-md-10 col-lg-9\n              my-4\n              pb-4\n              mx-auto\n            ",staticStyle:{"border-radius":"5px","height":"auto"}},[_c('div',{staticClass:"col-12 col-lg-4"},[_c('h4',{staticClass:"text-center txt-b my-4"},[_vm._v("\n                Offers incredible scalability\n              ")]),_vm._v(" "),_c('p',{staticClass:"txt-g mb-3 pl-1",staticStyle:{"text-align":"justify","border-left":"3px solid #633991"}},[_vm._v("\n                Scaling any business is not easy, whether it is a\n                brick-and-mortar location or an online business, but an online\n                business has advantages. For instance, a brick-and-mortar retail\n                store has a defined audience, typically a radius from the\n                business location. An online business isn’t restricted by this\n                and can market to a worldwide audience.\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-4"},[_c('h4',{staticClass:"text-center txt-b my-4"},[_vm._v("Provides limitless freedom")]),_vm._v(" "),_c('p',{staticClass:"txt-g mb-3 pl-1",staticStyle:{"text-align":"justify","border-left":"3px solid #633991"}},[_vm._v("\n                Many entrepreneurs are drawn to online businesses because of the\n                freedom they offer. Modern technology, laptops, tablets and\n                smart phones are just some of the tools that allow businesses to\n                be operated from any location.\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-4"},[_c('h4',{staticClass:"text-center txt-b my-4"},[_vm._v("\n                Low overhead and high margins\n              ")]),_vm._v(" "),_c('p',{staticClass:"txt-g mb-3 pl-1",staticStyle:{"text-align":"justify","border-left":"3px solid #633991"}},[_vm._v("\n                An online business will often allow you to eliminate some of the\n                huge costs associated with an offline business. Not only can you\n                eliminate things such as pricey office or retail space and\n                long-term lease commitments, but you can also eliminate having\n                to tie up your money in stocking inventory.\n              ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-6 col-lg-4",attrs:{"id":"contactUs"}},[_c('div',{staticClass:"block block-info"},[_c('h4',[_vm._v("Contact Us")]),_vm._v(" "),_c('ul',[_c('li',[_c('a',[_c('i',{staticClass:"fa fa-phone mr-2",attrs:{"aria-hidden":"true"}}),_vm._v("0719\n                      500 600")])]),_vm._v(" "),_c('li',[_c('a',[_c('i',{staticClass:"fa fa-envelope mr-2",attrs:{"aria-hidden":"true"}}),_vm._v("info@eshops.lk")])])]),_vm._v(" "),_c('ul',{staticClass:"social-media-icons mb-2 d-inline"},[_c('li',{},[_c('a',{staticClass:"px-0 ml-0 mr-2",attrs:{"href":"https://www.facebook.com/Eshopslk-2212428785713128/"}},[_c('i',{staticClass:"fa fa-facebook-official f-sm-link",staticStyle:{"font-size":"34px","color":"#3b5998","background-color":"#fff","width":"30px","height":"30px","border-radius":"4px","text-align":"center","vertical-align":"middle"}})])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"px-0 mx-2",attrs:{"href":"https://www.instagram.com/eshops.lk/"}},[_c('i',{staticClass:"fa fa-instagram f-sm-link",staticStyle:{"font-size":"30px","color":"#fff","background":"radial-gradient(","width":"32px","height":"32px","border-radius":"4px","text-align":"center","vertical-align":"middle"}})])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"px-0 mx-2",attrs:{"href":"https://www.youtube.com/channel/UCJhY3IfJD3T2bA5PJ3SrMZw"}},[_c('i',{staticClass:"fa fa-youtube-square f-sm-link",staticStyle:{"font-size":"35px","color":"#ff0000","background-color":"#fff","width":"30px","height":"30px","border-radius":"6px","text-align":"center","vertical-align":"middle"}})])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm col-md-8 col-lg-5"},[_c('div',{staticClass:"block-2 app-promotion"},[_c('a',[_c('img',{attrs:{"src":__webpack_require__(38),"alt":"mobile-icon"}})]),_vm._v(" "),_c('p',{staticClass:"m-f-text"},[_vm._v("\n                  Tap the Add to Home Screen Tab in Chrome Browser on Android or\n                  Safari Browser on IOS to Get the Splendid\n                  "),_c('span',{staticStyle:{"color":"#fd6a02","font-size":"20px"}},[_vm._v("Mobile App")]),_vm._v("\n                  Directly\n                ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ecom.1fd4ffd.png";

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/admin.2428c87.png";

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/app.48b7a14.png";

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Benefits_vue__ = __webpack_require__(178);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_612166bc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Benefits_vue__ = __webpack_require__(526);
function injectStyle (ssrContext) {
  __webpack_require__(525)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-612166bc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Benefits_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_612166bc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Benefits_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 525 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-modal',{staticClass:"text-center text-info",attrs:{"centered":"","ok-only":""},model:{value:(_vm.modalShow),callback:function ($$v) {_vm.modalShow=$$v},expression:"modalShow"}},[_vm._v("\n      Please Select Category and City\n    ")]),_vm._v(" "),(_vm.deferredPrompt)?_c('div',{staticClass:"alert alert-info alert-dismissible fade show",staticStyle:{"margin-bottom":"0px","background-color":"#fa9b47","border":"none","border-radius":"0px","color":"#fff"},attrs:{"role":"alert"}},[_vm._v("\n      Get the App. It's less than 1 MB\n      "),_c('a',{staticClass:"alert-link",staticStyle:{"cursor":"pointer","color":"#031c35"},on:{"click":function($event){_vm.promptInstall()}}},[_vm._v("INSTALL NOW")]),_vm._v(" "),_vm._m(0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"infobox"},[_c('div',{},[_c('section',[_c('div',{staticStyle:{"background-color":"#3232322e","height":"100%"}},[_c('nav',{staticClass:"navbar navbar-expand-lg navbar-dark bg-dark m-nav",staticStyle:{"z-index":"10"}},[_c('router-link',{staticClass:"navbar-brand",attrs:{"to":"/"}},[_c('img',{attrs:{"src":__webpack_require__(13),"width":"50","height":"50","alt":"eshops-logo"}})]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse",attrs:{"id":"navbarSupportedContent"}},[_c('ul',{staticClass:"navbar-nav mr-auto"},[_c('li',{staticClass:"nav-item mt-2"},[_c('router-link',{staticClass:"m-link nav-link text-white",attrs:{"to":{ name: 'home' }}},[_vm._v("Home")])],1),_vm._v(" "),_c('li',{staticClass:"nav-item"},[(_vm.admin)?_c('router-link',{staticClass:"m-link nav-link text-white",attrs:{"to":{ name: 'admin' }}},[_vm._v("Admin")]):_vm._e()],1),_vm._v(" "),_c('li',{staticClass:"nav-item"},[(_vm.pageadmin)?_c('router-link',{staticClass:"m-link nav-link text-white",attrs:{"to":{ name: 'admin-services' }}},[_vm._v("Admin")]):_vm._e()],1),_vm._v(" "),_c('li',{staticClass:"nav-item"},[(_vm.visitor)?_c('router-link',{staticClass:"m-link nav-link text-white",attrs:{"to":{ name: 'signin' }}},[_vm._v("Sign in")]):_vm._e()],1),_vm._v(" "),_c('li',{staticClass:"nav-item"},[(_vm.visitor)?_c('router-link',{staticClass:"m-link nav-link text-white",attrs:{"to":{ name: 'usersignup' }}},[_vm._v("Sign up")]):_vm._e()],1),_vm._v(" "),_c('li',{staticClass:"nav-item"},[(_vm.user)?_c('router-link',{staticClass:"m-link nav-link text-white",attrs:{"to":{ name: 'myaccount' }}},[_vm._v("My Account")]):_vm._e()],1),_vm._v(" "),_c('li',{staticClass:"nav-item"},[(_vm.user || _vm.admin || _vm.pageadmin || _vm.editor)?_c('a',{staticClass:"m-link nav-link text-white",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.logout()}}},[_vm._v("Sign out")]):_vm._e()])])])],1),_vm._v(" "),_c('nav',{staticClass:"navbar navbar-dark bg-dark d-nav",staticStyle:{"background-color":"#444444b8 !important"}},[_c('router-link',{staticClass:"navbar-brand",attrs:{"to":"/"}},[_c('img',{attrs:{"src":__webpack_require__(13),"width":"50","height":"50","alt":"eshops-logo"}})]),_vm._v(" "),_c('div',[_c('router-link',{staticClass:"text-white mr-5",attrs:{"to":{ name: 'home' }}},[_vm._v("\n                  Home\n                ")]),_vm._v(" "),(_vm.admin)?_c('router-link',{staticClass:"m-link text-white mr-5",attrs:{"to":{ name: 'admin' }}},[_vm._v("Admin")]):_vm._e(),_vm._v(" "),(_vm.pageadmin)?_c('router-link',{staticClass:"m-link text-white mr-5",attrs:{"to":{ name: 'admin-services' }}},[_vm._v("Admin")]):_vm._e(),_vm._v(" "),(_vm.visitor)?_c('router-link',{staticClass:"m-link text-white mr-5",attrs:{"to":{ name: 'signin' }}},[_vm._v("Sign in")]):_vm._e(),_vm._v(" "),(_vm.visitor)?_c('router-link',{staticClass:"m-link text-white mr-5",attrs:{"to":{ name: 'usersignup' }}},[_vm._v("Sign up")]):_vm._e(),_vm._v(" "),(_vm.user)?_c('router-link',{staticClass:"m-link text-white mr-5",attrs:{"to":{ name: 'myaccount' }}},[_vm._v("My Account")]):_vm._e(),_vm._v(" "),(_vm.user || _vm.admin || _vm.pageadmin || _vm.editor)?_c('a',{staticClass:"text-white mr-5",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.logout()}}},[_vm._v("Sign out")]):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticClass:"container",staticStyle:{"padding-top":"10%","position":"absolute"}},[_c('div',{staticClass:"row",staticStyle:{"margin-top":"-80px"}},[_c('div',{staticClass:"col-sm-12 col-md-4 text-center ml-auto"},[_vm._m(2),_vm._v(" "),_c('el-form',{ref:"searchForm",staticClass:"el-form m-auto",attrs:{"inline":true,"model":_vm.searchForm,"status-icon":"","label-width":"120px","label-position":_vm.labelPosition,"size":"medium"}},[_c('div',{staticClass:"col-sm-12 text-center mx-auto",staticStyle:{"margin-top":"30px"}},[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:({
                          el: '#benefits',
                          duration: 900,
                          easing: 'linear',
                          force: true,
                        }),expression:"{\n                          el: '#benefits',\n                          duration: 900,\n                          easing: 'linear',\n                          force: true,\n                        }"}]},[_c('el-button',{staticClass:"text-white mb-3",staticStyle:{"text-decoration":"none","background-color":"#702ef1"},attrs:{"type":"warning"}},[_c('h5',[_vm._v("Explore Benefits")])])],1),_vm._v(" "),_c('a',{attrs:{"href":"tel:0719500600"}},[_c('el-button',{staticClass:"text-white",staticStyle:{"text-decoration":"none","background-color":"#0ea53c"},attrs:{"type":"success"}},[_c('h5',[_vm._v("0719 500 600")])])],1)])])],1)])])])])]),_vm._v(" "),_c('section',{attrs:{"id":"benefits"}},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"container my-4"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 d-flex mx-auto align-items-center"},[_c('div',{staticClass:"m-q-a-768"},[_c('h1',{staticClass:"\n                    text-white\n                    display-4\n                    pb-2\n                    pl-5\n                    mquery-h\n                    m-q-a-768-h m-q-850\n                  "},[_vm._v("\n                  It’s All About the Success of Your Business.\n                ")]),_vm._v(" "),_c('p',{staticClass:"mb-2 h4 pb-2 mquery-p pl-5 m-q-a-768-p",staticStyle:{"color":"#eee"}},[_vm._v("\n                  The straightforward and timely way to grow your business in\n                  the modern world is an online business. Contact us to grow\n                  your business now.\n                ")]),_vm._v(" "),_c('a',{attrs:{"href":"tel:0719500600"}},[_c('el-button',{staticClass:"text-white ml-5 mx-auto mb-3",staticStyle:{"text-decoration":"none","display":"block","margin":"0 auto"},attrs:{"type":"success"}},[_c('h5',[_vm._v("0719 500 600")])])],1),_vm._v(" "),_c('p',{staticClass:"mb-2 h4 pb-2 mquery-p pl-5 m-q-a-768-p",staticStyle:{"color":"#eee"}},[_vm._v("\n                  Need your own domain name? We can provide that too, Just call\n                  us now.\n                ")]),_vm._v(" "),_c('a',{attrs:{"href":"tel:0719500600"}},[_c('el-button',{staticClass:"text-white ml-5 mx-auto",staticStyle:{"text-decoration":"none","display":"block","margin":"0 auto"},attrs:{"type":"success"}},[_c('h5',[_vm._v("0719 500 600")])])],1)])])])])]),_vm._v(" "),_c('div',[_c('footer',{staticClass:"footer section section-sm footer-search",staticStyle:{"padding-bottom":"0px"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-around"},[_c('div',{staticClass:"col-sm-6 col-lg-3"},[_c('div',{staticClass:"block block-link"},[_c('h4',[_vm._v("Site Pages")]),_vm._v(" "),_c('ul',[_c('li',{staticClass:"px-0"},[_c('router-link',{attrs:{"to":{ name: 'home' }}},[_vm._v("Home")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'about' }}},[_vm._v("About Us")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'termsofuse' }}},[_vm._v("Terms of Use")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'privacypolicy' }}},[_vm._v("Privacy Policy")])],1)])])]),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5)])])]),_vm._v(" "),_c('footer',{staticClass:"footer-bottom"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 mx-auto mt-5"},[_c('div',{staticClass:"copyright text-center"},[_c('img',{attrs:{"src":__webpack_require__(25),"alt":"eshops-logo"}}),_vm._v(" "),_c('p',{staticClass:"m-f-text mt-2"},[_vm._v("\n                  © "+_vm._s(new Date().getFullYear())+" eshops.lk | All Rights\n                  Reserved\n                ")])])])])])])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"alert","aria-label":"Close"}},[_c('span',{staticStyle:{"color":"#fff"},attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"navbar-toggler float-right",attrs:{"type":"button","data-toggle":"collapse","data-target":"#navbarSupportedContent","aria-controls":"navbarSupportedContent","aria-expanded":"false","aria-label":"Toggle navigation"}},[_c('span',{staticClass:"navbar-toggler-icon"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-4",staticStyle:{"background":"#ffffff70","border-radius":"5px"}},[_c('h1',{staticClass:"displayh-4 text-dark ml-auto mb-5 pt-4",attrs:{"id":"typed"}},[_vm._v("\n                      It’s All About the Success of Your Business.\n                    ")]),_vm._v(" "),_c('h5',{staticClass:"text-dark mr-3 display-5 mb-4 pb-4",staticStyle:{"font-weight":"bold"}},[_vm._v("\n                      Explore benefits and contact us to grow your business.\n                    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"timeline"},[_c('h2',{staticClass:"display-5 pb-3 pl-3 text-center mquery-h d-block pt-5",staticStyle:{"color":"#787878"}},[_vm._v("\n            Explore Features and Benefits\n          ")]),_vm._v(" "),_c('div',{staticClass:"\n              timeline__event\n              animated\n              fadeInUp\n              delay-3s\n              timeline__event--type1\n            "},[_c('div',{staticClass:"timeline__event__icon"},[_c('i',{staticClass:"el-icon-s-platform"})]),_vm._v(" "),_c('div',{staticClass:"timeline__event__date"},[_vm._v("POS System")]),_vm._v(" "),_c('div',{staticClass:"timeline__event__content"},[_c('div',{staticClass:"timeline__event__title"},[_vm._v("Benefits")]),_vm._v(" "),_c('div',{staticClass:"timeline__event__description"},[_c('ul',{staticClass:"benefits-list"},[_c('li',[_vm._v("Simple Invoicing")]),_vm._v(" "),_c('li',[_vm._v("Better Security & Service")]),_vm._v(" "),_c('li',[_vm._v("Improve Company Image")]),_vm._v(" "),_c('li',[_vm._v("Increased Efficiency & Saving Time")]),_vm._v(" "),_c('li',[_vm._v("Increased Revenues")])])])])]),_vm._v(" "),_c('div',{staticClass:"\n              timeline__event\n              animated\n              fadeInUp\n              delay-2s\n              timeline__event--type2\n            "},[_c('div',{staticClass:"timeline__event__icon"},[_c('i',{staticClass:"el-icon-s-data"})]),_vm._v(" "),_c('div',{staticClass:"timeline__event__date"},[_vm._v("Inventory Management")]),_vm._v(" "),_c('div',{staticClass:"timeline__event__content"},[_c('div',{staticClass:"timeline__event__title"},[_vm._v("Benefits")]),_vm._v(" "),_c('div',{staticClass:"timeline__event__description"},[_c('ul',{staticClass:"benefits-list"},[_c('li',[_vm._v("Prevent stock outs and overselling")]),_vm._v(" "),_c('li',[_vm._v("No More Manual Work")]),_vm._v(" "),_c('li',[_vm._v("Better Inventory Accuracy")]),_vm._v(" "),_c('li',[_vm._v("Increased Profits & Cost Saving")]),_vm._v(" "),_c('li',[_vm._v("More Productivity")])])])])]),_vm._v(" "),_c('div',{staticClass:"\n              timeline__event\n              animated\n              fadeInUp\n              delay-1s\n              timeline__event--type3\n            "},[_c('div',{staticClass:"timeline__event__icon"},[_c('i',{staticClass:"el-icon-shopping-cart-full"})]),_vm._v(" "),_c('div',{staticClass:"timeline__event__date"},[_vm._v("Online Store")]),_vm._v(" "),_c('div',{staticClass:"timeline__event__content"},[_c('div',{staticClass:"timeline__event__title"},[_vm._v("Benefits")]),_vm._v(" "),_c('div',{staticClass:"timeline__event__description"},[_c('ul',{staticClass:"benefits-list"},[_c('li',[_vm._v("You are open to the world")]),_vm._v(" "),_c('li',[_vm._v("New Customers")]),_vm._v(" "),_c('li',[_vm._v("New sales options")]),_vm._v(" "),_c('li',[_vm._v("Easy access to market")]),_vm._v(" "),_c('li',[_vm._v("Lower costs")])])])])]),_vm._v(" "),_c('div',{staticClass:"\n              timeline__event\n              animated\n              fadeInUp\n              delay-3s\n              timeline__event--type1\n            "},[_c('div',{staticClass:"timeline__event__icon"},[_c('i',{staticClass:"el-icon-data-analysis"})]),_vm._v(" "),_c('div',{staticClass:"timeline__event__date"},[_vm._v("Sales Analytics")]),_vm._v(" "),_c('div',{staticClass:"timeline__event__content"},[_c('div',{staticClass:"timeline__event__title"},[_vm._v("Benefits")]),_vm._v(" "),_c('div',{staticClass:"timeline__event__description"},[_c('ul',{staticClass:"benefits-list"},[_c('li',[_vm._v("Promotes Better Decision-making")]),_vm._v(" "),_c('li',[_vm._v("Keeps Your Business Updated")]),_vm._v(" "),_c('li',[_vm._v("Provides Better Insights Via Data Visualization")]),_vm._v(" "),_c('li',[_vm._v("Transparency Of Sales Data")]),_vm._v(" "),_c('li',[_vm._v("Better Accessibility & Boosts Efficiency")])])])])]),_vm._v(" "),_c('div',{staticClass:"\n              timeline__event\n              animated\n              fadeInUp\n              delay-2s\n              timeline__event--type2\n            "},[_c('div',{staticClass:"timeline__event__icon"},[_c('i',{staticClass:"el-icon-s-custom"})]),_vm._v(" "),_c('div',{staticClass:"timeline__event__date"},[_vm._v("CRM System")]),_vm._v(" "),_c('div',{staticClass:"timeline__event__content"},[_c('div',{staticClass:"timeline__event__title"},[_vm._v("Benefits")]),_vm._v(" "),_c('div',{staticClass:"timeline__event__description"},[_c('ul',{staticClass:"benefits-list"},[_c('li',[_vm._v("Maintain a centralized database of customers")]),_vm._v(" "),_c('li',[_vm._v("Better customer communication")]),_vm._v(" "),_c('li',[_vm._v("Better customer service")]),_vm._v(" "),_c('li',[_vm._v("Increased sales")]),_vm._v(" "),_c('li',[_vm._v("Improved customer retention")])])])])]),_vm._v(" "),_c('div',{staticClass:"\n              timeline__event\n              animated\n              fadeInUp\n              delay-1s\n              timeline__event--type3\n            "},[_c('div',{staticClass:"timeline__event__icon"},[_c('i',{staticClass:"el-icon-s-marketing"})]),_vm._v(" "),_c('div',{staticClass:"timeline__event__date"},[_vm._v("Loyalty Program")]),_vm._v(" "),_c('div',{staticClass:"timeline__event__content"},[_c('div',{staticClass:"timeline__event__title"},[_vm._v("Benefits")]),_vm._v(" "),_c('div',{staticClass:"timeline__event__description"},[_c('ul',{staticClass:"benefits-list"},[_c('li',[_vm._v("Improved Customer Engagement")]),_vm._v(" "),_c('li',[_vm._v("Improves Customer Experience")]),_vm._v(" "),_c('li',[_vm._v("Increased Customer Retention")]),_vm._v(" "),_c('li',[_vm._v("Increase in Sales and Revenue")]),_vm._v(" "),_c('li',[_vm._v("Increased Customer Lifetime Value")])])])])]),_vm._v(" "),_c('div',{staticClass:"\n              timeline__event\n              animated\n              fadeInUp\n              delay-3s\n              timeline__event--type1\n            "},[_c('div',{staticClass:"timeline__event__icon"},[_c('i',{staticClass:"el-icon-s-promotion"})]),_vm._v(" "),_c('div',{staticClass:"timeline__event__date"},[_vm._v("Referral Program")]),_vm._v(" "),_c('div',{staticClass:"timeline__event__content"},[_c('div',{staticClass:"timeline__event__title"},[_vm._v("Benefits")]),_vm._v(" "),_c('div',{staticClass:"timeline__event__description"},[_c('ul',{staticClass:"benefits-list"},[_c('li',[_vm._v("Word-of-mouth improves customer retention")]),_vm._v(" "),_c('li',[_vm._v("Referred customers are more valuable")]),_vm._v(" "),_c('li',[_vm._v("Increase brand awareness & reputation")]),_vm._v(" "),_c('li',[_vm._v("Customers trust referrals")]),_vm._v(" "),_c('li',[_vm._v("Reward current customers & Find new")])])])])]),_vm._v(" "),_c('div',{staticClass:"\n              timeline__event\n              animated\n              fadeInUp\n              delay-2s\n              timeline__event--type2\n            "},[_c('div',{staticClass:"timeline__event__icon"},[_c('i',{staticClass:"el-icon-user-solid"})]),_vm._v(" "),_c('div',{staticClass:"timeline__event__date"},[_vm._v("User Management")]),_vm._v(" "),_c('div',{staticClass:"timeline__event__content"},[_c('div',{staticClass:"timeline__event__title"},[_vm._v("Benefits")]),_vm._v(" "),_c('div',{staticClass:"timeline__event__description"},[_c('ul',{staticClass:"benefits-list"},[_c('li',[_vm._v("Improved security")]),_vm._v(" "),_c('li',[_vm._v("Information sharing")]),_vm._v(" "),_c('li',[_vm._v("Ease of use")]),_vm._v(" "),_c('li',[_vm._v("Productivity gains")]),_vm._v(" "),_c('li',[_vm._v("Improve employee productivity")])])])])]),_vm._v(" "),_c('div',{staticClass:"\n              timeline__event\n              animated\n              fadeInUp\n              delay-1s\n              timeline__event--type3\n            "},[_c('div',{staticClass:"timeline__event__icon"},[_c('i',{staticClass:"el-icon-price-tag"})]),_vm._v(" "),_c('div',{staticClass:"timeline__event__date"},[_vm._v("Barcodes")]),_vm._v(" "),_c('div',{staticClass:"timeline__event__content"},[_c('div',{staticClass:"timeline__event__title"},[_vm._v("Benefits")]),_vm._v(" "),_c('div',{staticClass:"timeline__event__description"},[_c('ul',{staticClass:"benefits-list"},[_c('li',[_vm._v("Barcodes are efficient")]),_vm._v(" "),_c('li',[_vm._v("Save time")]),_vm._v(" "),_c('li',[_vm._v("Reduce errors")]),_vm._v(" "),_c('li',[_vm._v("Inventory control improves")]),_vm._v(" "),_c('li',[_vm._v("Inexpensive to design and print")])])])])]),_vm._v(" "),_c('div',{staticClass:"\n              timeline__event\n              animated\n              fadeInUp\n              delay-3s\n              timeline__event--type1\n            "},[_c('div',{staticClass:"timeline__event__icon"},[_c('i',{staticClass:"el-icon-cloudy"})]),_vm._v(" "),_c('div',{staticClass:"timeline__event__date"},[_vm._v("Cloud Based System")]),_vm._v(" "),_c('div',{staticClass:"timeline__event__content"},[_c('div',{staticClass:"timeline__event__title"},[_vm._v("Benefits")]),_vm._v(" "),_c('div',{staticClass:"timeline__event__description"},[_c('ul',{staticClass:"benefits-list"},[_c('li',[_vm._v("Cost Savings & High speed")]),_vm._v(" "),_c('li',[_vm._v("24/7 Access to Data")]),_vm._v(" "),_c('li',[_vm._v("Automatic Software Updates")]),_vm._v(" "),_c('li',[_vm._v("Better Security")]),_vm._v(" "),_c('li',[_vm._v("Data Loss Prevention")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-6 col-lg-4",attrs:{"id":"contactUs"}},[_c('div',{staticClass:"block block-info"},[_c('h4',[_vm._v("Contact Us")]),_vm._v(" "),_c('ul',[_c('li',[_c('a',[_c('i',{staticClass:"fa fa-phone mr-2",attrs:{"aria-hidden":"true"}}),_vm._v("0719\n                      500 600")])]),_vm._v(" "),_c('li',[_c('a',[_c('i',{staticClass:"fa fa-envelope mr-2",attrs:{"aria-hidden":"true"}}),_vm._v("info@eshops.lk")])])]),_vm._v(" "),_c('ul',{staticClass:"social-media-icons mb-2 d-inline"},[_c('li',{},[_c('a',{staticClass:"px-0 ml-0 mr-2",attrs:{"href":"https://www.facebook.com/Eshopslk-2212428785713128/"}},[_c('i',{staticClass:"fa fa-facebook-official f-sm-link",staticStyle:{"font-size":"34px","color":"#3b5998","background-color":"#fff","width":"30px","height":"30px","border-radius":"4px","text-align":"center","vertical-align":"middle"}})])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"px-0 mx-2",attrs:{"href":"https://www.instagram.com/eshops.lk/"}},[_c('i',{staticClass:"fa fa-instagram f-sm-link",staticStyle:{"font-size":"30px","color":"#fff","background":"radial-gradient(","width":"32px","height":"32px","border-radius":"4px","text-align":"center","vertical-align":"middle"}})])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"px-0 mx-2",attrs:{"href":"https://www.youtube.com/channel/UCJhY3IfJD3T2bA5PJ3SrMZw"}},[_c('i',{staticClass:"fa fa-youtube-square f-sm-link",staticStyle:{"font-size":"35px","color":"#ff0000","background-color":"#fff","width":"30px","height":"30px","border-radius":"6px","text-align":"center","vertical-align":"middle"}})])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm col-md-8 col-lg-5"},[_c('div',{staticClass:"block-2 app-promotion"},[_c('a',[_c('img',{attrs:{"src":__webpack_require__(38),"alt":"mobile-icon"}})]),_vm._v(" "),_c('p',{staticClass:"m-f-text"},[_vm._v("\n                  Tap the Add to Home Screen Tab in Chrome Browser on Android or\n                  Safari Browser on IOS to Get the Splendid\n                  "),_c('span',{staticStyle:{"color":"#fd6a02","font-size":"20px"}},[_vm._v("Mobile App")]),_vm._v("\n                  Directly\n                ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Restaurants_vue__ = __webpack_require__(179);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70194128_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Restaurants_vue__ = __webpack_require__(529);
function injectStyle (ssrContext) {
  __webpack_require__(528)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-70194128"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Restaurants_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70194128_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Restaurants_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 528 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-modal',{staticClass:"text-center text-info",attrs:{"centered":"","ok-only":""},model:{value:(_vm.modalShow),callback:function ($$v) {_vm.modalShow=$$v},expression:"modalShow"}},[_vm._v("\n      Please Select Category and City\n    ")]),_vm._v(" "),(_vm.deferredPrompt)?_c('div',{staticClass:"alert alert-info alert-dismissible fade show",staticStyle:{"margin-bottom":"0px","background-color":"#fa9b47","border":"none","border-radius":"0px","color":"#fff"},attrs:{"role":"alert"}},[_vm._v("\n      Get the App. It's less than 1 MB\n      "),_c('a',{staticClass:"alert-link",staticStyle:{"cursor":"pointer","color":"#031c35"},on:{"click":function($event){_vm.promptInstall()}}},[_vm._v("INSTALL NOW")]),_vm._v(" "),_vm._m(0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"infobox"},[_c('div',{},[_c('section',[_c('div',{staticStyle:{"background-color":"#3232322e","height":"100%"}},[_c('nav',{staticClass:"navbar navbar-expand-lg navbar-dark bg-dark m-nav",staticStyle:{"z-index":"10"}},[_c('router-link',{staticClass:"navbar-brand",attrs:{"to":"/"}},[_c('img',{attrs:{"src":__webpack_require__(13),"width":"50","height":"50","alt":"eshops-logo"}})]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse",attrs:{"id":"navbarSupportedContent"}},[_c('ul',{staticClass:"navbar-nav mr-auto"},[_c('li',{staticClass:"nav-item mt-2"},[_c('router-link',{staticClass:"m-link nav-link text-white",attrs:{"to":{ name: 'home' }}},[_vm._v("Home")])],1),_vm._v(" "),_c('li',{staticClass:"nav-item"},[(_vm.admin)?_c('router-link',{staticClass:"m-link nav-link text-white",attrs:{"to":{ name: 'admin' }}},[_vm._v("Admin")]):_vm._e()],1),_vm._v(" "),_c('li',{staticClass:"nav-item"},[(_vm.pageadmin)?_c('router-link',{staticClass:"m-link nav-link text-white",attrs:{"to":{ name: 'admin-services' }}},[_vm._v("Admin")]):_vm._e()],1),_vm._v(" "),_c('li',{staticClass:"nav-item"},[(_vm.visitor)?_c('router-link',{staticClass:"m-link nav-link text-white",attrs:{"to":{ name: 'signin' }}},[_vm._v("Sign in")]):_vm._e()],1),_vm._v(" "),_c('li',{staticClass:"nav-item"},[(_vm.visitor)?_c('router-link',{staticClass:"m-link nav-link text-white",attrs:{"to":{ name: 'usersignup' }}},[_vm._v("Sign up")]):_vm._e()],1),_vm._v(" "),_c('li',{staticClass:"nav-item"},[(_vm.user)?_c('router-link',{staticClass:"m-link nav-link text-white",attrs:{"to":{ name: 'myaccount' }}},[_vm._v("My Account")]):_vm._e()],1),_vm._v(" "),_c('li',{staticClass:"nav-item"},[(_vm.user || _vm.admin || _vm.pageadmin || _vm.editor)?_c('a',{staticClass:"m-link nav-link text-white",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.logout()}}},[_vm._v("Sign out")]):_vm._e()])])])],1),_vm._v(" "),_c('nav',{staticClass:"navbar navbar-dark bg-dark d-nav",staticStyle:{"background-color":"#444444b8 !important"}},[_c('router-link',{staticClass:"navbar-brand",attrs:{"to":"/"}},[_c('img',{attrs:{"src":__webpack_require__(13),"width":"50","height":"50","alt":"eshops-logo"}})]),_vm._v(" "),_c('div',[_c('router-link',{staticClass:"text-white mr-5",attrs:{"to":{ name: 'home' }}},[_vm._v("\n                  Home\n                ")]),_vm._v(" "),(_vm.admin)?_c('router-link',{staticClass:"m-link text-white mr-5",attrs:{"to":{ name: 'admin' }}},[_vm._v("Admin")]):_vm._e(),_vm._v(" "),(_vm.pageadmin)?_c('router-link',{staticClass:"m-link text-white mr-5",attrs:{"to":{ name: 'admin-services' }}},[_vm._v("Admin")]):_vm._e(),_vm._v(" "),(_vm.visitor)?_c('router-link',{staticClass:"m-link text-white mr-5",attrs:{"to":{ name: 'signin' }}},[_vm._v("Sign in")]):_vm._e(),_vm._v(" "),(_vm.visitor)?_c('router-link',{staticClass:"m-link text-white mr-5",attrs:{"to":{ name: 'usersignup' }}},[_vm._v("Sign up")]):_vm._e(),_vm._v(" "),(_vm.user)?_c('router-link',{staticClass:"m-link text-white mr-5",attrs:{"to":{ name: 'myaccount' }}},[_vm._v("My Account")]):_vm._e(),_vm._v(" "),(_vm.user || _vm.admin || _vm.pageadmin || _vm.editor)?_c('a',{staticClass:"text-white mr-5",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.logout()}}},[_vm._v("Sign out")]):_vm._e()],1)],1)])])]),_vm._v(" "),_c('section',{attrs:{"id":"benefits"}},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"container my-4"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 d-flex mx-auto align-items-center"},[_c('div',{staticClass:"m-q-a-768"},[_c('h1',{staticClass:"\n                    text-white\n                    display-4\n                    pb-2\n                    pl-5\n                    mquery-h\n                    m-q-a-768-h m-q-850\n                  "},[_vm._v("\n                  It’s All About the Success of Your Business.\n                ")]),_vm._v(" "),_c('p',{staticClass:"mb-2 h4 pb-2 mquery-p pl-5 m-q-a-768-p",staticStyle:{"color":"#eee"}},[_vm._v("\n                  The straightforward and timely way to grow your business in\n                  the modern world is an online business. Contact us to grow\n                  your business now.\n                ")]),_vm._v(" "),_c('a',{attrs:{"href":"tel:0719500600"}},[_c('el-button',{staticClass:"text-white ml-5 mx-auto mb-3",staticStyle:{"text-decoration":"none","display":"block","margin":"0 auto"},attrs:{"type":"success"}},[_c('h5',[_vm._v("0719 500 600")])])],1),_vm._v(" "),_c('p',{staticClass:"mb-2 h4 pb-2 mquery-p pl-5 m-q-a-768-p",staticStyle:{"color":"#eee"}},[_vm._v("\n                  Need your own domain name? We can provide that too, Just call\n                  us now.\n                ")]),_vm._v(" "),_c('a',{attrs:{"href":"tel:0719500600"}},[_c('el-button',{staticClass:"text-white ml-5 mx-auto",staticStyle:{"text-decoration":"none","display":"block","margin":"0 auto"},attrs:{"type":"success"}},[_c('h5',[_vm._v("0719 500 600")])])],1)])])])])]),_vm._v(" "),_c('div',[_c('footer',{staticClass:"footer section section-sm footer-search",staticStyle:{"padding-bottom":"0px"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-around"},[_c('div',{staticClass:"col-sm-6 col-lg-3"},[_c('div',{staticClass:"block block-link"},[_c('h4',[_vm._v("Site Pages")]),_vm._v(" "),_c('ul',[_c('li',{staticClass:"px-0"},[_c('router-link',{attrs:{"to":{ name: 'home' }}},[_vm._v("Home")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'about' }}},[_vm._v("About Us")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'termsofuse' }}},[_vm._v("Terms of Use")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'privacypolicy' }}},[_vm._v("Privacy Policy")])],1)])])]),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4)])])]),_vm._v(" "),_c('footer',{staticClass:"footer-bottom"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 mx-auto mt-5"},[_c('div',{staticClass:"copyright text-center"},[_c('img',{attrs:{"src":__webpack_require__(25),"alt":"eshops-logo"}}),_vm._v(" "),_c('p',{staticClass:"m-f-text mt-2"},[_vm._v("\n                  © "+_vm._s(new Date().getFullYear())+" eshops.lk | All Rights\n                  Reserved\n                ")])])])])])])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"alert","aria-label":"Close"}},[_c('span',{staticStyle:{"color":"#fff"},attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"navbar-toggler float-right",attrs:{"type":"button","data-toggle":"collapse","data-target":"#navbarSupportedContent","aria-controls":"navbarSupportedContent","aria-expanded":"false","aria-label":"Toggle navigation"}},[_c('span',{staticClass:"navbar-toggler-icon"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container section-why",attrs:{"id":"section-why"}},[_c('section',{staticClass:"py-5 mt-5",staticStyle:{"background-color":"#f8f8f8","border-radius":"5px"},attrs:{"id":"icon-boxes"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row mb-1"},[_c('div',{staticClass:"col-md-6 d-flex mx-auto align-items-center"},[_c('div',[_c('h2',{staticClass:"display-5 pb-2 pl-3 text-center mquery-h",staticStyle:{"color":"#787878"}},[_vm._v("\n                    SPECIAL BENEFITS FOR RESTAURANTS & CAFES\n                  ")])])])]),_vm._v(" "),_c('div',{staticClass:"row "},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"bg-light text-center text-secondary"},[_c('div',{staticClass:"card-block py-4"},[_c('h3',{staticClass:"mb-1"},[_vm._v("Online Orders & Takeaway Orders\n& KOT/BOT\n")]),_vm._v(" "),_c('p',{staticClass:"text-left"},[_vm._v("\n                      Online ordering can streamline your systems in\nthe kitchen. When customers send their orders\nonline, it decreases the amount of time staff\nmembers need to spend on the phone. Instead,\nthe team can complete the steps — such as\ncooking & packaging. It ensures that every meal\nis ready for your customers on time.\n                    ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"bg-light text-center text-secondary"},[_c('div',{staticClass:"card-block py-4"},[_c('h3',{staticClass:"mb-1"},[_vm._v("Easily Manage Complete Menu")]),_vm._v(" "),_c('p',{staticClass:"text-left"},[_vm._v("\n                      Restaurants can update and display their menu\nitems, prices, and promotions quickly and\neasily. 86% of customers are ready to buy after\nseeing menu online. 90% of customers search for food delivery\nand takeout online.\n                    ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"bg-light text-center text-secondary"},[_c('div',{staticClass:"card-block py-4"},[_c('h3',{staticClass:"mb-1"},[_vm._v("Make It Easier for Your Customers to Order")]),_vm._v(" "),_c('p',{staticClass:"text-left"},[_vm._v("\n                      Customers can view menu items & promotions\nfrom mobile phones & place orders at any time\nfrom anywhere, and track their order status.\nCustomers don't like to sit in their car or the\nrestaurant to wait for their food. Reduce\ncustomer waiting time and increase customer\nsatisfaction.\n                    ")])])])])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"bg-light text-center text-secondary"},[_c('div',{staticClass:"card-block py-4"},[_c('h3',{staticClass:"mb-1"},[_vm._v("No commission for online orders")]),_vm._v(" "),_c('p',{staticClass:"text-left"},[_vm._v("\n                      Many restaurants have jumped on the online\nordering trend by partnering with delivery services\nlike PickMe, and UberEats. These companies charge\nhigher commissions either from you or your\ncustomers.\n                    ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"bg-light text-center text-secondary"},[_c('div',{staticClass:"card-block py-4"},[_c('h3',{staticClass:"mb-1"},[_vm._v("Increas the Reach")]),_vm._v(" "),_c('p',{staticClass:"text-left"},[_vm._v("\n                    It also increases word-of-mouth marketing.\nPromotions and discounts can bring customers\nthrough the door, When customers eat something\nthey love, they post it online and tell about their\nmeal to friends and family. This is the key to success\ntoday.\n                    ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"bg-light text-center text-secondary"},[_c('div',{staticClass:"card-block py-4"},[_c('h3',{staticClass:"mb-1"},[_vm._v("Better customers data")]),_vm._v(" "),_c('p',{staticClass:"text-left"},[_vm._v("\n                      Who are your regular customers? What do they\nlike ordering? Which food items are popular?\nAre they aware of the promotions and offers on\nthe website? These questions can be answered\nusing analytics and insights provided by an\nonline system. This data is valuable to send\ntargeted advertisements to your customers.\n                    ")])])])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-6 col-lg-4",attrs:{"id":"contactUs"}},[_c('div',{staticClass:"block block-info"},[_c('h4',[_vm._v("Contact Us")]),_vm._v(" "),_c('ul',[_c('li',[_c('a',[_c('i',{staticClass:"fa fa-phone mr-2",attrs:{"aria-hidden":"true"}}),_vm._v("0719\n                      500 600")])]),_vm._v(" "),_c('li',[_c('a',[_c('i',{staticClass:"fa fa-envelope mr-2",attrs:{"aria-hidden":"true"}}),_vm._v("info@eshops.lk")])])]),_vm._v(" "),_c('ul',{staticClass:"social-media-icons mb-2 d-inline"},[_c('li',{},[_c('a',{staticClass:"px-0 ml-0 mr-2",attrs:{"href":"https://www.facebook.com/Eshopslk-2212428785713128/"}},[_c('i',{staticClass:"fa fa-facebook-official f-sm-link",staticStyle:{"font-size":"34px","color":"#3b5998","background-color":"#fff","width":"30px","height":"30px","border-radius":"4px","text-align":"center","vertical-align":"middle"}})])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"px-0 mx-2",attrs:{"href":"https://www.instagram.com/eshops.lk/"}},[_c('i',{staticClass:"fa fa-instagram f-sm-link",staticStyle:{"font-size":"30px","color":"#fff","background":"radial-gradient(","width":"32px","height":"32px","border-radius":"4px","text-align":"center","vertical-align":"middle"}})])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"px-0 mx-2",attrs:{"href":"https://www.youtube.com/channel/UCJhY3IfJD3T2bA5PJ3SrMZw"}},[_c('i',{staticClass:"fa fa-youtube-square f-sm-link",staticStyle:{"font-size":"35px","color":"#ff0000","background-color":"#fff","width":"30px","height":"30px","border-radius":"6px","text-align":"center","vertical-align":"middle"}})])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm col-md-8 col-lg-5"},[_c('div',{staticClass:"block-2 app-promotion"},[_c('a',[_c('img',{attrs:{"src":__webpack_require__(38),"alt":"mobile-icon"}})]),_vm._v(" "),_c('p',{staticClass:"m-f-text"},[_vm._v("\n                  Tap the Add to Home Screen Tab in Chrome Browser on Android or\n                  Safari Browser on IOS to Get the Splendid\n                  "),_c('span',{staticStyle:{"color":"#fd6a02","font-size":"20px"}},[_vm._v("Mobile App")]),_vm._v("\n                  Directly\n                ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__ = __webpack_require__(180);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e73153a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__ = __webpack_require__(532);
function injectStyle (ssrContext) {
  __webpack_require__(531)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2e73153a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e73153a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 531 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',[_c('div',{staticClass:"outer-menu",staticStyle:{"z-index":"7777"}},[_c('input',{staticClass:"checkbox-toggle",attrs:{"type":"checkbox"}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"menu"},[_c('div',[_c('div',[_c('ul',[_c('li',[_c('router-link',{staticClass:"text-white",attrs:{"to":{ name: 'home' }}},[_vm._v("\n                    Home\n                  ")])],1),_vm._v(" "),_c('li',[(_vm.admin)?_c('router-link',{staticClass:"text-white",attrs:{"to":{ name: 'admin' }}},[_vm._v("\n                    Admin")]):_vm._e()],1),_vm._v(" "),_c('li',[(_vm.pageadmin)?_c('router-link',{staticClass:"text-white",attrs:{"to":{ name: 'admin-services' }}},[_vm._v("\n                    Admin")]):_vm._e()],1),_vm._v(" "),_c('li',[(_vm.visitor)?_c('router-link',{staticClass:"text-white",attrs:{"to":{ name: 'signin' }}},[_vm._v("\n                    Sign in")]):_vm._e()],1),_vm._v(" "),_c('li',[(_vm.visitor)?_c('router-link',{staticClass:"text-white",attrs:{"to":{ name: 'usersignup' }}},[_vm._v("\n                    Sign up")]):_vm._e()],1),_vm._v(" "),_c('li',[(_vm.user)?_c('router-link',{staticClass:"text-white",attrs:{"to":{ name: 'myaccount' }}},[_vm._v("\n                    My Account")]):_vm._e()],1),_vm._v(" "),_c('li',[(_vm.user || _vm.admin || _vm.pageadmin)?_c('a',{staticClass:"text-white",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.logout()}}},[_vm._v("\n                    Sign out")]):_vm._e()])])])])])])]),_vm._v(" "),_c('div',{},[_c('section',[_c('nav',{staticClass:"navbar",staticStyle:{"background-color":"#180000"}},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"d-nav"},[_c('router-link',{staticClass:"text-white mr-5",attrs:{"to":{ name: 'home' }}},[_vm._v("\n              Home\n            ")]),_vm._v(" "),(_vm.admin)?_c('router-link',{staticClass:"m-link text-white mr-5",attrs:{"to":{ name: 'admin' }}},[_vm._v("Admin")]):_vm._e(),_vm._v(" "),(_vm.pageadmin)?_c('router-link',{staticClass:"m-link text-white mr-5",attrs:{"to":{ name: 'admin-services' }}},[_vm._v("Admin")]):_vm._e(),_vm._v(" "),(_vm.visitor)?_c('router-link',{staticClass:"m-link text-white mr-5",attrs:{"to":{ name: 'signin' }}},[_vm._v("Sign in")]):_vm._e(),_vm._v(" "),(_vm.visitor)?_c('router-link',{staticClass:"m-link text-white mr-5",attrs:{"to":{ name: 'usersignup' }}},[_vm._v("Sign up")]):_vm._e(),_vm._v(" "),(_vm.user)?_c('router-link',{staticClass:"m-link text-white mr-5",attrs:{"to":{ name: 'myaccount' }}},[_vm._v("My Account")]):_vm._e(),_vm._v(" "),(_vm.user || _vm.admin || _vm.pageadmin)?_c('a',{staticClass:"text-white mr-5",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.logout()}}},[_vm._v("Sign out")]):_vm._e()],1)])])]),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('footer',{staticClass:"footer section section-sm"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-around"},[_c('div',{staticClass:"col-sm-6 col-lg-3"},[_c('div',{staticClass:"block block-link"},[_c('h4',[_vm._v("Site Pages")]),_vm._v(" "),_c('ul',[_c('li',{staticClass:"px-0"},[_c('router-link',{attrs:{"to":{ name: 'home' }}},[_vm._v("Home")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'about' }}},[_vm._v("About Us")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'termsofuse' }}},[_vm._v("Terms of Use")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'privacypolicy' }}},[_vm._v("Privacy Policy")])],1)])])]),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6)])])]),_vm._v(" "),_c('footer',{staticClass:"footer-bottom"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 mx-auto mt-5"},[_c('div',{staticClass:"copyright text-center mx-auto"},[_c('img',{attrs:{"src":__webpack_require__(25),"alt":"eshops-logo"}}),_vm._v(" "),_c('p',{staticClass:"m-f-text text-center mt-2"},[_vm._v("\n                © "+_vm._s(new Date().getFullYear())+" eshops.lk | All Rights Reserved\n              ")])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hamburger"},[_c('div')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"navbar-brand",attrs:{"href":"#"}},[_c('img',{attrs:{"src":__webpack_require__(13),"width":"50","height":"50","alt":"eshops-logo"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container mt-3 py-5"},[_c('div',{staticClass:"row col-md-8 col-lg-6 mx-auto"},[_c('h1',{staticClass:"text-center text-dark display-4 mx-auto mb-4",staticStyle:{"font-weight":"bold"}},[_vm._v("\n          We Develop Our Little Island Not just Businesses. Because It's Our\n          Country.\n        ")]),_vm._v(" "),_c('div',{staticClass:"mx-auto"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(13),"width":"240","height":"240","alt":"eshops.lk-logo"}})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row col-md-8 col-lg-6 mx-auto"},[_c('h1',{staticClass:"text-center text-dark display-4 mx-auto my-4",staticStyle:{"font-weight":"bold"}},[_vm._v("\n          We Are Here To Raise Our Nation On Modern Technology.\n        ")]),_vm._v(" "),_c('div',{staticClass:"mx-auto"},[_c('img',{staticClass:"img-fluid ml-3 text-center",attrs:{"src":__webpack_require__(533),"alt":"offing-logo"}}),_vm._v(" "),_c('h3',{staticClass:"text-center text-dark mx-auto my-2 pb-5",staticStyle:{"font-weight":"700"}},[_vm._v("\n            Offing Tech (Pvt Ltd)\n          ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h2',{staticClass:"text-center text-dark mx-auto mt-2 mb-3",staticStyle:{"font-weight":"800"}},[_vm._v("\n        Contact Us\n      ")]),_vm._v(" "),_c('div',{staticClass:"row col-md-8 col-lg-6 mx-auto"},[_c('div',{staticClass:"mx-auto text-center mb-4"},[_c('h5',{staticClass:"my-3"},[_c('i',{staticClass:"fa fa-phone fa-1x mr-2"}),_vm._v("0719 500 600\n          ")]),_vm._v(" "),_c('h5',{staticClass:"my-3"},[_c('i',{staticClass:"fa fa-envelope fa-1x mr-2"}),_vm._v("info@eshops.lk\n          ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-6 col-lg-4"},[_c('div',{staticClass:"block block-info"},[_c('h4',[_vm._v("Contact Us")]),_vm._v(" "),_c('ul',[_c('li',[_c('a',[_c('i',{staticClass:"fa fa-phone mr-2",attrs:{"aria-hidden":"true"}}),_vm._v("0719 500\n                    600")])]),_vm._v(" "),_c('li',[_c('a',[_c('i',{staticClass:"fa fa-envelope mr-2",attrs:{"aria-hidden":"true"}}),_vm._v("info@eshops.lk")])])]),_vm._v(" "),_c('ul',{staticClass:"social-media-icons mb-2 d-inline"},[_c('li',{},[_c('a',{staticClass:"px-0 ml-0 mr-2",attrs:{"href":"https://www.facebook.com/Eshopslk-2212428785713128/"}},[_c('i',{staticClass:"fa fa-facebook-official f-sm-link",staticStyle:{"font-size":"34px","color":"#3b5998","background-color":"#fff","width":"30px","height":"30px","border-radius":"4px","text-align":"center","vertical-align":"middle"}})])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"px-0 mx-2",attrs:{"href":"https://www.instagram.com/eshops.lk/"}},[_c('i',{staticClass:"fa fa-instagram f-sm-link",staticStyle:{"font-size":"30px","color":"#fff","background":"radial-gradient(","width":"32px","height":"32px","border-radius":"4px","text-align":"center","vertical-align":"middle"}})])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"px-0 mx-2",attrs:{"href":"https://www.youtube.com/channel/UCJhY3IfJD3T2bA5PJ3SrMZw"}},[_c('i',{staticClass:"fa fa-youtube-square f-sm-link",staticStyle:{"font-size":"35px","color":"#ff0000","background-color":"#fff","width":"30px","height":"30px","border-radius":"6px","text-align":"center","vertical-align":"middle"}})])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm col-md-8 col-lg-5"},[_c('div',{staticClass:"block-2 app-promotion"},[_c('a',[_c('img',{attrs:{"src":__webpack_require__(38),"alt":"mobile-icon"}})]),_vm._v(" "),_c('p',{staticClass:"m-f-text"},[_vm._v("\n                Tap the Add to Home Screen Tab in Chrome Browser on Android or\n                Safari Browser on IOS to Get the Splendid\n                "),_c('span',{staticStyle:{"color":"#fd6a02","font-size":"20px"}},[_vm._v("Mobile App")]),_vm._v("\n                Directly\n              ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/offing-logo.890d88f.png";

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsOfUse_vue__ = __webpack_require__(181);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ea452a7_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsOfUse_vue__ = __webpack_require__(536);
function injectStyle (ssrContext) {
  __webpack_require__(535)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1ea452a7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsOfUse_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ea452a7_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsOfUse_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 535 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',[_c('div',{staticClass:"outer-menu",staticStyle:{"z-index":"7777"}},[_c('input',{staticClass:"checkbox-toggle",attrs:{"type":"checkbox"}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"menu"},[_c('div',[_c('div',[_c('ul',[_c('li',[_c('router-link',{staticClass:"text-white",attrs:{"to":{ name: 'home' }}},[_vm._v("\n                    Home\n                  ")])],1),_vm._v(" "),_c('li',[(_vm.admin)?_c('router-link',{staticClass:"text-white",attrs:{"to":{ name: 'admin' }}},[_vm._v("\n                    Admin")]):_vm._e()],1),_vm._v(" "),_c('li',[(_vm.pageadmin)?_c('router-link',{staticClass:"text-white",attrs:{"to":{ name: 'admin-services' }}},[_vm._v("\n                    Admin")]):_vm._e()],1),_vm._v(" "),_c('li',[(_vm.visitor)?_c('router-link',{staticClass:"text-white",attrs:{"to":{ name: 'signin' }}},[_vm._v("\n                    Sign in")]):_vm._e()],1),_vm._v(" "),_c('li',[(_vm.visitor)?_c('router-link',{staticClass:"text-white",attrs:{"to":{ name: 'usersignup' }}},[_vm._v("\n                    Sign up")]):_vm._e()],1),_vm._v(" "),_c('li',[(_vm.user)?_c('router-link',{staticClass:"text-white",attrs:{"to":{ name: 'myaccount' }}},[_vm._v("\n                    My Account")]):_vm._e()],1),_vm._v(" "),_c('li',[(_vm.user || _vm.admin || _vm.pageadmin)?_c('a',{staticClass:"text-white",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.logout()}}},[_vm._v("\n                    Sign out")]):_vm._e()])])])])])])]),_vm._v(" "),_c('div',{},[_c('section',[_c('nav',{staticClass:"navbar",staticStyle:{"background-color":"#180000"}},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"d-nav"},[_c('router-link',{staticClass:"text-white mr-5",attrs:{"to":{ name: 'home' }}},[_vm._v("\n              Home\n            ")]),_vm._v(" "),(_vm.admin)?_c('router-link',{staticClass:"m-link text-white mr-5",attrs:{"to":{ name: 'admin' }}},[_vm._v("Admin")]):_vm._e(),_vm._v(" "),(_vm.pageadmin)?_c('router-link',{staticClass:"m-link text-white mr-5",attrs:{"to":{ name: 'admin-services' }}},[_vm._v("Admin")]):_vm._e(),_vm._v(" "),(_vm.visitor)?_c('router-link',{staticClass:"m-link text-white mr-5",attrs:{"to":{ name: 'signin' }}},[_vm._v("Sign in")]):_vm._e(),_vm._v(" "),(_vm.visitor)?_c('router-link',{staticClass:"m-link text-white mr-5",attrs:{"to":{ name: 'usersignup' }}},[_vm._v("Sign up")]):_vm._e(),_vm._v(" "),(_vm.user)?_c('router-link',{staticClass:"m-link text-white mr-5",attrs:{"to":{ name: 'myaccount' }}},[_vm._v("My Account")]):_vm._e(),_vm._v(" "),(_vm.user || _vm.admin || _vm.pageadmin)?_c('a',{staticClass:"text-white mr-5",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.logout()}}},[_vm._v("Sign out")]):_vm._e()],1)])])]),_vm._v(" "),_c('div',{staticClass:"container mt-3 py-5"},[_c('div',{staticClass:"row col-md-8 mx-auto"},[_c('h3',{staticClass:"text-center text-info mx-auto mb-4"},[_vm._v("TERMS OF USE")]),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_vm._v("\n          Welcome to www.eshops.lk. Thanks for stopping by. These Terms of Use,\n          the\n          "),_c('router-link',{staticClass:"text-primary",attrs:{"to":{ name: 'privacypolicy' }}},[_vm._v("Privacy Policy")]),_vm._v(", and all policies posted on our site set out the terms on which we\n          offer you access to and use of our site, services, applications and\n          tools. You can find an overview of our policies here. You agree to\n          comply with the full Terms of Use when accessing or using our\n          Services. The Terms of Use set out below take effect from 28 AUG 2018\n        ")],1),_vm._v(" "),_c('p'),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('p',[_vm._v("\n          To access and use some of the Services, you may need to register with\n          us and set up an account with your email address and a password (your\n          “Account”). The email address you register with will be your email\n          address, and you are solely responsible for maintaining the\n          confidentiality of your password. You are solely responsible for all\n          activities that happen under your Account.\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          You may connect to the Services with a third-party service (e.g.\n          Facebook or Google+) and you give us permission to access, store, and\n          use your information from that service as permitted by that service\n          and as may be described in our\n          "),_c('router-link',{staticClass:"text-primary",attrs:{"to":{ name: 'privacypolicy' }}},[_vm._v("Privacy Policy")]),_vm._v(". If you believe your Account has been compromised or misused,\n          contact us immediately at eshops.lk customer support.\n          "),_c('br')],1),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('p',[_vm._v("\n          To use the Services, you must be over 18 years old. You agree that you\n          will post in the appropriate category or area and you agree that you\n          will not do any of the following bad things:\n        ")]),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_c('p',[_vm._v("\n          eshops.lk and the eshops.lk community work together to keep the\n          Services working properly and the community safe. Please report\n          problems, offensive content and policy breaches to us using the\n          reporting system. You are solely responsible for all information that\n          you give to eshops.lk and any consequences that may result from your\n          posts. We can at our discretion refuse, delete or take down content\n          that we think is inappropriate or breaching these Terms of Use. We\n          also can at our discretion restrict a user’s usage of the Services\n          either temporarily or permanently, or refuse a user’s registration.\n          Without limiting other remedies, we may issue warnings, limit or\n          terminate our Services, remove hosted content and take technical and\n          legal steps to keep users off the Services if we think that they are\n          creating problems or acting inconsistently with the letter or spirit\n          of our policies. However, whether we take any of these steps, we don’t\n          accept any liability for monitoring the Services or for un-authorized\n          or unlawful content on the Services or use of the Services by users.\n          You also accept that eshops.lk is not under any obligation to monitor\n          any data or content which is submitted to or available on the\n          Services. ​​​\n        ")]),_vm._v(" "),_vm._m(8),_vm._v(" "),_c('p',[_vm._v("\n          We sometimes charge a fee for certain features or Services. If the\n          feature you use incurs a fee, you will be able to review and accept\n          that charge before purchase. Our fees are quoted in Sri Lankan rupees,\n          and we may sometimes change them. We’ll notify you of changes to our\n          fees by posting the changes on the site.\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          We may sometimes temporarily change our fees for testing purposes,\n          promotional events or new features, these changes take effect from the\n          time the price change is posted to the site. Our fees are\n          non-refundable after the feature is supplied, and you are responsible\n          for paying them when they are due. If you don’t, we may limit your\n          ability to use the Services. If your payment method fails or your\n          account is past due, we may collect fees owed using collection\n          mechanisms, including third party debt collection services.\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          You agree to provide accurate information necessary for eshops.lk to\n          comply with our obligations under applicable law. You are solely\n          responsible for collecting and remitting any applicable taxes\n          resulting from the sale of your items or services listed on\n          eshops.lk’s Services.\n        ")]),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11),_vm._v(" "),_vm._m(12),_vm._v(" "),_c('p',[_vm._v("\n          eshops.lk’s Services contain content from us, you, and other users.\n          eshops.lk is protected by copyright laws and international treaties.\n          Content displayed on or via the Services is protected as a collective\n          work and/or compilation, pursuant to copyrights laws and international\n          conventions. You agree not to copy, distribute the Services or modify\n          content from the Services, our trademarks or copyrights without our\n          express written consent. You may not disassemble or decompile, reverse\n          engineer or otherwise attempt to discover any source code contained in\n          the Services. Without limiting the foregoing, you agree not to\n          reproduce, copy, sell, resell, or exploit for any purposes any aspect\n          of the Services (other than your own content).\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          When you give us content, including pictures, you grant us and\n          represent that you have the right to grant us, a non-exclusive,\n          worldwide, perpetual, irrevocable, royalty-free, sub-licensable\n          (through multiple tiers) right to exercise any and all copyright,\n          publicity, trademarks, design, database and intellectual property\n          rights to that content, in any media whether now known or to be\n          discovered in the future, including third party sites and\n          applications. You also waive all moral rights you have in the content\n          to the fullest extent permitted by law. We reserve the right to remove\n          content where we have grounds for suspecting the violation of these\n          terms or the rights of any other party\n        ")]),_vm._v(" "),_vm._m(13),_vm._v(" "),_vm._m(14),_vm._v(" "),_vm._m(15),_vm._v(" "),_vm._m(16),_vm._v(" "),_vm._m(17),_vm._v(" "),_vm._m(18),_vm._v(" "),_c('p',[_vm._v("\n          You may use the PayPal payment gateway for some financial transactions\n          on our Services. When you link your PayPal account to your Account,\n          you can use your PayPal account to pay or be paid for items by buyers\n          or sellers while using eshops.lk’s Services. You acknowledge and agree\n          that by utilizing any third party services through our Services (such\n          as PayPal), you are bound by the terms and conditions of that third\n          party and we are not liable for any loss, claims or damages howsoever\n          arising in connection with that third party’s services.\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          If you to link your PayPal account to your Account you appoint\n          eshops.lk as your limited agent to:\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          a. provide to PayPal your name, address, payment amount, item details,\n          item category, and all other information required by PayPal to enable\n          PayPal to process payments to or from your PayPal account , and\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          b. receive payment confirmation and decline notices from PayPal in\n          respect of your PayPal payment transactions.\n        ")]),_vm._v(" "),_vm._m(19),_vm._v(" "),_c('p',[_vm._v("\n          eshops.lk is not able to access your complete financial details from\n          PayPal or your PayPal account. At no time does eshops.lk hold any of\n          the funds when a buyer pays a seller using PayPal. Funds are\n          transferred directly by PayPal from the buyer’s PayPal account to the\n          seller’s PayPal account after the deduction by PayPal of any relevant\n          PayPal fees. PayPal's terms and conditions apply to your use of PayPal\n          when you access PayPal’s services from our Services, and you must\n          agree to PayPal’s terms and conditions in order to use the PayPal’s\n          services.\n        ")]),_vm._v(" "),_vm._m(20),_vm._v(" "),_vm._m(21),_vm._v(" "),_vm._m(22),_vm._v(" "),_vm._m(23),_vm._v(" "),_vm._m(24),_vm._v(" "),_vm._m(25),_vm._v(" "),_vm._m(26),_vm._v(" "),_vm._m(27),_vm._v(" "),_c('p',[_vm._v("\n          You acknowledge and agree that you have the opportunity to obtain\n          independent legal and financial advice from appropriately qualified\n          professional advisers and that you take into account your personal\n          objectives, financial situation and needs before buying or selling an\n          item via our Services.\n        ")]),_vm._v(" "),_vm._m(28),_vm._v(" "),_vm._m(29),_vm._v(" "),_vm._m(30),_vm._v(" "),_vm._m(31),_vm._v(" "),_c('p',[_vm._v("\n          Services are provided “as is” and “as available”. You agree not to\n          hold us responsible for things other users post or do. As most of the\n          content on the Services comes from other users, we do not guarantee\n          the accuracy of postings or user communications or the quality,\n          safety, or legality of what is offered.\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          We also cannot guarantee continuous or secure access to our Services.\n          While we will use reasonable efforts to maintain an uninterrupted\n          service, we cannot guarantee this and, to the extent permitted by law,\n          we do not give any promises or warranties (whether express or implied)\n          about the availability of our Services or that the Services will be\n          uninterrupted or error-free.\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          Notification functionality in the Services may not occur in real time.\n          That functionality is subject to delays beyond our control, including\n          without limitation, delays or latency due to your physical location or\n          your wireless data service provider’s network. To the extent permitted\n          by law, we are not liable for the posting of any unlawful,\n          threatening, abusive, defamatory, obscene or indecent information, or\n          material of any kind by a user of the Service which violates or\n          infringes upon your rights, including without limitation any\n          transmissions constituting or encouraging conduct that would\n          constitute a criminal offense, give rise to civil liability or\n          otherwise violate any applicable law.\n        ")]),_vm._v(" "),_vm._m(32),_vm._v(" "),_vm._m(33),_vm._v(" "),_vm._m(34),_vm._v(" "),_c('p',[_vm._v("\n          You will indemnify and hold harmless eshops.lk and our affiliates and,\n          our and their respective officers, directors, agents and employees\n          (each an “Indemnified Party”), from any claim made by any third party,\n          together with any amounts payable to the third party whether in\n          settlement or as may otherwise be awarded, and reasonable legal costs\n          incurred by any of the Indemnified Parties, arising from or relating\n          to your use of the Services, any alleged violation by you of the\n          applicable terms, and any alleged violation by you of any applicable\n          law or regulation. We reserve the right, at our own expense, to assume\n          the exclusive defense and control of any matter subject to\n          indemnification by you, but doing so will not excuse your indemnity\n          obligations.\n        ")]),_vm._v(" "),_vm._m(35),_vm._v(" "),_c('p',[_vm._v("\n          If you have a dispute with one or more eshops.lk users, you release us\n          (and our officers, directors, agents, subsidiaries, joint ventures and\n          employees) from any and all claims, demands and damages (actual and\n          consequential) of every kind and nature, known or unknown, arising out\n          of or in any way connected with such disputes.\n        ")]),_vm._v(" "),_vm._m(36),_vm._v(" "),_vm._m(37),_vm._v(" "),_vm._m(38),_vm._v(" "),_c('p',[_vm._v("\n          If a provision of these Terms of Use is illegal or unenforceable in\n          any relevant jurisdiction, it may be severed for the purposes of that\n          jurisdiction without affecting the enforceability of the other\n          provisions of these Terms of Use.\n        ")]),_vm._v(" "),_vm._m(39),_vm._v(" "),_c('p',[_vm._v("\n          These Terms of Use and the other policies posted on the Services set\n          out the entire agreement between eshops.lk and you, overriding any\n          prior agreements. From 28 AUG 2018, this agreement is governed by the\n          laws of Sri Lanka.\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          We both submit to the non-exclusive jurisdiction of the courts of Sri\n          Lanka. If we don’t enforce any particular provision, we are not\n          waiving our right to do so later. If a court strikes down any of these\n          Terms of Use, the remaining terms will survive.\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          We may, automatically assign this agreement in our sole discretion in\n          accordance with the notice provision below (our assignment to an\n          affiliate will not require notice). Except for notices about illegal\n          or infringing content, your notices to us must be sent by registered\n          mail.\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          We will send notices to you via the email address you provide, or by\n          registered mail. Notices sent by registered mail will be deemed\n          received five days following the date of mailing.\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          We may update this agreement at any time, with updates taking effect\n          when you next use the site or after 30 days, whichever is sooner. No\n          other amendment to this agreement will be effective unless made in\n          writing, signed by you and by us.\n        ")]),_vm._v(" "),_vm._m(40),_vm._v(" "),_c('p',[_vm._v("\n          If you’re accessing eshops.lk Services from a mobile device using a\n          eshops.lk Mobile Application (the “Application”), the following terms\n          and conditions apply to you in addition to the applicable Mobile\n          Privacy and Legal Notice or End User License Agreement, as the case\n          may be. Your use of the Application confirms your agreement to these\n          Mobile Devices Terms.\n        ")]),_vm._v(" "),_vm._m(41),_vm._v(" "),_c('p',[_vm._v("\n          eshops.lk grants you the right to use the Application only for your\n          personal use. You must comply with all applicable laws and third party\n          terms of agreement when using the Application (e.g. your wireless data\n          service agreement). The Application may not contain the same\n          functionality available on the www.eshops.lk.com Website. Your\n          download and use of the Application is at your own discretion and\n          risk, and you are solely responsible for any damages to your hardware\n          device(s) or loss of data that result from the download or use of the\n          Application.\n        ")]),_vm._v(" "),_vm._m(42),_vm._v(" "),_vm._m(43),_vm._v(" "),_vm._m(44),_vm._v(" "),_c('p',[_vm._v("\n          Additional terms and conditions that apply to you based on the mobile\n          device the Application is installed on\n        ")]),_vm._v(" "),_vm._m(45),_vm._v(" "),_vm._m(46),_vm._v(" "),_c('p',[_vm._v("\n          1. These Mobile Devices Terms are an agreement between you and\n          Gumtree, and not with Apple. Apple is not responsible for the\n          Application and the content thereof.\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          2. Gumtree grants you the right to use the Application only on an iOS\n          product that you own or control and as permitted by the Usage Rules\n          set forth in the App Store Terms of Service.\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          3. Apple has no obligation whatsoever to furnish any maintenance and\n          support services with respect to the Application.\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          4. Apple is not responsible for the investigation, defense,\n          settlement, and discharge of any third party intellectual property\n          infringement claim.\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          5. Apple is not responsible for addressing any claims by you or any\n          third party relating to the Application or your possession and/or use\n          of the Application, including but not limited to\n        ")]),_vm._v(" "),_c('p',[_vm._v("(a) Product liability claims")]),_vm._v(" "),_c('p',[_vm._v("\n          (b) Any claim that the Application fails to conform to any applicable\n          legal or regulatory requirement\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          (c) claims arising under consumer protection or similar legislation.\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          6. In the event of any failure of the Application to conform to any\n          applicable warranty, you may notify Apple, and Apple will refund the\n          purchase price, if applicable, for the Application to you; and to the\n          maximum extent permitted by applicable law, Apple will have no other\n          warranty obligation whatsoever with respect to the Application.\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          7. Apple and Apple’s subsidiaries are third party beneficiaries of\n          these Mobile Devices Terms, and, upon your acceptance, Apple as a\n          third party beneficiary thereof will have the right (and will be\n          deemed to have accepted the right) to enforce these Mobile Devices\n          Terms against you.\n        ")]),_vm._v(" "),_vm._m(47),_vm._v(" "),_vm._m(48),_vm._v(" "),_c('p',[_vm._v("\n          1. These Mobile Devices Terms are an agreement between you and\n          eshops.lk, not Microsoft. The terms of use and privacy policies of\n          Microsoft and, where applicable, the network operators that provide\n          billing services for the Windows Phone Marketplace do not apply to\n          your use of the Application.\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          2. You may install and use one (1) copy of the Application on up to\n          five (5) devices you personally own or control and which are\n          affiliated with the Windows Live ID associated with your Windows\n          Marketplace account. You may not install or use a copy of the\n          Application on a device you do not own or control.\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          3. Microsoft, your device manufacturer, and (if applicable) your\n          wireless carrier are not responsible for providing support services\n          for the Application.\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          4. Microsoft, the wireless carriers over whose network the Application\n          is distributed (if applicable), and each of their respective\n          affiliates and suppliers (collectively, “Disclaiming Distributors”)\n          give no express warranty, guarantee, or conditions under or in\n          relation to the Application. To the extent permitted under your local\n          laws, the Disclaiming Distributors exclude any implied warranties or\n          conditions, including those of merchantability, fitness for a\n          particular purpose, and non-infringement.\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          5. You, and not the Disclaiming Distributors, bear the risk of using\n          the Application (even if the Disclaiming Distributors have been\n          advised of the possibility of damages to you). You may have additional\n          consumer rights under your local laws which these Mobile Devices Terms\n          cannot change.\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          6. To the extent not prohibited by law, you will not seek to recover\n          any consequential, lost profit, special, indirect, or incidental\n          damages from any Disclaiming Distributor.\n        ")])])]),_vm._v(" "),_c('footer',{staticClass:"footer section section-sm"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-around"},[_c('div',{staticClass:"col-sm-6 col-lg-3"},[_c('div',{staticClass:"block block-link"},[_c('h4',[_vm._v("Site Pages")]),_vm._v(" "),_c('ul',[_c('li',{staticClass:"px-0"},[_c('router-link',{attrs:{"to":{ name: 'home' }}},[_vm._v("Home")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'about' }}},[_vm._v("About Us")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'termsofuse' }}},[_vm._v("Terms of Use")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'privacypolicy' }}},[_vm._v("Privacy Policy")])],1)])])]),_vm._v(" "),_vm._m(49),_vm._v(" "),_vm._m(50)])])]),_vm._v(" "),_c('footer',{staticClass:"footer-bottom"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 mx-auto mt-5"},[_c('div',{staticClass:"copyright text-center mx-auto"},[_c('img',{attrs:{"src":__webpack_require__(25),"alt":"eshops-logo"}}),_vm._v(" "),_c('p',{staticClass:"m-f-text text-center mt-2"},[_vm._v("\n                © "+_vm._s(new Date().getFullYear())+" eshops.lk | All Rights Reserved\n              ")])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hamburger"},[_c('div')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"navbar-brand",attrs:{"href":"#"}},[_c('img',{attrs:{"src":__webpack_require__(13),"width":"50","height":"50","alt":"eshops-logo"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{attrs:{"align":"center"}},[_vm._v("\n          Effective from 28 AUG 2018, the Services, as defined below will be\n          provided to you by eshops.lk, the company currently providing the site\n          to you. eshops.lk will also be the applicable data controller from 15\n          OCT 2018.\n          "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("eshops.lk Terms of Use")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{attrs:{"align":"center"}},[_c('strong',[_vm._v("Introduction")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('br'),_vm._v(" "),_c('strong',[_vm._v("1. ")]),_vm._v(" "),_c('strong',[_vm._v("Your Account")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v(" 2.")]),_vm._v(" "),_c('strong',[_vm._v("Using eshops.lk. ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"prv-ul"},[_c('p'),_c('li',[_vm._v("Violate any laws or the posting rules.")]),_vm._v(" "),_c('p'),_vm._v(" "),_c('p'),_c('li',[_vm._v("\n              any threatening, abusive, defamatory, obscene or indecent\n              material;\n            ")]),_vm._v(" "),_c('p'),_vm._v(" "),_c('p'),_c('li',[_vm._v("be false or misleading;")]),_vm._v(" "),_c('p'),_vm._v(" "),_c('p'),_c('li',[_vm._v("infringe any third-party right;")]),_vm._v(" "),_c('p'),_vm._v(" "),_c('p'),_c('li',[_vm._v("\n              distribute or send communications that contain spam, chain\n              letters, or pyramid schemes;\n            ")]),_vm._v(" "),_c('p'),_vm._v(" "),_c('p'),_c('li',[_vm._v("\n              distribute viruses or any other technologies that may harm\n              eshops.lk, the Services or the interests or property of eshops.lk\n              users;\n            ")]),_vm._v(" "),_c('p'),_vm._v(" "),_c('p'),_c('li',[_vm._v("\n              impose an unreasonable load on our infrastructure or interfere\n              with the proper working of the Services;\n            ")]),_vm._v(" "),_c('p'),_vm._v(" "),_c('p'),_c('li',[_vm._v("\n              copy, modify, or distribute any other person’s content without\n              their consent;\n            ")]),_vm._v(" "),_c('p'),_vm._v(" "),_c('p'),_c('li',[_vm._v("\n              use any robot spider, scraper or other means to access the\n              Services and collect content for any purpose without our express\n              written permission;\n            ")]),_vm._v(" "),_c('p'),_vm._v(" "),_c('p'),_c('li',[_vm._v("\n              harvest or otherwise collect information about others, including\n              email addresses, without their consent; and/or\n            ")]),_vm._v(" "),_c('p'),_vm._v(" "),_c('p'),_c('li',[_vm._v("\n              Bypass measures used to prevent or restrict access to the\n              Services.\n            ")]),_vm._v(" "),_c('p')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{},[_c('strong',[_vm._v("3. ")]),_vm._v(" "),_c('strong',[_vm._v("Abusing eshops.lk Services")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("4.")]),_vm._v(" "),_c('strong',[_vm._v("Fees and Services.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("5. ")]),_vm._v(" "),_c('strong',[_vm._v("Content")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("6. ")]),_vm._v(" "),_c('strong',[_vm._v("\n            Reporting Intellectual Property Infringements (Verified Rights\n            Owners)\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong'),_vm._v("\n          Do not post content that infringes the rights of third parties. This\n          includes, but is not limited to, content that infringes on\n          intellectual property rights such as copyright and trademark (e.g.\n          offering counterfeit items for sale). We can remove content where we\n          have grounds for suspecting the violation of these terms, our policies\n          or of any party’s rights. If you have a good faith belief that a\n          listing on any of the Services infringes your copyright, trademark, or\n          other intellectual property rights, all you need to do is contact the\n          customer service of eshops.lk. Only the intellectual property rights\n          owner can report potentially infringing items or listings through\n          eshops.lk’s VERO Program. After we receive your first notice,\n          eshops.lk will confirm your enrolment in our program and send you the\n          instructions on how to submit future reports electronically. We can\n          share and discuss, in accordance with applicable law, the investigated\n          issue with the third party that originally posted the potentially\n          infringing listing.\n        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("7. ")]),_vm._v(" "),_c('strong',[_vm._v("Third Party services on eshops.lk")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('br'),_vm._v("\n          When you link your PayPal account to your eshops.lk Account, we accept\n          our appointment as your limited agent to undertake those activities\n          specified in the paragraph above. Our appointment as your agent to\n          undertake these activities terminates immediately upon your Account\n          ceasing to be linked to your PayPal account.\n          "),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n          You acknowledge and agree that, to the extent permitted by law, we are\n          not liable to you for any loss or damage you incur arising from your\n          use of the PayPal method, unless such loss or damage was as a direct\n          result of eshops.lk’s error, in which case our liability is limited in\n          accordance with.\n          "),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v(" 8. ")]),_c('strong',[_vm._v("Legal and Financial Advice")]),_vm._v(".")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n          You acknowledge and agree that the information provided by eshops.lk\n          in relation to using PayPal’s services is factual in nature only and\n          eshops.lk has not provided a recommendation or statement of opinion\n          intended to influence your decision on whether or not to use PayPal’s\n          services and that you cannot rely on any of eshops.lk’s advertising\n          materials, terms, instructions or policies as a recommendation,\n          statement of opinion or financial product advice.\n          "),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("9. ")]),_vm._v(" "),_c('strong',[_vm._v("Limitation of Liability. ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong'),_vm._v("\n          Nothing in these Terms of Use excludes, restricts or modifies any\n          rights or statutory guarantees that you may have under applicable laws\n          that cannot be excluded, restricted or modified, including any such\n          rights or statutory guarantees under the applicable Consumer Laws. To\n          the extent that these Terms of Use are found to exclude, restrict or\n          modify any such rights or statutory guarantees, those rights and/or\n          statutory guarantees prevail to the extent of the inconsistency.\n        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n          eshops.lk excludes any liability to you for any loss or damage\n          suffered by you as a result of using eshops.lk if the loss or damage\n          was not reasonably foreseeable and was not directly cased by\n          eshops.lk.\n          "),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("10. ")]),_vm._v(" "),_c('strong',[_vm._v("Indemnification")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("11. ")]),_vm._v(" "),_c('strong',[_vm._v("Release ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("12. ")]),_vm._v(" "),_c('strong',[_vm._v("Personal Information")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong'),_vm._v("\n          By using the Services, you agree to the collection, transfer, storage\n          and use of your personal information by us (the “data controller”) on\n          our servers.\n        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("13. ")]),_vm._v(" "),_c('strong',[_vm._v("Severability")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("14. ")]),_vm._v(" "),_c('strong',[_vm._v("General")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("15. ")]),_vm._v(" "),_c('strong',[_vm._v("Mobile Devices Terms")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("a. "),_c('strong',[_vm._v("Application Use")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("b. "),_c('strong',[_vm._v("Intellectual Property – Applications")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong'),_vm._v("\n          eshops.lk owns, or is the licensee to, all right, title, and interest\n          in and to its Applications, including all rights under patent,\n          copyright, trade secret, trademark, and any and all other proprietary\n          rights, including all applications, renewals, extensions, and\n          restorations thereof. You will not modify, adapt, translate, prepare\n          derivative works from, decompile, reverse-engineer, disassemble, or\n          otherwise attempt to derive source code from any Application and you\n          will not remove, obscure, or alter eshops.lk’s copyright notice,\n          trademarks or other proprietary rights notices affixed to, contained\n          within, or accessed in conjunction with or by any eshops.lk\n          Application.\n        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("16.")]),_vm._v(" "),_c('strong',[_vm._v("Additional Terms. ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('br'),_vm._v(" "),_c('li',{staticClass:"prv-li"},[_c('strong',[_vm._v("iOS – Apple")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',{staticClass:"prv-li"},[_c('strong',[_vm._v("Windows – Microsoft")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-6 col-lg-4"},[_c('div',{staticClass:"block block-info"},[_c('h4',[_vm._v("Contact Us")]),_vm._v(" "),_c('ul',[_c('li',[_c('a',[_c('i',{staticClass:"fa fa-phone mr-2",attrs:{"aria-hidden":"true"}}),_vm._v("0719 500\n                    600")])]),_vm._v(" "),_c('li',[_c('a',[_c('i',{staticClass:"fa fa-envelope mr-2",attrs:{"aria-hidden":"true"}}),_vm._v("info@eshops.lk")])])]),_vm._v(" "),_c('ul',{staticClass:"social-media-icons mb-2 d-inline"},[_c('li',{},[_c('a',{staticClass:"px-0 ml-0 mr-2",attrs:{"href":"https://www.facebook.com/Eshopslk-2212428785713128/"}},[_c('i',{staticClass:"fa fa-facebook-official f-sm-link",staticStyle:{"font-size":"34px","color":"#3b5998","background-color":"#fff","width":"30px","height":"30px","border-radius":"4px","text-align":"center","vertical-align":"middle"}})])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"px-0 mx-2",attrs:{"href":"https://www.instagram.com/eshops.lk/"}},[_c('i',{staticClass:"fa fa-instagram f-sm-link",staticStyle:{"font-size":"30px","color":"#fff","background":"radial-gradient(","width":"32px","height":"32px","border-radius":"4px","text-align":"center","vertical-align":"middle"}})])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"px-0 mx-2",attrs:{"href":"https://www.youtube.com/channel/UCJhY3IfJD3T2bA5PJ3SrMZw"}},[_c('i',{staticClass:"fa fa-youtube-square f-sm-link",staticStyle:{"font-size":"35px","color":"#ff0000","background-color":"#fff","width":"30px","height":"30px","border-radius":"6px","text-align":"center","vertical-align":"middle"}})])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm col-md-8 col-lg-5"},[_c('div',{staticClass:"block-2 app-promotion"},[_c('a',[_c('img',{attrs:{"src":__webpack_require__(38),"alt":"mobile-icon"}})]),_vm._v(" "),_c('p',{staticClass:"m-f-text"},[_vm._v("\n                Tap the Add to Home Screen Tab in Chrome Browser on Android or\n                Safari Browser on IOS to Get the Splendid\n                "),_c('span',{staticStyle:{"color":"#fd6a02","font-size":"20px"}},[_vm._v("Mobile App")]),_vm._v("\n                Directly\n              ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicy_vue__ = __webpack_require__(182);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8a07f4f2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicy_vue__ = __webpack_require__(539);
function injectStyle (ssrContext) {
  __webpack_require__(538)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8a07f4f2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8a07f4f2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 538 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',[_c('div',{staticClass:"outer-menu",staticStyle:{"z-index":"7777"}},[_c('input',{staticClass:"checkbox-toggle",attrs:{"type":"checkbox"}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"menu"},[_c('div',[_c('div',[_c('ul',[_c('li',[_c('router-link',{staticClass:"text-white",attrs:{"to":{ name: 'home' }}},[_vm._v("\n                    Home\n                  ")])],1),_vm._v(" "),_c('li',[(_vm.admin)?_c('router-link',{staticClass:"text-white",attrs:{"to":{ name: 'admin' }}},[_vm._v("\n                    Admin")]):_vm._e()],1),_vm._v(" "),_c('li',[(_vm.pageadmin)?_c('router-link',{staticClass:"text-white",attrs:{"to":{ name: 'admin-services' }}},[_vm._v("\n                    Admin")]):_vm._e()],1),_vm._v(" "),_c('li',[(_vm.visitor)?_c('router-link',{staticClass:"text-white",attrs:{"to":{ name: 'signin' }}},[_vm._v("\n                    Sign in")]):_vm._e()],1),_vm._v(" "),_c('li',[(_vm.visitor)?_c('router-link',{staticClass:"text-white",attrs:{"to":{ name: 'usersignup' }}},[_vm._v("\n                    Sign up")]):_vm._e()],1),_vm._v(" "),_c('li',[(_vm.user)?_c('router-link',{staticClass:"text-white",attrs:{"to":{ name: 'myaccount' }}},[_vm._v("\n                    My Account")]):_vm._e()],1),_vm._v(" "),_c('li',[(_vm.user || _vm.admin || _vm.pageadmin)?_c('a',{staticClass:"text-white",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.logout()}}},[_vm._v("\n                    Sign out")]):_vm._e()])])])])])])]),_vm._v(" "),_c('div',{},[_c('section',[_c('nav',{staticClass:"navbar",staticStyle:{"background-color":"#180000"}},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"d-nav"},[_c('router-link',{staticClass:"text-white mr-5",attrs:{"to":{ name: 'home' }}},[_vm._v("\n              Home\n            ")]),_vm._v(" "),(_vm.admin)?_c('router-link',{staticClass:"m-link text-white mr-5",attrs:{"to":{ name: 'admin' }}},[_vm._v("Admin")]):_vm._e(),_vm._v(" "),(_vm.pageadmin)?_c('router-link',{staticClass:"m-link text-white mr-5",attrs:{"to":{ name: 'admin-services' }}},[_vm._v("Admin")]):_vm._e(),_vm._v(" "),(_vm.visitor)?_c('router-link',{staticClass:"m-link text-white mr-5",attrs:{"to":{ name: 'signin' }}},[_vm._v("Sign in")]):_vm._e(),_vm._v(" "),(_vm.visitor)?_c('router-link',{staticClass:"m-link text-white mr-5",attrs:{"to":{ name: 'usersignup' }}},[_vm._v("Sign up")]):_vm._e(),_vm._v(" "),(_vm.user)?_c('router-link',{staticClass:"m-link text-white mr-5",attrs:{"to":{ name: 'myaccount' }}},[_vm._v("My Account")]):_vm._e(),_vm._v(" "),(_vm.user || _vm.admin || _vm.pageadmin)?_c('a',{staticClass:"text-white mr-5",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.logout()}}},[_vm._v("Sign out")]):_vm._e()],1)])])]),_vm._v(" "),_c('div',{staticClass:"container mt-3 py-5 prv-ul"},[_c('div',{staticClass:"row col-md-8 mx-auto"},[_vm._m(2),_vm._v("\n        Effective as at: 15 OCT 2018\n        "),_c('br'),_vm._v(" "),_c('div'),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('p'),_vm._v(" "),_c('p',[_vm._v("\n          It applies to this Site and to any Services where this Privacy Notice\n          is referenced.\n          "),_c('br'),_vm._v("\n          By using our Services and/or registering for an account, you are\n          accepting the terms of this Privacy Notice and our\n          "),_c('router-link',{staticClass:"text-primary",attrs:{"to":{ name: 'termsofuse' }}},[_vm._v("Terms of Use")]),_vm._v(".\n        ")],1),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_c('p',[_vm._v("\n          The Privacy Notice applies to this Site and to any applications,\n          services or tools (collectively “Services”) where this Privacy Notice\n          is referenced. By using our Services and/or registering for an\n          account, you are accepting the terms of this Privacy Notice and our\n          "),_c('router-link',{staticClass:"text-primary",attrs:{"to":{ name: 'termsofuse' }}},[_vm._v("Terms of Use")])],1),_vm._v(" "),_vm._m(8),_vm._v(" "),_c('p',[_vm._v("\n          We collect, process and retain personal information from you and any\n          devices (including mobile devices) you use when you: register for an\n          account with us, use our Services, give us information on a web form,\n          update or add information to your account, join community discussions,\n          chats or dispute resolution or when you otherwise contact us.\n        ")]),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11),_vm._v(" "),_vm._m(12),_vm._v(" "),_vm._m(13),_vm._v(" "),_vm._m(14),_vm._v(" "),_vm._m(15),_vm._v(" "),_vm._m(16),_vm._v(" "),_vm._m(17),_vm._v(" "),_vm._m(18),_vm._v(" "),_vm._m(19),_vm._v(" "),_vm._m(20),_vm._v(" "),_vm._m(21),_vm._v(" "),_vm._m(22),_vm._v(" "),_c('p',[_vm._v("\n          You can see, review and change your personal information by signing in\n          to your account. Please update your personal information immediately\n          if it changes or is inaccurate.\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          Once you make a public posting, you may not be able to change or\n          remove it. If you ask us to, we will close your account and remove\n          your personal information from view as soon as reasonably possible,\n          based on your account activity and as required under applicable\n          national laws.\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          We will honor your right to request access to, or modification or\n          deletion of, your personal information. We may have the right to\n          withhold that access or refuse to modify or erase your personal\n          information under applicable national laws, but we will give you\n          reasons if we do so. To contact us about access and to find out if any\n          fees apply, please contact our customer service.\n        ")]),_vm._v(" "),_vm._m(23),_vm._v(" "),_vm._m(24),_vm._v(" "),_vm._m(25),_vm._v(" "),_vm._m(26),_vm._v(" "),_vm._m(27),_vm._v(" "),_c('p',[_vm._v("Your personal information allows us to:")]),_vm._v(" "),_vm._m(28),_vm._v(" "),_vm._m(29),_vm._v(" "),_c('ul',{attrs:{"type":"disc"}},[_c('li',[_vm._v("\n            To give you customer support about your account such as to\n            troubleshoot problems, to resolve a dispute, to collect fees or\n            monies owed to us, or to get your opinion through surveys\n          ")]),_vm._v(" "),_c('li',[_vm._v("\n            For other reasons such as to enforce our\n            "),_c('router-link',{staticClass:"text-primary",attrs:{"to":{ name: 'termsofuse' }}},[_vm._v("Terms of Use")]),_vm._v("\n            or policies and any other agreement we may have with you\n          ")],1)]),_vm._v(" "),_vm._m(30),_vm._v(" "),_vm._m(31),_vm._v(" "),_vm._m(32),_vm._v(" "),_vm._m(33),_vm._v(" "),_vm._m(34),_vm._v(" "),_vm._m(35),_vm._v(" "),_c('ul',{attrs:{"type":"disc"}},[_c('li',[_vm._v("\n            Prevent, detect, mitigate and investigate fraud, security breaches,\n            potentially prohibited or illegal activities\n          ")]),_vm._v(" "),_c('li',[_vm._v("\n            Enforce our Privacy Notice, our\n            "),_c('router-link',{staticClass:"text-primary",attrs:{"to":{ name: 'termsofuse' }}},[_vm._v("Terms of Use")]),_vm._v("\n            or other policies\n          ")],1)]),_vm._v(" "),_vm._m(36),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Retention of personal information:")]),_vm._v(" "),_c('br'),_vm._v("\n          If your account is active, we will keep your personal information as\n          long as we need it for our operations. We may also keep personal\n          information from closed accounts to comply with national laws, stop\n          fraud, collect fees owed, assist with any investigation, enforce our\n          "),_c('router-link',{staticClass:"text-primary",attrs:{"to":{ name: 'termsofuse' }}},[_vm._v("Terms of Use")]),_vm._v("\n          and take other actions under applicable national laws. If we no longer\n          need your personal information, we securely dispose of it.\n          "),_c('br'),_vm._v(" "),_c('br')],1),_vm._v(" "),_vm._m(37),_vm._v(" "),_c('p',[_vm._v("\n          We may share your personal information with other companies in our\n          group and third parties to provide you with our Services, to comply\n          with the law, to enforce our policies, to enable our marketing and\n          advertising activities, or to prevent, detect, mitigate and\n          investigate fraud or other illegal activities. We don’t give your\n          personal information to third parties for their marketing and\n          advertising purposes unless you give us permission.\n        ")]),_vm._v(" "),_vm._m(38),_vm._v(" "),_c('ul',{attrs:{"type":"disc"}},[_c('li',[_vm._v("\n            provide joint content and services (like registration, transactions\n            and customer support)\n          ")]),_vm._v(" "),_c('li',[_vm._v("\n            help detect and stop possible fraud and illegal acts, violations of\n            our\n            "),_c('router-link',{staticClass:"text-primary",attrs:{"to":{ name: 'termsofuse' }}},[_vm._v("Terms of Use")]),_vm._v("\n            and data security breaches\n          ")],1),_vm._v(" "),_c('li',[_vm._v("offer you personalized advertising")]),_vm._v(" "),_c('li',[_vm._v("\n            Guide decisions about their products, sites, applications, services,\n            tools and marketing communications. Other group companies will not\n            send you marketing communications unless you have consented to\n            receiving their communications\n          ")])]),_vm._v(" "),_vm._m(39),_vm._v(" "),_c('ul',{attrs:{"type":"disc"}},[_c('li',[_vm._v("\n            third party service providers who help us provide our Services,\n            payment processing services, assist us in providing customized\n            advertising, help us with the prevention, detection, mitigation and\n            investigation of potentially illegal acts, violations of our\n            "),_c('router-link',{staticClass:"text-primary",attrs:{"to":{ name: 'termsofuse' }}},[_vm._v("Terms of Use")]),_vm._v(", fraud and/or security breaches, bill collection, affiliate and\n            rewards programs and other business operations\n          ")],1)]),_vm._v(" "),_vm._m(40),_vm._v(" "),_vm._m(41),_vm._v(" "),_c('ul',{attrs:{"type":"disc"}},[_c('li',[_vm._v("\n            law enforcement or governmental agencies, or authorized\n            third-parties, in response to a verified request regarding a\n            criminal investigation, alleged or suspected illegal activity, or\n            any other activity that may expose us, you or any of our users to\n            legal risk\n          ")]),_vm._v(" "),_c('li',[_vm._v("\n            participants of the eshops.lk “Verified Rights Owners Program” under\n            confidentiality agreement, if we decide that it is necessary to\n            disclose that information in connection with an investigation of\n            fraud, intellectual property infringement, piracy or other unlawful\n            activity\n          ")]),_vm._v(" "),_c('li',[_vm._v("\n            credit agencies or bureaus as authorized by applicable national laws\n          ")]),_vm._v(" "),_c('li',[_vm._v("\n            third parties commencing, or involved in, a legal proceeding if they\n            provide us with a subpoena, court order or similar legal document\n          ")]),_vm._v(" "),_c('li',[_vm._v("\n            other third parties to comply with our legal requirements, enforce\n            our\n            "),_c('router-link',{staticClass:"text-primary",attrs:{"to":{ name: 'termsofuse' }}},[_vm._v("Terms of Use")]),_vm._v("\n            respond to claims that a listing or other content violates the\n            rights of others, or if we otherwise believe in good faith that the\n            disclosure is needed to prevent imminent physical harm, harm to\n            property, financial loss or to report suspected illegal activity\n          ")],1)]),_vm._v(" "),_vm._m(42),_vm._v(" "),_vm._m(43),_vm._v(" "),_c('p',[_vm._v("\n          · If you sign into your social network account using the same email\n          that you previously used to register for an account with us, you will\n          access your existing account with us.\n        ")]),_vm._v(" "),_vm._m(44),_vm._v(" "),_vm._m(45),_vm._v(" "),_vm._m(46),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(47),_vm._v(" "),_vm._m(48),_vm._v(" "),_vm._m(49),_vm._v(" "),_vm._m(50),_vm._v(" "),_vm._m(51),_vm._v(" "),_vm._m(52),_vm._v(" "),_vm._m(53),_vm._v(" "),_vm._m(54),_vm._v(" "),_vm._m(55),_vm._v(" "),_c('p',[_vm._v("\n          If you have a question or a complaint about this Privacy Notice or our\n          privacy practices, you can contact us.\n        ")])])]),_vm._v(" "),_c('footer',{staticClass:"footer section section-sm"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-around"},[_c('div',{staticClass:"col-sm-6 col-lg-3"},[_c('div',{staticClass:"block block-link"},[_c('h4',[_vm._v("Site Pages")]),_vm._v(" "),_c('ul',[_c('li',{staticClass:"px-0"},[_c('router-link',{attrs:{"to":{ name: 'home' }}},[_vm._v("Home")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'about' }}},[_vm._v("About Us")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'termsofuse' }}},[_vm._v("Terms of Use")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'privacypolicy' }}},[_vm._v("Privacy Policy")])],1)])])]),_vm._v(" "),_vm._m(56),_vm._v(" "),_vm._m(57)])])]),_vm._v(" "),_c('footer',{staticClass:"footer-bottom"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 mx-auto mt-5"},[_c('div',{staticClass:"copyright text-center mx-auto"},[_c('img',{attrs:{"src":__webpack_require__(25),"alt":"eshops-logo"}}),_vm._v(" "),_c('p',{staticClass:"m-f-text text-center mt-2"},[_vm._v("\n                © "+_vm._s(new Date().getFullYear())+" eshops.lk | All Rights Reserved\n              ")])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hamburger"},[_c('div')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"navbar-brand",attrs:{"href":"#"}},[_c('img',{attrs:{"src":__webpack_require__(13),"width":"50","height":"50","alt":"eshops-logo"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"text-center text-info mx-auto mb-4"},[_vm._v("\n          eshops.lk User Privacy Policy\n          "),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"block"}},[_c('ul',{staticStyle:{"display":"block"}},[_c('strong',{staticClass:"mb-2",staticStyle:{"display":"block"}},[_vm._v("This Privacy Notice describes:")]),_vm._v(" "),_c('li',[_vm._v("\n              the personal information we collect and how we use that\n              information\n            ")]),_vm._v(" "),_c('li',[_vm._v("when we might disclose your personal information; and")]),_vm._v(" "),_c('li',[_vm._v("how we keep and protect your personal information")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n          We use your personal information to: provide and improve our Services,\n          give you a personalized experience on our sites, contact you, provide\n          customer service, provide you with personalized advertising and\n          marketing, including marketing from third parties, and detect, prevent\n          and investigate fraud and/or other illegal activities.\n          "),_c('br'),_vm._v("\n          We keep personal information from active accounts as long as it is\n          needed for our operations. We also keep personal information from\n          closed accounts when we’re legally required to and also to stop fraud,\n          collect outstanding fees, troubleshoot problems, help with\n          investigations, enforce our Terms of Use and take other actions under\n          applicable national laws. If you do not provide the information we\n          require, we may not be able to provide all of our Services to you.\n          "),_c('br'),_vm._v("\n          eshops.lk is responsible for the collection, use, disclosure,\n          retention and protection of your personal information under global\n          standards and applicable national laws. eshops.lk may transfer data to\n          other members of our corporate network as described in this Privacy\n          Notice who may process and keep your personal information on their\n          servers.\n        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("What is Personal information?")]),_vm._v(" "),_c('br'),_vm._v("\n          “Personal information” is information that can be associated with a\n          specific person that could be used to identify that specific person,\n          either from the data directly or from that data combined with other\n          information that we have, or are likely to have, access to. Personal\n          information doesn’t include anonymous or aggregated information that\n          can no longer be used to identify a specific person.\n          "),_c('br'),_vm._v(" "),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("Public Information? ")]),_vm._v(" "),_c('br'),_vm._v("\n          Public information is any information, including personal information,\n          you share with a public audience, including personal information you\n          publish on our Site. Public information is available to anyone on or\n          off our Services and can be seen or accessed through online search\n          engines, APIs, and offline media, such as on TV.\n        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("1. ")]),_vm._v(" "),_c('strong',[_vm._v("scope and consent ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("2. ")]),_vm._v(" "),_c('strong',[_vm._v("Collection")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('br'),_vm._v(" "),_c('strong',[_vm._v("We collect information you give us including:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{attrs:{"type":"disc"}},[_c('li',[_c('strong',[_vm._v("When you register for an account: ")]),_vm._v("\n            Information such as your name, addresses, telephone numbers, email\n            addresses or user ID (where applicable) when you register for an\n            account with us\n          ")]),_vm._v(" "),_c('li',[_c('strong',[_vm._v("When we verify you or your account: ")]),_vm._v("\n            we may collect and process information (as permitted by law) to\n            authenticate you or your account, or to verify the information that\n            you provided to us\n          ")]),_vm._v(" "),_c('li',[_c('strong',[_vm._v("When you transact on or use our Services: ")]),_vm._v("\n            such as when you post an ad, reply to an ad, communicate with us or\n            other users, information you provide for the Services that you use\n            or during a transaction or other transaction-based content. We may\n            also collect your financial information (such as credit card or bank\n            account numbers) if you buy a feature from us or are required to pay\n            fees to us\n          ")]),_vm._v(" "),_c('li',[_c('strong',[_vm._v("When you engage with our community: ")]),_vm._v("\n            such as when you submit a web form or participate in community\n            discussions or chats\n          ")]),_vm._v(" "),_c('li',[_c('strong',[_vm._v("When you interact with your account: ")]),_vm._v("\n            such as updating or adding information to your account, adding items\n            to alerts lists and saving searches. Sometimes you may also give us\n            your age, gender, interests and favorites\n          ")]),_vm._v(" "),_c('li',[_c('strong',[_vm._v("When you contact us: ")]),_vm._v("\n            such as through a web form, chat or dispute resolution or when we\n            otherwise communicate with each other. We may also record our calls\n            with you (if we have your consent to do so)\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("\n            Your resume if you choose to submit it to advertisers on our site\n            for consideration We collect information automatically including:\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{attrs:{"type":"disc"}},[_c('li',[_c('strong',[_vm._v("\n              Information from the devices you use when interacting with us or\n              our Services\n            ")]),_vm._v("\n            such as device ID or unique user ID, device type, ID for advertising\n            and unique device token\n          ")]),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Information about your location")]),_vm._v("\n            such as geo-location\n          ")]),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Computer and connection information")]),_vm._v("\n            such as statistics on your page views, traffic to and from the\n            sites, referral URL, ad data, your IP address, your browsing history\n            and your web log information\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('br'),_vm._v(" "),_c('strong',[_vm._v("\n            We collect information using cookies, web beacons and similar\n            technologies including:\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{attrs:{"type":"disc"}},[_c('li',[_vm._v("\n            Information about the pages you view, the links you click and other\n            actions you take on our Services, or within our advertising or email\n            content. For more information about our use of these technologies\n            and how to control them, see our cookies policy.\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("Information we collect from other sources including:")]),_vm._v(" "),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{attrs:{"type":"disc"}},[_c('li',[_c('strong',[_vm._v("Information we get from third parties")]),_vm._v("\n            which we may use to supplement your account information. For\n            example, we may collect and use demographic information that is\n            publically available, additional contact information, credit check\n            information and information from credit bureaus, as allowed by\n            applicable national laws.\n          ")]),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Information from social media sites")]),_vm._v("\n            when you use those sites to register, share information or connect\n            to your account. Those sites may automatically give us access to\n            some personal information they hold about you (e.g., content you\n            viewed, content you liked, and information about the advertisements\n            you were shown or clicked on, etc.). If you give us access to any\n            account with video content, we may share your video viewing with, or\n            collect information about your video viewing from, third-party\n            social media sites for at least two years or until you withdraw\n            consent. You control the personal information we have access to\n            through your privacy settings on the social media site and the\n            permissions you give us when you grant us access. When you grant us\n            access to information held by social media sites you agree that we\n            may collect, use and retain it in accordance with this Privacy\n            Notice\n          ")]),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Information other users may provide about you")]),_vm._v("\n            . If another user gives us information about you, they must tell you\n            about our collection, use, disclose and retention policies before\n            giving us the information. They must also get your explicit consent\n            before giving us your information\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("3. "),_c('strong',[_vm._v("Access")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("4. ")]),_vm._v(" "),_c('strong',[_vm._v("Use and Retention")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("\n            We use your personal information to provide, improve and personalize\n            our Services\n          ")]),_vm._v(" "),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{attrs:{"type":"disc"}},[_c('li',[_vm._v("\n            Provide you with access to and use of our Services as well as access\n            to your history, internal messages and other features we may provide\n          ")]),_vm._v(" "),_c('li',[_vm._v("\n            Offer you site content that includes items and services that you may\n            like\n          ")]),_vm._v(" "),_c('li',[_vm._v("\n            Provide you with credit offers and opportunities on behalf of other\n            members of our corporate family and their financial institution\n            partners. However, we don’t share financial information without your\n            explicit consent\n          ")]),_vm._v(" "),_c('li',[_vm._v("Customize, measure and improve our Services")]),_vm._v(" "),_c('li',[_vm._v("\n            Provide other services requested by you as described when we collect\n            the information\n          ")]),_vm._v(" "),_c('li',[_vm._v("\n            To provide you with location-based services (such as advertising,\n            search results and other personalized content)\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("\n            We use your personal information to contact you about your account:\n          ")]),_vm._v(" "),_c('br'),_vm._v("\n          We may contact you via Messages, email, telephone, SMS messages or\n          postal mail:\n        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("\n            We use your personal information to personalize our advertising and\n            marketing, including to:\n          ")]),_vm._v(" "),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{attrs:{"type":"disc"}},[_c('li',[_vm._v("Personalize, measure and improve our advertising")]),_vm._v(" "),_c('li',[_vm._v("\n            Contact you, either via email, telephone, SMS text messages or\n            postal mail to offer you discounts and special promotions and to let\n            you know about our Services and those of our corporate family (if\n            you have consented to this contact). Message and data rates may\n            apply\n          ")]),_vm._v(" "),_c('li',[_vm._v("\n            Deliver targeted marketing, service updates and promotional offers\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("\n            We use your personal information for legal compliance reasons,\n            including to:\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("5. "),_c('strong',[_vm._v("Disclosure")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("We disclose your information to our cooperated partners")]),_vm._v(" "),_c('strong',[_vm._v("who may use it to:")]),_vm._v(" "),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("We may disclose your information to third-parties: ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{attrs:{"type":"disc"}},[_c('li',[_vm._v("\n            Third party financial institution partners who may offer financial\n            products to you, for them to provide joint content and services\n            (such as registration, transactions and customer support). These\n            third party financial institution partners will use your personal\n            information to send you marketing communications only if you have\n            requested their services\n          ")]),_vm._v(" "),_c('li',[_vm._v("\n            Other third parties when you have given consent to share your\n            information via eshops.lk\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("\n            We may disclose your information to law enforcement and other\n            parties in connection with the law, including:\n          ")]),_vm._v(" "),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n          6. "),_c('strong',[_vm._v("Change of ownership")]),_vm._v(" "),_c('br'),_vm._v("\n\n          if we were to merge with or be bought by another company, we may share\n          information with them in accordance with our global privacy standards.\n          The new combined entity would comply with this Privacy Notice. If your\n          personal information is to be collected, used, disclosed or retained\n          for any purposes not covered in this Privacy Notice, you will receive\n          advance notice of any changes to the processing of your personal\n          information.\n          "),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n          7. "),_c('strong',[_vm._v("Social login")]),_vm._v(" "),_c('br'),_vm._v("\n          When you use social login:\n          "),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{attrs:{"type":"disc"}},[_c('li',[_vm._v("\n            If you sign into your social network account using an email address\n            that we don’t recognize in our systems, a new account will be\n            created in our systems for you.\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n          You may use social login or regular sign in each time you login into\n          your account with us. If you use regular sign in but a password has\n          not been issued to you (because you registered through social login)\n          you need to get a password through the password reset flow.\n          "),_c('br'),_vm._v("\n          When you use social login the “keep me signed in” policies of the\n          social network provider apply. We do not control those policies. For\n          your safety we recommend that you:\n        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{attrs:{"type":"disc"}},[_c('li',[_vm._v("\n            Don’t use social login if you are accessing our Services using a\n            public or shared device\n          ")]),_vm._v(" "),_c('li',[_vm._v("\n            Visit your social network provider site to learn about their sign in\n            policies and your options\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("8. ")]),_vm._v(" "),_c('strong',[_vm._v("Unwanted or threatening email")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v("\n          we do not tolerate abuse of our Services. You do not have permission\n          to add other users to your mailing list, call or send SMS messages for\n          commercial purposes, even if a user bought something from you, unless\n          the user has given their explicit consent. To report spam or spoof\n          emails please contact Customer service."),_c('strong')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n          9. "),_c('strong',[_vm._v("Security")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v("\n          We protect your information using technical and administrative\n          security measures. Our safeguards include firewalls and data\n          encryption. If you believe your account has been abused, please\n          contact us.\n        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("10. ")]),_vm._v(" "),_c('strong',[_vm._v("Push Notifications.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong'),_vm._v("\n          Upon download of certain Services, you are provided the option to opt\n          into receiving push notifications from eshops.lk on your device and\n          within the application. We send you push notifications from\n          time-to-time to (a) inform you of service related messages, (b)\n          communicate messages from others in the eshops.lk community and (c)\n          update you about any events or promotions that we may be running. If\n          you no longer wish to receive notifications from us, you can, where\n          applicable, change your preferences by logging into your account or by\n          disabling notifications in your device settings. To ensure you receive\n          proper notifications, we will need to collect certain information\n          about your device such as operating system and user identification\n          information.\n        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("11. ")]),_vm._v(" "),_c('strong',[_vm._v("Third party privacy practices")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n          This Privacy Notice addresses only the use and disclosure of personal\n          information we collect from you. If you disclose your information to\n          others, or if you are directed to a third party website, their privacy\n          notices and practices will apply.\n          "),_c('br'),_vm._v(" "),_c('br'),_vm._v("\n          We can’t guarantee the privacy or security of your information once\n          you provide it to a third party. You should check the privacy and\n          security policies of your trading partner before entering into a\n          transaction and choosing to share your information, even when dealing\n          with buyers or sellers on our site.\n        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n          12. "),_c('strong',[_vm._v("Changes to this Privacy Notice")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v("\n          We can change this Privacy Notice at any time by posting the updated\n          terms to the Site. The updated terms automatically take effect 30 days\n          after they are posted. We may announce any changes to this Privacy\n          Notice on our Site and/or via email if we believe they are material.\n        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("13. "),_c('strong',[_vm._v("Inquiries")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-6 col-lg-4"},[_c('div',{staticClass:"block block-info"},[_c('h4',[_vm._v("Contact Us")]),_vm._v(" "),_c('ul',[_c('li',[_c('a',[_c('i',{staticClass:"fa fa-phone mr-2",attrs:{"aria-hidden":"true"}}),_vm._v("0719 500\n                    600")])]),_vm._v(" "),_c('li',[_c('a',[_c('i',{staticClass:"fa fa-envelope mr-2",attrs:{"aria-hidden":"true"}}),_vm._v("info@eshops.lk")])])]),_vm._v(" "),_c('ul',{staticClass:"social-media-icons mb-2 d-inline"},[_c('li',{},[_c('a',{staticClass:"px-0 ml-0 mr-2",attrs:{"href":"https://www.facebook.com/Eshopslk-2212428785713128/"}},[_c('i',{staticClass:"fa fa-facebook-official f-sm-link",staticStyle:{"font-size":"34px","color":"#3b5998","background-color":"#fff","width":"30px","height":"30px","border-radius":"4px","text-align":"center","vertical-align":"middle"}})])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"px-0 mx-2",attrs:{"href":"https://www.instagram.com/eshops.lk/"}},[_c('i',{staticClass:"fa fa-instagram f-sm-link",staticStyle:{"font-size":"30px","color":"#fff","background":"radial-gradient(","width":"32px","height":"32px","border-radius":"4px","text-align":"center","vertical-align":"middle"}})])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"px-0 mx-2",attrs:{"href":"https://www.youtube.com/channel/UCJhY3IfJD3T2bA5PJ3SrMZw"}},[_c('i',{staticClass:"fa fa-youtube-square f-sm-link",staticStyle:{"font-size":"35px","color":"#ff0000","background-color":"#fff","width":"30px","height":"30px","border-radius":"6px","text-align":"center","vertical-align":"middle"}})])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm col-md-8 col-lg-5"},[_c('div',{staticClass:"block-2 app-promotion"},[_c('a',[_c('img',{attrs:{"src":__webpack_require__(38),"alt":"mobile-icon"}})]),_vm._v(" "),_c('p',{staticClass:"m-f-text"},[_vm._v("\n                Tap the Add to Home Screen Tab in Chrome Browser on Android or\n                Safari Browser on IOS to Get the Splendid\n                "),_c('span',{staticStyle:{"color":"#fd6a02","font-size":"20px"}},[_vm._v("Mobile App")]),_vm._v("\n                Directly\n              ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 540 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-modal',{staticClass:"text-center text-info",attrs:{"ok-only":"","centered":""},model:{value:(_vm.modalShow),callback:function ($$v) {_vm.modalShow=$$v},expression:"modalShow"}},[_vm._v("\n      You are not logged in as a user!\n    ")]),_vm._v(" "),_c('b-modal',{staticClass:"text-center text-info",attrs:{"ok-only":"","centered":""},model:{value:(_vm.modalShow1),callback:function ($$v) {_vm.modalShow1=$$v},expression:"modalShow1"}},[_vm._v("\n      You can't add more shops to My SHOPiN!\n    ")]),_vm._v(" "),_c('b-modal',{staticClass:"text-center text-info",attrs:{"ok-only":"","centered":""},model:{value:(_vm.modalShow2),callback:function ($$v) {_vm.modalShow2=$$v},expression:"modalShow2"}},[_vm._v("\n      Shop is added to My SHOPiN.\n    ")]),_vm._v(" "),_c('header',{staticClass:"header-v4"},[_c('div',{staticClass:"container-menu-desktop"},[_c('div',{staticClass:"top-bar"},[_c('div',{staticClass:"content-topbar flex-sb-m h-full container"},[_c('div',{staticClass:"left-top-bar"},[_c('router-link',{staticClass:"logo",attrs:{"to":"/"}},[_c('img',{attrs:{"src":__webpack_require__(13),"alt":"eshops-logo","width":"40","height":"40"}})])],1),_vm._v(" "),_c('div',{staticClass:"right-top-bar flex-w h-full"},[_c('router-link',{staticClass:"flex-c-m trans-04 p-lr-25",attrs:{"to":{ name: 'home' }}},[_vm._v("\n                Home\n              ")]),_vm._v(" "),(
                  this.$store.state.searchLocation != undefined &&
                  this.$store.state.searchLocation != ''
                )?_c('router-link',{staticClass:"flex-c-m trans-04 p-lr-25",attrs:{"to":{ name: 'search', query: _vm.searchQuery }}},[_vm._v("\n                Back to Search\n              ")]):_vm._e(),_vm._v(" "),(_vm.admin)?_c('router-link',{staticClass:"flex-c-m trans-04 p-lr-25",staticStyle:{"color":"red"},attrs:{"to":{ name: _vm.adminLink }}},[_vm._v("\n                Admin Area\n              ")]):_vm._e(),_vm._v(" "),(_vm.pageadmin)?_c('router-link',{staticClass:"flex-c-m trans-04 p-lr-25",staticStyle:{"color":"red"},attrs:{"to":{ name: 'admin-services' }}},[_vm._v("\n                Admin Area\n              ")]):_vm._e(),_vm._v(" "),(_vm.visitor)?_c('router-link',{staticClass:"flex-c-m trans-04 p-lr-25",attrs:{"to":{ name: 'signin' }}},[_vm._v("\n                Sign in\n              ")]):_vm._e(),_vm._v(" "),(_vm.visitor)?_c('router-link',{staticClass:"flex-c-m trans-04 p-lr-25",attrs:{"to":{ name: 'usersignup' }}},[_vm._v("\n                Sign up\n              ")]):_vm._e(),_vm._v(" "),(_vm.user)?_c('router-link',{staticClass:"flex-c-m trans-04 p-lr-25",attrs:{"to":{ name: 'myaccount' }}},[_vm._v("\n                My Account\n              ")]):_vm._e(),_vm._v(" "),(_vm.user || _vm.admin || _vm.pageadmin)?_c('a',{staticClass:"flex-c-m trans-04 p-lr-25",staticStyle:{"cursor":"pointer","color":"red"},on:{"click":function($event){_vm.logout()}}},[_vm._v("Sign out")]):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"wrap-menu-desktop how-shadow1"},[_c('nav',{staticClass:"limiter-menu-desktop container"},[_c('div',{staticClass:"menu-desktop"},[_c('ul',{staticClass:"main-menu"},[_c('li',[_c('router-link',{attrs:{"to":{
                      name: 'storehome',
                      params: { storename: this.$route.params.storename },
                    }}},[_vm._v("Home")])],1),_vm._v(" "),(_vm.plan != 'Starter')?_c('li',[_c('router-link',{attrs:{"to":{
                      name: 'storecategories',
                      params: { storename: this.$route.params.storename },
                    }}},[_vm._v("Categories")])],1):_vm._e(),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{
                      name: 'storeoffers',
                      params: { storename: this.$route.params.storename },
                    }}},[_vm._v("Offers")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{
                      name: 'storecontact',
                      params: { storename: this.$route.params.storename },
                    }}},[_vm._v("Contact")])],1)])]),_vm._v(" "),_c('div',{staticClass:"wrap-icon-header flex-w flex-r-m"},[_c('div',{staticClass:"icon-header-item cl2 hov-cl1 trans-04 tooltip100",attrs:{"data-tooltip":this.datanotify}},[(_vm.isFavShop == undefined || _vm.isFavShop == 'show')?_c('i',{staticClass:"fa fa-heart-o",on:{"click":function($event){_vm.addToFavourite()}}}):_vm._e(),_vm._v(" "),(_vm.isFavourite == true)?_c('i',{staticClass:"fa fa-heart-o text-danger",staticStyle:{"cursor":"default"}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"icon-header-item cl2 hov-cl1 trans-04 p-l-22 p-r-11",staticStyle:{"cursor":"pointer"}},[_c('i',{staticClass:"fa fa-share-alt",on:{"click":function($event){_vm.share()}}})]),_vm._v(" "),_c('div',{staticClass:"\n                  icon-header-item\n                  cl2\n                  hov-cl1\n                  trans-04\n                  p-r-11 p-l-10\n                  icon-header-noti\n                ",attrs:{"data-notify":_vm.cartItems}},[_c('i',{staticClass:"fa fa-shopping-cart",on:{"click":function($event){_vm.cartClicked()}}})])])])])]),_vm._v(" "),_c('div',{staticClass:"wrap-header-mobile"},[_c('div',{staticClass:"logo-mobile"},[_c('router-link',{staticClass:"ml-2",attrs:{"to":"/"}},[_c('img',{attrs:{"src":__webpack_require__(13),"alt":"eshops-logo"}})])],1),_vm._v(" "),_c('div',{staticClass:"wrap-icon-header flex-w flex-r-m"},[_c('div',{staticClass:"icon-header-item cl2 hov-cl1 trans-04"},[(_vm.isFavShop == undefined || _vm.isFavShop == 'show')?_c('i',{staticClass:"fa fa-heart-o",staticStyle:{"font-size":"25px"},on:{"click":function($event){_vm.addToFavourite()}}}):_vm._e(),_vm._v(" "),(_vm.isFavourite == true)?_c('i',{staticClass:"fa fa-heart-o text-danger",staticStyle:{"cursor":"default","font-size":"25px"}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"icon-header-item cl2 hov-cl1 trans-04 p-l-22 p-r-11",staticStyle:{"cursor":"pointer"}},[_c('i',{staticClass:"fa fa-share-alt",staticStyle:{"font-size":"25px"},on:{"click":function($event){_vm.share()}}})]),_vm._v(" "),_c('div',{staticClass:"\n              icon-header-item\n              cl2\n              hov-cl1\n              trans-04\n              p-r-11 p-l-10\n              icon-header-noti\n            ",attrs:{"data-notify":_vm.cartItems}},[_c('i',{staticClass:"fa fa-shopping-cart",staticStyle:{"font-size":"30px"},on:{"click":function($event){_vm.cartClicked()}}})]),_vm._v(" "),_c('div',{staticClass:"icon-header-item cl2 trans-04 p-r-11 p-l-10"},[_c('i',{staticClass:"fa fa-bars hamburger-inner",staticStyle:{"font-size":"25px"},on:{"click":function($event){_vm.showsidemenu = true}}})])])]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"wrap-header-cart js-panel-cart",class:{ 'show-header-cart': _vm.showsidemenu }},[_c('div',{staticClass:"s-full js-hide-cart",on:{"click":function($event){_vm.showsidemenu = false}}}),_vm._v(" "),_c('div',{staticClass:"header-cart"},[_c('div',{staticClass:"header-cart-title flex-w flex-sb-m p-b-8"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"fs-35 lh-10 p-lr-5 pointer hov-cl1 trans-04 js-hide-cart",on:{"click":function($event){_vm.showsidemenu = false}}},[_c('i',{staticClass:"fa fa-close text-white"})])]),_vm._v(" "),_c('div',{staticClass:"header-cart-content js-pscroll m-slide-h",staticStyle:{"height":"440px"}},[_c('ul',{staticClass:"main-menu-m"},[_c('li',{on:{"click":function($event){_vm.showsidemenu = false}}},[_c('router-link',{attrs:{"to":{
                  name: 'storehome',
                  params: { storename: this.$route.params.storename },
                }}},[_vm._v("Store Home")])],1),_vm._v(" "),(_vm.plan != 'Starter')?_c('li',{on:{"click":function($event){_vm.showsidemenu = false}}},[_c('router-link',{attrs:{"to":{
                  name: 'storecategories',
                  params: { storename: this.$route.params.storename },
                }}},[_vm._v("Store Categories")])],1):_vm._e(),_vm._v(" "),_c('li',{on:{"click":function($event){_vm.showsidemenu = false}}},[_c('router-link',{attrs:{"to":{
                  name: 'storeoffers',
                  params: { storename: this.$route.params.storename },
                }}},[_vm._v("Store Offers")])],1),_vm._v(" "),_c('li',{on:{"click":function($event){_vm.showsidemenu = false}}},[_c('router-link',{attrs:{"to":{
                  name: 'storecontact',
                  params: { storename: this.$route.params.storename },
                }}},[_vm._v("Store Contact")])],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('li',{on:{"click":function($event){_vm.showsidemenu = false}}},[_c('router-link',{attrs:{"to":{ name: 'home' }}},[_vm._v(" Home ")])],1),_vm._v(" "),_c('li',{on:{"click":function($event){_vm.showsidemenu = false}}},[(
                  this.$store.state.searchLocation != undefined &&
                  this.$store.state.searchLocation != ''
                )?_c('router-link',{attrs:{"to":{ name: 'search', query: _vm.searchQuery }}},[_vm._v("\n                Back to Search\n              ")]):_vm._e()],1),_vm._v(" "),_c('li',{on:{"click":function($event){_vm.showsidemenu = false}}},[(_vm.admin)?_c('router-link',{attrs:{"to":{ name: _vm.adminLink }}},[_vm._v("\n                Admin Area\n              ")]):_vm._e()],1),_vm._v(" "),_c('li',{on:{"click":function($event){_vm.showsidemenu = false}}},[(_vm.pageadmin)?_c('router-link',{attrs:{"to":{ name: 'admin-services' }}},[_vm._v("\n                Admin Area\n              ")]):_vm._e()],1),_vm._v(" "),_c('li',{on:{"click":function($event){_vm.showsidemenu = false}}},[(_vm.visitor)?_c('router-link',{attrs:{"to":{ name: 'signin' }}},[_vm._v("\n                Sign in\n              ")]):_vm._e()],1),_vm._v(" "),_c('li',{on:{"click":function($event){_vm.showsidemenu = false}}},[(_vm.visitor)?_c('router-link',{attrs:{"to":{ name: 'usersignup' }}},[_vm._v("\n                Sign up\n              ")]):_vm._e()],1),_vm._v(" "),_c('li',{on:{"click":function($event){_vm.showsidemenu = false}}},[(_vm.user)?_c('router-link',{attrs:{"to":{ name: 'myaccount' }}},[_vm._v("\n                My Account\n              ")]):_vm._e()],1),_vm._v(" "),_c('li',{on:{"click":function($event){_vm.showsidemenu = false}}},[(_vm.user || _vm.admin || _vm.pageadmin)?_c('a',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.logout()}}},[_vm._v("\n                Sign out\n              ")]):_vm._e()])])])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap-header-cart js-panel-cart"},[_c('div',{staticClass:"s-full js-hide-cart"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo-mobile"},[_c('a',{attrs:{"href":""}},[_c('img',{attrs:{"src":__webpack_require__(13),"alt":"IMG-LOGO"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cart_vue__ = __webpack_require__(185);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5754ac88_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cart_vue__ = __webpack_require__(544);
function injectStyle (ssrContext) {
  __webpack_require__(543)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5754ac88"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5754ac88_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 543 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{staticClass:"loading"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.fetch)?_c('div',[_c('b-modal',{staticClass:"text-center text-info",attrs:{"centered":"","ok-only":"","centered":""},model:{value:(_vm.modalShow),callback:function ($$v) {_vm.modalShow=$$v},expression:"modalShow"}},[_vm._v("\n        You order has been sent\n      ")]),_vm._v(" "),_c('b-modal',{staticClass:"text-center text-info",attrs:{"centered":"","ok-only":"","centered":""},model:{value:(_vm.modalShow1),callback:function ($$v) {_vm.modalShow1=$$v},expression:"modalShow1"}},[_vm._v("\n        Please wait. Your order is being sent.\n      ")]),_vm._v(" "),_c('form',{staticClass:"p-t-40 p-b-50 mobi-p-t-30"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-10 col-lg-10 col-xl-7 m-lr-auto m-b-50"},[_c('div',{staticClass:"m-l-25 m-r--38 m-lr-0-xl"},[_c('div',{staticClass:"wrap-table-shopping-cart"},[_c('table',{staticClass:"table-shopping-cart"},[_vm._m(1),_vm._v(" "),_vm._l((_vm.cartItems),function(item,i){return _c('tr',{key:item.id,staticClass:"table_row"},[_c('td',{staticClass:"column-1"},[_c('div',{staticClass:"how-itemcart1"},[_c('img',{attrs:{"src":item.image,"alt":"IMG"}})])]),_vm._v(" "),_c('td',{staticClass:"column-2"},[_c('span',{staticClass:"mr-3 text-danger",staticStyle:{"font-weight":"bold","font-size":"20px","cursor":"pointer"},on:{"click":function($event){_vm.deleteCartItem(i)}}},[_vm._v("X")]),_vm._v(_vm._s(item.name)+"\n                      ")]),_vm._v(" "),_c('td',{staticClass:"column-3"},[_vm._v("RS "+_vm._s(item.price))]),_vm._v(" "),_c('td',{staticClass:"column-4"},[_c('div',{staticClass:"wrap-num-product flex-w m-l-auto m-r-0"},[_c('div',{staticClass:"\n                              btn-num-product-down\n                              cl8\n                              hov-btn3\n                              trans-04\n                              flex-c-m\n                            ",on:{"click":function($event){_vm.decQuantity(i)}}},[_c('i',{staticClass:"fs-16 fa fa-minus"})]),_vm._v(" "),_c('input',{staticClass:"mtext-104 cl3 txt-center num-product",attrs:{"type":"number","name":"num-product2"},domProps:{"value":item.quantity}}),_vm._v(" "),_c('div',{staticClass:"\n                              btn-num-product-up\n                              cl8\n                              hov-btn3\n                              trans-04\n                              flex-c-m\n                            ",on:{"click":function($event){_vm.incQuantity(i)}}},[_c('i',{staticClass:"fs-16 fa fa-plus"})])])]),_vm._v(" "),_c('td',{staticClass:"column-5"},[_vm._v("\n                        RS"+_vm._s(item.quantity * item.price)+"\n                      ")])])})],2)]),_vm._v(" "),_c('div',{staticClass:"\n                    flex-w flex-sb-m\n                    bor15\n                    p-t-18 p-b-15 p-lr-40 p-lr-15-sm\n                  "},[_c('div',{staticClass:"size-208",style:({ display: _vm.display })},[_c('span',{staticClass:"stext-110 cl2"},[_vm._v(" Total: ")])]),_vm._v(" "),_c('div',{staticClass:"size-209",style:({ display: _vm.display })},[_c('span',{staticClass:"mtext-110 cl2"},[_vm._v("\n                      RS "+_vm._s(Math.round((_vm.Total + 0.00001) * 100) / 100)+"\n                    ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-10 col-lg-7 col-xl-5 m-lr-auto m-b-50"},[_c('div',{staticClass:"\n                  bor10\n                  p-lr-40 p-t-30 p-b-40\n                  m-l-63 m-r-40 m-lr-0-xl\n                  p-lr-15-sm\n                  mobi-m-lr\n                "},[_c('h4',{staticClass:"mtext-109 cl2 p-b-30"},[_vm._v("Your Details")]),_vm._v(" "),_c('div',{staticClass:"flex-w flex-t bor12 p-t-15 p-b-30"},[_c('div',{staticClass:"size-209 p-r-18 p-r-0-sm w-full-ssm"},[_c('div',{staticClass:"p-t-15"},[_c('el-form',{ref:"formdata",attrs:{"model":_vm.formdata,"size":"medium"}},[_c('el-form-item',{attrs:{"prop":"name","rules":[
                            {
                              required: true,
                              message: 'Please input your name',
                              trigger: 'blur',
                            } ]}},[_c('el-input',{attrs:{"placeholder":"Name"},model:{value:(_vm.formdata.name),callback:function ($$v) {_vm.$set(_vm.formdata, "name", $$v)},expression:"formdata.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"telephone","rules":[
                            {
                              required: true,
                              message: 'telephone no is required',
                            },
                            {
                              type: 'number',
                              message: 'telephone no must be a number',
                            } ]}},[_c('el-input',{attrs:{"placeholder":"Telephone (without 0)","auto-complete":"off"},model:{value:(_vm.formdata.telephone),callback:function ($$v) {_vm.$set(_vm.formdata, "telephone", _vm._n($$v))},expression:"formdata.telephone"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"address","rules":[
                            {
                              required: true,
                              message: 'Please input address',
                              trigger: 'blur',
                            } ]}},[_c('el-input',{attrs:{"type":"text","placeholder":"Address"},model:{value:(_vm.formdata.address),callback:function ($$v) {_vm.$set(_vm.formdata, "address", $$v)},expression:"formdata.address"}})],1),_vm._v(" "),_c('div',{staticClass:"flex-w flex-t p-t-27 p-b-33"},[_c('div',{staticClass:"size-208"},[_c('span',{staticClass:"mtext-101 cl2"},[_vm._v(" Total: ")])]),_vm._v(" "),_c('div',{staticClass:"size-209 p-t-1"},[_c('span',{staticClass:"mtext-110 cl2"},[_vm._v("\n                              RS "+_vm._s(Math.round((_vm.Total + 0.00001) * 100) / 100)+"\n                            ")])])]),_vm._v(" "),_c('el-form-item',[_c('div',{staticClass:"\n                              flex-c-m\n                              stext-101\n                              cl2\n                              size-119\n                              bg10\n                              bor13\n                              hov-btn3\n                              p-lr-15\n                              trans-04\n                              pointer\n                              m-tb-10\n                            ",on:{"click":function($event){_vm.sendOrder('formdata')}}},[_vm._v("\n                            Send Order\n                          ")])])],1)],1)])])])])])])])],1):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader"},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"table_head"},[_c('th',{staticClass:"column-1"},[_vm._v("Product")]),_vm._v(" "),_c('th',{staticClass:"column-2"}),_vm._v(" "),_c('th',{staticClass:"column-3"},[_vm._v("Price")]),_vm._v(" "),_c('th',{staticClass:"column-4"},[_vm._v("Quantity")]),_vm._v(" "),_c('th',{staticClass:"column-5"},[_vm._v("Subtotal")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Categories_vue__ = __webpack_require__(186);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1499ed0c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Categories_vue__ = __webpack_require__(548);
function injectStyle (ssrContext) {
  __webpack_require__(546)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1499ed0c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Categories_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1499ed0c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Categories_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 546 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = ({
    "Men’s & Women’s Clothing": {
        "Mens Ware": {
            "T-Shirts": 0,
            "Shirts": 0
        },

        "Mens Cloth": {
            "Mens Cloth": 0
        },

        "Womens Ware": {
            "Watch": 0,
            "Ring": 7,
            "Neckels": 8
        }
    },

    "Men’s Clothing": {
        "Men’s Clothing": {
            "T-Shirts": 0,
            "Shirts": 0,
            "Blazers": 0,
            "Sweaters ": 0,
            "Jeans": 0,
            "Pants": 0,
            "Shorts": 0,
            "Coats & Jackets": 0,
            "Suits": 0,
            "Athletic Apparel": 0,
            "Socks": 0,
            "Underwear": 0,
            "Shoes": 0

        }

    }
});

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{staticClass:"loading"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.fetch)?_c('div',[_c('section',{staticClass:" section",staticStyle:{"padding-top":"30px"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h2',{staticClass:"ltext-105 pb-4 txt-center"},[_vm._v("\n\t\t\t\t\tAll Categories\n\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.shopcats),function(values,key){return _c('div',{key:key,staticClass:"col-lg-3 offset-lg-0 col-md-4 offset-md-1 col-sm-6",staticStyle:{"height":"auto"}},[_c('div',{staticClass:"category-block",staticStyle:{"background-color":"#fff"}},[_c('div',{staticClass:"header"},[_c('i',{staticClass:"fa fa-tag icon-bg-1"}),_vm._v(" "),_c('h4',[_c('a',[_vm._v(_vm._s(key))])])]),_vm._v(" "),_c('ul',{staticClass:"category-list"},_vm._l((values),function(value,key){return (value > 0)?_c('li',{key:key},[_c('router-link',{attrs:{"to":{name: 'storeproducts', params: {cat: key}}}},[_vm._v(_vm._s(key)),_c('span',[_vm._v(_vm._s(value))])])],1):_vm._e()}))])])}))])])])])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader"},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Offers_vue__ = __webpack_require__(187);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aa392ec2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Offers_vue__ = __webpack_require__(551);
function injectStyle (ssrContext) {
  __webpack_require__(550)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-aa392ec2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Offers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aa392ec2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Offers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 550 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{staticClass:"loading"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.fetch)?_c('div',[_c('h2',{staticClass:"ltext-105 pt-4 txt-center"},[_vm._v("\r\n\t\t\tOffers\r\n\t")]),_vm._v(" "),_c('section',{staticClass:"section-sm",staticStyle:{"padding-top":"30px"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 pt-2"},[_c('div',{staticClass:"product-grid-list"},[_c('div',{staticClass:"row mt-25 justify-content-around"},[(_vm.noresults)?_c('div',[_vm._v("No Offers are Available")]):_vm._e(),_vm._v(" "),_vm._l((_vm.offers),function(offer,i){return [_c('div',{key:offer.id,staticClass:" col-12 col-sm-6 col-md-4 col-lg-4 "},[_c('div',{staticClass:"product-item bg-light"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"block2-pic hov-img0"},[_c('img',{attrs:{"src":offer.image,"alt":"IMG-SHOP"}})]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('h4',{staticClass:"card-title"},[_c('a',{staticClass:"text-primary"},[_vm._v(_vm._s(offer.dis)),_c('span',[_vm._v("% Discount")])])]),_vm._v(" "),_c('ul',{staticClass:"list-inline product-meta mb-1 mt-2"},[_c('li',{staticClass:"list-inline-item mr-2"},[_c('a',{},[_vm._v(_vm._s(offer.desc))])])])])])])])]})],2)])])])])])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader"},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Products_vue__ = __webpack_require__(188);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dbc92be2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Products_vue__ = __webpack_require__(554);
function injectStyle (ssrContext) {
  __webpack_require__(553)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dbc92be2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Products_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dbc92be2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Products_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 553 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{staticClass:"loading"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.fetch)?_c('div',[_c('modal',{attrs:{"name":"prdDetails","adaptive":true,"height":"auto","scrollable":true}},[_c('b-modal',{staticClass:"text-center text-info",staticStyle:{"z-index":"99999"},attrs:{"ok-only":"","centered":"","centered":""},model:{value:(_vm.modalShow),callback:function ($$v) {_vm.modalShow=$$v},expression:"modalShow"}},[_vm._v("\n\t\tYou are not logged in as a user!\n\t\t")]),_vm._v(" "),_c('b-modal',{staticClass:"text-center text-info",staticStyle:{"z-index":"99999"},attrs:{"ok-only":"","centered":"","centered":""},model:{value:(_vm.modalShow2),callback:function ($$v) {_vm.modalShow2=$$v},expression:"modalShow2"}},[_vm._v("\n\t\tAdded To Cart\n\t\t")]),_vm._v(" "),_c('b-modal',{staticClass:"text-center text-info",staticStyle:{"z-index":"99999"},attrs:{"ok-only":"","centered":"","centered":""},model:{value:(_vm.modalShow3),callback:function ($$v) {_vm.modalShow3=$$v},expression:"modalShow3"}},[_vm._v("\n\t\tRemoved from Cart\n\t\t")]),_vm._v(" "),_c('div',{staticStyle:{"position":"relative"}},[_c('a',{staticClass:"md-close",on:{"click":function($event){_vm.close()}}})]),_vm._v(" "),_c('div',{staticClass:"container p-t-45 p-b-60 mobi-m-p-100"},[_c('div',{staticClass:"row",staticStyle:{"height":"480px"}},[_c('carousel-3d',{staticStyle:{"height":"480px"},attrs:{"border":0,"controls-visible":_vm.ctrl,"autoplay":true,"autoplay-timeout":3000}},[_c('slide',{staticStyle:{"height":"auto !important"},attrs:{"index":0}},[_c('div',{staticClass:"zoom",attrs:{"data-zoom":_vm.image}},[_c('img',{attrs:{"src":_vm.image,"alt":""},on:{"click":function($event){_vm.zoom(_vm.image)}}})])]),_vm._v(" "),(_vm.otherimgs.length > 0)?_c('slide',{staticStyle:{"height":"auto !important"},attrs:{"index":1}},[_c('div',{staticClass:"zoom",attrs:{"data-zoom":_vm.otherimgs[0]}},[_c('img',{attrs:{"src":_vm.otherimgs[0],"alt":""}})])]):_vm._e(),_vm._v(" "),(_vm.otherimgs.length > 1)?_c('slide',{staticStyle:{"height":"auto !important"},attrs:{"index":2}},[_c('div',{staticClass:"zoom",attrs:{"data-zoom":_vm.otherimgs[1]}},[_c('img',{attrs:{"src":_vm.otherimgs[1],"alt":""}})])]):_vm._e(),_vm._v(" "),(_vm.otherimgs.length > 2)?_c('slide',{staticStyle:{"height":"auto !important"},attrs:{"index":3}},[_c('div',{staticClass:"zoom",attrs:{"data-zoom":_vm.otherimgs[2]}},[_c('img',{attrs:{"src":_vm.otherimgs[2]}})])]):_vm._e(),_vm._v(" "),(_vm.otherimgs.length > 3)?_c('slide',{staticStyle:{"height":"auto !important"},attrs:{"index":4}},[_c('div',{staticClass:"zoom",attrs:{"data-zoom":_vm.otherimgs[3]}},[_c('img',{attrs:{"src":_vm.otherimgs[3]}})])]):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-lg-12 p-t-10 p-b-30 mx-auto text-center mobi-m-p-0"},[_c('div',{staticClass:" p-t-5 p-lr-0-lg mx-auto text-center"},[_c('h4',{staticClass:"mtext-105 cl13 js-name-detail p-b-14 pt-2"},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm.formdata.name)+"\n\t\t\t\t\t\t")]),_vm._v(" "),_c('span',{staticClass:"mtext-106 cl13"},[_vm._v("\n\t\t\t\t\t\t\tRS "+_vm._s(_vm.formdata.price)+"\n\t\t\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"p-t-33"},[_c('div',{staticClass:"flex-w flex-t p-b-10"},[_c('div',{staticClass:"size-204 m-l-56"},[_c('button',{staticClass:"flex-c-m stext-101 cl0 size-101 bg10 bor1 hov-btn1 mb-3 p-lr-15 trans-04  mx-auto",staticStyle:{"background-color":"#8b2ae5"},on:{"click":function($event){_vm.sharePrd()}}},[_vm._v("\n\t\t\t\t\t\t\t\t\tShare\n\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),(!_vm.incart)?_c('button',{staticClass:"flex-c-m stext-101 cl0 size-101 bg1 bor1 hov-btn1 p-lr-15 mb-3 trans-04  mx-auto text-center",on:{"click":function($event){_vm.addToCart()}}},[_vm._v("\n\t\t\t\t\t\t\t\t\t\tAdd to Cart\n\t\t\t\t\t\t\t\t\t")]):_vm._e(),_vm._v(" "),(_vm.incart)?_c('button',{staticClass:"flex-c-m stext-101 cl0 size-101 bg1 bor1 hov-btn1 p-lr-25 mb-3 trans-04  mx-auto text-center",on:{"click":function($event){_vm.removeCart()}}},[_vm._v("\n\t\t\t\t\t\t\t\t\t\tRemove from Cart\n\t\t\t\t\t\t\t\t\t")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"flex-c-m stext-101 cl0 size-101 bg10 bor1 hov-btn1 p-lr-15 trans-04  mx-auto",on:{"click":function($event){_vm.cartClicked()}}},[_vm._v("\n\t\t\t\t\t\t\t\t\tView cart\n\t\t\t\t\t\t\t\t\t")])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"bor10 m-t-0 p-t-43 p-b-40"},[_c('div',{staticClass:"tab01"},[_c('ul',{staticClass:"nav nav-tabs",attrs:{"role":"tablist"}},[_c('li',{staticClass:"nav-item p-b-10"},[_c('a',{staticClass:"nav-link active",attrs:{"data-toggle":"tab","href":"#information","role":"tab"}},[_vm._v("Additional information")])]),_vm._v(" "),_c('li',{staticClass:"nav-item p-b-10"},[_c('a',{staticClass:"nav-link ",attrs:{"data-toggle":"tab","href":"#description","role":"tab"}},[_vm._v("Description")])])]),_vm._v(" "),_c('div',{staticClass:"tab-content p-t-43"},[_c('div',{staticClass:"tab-pane fade",attrs:{"id":"description","role":"tabpanel"}},[_c('div',{staticClass:"how-pos2 p-lr-15-md"},[_c('p',{staticClass:"stext-102 cl6"},[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.formdata.desc)+"\n\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t")])])]),_vm._v(" "),_c('div',{staticClass:"tab-pane fade active show",attrs:{"id":"information","role":"tabpanel"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-10 col-md-8 col-lg-6 m-lr-auto"},[_c('ul',{staticClass:"p-lr-28 p-lr-15-sm"},[_c('li',{staticClass:"flex-w flex-t p-b-7"},[_c('span',{staticClass:"stext-102 cl3 size-205"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tname\n\t\t\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('span',{staticClass:"stext-102 cl6 size-206"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.formdata.name)+"\n\t\t\t\t\t\t\t\t\t\t\t")])]),_vm._v(" "),_c('li',{staticClass:"flex-w flex-t p-b-7"},[_c('span',{staticClass:"stext-102 cl3 size-205"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tprice\n\t\t\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('span',{staticClass:"stext-102 cl6 size-206"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tRS "+_vm._s(_vm.formdata.price)+"\n\t\t\t\t\t\t\t\t\t\t\t")])]),_vm._v(" "),_c('li',{staticClass:"flex-w flex-t p-b-7"},[_c('span',{staticClass:"stext-102 cl3 size-205"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tbrand/make\n\t\t\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('span',{staticClass:"stext-102 cl6 size-206"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.formdata.brand)+"\n\t\t\t\t\t\t\t\t\t\t\t")])]),_vm._v(" "),_c('li',{staticClass:"flex-w flex-t p-b-7"},[_c('span',{staticClass:"stext-102 cl3 size-205"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tcolor\n\t\t\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('span',{staticClass:"stext-102 cl6 size-206"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.formdata.color)+"\n\t\t\t\t\t\t\t\t\t\t\t")])]),_vm._v(" "),_c('li',{staticClass:"flex-w flex-t p-b-7"},[_c('span',{staticClass:"stext-102 cl3 size-205"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tcondition\n\t\t\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('span',{staticClass:"stext-102 cl6 size-206"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.formdata.condition)+"\n\t\t\t\t\t\t\t\t\t\t\t")])]),_vm._v(" "),_c('li',{staticClass:"flex-w flex-t p-b-7"},[_c('span',{staticClass:"stext-102 cl3 size-205"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\twarranty\n\t\t\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('span',{staticClass:"stext-102 cl6 size-206"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.formdata.warranty)+"\n\t\t\t\t\t\t\t\t\t\t\t")])]),_vm._v(" "),_vm._l((_vm.formdata.details),function(value,key){return (value != '')?_c('li',{key:key,staticClass:"flex-w flex-t p-b-7"},[(key != 'enginecapacity' && key != 'enginetype' && key != 'fueltype'
											 && key != 'bodytype' && key != 'cpugeneration')?_c('span',{staticClass:"stext-102 cl3 size-205"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(key)+"\n\t\t\t\t\t\t\t\t\t\t\t")]):_vm._e(),_vm._v(" "),(key == 'enginecapacity')?_c('span',{staticClass:"stext-102 cl6 size-206"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tengine capacity\n\t\t\t\t\t\t\t\t\t\t\t")]):_vm._e(),_vm._v(" "),(key == 'bodytype')?_c('span',{staticClass:"stext-102 cl6 size-206"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tbody type\n\t\t\t\t\t\t\t\t\t\t\t")]):_vm._e(),_vm._v(" "),(key == 'enginetype')?_c('span',{staticClass:"stext-102 cl6 size-206"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tengine type\n\t\t\t\t\t\t\t\t\t\t\t")]):_vm._e(),_vm._v(" "),(key == 'fueltype')?_c('span',{staticClass:"stext-102 cl6 size-206"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tfuel type\n\t\t\t\t\t\t\t\t\t\t\t")]):_vm._e(),_vm._v(" "),(key == 'cpugeneration')?_c('span',{staticClass:"stext-102 cl6 size-206"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tcpu generation\n\t\t\t\t\t\t\t\t\t\t\t")]):_vm._e(),_vm._v(" "),(key == 'model'|| key == 'size' || key == 'material'
											 || key == 'modelcode' || key == 'year' || key == 'enginetype' || key == 'fueltype' || key == 'transmission'
											 || key == 'bodytype' || key == 'publisher' || key == 'orthor' || key == 'metal' || key == 'cpugeneration' || key == 'os' || key == 'cpu')?_c('span',{staticClass:"stext-102 cl6 size-206"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(value)+"\n\t\t\t\t\t\t\t\t\t\t\t")]):_vm._e(),_vm._v(" "),(key == 'storage'|| key == 'ram' || key == 'hard'
											 || key == 'graphics')?_c('span',{staticClass:"stext-102 cl6 size-206"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(value)+" GB\n\t\t\t\t\t\t\t\t\t\t\t")]):_vm._e(),_vm._v(" "),(key == 'frontcamera'|| key == 'rearcamera')?_c('span',{staticClass:"stext-102 cl6 size-206"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(value)+" MP\n\t\t\t\t\t\t\t\t\t\t\t")]):_vm._e(),_vm._v(" "),(key == 'screen'|| key == 'screensize')?_c('span',{staticClass:"stext-102 cl6 size-206"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(value)+" inches\n\t\t\t\t\t\t\t\t\t\t\t")]):_vm._e(),_vm._v(" "),(key == 'karat')?_c('span',{staticClass:"stext-102 cl6 size-206"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(value)+" k\n\t\t\t\t\t\t\t\t\t\t\t")]):_vm._e(),_vm._v(" "),(key == 'weight')?_c('span',{staticClass:"stext-102 cl6 size-206"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(value)+" g\n\t\t\t\t\t\t\t\t\t\t\t")]):_vm._e(),_vm._v(" "),(key == 'battery')?_c('span',{staticClass:"stext-102 cl6 size-206"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(value)+" mAh\n\t\t\t\t\t\t\t\t\t\t\t")]):_vm._e(),_vm._v(" "),(key == 'enginecapacity')?_c('span',{staticClass:"stext-102 cl6 size-206"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(value)+" cc\n\t\t\t\t\t\t\t\t\t\t\t")]):_vm._e(),_vm._v(" "),(key == 'mileage')?_c('span',{staticClass:"stext-102 cl6 size-206"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(value)+" km\n\t\t\t\t\t\t\t\t\t\t\t")]):_vm._e()]):_vm._e()})],2)])])])])])])])],1),_vm._v(" "),_c('div',{staticClass:"p-b-50"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"flex-w flex-sb-m"},[_c('div',{staticClass:"flex-w flex-c-m m-tb-10 m-t-70 m-filter",staticStyle:{"width":"100%","z-index":"1099"}},[_c('div',{staticClass:"flex-c-m stext-106 cl6  bor4 pointer filter-btn trans-04 m-r-8 m-tb-4",staticStyle:{"position":"fixed","z-index":"1099","height":"40px","width":"284px"},on:{"click":function($event){_vm.disFilter()}}},[_c('i',{staticClass:"icon-filter cl2 m-r-6 fs-15 trans-04 zmdi zmdi-filter-list"}),_vm._v(" "),_vm._v("\n\t\t\t\t\t\tAll Categories & Filters\n\t\t\t\t\t")])]),_vm._v(" "),_c('div',{staticClass:"panel-filter w-full",style:({display: _vm.dismobi})},[_c('div',{staticClass:"wrap-filter flex-w bg6 p-lr-40 p-t-27 p-lr-15-sm"},[_c('div',{staticClass:"filter-col1 p-r-15 p-b-27 col-sm-12"},[_c('div',{staticClass:"mtext-102 cl2 p-b-15"},[_vm._v("\n\t\t\t\t\t\t\t\tSort By\n\t\t\t\t\t\t\t")]),_vm._v(" "),_c('ul',[_c('li',{staticClass:"p-b-6"},[_c('a',{staticClass:"filter-link stext-106 trans-04",on:{"click":function($event){_vm.sortPriceLTH()}}},[_vm._v("\n\t\t\t\t\t\t\t\t\t\tPrice: Low to High\n\t\t\t\t\t\t\t\t\t")])]),_vm._v(" "),_c('li',{staticClass:"p-b-6"},[_c('a',{staticClass:"filter-link stext-106 trans-04",on:{"click":function($event){_vm.sortPriceHTL()}}},[_vm._v("\n\t\t\t\t\t\t\t\t\t\tPrice: High to Low\n\t\t\t\t\t\t\t\t\t")])])]),_vm._v(" "),_c('div',{staticClass:"mtext-102 cl2 p-b-15"},[_vm._v("\n\t\t\t\t\t\t\t\tCategories\n\t\t\t\t\t\t\t")]),_vm._v(" "),_c('ul',_vm._l((_vm.shopcats),function(values,key){return _c('li',{key:key,staticClass:"main-nav-list  child mb-3"},[_c('span',{staticClass:"mb-3 text-info"},[_vm._v(_vm._s(key))]),_vm._v(" "),_c('ul',_vm._l((values),function(value,key){return (value > 0)?_c('li',{key:key,staticClass:"main-nav-list py-1 ml-1 sidesubcat"},[_c('span',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.collapseItem(key)}}},[_vm._v(_vm._s(key)+" ("+_vm._s(value)+")")])]):_vm._e()}))])}))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 col-lg-2 p-b-30 "},[_c('div',[_c('div',{staticClass:"side-menu m-t-30"},[_c('div',{staticClass:"p-t-10 sidebar-categories"},[_c('h4',{staticClass:"mtext-112 cl2 p-b-10"},[_vm._v("\n\t\t\t\t\t\t\t\tSort By\n\t\t\t\t\t\t\t")]),_vm._v(" "),_c('ul',[_c('li',{staticClass:"p-b-6"},[_c('a',{staticClass:"filter-link stext-106 trans-04 p-l-8",on:{"click":function($event){_vm.sortPriceLTH()}}},[_c('span',{staticStyle:{"cursor":"pointer"}},[_vm._v(" Price: Low to High")])])]),_vm._v(" "),_c('li',{staticClass:"p-b-6"},[_c('a',{staticClass:"filter-link stext-106 trans-04 p-l-8",on:{"click":function($event){_vm.sortPriceHTL()}}},[_c('span',{staticStyle:{"cursor":"pointer"}},[_vm._v(" Price: High to Low")])])])]),_vm._v(" "),_c('h4',{staticClass:"mtext-112 cl2 p-b-20 p-t-16"},[_vm._v("\n\t\t\t\t\t\t\t\tCategories\n\t\t\t\t\t\t\t")]),_vm._v(" "),_c('ul',_vm._l((_vm.shopcats),function(values,key){return _c('li',{key:key,staticClass:"main-nav-list  child mb-3"},[_c('span',{staticClass:"mb-3 text-info"},[_vm._v(_vm._s(key))]),_vm._v(" "),_c('ul',_vm._l((values),function(value,key){return (value > 0)?_c('li',{key:key,staticClass:"main-nav-list py-1 ml-1 sidesubcat"},[_c('span',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.collapseItem(key)}}},[_vm._v(_vm._s(key)+" ("+_vm._s(value)+")")])]):_vm._e()}))])}))])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-9 col-lg-10 justify-item-center m-t-50 mobi-m-t-10"},[_c('div',{staticClass:"row isotope-grid"},[_vm._l((_vm.filteredProducts.slice(0, _vm.items)),function(item,i){return [_c('div',{key:item.id,staticClass:"col-6 col-sm-4 col-md-4 col-lg-3 p-b-35 isotope-item men"},[_c('div',{staticClass:"block2 ",staticStyle:{"box-shadow":"0px 1px 3px 0px rgba(0, 0, 0, 0.1)"}},[_c('div',{staticClass:"block2-pic hov-img0"},[_c('div',{staticClass:"zoom",attrs:{"src":item.image}},[_c('img',{staticStyle:{"cursor":"pointer"},attrs:{"src":item.image,"alt":"PRODUCT-IMAGE"},on:{"click":function($event){_vm.show(item)}}})])]),_vm._v(" "),_c('div',{staticClass:"block2-txt flex-w flex-t p-t-14",staticStyle:{"padding":"20px","background-color":"#ffffff"}},[_c('div',{staticClass:"block2-txt-child1 flex-col-l "},[_c('router-link',{staticClass:"stext-104 cl6 hov-cl13 text-info trans-04 m-txt js-name-b2 p-b-6",staticStyle:{"font-size":"16px","font-weight":"500"},attrs:{"to":{name: 'storeproductdetails', params:{id: item.id}}}},[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(item.name)+"\n\t\t\t\t\t\t\t\t")]),_vm._v(" "),((item.disprice != item.price ))?_c('span',{staticClass:"stext-105 cl3"},[_c('span',{staticClass:"stext-105 cl15 m-txt",staticStyle:{"color":"#F03B3B","display":"block"}},[_vm._v("RS "+_vm._s(item.price))]),_vm._v(" "),_c('span',{staticClass:"stext-105 cl3 m-txt",staticStyle:{"text-decoration":"line-through"}},[_vm._v("\n\t\t\t\t\t\t\t\t\tRS "+_vm._s(item.disprice)+"\n\t\t\t\t\t\t\t\t\t")])]):_vm._e(),_vm._v(" "),((item.disprice == item.price ))?_c('span',{staticClass:"stext-105 cl3 text-info m-txt"},[_vm._v("\n\t\t\t\t\t\t\t\t\tRS "+_vm._s(item.price)+"\n\t\t\t\t\t\t\t\t")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"block2-txt-child2 flex-r p-t-3"})])])])]})],2),_vm._v(" "),_vm._m(1)])])])])],1):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader"},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-c-m flex-w w-full p-t-45"},[_c('div',{staticClass:"block"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductDetails_vue__ = __webpack_require__(189);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bc50bb6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductDetails_vue__ = __webpack_require__(557);
function injectStyle (ssrContext) {
  __webpack_require__(556)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7bc50bb6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bc50bb6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 556 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{staticClass:"loading"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.fetch)?_c('div',[_c('b-modal',{staticClass:"text-center text-info",attrs:{"ok-only":"","centered":"","centered":""},model:{value:(_vm.modalShow),callback:function ($$v) {_vm.modalShow=$$v},expression:"modalShow"}},[_vm._v("\n      You are not logged in as a user!\n    ")]),_vm._v(" "),_c('b-modal',{staticClass:"text-center text-info",attrs:{"ok-only":"","centered":"","centered":""},model:{value:(_vm.modalShow2),callback:function ($$v) {_vm.modalShow2=$$v},expression:"modalShow2"}},[_vm._v("\n      Added To Cart\n    ")]),_vm._v(" "),_c('b-modal',{staticClass:"text-center text-info",attrs:{"ok-only":"","centered":"","centered":""},model:{value:(_vm.modalShow3),callback:function ($$v) {_vm.modalShow3=$$v},expression:"modalShow3"}},[_vm._v("\n      Item Already In the Cart\n    ")]),_vm._v(" "),_c('div',{staticClass:"container p-t-45 p-b-60 mobi-m-p-100"},[_c('div',{staticClass:"row",staticStyle:{"height":"auto"}},[_c('carousel-3d',{staticStyle:{"height":"480px"},attrs:{"border":0,"controls-visible":_vm.ctrl}},[_c('slide',{staticStyle:{"height":"auto"},attrs:{"index":0}},[_c('div',{staticClass:"zoom",attrs:{"data-zoom":_vm.image}},[_c('img',{attrs:{"src":_vm.image,"alt":""}})])]),_vm._v(" "),_c('slide',{staticStyle:{"height":"auto"},attrs:{"index":1}},[_c('div',{staticClass:"zoom",attrs:{"data-zoom":_vm.otherimgs[0]}},[_c('img',{attrs:{"src":_vm.otherimgs[0],"alt":""}})])]),_vm._v(" "),_c('slide',{staticStyle:{"height":"auto"},attrs:{"index":2}},[_c('div',{staticClass:"zoom",attrs:{"data-zoom":_vm.otherimgs[1]}},[_c('img',{attrs:{"src":_vm.otherimgs[1],"alt":""}})])]),_vm._v(" "),_c('slide',{staticStyle:{"height":"auto"},attrs:{"index":3}},[_c('div',{staticClass:"zoom",attrs:{"data-zoom":_vm.otherimgs[2]}},[_c('img',{attrs:{"src":_vm.otherimgs[2],"alt":""}})])]),_vm._v(" "),_c('slide',{staticStyle:{"height":"auto"},attrs:{"index":4}},[_c('div',{staticClass:"zoom",attrs:{"data-zoom":_vm.otherimgs[3]}},[_c('img',{attrs:{"src":_vm.otherimgs[3],"alt":""}})])])],1)],1),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-lg-12 p-t-10 p-b-30 mx-auto text-center mobi-m-p-0"},[_c('div',{staticClass:" p-t-5 p-lr-0-lg mx-auto text-center"},[_c('h4',{staticClass:"mtext-105 cl13 js-name-detail p-b-14"},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm.formdata.name)+"\n\t\t\t\t\t\t")]),_vm._v(" "),_c('span',{staticClass:"mtext-106 cl13"},[_vm._v("\n\t\t\t\t\t\t\tRS "+_vm._s(_vm.formdata.price)+"\n\t\t\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"p-t-33"},[_c('div',{staticClass:"flex-w flex-t p-b-10"},[_c('div',{staticClass:"size-204 m-l-56"},[_c('button',{staticClass:"flex-c-m stext-101 cl0 size-101 bg1 bor1 hov-btn1 p-lr-15 mb-3 trans-04  mx-auto text-center",on:{"click":function($event){_vm.addToCart()}}},[_vm._v("\n\t\t\t\t\t\t\t\t\t\tAdd to Cart\n\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('button',{staticClass:"flex-c-m stext-101 cl0 size-101 bg10 bor1 hov-btn1 p-lr-15 trans-04  mx-auto",on:{"click":function($event){_vm.cartClicked()}}},[_vm._v("\n\t\t\t\t\t\t\t\t\tView cart\n\t\t\t\t\t\t\t\t\t")])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"bor10 m-t-0 p-t-43 p-b-40"},[_c('div',{staticClass:"tab01"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"tab-content p-t-43"},[_c('div',{staticClass:"tab-pane fade",attrs:{"id":"description","role":"tabpanel"}},[_c('div',{staticClass:"how-pos2 p-lr-15-md"},[_c('p',{staticClass:"stext-102 cl6"},[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.formdata.desc)+"\n\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t")])])]),_vm._v(" "),_c('div',{staticClass:"tab-pane fade active show",attrs:{"id":"information","role":"tabpanel"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-10 col-md-8 col-lg-6 m-lr-auto"},[_c('ul',{staticClass:"p-lr-28 p-lr-15-sm"},[_c('li',{staticClass:"flex-w flex-t p-b-7"},[_c('span',{staticClass:"stext-102 cl3 size-205"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tname\n\t\t\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('span',{staticClass:"stext-102 cl6 size-206"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.formdata.name)+"\n\t\t\t\t\t\t\t\t\t\t\t")])]),_vm._v(" "),_c('li',{staticClass:"flex-w flex-t p-b-7"},[_c('span',{staticClass:"stext-102 cl3 size-205"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tprice\n\t\t\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('span',{staticClass:"stext-102 cl6 size-206"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tRS "+_vm._s(_vm.formdata.price)+"\n\t\t\t\t\t\t\t\t\t\t\t")])]),_vm._v(" "),_c('li',{staticClass:"flex-w flex-t p-b-7"},[_c('span',{staticClass:"stext-102 cl3 size-205"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tbrand/make\n\t\t\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('span',{staticClass:"stext-102 cl6 size-206"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.formdata.brand)+"\n\t\t\t\t\t\t\t\t\t\t\t")])]),_vm._v(" "),_c('li',{staticClass:"flex-w flex-t p-b-7"},[_c('span',{staticClass:"stext-102 cl3 size-205"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tcolor\n\t\t\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('span',{staticClass:"stext-102 cl6 size-206"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.formdata.color)+"\n\t\t\t\t\t\t\t\t\t\t\t")])]),_vm._v(" "),_c('li',{staticClass:"flex-w flex-t p-b-7"},[_c('span',{staticClass:"stext-102 cl3 size-205"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tcondition\n\t\t\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('span',{staticClass:"stext-102 cl6 size-206"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.formdata.condition)+"\n\t\t\t\t\t\t\t\t\t\t\t")])]),_vm._v(" "),_c('li',{staticClass:"flex-w flex-t p-b-7"},[_c('span',{staticClass:"stext-102 cl3 size-205"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\twarranty\n\t\t\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('span',{staticClass:"stext-102 cl6 size-206"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.formdata.warranty)+"\n\t\t\t\t\t\t\t\t\t\t\t")])]),_vm._v(" "),_vm._l((_vm.formdata.details),function(value,key){return (value != '')?_c('li',{key:key,staticClass:"flex-w flex-t p-b-7"},[(key != 'enginecapacity' && key != 'enginetype' && key != 'fueltype'
											 && key != 'bodytype' && key != 'cpugeneration')?_c('span',{staticClass:"stext-102 cl3 size-205"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(key)+"\n\t\t\t\t\t\t\t\t\t\t\t")]):_vm._e(),_vm._v(" "),(key == 'enginecapacity')?_c('span',{staticClass:"stext-102 cl6 size-206"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tengine capacity\n\t\t\t\t\t\t\t\t\t\t\t")]):_vm._e(),_vm._v(" "),(key == 'bodytype')?_c('span',{staticClass:"stext-102 cl6 size-206"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tbody type\n\t\t\t\t\t\t\t\t\t\t\t")]):_vm._e(),_vm._v(" "),(key == 'enginetype')?_c('span',{staticClass:"stext-102 cl6 size-206"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tengine type\n\t\t\t\t\t\t\t\t\t\t\t")]):_vm._e(),_vm._v(" "),(key == 'fueltype')?_c('span',{staticClass:"stext-102 cl6 size-206"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tfuel type\n\t\t\t\t\t\t\t\t\t\t\t")]):_vm._e(),_vm._v(" "),(key == 'cpugeneration')?_c('span',{staticClass:"stext-102 cl6 size-206"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tcpu generation\n\t\t\t\t\t\t\t\t\t\t\t")]):_vm._e(),_vm._v(" "),(key == 'model'|| key == 'size' || key == 'material'
											 || key == 'modelcode' || key == 'year' || key == 'enginetype' || key == 'fueltype' || key == 'transmission'
											 || key == 'bodytype' || key == 'publisher' || key == 'orthor' || key == 'metal' || key == 'cpugeneration' || key == 'os' || key == 'cpu')?_c('span',{staticClass:"stext-102 cl6 size-206"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(value)+"\n\t\t\t\t\t\t\t\t\t\t\t")]):_vm._e(),_vm._v(" "),(key == 'storage'|| key == 'ram' || key == 'hard'
											 || key == 'graphics')?_c('span',{staticClass:"stext-102 cl6 size-206"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(value)+" GB\n\t\t\t\t\t\t\t\t\t\t\t")]):_vm._e(),_vm._v(" "),(key == 'frontcamera'|| key == 'rearcamera')?_c('span',{staticClass:"stext-102 cl6 size-206"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(value)+" MP\n\t\t\t\t\t\t\t\t\t\t\t")]):_vm._e(),_vm._v(" "),(key == 'screen'|| key == 'screensize')?_c('span',{staticClass:"stext-102 cl6 size-206"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(value)+" inches\n\t\t\t\t\t\t\t\t\t\t\t")]):_vm._e(),_vm._v(" "),(key == 'karat')?_c('span',{staticClass:"stext-102 cl6 size-206"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(value)+" k\n\t\t\t\t\t\t\t\t\t\t\t")]):_vm._e(),_vm._v(" "),(key == 'weight')?_c('span',{staticClass:"stext-102 cl6 size-206"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(value)+" g\n\t\t\t\t\t\t\t\t\t\t\t")]):_vm._e(),_vm._v(" "),(key == 'battery')?_c('span',{staticClass:"stext-102 cl6 size-206"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(value)+" mAh\n\t\t\t\t\t\t\t\t\t\t\t")]):_vm._e(),_vm._v(" "),(key == 'enginecapacity')?_c('span',{staticClass:"stext-102 cl6 size-206"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(value)+" cc\n\t\t\t\t\t\t\t\t\t\t\t")]):_vm._e(),_vm._v(" "),(key == 'mileage')?_c('span',{staticClass:"stext-102 cl6 size-206"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(value)+" km\n\t\t\t\t\t\t\t\t\t\t\t")]):_vm._e()]):_vm._e()})],2)])])])])])])])],1):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader"},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav nav-tabs",attrs:{"role":"tablist"}},[_c('li',{staticClass:"nav-item p-b-10"},[_c('a',{staticClass:"nav-link active",attrs:{"data-toggle":"tab","href":"#information","role":"tab"}},[_vm._v("Additional information")])]),_vm._v(" "),_c('li',{staticClass:"nav-item p-b-10"},[_c('a',{staticClass:"nav-link ",attrs:{"data-toggle":"tab","href":"#description","role":"tab"}},[_vm._v("Description")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StoreHome_vue__ = __webpack_require__(190);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2db53d77_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StoreHome_vue__ = __webpack_require__(568);
function injectStyle (ssrContext) {
  __webpack_require__(559)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2db53d77"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StoreHome_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2db53d77_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StoreHome_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 559 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(191);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48034892_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(562);
function injectStyle (ssrContext) {
  __webpack_require__(561)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-48034892"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48034892_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 561 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{staticClass:"loading"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.fetch)?_c('div',[_c('div',{staticClass:"wrap-slick1 rs1-slick1 shophome"},[_c('div',{staticClass:"slick1 shophome"},[_c('div',{staticClass:"item-slick1 shophome",style:({ backgroundImage: 'url(' + _vm.homeimg + ')' })},[_c('div',{staticClass:"container h-full",staticStyle:{"background-color":"#3333336e"}},[_c('div',{staticClass:"flex-col-l-m h-full p-t-0 p-b-30 m-p-t-00"},[_c('div',{},[_c('h2',{staticClass:"ltext-104 cl15 p-t-1 p-b-25 respon1 animated flip slower delay-3s",style:({color:_vm.color1})},[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.name)+"\n\t\t\t\t\t\t\t\t")])]),_vm._v(" "),(_vm.tel1 != '')?_c('div',{staticClass:"animated lightSpeedIn slower delay-2s"},[_c('span',{staticClass:"ltext-202 cl1 respon2",style:({color:_vm.color1})},[_vm._v("\n\t\t\t\t\t\t\t\t\t+94 "+_vm._s(_vm.tel1)+"\n\t\t\t\t\t\t\t\t")])]):_vm._e(),_vm._v(" "),(_vm.shops[0].details.lat && _vm.shops[0].details.lng)?_c('a',{attrs:{"href":("https://maps.google.com/?q=" + (_vm.shops[0].details.lat) + ", " + (_vm.shops[0].details.lng)),"target":"_blank","rel":"noopener noreferrer"}},[_c('el-button',{staticClass:"mt-3",attrs:{"size":"small","type":"success"}},[_vm._v("Get Direction")])],1):_vm._e()])])])])]),_vm._v(" "),_c('section',{staticClass:" section",staticStyle:{"padding-top":"30px"}},[_c('div',{staticClass:"container"},[(_vm.show)?_c('div',[(_vm.shops3[0].gallery.length >0)?_c('div',[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-8 col-md-10 col-12 mx-auto"},[_c('el-carousel',{attrs:{"interval":2000,"type":_vm.type}},_vm._l((_vm.shops3[0].gallery),function(item,i){return _c('el-carousel-item',{key:i},[_c('div',{staticClass:"mx-auto",staticStyle:{"width":"100%","height":"100%","overflow":"hidden","display":"block","background-position":"50%","background-repeat":"no-repeat","background-size":"contain"},style:({backgroundImage: 'url(' + item + ')'})})])}))],1)])]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.darea != undefined)?_c('div',{staticClass:"row mt-1 mx-auto"},[_c('div',{staticClass:"col-lg-10  col-md-10  col-sm-10 mx-auto",staticStyle:{"height":"auto"}},[_c('div',{staticClass:"category-block",staticStyle:{"background-color":"#fff"}},[_vm._m(2),_vm._v(" "),_c('ul',{staticClass:"category-list"},[_c('li',[_c('span',[_vm._v(_vm._s(_vm.darea))])])])])])]):_vm._e()]),_vm._v(" "),_c('div',[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"row mt-3"},_vm._l((_vm.shopcats),function(values,key){return _c('div',{key:key,staticClass:"col-lg-3 offset-lg-0 col-md-4 offset-md-1 col-sm-6",staticStyle:{"height":"auto"}},[_c('div',{staticClass:"category-block",staticStyle:{"background-color":"#fff"}},[_c('div',{staticClass:"header"},[_c('i',{staticClass:"fa fa-tag icon-bg-1"}),_vm._v(" "),_c('h4',[_c('a',[_vm._v(_vm._s(key))])])]),_vm._v(" "),_c('ul',{staticClass:"category-list"},_vm._l((values),function(value,key){return (value > 0)?_c('li',{key:key},[_c('router-link',{attrs:{"to":{name: 'storeproducts', params: {cat: key}}}},[_vm._v(_vm._s(key)),_c('span',[_vm._v(_vm._s(value))])])],1):_vm._e()}))])])}))]),_vm._v(" "),(this.products.length > 0)?_c('div',{staticClass:"p-b-10"},[_c('h3',{staticClass:"ltext-103 cl5 text-center"},[_vm._v("\n\t\t\t\tAll Products\n\t\t\t")])]):_vm._e(),_vm._v(" "),(this.products.length > 0)?_c('div',{staticClass:"container pb-4"},[_c('div',{staticClass:"row"},_vm._l((_vm.products),function(p,i){return _c('div',{key:i,staticClass:"col-6 col-sm-4 col-md-4 col-lg-3 my-2"},[_c('el-card',{attrs:{"body-style":{ padding: '0px' }}},[_c('div',{staticStyle:{"width":"100%","height":"300px","overflow":"hidden","display":"block","background-position":"50%","background-repeat":"no-repeat","background-size":"cover","cursor":"pointer"},style:({backgroundImage: 'url(' + p.image + ')'}),on:{"click":function($event){_vm.showDetails(p)}}}),_vm._v(" "),_c('div',{staticStyle:{"padding":"14px"}},[_c('span',{staticClass:"text-primary"},[_vm._v(" "+_vm._s(p.name))]),_vm._v(" "),_c('p',{staticClass:"my-1"},[_c('i',{staticClass:"fa fa-tag text-primary mr-1"}),_vm._v(" "+_vm._s(p.subcat))]),_vm._v(" "),_c('p',{staticClass:"my-1"},[((p.disprice != p.price ))?_c('span',{staticClass:"stext-105 cl15 m-txt",staticStyle:{"color":"#F03B3B","display":"block"}},[_c('i',{staticClass:"fa fa-tag text-primary mr-1"}),_vm._v("RS "+_vm._s(p.price))]):_vm._e(),_vm._v(" "),((p.disprice != p.price ))?_c('span',{staticClass:"stext-105 cl3 m-txt",staticStyle:{"text-decoration":"line-through"}},[_c('i',{staticClass:"fa fa-tag text-primary mr-1"}),_vm._v("\n\t\t\t\t\t\t\t\t\tRS "+_vm._s(p.disprice)+"\n\t\t\t\t\t\t\t\t\t")]):_vm._e(),_vm._v(" "),((p.disprice == p.price ))?_c('span',{staticClass:"stext-105 cl3 text-info m-txt"},[_c('i',{staticClass:"fa fa-tag text-primary mr-1"}),_vm._v("\n\t\t\t\t\t\t\t\t\tRS "+_vm._s(p.price)+"\n\t\t\t\t\t\t\t\t")]):_vm._e()])])])],1)}))]):_vm._e()])])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader"},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-b-10"},[_c('h3',{staticClass:"ltext-103 cl5 text-center"},[_vm._v("\n\t\t\t\t\t\tStore overview\n\t\t\t\t\t")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('i',{staticClass:"fa fa-truck icon-bg-1"}),_vm._v(" "),_c('h4',[_c('a',[_vm._v("Delivery Details & Special Notes")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-b-10"},[_c('h3',{staticClass:"ltext-103 cl5 text-center"},[_vm._v("\n\t\t\t\t\tCategories\n\t\t\t\t")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StoreFooter_vue__ = __webpack_require__(192);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e3664ce_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StoreFooter_vue__ = __webpack_require__(565);
function injectStyle (ssrContext) {
  __webpack_require__(564)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1e3664ce"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StoreFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e3664ce_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StoreFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 564 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('footer',{staticClass:"bg3 p-t-75 p-b-32 es-footer"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4 col-lg-4 p-b-20"},[_c('h4',{staticClass:"stext-301 shopin cl0 p-b-30 f-font"},[_vm._v("eshops.lk")]),_vm._v(" "),_c('ul',[_c('li',{staticClass:"p-b-10"},[_c('router-link',{staticClass:"stext-107 cl7 hov-cl1 trans-04",attrs:{"to":{ name: 'home' }}},[_vm._v("\n                  Home\n                ")])],1),_vm._v(" "),_c('li',{staticClass:"p-b-10"},[_c('router-link',{staticClass:"stext-107 cl7 hov-cl1 trans-04",attrs:{"to":{ name: 'about' }}},[_vm._v("\n                  About Us\n                ")])],1),_vm._v(" "),_c('li',{staticClass:"p-b-10"},[_c('router-link',{staticClass:"stext-107 cl7 hov-cl1 trans-04",attrs:{"to":{ name: 'termsofuse' }}},[_vm._v("\n                  Terms of Use\n                ")])],1),_vm._v(" "),_c('li',{staticClass:"p-b-10"},[_c('router-link',{staticClass:"stext-107 cl7 hov-cl1 trans-04",attrs:{"to":{ name: 'privacypolicy' }}},[_vm._v("\n                  Privacy Policy\n                ")])],1)]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"col-sm-4 col-lg-4 p-b-20"},[_c('h4',{staticClass:"stext-301 cl0 p-b-30 f-font"},[_vm._v("Store")]),_vm._v(" "),_c('ul',[_c('li',{staticClass:"p-b-10"},[_c('router-link',{staticClass:"stext-107 cl7 hov-cl1 trans-04",attrs:{"to":{
                    name: 'storehome',
                    params: { storename: this.$route.params.storename },
                  }}},[_vm._v("\n                  Home\n                ")])],1),_vm._v(" "),_c('li',{staticClass:"p-b-10"},[(_vm.plan != 'Starter')?_c('router-link',{staticClass:"stext-107 cl7 hov-cl1 trans-04",attrs:{"to":{
                    name: 'storecategories',
                    params: { storename: this.$route.params.storename },
                  }}},[_vm._v("\n                  Categories\n                ")]):_vm._e()],1),_vm._v(" "),_c('li',{staticClass:"p-b-10"},[_c('router-link',{staticClass:"stext-107 cl7 hov-cl1 trans-04",attrs:{"to":{
                    name: 'storeoffers',
                    params: { storename: this.$route.params.storename },
                  }}},[_vm._v("\n                  Offers\n                ")])],1),_vm._v(" "),_c('li',{staticClass:"p-b-10"},[_c('router-link',{staticClass:"stext-107 cl7 hov-cl1 trans-04",attrs:{"to":{
                    name: 'storecontact',
                    params: { storename: this.$route.params.storename },
                  }}},[_vm._v("\n                  Contact\n                ")])],1)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4 col-lg-4 p-b-30"},[_c('h4',{staticClass:"stext-301 cl0 p-b-20 f-font"},[_vm._v("GET IN TOUCH")]),_vm._v(" "),_c('p',{staticClass:"stext-107 cl7 size-201"},[_vm._v("\n              Any questions? Let us know in store at "+_vm._s(_vm.address)+" or call us on\n              +94 "+_vm._s(_vm.tel1)+"\n            ")]),_vm._v(" "),_vm._m(1)])]),_vm._v(" "),_c('div',{staticClass:"p-t-1"},[_vm._m(2),_vm._v(" "),_c('p',{staticClass:"stext-107 cl6 txt-center"},[_vm._v("\n            © "+_vm._s(new Date().getFullYear())+" eshops.lk | All Rights\n            Reserved\n          ")])])])]),_vm._v(" "),_c('footer',{staticClass:"app-footer"},[_c('ul',[_c('li',{on:{"click":function($event){_vm.setRoute('storehome')}}},[_c('i',{staticClass:"fa fa-home"}),_vm._v("\n          Home\n        ")]),_vm._v(" "),_c('li',{on:{"click":function($event){_vm.setRoute('storeoffers')}}},[_c('i',{staticClass:"fa fa-percent"}),_vm._v("\n          Offers\n        ")]),_vm._v(" "),_c('li',{on:{"click":function($event){_vm.setRoute('storecontact')}}},[_c('i',{staticClass:"fa fa-phone"}),_vm._v("\n          Contact\n        ")]),_vm._v(" "),(
            this.$store.state.searchLocation != undefined &&
            this.$store.state.searchLocation != ''
          )?_c('li',{on:{"click":function($event){_vm.setRoute2('search', _vm.searchQuery)}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v("\n          Search\n        ")]):_vm._e(),_vm._v(" "),(_vm.user)?_c('li',{on:{"click":function($event){_vm.setRoute('myaccount')}}},[_c('i',{staticClass:"fa fa-user"}),_vm._v("\n          Account\n        ")]):_vm._e(),_vm._v(" "),(_vm.admin)?_c('li',{on:{"click":function($event){_vm.setRoute('admin')}}},[_c('i',{staticClass:"fa fa-dashboard",staticStyle:{"font-size":"21px"}}),_vm._v("\n          Admin\n        ")]):_vm._e()])]),_vm._v(" "),_vm._m(3)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"social-media-icons mb-2 d-inline"},[_c('li',{},[_c('a',{staticClass:"px-0 ml-0 mr-2",attrs:{"href":"https://www.facebook.com/Eshopslk-2212428785713128/"}},[_c('i',{staticClass:"fa fa-facebook-official f-sm-link",staticStyle:{"font-size":"34px","color":"#3b5998","background-color":"#fff","width":"30px","height":"30px","border-radius":"4px","text-align":"center","vertical-align":"middle"}})])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"px-0 mx-2",attrs:{"href":"https://www.instagram.com/eshops.lk/"}},[_c('i',{staticClass:"fa fa-instagram f-sm-link",staticStyle:{"font-size":"30px","color":"#fff","background":"radial-gradient(","width":"32px","height":"32px","border-radius":"4px","text-align":"center","vertical-align":"middle"}})])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"px-0 mx-2",attrs:{"href":"https://www.youtube.com/channel/UCJhY3IfJD3T2bA5PJ3SrMZw"}},[_c('i',{staticClass:"fa fa-youtube-square f-sm-link",staticStyle:{"font-size":"35px","color":"#ff0000","background-color":"#fff","width":"30px","height":"30px","border-radius":"6px","text-align":"center","vertical-align":"middle"}})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-2 app-promotion"},[_c('a',[_c('img',{staticClass:"mt-3 mb-2",attrs:{"src":__webpack_require__(566),"alt":"mobile-icon"}})]),_vm._v(" "),_c('p',{staticClass:"m-f-text text-white"},[_vm._v("\n                Tap the Add to Home Screen Tab in Chrome Browser on Android or\n                Safari Browser on IOS to Get the Splendid\n                "),_c('span',{staticStyle:{"color":"#fd6a02","font-size":"20px"}},[_vm._v("Mobile App")]),_vm._v("\n                Directly\n              ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-c-m flex-w p-b-18"},[_c('a',{staticClass:"m-all-1"},[_c('img',{attrs:{"src":__webpack_require__(25),"alt":"eshops-logo"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-back-to-top",attrs:{"id":"myBtn"}},[_c('span',{staticClass:"symbol-btn-back-to-top"},[_c('i',{staticClass:"fa fa-chevron-up"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 566 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 567 */
/***/ (function(module, exports) {

// Github repo: https://github.com/jansson/jquery.imagezoom

(function ($) {

  $.fn.zoom = function (action) {
    var touchStateKey = 'zoomTouchState';

    var mouseMoveHandler = function mouseMoveHandler(e) {
      e.stopPropagation();

      var $mouseZoom = $(this).find('.jsZoomMouse');
      var $image = $(this).find('img');

      loadHqImage($(this));

      $image.css({ visibility: 'visible' });
      resetTouch($(this));

      var offset = $(this).offset();
      var x = e.pageX - offset.left;
      var y = e.pageY - offset.top;

      if (x < 0 || x > $(this).width() || y < 0 || y > $(this).height()) {
        $mouseZoom.hide();
        return;
      }

      $mouseZoom.css({
        'top': y - $mouseZoom.height() / 2,
        'left': x - $mouseZoom.width() / 2,
        'background-position': x / $(this).width() * 100 + '% ' + y / $(this).height() * 100 + '%',
        'background-size': $(this).width() * 3 + 'px ' + $(this).height() * 3 + 'px'
      });

      // Make sure this is the only zoom shown on page (in case there are multiple pages)
      $('.jsZoomMouse').hide();
      $mouseZoom.show();
    };

    var touchStartHandler = function touchStartHandler(e) {
      var $container = $(this);
      var $image = $(this).find('img');
      var $mouseZoom = $(this).find('.jsZoomMouse');
      var offset = $container.offset();
      var touchState = $container.data(touchStateKey);

      loadHqImage($container);

      $mouseZoom.hide();
      $image.css({ visibility: 'hidden' });

      if (e.originalEvent.touches.length == 2) {

        $image.css({ visibility: 'hidden' });

        touchState.startPinch = distance(toPoint(e.originalEvent.touches[0]), toPoint(e.originalEvent.touches[1]));

        touchState.startPan = toPoint(e.originalEvent.touches[0].pageX - offset.left, e.originalEvent.touches[0].pageY - offset.top);
        touchState.startZoom = touchState.currentZoom;
      } else if (e.originalEvent.touches.length == 1) {

        touchState.startPan = toPoint(e.originalEvent.touches[0].pageX - offset.left, e.originalEvent.touches[0].pageY - offset.top);
        touchState.startPosition = copyPoint(touchState.currentPosition);
      }

      applyTouch($container);
    };

    var touchEndHandler = function touchEndHandler(e) {
      var $container = $(this);
      var offset = $container.offset();
      var touchState = $container.data(touchStateKey);

      // Prevent touch from simulating mouseclick/move
      if (e.cancelable) {
        e.preventDefault();
      }

      if (e.originalEvent.touches.length == 1) {

        touchState.startPan = toPoint(e.originalEvent.touches[0].pageX - offset.left, e.originalEvent.touches[0].pageY - offset.top);
        touchState.startPosition = copyPoint(touchState.currentPosition);
      }

      applyTouch($container);
    };

    var touchMoveHandler = function touchMoveHandler(e) {
      var $container = $(this);
      var $mouseZoom = $(this).find('.jsZoomMouse');
      var $image = $(this).find('img');
      var touchState = $container.data(touchStateKey);
      var offset = $container.offset();
      var originalPosition = copyPoint(touchState.currentPosition);

      var currentPan = toPoint(e.originalEvent.touches[0].pageX - offset.left, e.originalEvent.touches[0].pageY - offset.top);

      if (e.originalEvent.touches.length == 2) {

        var preZoom = toPoint((touchState.currentPosition.x + currentPan.x) / ($container.width() * touchState.currentZoom), (touchState.currentPosition.y + currentPan.y) / ($container.height() * touchState.currentZoom));

        var dst = distance(toPoint(e.originalEvent.touches[0]), toPoint(e.originalEvent.touches[1]));

        touchState.currentZoom = touchState.startZoom * (dst / touchState.startPinch);
        if (touchState.currentZoom < 1) {
          touchState.currentZoom = 1;
        }
        if (touchState.currentZoom > 10) {
          touchState.currentZoom = 10;
        }

        touchState.currentPosition = toPoint(preZoom.x * $container.width() * touchState.currentZoom - currentPan.x, preZoom.y * $container.height() * touchState.currentZoom - currentPan.y);
      } else if (e.originalEvent.touches.length == 1) {

        touchState.currentPosition = toPoint(touchState.currentPosition.x = touchState.startPosition.x + (touchState.startPan.x - currentPan.x), touchState.currentPosition.y = touchState.startPosition.y + (touchState.startPan.y - currentPan.y));
      }

      var zoomWidth = $container.width() * touchState.currentZoom;
      var zoomHeight = $container.height() * touchState.currentZoom;

      if (touchState.currentPosition.x < 0) {
        touchState.currentPosition.x = 0;
      }
      if (touchState.currentPosition.x + $container.width() > zoomWidth) {
        touchState.currentPosition.x = zoomWidth - $container.width();
      }
      if (touchState.currentPosition.y < 0) {
        touchState.currentPosition.y = 0;
      }
      if (touchState.currentPosition.y + $container.height() > zoomHeight) {
        touchState.currentPosition.y = zoomHeight - $container.height();
      }

      applyTouch($container);

      if (touchState.currentZoom > 1) {
        e.stopPropagation();
        e.preventDefault();
      }
    };

    var resetTouch = function resetTouch($container) {
      var touchState = $container.data(touchStateKey);

      if (touchState) {
        touchState.startPinch = 0;
        touchState.startZoom = 1;
        touchState.startPan = toPoint(0, 0);
        touchState.startPosition = toPoint(0, 0);
        touchState.currentZoom = 1;
        touchState.currentPosition = toPoint(0, 0);

        applyTouch($container);
      }
    };

    var applyTouch = function applyTouch($container) {
      var touchState = $container.data(touchStateKey);

      if (touchState.currentZoom > 1) {
        $container.addClass('jsZoomTouchZoomed');
      } else {
        $container.removeClass('jsZoomTouchZoomed');
      }

      $container.css({
        'background-size': touchState.currentZoom * 100 + '%',
        'background-position': -touchState.currentPosition.x + 'px ' + -touchState.currentPosition.y + 'px'
      });
    };

    var loadHqImage = function loadHqImage($target) {
      var $mouseZoom = $target.find('.jsZoomMouse');
      var $image = $target.find('img');

      if (!$target.hasClass('jsZoomHqLoaded')) {
        $target.addClass('jsZoomHqLoaded');

        $target.css({
          'background-image': 'url(' + $image.attr('src') + ')'
        });
        $mouseZoom.css({
          'background-image': 'url(' + $image.attr('src') + ')'
        });

        var hqImage = $target.attr('data-zoom');
        if (hqImage) {
          var img = new Image();

          img.onload = function () {
            $target.css({
              'background-image': 'url(' + hqImage + ')'
            });
            $mouseZoom.css({
              'background-image': 'url(' + hqImage + ')'
            });
            hqImageState = 'loaded';
          };

          img.src = $target.attr('data-zoom');
        }
      }
    };

    var toPoint = function toPoint(obj1, obj2) {
      if (typeof obj1.pageX === 'number' && typeof obj1.pageY === 'number') {
        return { x: obj1.pageX, y: obj1.pageY };
      } else if (typeof obj1 === 'number' && typeof obj2 === 'number') {
        return { x: obj1, y: obj2 };
      }

      throw 'Could not convert to point. Unrecognized object: ' + obj1;
    };

    var copyPoint = function copyPoint(point) {
      return { x: point.x, y: point.y };
    };

    /**
     * Calculates the distance between two points
     */
    var distance = function distance(point1, point2) {
      var x = point1.x - point2.x;
      if (x < 0) {
        x *= -1;
      }
      var y = point1.y - point2.y;
      if (y < 0) {
        y *= -1;
      }
      return Math.round(Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2)));
    };

    /**
     * Calculates the center point between two points
     */
    var center = function center(point1, point2) {
      var x = point1.x - (point1.x - point2.x) / 2;
      var y = point1.y - (point1.y - point2.y) / 2;
      return [x, y];
    };

    if (action === 'reset') {
      this.each(function (idx, elem) {
        resetTouch($(elem));
      });
    } else {

      this.css({
        'position': 'relative',
        'background-repeat': 'no-repeat'
      });
      this.addClass('jsZoom');
      if ('ontouchstart' in document.documentElement) {
        this.addClass("jsZoomTouch");
      }
      this.find('img').css({ 'display': 'block' });

      this.append($('<div class="jsZoomMouse" style="display: none; position: absolute; height: 300px; width: 300px; z-index: 9999; border-radius: 200px; background-repeat: no-repeat;"/>'));

      this.each(function (idx, elem) {
        $(elem).data(touchStateKey, {
          startPinch: 0,
          startZoom: 1,
          startPan: toPoint(0, 0),
          startPosition: toPoint(0, 0),
          currentZoom: 1,
          currentPosition: toPoint(0, 0)
        });
      });

      this.on('mousemove', mouseMoveHandler);
      this.on("touchstart", touchStartHandler);
      this.on("touchend", touchEndHandler);
      this.on("touchmove", touchMoveHandler);

      $(document).on('mousemove', function () {
        $('.jsZoomMouse').hide();
      });
    }
  };
})(jQuery);

/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.show2)?_c('div',[_c('StoreNavbar'),_vm._v(" "),(_vm.show)?_c('Home'):_vm._e(),_vm._v(" "),_c('router-view',{key:_vm.$route.fullPath}),_vm._v(" "),_c('StoreFooter')],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__ = __webpack_require__(193);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b3fd57f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__ = __webpack_require__(571);
function injectStyle (ssrContext) {
  __webpack_require__(570)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2b3fd57f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b3fd57f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 570 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{staticClass:"loading"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.fetch)?_c('div',[_c('h2',{staticClass:"ltext-105 pt-4 txt-center"},[_vm._v("\n\t\t\tContact\n\t\t")]),_vm._v(" "),_c('section',{staticClass:"pt-4"},[_c('div',{staticClass:"container"},[_c('div',{},[_c('div',{staticClass:" p-b-20 p-t-15  "},[_c('div',{staticClass:"flex-w w-full p-b-42"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"size-212 p-t-2"},[_c('span',{staticClass:"mtext-110 cl2"},[_vm._v("\n\t\t\t\t\t\t\t\tOpen - Close Time\n\t\t\t\t\t\t\t")]),_vm._v(" "),_c('p',{staticClass:"stext-115 cl1 size-213 p-t-18"},[_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(_vm.stime)+" AM - "+_vm._s(_vm.etime)+" PM\n\t\t\t\t\t\t\t")])])]),_vm._v(" "),_c('div',{staticClass:"flex-w w-full p-b-42"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"size-212 p-t-2"},[_c('span',{staticClass:"mtext-110 cl2"},[_vm._v("\n\t\t\t\t\t\t\t\tAddress\n\t\t\t\t\t\t\t")]),_vm._v(" "),_c('p',{staticClass:"stext-115 cl6 size-213 p-t-18"},[_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(_vm.address)+"\n\t\t\t\t\t\t\t")])])]),_vm._v(" "),_c('div',{staticClass:"flex-w w-full p-b-42"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"size-212 p-t-2"},[_c('span',{staticClass:"mtext-110 cl2"},[_vm._v("\n\t\t\t\t\t\t\t\tLets Talk\n\t\t\t\t\t\t\t")]),_vm._v(" "),(_vm.tel1 != '')?_c('p',{staticClass:"stext-115 cl1 size-213 p-t-18"},[_vm._v("\n\t\t\t\t\t\t\t\t+94 "+_vm._s(_vm.tel1)+"\n\t\t\t\t\t\t\t")]):_vm._e(),_vm._v(" "),(_vm.tel2 != '')?_c('p',{staticClass:"stext-115 cl1 size-213 p-t-18"},[_vm._v("\n\t\t\t\t\t\t\t\t+94 "+_vm._s(_vm.tel2)+"\n\t\t\t\t\t\t\t")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"flex-w w-full"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"size-212 p-t-2"},[_c('span',{staticClass:"mtext-110 cl2"},[_vm._v("\n\t\t\t\t\t\t\t\tSale Support\n\t\t\t\t\t\t\t")]),_vm._v(" "),_c('p',{staticClass:"stext-115 cl6 size-213 p-t-18"},[_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(_vm.email)+"\n\t\t\t\t\t\t\t")])])])])])])])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader"},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"fs-18 cl5 txt-center size-211"},[_c('i',{staticClass:"fa fa-clock-o"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"fs-18 cl5 txt-center size-211"},[_c('i',{staticClass:"fa fa-map-marker"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"fs-18 cl5 txt-center size-211"},[_c('i',{staticClass:"fa fa-phone"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"fs-18 cl5 txt-center size-211"},[_c('i',{staticClass:"fa fa-envelope"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__ = __webpack_require__(194);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_652330b1_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__ = __webpack_require__(574);
function injectStyle (ssrContext) {
  __webpack_require__(573)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-652330b1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_652330b1_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 573 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{staticClass:"loading"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.fetch)?_c('div',[_c('h2',{staticClass:"ltext-105 pt-4 txt-center"},[_vm._v("\n\t\t\tAbout Us\n\t")]),_vm._v(" "),_c('section',{staticClass:"p-t-40 p-b-50"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row p-b-60"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"p-t-7 p-r-50 p-l-50 p-r-15-lg p-r-0-md"},[_c('h3',{staticClass:"mtext-111 cl2 p-b-16"},[_vm._v("\n\t\t\t\t\t\t\tOur Story\n\t\t\t\t\t\t")]),_vm._v(" "),_c('p',{staticClass:"stext-113 cl6 p-b-26"},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm.about)+"\n\t\t\t\t\t\t")]),_vm._v(" "),(_vm.address != '')?_c('p',{staticClass:"stext-113 cl6 p-b-26"},[_vm._v("\n\t\t\t\t\t\t\tAny questions? Let us know in store at "+_vm._s(_vm.address)+" or call us on +94"+_vm._s(_vm.tel1)+"\n\t\t\t\t\t\t")]):_vm._e()])]),_vm._v(" "),(_vm.aboutimg != undefined)?_c('div',{staticClass:"col-11 col-md-5 m-lr-auto"},[_c('div',{staticClass:"how-bor1 "},[_c('div',{staticClass:"hov-img0"},[_c('img',{attrs:{"src":_vm.aboutimg,"alt":"IMG"}})])])]):_vm._e()])])])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader"},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserSignup_vue__ = __webpack_require__(195);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e786b462_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserSignup_vue__ = __webpack_require__(580);
function injectStyle (ssrContext) {
  __webpack_require__(576)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e786b462"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserSignup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e786b462_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserSignup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 576 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{staticClass:"loading"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.fetch)?_c('div',[_c('div',{staticStyle:{"background-size":"cover","background-position":"center left"}},[_c('nav',{staticClass:"navbar",staticStyle:{"background-color":"rgba()"}},[_c('router-link',{staticClass:"navbar-brand",attrs:{"to":"/"}},[_c('img',{attrs:{"src":__webpack_require__(13),"width":"50","height":"50","alt":"eshops-logo"}})]),_vm._v(" "),_c('div',[_c('router-link',{staticClass:"text-info mr-1 m-link",attrs:{"to":"/"}},[_vm._v("Home")])],1)],1),_vm._v(" "),_c('div',{staticStyle:{"background-color":"rgba(0, 0, 0, 0)","height":"100%"}},[_c('div',{staticClass:"col-sm-8 col-md-4 m-auto pb-5"},[_c('h2',{staticClass:"m-auto text-center pt-5 pb-2",staticStyle:{"color":"#e94de9"}},[_vm._v("\n            User Sign Up\n          ")]),_vm._v(" "),_c('el-form',{ref:"formdata",staticStyle:{"border":"1px solid #e2e2e2","border-radius":"5px","background-color":"#fff","padding":"20px"},attrs:{"model":_vm.formdata,"status-icon":"","rules":_vm.rules2,"label-width":"120px","label-position":_vm.labelPosition,"size":"medium"}},[_c('el-form-item',{attrs:{"label":"Name","prop":"name","rules":[
                {
                  required: true,
                  message: 'Please input your name',
                  trigger: 'blur',
                } ]}},[_c('el-input',{attrs:{"placeholder":"Name"},model:{value:(_vm.formdata.name),callback:function ($$v) {_vm.$set(_vm.formdata, "name", $$v)},expression:"formdata.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Telephone","prop":"telephone","rules":[
                { required: true, message: 'telephone no is required' },
                { type: 'number', message: 'telephone no must be a number' } ]}},[_c('el-input',{attrs:{"placeholder":"777666666 (without 0)","auto-complete":"off"},model:{value:(_vm.formdata.telephone),callback:function ($$v) {_vm.$set(_vm.formdata, "telephone", _vm._n($$v))},expression:"formdata.telephone"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"email","label":"Email","rules":[
                {
                  required: true,
                  message: 'Please input email address',
                  trigger: 'blur',
                },
                {
                  type: 'email',
                  message: 'Please input correct email address',
                  trigger: ['blur', 'change'],
                } ]}},[_c('el-input',{attrs:{"placeholder":"Email","type":"email"},model:{value:(_vm.formdata.email),callback:function ($$v) {_vm.$set(_vm.formdata, "email", $$v)},expression:"formdata.email"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Password","prop":"pass"}},[_c('el-input',{attrs:{"placeholder":"Password","type":"password","auto-complete":"off"},model:{value:(_vm.formdata.pass),callback:function ($$v) {_vm.$set(_vm.formdata, "pass", $$v)},expression:"formdata.pass"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Confirm Password","prop":"checkPass"}},[_c('el-input',{attrs:{"placeholder":"Confirm Password","type":"password","auto-complete":"off"},model:{value:(_vm.formdata.checkPass),callback:function ($$v) {_vm.$set(_vm.formdata, "checkPass", $$v)},expression:"formdata.checkPass"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"pb-5 pt-2",staticStyle:{"margin-bottom":"0px"}},[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.submitForm('formdata')}}},[_vm._v("Sign up")]),_vm._v(" "),_c('el-button',{on:{"click":function($event){_vm.resetForm('formdata')}}},[_vm._v("Reset")])],1)],1)],1)])])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader"},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Signin_vue__ = __webpack_require__(196);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b8994ca_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Signin_vue__ = __webpack_require__(583);
function injectStyle (ssrContext) {
  __webpack_require__(582)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2b8994ca"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Signin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b8994ca_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Signin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 582 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{staticClass:"loading"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.fetch)?_c('div',[_c('div',{staticClass:" mb-signin-bac",staticStyle:{"background-size":"cover","background-position":"center left","height":"100vh"}},[_c('nav',{staticClass:"navbar  ",staticStyle:{"background-color":"rgba()"}},[_c('router-link',{staticClass:"navbar-brand ",attrs:{"to":"/"}},[_c('img',{attrs:{"src":__webpack_require__(13),"width":"50","height":"50","alt":"eshops-logo"}})]),_vm._v(" "),_c('div',[_c('router-link',{staticClass:"text-info mr-1 m-link",attrs:{"to":"/"}},[_vm._v("Home")])],1)],1),_vm._v(" "),_c('div',{staticClass:" ",staticStyle:{"background-color":"rgba(0, 0,0, 0.0)"}},[_c('div',{staticClass:"col-sm-8 col-md-4 m-auto "},[_c('h3',{staticClass:"m-auto text-center pt-5 pb-2",staticStyle:{"color":"#E94DE9"}},[_vm._v("Sign in")]),_vm._v(" "),_c('b-modal',{staticClass:"text-center text-info",attrs:{"centered":"","ok-only":""},model:{value:(_vm.modalShow),callback:function ($$v) {_vm.modalShow=$$v},expression:"modalShow"}},[_vm._v("\r\n      Please Enter Email!\r\n    ")]),_vm._v(" "),_c('b-modal',{staticClass:"text-center text-info",attrs:{"centered":""},model:{value:(_vm.modalShow2),callback:function ($$v) {_vm.modalShow2=$$v},expression:"modalShow2"}},[_vm._v("\r\n      Password Reset Email is Sent to Your Email!\r\n    ")]),_vm._v(" "),_c('el-form',{ref:"ruleForm3",staticStyle:{"border":"1px solid #e2e2e2","border-radius":"5px","background-color":"#fff","padding":"20px"},attrs:{"model":_vm.ruleForm3,"status-icon":"","label-width":"120px","label-position":_vm.labelPosition,"size":"medium"}},[_c('el-form-item',{attrs:{"prop":"email","label":"Email","rules":[
      { required: true, message: 'Please input email address', trigger: 'blur' },
      { type: 'email', message: 'Please input correct email address', trigger: ['blur', 'change'] }
    ]}},[_c('el-input',{attrs:{"type":"email"},model:{value:(_vm.ruleForm3.email),callback:function ($$v) {_vm.$set(_vm.ruleForm3, "email", $$v)},expression:"ruleForm3.email"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Password","prop":"pass","rules":[
      { required: true, message: 'Please input password', trigger: 'blur' }
    ]}},[_c('el-input',{attrs:{"type":"password","auto-complete":"off"},model:{value:(_vm.ruleForm3.pass),callback:function ($$v) {_vm.$set(_vm.ruleForm3, "pass", $$v)},expression:"ruleForm3.pass"}})],1),_vm._v(" "),_c('p',[_c('span',{staticClass:"pass text-danger pb-2",on:{"click":function($event){_vm.respsw()}}},[_vm._v("Forgot Password?")])]),_vm._v(" "),_c('el-form-item',{staticClass:"pt-3"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.signin('ruleForm3')}}},[_vm._v("Sign in")]),_vm._v(" "),_c('el-button',{on:{"click":function($event){_vm.resetForm('ruleForm3')}}},[_vm._v("Reset")])],1)],1)],1)])])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader"},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckEmail_vue__ = __webpack_require__(197);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10822903_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckEmail_vue__ = __webpack_require__(586);
function injectStyle (ssrContext) {
  __webpack_require__(585)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-10822903"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckEmail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10822903_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckEmail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 585 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-modal',{staticClass:"text-center text-info",attrs:{"centered":"","ok-only":"","centered":""},model:{value:(_vm.modalShow),callback:function ($$v) {_vm.modalShow=$$v},expression:"modalShow"}},[_vm._v("\n    Please Verify Your Email First!!!\n  ")]),_vm._v(" "),_c('b-modal',{staticClass:"text-center text-info",attrs:{"ok-only":"","centered":""},model:{value:(_vm.modalShow2),callback:function ($$v) {_vm.modalShow2=$$v},expression:"modalShow2"}},[_vm._v("\n  \t  You have successfully registered. We will contact you soon. \n  \t")]),_vm._v(" "),_c('div',{staticClass:"container",staticStyle:{"min-height":"100vh"}},[_c('div',{staticClass:"row col-md-8 mx-auto"},[_c('div',{staticClass:"mt-5 mb-5 mx-auto text-center text-danger h4"},[_vm._v("An Email is Sent to Your Email Address. Please Check Your Email and Follow the Link to Verify  Your Email and Then Sign In.")]),_vm._v(" "),_c('div',{staticClass:"mx-auto text-center  m-btn",staticStyle:{"z-index":"5"}},[_c('a',{staticClass:"button sec py-2  text-white ",staticStyle:{"text-decoration":"none","font-size":"15px"},on:{"click":function($event){_vm.signin()}}},[_vm._v("Sign In")])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyAccount_vue__ = __webpack_require__(198);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_568a777c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyAccount_vue__ = __webpack_require__(589);
function injectStyle (ssrContext) {
  __webpack_require__(588)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-568a777c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyAccount_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_568a777c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyAccount_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 588 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{staticClass:"loading"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.fetch)?_c('div',[_c('section',[_c('nav',{staticClass:"navbar navbar-expand-lg navbar-dark bg-dark m-nav"},[_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse",attrs:{"id":"navbarSupportedContent"}},[_c('ul',{staticClass:"navbar-nav mr-auto"},[_c('li',{staticClass:"nav-item mt-3"},[_c('router-link',{staticClass:"m-link nav-link text-white",attrs:{"to":{ name: 'home' }}},[_vm._v("Home")])],1),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"m-link nav-link text-white",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.logout()}}},[_vm._v("Sign out")])])])])]),_vm._v(" "),_c('nav',{staticClass:"navbar navbar-dark bg-dark d-nav"},[_vm._m(3),_vm._v(" "),_c('div',[_c('router-link',{staticClass:"text-white mr-3",attrs:{"to":{ name: 'home' }}},[_vm._v("\n              Home\n            ")]),_vm._v(" "),_c('a',{staticClass:"text-white mr-5",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.logout()}}},[_vm._v("Sign out")])],1)]),_vm._v(" "),_c('div',{staticClass:"outer-menu d-nav"},[_c('input',{staticClass:"checkbox-toggle",attrs:{"type":"checkbox"}}),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('div',{staticClass:"menu"},[_c('div',[_c('div',[_c('ul',[_c('li',[_c('router-link',{staticClass:"text-white",attrs:{"to":{ name: 'home' }}},[_vm._v("\n                      Home\n                    ")])],1),_vm._v(" "),_c('li',[_c('a',{staticClass:"text-white",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.logout()}}},[_vm._v("Sign out")])])])])])])])]),_vm._v(" "),_c('section',{staticClass:"section-sm",staticStyle:{"padding-top":"15px"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row mb-4"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"search-result bg-gray text-center"},[_vm._m(5),_vm._v(" "),_c('h6',[_vm._v("\n                  Your Reference code is "),_c('b',[_vm._v(_vm._s(_vm.refCode))])]),_vm._v(" "),_c('h5',{staticClass:"mt-3"},[_vm._v("Your Reference shops")])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-12 mt-1"},[_c('el-card',{attrs:{"shadow":"always"}},[_c('b-table',{staticClass:"mt-4",attrs:{"show-empty":"","stacked":"sm","items":_vm.items,"fields":_vm.fields,"hover":true,"head-variant":"dark","dark":false,"small":true,"current-page":1,"per-page":100,"filter":_vm.filter,"empty-text":_vm.emptyText,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event}},scopedSlots:_vm._u([{key:"id",fn:function(row){return [_c('div',[_vm._v(_vm._s(row.value))])]}},{key:"cell(actions)",fn:function(row){return [_c('div',{staticClass:"btn-group",attrs:{"role":"group","aria-label":"Basic example"}},[_c('a',{staticClass:"btn btn-sm btn-success text-white",attrs:{"href":("tel:" + (row.item.telephone)),"size":"sm"}},[_vm._v("\n                        Call\n                      ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-secondary text-white",attrs:{"href":("sms:" + (row.item.telephone)),"size":"sm"}},[_vm._v("\n                        SMS\n                      ")])])]}}])})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"product-grid-list"},[_c('div',{staticClass:"row mt-30 justify-content-around"},[(_vm.noresults)?_c('div',{staticClass:"mt-3 mb-2 text-center text-danger h4"},[_vm._v("\n                    You Haven't Added Any Favourite Shops Yet\n                  ")]):_vm._e(),_vm._v(" "),(_vm.nofavshops)?_c('div',{staticClass:"mt-3 mb-2 text-center text-danger h4"},[_vm._v("\n                    You Haven't Any Favourite Shops\n                  ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.shops),function(shop,i){return [_c('div',{key:shop.id,staticClass:"col-12 col-sm-6 col-md-6 col-lg-4"},[_c('div',{staticClass:"product-item bg-light"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"block2-pic hov-img0"},[(
                                shop.isHosted != true && shop.isCloned != true
                              )?_c('router-link',{attrs:{"to":{
                                name: 'storehome',
                                params: { storename: shop.owner },
                              }}},[_c('img',{attrs:{"src":shop.homeimg,"alt":"IMG-SHOP"},on:{"click":function($event){_vm.userVisits(i)}}})]):_vm._e(),_vm._v(" "),(shop.isCloned == true)?_c('router-link',{attrs:{"to":{
                                name: 'storehome',
                                params: { storename: shop.realOwner },
                              }}},[_c('img',{attrs:{"src":shop.homeimg,"alt":"IMG-SHOP"},on:{"click":function($event){_vm.userVisits(i)}}})]):_vm._e(),_vm._v(" "),(shop.isHosted == true)?_c('a',{attrs:{"target":"blank","href":shop.domain}},[_c('img',{attrs:{"src":shop.homeimg,"alt":"IMG-SHOP"},on:{"click":function($event){_vm.userVisits(i)}}})]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('span',{staticClass:"float-right"},[_c('i',{staticClass:"fa fa-trash fa-lg text-danger",staticStyle:{"cursor":"pointer","font-size":"20px"},on:{"click":function($event){_vm.delFavShop(shop)}}})]),_vm._v(" "),_vm._m(6,true),_vm._v(" "),(
                                shop.isHosted != true && shop.isCloned != true
                              )?_c('span',{staticClass:"card-title",on:{"click":function($event){_vm.userVisits(i)}}},[_c('router-link',{staticClass:"text-primary",attrs:{"to":{
                                  name: 'storehome',
                                  params: { storename: shop.owner },
                                }}},[_vm._v(_vm._s(shop.name))])],1):_vm._e(),_vm._v(" "),(shop.isCloned == true)?_c('span',{staticClass:"card-title",on:{"click":function($event){_vm.userVisits(i)}}},[_c('router-link',{staticClass:"text-primary",attrs:{"to":{
                                  name: 'storehome',
                                  params: { storename: shop.realOwner },
                                }}},[_vm._v(_vm._s(shop.name))])],1):_vm._e(),_vm._v(" "),(shop.isHosted == true)?_c('span',{staticClass:"card-title",on:{"click":function($event){_vm.userVisits(i)}}},[_c('a',{staticClass:"text-primary",attrs:{"href":shop.domain,"target":"blank"}},[_vm._v(_vm._s(shop.name))])]):_vm._e(),_vm._v(" "),(
                                shop.plan == 'Premium' ||
                                shop.plan == 'Enterprise'
                              )?_c('ul',{staticClass:"list-inline product-meta mb-1 mt-2"},[_vm._m(7,true)]):_vm._e(),_vm._v(" "),_c('ul',{staticClass:"list-inline product-meta mb-1"},[_c('li',{staticClass:"list-inline-item mr-2"},[_c('a',{},[_c('i',{staticClass:"fa fa-map-marker",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(shop.location))])])]),_vm._v(" "),_c('ul',{staticClass:"list-inline product-meta mb-1"},[_c('li',{staticClass:"list-inline-item"},[_c('a',{},[_c('i',{staticClass:"fa fa-tag",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(shop.category))])])]),_vm._v(" "),(shop.shoptype != '')?_c('ul',{staticClass:"list-inline product-meta mb-1"},[_c('li',{staticClass:"list-inline-item"},[_c('a',{},[_c('i',{staticClass:"fa fa-tag",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(shop.shoptype))])])]):_vm._e(),_vm._v(" "),(shop.details.etime && shop.details.stime)?_c('ul',{staticClass:"list-inline product-meta mb-1"},[_c('li',{staticClass:"list-inline-item mr-2"},[_c('a',{},[_c('i',{staticClass:"fa fa-clock-o",attrs:{"aria-hidden":"true"}}),_vm._v("Open - Close "+_vm._s(shop.details.stime)+" AM -\n                                  "+_vm._s(shop.details.etime)+" PM\n                                ")])])]):_vm._e(),_vm._v(" "),(shop.details.tel1)?_c('ul',{staticClass:"list-inline product-meta mb-1"},[_c('li',{staticClass:"list-inline-item"},[_c('a',[_c('i',{staticClass:"fa fa-phone-square",attrs:{"aria-hidden":"true"}}),_vm._v("+94 "+_vm._s(shop.details.tel1))])])]):_vm._e(),_vm._v(" "),(shop.details.address)?_c('ul',{staticClass:"list-inline product-meta mb-2"},[_c('li',{staticClass:"list-inline-item"},[_c('a',[_c('i',{staticClass:"fa fa-address-card",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(shop.details.address))])])]):_vm._e()])])])])]})],2)])])])])]),_vm._v(" "),_c('footer',{staticClass:"footer section section-sm"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-around"},[_c('div',{staticClass:"col-sm-6 col-lg-3"},[_c('div',{staticClass:"block block-link"},[_c('h4',[_vm._v("Site Pages")]),_vm._v(" "),_c('ul',[_c('li',{staticClass:"px-0"},[_c('router-link',{attrs:{"to":{ name: 'home' }}},[_vm._v("Home")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'startstore' }}},[_vm._v("Start Store")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'about' }}},[_vm._v("About Us")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'termsofuse' }}},[_vm._v("Terms of Use")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'privacypolicy' }}},[_vm._v("Privacy Policy")])],1)])])]),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9)])])]),_vm._v(" "),_vm._m(10),_vm._v(" "),_c('back-to-top',{attrs:{"bottom":"50px","right":"50px"}},[_c('button',{staticClass:"btn btn-info btn-to-top",attrs:{"type":"button"}},[_c('i',{staticClass:"fa fa-chevron-up"})])])],1):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader"},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"navbar-brand",attrs:{"href":"#"}},[_c('img',{attrs:{"src":__webpack_require__(65),"alt":"eshops-logo"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"navbar-toggler float-right",attrs:{"type":"button","data-toggle":"collapse","data-target":"#navbarSupportedContent","aria-controls":"navbarSupportedContent","aria-expanded":"false","aria-label":"Toggle navigation"}},[_c('span',{staticClass:"navbar-toggler-icon"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"navbar-brand",attrs:{"href":"#"}},[_c('img',{attrs:{"src":__webpack_require__(65),"alt":"eshops-logo"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hamburger"},[_c('div')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{staticStyle:{"letter-spacing":"-2px"}},[_c('span',{staticClass:"text-secondary"},[_vm._v("My")]),_vm._v(" "),_c('span',{staticStyle:{"color":"orange","letter-spacing":"-5px"}},[_vm._v("S")]),_vm._v(" "),_c('span',{staticStyle:{"color":"red","letter-spacing":"-5px"}},[_vm._v("H")]),_vm._v(" "),_c('span',{staticStyle:{"color":"blue","letter-spacing":"-5px"}},[_vm._v("O")]),_vm._v(" "),_c('span',{staticStyle:{"color":"green","letter-spacing":"-5px"}},[_vm._v("P")]),_vm._v(" "),_c('span',{staticStyle:{"color":"purple","letter-spacing":"-5px"}},[_vm._v("i")]),_vm._v(" "),_c('span',{staticStyle:{"color":"purple","letter-spacing":"-5px"}},[_vm._v("N")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"float-right mr-3"},[_c('i',{staticClass:"fa fa-heart-o text-danger",staticStyle:{"font-size":"18px"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"list-inline-item mr-2"},[_c('a',{staticStyle:{"color":"red"}},[_c('i',{staticClass:"fa fa-home",attrs:{"aria-hidden":"true"}}),_vm._v("Home Deliver")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-6 col-lg-4"},[_c('div',{staticClass:"block block-info"},[_c('h4',[_vm._v("Contact Us")]),_vm._v(" "),_c('ul',[_c('li',[_c('a',[_c('i',{staticClass:"fa fa-phone mr-2",attrs:{"aria-hidden":"true"}}),_vm._v("011-360-1-444")])]),_vm._v(" "),_c('li',[_c('a',[_c('i',{staticClass:"fa fa-phone mr-2",attrs:{"aria-hidden":"true"}}),_vm._v("0719\n                      500 600")])]),_vm._v(" "),_c('li',[_c('a',[_c('i',{staticClass:"fa fa-envelope mr-2",attrs:{"aria-hidden":"true"}}),_vm._v("info@eshops.lk")])])]),_vm._v(" "),_c('ul',{staticClass:"social-media-icons mb-2 d-inline"},[_c('li',{},[_c('a',{staticClass:"px-0 ml-0 mr-2",attrs:{"href":"https://www.facebook.com/Eshopslk-2212428785713128/"}},[_c('i',{staticClass:"fa fa-facebook-official f-sm-link",staticStyle:{"font-size":"34px","color":"#3b5998","background-color":"#fff","width":"30px","height":"30px","border-radius":"4px","text-align":"center","vertical-align":"middle"}})])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"px-0 mx-2",attrs:{"href":"https://www.instagram.com/eshops.lk/"}},[_c('i',{staticClass:"fa fa-instagram f-sm-link",staticStyle:{"font-size":"30px","color":"#fff","background":"radial-gradient(","width":"32px","height":"32px","border-radius":"4px","text-align":"center","vertical-align":"middle"}})])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"px-0 mx-2",attrs:{"href":"https://www.youtube.com/channel/UCJhY3IfJD3T2bA5PJ3SrMZw"}},[_c('i',{staticClass:"fa fa-youtube-square f-sm-link",staticStyle:{"font-size":"35px","color":"#ff0000","background-color":"#fff","width":"30px","height":"30px","border-radius":"6px","text-align":"center","vertical-align":"middle"}})])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm col-md-8 col-lg-5"},[_c('div',{staticClass:"block-2 app-promotion"},[_c('a',[_c('img',{attrs:{"src":__webpack_require__(38),"alt":"mobile-icon"}})]),_vm._v(" "),_c('p',{staticClass:"m-f-text"},[_vm._v("\n                  Tap the Add to Home Screen Tab in Chrome Browser on Android or\n                  Safari Browser on IOS to Get the Splendid\n                  "),_c('span',{staticStyle:{"color":"#fd6a02","font-size":"20px"}},[_vm._v("Mobile App")]),_vm._v("\n                  Directly\n                ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer-bottom"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 mx-auto mt-5"},[_c('div',{staticClass:"copyright text-center"},[_c('img',{attrs:{"src":__webpack_require__(25),"alt":"eshops-logo"}}),_vm._v(" "),_c('p',{staticClass:"m-f-text mt-2"},[_vm._v("\n                  © 2018 eshops.lk | All Rights Reserved\n                ")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegShop_vue__ = __webpack_require__(200);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fac4f03_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegShop_vue__ = __webpack_require__(597);
function injectStyle (ssrContext) {
  __webpack_require__(591)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7fac4f03"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegShop_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fac4f03_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegShop_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 591 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  value: 'Colombo',
  label: 'Colombo',

  children: [{
    value: 'Colombo 01',
    label: 'Colombo 01'
  }, {
    value: 'Colombo 02',
    label: 'Colombo 02'
  }, {
    value: 'Colombo 03',
    label: 'Colombo 03'
  }, {
    value: 'Colombo 04',
    label: 'Colombo 04'
  }, {
    value: 'Colombo 05',
    label: 'Colombo 05'
  }, {
    value: 'Colombo 06',
    label: 'Colombo 06'
  }, {
    value: 'Colombo 07',
    label: 'Colombo 07'
  }, {
    value: 'Colombo 08',
    label: 'Colombo 08'
  }, {
    value: 'Colombo 08',
    label: 'Colombo 08'
  }, {
    value: 'Colombo 08',
    label: 'Colombo 08'
  }, {
    value: 'Colombo 09',
    label: 'Colombo 09'
  }, {
    value: 'Colombo 10',
    label: 'Colombo 10'
  }, {
    value: 'Colombo 11',
    label: 'Colombo 11'
  }, {
    value: 'Colombo 12',
    label: 'Colombo 12'
  }, {
    value: 'Colombo 13',
    label: 'Colombo 13'
  }, {
    value: 'Colombo 14',
    label: 'Colombo 14'
  }, {
    value: 'Colombo 15',
    label: 'Colombo 15'
  }, {
    value: 'Angoda ',
    label: 'Angoda '
  }, {
    value: 'Athurugiriya',
    label: 'Athurugiriya'
  }, {
    value: 'Awissawella',
    label: 'Awissawella'
  }, {
    value: 'Battaramulla',
    label: 'Battaramulla'
  }, {
    value: 'Boralesgamuwa',
    label: 'Boralesgamuwa'
  }, {
    value: 'Dehiwala',
    label: 'Dehiwala'
  }, {
    value: 'Hanwella',
    label: 'Hanwella'
  }, {
    value: 'Homagama ',
    label: 'Homagama '
  }, {
    value: 'Kaduwela',
    label: 'Kaduwela'
  }, {
    value: 'Kesbewa',
    label: 'Kesbewa'
  }, {
    value: 'Kohuwala',
    label: 'Kohuwala'
  }, {
    value: 'Kolonnawa',
    label: 'Kolonnawa'
  }, {
    value: 'Kottawa',
    label: 'Kottawa'
  }, {
    value: 'Kotte',
    label: 'Kotte'
  }, {
    value: 'Maharagama',
    label: 'Maharagama'

  }, {
    value: 'Malabe',
    label: 'Malabe'
  }, {
    value: 'Moratuwa',
    label: 'Moratuwa'
  }, {
    value: 'Mount Lavinia',
    label: 'Mount Lavinia'
  }, {
    value: 'Nawala',
    label: 'Nawala'
  }, {
    value: 'Nugegoda',
    label: 'Nugegoda'
  }, {
    value: 'Padukka',
    label: 'Padukka'
  }, {
    value: 'Pannipitiya',
    label: 'Pannipitiya'
  }, {
    value: 'Piliyandala',
    label: 'Piliyandala'
  }, {
    value: 'Rajagiriya',
    label: 'Rajagiriya'
  }, {
    value: 'Rathmalana',
    label: 'Rathmalana'
  }, {
    value: 'Thalawathugoda',
    label: 'Thalawathugoda'
  }, {
    value: 'Wellampitiya',
    label: 'Wellampitiya'
  }]
}, {
  value: 'Kandy',
  label: 'Kandy',

  children: [{
    value: 'Kandy',
    label: 'Kandy'
  }, {
    value: 'Katugastota',
    label: 'Katugastota'
  }, {
    value: 'Peradeniya',
    label: 'Peradeniya'
  }, {
    value: 'Gampola',
    label: 'Gampola'
  }, {
    value: 'Kadugannawa',
    label: 'Kadugannawa'
  }, {
    value: 'Kundasale',
    label: 'Kundasale'
  }, {
    value: 'Akurana',
    label: 'Akurana'
  }, {
    value: 'Gelioya',
    label: 'Gelioya'
  }, {
    value: 'Delthota',
    label: 'Delthota'
  }, {
    value: 'Nawalapitiya',
    label: 'Nawalapitiya'
  }, {
    value: 'Pilimathalawa',
    label: 'Pilimathalawa'

  }]
}, {
  value: 'Gampaha',
  label: 'Gampaha',

  children: [{
    value: 'Gampaha',
    label: 'Gampaha'
  }, {
    value: 'Negombo',
    label: 'Negombo'
  }, {
    value: 'Kelaniya',
    label: 'Kelaniya'
  }, {
    value: 'Kiribathgoda',
    label: 'Kiribathgoda'
  }, {
    value: 'Kadawatha',
    label: 'Kadawatha'
  }, {
    value: 'Delgoda',
    label: 'Delgoda'
  }, {
    value: 'Divulapitiya',
    label: 'Divulapitiya'
  }, {
    value: 'Ganemulla',
    label: 'Ganemulla'
  }, {
    value: 'Ja-Ela',
    label: 'Ja-Ela'
  }, {
    value: 'Kandana',
    label: 'Kandana'
  }, {
    value: 'Katunayake',
    label: 'Katunayake'
  }, {
    value: 'Kirindiwela',
    label: 'Kirindiwela'
  }, {
    value: 'Minuwangoda',
    label: 'Minuwangoda'
  }, {
    value: 'Mirigama',
    label: 'Mirigama'
  }, {
    value: 'Nittambuwa',
    label: 'Nittambuwa'
  }, {
    value: 'Ragama',
    label: 'Ragama'
  }, {
    value: 'Veyangoda',
    label: 'Veyangoda'
  }, {
    value: 'Wattala',
    label: 'Wattala'

  }]
}, {
  value: 'Kurunegala',
  label: 'Kurunegala',

  children: [{
    value: 'Kurunegala',
    label: 'Kurunegala'
  }, {
    value: 'Kuliyapitiya',
    label: 'Kuliyapitiya'
  }, {
    value: 'Pannala',
    label: 'Pannala'
  }, {
    value: 'Narammala',
    label: 'Narammala'
  }, {
    value: 'Wariyapola',
    label: 'Wariyapola'
  }, {
    value: 'Alawwa',
    label: 'Alawwa'
  }, {
    value: 'Bingiriya',
    label: 'Bingiriya'
  }, {
    value: 'Galgamuwa',
    label: 'Galgamuwa'
  }, {
    value: 'Giriulla',
    label: 'Giriulla'
  }, {
    value: 'Hettipola',
    label: 'Hettipola'
  }, {
    value: 'Ibbagamuwa',
    label: 'Ibbagamuwa'
  }, {
    value: 'Mawathagama',
    label: 'Mawathagama'
  }, {
    value: 'Nikaweratiya',
    label: 'Nikaweratiya'
  }, {
    value: 'Polgahawela',
    label: 'Polgahawela'

  }]
}, {
  value: 'Ratnapura',
  label: 'Ratnapura',

  children: [{
    value: 'Ratnapura',
    label: 'Ratnapura'
  }, {
    value: 'Embilipitiya',
    label: 'Embilipitiya'
  }, {
    value: 'Balangoda',
    label: 'Balangoda'
  }, {
    value: 'Pelmadulla',
    label: 'Pelmadulla'
  }, {
    value: 'Eheliyagoda',
    label: 'Eheliyagoda'
  }, {
    value: 'Kuruwita',
    label: 'Kuruwita'
  }, {
    value: 'Godakawela',
    label: 'Godakawela'
  }, {
    value: 'Udawalawa',
    label: 'Udawalawa'

  }]
}, {
  value: 'Galle',
  label: 'Galle',

  children: [{
    value: 'Galle',
    label: 'Galle'
  }, {
    value: 'Ambalangoda',
    label: 'Ambalangoda'
  }, {
    value: 'Elpitiya',
    label: 'Elpitiya'
  }, {
    value: 'Hikkaduwa',
    label: 'Hikkaduwa'
  }, {
    value: 'Baddegama',
    label: 'Baddegama'
  }, {
    value: 'Ahangama',
    label: 'Ahangama'
  }, {
    value: 'Batapola',
    label: 'Batapola'
  }, {
    value: 'Benthota',
    label: 'Benthota'
  }, {
    value: 'Katapitiya',
    label: 'Katapitiya'

  }]
}, {
  value: 'Ampara',
  label: 'Ampara',

  children: [{
    value: 'Ampara',
    label: 'Ampara'
  }, {
    value: 'Akkarepattu',
    label: 'Akkarepattu'
  }, {
    value: 'Kalmunai',
    label: 'Kalmunai'
  }, {
    value: 'Sainthamaruthu',
    label: 'Sainthamaruthu'

  }]
}, {
  value: 'Anuradhapura',
  label: 'Anuradhapura',

  children: [{
    value: 'Anuradhapura',
    label: 'Anuradhapura'
  }, {
    value: 'Kekirawa',
    label: 'Kekirawa'
  }, {
    value: 'Medawachchiya',
    label: 'Medawachchiya'
  }, {
    value: 'Eppawala',
    label: 'Eppawala'
  }, {
    value: 'Tambuttegama',
    label: 'Tambuttegama'
  }, {
    value: 'Galenbidunuwewa',
    label: 'Galenbidunuwewa'
  }, {
    value: 'Galnewa',
    label: 'Galnewa'
  }, {
    value: 'Habarana',
    label: 'Habarana'
  }, {
    value: 'Mihinthale',
    label: 'Mihinthale'
  }, {
    value: 'Nochchiyagama',
    label: 'Nochchiyagama'
  }, {
    value: 'Thalawa',
    label: 'Thalawa'

  }]
}, {
  value: 'Badulla',
  label: 'Badulla',

  children: [{
    value: 'Badulla',
    label: 'Badulla'
  }, {
    value: 'Bandarawela',
    label: 'Bandarawela'
  }, {
    value: 'Welimada',
    label: 'Welimada'
  }, {
    value: 'Mahiyanganaya',
    label: 'Mahiyanganaya'
  }, {
    value: 'Ella',
    label: 'Ella'
  }, {
    value: 'Haputale',
    label: 'Haputale'

  }]
}, {
  value: 'Batticaloa',
  label: 'Batticaloa',

  children: [{
    value: 'Batticaloa',
    label: 'Batticaloa'

  }]
}, {
  value: 'Hambantota',
  label: 'Hambantota',

  children: [{
    value: 'Hambantota',
    label: 'Hambantota'
  }, {
    value: 'Tangalla',
    label: 'Tangalla'
  }, {
    value: 'Beliatta',
    label: 'Beliatta'
  }, {
    value: 'Ambalantota',
    label: 'Ambalantota'
  }, {
    value: 'Tissamaharama',
    label: 'Tissamaharama'

  }]
}, {
  value: 'Jaffna',
  label: 'Jaffna',

  children: [{
    value: 'Jaffna',
    label: 'Jaffna'
  }, {
    value: 'Nallur',
    label: 'Nallur'
  }, {
    value: 'Chavakachcheri',
    label: 'Chavakachcheri'

  }]
}, {
  value: 'Kalutara',
  label: 'Kalutara',

  children: [{
    value: 'Kalutara',
    label: 'Kalutara'
  }, {
    value: 'Horana',
    label: 'Horana'
  }, {
    value: 'Panadura',
    label: 'Panadura'
  }, {
    value: 'Bandaragama',
    label: 'Bandaragama'
  }, {
    value: 'Dharga Town',
    label: 'Dharga Town'
  }, {
    value: 'Matugama',
    label: 'Matugama'
  }, {
    value: 'Aluthgama',
    label: 'Aluthgama'
  }, {
    value: 'Beruwala',
    label: 'Beruwala'
  }, {
    value: 'Ingiriya',
    label: 'Ingiriya'
  }, {
    value: 'Wadduwa',
    label: 'Wadduwa'

  }]
}, {
  value: 'Kegalle',
  label: 'Kegalle',

  children: [{
    value: 'Kegalle',
    label: 'Kegalle'
  }, {
    value: 'Aranayaka',
    label: 'Aranayaka'
  }, {
    value: 'Mawanella',
    label: 'Mawanella'
  }, {
    value: 'Warakapola',
    label: 'Warakapola'
  }, {
    value: 'Rambukkana',
    label: 'Rambukkana'
  }, {
    value: 'Galigamuwa',
    label: 'Galigamuwa'

  }]
}, {
  value: 'Kilinochchi',
  label: 'Kilinochchi',

  children: [{
    value: 'All of Kilinochchi',
    label: 'All of Kilinochchi'
  }, {
    value: 'Kilinochchi',
    label: 'Kilinochchi'
  }]
}, {
  value: 'Mannar',
  label: 'Mannar',

  children: [{
    value: 'Mannar',
    label: 'Mannar'

  }]
}, {
  value: 'Matale',
  label: 'Matale',

  children: [{
    value: 'Matale',
    label: 'Matale'
  }, {
    value: 'Dambulla',
    label: 'Dambulla'
  }, {
    value: 'Galewela',
    label: 'Galewela'
  }, {
    value: 'Ukuwela',
    label: 'Ukuwela'
  }, {
    value: 'Sigiriya',
    label: 'Sigiriya'
  }, {
    value: 'Palapathwela',
    label: 'Palapathwela'
  }, {
    value: 'Rattota',
    label: 'Rattota'
  }, {
    value: 'Yatawatta',
    label: 'Yatawatta'

  }]
}, {
  value: 'Matara',
  label: 'Matara',

  children: [{
    value: 'Matara',
    label: 'Matara'
  }, {
    value: 'Akuressa',
    label: 'Akuressa'
  }, {
    value: 'Weligama',
    label: 'Weligama'
  }, {
    value: 'Dikwella',
    label: 'Dikwella'
  }, {
    value: 'Hakmana',
    label: 'Hakmana'
  }, {
    value: 'Deniyaya',
    label: 'Deniyaya'
  }, {
    value: 'Kamburugamuwa',
    label: 'Kamburugamuwa'
  }, {
    value: 'Kamburupitiya',
    label: 'Kamburupitiya'
  }, {
    value: 'Mirissa',
    label: 'Mirissa'
  }, {
    value: 'Morawaka',
    label: 'Morawaka'
  }, {
    value: 'Pitabaddara',
    label: 'Pitabaddara'

  }]
}, {
  value: 'Monaragala',
  label: 'Monaragala',

  children: [{
    value: 'Monaragala',
    label: 'Monaragala'
  }, {
    value: 'Wellawaya',
    label: 'Wellawaya'
  }, {
    value: 'Bibile',
    label: 'Bibile'
  }, {
    value: 'Kataragama',
    label: 'Kataragama'
  }, {
    value: 'Buttala',
    label: 'Buttala'

  }]
}, {
  value: 'Mullativu',
  label: 'Mullativu',

  children: [{
    value: 'Mullativu',
    label: 'Mullativu'

  }]
}, {
  value: 'Nuwara Eliya',
  label: 'Nuwara Eliya',

  children: [{
    value: 'Nuwara Eliya',
    label: 'Nuwara Eliya'
  }, {
    value: 'Hatton',
    label: 'Hatton'
  }, {
    value: 'Ginigathena',
    label: 'Ginigathena'
  }, {
    value: 'Thalawakele',
    label: 'Thalawakele'
  }, {
    value: 'Maskeliya',
    label: 'Maskeliya'

  }]
}, {
  value: 'Polonnaruwa',
  label: 'Polonnaruwa',

  children: [{
    value: 'Polonnaruwa',
    label: 'Polonnaruwa'
  }, {
    value: 'Kaduruwela',
    label: 'Kaduruwela'
  }, {
    value: 'Hingurakgoda',
    label: 'Hingurakgoda'
  }, {
    value: 'Medirigiriya',
    label: 'Medirigiriya'

  }]
}, {
  value: 'Puttalam',
  label: 'Puttalam',

  children: [{
    value: 'Puttalam',
    label: 'Puttalam'
  }, {
    value: 'Chilaw',
    label: 'Chilaw'
  }, {
    value: 'Wennappuwa',
    label: 'Wennappuwa'
  }, {
    value: 'Dankotuwa',
    label: 'Dankotuwa'
  }, {
    value: 'Nattandiya',
    label: 'Nattandiya'
  }, {
    value: 'Marawila',
    label: 'Marawila'

  }]
}, {
  value: 'Trincomalee',
  label: 'Trincomalee',

  children: [{
    value: 'Trincomalee',
    label: 'Trincomalee'
  }, {
    value: 'Kinniya',
    label: 'Kinniya'

  }]
}, {
  value: 'Vavuniya',
  label: 'Vavuniya',

  children: [{
    value: 'Vavuniya',
    label: 'Vavuniya'

  }]
}]);

/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);


var _Outdoor, _Car, _Motorcycle;

/* harmony default export */ __webpack_exports__["a"] = ({
    "Grocery": {
        "Product Types": {
            "Beverages": 0,
            "Bread & Bakery": 0,
            "Cereal": 0,
            "Dry Goods": 0,
            "Frozen Food": 0,
            "Canned Goods & Soups": 0,
            "Spices": 0,
            "Cookies, Snacks & Candy": 0,
            "Dairy & Cheese": 0,
            "Pasta & Sides": 0,
            "Meat, Seafood & Eggs": 0,
            "Paper Products": 0,
            "Cleaning Supplies": 0,
            "Health & Beauty": 0,
            "Other Grocery Items": 0
        }
    },

    "Food / Restaurants": {
        "Food Types": {
            "Beverages": 0,
            "Bread & Bakery": 0,
            "Dairy Products": 0,
            "Fast Food": 0,
            "Seafood": 0,
            "Short Eats": 0,
            "Rice & Curry": 0,
            "Chinese Food": 0,
            "Italian Food": 0,
            "Indian Food": 0,
            "Buffet": 0,
            "Other Food": 0

        }
    },

    "Agri Products": {
        "Agri Products": {
            "Vegetables": 0,
            "Fruits": 0,
            "Seeds": 0,
            "Grains": 0,
            "Coconut": 0,
            "Dairy": 0,
            "Fertilizer": 0,
            "Rice": 0,
            "Sugary": 0,
            "Plants": 0,
            "Organic": 0,
            "Oils": 0,
            "Machines": 0

        }
    },

    "Vegetables & Fruits": {
        "Vegetables & Fruits": {
            "Vegetables": 0,
            "Fruits": 0
        }
    },
    "Auto Parts": {
        "Car Parts": {
            "Body Parts & Framework": 0,
            "Doors": 0,
            "Windows": 0,
            "Audio/Video Devices": 0,
            "Cameras": 0,
            "Electrical Supply System": 0,
            "Gauges & Meters": 0,
            "Ignition Electronic System": 0,
            "Lighting & Signaling System": 0,
            "Sensors": 0,
            "Starting System": 0,
            "Electrical Switches": 0,
            "Wiring Harnesses": 0,
            "Floor Components & Parts": 0,
            "Seat Sets": 0,
            "Tyres & Rims": 0,
            "Dashboard & Interior Items": 0,
            "Braking System": 0,
            "Engine Components & Parts": 0,
            "Engine Cooling System": 0,
            "Engine Oil Systems": 0,
            "Exhaust System": 0,
            "Fuel Supply System": 0,
            "Suspension & Steering Systems": 0,
            "Transmission System": 0,
            "Air Conditioning System (A/C)": 0,
            "Bearings": 0,
            "Hose": 0,
            "Other Miscellaneous Parts": 0
        },
        "Motocycle Parts": {
            "Proctive Equipments": 0,
            "Exhausts": 0,
            "Body Works": 0,
            "Engine Parts": 0,
            "Handles & Control Parts": 0,
            "Drive Parts": 0,
            "Brakes": 0,
            "Electrical": 0,
            "Framework": 0,
            "Suspension": 0,
            "Reaersets": 0,
            "Wheels": 0,
            "Swingarms": 0,
            "Tyres": 0,
            "Other Miscellaneous Parts": 0
        },
        "Three Wheeler Parts": {
            "Body Parts& Framework": 0,
            "Doors": 0,
            "Windows": 0,
            "Audio/Video Devices": 0,
            "Cameras": 0,
            "Electrical Supply System": 0,
            "Gauges & Meters": 0,
            "Ignition Electronic System": 0,
            "Lighting & Signaling System": 0,
            "Sensors": 0,
            "Starting System": 0,
            "Electrical Switches": 0,
            "Wiring Harnesses": 0,
            "Floor Components & Parts": 0,
            "Seat Sets": 0,
            "Tyres & Rims": 0,
            "Dashboard & Interior Items": 0,
            "Braking System": 0,
            "Engine Components & Parts": 0,
            "Engine Cooling System": 0,
            "Engine Oil Systems": 0,
            "Exhaust System": 0,
            "Fuel Supply System": 0,
            "Suspension & Steering Systems": 0,
            "Transmission System": 0,
            "Air Conditioning System (A/C)": 0,
            "Bearings": 0,
            "Hose": 0,
            "Other Miscellaneous Parts": 0
        },
        "Bus Parts": {
            "Body Parts& Framework": 0,
            "Doors": 0,
            "Windows": 0,
            "Audio/Video Devices": 0,
            "Cameras": 0,
            "Electrical Supply System": 0,
            "Gauges & Meters": 0,
            "Ignition Electronic System": 0,
            "Lighting & Signaling System": 0,
            "Sensors": 0,
            "Starting System": 0,
            "Electrical Switches": 0,
            "Wiring Harnesses": 0,
            "Floor Components & Parts": 0,
            "Seat Sets": 0,
            "Tyres & Rims": 0,
            "Dashboard & Interior Items": 0,
            "Braking System": 0,
            "Engine Components & Parts": 0,
            "Engine Cooling System": 0,
            "Engine Oil Systems": 0,
            "Exhaust System": 0,
            "Fuel Supply System": 0,
            "Suspension & Steering Systems": 0,
            "Transmission System": 0,
            "Air Conditioning System (A/C)": 0,
            "Bearings": 0,
            "Hose": 0,
            "Other Miscellaneous Parts": 0
        },
        "Lorry Parts": {
            "Body Parts& Framework": 0,
            "Doors": 0,
            "Windows": 0,
            "Audio/Video Devices": 0,
            "Cameras": 0,
            "Electrical Supply System": 0,
            "Gauges & Meters": 0,
            "Ignition Electronic System": 0,
            "Lighting & Signaling System": 0,
            "Sensors": 0,
            "Starting System": 0,
            "Electrical Switches": 0,
            "Wiring Harnesses": 0,
            "Floor Components & Parts": 0,
            "Seat Sets": 0,
            "Tyres & Rims": 0,
            "Dashboard & Interior Items": 0,
            "Braking System": 0,
            "Engine Components & Parts": 0,
            "Engine Cooling System": 0,
            "Engine Oil Systems": 0,
            "Exhaust System": 0,
            "Fuel Supply System": 0,
            "Suspension & Steering Systems": 0,
            "Transmission System": 0,
            "Air Conditioning System (A/C)": 0,
            "Bearings": 0,
            "Hose": 0,
            "Other Miscellaneous Parts": 0
        },
        "Tipper Parts": {
            "Body Parts& Framework": 0,
            "Doors": 0,
            "Windows": 0,
            "Audio/Video Devices": 0,
            "Cameras": 0,
            "Electrical Supply System": 0,
            "Gauges & Meters": 0,
            "Ignition Electronic System": 0,
            "Lighting & Signaling System": 0,
            "Sensors": 0,
            "Starting System": 0,
            "Electrical Switches": 0,
            "Wiring Harnesses": 0,
            "Floor Components & Parts": 0,
            "Seat Sets": 0,
            "Tyres & Rims": 0,
            "Dashboard & Interior Items": 0,
            "Braking System": 0,
            "Engine Components & Parts": 0,
            "Engine Cooling System": 0,
            "Engine Oil Systems": 0,
            "Exhaust System": 0,
            "Fuel Supply System": 0,
            "Suspension & Steering Systems": 0,
            "Transmission System": 0,
            "Air Conditioning System (A/C)": 0,
            "Bearings": 0,
            "Hose": 0,
            "Other Miscellaneous Parts": 0
        },
        "Truck Parts": {
            "Body Parts& Framework": 0,
            "Doors": 0,
            "Windows": 0,
            "Audio/Video Devices": 0,
            "Cameras": 0,
            "Electrical Supply System": 0,
            "Gauges & Meters": 0,
            "Ignition Electronic System": 0,
            "Lighting & Signaling System": 0,
            "Sensors": 0,
            "Starting System": 0,
            "Electrical Switches": 0,
            "Wiring Harnesses": 0,
            "Floor Components & Parts": 0,
            "Seat Sets": 0,
            "Tyres & Rims": 0,
            "Dashboard & Interior Items": 0,
            "Braking System": 0,
            "Engine Components & Parts": 0,
            "Engine Cooling System": 0,
            "Engine Oil Systems": 0,
            "Exhaust System": 0,
            "Fuel Supply System": 0,
            "Suspension & Steering Systems": 0,
            "Transmission System": 0,
            "Air Conditioning System (A/C)": 0,
            "Bearings": 0,
            "Hose": 0,
            "Other Miscellaneous Parts": 0
        },
        "Jeep & Picup Parts": {
            "Body Parts& Framework": 0,
            "Doors": 0,
            "Windows": 0,
            "Audio/Video Devices": 0,
            "Cameras": 0,
            "Electrical Supply System": 0,
            "Gauges & Meters": 0,
            "Ignition Electronic System": 0,
            "Lighting & Signaling System": 0,
            "Sensors": 0,
            "Starting System": 0,
            "Electrical Switches": 0,
            "Wiring Harnesses": 0,
            "Floor Components & Parts": 0,
            "Seat Sets": 0,
            "Tyres & Rims": 0,
            "Dashboard & Interior Items": 0,
            "Braking System": 0,
            "Engine Components & Parts": 0,
            "Engine Cooling System": 0,
            "Engine Oil Systems": 0,
            "Exhaust System": 0,
            "Fuel Supply System": 0,
            "Suspension & Steering Systems": 0,
            "Transmission System": 0,
            "Air Conditioning System (A/C)": 0,
            "Bearings": 0,
            "Hose": 0,
            "Other Miscellaneous Parts": 0
        },
        "Van Parts": {
            "Body Parts& Framework": 0,
            "Doors": 0,
            "Windows": 0,
            "Audio/Video Devices": 0,
            "Cameras": 0,
            "Electrical Supply System": 0,
            "Gauges & Meters": 0,
            "Ignition Electronic System": 0,
            "Lighting & Signaling System": 0,
            "Sensors": 0,
            "Starting System": 0,
            "Electrical Switches": 0,
            "Wiring Harnesses": 0,
            "Floor Components & Parts": 0,
            "Seat Sets": 0,
            "Tyres & Rims": 0,
            "Dashboard & Interior Items": 0,
            "Braking System": 0,
            "Engine Components & Parts": 0,
            "Engine Cooling System": 0,
            "Engine Oil Systems": 0,
            "Exhaust System": 0,
            "Fuel Supply System": 0,
            "Suspension & Steering Systems": 0,
            "Transmission System": 0,
            "Air Conditioning System (A/C)": 0,
            "Bearings": 0,
            "Hose": 0,
            "Other Miscellaneous Parts": 0
        },
        "Heavy-Duty & Machinery Parts": {
            "Body Parts& Framework": 0,
            "Doors": 0,
            "Windows": 0,
            "Audio/Video Devices": 0,
            "Cameras": 0,
            "Electrical Supply System": 0,
            "Gauges & Meters": 0,
            "Ignition Electronic System": 0,
            "Lighting & Signaling System": 0,
            "Sensors": 0,
            "Starting System": 0,
            "Electrical Switches": 0,
            "Wiring Harnesses": 0,
            "Floor Components & Parts": 0,
            "Seat Sets": 0,
            "Tyres & Rims": 0,
            "Hydraulic System": 0,
            "Trailers": 0,
            "Stabilizer": 0,
            "Boom": 0,
            "Compressor": 0,
            "Dashboard & Interior Items": 0,
            "Braking System": 0,
            "Engine Components & Parts": 0,
            "Engine Cooling System": 0,
            "Engine Oil Systems": 0,
            "Exhaust System": 0,
            "Fuel Supply System": 0,
            "Suspension & Steering Systems": 0,
            "Transmission System": 0,
            "Air Conditioning System (A/C)": 0,
            "Bearings": 0,
            "Hose": 0,
            "Other Miscellaneous Parts": 0
        }
    },

    "Baby Kids & Toys": {
        "Baby Cosmetics": {
            "Powders and talc": 0,
            "Oils": 0,
            "Nappy Care": 0,
            "Lotions and Creams": 0,
            "Healthy Teeth": 0,
            "Bath Time": 0,
            "Other Baby Cosmetics": 0
        },

        "Fresh and Cuddly": {
            "Wet Wipes": 0,
            "Toilet Trainers": 0,
            "Grooming Items": 0,
            "Diapers": 0,
            "Baby Detergents": 0,
            "Other Fresh and Cuddly": 0
        },
        "Furniture": {
            "Playmats & Playpens": 0,
            "Baby Cupboards & Storage": 0,
            "Baby Cot": 0,
            "Chair & Desks": 0,
            "Baby Swings": 0,
            "Other Furniture": 0
        },

        "Baby Gear": {
            "Baby Bath": 0,
            "Car Seat": 0,
            "Bouncers,Rockers & Cradles": 0,
            "Baby Carrier": 0,
            "Feeding Chair": 0,
            "Baby Strollers & Go Carts": 0,
            "Baby Walkers": 0,
            "Other Baby Gear": 0
        },
        "Toys": {
            "Activity Gyms & Play Gyms": 0,
            "Tricycles": 0,
            "Rechargeable Electric Cars": 0,
            "Rechargeable Electric Motorbikes": 0,
            "Ride on Cars": 0,
            "Kids Scooter": 0,
            "Crib & Cot Toys": 0,
            "Rocking Horse": 0,
            "Toys (Educational)": 0,
            "Other Toys": 0
        }
    },

    "Bags": {
        "Bags": {
            "Women’s Handbags": 0,
            "Side Bags": 0,
            "Totes & Shoppers": 0,
            "Cosmetic Bags": 0,
            "Office Bag": 0,
            "School Bags": 0,
            "Other Bags": 0
        }
    },

    "Supermarket": {
        "Product Types": {
            "Fruits": 0,
            "Vegetables": 0,
            "Meat Fish & Sea food": 0,
            "Dry Food": 0,
            "Health Beauty & Personal care": 0,
            "Bread & Bakery": 0,
            "Beverages": 0,
            "Beer, Wine & Spirits": 0,
            // "Tobacco":0,
            "Dairy Products": 0,
            "Canned Goods & Soups": 0,
            "Cereal Grains & Pasta": 0,
            "Cookies & Snacks": 0,
            "Pet Care": 0,
            "Baby Care": 0,
            "Cleaning Supplies": 0,
            "Paper Products": 0,
            "Stationary": 0,
            "Pharmacy": 0
        }
    },

    "Books": {
        "A/L Books": {
            "Science": 0,
            "Maths": 0,
            "Commerce": 0,
            "Arts": 0,
            "Technology": 0,
            "Pass Papers": 0
        },
        "Grades": {
            "O/L Pass Papers": 0,
            "Grade 11 to 6": 0,
            "Grade 5 Schoolarship": 0,
            "Grade 5 to 1": 0,
            "Pre School": 0
        },
        "Novels": {
            "Short Stories": 0,
            "Translated": 0,
            "Horror": 0,
            "Sci-Fi & Fantasy": 0,
            "Romance": 0,
            "Mysteries": 0,
            "Other Novels": 0
        },

        "Other Categories": {
            "Arts": 0,
            "Music": 0,
            "History": 0,
            "Higher Education": 0,
            "Biographies": 0,
            "Business": 0,
            "Kids": 0,
            "Computers & Tech": 0,
            "Cooking": 0,
            "Hobbies & Crafts": 0,
            "Health & Fitness": 0,
            "Home & Garden": 0,
            "Entertainment": 0,
            "Literature & Fiction": 0,
            "Medical": 0,
            "Parenting": 0,
            "Social Science": 0,
            "Religious": 0,
            "Science": 0,
            "Self-Help": 0,
            "Sports": 0,
            "Crime": 0,
            "Western": 0,
            "Languages": 0,
            "Buddhism": 0,
            "Accountig & Marketing": 0,
            "Agriculture": 0,
            "Archaeology": 0,
            "Astrology": 0,
            "Astronomy": 0,
            "Ayurwedaya & Yoga": 0,
            "Dictionaries": 0,
            "Dancing": 0,
            "Drama": 0,
            "Economics, Finance & Law": 0,
            "Electronic": 0,
            "General Knowledge": 0,
            "Human Resource Management": 0,
            "Philosophy": 0,
            "Poetry": 0,
            "Politics": 0,
            "Psychology": 0,
            "Travel and Tourism": 0,
            "Other": 0
        }
    },

    "Cameras": {
        "Cameras": {
            "Security Cameras": 0,
            "DSLR & Mirrorless Cameras": 0,
            "Digital Cameras": 0,
            "Drones": 0,
            "Camcorders": 0,
            "Instant Cameras": 0,
            "Other Cameras": 0

        },

        "Camera Accessories": {
            "Lenses": 0,
            "Lens Hood": 0,
            "Filters": 0,
            "Flashes": 0,
            "Camera Tripods": 0,
            "Camera Batteries": 0,
            "Digital Photo Frames": 0,
            "Camera Bags": 0,
            "Lens Caps": 0,
            "Binoculars & Optics": 0,
            "Triggers": 0,
            "Audio & Video Accessories": 0,
            "Lens Cleaner": 0,
            "Camera Monopods": 0,
            "Straps": 0,
            "Memory Cards": 0,
            "Screen Guards": 0,
            "Camera Remote Controllers": 0,
            "Other Camera Accessories": 0
        },

        "Binoculars & Telescopes": {
            "Binoculars & Telescopes": 0
        }
    },

    "Computers": {
        "Desktops": {
            "Apple Desktops": 0,
            "Other Desktops": 0

        },

        "Laptops": {
            "Acer": 0,
            "Apple": 0,
            "ASUS": 0,
            "Dell": 0,
            "HP": 0,
            "Huawei": 0,
            "Lenovo": 0,
            "Microsoft": 0,
            "MSI": 0,
            "Razer": 0,
            "Samsung": 0,
            "Singer": 0,
            "Toshiba": 0,
            "Other Laptops": 0
        },

        "Laptop & Desktop Accessories": {
            "Keyboards & Mouses": 0,
            "Headphones & Speakers": 0,
            "Cables & Interconnects": 0,
            "Printers": 0,
            "Scanners": 0,
            "Monitors": 0,
            "Projectors": 0,
            "Memory Cards": 0,
            "USB Flash Drives": 0,
            "Routers & Modems": 0,
            "Docking Stations": 0,
            "Laptop Bags": 0,
            "Chargers & Adapters": 0,
            "Cooling Pads": 0,
            "Stands": 0,
            "Screen Protectors": 0,
            "Other Laptop & Desktop Accessories": 0
        },

        "PC Components": {
            "Cases": 0,
            "CD/DVD Drives": 0,
            "CPU Processors": 0,
            "Fans & Cooling": 0,
            "Graphics Cards": 0,
            "Memory": 0,
            "Motherboards": 0,
            "Network Cards": 0,
            "Power Supplies": 0,
            "Softwares": 0,
            "Soundcards": 0,
            "Solid State Drives": 0,
            "External Hard Drives": 0,
            "Internal Hard Drives": 0,
            "Hard Drives for Mac": 0,
            "Other PC Components": 0
        }
    },

    "Diamonds & Gems": {
        "Diamonds & Gemstones": {
            "Stone": 0,
            "Metals": 0,
            "Crystals": 0,
            "Rhinestone": 0,
            "Vintage": 0,
            "Fused Glass": 0,
            "Other Diamonds & Gemstones": 0
        }
    },

    "Electronics": {
        "Home Electronics": {
            "TV": 0,
            "Air Conditioning": 0,
            "Heaters": 0,
            "Washing Machine": 0,
            "Ions": 0,
            "Refrigerators & Freezers": 0,
            "Fans": 0,
            "Home Theater": 0,
            "Hi-Fi & Stereo": 0,
            "Speakers": 0,
            "Vacuum Cleaners": 0,
            "DVD & BLU-RAY Players": 0,
            "Torch & Portable Lamps": 0,
            "Other Home Electronics": 0
        },
        "Kitchen Electronics": {
            "Electronic Oven": 0,
            "Gas Cookers": 0,
            "Toasters & Waffle Makers": 0,
            "Kettles": 0,
            "Water Heaters": 0,
            "Rice Cookers": 0,
            "Other Cookers": 0,
            "Steamers": 0,
            "Coffee Makers": 0,
            "Ovens": 0,
            "Other Kitchen Electronics": 0
        }
    },

    "Lighting & Electrical": {
        "Lighting": {
            "Indoor Lighting": 0,
            "Outdoor Lighting": 0,
            "Ceiling Fans": 0,
            "Light Bulbs": 0,
            "LED Lighting": 0,
            "Ceiling Lights": 0,
            "Indoor Wall Lights": 0,
            "Outdoor Wall Lights": 0,
            "Torches & Work Lights": 0,
            "Lighting Gifts": 0,
            "Light Fixtures & Fittings": 0,
            "Light Switches & Dimmers": 0,
            "Lighting Clearance": 0,
            "Other Lighting": 0
        },
        "Electrical": {
            "Door Bells": 0,
            "Switches & Sockets": 0,
            "Mounting Boxes": 0,
            "Plugs": 0,
            "Cable": 0,
            "Consumer Units": 0,
            "Electrical Tools & Supplies": 0,
            "Multiway Adaptors": 0,
            "Other Electrical": 0
        }
    },

    "Household Supplies": {
        "Household Supplies": {
            "Flatware, Knives & Cutlery": 0,
            "Dinnerware & Serving Dishes": 0,
            "Cookware": 0,
            "Bakeware": 0,
            "Racks": 0,
            "Basins": 0,
            "Plastic Items": 0,
            "Glassware & Drinkware": 0,
            "Vacuum Flasks & Mugs": 0,
            "Mops & Brooms": 0,
            "Brushes & Dusters": 0,
            "Other Household Supplies": 0
        }
    },

    "Tiles & Bathware": {
        "Tiles": {
            "Wall Tiles": 0,
            "Floor Tiles": 0,
            "Mosaic & Border Tiles": 0,
            "Bathroom Tiles": 0,
            "Kitchen Tiles": 0,
            "Wall & Floor Tiles": 0,
            "Outdoor Tiles": 0,
            "Decking Tiles": 0,
            "Other Tiles": 0
        },
        "Bathware": {
            "Bathroom Suites": 0,
            "Furniture & Cabinets": 0,
            "Enclosures,Doors & Trays": 0,
            "Showers & Accessories": 0,
            "Baths, Panels & Screens": 0,
            "Toilets": 0,
            "Basins": 0,
            "Bathroom Taps": 0,
            "Bathroom Accessories": 0,
            "Toilet Seats": 0,
            "Bathroom Wall Panels": 0,
            "Other Bathware": 0
        }
    },

    "Outdoor": {
        "Outdoor": (_Outdoor = {
            "Garden Décor Items": 0,
            "Garden Fencing Supplies": 0,
            "Garden Structures": 0,
            "Shade Equipment": 0,
            "Gardening Supplies": 0,
            "Garden Furniture": 0,
            "Gates": 0,
            "Lawn Mowers": 0,
            "Outdoor Cooking Equipment": 0,
            "Outdoor Power Equipment": 0
        }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Outdoor, "Garden Furniture", 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Outdoor, "Outdoor Ponds", 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Outdoor, "Water Features", 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Outdoor, "Other Yard & Outdoor Items", 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Outdoor, "Other Outdoor", 0), _Outdoor)
    },

    "Furniture": {
        "Living Room Furniture": {
            "Sofas": 0,
            "Drawer And Cabinets": 0,
            "Benches": 0,
            "Tv Media Stands": 0,
            "Tables": 0,
            "Racks": 0,
            "Chairs": 0,
            "Stools": 0,
            "Ottomans": 0,
            "Stand": 0,
            "Cart And Easels": 0,
            "Wine Racks And Cabinet": 0,
            "Other Living Room Furniture": 0

        },
        "Bedroom Furniture": {
            "Bed Trays": 0,
            "Beds": 0,
            "Headboard": 0,
            "Pillows": 0,
            "Mattresses": 0,
            "Bedroom Sets": 0,
            "Sheets And Curtains": 0,
            "Rugs And Mats": 0,
            "Other Bedroom Furniture": 0
        },
        "Office Furniture": {
            "Home Office Desks": 0,
            "Office Accessory": 0,
            "Bookcase And Shelf": 0,
            "Office Products": 0,
            "Bookcase": 0,
            "Other Office Furniture": 0
        },
        "Other Furniture": {
            "Medical Furniture": 0,
            "Medical Equipment": 0,
            "Kid Furniture": 0,
            "Other Furniture": 0
        }

    },

    "Handicrafts": {
        "Clothes,Fabrics & Accessories": {
            "Batik": 0,
            "Handloom": 0,
            "Weaving": 0,
            "Tatting": 0,
            "Macramé": 0,
            "Crochet": 0,
            "Tapestry": 0,
            "Other": 0
        },
        "Leather": {
            "Bags & pouches": 0,
            "Basket Weaving": 0,
            "Other": 0
        },
        "Stone & Metal": {
            "Jewellery": 0,
            "Brass": 0,
            "Oxidised": 0,
            "Silver": 0,
            "Copper": 0,
            "Other": 0
        },
        "Wood": {
            "Woodworks": 0,
            "Furniture": 0,
            "Other": 0
        },
        "Clay,Glass & Ceramics": {
            "Mosaic": 0,
            "Cameo Glass": 0,
            "Porcelain": 0,
            "Pottery": 0,
            "Other": 0
        },
        "Paintings": {
            "Paintings": 0,
            "Other": 0
        },
        "Sea Shells": {
            "Sea Shells": 0,
            "Other": 0
        },
        "Paper Crafts": {
            "Paper Marbling": 0,
            "Origami": 0,
            "Papier-Mâché": 0,
            "Calligraphy": 0,
            "Decoupage & Quilling": 0,
            "Other": 0
        }
    },

    "Health & Beauty": {
        "Health & Beauty": {
            "Makeup": 0,
            "Men’s Perfume": 0,
            "Women’s Perfume": 0,
            "Skin Care": 0,
            "Nail Care": 0,
            "Hair Care": 0,
            "Health Care": 0,
            "Other Health & Beauty": 0
        }
    },

    "Fancy Items": {
        "Health & Beauty": {
            "Makeup": 0,
            "Men’s Perfume": 0,
            "Women’s Perfume": 0,
            "Skin Care": 0,
            "Nail Care": 0,
            "Hair Care": 0,
            "Health Care": 0,
            "Other Health & Beauty": 0
        },
        "Fancy Items": {
            "Bags": 0,
            "Jewelrys": 0,
            "Shoes": 0,
            "Clothing": 0,
            "Other Fancy Items": 0
        }
    },

    "Home Decoration": {
        "Home Decoration": {
            "Clocks": 0,
            "Candle Holders": 0,
            "Picture Frames": 0,
            "Vases": 0,
            "Mirrors": 0,
            "Decor Accessories": 0,
            "Wall Art": 0,
            "Wall Decor": 0,
            "Home & Kitchen": 0,
            "Blinds And Shades": 0,
            "Christmas Tree": 0,
            "Sculptures": 0,
            "Other Home Decoration": 0
        }
    },

    "Window Treatments": {
        "Window Treatments": {
            "Curtain, Blinds & Shades": 0,
            "Curtain Rods & Finials": 0,
            "Beddings": 0,
            "Rugs & Carpets": 0,
            "Cushions & Throws": 0,
            "Other Window Treatments": 0
        }
    },

    "Jewelry & Watches": {
        "Women’s Jewelry": {
            "Rings": 0,
            "Necklace & Pendants": 0,
            "Earrings": 0,
            "Bracelets": 0,
            "Anklets": 0,
            "Body Jewelry": 0,
            "Hair & Head Jewelry": 0,
            "Jewelry Sets": 0,
            "Toe Rings": 0,
            "Other Women’s Jewelry": 0
        },

        "Men’s Jewelry": {
            "Rings": 0,
            "Chains, Necklaces & Pendants": 0,
            "Bracelets": 0,
            "Cufflinks": 0,
            "Earrings, Studs": 0,
            "Lapel Pins": 0,
            "Tie Clasps & Tacks": 0,
            "Other Men’s Jewelry": 0
        },

        "Engagement & Wedding": {
            "Engagement Rings": 0,
            "Engagement & Wedding Ring Sets": 0,
            "Wedding & Anniversary Bands": 0,
            "Wedding party Jewelry": 0
        },

        "Kids Watches": {
            "Analog": 0,
            "Digital": 0,
            "Smart": 0,
            "Chronograph": 0,
            "Other Kids Watches": 0
        },
        "Mens Watches": {
            "Analog": 0,
            "Digital": 0,
            "Smart": 0,
            "Chronograph": 0,
            "Other Mens Watches": 0
        },
        "Ladies Watches": {
            "Analog": 0,
            "Digital": 0,
            "Smart": 0,
            "Chronograph": 0,
            "Other Ladies Watches": 0
        },
        "Couple Watches": {
            "Analog": 0,
            "Digital": 0,
            "Smart": 0,
            "Chronograph": 0,
            "Other Couple Watches": 0
        }

    },

    "Watches": {
        "Kids Watches": {
            "Analog": 0,
            "Digital": 0,
            "Smart": 0,
            "Chronograph": 0,
            "Other Kids Watches": 0
        },
        "Mens Watches": {
            "Analog": 0,
            "Digital": 0,
            "Smart": 0,
            "Chronograph": 0,
            "Other Mens Watches": 0
        },
        "Ladies Watches": {
            "Analog": 0,
            "Digital": 0,
            "Smart": 0,
            "Chronograph": 0,
            "Other Ladies Watches": 0
        },
        "Couple Watches": {
            "Analog": 0,
            "Digital": 0,
            "Smart": 0,
            "Chronograph": 0,
            "Other Couple Watches": 0
        }
    },

    "Jewelry": {
        "Women’s Jewelry": {
            "Rings": 0,
            "Necklace & Pendants": 0,
            "Earrings": 0,
            "Bracelets": 0,
            "Anklets": 0,
            "Body Jewelry": 0,
            "Hair & Head Jewelry": 0,
            "Jewelry Sets": 0,
            "Toe Rings": 0,
            "Other Women’s Jewelry": 0
        },

        "Men’s Jewelry": {
            "Rings": 0,
            "Chains, Necklaces & Pendants": 0,
            "Bracelets": 0,
            "Cufflinks": 0,
            "Earrings, Studs": 0,
            "Lapel Pins": 0,
            "Tie Clasps & Tacks": 0,
            "Other Men’s Jewelry": 0
        },

        "Engagement & Wedding": {
            "Engagement Rings": 0,
            "Engagement & Wedding Ring Sets": 0,
            "Wedding & Anniversary Bands": 0,
            "Wedding party Jewelry": 0
        }
    },

    "Mobiles & Tablets": {
        "Mobiles": {
            "Acer": 0,
            "Ag-tel": 0,
            "Alcatel": 0,
            "Apple": 0,
            "Asus": 0,
            "BenQ": 0,
            "BlackBerry": 0,
            "Dialog": 0,
            "E-tel": 0,
            "Google": 0,
            "Greentel": 0,
            "HTC": 0,
            "Huawei": 0,
            "Lenovo": 0,
            "LG": 0,
            "Micromax": 0,
            "Microsoft": 0,
            "Moto": 0,
            "Nokia": 0,
            "OnePlus": 0,
            "Oppo": 0,
            "Samsung": 0,
            "Sky": 0,
            "Sony Ericsson": 0,
            "Sony": 0,
            "Vivo": 0,
            "Xiaomi": 0,
            "Zigo": 0,
            "ZTE": 0,
            "Other Mobile": 0

        },

        "Tablets": {
            "Acer Tablet": 0,
            "Amazon Tablet": 0,
            "Apple Tablet": 0,
            "ASUS Tablet": 0,
            "Dialog Tablet": 0,
            "HP Tablet": 0,
            "Huawei Tablet": 0,
            "Microsoft Tablet": 0,
            "Samsung Tablet": 0,
            "Other Tablet": 0
        },

        "Accessories": {
            "Headsets": 0,
            "Audio Docks & Speakers": 0,
            "Cases, Covers & Skins": 0,
            "Screen Protectors": 0,
            "Chargers & Cradles": 0,
            "Batteries": 0,
            "Cable & Adapters": 0,
            "Memory Cards": 0,
            "Other Accessories": 0
        }
    },

    "Music": {
        "Musicle Instruments": {
            "Guitars": 0,
            "Ukuleles": 0,
            "Amps & Effects": 0,
            "Drums and Percussion": 0,
            "DJ & Karaoke": 0,
            "Keyboards & Midi": 0,
            "Microphones": 0,
            "Headphones": 0,
            "Studio Recording": 0,
            "Live Sound & Stage": 0,
            "Brass": 0,
            "Strings": 0,
            "Winds & Woodwinds": 0,
            "Accessories": 0,
            "Other Musicle Instruments": 0
        }
    },

    "Sports": {
        "Sports Nutrition": {
            "Supplements": 0,
            "Fat Burners": 0,
            "Other Sports Nutrition": 0
        },
        "Sports Equipment": {
            "Cricket": 0,
            "Badminton": 0,
            "Swimming": 0,
            "Running": 0,
            "Cycling": 0,
            "Camping & Hiking": 0,
            "Basketball": 0,
            "Netball": 0,
            "Skates": 0,
            "Tennis": 0,
            "Other Sports Equipment": 0
        },
        "Fitness Equipment": {
            "Treadmills": 0,
            "Dumbbells": 0,
            "Ab Exercisers": 0,
            "Skipping Ropes": 0,
            "Balls": 0,
            "Bars": 0,
            "Fitness Accessories": 0,
            "Kits": 0,
            "Mats": 0,
            "Bottles & Shakers": 0,
            "Gloves": 0,
            "Other Fitness Equipment": 0
        },
        "Sports Clothing": {
            "T-Shirts": 0,
            "Shorts": 0,
            "Shoes": 0,
            "Bags": 0,
            "Other Sports Clothing": 0

        }

    },

    "Shoes & Footwear": {
        "Women’s Shoes": {
            "Heels": 0,
            "Flats & Oxfords": 0,
            "Occupational": 0,
            "Sandals & Flip Flops": 0,
            "Slippers": 0,
            "Athletic": 0,
            "Other Women’s Shoes": 0
        },

        "Men’s Shoes": {
            "Dress Formal Shoes": 0,
            "Casual": 0,
            "Sandals & Flip Flops": 0,
            "Slippers": 0,
            "Boots": 0,
            "Athletic": 0,
            "Other Men’s Shoes": 0

        },

        "Kids & Baby Shoes": {
            "Girls": 0,
            "Boys": 0
        }

    },

    "Tools & Machines": {
        "Tools & Machines": {
            "Air Tools": 0,
            "Hand Tools": 0,
            "Power Tools": 0,
            "Tool Boxes": 0,
            "Ladders": 0,
            "Generators": 0,
            "Air Compressors": 0,
            "Welding & Soldering Tools": 0,
            "Safety & Protective Gear": 0,
            "Other Tools & Machines": 0
        },
        "Machines": {
            "Industrial Machines": 0,
            "Other Machines": 0
        }
    },

    "Vehicles": {
        "Agriculture Machinery": {
            "Massey Ferguson": 0,
            "Photon": 0,
            "John Deere": 0,
            "Tafe": 0,
            "Kubota": 0,
            "Mahindra": 0,
            "Other Agriculture Machinery": 0
        },

        "Bus": {
            "Ashok Leyland": 0,
            "Tata": 0,
            "Micro": 0,
            "Mercedes": 0,
            "Mitsubishi": 0,
            "Isuzu": 0,
            "Toyota": 0,
            "Star Bus": 0,
            "Ssangyong": 0,
            "Other Bus": 0
        },

        "Car": (_Car = {
            "Alfa": 0,
            "Aston Martin": 0,
            "Audi": 0,
            "Austin": 0,
            "BMW": 0,
            "Cherry": 0,
            "Chevrolet": 0,
            "Chrysler": 0,
            "Daewoo": 0,
            "Daihatsu": 0,
            "Datsun": 0,
            "DFSK": 0,
            "Dodge": 0,
            "Ferrari": 0,
            "Fiat": 0,
            "Ford": 0,
            "Hillman": 0,
            "Honda": 0,
            "Hummer": 0,
            "Hyundai": 0,
            "Isuzu": 0,
            "Jaguar": 0,
            "Jeep": 0,
            "KIA": 0,
            "Lamborghini": 0,
            "Land Rover": 0,
            "Lexus": 0,
            "Mahindra": 0,
            "Skoda": 0,
            "Suzuki Maruti": 0,
            "Mazda": 0,
            "Mangustan": 0,
            "MCLaren": 0,
            "Mercedes": 0,
            "Micro": 0,
            "Mini": 0,
            "Mitsubishi": 0,
            "Morris": 0,
            "Nissan": 0,
            "Opel": 0,
            "Perodua": 0,
            "Peugeot": 0,
            "Plymouth": 0,
            "Porsche": 0,
            "Proton": 0,
            "Renault": 0,
            "Rover": 0,
            "Royal Enfield": 0,
            "Rolls Royce": 0,
            "Saab": 0,
            "Scion": 0
        }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Car, "Skoda", 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Car, "Subaru", 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Car, "Suzuki", 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Car, "Tata", 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Car, "Tesla", 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Car, "Toyota", 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Car, "Vauxhall", 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Car, "Volkswagen", 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Car, "Volvo", 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Car, "Zotye", 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Car, "Other Car", 0), _Car),

        "Crew Cab": {
            "Mitsubishi": 0,
            "Toyota": 0,
            "Nissan": 0,
            "Isuzu": 0,
            "FAW": 0,
            "KIA": 0,
            "JAC": 0,
            "JMC": 0,
            "Mazda": 0,
            "Changan": 0,
            "Dongfeng": 0,
            "ATCO": 0,
            "Hyundai": 0,
            "Foton": 0,
            "Micro": 0,
            "Ssangyong": 0,
            "Other Crew Cab": 0

        },

        "Heavy-Duty & Land Vehicle": {
            "Isuzu": 0,
            "Mitsubishi": 0,
            "Man": 0,
            "Sinotruk": 0,
            "Mercedes": 0,
            "Hino": 0,
            "Tata": 0,
            "John Deere": 0,
            "Cobelco": 0,
            "Hitachi": 0,
            "Volvo": 0,
            "Sumitomo": 0,
            "Komatsu": 0,
            "Perkins": 0,
            "Yanmar": 0,
            "Hyundai": 0,
            "DAF": 0,
            "IVECO": 0,
            "Howo": 0,
            "Ashok Leyland": 0,
            "SANY": 0,
            "Kawasaki": 0,
            "BOMAG": 0,
            "Nissan": 0,
            "JCB": 0,
            "Kubota": 0,
            "Mahindra": 0,
            "Massey Ferguson": 0,
            "Caterpillar": 0,
            "New Holland": 0,
            "Bobcat": 0,
            "TCM": 0,
            "Ford": 0,
            "Eicher": 0,
            "Sakai": 0,
            "Benford": 0,
            "Furukawa": 0,
            "DFAC": 0,
            "Tadana": 0,
            "Toyota": 0,
            "Other Heavy-Duty & Land Vehicle": 0

        },

        "Jeep & Picup": {
            "Audi": 0,
            "BMW": 0,
            "Chevrolet": 0,
            "Daewoo": 0,
            "Daihatsu": 0,
            "Datsun": 0,
            "DFSK": 0,
            "Ford": 0,
            "GMC": 0,
            "Honda": 0,
            "Hummer": 0,
            "Hyundai": 0,
            "Isuzu": 0,
            "Jeep": 0,
            "Foton": 0,
            "Kia": 0,
            "Land Rover": 0,
            "Lexus": 0,
            "Mahindra": 0,
            "Suzuki Maruti": 0,
            "Mazda": 0,
            "MCLaren": 0,
            "Mercedes": 0,
            "Micro": 0,
            "Mitsubishi": 0,
            "Nissan": 0,
            "Perodua": 0,
            "Peugeot": 0,
            "Porsche": 0,
            "Renault": 0,
            "Rolls Royce": 0,
            "Subaru": 0,
            "Skoda": 0,
            "Suzuki": 0,
            "Tata": 0,
            "Tesla": 0,
            "Toyota": 0,
            "Vauxhall": 0,
            "Volkswagen": 0,
            "Volvo": 0,
            "Willys": 0,
            "Zotye": 0,
            "Other Jeep & Picup": 0

        },

        "Lorry": {
            "Ashok Leland": 0,
            "Changan": 0,
            "DFAC": 0,
            "Mitsubishi": 0,
            "Isuzu": 0,
            "Tata": 0,
            "Toyota": 0,
            "JAC": 0,
            "JMC": 0,
            "JVC": 0,
            "Eicher": 0,
            "FAW": 0,
            "Foton": 0,
            "Ford": 0,
            "Hino": 0,
            "KIA": 0,
            "Mahindra": 0,
            "Mazda": 0,
            "Nissan": 0,
            "Honda": 0,
            "Dimo": 0,
            "Daihatsu": 0,
            "Suzuki": 0,
            "Micro": 0,
            "Freight Rover": 0,
            "Unimo": 0,
            "Youjin": 0,
            "MAN": 0,
            "DFSK": 0,
            "Subaru": 0,
            "Other Lorry": 0
        },

        "Motorcycle": (_Motorcycle = {
            "Aprilla": 0,
            "Bajaj": 0,
            "BMW": 0,
            "Demak": 0,
            "Ducati": 0,
            "Ceygra": 0,
            "Cagiva": 0,
            "Chans": 0,
            "Singer": 0,
            "Harley Davidson": 0,
            "Hero Honda": 0,
            "Honda": 0,
            "Husqvarna": 0,
            "Hyosung": 0,
            "Jialing": 0,
            "Kawasaki": 0,
            "Kinetic": 0,
            "KTM": 0,
            "DFSK": 0,
            "SsangYong": 0,
            "TVS": 0,
            "Triumph": 0,
            "Loncin": 0,
            "Mahindra": 0,
            "Minnelli": 0,
            "Moto Guzzi": 0,
            "Piaggio": 0,
            "Ranamoto": 0,
            "Royal Enfieid": 0,
            "Suzuki": 0
        }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Motorcycle, "Triumph", 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Motorcycle, "Vespa", 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Motorcycle, "Yamaha", 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Motorcycle, "Yoshimura", 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Motorcycle, "Zhongneng", 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Motorcycle, "Other Motorcycle", 0), _Motorcycle),

        "Three Wheeler": {
            "TVS": 0,
            "Bajaj": 0,
            "Mahindra": 0,
            "Ceygra": 0,
            "Piaggio": 0,
            "Other Three Wheeler": 0
        },

        "Tipper": {
            "Ashok Leyland": 0,
            "Tata": 0,
            "Hino": 0,
            "Isuzu": 0,
            "Mitsubishi": 0,
            "MAN": 0,
            "Youjin": 0,
            "Eicher": 0,
            "JAC": 0,
            "Mazda": 0,
            "ATCO": 0,
            "Mahindra": 0,
            "Nissan": 0,
            "Toyota": 0,
            "Changan": 0,
            "Sojen": 0,
            "Other Tipper": 0

        },

        "Truck": {
            "Tata": 0,
            "Mahindra": 0,
            "DFSK": 0,
            "GMC": 0,
            "Micro": 0,
            "Suzuki": 0,
            "Nissan": 0,
            "Honda": 0,
            "Daihatsu": 0,
            "Subaru": 0,
            "Isuzu": 0,
            "Mitsubishi": 0,
            "Other Truck": 0
        },

        "Van": {
            "FAW": 0,
            "Ford": 0,
            "Daihatsu": 0,
            "Dimo": 0,
            "Honda": 0,
            "Hyundai": 0,
            "Isuzu": 0,
            "Kia": 0,
            "Mazda": 0,
            "Mercedes": 0,
            "Mitsubishi": 0,
            "Micro": 0,
            "DFSK": 0,
            "Nissan": 0,
            "Subaru": 0,
            "Suzuki": 0,
            "Tata": 0,
            "Toyota": 0,
            "Volvo": 0,
            "Austin": 0,
            "Other Van": 0

        }

    },

    "Men’s & Women’s Clothing": {
        "Men’s Clothing": {
            "T-Shirts": 0,
            "Shirts": 0,
            "sarongs": 0,
            "Swimwear": 0,
            "Denim & Jeans": 0,
            "Pants": 0,
            "Shorts": 0,
            "Coats & Jackets": 0,
            "Athletic Apparel": 0,
            "Socks": 0,
            "Underwear": 0,
            "Sleep & Lounge": 0,
            "Office Ware": 0,
            "Other Men’s Clothing": 0

        },

        "Women’s Clothing": {
            "Frocks": 0,
            "Sarees": 0,
            "Tops & Blouses": 0,
            "T- Shirts": 0,
            "Office Ware": 0,
            "Coats & Jackets": 0,
            "Denim & Jeans": 0,
            "Party Dresses": 0,
            "Shorts": 0,
            "Skirts": 0,
            "Swimwear": 0,
            "Intimates & Sleepwear": 0,
            "Other Women’s Clothing": 0

        },

        "Kids & Baby": {
            "Girls (newborn)": 0,
            "Girls": 0,
            "Boys (newborn)": 0,
            "Boys": 0

        },

        "Men’s Accessories": {
            "Sunglasses": 0,
            "Wallets": 0,
            "Scarves & Wraps": 0,
            "Watches": 0,
            "Belts": 0,
            "Hats": 0,
            "Caps": 0,
            "Gloves & Mittens": 0,
            "Shoes": 0,
            "Slippers": 0,
            "Bags": 0,
            "Jewelries": 0,
            "Beauty": 0,
            "Other Men’s Accessories": 0

        },

        "Women’s Accessories": {
            "Sunglasses": 0,
            "Wallets": 0,
            "Scarves & Wraps": 0,
            "Watches": 0,
            "Belts": 0,
            "Hats": 0,
            "Caps": 0,
            "Gloves & Mittens": 0,
            "Shoes": 0,
            "Slippers": 0,
            "Bags": 0,
            "Jewelries": 0,
            "Beauty": 0,
            "Other Women’s Accessories": 0

        }

    },

    "Men’s Clothing": {
        "Men’s Clothing": {
            "T-Shirts": 0,
            "Shirts": 0,
            "sarongs": 0,
            "Swimwear": 0,
            "Denim & Jeans": 0,
            "Pants": 0,
            "Shorts": 0,
            "Coats & Jackets": 0,
            "Athletic Apparel": 0,
            "Socks": 0,
            "Underwear": 0,
            "Sleep & Lounge": 0,
            "Office Ware": 0,
            "Other Men’s Clothing": 0

        },

        "Kids & Baby": {
            "Girls (newborn)": 0,
            "Girls": 0,
            "Boys (newborn)": 0,
            "Boys": 0

        },

        "Men’s Accessories": {
            "Sunglasses": 0,
            "Wallets": 0,
            "Scarves & Wraps": 0,
            "Watches": 0,
            "Belts": 0,
            "Hats": 0,
            "Caps": 0,
            "Gloves & Mittens": 0,
            "Shoes": 0,
            "Slippers": 0,
            "Bags": 0,
            "Jewelries": 0,
            "Beauty": 0,
            "Other Men’s Accessories": 0

        }

    },

    "Women’s Clothing": {
        "Women’s Clothing": {
            "Frocks": 0,
            "Sarees": 0,
            "Tops & Blouses": 0,
            "T- Shirts": 0,
            "Office Ware": 0,
            "Coats & Jackets": 0,
            "Denim & Jeans": 0,
            "Party Dresses": 0,
            "Shorts": 0,
            "Skirts": 0,
            "Swimwear": 0,
            "Intimates & Sleepwear": 0,
            "Other Women’s Clothing": 0

        },

        "Kids & Baby": {
            "Girls (newborn)": 0,
            "Girls": 0,
            "Boys (newborn)": 0,
            "Boys": 0

        },

        "Women’s Accessories": {
            "Sunglasses": 0,
            "Wallets": 0,
            "Scarves & Wraps": 0,
            "Watches": 0,
            "Belts": 0,
            "Hats": 0,
            "Caps": 0,
            "Gloves & Mittens": 0,
            "Shoes": 0,
            "Slippers": 0,
            "Bags": 0,
            "Jewelries": 0,
            "Beauty": 0,
            "Other Women’s Accessories": 0

        }

    }
});

/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-modal',{staticClass:"text-center text-info",attrs:{"ok-only":"","centered":""},model:{value:(_vm.modalShow),callback:function ($$v) {_vm.modalShow=$$v},expression:"modalShow"}},[_vm._v("\n      You have already created a shop with this email. You can create only one\n      shop with an email. Please use another email to create another shop.\n    ")]),_vm._v(" "),_c('b-modal',{staticClass:"text-center text-info",attrs:{"ok-only":"","centered":""},model:{value:(_vm.modalShow2),callback:function ($$v) {_vm.modalShow2=$$v},expression:"modalShow2"}},[_vm._v("\n      You have already created a page with this email. You can create either one\n      page or one shop with an email. Please use another email to create a shop.\n    ")]),_vm._v(" "),_c('b-modal',{staticClass:"text-center text-info",attrs:{"ok-only":"","centered":""},model:{value:(_vm.modalShow1),callback:function ($$v) {_vm.modalShow1=$$v},expression:"modalShow1"}},[_vm._v("\n      You have already signed in. Please sign out & sign up again to create\n      another shop.\n    ")]),_vm._v(" "),_c('b-modal',{staticClass:"text-center text-info",attrs:{"ok-only":"","centered":""},model:{value:(_vm.modalShow3),callback:function ($$v) {_vm.modalShow3=$$v},expression:"modalShow3"}},[_vm._v("\n      You have successfully registered. We will contact you soon.\n    ")]),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"loading"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.fetch)?_c('div',[_c('div',{},[_c('nav',{staticClass:"navbar",staticStyle:{"background-color":"rgba()"}},[_c('router-link',{staticClass:"navbar-brand",attrs:{"to":"/"}},[_c('img',{attrs:{"src":__webpack_require__(65),"alt":"shopin-logo"}})]),_vm._v(" "),_c('div',[_c('router-link',{staticClass:"text-info mr-1 m-link",attrs:{"to":"/"}},[_vm._v("Home")])],1)],1),_vm._v(" "),_c('div',{staticStyle:{"background-color":"rgba(0, 0, 0, 0)","height":"100%"}},[_c('div',{staticClass:"col-sm-8 col-md-8 col-lg-6 m-auto pl-4 pb-4"},[_c('h3',{staticClass:"m-auto text-center pb-4",staticStyle:{"color":"#e94de9"}},[_vm._v("\n              Create Your Store\n            ")]),_vm._v(" "),_c('el-form',{ref:"formdata",staticClass:"pt-4",staticStyle:{"border":"1px solid #e2e2e2","border-radius":"5px","background-color":"#fff","padding":"20px"},attrs:{"model":_vm.formdata,"rules":_vm.rules,"label-width":"200px","label-position":_vm.labelPosition,"size":"medium","status-icon":""}},[_c('el-form-item',{attrs:{"label":"City/Town","prop":"location"}},[_c('el-cascader',{attrs:{"clearable":"","placeholder":"City","size":"medium","options":_vm.cities,"show-all-levels":false},on:{"change":_vm.handleChange},model:{value:(_vm.city),callback:function ($$v) {_vm.city=$$v},expression:"city"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Shop Category","prop":"shopcat"}},[_c('el-cascader',{attrs:{"clearable":"","placeholder":"Shop Category","size":"medium","options":_vm.shops,"show-all-levels":false},on:{"change":_vm.handleChange2},model:{value:(_vm.shopcat),callback:function ($$v) {_vm.shopcat=$$v},expression:"shopcat"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Shop Name","prop":"name"}},[_c('el-input',{attrs:{"placeholder":"Shop Name"},model:{value:(_vm.formdata.name),callback:function ($$v) {_vm.$set(_vm.formdata, "name", $$v)},expression:"formdata.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Referee Code","prop":"refCode"}},[_c('el-input',{attrs:{"placeholder":"Referee Code"},model:{value:(_vm.formdata.refCode),callback:function ($$v) {_vm.$set(_vm.formdata, "refCode", $$v)},expression:"formdata.refCode"}})],1),_vm._v(" "),(_vm.userDisplayName == "editor" || _vm.userDisplayName == "super admin")?_c('el-form-item',{attrs:{"label":"API Key","prop":"api","rules":[
                  { required: true, message: 'API key is required' } ]}},[_c('el-input',{attrs:{"placeholder":"","auto-complete":"off"},model:{value:(_vm.formdata.api),callback:function ($$v) {_vm.$set(_vm.formdata, "api", $$v)},expression:"formdata.api"}})],1):_vm._e(),_vm._v(" "),(_vm.userDisplayName == "editor" || _vm.userDisplayName == "super admin")?_c('el-form-item',{attrs:{"label":"Project ID","prop":"pidNo","rules":[
                  { required: true, message: 'Project ID is required' } ]}},[_c('el-input',{attrs:{"placeholder":"Project ID","auto-complete":"off"},model:{value:(_vm.formdata.pidNo),callback:function ($$v) {_vm.$set(_vm.formdata, "pidNo", $$v)},expression:"formdata.pidNo"}})],1):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Telephone","prop":"telephone","rules":[
                  { required: true, message: 'telephone no is required' },
                  { type: 'number', message: 'telephone no must be a number' } ]}},[_c('el-input',{attrs:{"placeholder":"777666666","auto-complete":"off"},model:{value:(_vm.formdata.telephone),callback:function ($$v) {_vm.$set(_vm.formdata, "telephone", _vm._n($$v))},expression:"formdata.telephone"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"System ID","prop":"sysid","rules":[
                  { required: true, message: 'System ID is required' } ]}},[_c('el-input',{attrs:{"placeholder":"Please remember this to login to Dashboard","auto-complete":"off"},model:{value:(_vm.formdata.sysid),callback:function ($$v) {_vm.$set(_vm.formdata, "sysid", $$v)},expression:"formdata.sysid"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"email","label":"Email","rules":[
                  {
                    required: true,
                    message: 'Please input email address',
                    trigger: 'blur',
                  },
                  {
                    type: 'email',
                    message: 'Please input correct email address',
                    trigger: ['blur', 'change'],
                  } ]}},[_c('el-input',{attrs:{"placeholder":"Email","type":"email","disabled":_vm.disableEmail},model:{value:(_vm.formdata.email),callback:function ($$v) {_vm.$set(_vm.formdata, "email", $$v)},expression:"formdata.email"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Password","prop":"pass"}},[_c('el-input',{attrs:{"placeholder":"Password (min 6 characters)","type":"password","auto-complete":"off"},model:{value:(_vm.formdata.pass),callback:function ($$v) {_vm.$set(_vm.formdata, "pass", $$v)},expression:"formdata.pass"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Confirm Password","prop":"checkPass"}},[_c('el-input',{attrs:{"placeholder":"Confirm Password","type":"password","auto-complete":"off"},model:{value:(_vm.formdata.checkPass),callback:function ($$v) {_vm.$set(_vm.formdata, "checkPass", $$v)},expression:"formdata.checkPass"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-checkbox',{staticStyle:{"color":"#e94de9","font-weight":"800"},model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}},[_vm._v("I Agree")])],1),_vm._v(" "),_c('el-form-item',[_c('router-link',{staticClass:"text-info",attrs:{"to":{ name: 'privacypolicy' }}},[_vm._v("Terms of Use and Privacy Policy")])],1),_vm._v(" "),_c('el-form-item',{staticClass:"pb-5",staticStyle:{"margin-bottom":"0px"}},[_c('el-button',{attrs:{"type":"primary","disabled":_vm.checked == false},on:{"click":function($event){_vm.submitForm('formdata')}}},[_vm._v("Create")]),_vm._v(" "),_c('el-button',{attrs:{"type":"danger"},on:{"click":function($event){_vm.resetForm('formdata')}}},[_vm._v("Reset")])],1)],1)],1)])])]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader"},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AllProducts_vue__ = __webpack_require__(202);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dcec7426_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AllProducts_vue__ = __webpack_require__(683);
function injectStyle (ssrContext) {
  __webpack_require__(599)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dcec7426"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AllProducts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dcec7426_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AllProducts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 599 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vue_easy_print_vue__ = __webpack_require__(203);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_75aa9db4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_vue_easy_print_vue__ = __webpack_require__(605);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vue_easy_print_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_75aa9db4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_vue_easy_print_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.tableShow),expression:"tableShow"}],ref:"template"},[_vm._t("default",[_c('span',[_vm._v("编写你自己的打印区域组件，然后slot插入到vue-easy-print")])],{getChineseNumber:_vm.getChineseNumber})],2),_vm._v(" "),(_vm.buttonShow)?_c('button',{class:_vm.buttonClass,attrs:{"type":"button"},on:{"click":_vm.print}},[_c('span',[_vm._v("开始打印")])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 606 */,
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-table',{ref:"singleTable",staticStyle:{"{\n        overflow-x":"scroll","width":"950px","margin":"0 auto"},attrs:{"data":_vm.priceData.filter(function (data) { return _vm.store ? (_vm.store === 'all' ? data : data.store === _vm.store) : data; }
      ),"highlight-current-row":""}},[_c('el-table-column',{attrs:{"type":"index","width":"50"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"150","property":"store","label":"Store"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',[_vm._v(_vm._s(_vm.$store.state.stores.find(function (store) { return store.id == scope.row.store; })
            .name))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"150","property":"serial","label":"Serial/Item Code"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-input',{attrs:{"size":"mini"},model:{value:(scope.row.serial),callback:function ($$v) {_vm.$set(scope.row, "serial", $$v)},expression:"scope.row.serial"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"150","property":"purcPr","label":"Purchased Price"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-input-number',{attrs:{"size":"mini","precision":2,"min":0},on:{"change":function($event){_vm.setRowSellPr(scope)}},model:{value:(scope.row.purcPr),callback:function ($$v) {_vm.$set(scope.row, "purcPr", $$v)},expression:"scope.row.purcPr"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"150","property":"sellPr","label":"Selling Price"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-input-number',{attrs:{"size":"mini","precision":2,"min":0},model:{value:(scope.row.sellPr),callback:function ($$v) {_vm.$set(scope.row, "sellPr", $$v)},expression:"scope.row.sellPr"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"150","property":"quantity","label":"Quantity"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-input-number',{attrs:{"size":"mini","precision":2,"min":0},model:{value:(scope.row.quantity),callback:function ($$v) {_vm.$set(scope.row, "quantity", $$v)},expression:"scope.row.quantity"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"150","label":"Operations"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"size":"small","type":"danger","icon":"el-icon-delete","circle":""},on:{"click":function($event){_vm.open(scope.$index, scope.row)}}}),_vm._v(" "),(_vm.printMethod)?_c('a',{staticClass:"btn btn-sm btn-secondary text-white",attrs:{"size":"sm"},on:{"click":function($event){_vm.print(_vm.product,scope.row)}}},[_vm._v("\n          Print Labels\n        ")]):_vm._e()]}}])})],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"10px","height":"30px"}},[_c('el-select',{staticStyle:{"float":"right","width":"160px","margin-right":"0px"},attrs:{"label":"Select Store","size":"small","placeholder":"Select Store"},on:{"change":_vm.updatePriceData},model:{value:(_vm.store),callback:function ($$v) {_vm.store=$$v},expression:"store"}},_vm._l((_vm.stores),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.id}})})),_vm._v(" "),(_vm.store && _vm.store !== 'all')?_c('el-button',{staticStyle:{"float":"right","margin-right":"20px"},attrs:{"size":"small","plain":""},on:{"click":function($event){_vm.addRow()}}},[_vm._v("Add Price Row")]):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 608 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"none"}},[_c('div',{staticStyle:{"width":"150px"},attrs:{"id":"print"}},[_c('barcode',{staticStyle:{"text-align":"center","height":"78px"},attrs:{"id":"pdf","value":_vm.barcode,"width":1,"height":35,"fontSize":14}},[_vm._v("\n        rendering fails.\n      ")]),_vm._v(" "),_c('div',{staticClass:"printprd",staticStyle:{"font-size":"12px","font-weight":"bold","margin-top":"-8px","text-align":"center","margin-bottom":"-4px !important"}},[_vm._v("Rs "+_vm._s(_vm.price))]),_vm._v(" "),_c('div',{staticStyle:{"font-size":"12px","font-weight":"bold","text-align":"center","margin-bottom":"-4px !important"}},[_vm._v(_vm._s(_vm.name))])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SavePDF_vue__ = __webpack_require__(216);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b8f1d982_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SavePDF_vue__ = __webpack_require__(649);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SavePDF_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b8f1d982_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SavePDF_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"overflow-x":"scroll"},attrs:{"id":"print"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-card',{staticClass:"d-print-none",staticStyle:{"background-color":"#d4e2f8","overflow":"initial"},attrs:{"shadow":"always"}},[_c('div',{staticStyle:{"margin":"-10px -10px"}},[_c('el-button',{attrs:{"size":"medium","type":"primary","plain":""},on:{"click":function($event){_vm.callCSVDownload(_vm.downloadCSVMethod)}}},[_vm._v("Download CSV")]),_vm._v(" "),_c('el-button',{staticStyle:{"margin-left":"0px"},attrs:{"size":"medium","type":"primary","plain":""},on:{"click":function($event){_vm.downloadPDF()}}},[_vm._v("Download PDF")]),_vm._v(" "),(_vm.showToggleDetails)?_c('el-button',{staticStyle:{"margin-left":"0px"},attrs:{"size":"medium","type":"primary","plain":""},on:{"click":function($event){_vm.toggleDetails()}}},[_vm._v("Toggle Details")]):_vm._e(),_vm._v(" "),(_vm.tableColumns)?_c('el-select',{staticStyle:{"margin-left":"0px","width":"180px"},attrs:{"size":"medium","multiple":"","collapse-tags":"","placeholder":"Visible Columns"},on:{"change":function($event){_vm.$root.$emit('columnChanged', _vm.tableColumns)}},model:{value:(_vm.tableColumns),callback:function ($$v) {_vm.tableColumns=$$v},expression:"tableColumns"}},_vm._l((_vm.fields),function(item){return _c('el-option',{key:item.key,attrs:{"label":item.label,"value":item.key}})})):_vm._e()],1)]),_vm._v(" "),_c('SavePDF',{staticStyle:{"display":"none"},attrs:{"items":[]}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Updating")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.loading1)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Loading")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.loading2)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Deleting")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.changed)?_c('div',[_c('b-container',{staticClass:"col-lg-10 mt-5"},[_c('h3',{staticClass:"text-info text-center pt-4 my-4"},[_vm._v("\n        "+_vm._s(this.$route.params.cat)+"\n      ")]),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"my-1",attrs:{"sm":"4"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":""}},[_c('b-input-group',[_c('b-form-input',{attrs:{"placeholder":"Search"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),_c('b-input-group-append',[_c('b-btn',{attrs:{"disabled":!_vm.filter},on:{"click":function($event){_vm.filter = ''}}},[_vm._v("Clear")])],1)],1)],1)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"sm":"5"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":""}},[_c('b-input-group',[_c('b-form-select',{attrs:{"options":_vm.sortOptions},model:{value:(_vm.sortBy),callback:function ($$v) {_vm.sortBy=$$v},expression:"sortBy"}},[_c('option',{attrs:{"slot":"first"},domProps:{"value":null},slot:"first"},[_vm._v("Sort By")])]),_vm._v(" "),_c('b-form-select',{attrs:{"slot":"append","disabled":!_vm.sortBy},slot:"append",model:{value:(_vm.sortDesc),callback:function ($$v) {_vm.sortDesc=$$v},expression:"sortDesc"}},[_c('option',{domProps:{"value":false}},[_vm._v("Asc")]),_vm._v(" "),_c('option',{domProps:{"value":true}},[_vm._v("Desc")])])],1)],1)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"sm":"3"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"horizontal":""}},[_c('b-form-select',{model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}},[_c('option',{attrs:{"disabled":""}},[_vm._v("per page")]),_vm._v(" "),_c('option',{domProps:{"value":10}},[_vm._v("10")]),_vm._v(" "),_c('option',{domProps:{"value":25}},[_vm._v("25")]),_vm._v(" "),_c('option',{domProps:{"value":50}},[_vm._v("50")]),_vm._v(" "),_c('option',{domProps:{"value":80}},[_vm._v("80")])])],1)],1)],1),_vm._v(" "),_c('el-card',{staticStyle:{"overflow-x":"scroll"},attrs:{"id":"realtable","shadow":"always"}},[_c('TableHeader',{attrs:{"pageOptions":_vm.pageOptions,"fields":_vm.fields,"items":_vm.items,"perPage":_vm.perPage,"month":_vm.month,"visibleFields":undefined,"downloadCSVMethod":'downloadCSVProducts',"enableToggle":true}}),_vm._v(" "),_c('b-table',{staticClass:"mt-4",attrs:{"show-empty":"","stacked":"sm","items":_vm.items,"fields":_vm.fields,"hover":true,"head-variant":"dark","current-page":_vm.currentPage,"per-page":_vm.perPage,"empty-text":_vm.emptyText,"filter":_vm.filter,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc,"responsive":""},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event},"filtered":_vm.onFiltered},scopedSlots:_vm._u([{key:"index",fn:function(data){return [_vm._v("\n            "+_vm._s(data.index + 1)+"\n          ")]}},{key:"default",fn:function(row){return [_c('b-img',{attrs:{"slot":"img","src":row.value,"width":"64","height":"64","alt":"image"},slot:"img"})]}},{key:"name",fn:function(row){return [_c('h6',{},[_vm._v(_vm._s(row.value))])]}},{key:"category",fn:function(row){return [_c('div',{staticClass:"row"},[_vm._v(_vm._s(row.value))])]}},{key:"actions",fn:function(row){return [_c('div',{staticClass:"btn-group",attrs:{"role":"group","aria-label":"Basic example"}},[(_vm.printItemPrice)?_c('PrintLabels',{attrs:{"id":row.item.id,"name":_vm.printItemName,"price":_vm.printItemPrice,"barcode":row.item.barcode}}):_vm._e(),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-info text-white",attrs:{"size":"sm"},on:{"click":function($event){$event.stopPropagation();row.toggleDetails($event)}}},[_vm._v("\n                View Prices\n              ")]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-sm btn-primary",attrs:{"to":{
                  name: 'editcommonproduct',
                  params: { product_id: row.item.id, cat: _vm.$route.params.cat },
                }}},[_vm._v("\n                View & Edit\n              ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-danger text-white",attrs:{"size":"sm"},on:{"click":function($event){_vm.open(row.item)}}},[_vm._v("\n                Delete\n              ")])],1)]}},{key:"row-details",fn:function(row){return [_c('b-card',{staticStyle:{"background-color":"#c9c9c9"}},[_c('el-button',{staticStyle:{"float":"right","margin-bottom":"5px"},attrs:{"type":"success","size":"small"},on:{"click":function($event){_vm.savePriceDetails(row.item)}}},[_vm._v("Save")]),_vm._v(" "),_c('PriceTable',{staticStyle:{"margin":"0 auto"},attrs:{"priceData":row.item.priceList,"showPriceTable":true,"printMethod":_vm.print,"product":row.item,"profitMargin":row.item.profitMargin}})],1)]}}])})],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"md":"6"}},[_c('b-pagination',{staticClass:"my-0",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Categories_vue__ = __webpack_require__(222);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b6c75c96_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Categories_vue__ = __webpack_require__(698);
function injectStyle (ssrContext) {
  __webpack_require__(685)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b6c75c96"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Categories_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b6c75c96_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Categories_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 685 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_commonProducts_vue__ = __webpack_require__(223);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37cdc4d0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_commonProducts_vue__ = __webpack_require__(693);
function injectStyle (ssrContext) {
  __webpack_require__(687)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-37cdc4d0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_commonProducts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37cdc4d0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_commonProducts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 687 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VariationsTable_vue__ = __webpack_require__(224);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ba6580f4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VariationsTable_vue__ = __webpack_require__(692);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VariationsTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ba6580f4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VariationsTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-table',{ref:"singleTable",staticStyle:{"{\n        overflow-x":"scroll","width":"800px","margin":"0 auto"},attrs:{"data":_vm.variationsData.filter(function (data) { return _vm.store ? (_vm.store === 'all' ? data : data.store === _vm.store) : data; }
      ),"highlight-current-row":""}},[_c('el-table-column',{attrs:{"type":"index","width":"50"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"150","property":"store","label":"Store"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',[_vm._v(_vm._s(_vm.$store.state.stores.find(function (store) { return store.id == scope.row.store; })
            .name))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"150","property":"serial","label":"Serial/Item Code"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-input',{attrs:{"size":"mini"},model:{value:(scope.row.serial),callback:function ($$v) {_vm.$set(scope.row, "serial", $$v)},expression:"scope.row.serial"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"150","property":"quantity","label":"Quantity"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-input-number',{attrs:{"size":"mini","precision":2,"min":0},model:{value:(scope.row.quantity),callback:function ($$v) {_vm.$set(scope.row, "quantity", $$v)},expression:"scope.row.quantity"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"150","label":"Operations"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"size":"small","type":"danger","icon":"el-icon-delete","circle":""},on:{"click":function($event){_vm.open(scope.$index, scope.row)}}})]}}])})],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"10px","height":"30px"}},[_c('el-select',{staticStyle:{"float":"right","width":"160px","margin-right":"0px"},attrs:{"label":"Select Store","size":"small","placeholder":"Select Store"},on:{"change":_vm.updatePriceData},model:{value:(_vm.store),callback:function ($$v) {_vm.store=$$v},expression:"store"}},_vm._l((_vm.stores),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.id}})})),_vm._v(" "),(_vm.store && _vm.store !== 'all')?_c('el-button',{staticStyle:{"float":"right","margin-right":"20px"},attrs:{"size":"small","plain":""},on:{"click":function($event){_vm.addRow()}}},[_vm._v("Add Row")]):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Adding")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.loading1)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Loading")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.changed)?_c('div',[_c('div',{staticClass:"container",staticStyle:{"padding":"0px"}},[_c('b-modal',{staticClass:"text-center text-info",attrs:{"ok-only":"","centered":""},model:{value:(_vm.modalShow),callback:function ($$v) {_vm.modalShow=$$v},expression:"modalShow"}},[_vm._v("\n          You have added maximum products/items. Please upgrade the package to\n          add more products/items.\n        ")]),_vm._v(" "),_c('b-modal',{staticClass:"text-center text-info",attrs:{"ok-only":"","centered":""},model:{value:(_vm.modalShow2),callback:function ($$v) {_vm.modalShow2=$$v},expression:"modalShow2"}},[_vm._v("\n          Product/Item Added.\n        ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-12 col-lg-8 m-auto"},[_c('el-form',{ref:"formdata",staticStyle:{"border":"1px solid #e2e2e2","border-radius":"5px","background-color":"#fff","padding":"20px"},attrs:{"model":_vm.formdata,"rules":_vm.rules,"label-width":"200px","label-position":_vm.labelPosition,"size":"medium","status-icon":""},nativeOn:{"submit":function($event){$event.preventDefault();}}},[(_vm.shopcat != 'Supermarket')?_c('h4',{staticClass:"text-center text-info mt-4"},[_vm._v("\n              Add "+_vm._s(this.$route.params.cat)+" items\n            ")]):_vm._e(),_vm._v(" "),(_vm.shopcat == 'Supermarket')?_c('h4',{staticClass:"text-center text-info mt-4"},[_vm._v("\n              Add items\n            ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"file-upload col-12 col-md-6",staticStyle:{"margin-top":"20px"}},[_c('div',{staticClass:"image-upload-wrap",staticStyle:{"height":"100px"}},[_c('input',{staticClass:"file-upload-input",attrs:{"type":"file","accept":".jpg, .jpeg"},on:{"change":_vm.fileSelect1}}),_vm._v(" "),_c('div',{staticClass:"drag-text"},[_c('h6',{staticClass:"pt-3 pb-1"},[_vm._v("Add main image")]),_vm._v(" "),_c('p',[_vm._v("(maximum file size 5MB)")])])]),_vm._v(" "),_c('div',{staticClass:"file-upload-content mx-auto text-center",style:({ display: _vm.visible1 })},[_c('img',{staticClass:"file-upload-image",attrs:{"src":_vm.formdata.imageUrl1,"alt":""}})])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Product Name","prop":"name"}},[_c('el-input',{staticStyle:{"width":"220px"},attrs:{"clearable":""},model:{value:(_vm.formdata.name),callback:function ($$v) {_vm.$set(_vm.formdata, "name", $$v)},expression:"formdata.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Barcode/SKU","prop":"barcode"}},[_c('el-input',{staticStyle:{"width":"220px"},attrs:{"clearable":""},on:{"change":_vm.checkBarcode},model:{value:(_vm.formdata.barcode),callback:function ($$v) {_vm.$set(_vm.formdata, "barcode", $$v)},expression:"formdata.barcode"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Low Alert Quantity","prop":"quantity"}},[_c('el-input',{staticStyle:{"width":"220px"},attrs:{"type":"number","clearable":"","min":1},model:{value:(_vm.formdata.quantity),callback:function ($$v) {_vm.$set(_vm.formdata, "quantity", _vm._n($$v))},expression:"formdata.quantity"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Profit Margin","prop":"profitmargin"}},[_c('el-input',{staticClass:"input-with-select",staticStyle:{"width":"220px"},attrs:{"type":"number","precision":2,"clearable":""},model:{value:(_vm.formdata.profitMargin),callback:function ($$v) {_vm.$set(_vm.formdata, "profitMargin", _vm._n($$v))},expression:"formdata.profitMargin"}},[_c('template',{attrs:{"slot":"append"},slot:"append"},[_c('i',{staticClass:"fa fa-percent"})])],2)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Update Price List"}},[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.showPriceTable = true}}},[_vm._v("Update Price List")])],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Online Store Price","prop":"price"}},[_c('el-input',{staticClass:"input-with-select",staticStyle:{"width":"220px"},attrs:{"type":"number","precision":2,"clearable":""},model:{value:(_vm.formdata.price),callback:function ($$v) {_vm.$set(_vm.formdata, "price", _vm._n($$v))},expression:"formdata.price"}},[_c('template',{attrs:{"slot":"prepend"},slot:"prepend"},[_vm._v("RS")])],2)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Discount","prop":"dis"}},[_c('el-input',{staticStyle:{"width":"220px"},attrs:{"type":"number","placeholder":"Discount"},model:{value:(_vm.formdata.dis),callback:function ($$v) {_vm.$set(_vm.formdata, "dis", _vm._n($$v))},expression:"formdata.dis"}},[_c('template',{attrs:{"slot":"append"},slot:"append"},[_c('i',{staticClass:"fa fa-percent"})])],2)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Category","prop":"category"}},[_c('el-select',{attrs:{"placeholder":"Category"},model:{value:(_vm.category),callback:function ($$v) {_vm.category=$$v},expression:"category"}},[_c('el-option',{attrs:{"value":this.$route.params.cat}},[_vm._v(_vm._s(this.$route.params.cat))])],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Sub Category","prop":"subcategory"}},[_c('el-select',{attrs:{"placeholder":"Sub Category"},model:{value:(_vm.formdata.subcategory),callback:function ($$v) {_vm.$set(_vm.formdata, "subcategory", $$v)},expression:"formdata.subcategory"}},_vm._l((Object.keys(_vm.subcategories).sort()),function(subcat,key){return _c('el-option',{key:key,attrs:{"value":subcat}},[_vm._v(_vm._s(subcat))])}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Product Variations"}},[_c('el-select',{attrs:{"multiple":"","filterable":"","allow-create":"","default-first-option":"","placeholder":"Enter Variations"},model:{value:(_vm.formdata.variations),callback:function ($$v) {_vm.$set(_vm.formdata, "variations", $$v)},expression:"formdata.variations"}},_vm._l((_vm.formdata.variations),function(item){return _c('el-option',{key:item,attrs:{"label":item,"value":item}})}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Brand (if any)","prop":"brand"}},[_c('el-input',{staticStyle:{"width":"220px"},attrs:{"placeholder":"Brand","clearable":""},model:{value:(_vm.formdata.brand),callback:function ($$v) {_vm.$set(_vm.formdata, "brand", $$v)},expression:"formdata.brand"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Bin Location/Rack","prop":"rack"}},[_c('el-input',{staticStyle:{"width":"220px"},attrs:{"placeholder":"Bin Location/Rack","clearable":""},model:{value:(_vm.formdata.rack),callback:function ($$v) {_vm.$set(_vm.formdata, "rack", $$v)},expression:"formdata.rack"}})],1),_vm._v(" "),(this.$route.params.cat == 'Cameras')?_c('el-form-item',{attrs:{"label":"Model","prop":"model"}},[_c('el-input',{staticStyle:{"width":"220px"},attrs:{"placeholder":"Model","clearable":""},model:{value:(_vm.formdata.model),callback:function ($$v) {_vm.$set(_vm.formdata, "model", $$v)},expression:"formdata.model"}})],1):_vm._e(),_vm._v(" "),(
                _vm.shoptype == 'Jewelry' ||
                _vm.shoptype == 'Gems' ||
                _vm.shoptype == 'Jewelry Gems & Watch'
              )?_c('el-form-item',{attrs:{"label":"Karat/Carat","prop":"krat"}},[_c('el-input',{staticClass:"input-with-select",staticStyle:{"width":"220px"},attrs:{"type":"number","clearable":""},model:{value:(_vm.formdata.karat),callback:function ($$v) {_vm.$set(_vm.formdata, "karat", _vm._n($$v))},expression:"formdata.karat"}},[_c('template',{attrs:{"slot":"prepend"},slot:"prepend"},[_vm._v("k")])],2)],1):_vm._e(),_vm._v(" "),(
                _vm.shoptype == 'Jewelry' ||
                _vm.shoptype == 'Gems' ||
                _vm.shoptype == 'Jewelry Gems & Watch'
              )?_c('el-form-item',{attrs:{"label":"Metal/Stone","prop":"metal"}},[_c('el-input',{staticStyle:{"width":"220px"},attrs:{"placeholder":"Metal/Stone","clearable":""},model:{value:(_vm.formdata.metal),callback:function ($$v) {_vm.$set(_vm.formdata, "metal", $$v)},expression:"formdata.metal"}})],1):_vm._e(),_vm._v(" "),(_vm.shopcat == 'Books')?_c('el-form-item',{attrs:{"label":"Author","prop":"author"}},[_c('el-input',{staticStyle:{"width":"220px"},attrs:{"placeholder":"Author","clearable":""},model:{value:(_vm.formdata.author),callback:function ($$v) {_vm.$set(_vm.formdata, "author", $$v)},expression:"formdata.author"}})],1):_vm._e(),_vm._v(" "),(_vm.shopcat == 'Books')?_c('el-form-item',{attrs:{"label":"Publisher","prop":"publisher"}},[_c('el-input',{staticStyle:{"width":"220px"},attrs:{"placeholder":"Publisher","clearable":""},model:{value:(_vm.formdata.publisher),callback:function ($$v) {_vm.$set(_vm.formdata, "publisher", $$v)},expression:"formdata.publisher"}})],1):_vm._e(),_vm._v(" "),(_vm.formdata.subcategory == 'TV')?_c('el-form-item',{attrs:{"label":"Screen Size","prop":"screensize"}},[_c('el-input',{staticClass:"input-with-select",staticStyle:{"width":"220px"},attrs:{"placeholder":"Screen Size","clearable":""},model:{value:(_vm.formdata.screensize),callback:function ($$v) {_vm.$set(_vm.formdata, "screensize", $$v)},expression:"formdata.screensize"}},[_c('template',{attrs:{"slot":"prepend"},slot:"prepend"},[_vm._v("inches")])],2)],1):_vm._e(),_vm._v(" "),(
                _vm.shopcat == 'Clothing & Accessories' ||
                _vm.shopcat == 'Shoes & Footwear' ||
                this.$route.params.cat == 'Tiles'
              )?_c('el-form-item',{attrs:{"label":"Size","prop":"size"}},[_c('el-input',{staticStyle:{"width":"220px"},attrs:{"placeholder":"Size","clearable":""},model:{value:(_vm.formdata.size),callback:function ($$v) {_vm.$set(_vm.formdata, "size", $$v)},expression:"formdata.size"}})],1):_vm._e(),_vm._v(" "),(
                _vm.shopcat == 'Clothing & Accessories' ||
                _vm.shopcat == 'Shoes & Footwear' ||
                this.$route.params.cat == 'Tiles' ||
                _vm.shoptype == 'Watch' ||
                _vm.shopcat == 'Bags' ||
                _vm.shopcat == 'Furniture' ||
                _vm.shopcat == 'Home Decor' ||
                _vm.shopcat == 'Handicrafts' ||
                _vm.shopcat == 'Baby Kids & Toys'
              )?_c('el-form-item',{attrs:{"label":"Material","prop":"material"}},[_c('el-input',{staticStyle:{"width":"220px"},attrs:{"placeholder":"Material","clearable":""},model:{value:(_vm.formdata.material),callback:function ($$v) {_vm.$set(_vm.formdata, "material", $$v)},expression:"formdata.material"}})],1):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Main Color","prop":"color"}},[_c('el-input',{staticStyle:{"width":"220px"},attrs:{"placeholder":"Color","clearable":""},model:{value:(_vm.formdata.color),callback:function ($$v) {_vm.$set(_vm.formdata, "color", $$v)},expression:"formdata.color"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Other Colors"}},[_c('el-select',{attrs:{"multiple":"","filterable":"","allow-create":"","default-first-option":"","placeholder":"Enter Other Colors"},model:{value:(_vm.formdata.colors),callback:function ($$v) {_vm.$set(_vm.formdata, "colors", $$v)},expression:"formdata.colors"}},_vm._l((_vm.formdata.colors),function(item){return _c('el-option',{key:item,attrs:{"label":item,"value":item}})}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Expire Date","prop":"expireDate"}},[_c('el-date-picker',{attrs:{"type":"date","placeholder":"Expire Date"},model:{value:(_vm.formdata.expireDate),callback:function ($$v) {_vm.$set(_vm.formdata, "expireDate", $$v)},expression:"formdata.expireDate"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Condition","prop":"cond"}},[_c('el-select',{attrs:{"placeholder":"Condition"},model:{value:(_vm.formdata.cond),callback:function ($$v) {_vm.$set(_vm.formdata, "cond", $$v)},expression:"formdata.cond"}},[_c('el-option',{attrs:{"value":"new"}},[_vm._v("New")]),_vm._v(" "),_c('el-option',{attrs:{"value":"used"}},[_vm._v("Used")])],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Warranty","prop":"warranty"}},[_c('el-select',{staticStyle:{"width":"220px"},attrs:{"filterable":"","allow-create":"","placeholder":"Warranty","clearable":""},model:{value:(_vm.formdata.warranty),callback:function ($$v) {_vm.$set(_vm.formdata, "warranty", $$v)},expression:"formdata.warranty"}},[_c('el-option',{attrs:{"value":"No Warranty"}},[_vm._v("No Warranty")]),_vm._v(" "),_c('el-option',{attrs:{"value":"1 Months Warranty"}},[_vm._v("1 Months Warranty")]),_vm._v(" "),_c('el-option',{attrs:{"value":"3 Months Warranty"}},[_vm._v("3 Months Warranty")]),_vm._v(" "),_c('el-option',{attrs:{"value":"6 Months Warranty"}},[_vm._v("6 Months Warranty")]),_vm._v(" "),_c('el-option',{attrs:{"value":"1 Year Warranty"}},[_vm._v("1 Year Warranty")]),_vm._v(" "),_c('el-option',{attrs:{"value":"2 Year Warranty"}},[_vm._v("2 Year Warranty")]),_vm._v(" "),_c('el-option',{attrs:{"value":"3 Year Warranty"}},[_vm._v("3 Year Warranty")]),_vm._v(" "),_c('el-option',{attrs:{"value":"4 Year Warranty"}},[_vm._v("4 Year Warranty")]),_vm._v(" "),_c('el-option',{attrs:{"value":"5 Year Warranty"}},[_vm._v("5 Year Warranty")]),_vm._v(" "),_c('el-option',{attrs:{"value":"10 Year Warranty"}},[_vm._v("10 Year Warranty")]),_vm._v(" "),_c('el-option',{attrs:{"value":"Lifetime Warranty"}},[_vm._v("Lifetime Warranty")])],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Product Description","prop":"desc"}},[_c('el-input',{attrs:{"type":"textarea","maxlength":"1000","autosize":{ minRows: 2, maxRows: 4 }},model:{value:(_vm.formdata.desc),callback:function ($$v) {_vm.$set(_vm.formdata, "desc", $$v)},expression:"formdata.desc"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.submitForm('formdata')}}},[_vm._v("Add")]),_vm._v(" "),_c('el-button',{on:{"click":function($event){_vm.resetForm('formdata')}}},[_vm._v("Reset")])],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"width":_vm.priceTableWidth,"show-close":true,"close-on-click-modal":false,"title":"Update Prices","center":"","visible":_vm.showPriceTable},on:{"update:visible":function($event){_vm.showPriceTable=$event}}},[_c('PriceTable',{attrs:{"priceData":_vm.formdata.priceData,"showPriceTable":_vm.showPriceTable,"profitMargin":_vm.formdata.profitMargin}})],1),_vm._v(" "),_c('el-dialog',{attrs:{"width":_vm.priceTableWidth,"show-close":true,"close-on-click-modal":false,"title":"Update Variations","center":"","visible":_vm.showVariationsTable},on:{"update:visible":function($event){_vm.showVariationsTable=$event}}},[_c('PriceTable',{attrs:{"variationsData":_vm.formdata.variations,"showVariationsTable":_vm.showVariationsTable}})],1)],1)],1)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 694 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Adding")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.loading1)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Loading")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.changed)?_c('div',[_c('b-modal',{staticClass:"text-center text-info",attrs:{"ok-only":"","centered":"","centered":""},model:{value:(_vm.modalShow),callback:function ($$v) {_vm.modalShow=$$v},expression:"modalShow"}},[_vm._v("\n        You have added maximum items. Please upgrade the package to add more\n        items.\n      ")]),_vm._v(" "),_c('b-modal',{staticClass:"text-center text-info",attrs:{"ok-only":"","centered":"","centered":""},model:{value:(_vm.modalShow2),callback:function ($$v) {_vm.modalShow2=$$v},expression:"modalShow2"}},[_vm._v("\n        Item Added.\n      ")]),_vm._v(" "),_c('div',{staticClass:"container",staticStyle:{"padding":"0px"}},[_c('div',{staticClass:"m-auto text-right pt-4 pb-3"},[_c('router-link',{staticClass:"text-white",staticStyle:{"text-decoration":"none"},attrs:{"to":{
              name: 'allProducts',
              params: { cat: this.$route.params.cat },
            }}},[_c('el-button',{attrs:{"type":"primary","size":"medium"}},[_c('i',{staticClass:"el-icon-view mr-2"}),_vm._v("View Products")])],1)],1),_vm._v(" "),_c('div',{staticClass:"col-sm-12 col-lg-8 m-auto"},[_c('el-form',{ref:"formdata",staticStyle:{"border":"1px solid #e2e2e2","border-radius":"5px","background-color":"#fff","padding":"20px"},attrs:{"model":_vm.formdata,"rules":_vm.rules,"label-width":"200px","label-position":_vm.labelPosition,"size":"medium","status-icon":""},nativeOn:{"submit":function($event){$event.preventDefault();}}},[_c('h4',{staticClass:"text-center text-info mt-4"},[_vm._v("\n              Add "+_vm._s(this.$route.params.cat)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"file-upload col-12 col-md-6",staticStyle:{"margin-top":"30px"}},[_c('div',{staticClass:"image-upload-wrap",staticStyle:{"height":"100px"}},[_c('input',{staticClass:"file-upload-input",attrs:{"type":"file","accept":".jpg, .jpeg"},on:{"change":_vm.fileSelect1}}),_vm._v(" "),_c('div',{staticClass:"drag-text"},[_c('h6',{staticClass:"pt-3 pb-1"},[_vm._v("Add main image")]),_vm._v(" "),_c('p',[_vm._v("(maximum file size 5MB)")])])]),_vm._v(" "),_c('div',{staticClass:"file-upload-content mx-auto text-center",style:({ display: _vm.visible1 })},[_c('img',{staticClass:"file-upload-image",attrs:{"src":_vm.formdata.imageUrl1,"alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"mt-3 mb-4",staticStyle:{"height":"auto"}},[_c('div',{staticClass:"file-upload col-12 col-md-6 m-auto"},[_c('div',{staticClass:"image-upload-wrap",staticStyle:{"height":"100px"}},[_c('input',{staticClass:"file-upload-input",attrs:{"type":"file","multiple":"","accept":".jpg, .jpeg"},on:{"change":_vm.otherIMG}}),_vm._v(" "),_c('div',{staticClass:"drag-text"},[_c('h6',{staticClass:"pt-3 pb-1"},[_vm._v("Add other images")]),_vm._v(" "),_c('p',[_vm._v("(maximum 4 images)")])])]),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.imgfiles),function(file,i){return _c('div',{key:i,staticClass:"\n                      file-upload-content\n                      justify-item-center\n                      col-12 col-sm-12\n                    ",style:({ display: _vm.visible2 })},[_c('div',{style:({ display: _vm.visible2 })},[_c('img',{staticClass:"file-upload-image",staticStyle:{"margin-right":"0px"},attrs:{"src":file,"alt":"your image"}}),_vm._v(" "),_c('div',{staticClass:"image-title-wrap mt-2"},[_c('el-button',{attrs:{"type":"danger","size":"small"},on:{"click":function($event){_vm.removeimg(i)}}},[_vm._v("Remove Image")])],1)])])}))])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Product Name","prop":"name"}},[_c('el-input',{staticStyle:{"width":"220px"},attrs:{"clearable":""},model:{value:(_vm.formdata.name),callback:function ($$v) {_vm.$set(_vm.formdata, "name", $$v)},expression:"formdata.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Barcode/SKU","prop":"barcode"}},[_c('el-input',{staticStyle:{"width":"220px"},attrs:{"clearable":""},on:{"change":_vm.checkBarcode},model:{value:(_vm.formdata.barcode),callback:function ($$v) {_vm.$set(_vm.formdata, "barcode", $$v)},expression:"formdata.barcode"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Quantity","prop":"quantity"}},[_c('el-input',{staticStyle:{"width":"220px"},attrs:{"type":"number","clearable":"","min":1},model:{value:(_vm.formdata.quantity),callback:function ($$v) {_vm.$set(_vm.formdata, "quantity", _vm._n($$v))},expression:"formdata.quantity"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Main Price","prop":"price"}},[_c('el-input',{staticClass:"input-with-select",staticStyle:{"width":"220px"},attrs:{"clearable":""},model:{value:(_vm.formdata.price),callback:function ($$v) {_vm.$set(_vm.formdata, "price", _vm._n($$v))},expression:"formdata.price"}},[_c('template',{attrs:{"slot":"prepend"},slot:"prepend"},[_vm._v("RS")])],2)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Price List"}},[_c('el-select',{attrs:{"multiple":"","filterable":"","allow-create":"","default-first-option":"","placeholder":"Enter Prices"},model:{value:(_vm.formdata.priceList),callback:function ($$v) {_vm.$set(_vm.formdata, "priceList", $$v)},expression:"formdata.priceList"}},_vm._l((_vm.formdata.priceList),function(item){return _c('el-option',{key:item,attrs:{"label":item,"value":item}})}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Product Variations"}},[_c('el-select',{attrs:{"multiple":"","filterable":"","allow-create":"","default-first-option":"","placeholder":"Enter Variations"},model:{value:(_vm.formdata.variations),callback:function ($$v) {_vm.$set(_vm.formdata, "variations", $$v)},expression:"formdata.variations"}},_vm._l((_vm.formdata.variations),function(item){return _c('el-option',{key:item,attrs:{"label":item,"value":item}})}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Discount","prop":"dis"}},[_c('el-input',{staticStyle:{"width":"220px"},attrs:{"placeholder":"Discount"},model:{value:(_vm.formdata.dis),callback:function ($$v) {_vm.$set(_vm.formdata, "dis", _vm._n($$v))},expression:"formdata.dis"}},[_c('template',{attrs:{"slot":"append"},slot:"append"},[_c('i',{staticClass:"fa fa-percent"})])],2)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Category","prop":"category"}},[_c('el-select',{staticClass:"el-select",attrs:{"placeholder":"Category"},model:{value:(_vm.category),callback:function ($$v) {_vm.category=$$v},expression:"category"}},[_c('el-option',{staticClass:"el-input",attrs:{"value":this.$route.params.cat}},[_vm._v(_vm._s(this.$route.params.cat))])],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Brand","prop":"subcategory"}},[_c('el-select',{attrs:{"placeholder":"Brand"},model:{value:(_vm.formdata.subcategory),callback:function ($$v) {_vm.$set(_vm.formdata, "subcategory", $$v)},expression:"formdata.subcategory"}},_vm._l((_vm.subcategories),function(subcat,key){return _c('el-option',{key:key,attrs:{"value":key}},[_vm._v(_vm._s(key))])}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Model","prop":"model"}},[_c('el-input',{staticClass:"input-with-select",staticStyle:{"width":"220px"},attrs:{"placeholder":"Model","type":"text"},model:{value:(_vm.formdata.model),callback:function ($$v) {_vm.$set(_vm.formdata, "model", $$v)},expression:"formdata.model"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Main Color","prop":"color"}},[_c('el-input',{staticStyle:{"width":"220px"},attrs:{"placeholder":"Color","clearable":""},model:{value:(_vm.formdata.color),callback:function ($$v) {_vm.$set(_vm.formdata, "color", $$v)},expression:"formdata.color"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Other Colors"}},[_c('el-select',{attrs:{"multiple":"","filterable":"","allow-create":"","default-first-option":"","placeholder":"Enter Other Colors"},model:{value:(_vm.formdata.colors),callback:function ($$v) {_vm.$set(_vm.formdata, "colors", $$v)},expression:"formdata.colors"}},_vm._l((_vm.formdata.colors),function(item){return _c('el-option',{key:item,attrs:{"label":item,"value":item}})}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"CPU","prop":"cpu"}},[_c('el-input',{staticClass:"input-with-select",staticStyle:{"width":"220px"},attrs:{"placeholder":"CPU","type":"text"},model:{value:(_vm.formdata.cpu),callback:function ($$v) {_vm.$set(_vm.formdata, "cpu", $$v)},expression:"formdata.cpu"}})],1),_vm._v(" "),(_vm.shopcat == 'Computers & Laptops')?_c('el-form-item',{attrs:{"label":"CPU Generation","prop":"cpugen"}},[_c('el-input',{staticClass:"input-with-select",staticStyle:{"width":"220px"},attrs:{"placeholder":"CPU Generation","type":"text"},model:{value:(_vm.formdata.cpugen),callback:function ($$v) {_vm.$set(_vm.formdata, "cpugen", $$v)},expression:"formdata.cpugen"}})],1):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":"OS","prop":"os"}},[_c('el-input',{staticClass:"input-with-select",staticStyle:{"width":"220px"},attrs:{"placeholder":"OS","type":"text"},model:{value:(_vm.formdata.os),callback:function ($$v) {_vm.$set(_vm.formdata, "os", $$v)},expression:"formdata.os"}})],1),_vm._v(" "),(_vm.shopcat == 'Computers & Laptops')?_c('el-form-item',{attrs:{"label":"Hard Drive","prop":"hard"}},[_c('el-input',{staticClass:"input-with-select",staticStyle:{"width":"220px"},attrs:{"placeholder":"Hard Drive","type":"text"},model:{value:(_vm.formdata.hard),callback:function ($$v) {_vm.$set(_vm.formdata, "hard", $$v)},expression:"formdata.hard"}},[_c('template',{attrs:{"slot":"append"},slot:"append"},[_vm._v("GB")])],2)],1):_vm._e(),_vm._v(" "),(_vm.shopcat == 'Mobiles & Tablets')?_c('el-form-item',{attrs:{"label":"Storage/ROM","prop":"storage"}},[_c('el-input',{staticClass:"input-with-select",staticStyle:{"width":"220px"},attrs:{"placeholder":"Storage/ROM","type":"text"},model:{value:(_vm.formdata.storage),callback:function ($$v) {_vm.$set(_vm.formdata, "storage", $$v)},expression:"formdata.storage"}},[_c('template',{attrs:{"slot":"append"},slot:"append"},[_vm._v("GB")])],2)],1):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":"RAM","prop":"ram"}},[_c('el-input',{staticClass:"input-with-select",staticStyle:{"width":"220px"},attrs:{"placeholder":"RAM","type":"text"},model:{value:(_vm.formdata.ram),callback:function ($$v) {_vm.$set(_vm.formdata, "ram", $$v)},expression:"formdata.ram"}},[_c('template',{attrs:{"slot":"append"},slot:"append"},[_vm._v("GB")])],2)],1),_vm._v(" "),(_vm.shopcat == 'Computers & Laptops')?_c('el-form-item',{attrs:{"label":"Graphics","prop":"graphics"}},[_c('el-input',{staticClass:"input-with-select",staticStyle:{"width":"220px"},attrs:{"placeholder":"Graphics","type":"text"},model:{value:(_vm.formdata.graphics),callback:function ($$v) {_vm.$set(_vm.formdata, "graphics", $$v)},expression:"formdata.graphics"}},[_c('template',{attrs:{"slot":"append"},slot:"append"},[_vm._v("GB")])],2)],1):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Screen Size","prop":"screen"}},[_c('el-input',{staticClass:"input-with-select",staticStyle:{"width":"220px"},attrs:{"placeholder":"Screen Size","type":"text"},model:{value:(_vm.formdata.screen),callback:function ($$v) {_vm.$set(_vm.formdata, "screen", $$v)},expression:"formdata.screen"}},[_c('template',{attrs:{"slot":"append"},slot:"append"},[_vm._v("inches")])],2)],1),_vm._v(" "),(_vm.shopcat == 'Mobiles & Tablets')?_c('el-form-item',{attrs:{"label":"Rear Camera","prop":"rearcamera"}},[_c('el-input',{staticClass:"input-with-select",staticStyle:{"width":"220px"},attrs:{"placeholder":"Rear Camera","type":"text"},model:{value:(_vm.formdata.rearcamera),callback:function ($$v) {_vm.$set(_vm.formdata, "rearcamera", $$v)},expression:"formdata.rearcamera"}},[_c('template',{attrs:{"slot":"append"},slot:"append"},[_vm._v("MP")])],2)],1):_vm._e(),_vm._v(" "),(_vm.shopcat == 'Mobiles & Tablets')?_c('el-form-item',{attrs:{"label":"Front Camera","prop":"frontcamera"}},[_c('el-input',{staticClass:"input-with-select",staticStyle:{"width":"220px"},attrs:{"placeholder":"Front Camera","type":"text"},model:{value:(_vm.formdata.frontcamera),callback:function ($$v) {_vm.$set(_vm.formdata, "frontcamera", $$v)},expression:"formdata.frontcamera"}},[_c('template',{attrs:{"slot":"append"},slot:"append"},[_vm._v("MP")])],2)],1):_vm._e(),_vm._v(" "),(_vm.shopcat == 'Mobiles & Tablets')?_c('el-form-item',{attrs:{"label":"Battery","prop":"battery"}},[_c('el-input',{staticClass:"input-with-select",staticStyle:{"width":"220px"},attrs:{"placeholder":"Battery","type":"text"},model:{value:(_vm.formdata.battery),callback:function ($$v) {_vm.$set(_vm.formdata, "battery", $$v)},expression:"formdata.battery"}},[_c('template',{attrs:{"slot":"append"},slot:"append"},[_vm._v("mAh")])],2)],1):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Weight","prop":"weight"}},[_c('el-input',{staticClass:"input-with-select",staticStyle:{"width":"220px"},attrs:{"placeholder":"Weight","type":"text"},model:{value:(_vm.formdata.weight),callback:function ($$v) {_vm.$set(_vm.formdata, "weight", $$v)},expression:"formdata.weight"}},[_c('template',{attrs:{"slot":"append"},slot:"append"},[_vm._v("g")])],2)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Condition","prop":"cond"}},[_c('el-select',{attrs:{"placeholder":"Condition"},model:{value:(_vm.formdata.cond),callback:function ($$v) {_vm.$set(_vm.formdata, "cond", $$v)},expression:"formdata.cond"}},[_c('el-option',{attrs:{"value":"new"}},[_vm._v("New")]),_vm._v(" "),_c('el-option',{attrs:{"value":"used"}},[_vm._v("Used")])],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Item Type","prop":"type"}},[_c('el-select',{attrs:{"placeholder":"Item Type"},model:{value:(_vm.formdata.type),callback:function ($$v) {_vm.$set(_vm.formdata, "type", $$v)},expression:"formdata.type"}},[_c('el-option',{attrs:{"value":"none"}},[_vm._v("None")]),_vm._v(" "),_c('el-option',{attrs:{"value":"latest"}},[_vm._v("Latest Item")]),_vm._v(" "),_c('el-option',{attrs:{"value":"bestselling"}},[_vm._v("Best Selling Item")])],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Warranty","prop":"warranty"}},[_c('el-select',{staticStyle:{"width":"220px"},attrs:{"filterable":"","allow-create":"","placeholder":"Warranty","clearable":""},model:{value:(_vm.formdata.warranty),callback:function ($$v) {_vm.$set(_vm.formdata, "warranty", $$v)},expression:"formdata.warranty"}},[_c('el-option',{attrs:{"value":"No Warranty"}},[_vm._v("No Warranty")]),_vm._v(" "),_c('el-option',{attrs:{"value":"1 Months Warranty"}},[_vm._v("1 Months Warranty")]),_vm._v(" "),_c('el-option',{attrs:{"value":"3 Months Warranty"}},[_vm._v("3 Months Warranty")]),_vm._v(" "),_c('el-option',{attrs:{"value":"6 Months Warranty"}},[_vm._v("6 Months Warranty")]),_vm._v(" "),_c('el-option',{attrs:{"value":"1 Year Warranty"}},[_vm._v("1 Year Warranty")]),_vm._v(" "),_c('el-option',{attrs:{"value":"2 Year Warranty"}},[_vm._v("2 Year Warranty")]),_vm._v(" "),_c('el-option',{attrs:{"value":"3 Year Warranty"}},[_vm._v("3 Year Warranty")]),_vm._v(" "),_c('el-option',{attrs:{"value":"4 Year Warranty"}},[_vm._v("4 Year Warranty")]),_vm._v(" "),_c('el-option',{attrs:{"value":"5 Year Warranty"}},[_vm._v("5 Year Warranty")]),_vm._v(" "),_c('el-option',{attrs:{"value":"10 Year Warranty"}},[_vm._v("10 Year Warranty")]),_vm._v(" "),_c('el-option',{attrs:{"value":"Lifetime Warranty"}},[_vm._v("Lifetime Warranty")])],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Description","prop":"desc"}},[_c('el-input',{attrs:{"type":"textarea","maxlength":"1000","autosize":{ minRows: 2, maxRows: 4 }},model:{value:(_vm.formdata.desc),callback:function ($$v) {_vm.$set(_vm.formdata, "desc", $$v)},expression:"formdata.desc"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.submitForm('formdata')}}},[_vm._v("Add")]),_vm._v(" "),_c('el-button',{on:{"click":function($event){_vm.resetForm('formdata')}}},[_vm._v("Reset")])],1)],1)],1)])],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 696 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Adding")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.loading1)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Loading")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.changed)?_c('div',[_c('div',{staticClass:"container",staticStyle:{"padding":"0px"}},[_c('b-modal',{staticClass:"text-center text-info",attrs:{"ok-only":"","centered":"","centered":""},model:{value:(_vm.modalShow),callback:function ($$v) {_vm.modalShow=$$v},expression:"modalShow"}},[_vm._v("\n          You have added maximum vehicles. Please upgrade the package to add\n          more vehicles.\n        ")]),_vm._v(" "),_c('b-modal',{staticClass:"text-center text-info",attrs:{"ok-only":"","centered":"","centered":""},model:{value:(_vm.modalShow2),callback:function ($$v) {_vm.modalShow2=$$v},expression:"modalShow2"}},[_vm._v("\n          Vehicle Added.\n        ")]),_vm._v(" "),_c('div',{staticClass:"m-auto text-right pt-4 pb-3"},[_c('router-link',{staticClass:"text-white",staticStyle:{"text-decoration":"none"},attrs:{"to":{
              name: 'allProducts',
              params: { cat: this.$route.params.cat },
            }}},[_c('el-button',{attrs:{"type":"primary","size":"medium"}},[_c('i',{staticClass:"el-icon-view mr-2"}),_vm._v("View Vehicles")])],1)],1),_vm._v(" "),_c('div',{staticClass:"col-sm-12 col-lg-8 m-auto"},[_c('el-form',{ref:"formdata",staticStyle:{"border":"1px solid #e2e2e2","border-radius":"5px","background-color":"#fff","padding":"20px"},attrs:{"model":_vm.formdata,"rules":_vm.rules,"label-width":"200px","label-position":_vm.labelPosition,"size":"medium","status-icon":""},nativeOn:{"submit":function($event){$event.preventDefault();}}},[_c('h4',{staticClass:"text-center text-info mt-4"},[_vm._v("\n              Add "+_vm._s(this.$route.params.cat)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"file-upload col-12 col-md-6",staticStyle:{"margin-top":"30px"}},[_c('div',{staticClass:"image-upload-wrap",staticStyle:{"height":"100px"}},[_c('input',{staticClass:"file-upload-input",attrs:{"type":"file","accept":".jpg, .jpeg"},on:{"change":_vm.fileSelect1}}),_vm._v(" "),_c('div',{staticClass:"drag-text"},[_c('h6',{staticClass:"pt-3 pb-1"},[_vm._v("Add main image")]),_vm._v(" "),_c('p',[_vm._v("(maximum file size 5MB)")])])]),_vm._v(" "),_c('div',{staticClass:"file-upload-content mx-auto text-center",style:({ display: _vm.visible1 })},[_c('img',{staticClass:"file-upload-image",attrs:{"src":_vm.formdata.imageUrl1,"alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"mt-3 mb-4",staticStyle:{"height":"auto"}},[_c('div',{staticClass:"file-upload"},[_c('div',{staticClass:"image-upload-wrap col-12 col-md-6 m-auto",staticStyle:{"height":"100px"}},[_c('input',{staticClass:"file-upload-input",attrs:{"type":"file","multiple":"","accept":".jpg, .jpeg"},on:{"change":_vm.otherIMG}}),_vm._v(" "),_c('div',{staticClass:"drag-text"},[_c('h6',{staticClass:"pt-3 pb-1"},[_vm._v("Add other images")]),_vm._v(" "),_c('p',[_vm._v("(maximum 4 images)")])])]),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.imgfiles),function(file,i){return _c('div',{key:i,staticClass:"\n                      file-upload-content\n                      justify-item-center\n                      col-12 col-sm-6 col-md-3\n                    ",style:({ display: _vm.visible2 })},[_c('div',{style:({ display: _vm.visible2 })},[_c('img',{staticClass:"file-upload-image",staticStyle:{"margin-right":"0px"},attrs:{"src":file,"alt":"your image"}}),_vm._v(" "),_c('div',{staticClass:"image-title-wrap mt-2"},[_c('el-button',{attrs:{"type":"danger","size":"small"},on:{"click":function($event){_vm.removeimg(i)}}},[_vm._v("Remove Image")])],1)])])}))])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Product Name","prop":"name"}},[_c('el-input',{staticStyle:{"width":"220px"},attrs:{"clearable":""},model:{value:(_vm.formdata.name),callback:function ($$v) {_vm.$set(_vm.formdata, "name", $$v)},expression:"formdata.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Barcode/SKU","prop":"barcode"}},[_c('el-input',{staticStyle:{"width":"220px"},attrs:{"clearable":""},on:{"change":_vm.checkBarcode},model:{value:(_vm.formdata.barcode),callback:function ($$v) {_vm.$set(_vm.formdata, "barcode", $$v)},expression:"formdata.barcode"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Quantity","prop":"quantity"}},[_c('el-input',{staticStyle:{"width":"220px"},attrs:{"type":"number","clearable":"","min":1},model:{value:(_vm.formdata.quantity),callback:function ($$v) {_vm.$set(_vm.formdata, "quantity", _vm._n($$v))},expression:"formdata.quantity"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Main Price","prop":"price"}},[_c('el-input',{staticClass:"input-with-select",staticStyle:{"width":"220px"},attrs:{"clearable":""},model:{value:(_vm.formdata.price),callback:function ($$v) {_vm.$set(_vm.formdata, "price", _vm._n($$v))},expression:"formdata.price"}},[_c('template',{attrs:{"slot":"prepend"},slot:"prepend"},[_vm._v("RS")])],2)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Price List"}},[_c('el-select',{attrs:{"multiple":"","filterable":"","allow-create":"","default-first-option":"","placeholder":"Enter Prices"},model:{value:(_vm.formdata.priceList),callback:function ($$v) {_vm.$set(_vm.formdata, "priceList", $$v)},expression:"formdata.priceList"}},_vm._l((_vm.formdata.priceList),function(item){return _c('el-option',{key:item,attrs:{"label":item,"value":item}})}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Product Variations"}},[_c('el-select',{attrs:{"multiple":"","filterable":"","allow-create":"","default-first-option":"","placeholder":"Enter Variations"},model:{value:(_vm.formdata.variations),callback:function ($$v) {_vm.$set(_vm.formdata, "variations", $$v)},expression:"formdata.variations"}},_vm._l((_vm.formdata.variations),function(item){return _c('el-option',{key:item,attrs:{"label":item,"value":item}})}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Discount","prop":"dis"}},[_c('el-input',{staticStyle:{"width":"220px"},attrs:{"placeholder":"Discount"},model:{value:(_vm.formdata.dis),callback:function ($$v) {_vm.$set(_vm.formdata, "dis", _vm._n($$v))},expression:"formdata.dis"}},[_c('template',{attrs:{"slot":"append"},slot:"append"},[_c('i',{staticClass:"fa fa-percent"})])],2)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Category","prop":"category"}},[_c('el-select',{attrs:{"placeholder":"Category"},model:{value:(_vm.category),callback:function ($$v) {_vm.category=$$v},expression:"category"}},[_c('el-option',{attrs:{"value":this.$route.params.cat}},[_vm._v(_vm._s(this.$route.params.cat))])],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Make","prop":"subcategory"}},[_c('el-select',{attrs:{"placeholder":"Make"},model:{value:(_vm.formdata.subcategory),callback:function ($$v) {_vm.$set(_vm.formdata, "subcategory", $$v)},expression:"formdata.subcategory"}},_vm._l((_vm.subcategories),function(subcat,key){return _c('el-option',{key:key,attrs:{"value":key}},[_vm._v(_vm._s(key))])}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Model","prop":"model"}},[_c('el-input',{staticStyle:{"width":"220px"},attrs:{"placeholder":"Model","clearable":""},model:{value:(_vm.formdata.model),callback:function ($$v) {_vm.$set(_vm.formdata, "model", $$v)},expression:"formdata.model"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Model Code","prop":"modelcode"}},[_c('el-input',{staticStyle:{"width":"220px"},attrs:{"placeholder":"Model Code","clearable":""},model:{value:(_vm.formdata.modelcode),callback:function ($$v) {_vm.$set(_vm.formdata, "modelcode", $$v)},expression:"formdata.modelcode"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Manufactured Year","prop":"manuyear"}},[_c('el-input',{staticStyle:{"width":"220px"},attrs:{"placeholder":"Manufactured Year","clearable":""},model:{value:(_vm.formdata.manuyear),callback:function ($$v) {_vm.$set(_vm.formdata, "manuyear", $$v)},expression:"formdata.manuyear"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Condition","prop":"cond"}},[_c('el-select',{attrs:{"placeholder":"Condition"},model:{value:(_vm.formdata.cond),callback:function ($$v) {_vm.$set(_vm.formdata, "cond", $$v)},expression:"formdata.cond"}},[_c('el-option',{attrs:{"value":"new"}},[_vm._v("New")]),_vm._v(" "),_c('el-option',{attrs:{"value":"used"}},[_vm._v("Used")])],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Main Color","prop":"color"}},[_c('el-input',{staticStyle:{"width":"220px"},attrs:{"placeholder":"Color","clearable":""},model:{value:(_vm.formdata.color),callback:function ($$v) {_vm.$set(_vm.formdata, "color", $$v)},expression:"formdata.color"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Other Colors"}},[_c('el-select',{attrs:{"multiple":"","filterable":"","allow-create":"","default-first-option":"","placeholder":"Enter Other Colors"},model:{value:(_vm.formdata.colors),callback:function ($$v) {_vm.$set(_vm.formdata, "colors", $$v)},expression:"formdata.colors"}},_vm._l((_vm.formdata.colors),function(item){return _c('el-option',{key:item,attrs:{"label":item,"value":item}})}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Engine Type","prop":"enginetype"}},[_c('el-input',{staticStyle:{"width":"220px"},attrs:{"placeholder":"Engine Type","clearable":""},model:{value:(_vm.formdata.enginetype),callback:function ($$v) {_vm.$set(_vm.formdata, "enginetype", _vm._n($$v))},expression:"formdata.enginetype"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Engine Capacity","prop":"enginecapacity"}},[_c('el-input',{staticClass:"input-with-select",staticStyle:{"width":"220px"},attrs:{"clearable":""},model:{value:(_vm.formdata.enginecapacity),callback:function ($$v) {_vm.$set(_vm.formdata, "enginecapacity", _vm._n($$v))},expression:"formdata.enginecapacity"}},[_c('template',{attrs:{"slot":"prepend"},slot:"prepend"},[_vm._v("cc")])],2)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Fuel Type","prop":"fueltype"}},[_c('el-select',{attrs:{"placeholder":"Fuel Type"},model:{value:(_vm.formdata.fueltype),callback:function ($$v) {_vm.$set(_vm.formdata, "fueltype", $$v)},expression:"formdata.fueltype"}},[_c('el-option',{attrs:{"value":"Petrol"}},[_vm._v("Petrol")]),_vm._v(" "),_c('el-option',{attrs:{"value":"Diesel"}},[_vm._v("Diesel")]),_vm._v(" "),_c('el-option',{attrs:{"value":"Electric"}},[_vm._v("Electric")]),_vm._v(" "),_c('el-option',{attrs:{"value":"Hybrid"}},[_vm._v("Hybrid")])],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Transmission","prop":"transmission"}},[_c('el-input',{staticStyle:{"width":"220px"},attrs:{"placeholder":"Transmission","clearable":""},model:{value:(_vm.formdata.transmission),callback:function ($$v) {_vm.$set(_vm.formdata, "transmission", $$v)},expression:"formdata.transmission"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Body Type","prop":"bodytype"}},[_c('el-input',{staticStyle:{"width":"220px"},attrs:{"placeholder":"Body Type","clearable":""},model:{value:(_vm.formdata.bodytype),callback:function ($$v) {_vm.$set(_vm.formdata, "bodytype", $$v)},expression:"formdata.bodytype"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Mileage","prop":"mileage"}},[_c('el-input',{staticClass:"input-with-select",staticStyle:{"width":"220px"},attrs:{"clearable":""},model:{value:(_vm.formdata.mileage),callback:function ($$v) {_vm.$set(_vm.formdata, "mileage", _vm._n($$v))},expression:"formdata.mileage"}},[_c('template',{attrs:{"slot":"prepend"},slot:"prepend"},[_vm._v("km")])],2)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Type","prop":"type"}},[_c('el-select',{attrs:{"placeholder":"Type"},model:{value:(_vm.formdata.type),callback:function ($$v) {_vm.$set(_vm.formdata, "type", $$v)},expression:"formdata.type"}},[_c('el-option',{attrs:{"value":"none"}},[_vm._v("None")]),_vm._v(" "),_c('el-option',{attrs:{"value":"latest"}},[_vm._v("Latest Vehicle")]),_vm._v(" "),_c('el-option',{attrs:{"value":"bestselling"}},[_vm._v("Best Selling Vehicle")])],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Warranty","prop":"warranty"}},[_c('el-select',{staticStyle:{"width":"220px"},attrs:{"filterable":"","allow-create":"","placeholder":"Warranty","clearable":""},model:{value:(_vm.formdata.warranty),callback:function ($$v) {_vm.$set(_vm.formdata, "warranty", $$v)},expression:"formdata.warranty"}},[_c('el-option',{attrs:{"value":"No Warranty"}},[_vm._v("No Warranty")]),_vm._v(" "),_c('el-option',{attrs:{"value":"1 Months Warranty"}},[_vm._v("1 Months Warranty")]),_vm._v(" "),_c('el-option',{attrs:{"value":"3 Months Warranty"}},[_vm._v("3 Months Warranty")]),_vm._v(" "),_c('el-option',{attrs:{"value":"6 Months Warranty"}},[_vm._v("6 Months Warranty")]),_vm._v(" "),_c('el-option',{attrs:{"value":"1 Year Warranty"}},[_vm._v("1 Year Warranty")]),_vm._v(" "),_c('el-option',{attrs:{"value":"2 Year Warranty"}},[_vm._v("2 Year Warranty")]),_vm._v(" "),_c('el-option',{attrs:{"value":"3 Year Warranty"}},[_vm._v("3 Year Warranty")]),_vm._v(" "),_c('el-option',{attrs:{"value":"4 Year Warranty"}},[_vm._v("4 Year Warranty")]),_vm._v(" "),_c('el-option',{attrs:{"value":"5 Year Warranty"}},[_vm._v("5 Year Warranty")]),_vm._v(" "),_c('el-option',{attrs:{"value":"10 Year Warranty"}},[_vm._v("10 Year Warranty")]),_vm._v(" "),_c('el-option',{attrs:{"value":"Lifetime Warranty"}},[_vm._v("Lifetime Warranty")])],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Product Description","prop":"desc"}},[_c('el-input',{attrs:{"type":"textarea","maxlength":"1000","autosize":{ minRows: 2, maxRows: 4 }},model:{value:(_vm.formdata.desc),callback:function ($$v) {_vm.$set(_vm.formdata, "desc", $$v)},expression:"formdata.desc"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.submitForm('formdata')}}},[_vm._v("Add")]),_vm._v(" "),_c('el-button',{on:{"click":function($event){_vm.resetForm('formdata')}}},[_vm._v("Reset")])],1)],1)],1)],1)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[(_vm.loading)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Updating")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.loading1)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Loading")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.changed)?_c('div',[_c('div',{staticClass:"m-auto text-right pt-4 pb-3"},[_c('router-link',{staticClass:"text-white",staticStyle:{"text-decoration":"none"},attrs:{"to":{name:'allProducts' , params:{cat:this.$route.params.cat}}}},[_c('el-button',{attrs:{"type":"primary","size":"medium"}},[_c('i',{staticClass:"el-icon-view mr-2"}),_vm._v("View Products")])],1)],1),_vm._v(" "),_c('commonProducts')],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditCommonProduct_vue__ = __webpack_require__(229);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_683735d2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditCommonProduct_vue__ = __webpack_require__(701);
function injectStyle (ssrContext) {
  __webpack_require__(700)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-683735d2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditCommonProduct_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_683735d2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditCommonProduct_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 700 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Updating")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.loading1)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Loading")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.changed)?_c('div',[_c('div',{staticClass:"container",staticStyle:{"padding":"0px"}},[_c('div',{staticClass:"col-sm-12 col-lg-8 m-auto"},[_c('el-form',{ref:"formdata",staticStyle:{"border":"1px solid #e2e2e2","border-radius":"5px","background-color":"#fff","padding":"20px"},attrs:{"model":_vm.formdata,"rules":_vm.rules,"label-width":"200px","label-position":_vm.labelPosition,"size":"medium","status-icon":""},nativeOn:{"submit":function($event){$event.preventDefault();}}},[_c('h3',{staticClass:"text-center text-info pt-4"},[_vm._v("Edit Product/Item")]),_vm._v(" "),_c('div',{staticClass:"file-upload col-12 col-md-6",staticStyle:{"margin-top":"25px"}},[_c('div',{staticClass:"image-upload-wrap",staticStyle:{"height":"100px"}},[_c('input',{staticClass:"file-upload-input",attrs:{"type":"file","accept":".jpg, .jpeg"},on:{"change":_vm.fileSelect1}}),_vm._v(" "),_c('div',{staticClass:"drag-text"},[_c('h6',{staticClass:"pt-3 pb-1"},[_vm._v("Add main image")]),_vm._v(" "),_c('p',[_vm._v("(maximum file size 5MB)")])])]),_vm._v(" "),_c('div',{staticClass:"mx-auto text-center"},[_c('img',{staticClass:"file-upload-image",attrs:{"src":_vm.formdata.imageUrl,"alt":"your image"}})])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Product Name","prop":"name"}},[_c('el-input',{staticStyle:{"width":"220px"},attrs:{"clearable":""},model:{value:(_vm.formdata.name),callback:function ($$v) {_vm.$set(_vm.formdata, "name", $$v)},expression:"formdata.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Barcode/SKU","prop":"barcode"}},[_c('el-input',{staticStyle:{"width":"220px"},attrs:{"clearable":""},on:{"change":_vm.checkBarcode},model:{value:(_vm.formdata.barcode),callback:function ($$v) {_vm.$set(_vm.formdata, "barcode", $$v)},expression:"formdata.barcode"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Low Alert Quantity","prop":"quantity"}},[_c('el-input',{staticStyle:{"width":"220px"},attrs:{"type":"number","clearable":"","min":1},model:{value:(_vm.formdata.quantity),callback:function ($$v) {_vm.$set(_vm.formdata, "quantity", _vm._n($$v))},expression:"formdata.quantity"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Profit Margin","prop":"profitmargin"}},[_c('el-input',{staticClass:"input-with-select",staticStyle:{"width":"220px"},attrs:{"type":"number","precision":2,"clearable":""},model:{value:(_vm.formdata.profitMargin),callback:function ($$v) {_vm.$set(_vm.formdata, "profitMargin", _vm._n($$v))},expression:"formdata.profitMargin"}},[_c('template',{attrs:{"slot":"append"},slot:"append"},[_c('i',{staticClass:"fa fa-percent"})])],2)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Update Price List"}},[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.showPriceTable = true}}},[_vm._v("Update Price List")])],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Online Store Price","prop":"price"}},[_c('el-input',{staticClass:"input-with-select",staticStyle:{"width":"220px"},attrs:{"type":"number","clearable":""},model:{value:(_vm.formdata.price),callback:function ($$v) {_vm.$set(_vm.formdata, "price", _vm._n($$v))},expression:"formdata.price"}},[_c('template',{attrs:{"slot":"prepend"},slot:"prepend"},[_vm._v("RS")])],2)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Discount","prop":"dis"}},[_c('el-input',{staticStyle:{"width":"220px"},attrs:{"type":"number","placeholder":"Discount"},model:{value:(_vm.formdata.dis),callback:function ($$v) {_vm.$set(_vm.formdata, "dis", _vm._n($$v))},expression:"formdata.dis"}},[_c('template',{attrs:{"slot":"append"},slot:"append"},[_c('i',{staticClass:"fa fa-percent"})])],2)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Category","prop":"category"}},[_c('el-select',{attrs:{"placeholder":"Category"},model:{value:(_vm.category),callback:function ($$v) {_vm.category=$$v},expression:"category"}},[_c('el-option',{attrs:{"value":this.$route.params.cat}},[_vm._v(_vm._s(_vm.category))])],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Sub Category","prop":"subcategory"}},[_c('el-select',{attrs:{"placeholder":"Sub Category"},model:{value:(_vm.subcategory),callback:function ($$v) {_vm.subcategory=$$v},expression:"subcategory"}},_vm._l((Object.keys(_vm.subcategories).sort()),function(subcat,key){return _c('el-option',{key:key,attrs:{"value":subcat}},[_vm._v(_vm._s(subcat))])}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Product Variations"}},[_c('el-select',{attrs:{"multiple":"","filterable":"","allow-create":"","default-first-option":"","placeholder":"Enter Variations"},model:{value:(_vm.formdata.variations),callback:function ($$v) {_vm.$set(_vm.formdata, "variations", $$v)},expression:"formdata.variations"}},_vm._l((_vm.formdata.variations),function(item){return _c('el-option',{key:item,attrs:{"label":item,"value":item}})}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Brand (if any)","prop":"brand"}},[_c('el-input',{staticStyle:{"width":"220px"},attrs:{"placeholder":"Brand","clearable":""},model:{value:(_vm.formdata.brand),callback:function ($$v) {_vm.$set(_vm.formdata, "brand", $$v)},expression:"formdata.brand"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Bin Location/Rack","prop":"rack"}},[_c('el-input',{staticStyle:{"width":"220px"},attrs:{"placeholder":"Bin Location/Rack","clearable":""},model:{value:(_vm.formdata.rack),callback:function ($$v) {_vm.$set(_vm.formdata, "rack", $$v)},expression:"formdata.rack"}})],1),_vm._v(" "),(this.$route.params.cat == 'Cameras')?_c('el-form-item',{attrs:{"label":"Model","prop":"model"}},[_c('el-input',{staticStyle:{"width":"220px"},attrs:{"placeholder":"Model","clearable":""},model:{value:(_vm.formdata.model),callback:function ($$v) {_vm.$set(_vm.formdata, "model", $$v)},expression:"formdata.model"}})],1):_vm._e(),_vm._v(" "),(
              _vm.shoptype == 'Jewelry' ||
              _vm.shoptype == 'Gems' ||
              _vm.shoptype == 'Jewelry Gems & Watch'
            )?_c('el-form-item',{attrs:{"label":"Karat/Carat","prop":"krat"}},[_c('el-input',{staticClass:"input-with-select",staticStyle:{"width":"220px"},attrs:{"type":"number","clearable":""},model:{value:(_vm.formdata.karat),callback:function ($$v) {_vm.$set(_vm.formdata, "karat", _vm._n($$v))},expression:"formdata.karat"}},[_c('template',{attrs:{"slot":"prepend"},slot:"prepend"},[_vm._v("k")])],2)],1):_vm._e(),_vm._v(" "),(
              _vm.shoptype == 'Jewelry' ||
              _vm.shoptype == 'Gems' ||
              _vm.shoptype == 'Jewelry Gems & Watch'
            )?_c('el-form-item',{attrs:{"label":"Metal/Stone","prop":"metal"}},[_c('el-input',{staticStyle:{"width":"220px"},attrs:{"placeholder":"Metal/Stone","clearable":""},model:{value:(_vm.formdata.metal),callback:function ($$v) {_vm.$set(_vm.formdata, "metal", $$v)},expression:"formdata.metal"}})],1):_vm._e(),_vm._v(" "),(_vm.shopcat == 'Books')?_c('el-form-item',{attrs:{"label":"Author","prop":"author"}},[_c('el-input',{staticStyle:{"width":"220px"},attrs:{"placeholder":"Author","clearable":""},model:{value:(_vm.formdata.author),callback:function ($$v) {_vm.$set(_vm.formdata, "author", $$v)},expression:"formdata.author"}})],1):_vm._e(),_vm._v(" "),(_vm.shopcat == 'Books')?_c('el-form-item',{attrs:{"label":"Publisher","prop":"publisher"}},[_c('el-input',{staticStyle:{"width":"220px"},attrs:{"placeholder":"Publisher","clearable":""},model:{value:(_vm.formdata.publisher),callback:function ($$v) {_vm.$set(_vm.formdata, "publisher", $$v)},expression:"formdata.publisher"}})],1):_vm._e(),_vm._v(" "),(_vm.formdata.subcategory == 'TV')?_c('el-form-item',{attrs:{"label":"Screen Size","prop":"screensize"}},[_c('el-input',{staticStyle:{"width":"220px"},attrs:{"placeholder":"Screen Size","clearable":""},model:{value:(_vm.formdata.screensize),callback:function ($$v) {_vm.$set(_vm.formdata, "screensize", $$v)},expression:"formdata.screensize"}})],1):_vm._e(),_vm._v(" "),(
              _vm.shopcat == 'Clothing & Accessories' ||
              _vm.shopcat == 'Shoes & Footwear' ||
              this.$route.params.cat == 'Tiles'
            )?_c('el-form-item',{attrs:{"label":"Size","prop":"size"}},[_c('el-input',{staticStyle:{"width":"220px"},attrs:{"placeholder":"Size","clearable":""},model:{value:(_vm.formdata.size),callback:function ($$v) {_vm.$set(_vm.formdata, "size", $$v)},expression:"formdata.size"}})],1):_vm._e(),_vm._v(" "),(
              _vm.shopcat == 'Clothing & Accessories' ||
              _vm.shopcat == 'Shoes & Footwear' ||
              this.$route.params.cat == 'Tiles' ||
              _vm.shoptype == 'Watch' ||
              _vm.shopcat == 'Bags' ||
              _vm.shopcat == 'Furniture' ||
              _vm.shopcat == 'Home Decor' ||
              _vm.shopcat == 'Handicrafts' ||
              _vm.shopcat == 'Baby Kids & Toys'
            )?_c('el-form-item',{attrs:{"label":"Material","prop":"material"}},[_c('el-input',{staticStyle:{"width":"220px"},attrs:{"placeholder":"Material","clearable":""},model:{value:(_vm.formdata.material),callback:function ($$v) {_vm.$set(_vm.formdata, "material", $$v)},expression:"formdata.material"}})],1):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Main Color","prop":"color"}},[_c('el-input',{staticStyle:{"width":"220px"},attrs:{"placeholder":"Color","clearable":""},model:{value:(_vm.formdata.color),callback:function ($$v) {_vm.$set(_vm.formdata, "color", $$v)},expression:"formdata.color"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Other Colors"}},[_c('el-select',{attrs:{"multiple":"","filterable":"","allow-create":"","default-first-option":"","placeholder":"Enter Other Colors"},model:{value:(_vm.formdata.colors),callback:function ($$v) {_vm.$set(_vm.formdata, "colors", $$v)},expression:"formdata.colors"}},_vm._l((_vm.formdata.colors),function(item){return _c('el-option',{key:item,attrs:{"label":item,"value":item}})}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Expire Date","prop":"expireDate"}},[_c('el-date-picker',{attrs:{"type":"date","placeholder":"Expire Date"},model:{value:(_vm.formdata.expireDate),callback:function ($$v) {_vm.$set(_vm.formdata, "expireDate", $$v)},expression:"formdata.expireDate"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Condition","prop":"cond"}},[_c('el-select',{attrs:{"placeholder":"Condition"},model:{value:(_vm.formdata.cond),callback:function ($$v) {_vm.$set(_vm.formdata, "cond", $$v)},expression:"formdata.cond"}},[_c('el-option',{attrs:{"value":"new"}},[_vm._v("New")]),_vm._v(" "),_c('el-option',{attrs:{"value":"used"}},[_vm._v("Used")])],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Item Type","prop":"type"}},[_c('el-select',{attrs:{"placeholder":"Item Type"},model:{value:(_vm.formdata.type),callback:function ($$v) {_vm.$set(_vm.formdata, "type", $$v)},expression:"formdata.type"}},[_c('el-option',{attrs:{"value":"none"}},[_vm._v("None")]),_vm._v(" "),_c('el-option',{attrs:{"value":"latest"}},[_vm._v("Latest Item")]),_vm._v(" "),_c('el-option',{attrs:{"value":"bestselling"}},[_vm._v("Best Selling Item")])],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Warranty","prop":"warranty"}},[_c('el-select',{staticStyle:{"width":"220px"},attrs:{"filterable":"","allow-create":"","placeholder":"Warranty","clearable":""},model:{value:(_vm.formdata.warranty),callback:function ($$v) {_vm.$set(_vm.formdata, "warranty", $$v)},expression:"formdata.warranty"}},[_c('el-option',{attrs:{"value":"No Warranty"}},[_vm._v("No Warranty")]),_vm._v(" "),_c('el-option',{attrs:{"value":"1 Months Warranty"}},[_vm._v("1 Months Warranty")]),_vm._v(" "),_c('el-option',{attrs:{"value":"3 Months Warranty"}},[_vm._v("3 Months Warranty")]),_vm._v(" "),_c('el-option',{attrs:{"value":"6 Months Warranty"}},[_vm._v("6 Months Warranty")]),_vm._v(" "),_c('el-option',{attrs:{"value":"1 Year Warranty"}},[_vm._v("1 Year Warranty")]),_vm._v(" "),_c('el-option',{attrs:{"value":"2 Year Warranty"}},[_vm._v("2 Year Warranty")]),_vm._v(" "),_c('el-option',{attrs:{"value":"3 Year Warranty"}},[_vm._v("3 Year Warranty")]),_vm._v(" "),_c('el-option',{attrs:{"value":"4 Year Warranty"}},[_vm._v("4 Year Warranty")]),_vm._v(" "),_c('el-option',{attrs:{"value":"5 Year Warranty"}},[_vm._v("5 Year Warranty")]),_vm._v(" "),_c('el-option',{attrs:{"value":"10 Year Warranty"}},[_vm._v("10 Year Warranty")]),_vm._v(" "),_c('el-option',{attrs:{"value":"Lifetime Warranty"}},[_vm._v("Lifetime Warranty")])],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Product Description","prop":"desc"}},[_c('el-input',{attrs:{"type":"textarea","maxlength":"1000","autosize":{ minRows: 2, maxRows: 4 }},model:{value:(_vm.formdata.desc),callback:function ($$v) {_vm.$set(_vm.formdata, "desc", $$v)},expression:"formdata.desc"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.updateForm('formdata')}}},[_vm._v("Update")]),_vm._v(" "),_c('el-button',{attrs:{"type":"danger"},on:{"click":function($event){_vm.goback()}}},[_vm._v("Go Back")])],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"width":_vm.priceTableWidth,"show-close":true,"close-on-click-modal":false,"title":"Update Prices","center":"","visible":_vm.showPriceTable},on:{"update:visible":function($event){_vm.showPriceTable=$event}}},[_c('PriceTable',{attrs:{"priceData":_vm.formdata.priceData,"showPriceTable":_vm.showPriceTable,"profitMargin":_vm.formdata.profitMargin}})],1)],1)])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditMobiles_vue__ = __webpack_require__(230);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ffbddf6c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditMobiles_vue__ = __webpack_require__(704);
function injectStyle (ssrContext) {
  __webpack_require__(703)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ffbddf6c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditMobiles_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ffbddf6c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditMobiles_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 703 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Updating")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.loading1)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Loading")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.changed)?_c('div',[_c('div',{staticClass:"container",staticStyle:{"padding":"0px"}},[_c('div',{staticClass:"col-sm-12 col-lg-8 m-auto"},[_c('el-form',{ref:"formdata",staticStyle:{"border":"1px solid #e2e2e2","border-radius":"5px","background-color":"#fff","padding":"20px"},attrs:{"model":_vm.formdata,"rules":_vm.rules,"label-width":"200px","label-position":_vm.labelPosition,"size":"medium","status-icon":""},nativeOn:{"submit":function($event){$event.preventDefault();}}},[_c('h3',{staticClass:"text-center text-info pt-4"},[_vm._v("Edit Item")]),_vm._v(" "),_c('div',{staticClass:"file-upload col-12 col-md-6",staticStyle:{"margin-top":"25px"}},[_c('div',{staticClass:"image-upload-wrap",staticStyle:{"height":"100px"}},[_c('input',{staticClass:"file-upload-input",attrs:{"type":"file","accept":".jpg, .jpeg"},on:{"change":_vm.fileSelect1}}),_vm._v(" "),_c('div',{staticClass:"drag-text"},[_c('h6',{staticClass:"pt-3"},[_vm._v("Add main image")]),_vm._v(" "),_c('h6')])]),_vm._v(" "),_c('div',{staticClass:"mx-auto text-center"},[_c('img',{staticClass:"file-upload-image",attrs:{"src":_vm.formdata.imageUrl,"alt":"your image"}})])]),_vm._v(" "),_c('div',{staticClass:"mt-3 mb-4",staticStyle:{"height":"auto"}},[_c('div',{staticClass:"file-upload"},[_c('div',{staticClass:"image-upload-wrap col-12 col-md-6 m-auto",staticStyle:{"height":"100px"}},[_c('input',{staticClass:"file-upload-input",attrs:{"type":"file","multiple":"","accept":".jpg, .jpeg"},on:{"change":_vm.otherIMG}}),_vm._v(" "),_c('div',{staticClass:"drag-text"},[_c('h6',{staticClass:"pt-3 pb-1"},[_vm._v("Add other images")]),_vm._v(" "),_c('p',[_vm._v("(maximum 4 images)")])])]),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.imgfiles),function(file,i){return _c('div',{key:i,staticClass:"justify-item-center col-12 col-sm-6 col-md-3"},[_c('div',[_c('img',{staticClass:"file-upload-image",staticStyle:{"margin-right":"0px"},attrs:{"src":file,"alt":"your image"}}),_vm._v(" "),_c('div',{staticClass:"image-title-wrap mt-2"},[_c('el-button',{attrs:{"type":"danger","size":"small"},on:{"click":function($event){_vm.removeimg(i)}}},[_vm._v("Remove Image")])],1)])])}))])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Product Name","prop":"name"}},[_c('el-input',{staticStyle:{"width":"220px"},attrs:{"clearable":""},model:{value:(_vm.formdata.name),callback:function ($$v) {_vm.$set(_vm.formdata, "name", $$v)},expression:"formdata.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Barcode/SKU","prop":"barcode"}},[_c('el-input',{staticStyle:{"width":"220px"},attrs:{"clearable":""},on:{"change":_vm.checkBarcode},model:{value:(_vm.formdata.barcode),callback:function ($$v) {_vm.$set(_vm.formdata, "barcode", $$v)},expression:"formdata.barcode"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Quantity","prop":"quantity"}},[_c('el-input',{staticStyle:{"width":"220px"},attrs:{"type":"number","clearable":"","min":1},model:{value:(_vm.formdata.quantity),callback:function ($$v) {_vm.$set(_vm.formdata, "quantity", _vm._n($$v))},expression:"formdata.quantity"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Main Price","prop":"price"}},[_c('el-input',{staticClass:"input-with-select",staticStyle:{"width":"220px"},attrs:{"clearable":""},model:{value:(_vm.formdata.price),callback:function ($$v) {_vm.$set(_vm.formdata, "price", _vm._n($$v))},expression:"formdata.price"}},[_c('template',{attrs:{"slot":"prepend"},slot:"prepend"},[_vm._v("RS")])],2)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Price List"}},[_c('el-select',{attrs:{"multiple":"","filterable":"","allow-create":"","default-first-option":"","placeholder":"Enter Prices"},model:{value:(_vm.formdata.priceList),callback:function ($$v) {_vm.$set(_vm.formdata, "priceList", $$v)},expression:"formdata.priceList"}},_vm._l((_vm.formdata.priceList),function(item){return _c('el-option',{key:item,attrs:{"label":item,"value":item}})}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Product Variations"}},[_c('el-select',{attrs:{"multiple":"","filterable":"","allow-create":"","default-first-option":"","placeholder":"Enter Variations"},model:{value:(_vm.formdata.variations),callback:function ($$v) {_vm.$set(_vm.formdata, "variations", $$v)},expression:"formdata.variations"}},_vm._l((_vm.formdata.variations),function(item){return _c('el-option',{key:item,attrs:{"label":item,"value":item}})}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Discount","prop":"dis"}},[_c('el-input',{staticStyle:{"width":"220px"},attrs:{"placeholder":"Discount"},model:{value:(_vm.formdata.dis),callback:function ($$v) {_vm.$set(_vm.formdata, "dis", _vm._n($$v))},expression:"formdata.dis"}},[_c('template',{attrs:{"slot":"append"},slot:"append"},[_c('i',{staticClass:"fa fa-percent"})])],2)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Category","prop":"category"}},[_c('el-select',{attrs:{"placeholder":"Category"},model:{value:(_vm.category),callback:function ($$v) {_vm.category=$$v},expression:"category"}},[_c('el-option',{attrs:{"value":this.$route.params.cat}},[_vm._v(_vm._s(_vm.category))])],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Brand","prop":"brand"}},[_c('el-select',{attrs:{"placeholder":"Brand"},model:{value:(_vm.subcategory),callback:function ($$v) {_vm.subcategory=$$v},expression:"subcategory"}},_vm._l((_vm.subcategories),function(subcat,key){return _c('el-option',{key:key,attrs:{"value":key}},[_vm._v(_vm._s(key))])}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Model","prop":"model"}},[_c('el-input',{staticClass:"input-with-select",staticStyle:{"width":"220px"},attrs:{"placeholder":"Model","type":"text"},model:{value:(_vm.formdata.model),callback:function ($$v) {_vm.$set(_vm.formdata, "model", $$v)},expression:"formdata.model"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Main Color","prop":"color"}},[_c('el-input',{staticStyle:{"width":"220px"},attrs:{"placeholder":"Color","clearable":""},model:{value:(_vm.formdata.color),callback:function ($$v) {_vm.$set(_vm.formdata, "color", $$v)},expression:"formdata.color"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Other Colors"}},[_c('el-select',{attrs:{"multiple":"","filterable":"","allow-create":"","default-first-option":"","placeholder":"Enter Other Colors"},model:{value:(_vm.formdata.colors),callback:function ($$v) {_vm.$set(_vm.formdata, "colors", $$v)},expression:"formdata.colors"}},_vm._l((_vm.formdata.colors),function(item){return _c('el-option',{key:item,attrs:{"label":item,"value":item}})}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"CPU","prop":"cpu"}},[_c('el-input',{staticClass:"input-with-select",staticStyle:{"width":"220px"},attrs:{"placeholder":"CPU","type":"text"},model:{value:(_vm.formdata.cpu),callback:function ($$v) {_vm.$set(_vm.formdata, "cpu", $$v)},expression:"formdata.cpu"}})],1),_vm._v(" "),(_vm.shopcat == 'Computers & Laptops')?_c('el-form-item',{attrs:{"label":"CPU Generation","prop":"cpugen"}},[_c('el-input',{staticClass:"input-with-select",staticStyle:{"width":"220px"},attrs:{"placeholder":"CPU Generation","type":"text"},model:{value:(_vm.formdata.cpugen),callback:function ($$v) {_vm.$set(_vm.formdata, "cpugen", $$v)},expression:"formdata.cpugen"}})],1):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":"OS","prop":"os"}},[_c('el-input',{staticClass:"input-with-select",staticStyle:{"width":"220px"},attrs:{"placeholder":"OS","type":"text"},model:{value:(_vm.formdata.os),callback:function ($$v) {_vm.$set(_vm.formdata, "os", $$v)},expression:"formdata.os"}})],1),_vm._v(" "),(_vm.shopcat == 'Computers & Laptops')?_c('el-form-item',{attrs:{"label":"Hard Drive","prop":"hard"}},[_c('el-input',{staticClass:"input-with-select",staticStyle:{"width":"220px"},attrs:{"placeholder":"Hard Drive","type":"text"},model:{value:(_vm.formdata.hard),callback:function ($$v) {_vm.$set(_vm.formdata, "hard", $$v)},expression:"formdata.hard"}},[_c('template',{attrs:{"slot":"append"},slot:"append"},[_vm._v("GB")])],2)],1):_vm._e(),_vm._v(" "),(_vm.shopcat == 'Mobiles & Tablets')?_c('el-form-item',{attrs:{"label":"Storage/ROM","prop":"storage"}},[_c('el-input',{staticClass:"input-with-select",staticStyle:{"width":"220px"},attrs:{"placeholder":"Storage/ROM","type":"text"},model:{value:(_vm.formdata.storage),callback:function ($$v) {_vm.$set(_vm.formdata, "storage", $$v)},expression:"formdata.storage"}},[_c('template',{attrs:{"slot":"append"},slot:"append"},[_vm._v("GB")])],2)],1):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":"RAM","prop":"ram"}},[_c('el-input',{staticClass:"input-with-select",staticStyle:{"width":"220px"},attrs:{"placeholder":"RAM","type":"text"},model:{value:(_vm.formdata.ram),callback:function ($$v) {_vm.$set(_vm.formdata, "ram", $$v)},expression:"formdata.ram"}},[_c('template',{attrs:{"slot":"append"},slot:"append"},[_vm._v("GB")])],2)],1),_vm._v(" "),(_vm.shopcat == 'Computers & Laptops')?_c('el-form-item',{attrs:{"label":"Graphics","prop":"graphics"}},[_c('el-input',{staticClass:"input-with-select",staticStyle:{"width":"220px"},attrs:{"placeholder":"Graphics","type":"text"},model:{value:(_vm.formdata.graphics),callback:function ($$v) {_vm.$set(_vm.formdata, "graphics", $$v)},expression:"formdata.graphics"}},[_c('template',{attrs:{"slot":"append"},slot:"append"},[_vm._v("GB")])],2)],1):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Screen Size","prop":"screen"}},[_c('el-input',{staticClass:"input-with-select",staticStyle:{"width":"220px"},attrs:{"placeholder":"Screen Size","type":"text"},model:{value:(_vm.formdata.screen),callback:function ($$v) {_vm.$set(_vm.formdata, "screen", $$v)},expression:"formdata.screen"}},[_c('template',{attrs:{"slot":"append"},slot:"append"},[_vm._v("inches")])],2)],1),_vm._v(" "),(_vm.shopcat == 'Mobiles & Tablets')?_c('el-form-item',{attrs:{"label":"Rear Camera","prop":"rearcamera"}},[_c('el-input',{staticClass:"input-with-select",staticStyle:{"width":"220px"},attrs:{"placeholder":"Rear Camera","type":"text"},model:{value:(_vm.formdata.rearcamera),callback:function ($$v) {_vm.$set(_vm.formdata, "rearcamera", $$v)},expression:"formdata.rearcamera"}},[_c('template',{attrs:{"slot":"append"},slot:"append"},[_vm._v("MP")])],2)],1):_vm._e(),_vm._v(" "),(_vm.shopcat == 'Mobiles & Tablets')?_c('el-form-item',{attrs:{"label":"Front Camera","prop":"frontcamera"}},[_c('el-input',{staticClass:"input-with-select",staticStyle:{"width":"220px"},attrs:{"placeholder":"Front Camera","type":"text"},model:{value:(_vm.formdata.frontcamera),callback:function ($$v) {_vm.$set(_vm.formdata, "frontcamera", $$v)},expression:"formdata.frontcamera"}},[_c('template',{attrs:{"slot":"append"},slot:"append"},[_vm._v("MP")])],2)],1):_vm._e(),_vm._v(" "),(_vm.shopcat == 'Mobiles & Tablets')?_c('el-form-item',{attrs:{"label":"Battery","prop":"battery"}},[_c('el-input',{staticClass:"input-with-select",staticStyle:{"width":"220px"},attrs:{"placeholder":"Battery","type":"text"},model:{value:(_vm.formdata.battery),callback:function ($$v) {_vm.$set(_vm.formdata, "battery", $$v)},expression:"formdata.battery"}},[_c('template',{attrs:{"slot":"append"},slot:"append"},[_vm._v("mAh")])],2)],1):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Weight","prop":"weight"}},[_c('el-input',{staticClass:"input-with-select",staticStyle:{"width":"220px"},attrs:{"placeholder":"Weight","type":"text"},model:{value:(_vm.formdata.weight),callback:function ($$v) {_vm.$set(_vm.formdata, "weight", $$v)},expression:"formdata.weight"}},[_c('template',{attrs:{"slot":"append"},slot:"append"},[_vm._v("g")])],2)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Condition","prop":"cond"}},[_c('el-select',{attrs:{"placeholder":"Condition"},model:{value:(_vm.formdata.cond),callback:function ($$v) {_vm.$set(_vm.formdata, "cond", $$v)},expression:"formdata.cond"}},[_c('el-option',{attrs:{"value":"new"}},[_vm._v("New")]),_vm._v(" "),_c('el-option',{attrs:{"value":"used"}},[_vm._v("Used")])],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Item Type","prop":"type"}},[_c('el-select',{attrs:{"placeholder":"Item Type"},model:{value:(_vm.formdata.type),callback:function ($$v) {_vm.$set(_vm.formdata, "type", $$v)},expression:"formdata.type"}},[_c('el-option',{attrs:{"value":"none"}},[_vm._v("None")]),_vm._v(" "),_c('el-option',{attrs:{"value":"latest"}},[_vm._v("Latest Item")]),_vm._v(" "),_c('el-option',{attrs:{"value":"bestselling"}},[_vm._v("Best Selling Item")])],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Warranty","prop":"warranty"}},[_c('el-select',{staticStyle:{"width":"220px"},attrs:{"filterable":"","allow-create":"","placeholder":"Warranty","clearable":""},model:{value:(_vm.formdata.warranty),callback:function ($$v) {_vm.$set(_vm.formdata, "warranty", $$v)},expression:"formdata.warranty"}},[_c('el-option',{attrs:{"value":"No Warranty"}},[_vm._v("No Warranty")]),_vm._v(" "),_c('el-option',{attrs:{"value":"1 Months Warranty"}},[_vm._v("1 Months Warranty")]),_vm._v(" "),_c('el-option',{attrs:{"value":"3 Months Warranty"}},[_vm._v("3 Months Warranty")]),_vm._v(" "),_c('el-option',{attrs:{"value":"6 Months Warranty"}},[_vm._v("6 Months Warranty")]),_vm._v(" "),_c('el-option',{attrs:{"value":"1 Year Warranty"}},[_vm._v("1 Year Warranty")]),_vm._v(" "),_c('el-option',{attrs:{"value":"2 Year Warranty"}},[_vm._v("2 Year Warranty")]),_vm._v(" "),_c('el-option',{attrs:{"value":"3 Year Warranty"}},[_vm._v("3 Year Warranty")]),_vm._v(" "),_c('el-option',{attrs:{"value":"4 Year Warranty"}},[_vm._v("4 Year Warranty")]),_vm._v(" "),_c('el-option',{attrs:{"value":"5 Year Warranty"}},[_vm._v("5 Year Warranty")]),_vm._v(" "),_c('el-option',{attrs:{"value":"10 Year Warranty"}},[_vm._v("10 Year Warranty")]),_vm._v(" "),_c('el-option',{attrs:{"value":"Lifetime Warranty"}},[_vm._v("Lifetime Warranty")])],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Product Description","prop":"desc"}},[_c('el-input',{attrs:{"type":"textarea","maxlength":"1000","autosize":{ minRows: 2, maxRows: 4 }},model:{value:(_vm.formdata.desc),callback:function ($$v) {_vm.$set(_vm.formdata, "desc", $$v)},expression:"formdata.desc"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.updateForm('formdata')}}},[_vm._v("Update")]),_vm._v(" "),_c('el-button',{attrs:{"type":"danger"},on:{"click":function($event){_vm.goback()}}},[_vm._v("Go Back")])],1)],1)],1)])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditVehicles_vue__ = __webpack_require__(231);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62a640b5_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditVehicles_vue__ = __webpack_require__(707);
function injectStyle (ssrContext) {
  __webpack_require__(706)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-62a640b5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditVehicles_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62a640b5_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditVehicles_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 706 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Updating")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.loading1)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Loading")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.changed)?_c('div',[_c('div',{staticClass:"container",staticStyle:{"padding":"0px"}},[_c('div',{staticClass:"col-sm-12 col-lg-8 m-auto"},[_c('el-form',{ref:"formdata",staticStyle:{"border":"1px solid #e2e2e2","border-radius":"5px","background-color":"#fff","padding":"20px"},attrs:{"model":_vm.formdata,"rules":_vm.rules,"label-width":"200px","label-position":_vm.labelPosition,"size":"medium","status-icon":""},nativeOn:{"submit":function($event){$event.preventDefault();}}},[_c('h3',{staticClass:"text-center text-info pt-4"},[_vm._v("Edit Vehicle")]),_vm._v(" "),_c('div',{staticClass:"file-upload col-12 col-md-6",staticStyle:{"margin-top":"25px"}},[_c('div',{staticClass:"image-upload-wrap",staticStyle:{"height":"100px"}},[_c('input',{staticClass:"file-upload-input",attrs:{"type":"file","accept":".jpg, .jpeg"},on:{"change":_vm.fileSelect1}}),_vm._v(" "),_c('div',{staticClass:"drag-text"},[_c('h6',{staticClass:"pt-3 pb-1"},[_vm._v("Add main image")]),_vm._v(" "),_c('p',[_vm._v("(maximum file size 5MB)")])])]),_vm._v(" "),_c('div',{staticClass:"mx-auto text-center"},[_c('img',{staticClass:"file-upload-image",attrs:{"src":_vm.formdata.imageUrl,"alt":"your image"}})])]),_vm._v(" "),_c('div',{staticClass:"mt-3 mb-4",staticStyle:{"height":"auto"}},[_c('div',{staticClass:"file-upload"},[_c('div',{staticClass:"image-upload-wrap col-12 col-md-6 m-auto",staticStyle:{"height":"100px"}},[_c('input',{staticClass:"file-upload-input",attrs:{"type":"file","multiple":"","accept":".jpg, .jpeg"},on:{"change":_vm.otherIMG}}),_vm._v(" "),_c('div',{staticClass:"drag-text"},[_c('h6',{staticClass:"pt-3 pb-1"},[_vm._v("Add other images")]),_vm._v(" "),_c('p',[_vm._v("(maximum 4 images)")])])]),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.imgfiles),function(file,i){return _c('div',{key:i,staticClass:"justify-item-center col-12 col-sm-6 col-md-3"},[_c('div',[_c('img',{staticClass:"file-upload-image",staticStyle:{"margin-right":"0px"},attrs:{"src":file,"alt":"your image"}}),_vm._v(" "),_c('div',{staticClass:"image-title-wrap mt-2"},[_c('el-button',{attrs:{"type":"danger","size":"small"},on:{"click":function($event){_vm.removeimg(i)}}},[_vm._v("Remove Image")])],1)])])}))])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Product Name","prop":"name"}},[_c('el-input',{staticStyle:{"width":"220px"},attrs:{"clearable":""},model:{value:(_vm.formdata.name),callback:function ($$v) {_vm.$set(_vm.formdata, "name", $$v)},expression:"formdata.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Barcode/SKU","prop":"barcode"}},[_c('el-input',{staticStyle:{"width":"220px"},attrs:{"clearable":""},on:{"change":_vm.checkBarcode},model:{value:(_vm.formdata.barcode),callback:function ($$v) {_vm.$set(_vm.formdata, "barcode", $$v)},expression:"formdata.barcode"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Quantity","prop":"quantity"}},[_c('el-input',{staticStyle:{"width":"220px"},attrs:{"type":"number","clearable":"","min":1},model:{value:(_vm.formdata.quantity),callback:function ($$v) {_vm.$set(_vm.formdata, "quantity", _vm._n($$v))},expression:"formdata.quantity"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Main Price","prop":"price"}},[_c('el-input',{staticClass:"input-with-select",staticStyle:{"width":"220px"},attrs:{"clearable":""},model:{value:(_vm.formdata.price),callback:function ($$v) {_vm.$set(_vm.formdata, "price", _vm._n($$v))},expression:"formdata.price"}},[_c('template',{attrs:{"slot":"prepend"},slot:"prepend"},[_vm._v("RS")])],2)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Price List"}},[_c('el-select',{attrs:{"multiple":"","filterable":"","allow-create":"","default-first-option":"","placeholder":"Enter Prices"},model:{value:(_vm.formdata.priceList),callback:function ($$v) {_vm.$set(_vm.formdata, "priceList", $$v)},expression:"formdata.priceList"}},_vm._l((_vm.formdata.priceList),function(item){return _c('el-option',{key:item,attrs:{"label":item,"value":item}})}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Product Variations"}},[_c('el-select',{attrs:{"multiple":"","filterable":"","allow-create":"","default-first-option":"","placeholder":"Enter Variations"},model:{value:(_vm.formdata.variations),callback:function ($$v) {_vm.$set(_vm.formdata, "variations", $$v)},expression:"formdata.variations"}},_vm._l((_vm.formdata.variations),function(item){return _c('el-option',{key:item,attrs:{"label":item,"value":item}})}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Discount","prop":"dis"}},[_c('el-input',{staticStyle:{"width":"220px"},attrs:{"placeholder":"Discount"},model:{value:(_vm.formdata.dis),callback:function ($$v) {_vm.$set(_vm.formdata, "dis", _vm._n($$v))},expression:"formdata.dis"}},[_c('template',{attrs:{"slot":"append"},slot:"append"},[_c('i',{staticClass:"fa fa-percent"})])],2)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Category","prop":"category"}},[_c('el-select',{attrs:{"placeholder":"Category"},model:{value:(_vm.category),callback:function ($$v) {_vm.category=$$v},expression:"category"}},[_c('el-option',{attrs:{"value":this.$route.params.cat}},[_vm._v(_vm._s(_vm.category))])],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Make","prop":"subcategory"}},[_c('el-select',{attrs:{"placeholder":"Make"},model:{value:(_vm.formdata.subcategory),callback:function ($$v) {_vm.$set(_vm.formdata, "subcategory", $$v)},expression:"formdata.subcategory"}},_vm._l((_vm.subcategories),function(subcat,key){return _c('el-option',{key:key,attrs:{"value":key}},[_vm._v(_vm._s(key))])}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Model","prop":"model"}},[_c('el-input',{staticStyle:{"width":"220px"},attrs:{"placeholder":"Model","clearable":""},model:{value:(_vm.formdata.model),callback:function ($$v) {_vm.$set(_vm.formdata, "model", $$v)},expression:"formdata.model"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Model Code","prop":"modelcode"}},[_c('el-input',{staticStyle:{"width":"220px"},attrs:{"placeholder":"Model Code","clearable":""},model:{value:(_vm.formdata.modelcode),callback:function ($$v) {_vm.$set(_vm.formdata, "modelcode", $$v)},expression:"formdata.modelcode"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Manufactured Year","prop":"manuyear"}},[_c('el-input',{staticStyle:{"width":"220px"},attrs:{"placeholder":"Manufactured Year","clearable":""},model:{value:(_vm.formdata.manuyear),callback:function ($$v) {_vm.$set(_vm.formdata, "manuyear", $$v)},expression:"formdata.manuyear"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Condition","prop":"cond"}},[_c('el-select',{attrs:{"placeholder":"Condition"},model:{value:(_vm.formdata.cond),callback:function ($$v) {_vm.$set(_vm.formdata, "cond", $$v)},expression:"formdata.cond"}},[_c('el-option',{attrs:{"value":"new"}},[_vm._v("New")]),_vm._v(" "),_c('el-option',{attrs:{"value":"used"}},[_vm._v("Used")])],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Main Color","prop":"color"}},[_c('el-input',{staticStyle:{"width":"220px"},attrs:{"placeholder":"Color","clearable":""},model:{value:(_vm.formdata.color),callback:function ($$v) {_vm.$set(_vm.formdata, "color", $$v)},expression:"formdata.color"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Other Colors"}},[_c('el-select',{attrs:{"multiple":"","filterable":"","allow-create":"","default-first-option":"","placeholder":"Enter Other Colors"},model:{value:(_vm.formdata.colors),callback:function ($$v) {_vm.$set(_vm.formdata, "colors", $$v)},expression:"formdata.colors"}},_vm._l((_vm.formdata.colors),function(item){return _c('el-option',{key:item,attrs:{"label":item,"value":item}})}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Engine Type","prop":"enginetype"}},[_c('el-input',{staticStyle:{"width":"220px"},attrs:{"placeholder":"Engine Type","clearable":""},model:{value:(_vm.formdata.enginetype),callback:function ($$v) {_vm.$set(_vm.formdata, "enginetype", _vm._n($$v))},expression:"formdata.enginetype"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Engine Capacity","prop":"enginecapacity"}},[_c('el-input',{staticClass:"input-with-select",staticStyle:{"width":"220px"},attrs:{"clearable":""},model:{value:(_vm.formdata.enginecapacity),callback:function ($$v) {_vm.$set(_vm.formdata, "enginecapacity", _vm._n($$v))},expression:"formdata.enginecapacity"}},[_c('template',{attrs:{"slot":"prepend"},slot:"prepend"},[_vm._v("cc")])],2)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Fuel Type","prop":"fueltype"}},[_c('el-select',{attrs:{"placeholder":"Fuel Type"},model:{value:(_vm.formdata.fueltype),callback:function ($$v) {_vm.$set(_vm.formdata, "fueltype", $$v)},expression:"formdata.fueltype"}},[_c('el-option',{attrs:{"value":"Petrol"}},[_vm._v("Petrol")]),_vm._v(" "),_c('el-option',{attrs:{"value":"Diesel"}},[_vm._v("Diesel")]),_vm._v(" "),_c('el-option',{attrs:{"value":"Electric"}},[_vm._v("Electric")]),_vm._v(" "),_c('el-option',{attrs:{"value":"Hybrid"}},[_vm._v("Hybrid")])],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Transmission","prop":"transmission"}},[_c('el-input',{staticStyle:{"width":"220px"},attrs:{"placeholder":"Transmission","clearable":""},model:{value:(_vm.formdata.transmission),callback:function ($$v) {_vm.$set(_vm.formdata, "transmission", $$v)},expression:"formdata.transmission"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Body Type","prop":"bodytype"}},[_c('el-input',{staticStyle:{"width":"220px"},attrs:{"placeholder":"Body Type","clearable":""},model:{value:(_vm.formdata.bodytype),callback:function ($$v) {_vm.$set(_vm.formdata, "bodytype", $$v)},expression:"formdata.bodytype"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Mileage","prop":"mileage"}},[_c('el-input',{staticClass:"input-with-select",staticStyle:{"width":"220px"},attrs:{"clearable":""},model:{value:(_vm.formdata.mileage),callback:function ($$v) {_vm.$set(_vm.formdata, "mileage", _vm._n($$v))},expression:"formdata.mileage"}},[_c('template',{attrs:{"slot":"prepend"},slot:"prepend"},[_vm._v("Km")])],2)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Type","prop":"type"}},[_c('el-select',{attrs:{"placeholder":"Type"},model:{value:(_vm.formdata.type),callback:function ($$v) {_vm.$set(_vm.formdata, "type", $$v)},expression:"formdata.type"}},[_c('el-option',{attrs:{"value":"none"}},[_vm._v("None")]),_vm._v(" "),_c('el-option',{attrs:{"value":"latest"}},[_vm._v("Latest Vehicle")]),_vm._v(" "),_c('el-option',{attrs:{"value":"bestselling"}},[_vm._v("Best Selling Vehicle")])],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Warranty","prop":"warranty"}},[_c('el-select',{staticStyle:{"width":"220px"},attrs:{"filterable":"","allow-create":"","placeholder":"Warranty","clearable":""},model:{value:(_vm.formdata.warranty),callback:function ($$v) {_vm.$set(_vm.formdata, "warranty", $$v)},expression:"formdata.warranty"}},[_c('el-option',{attrs:{"value":"No Warranty"}},[_vm._v("No Warranty")]),_vm._v(" "),_c('el-option',{attrs:{"value":"1 Months Warranty"}},[_vm._v("1 Months Warranty")]),_vm._v(" "),_c('el-option',{attrs:{"value":"3 Months Warranty"}},[_vm._v("3 Months Warranty")]),_vm._v(" "),_c('el-option',{attrs:{"value":"6 Months Warranty"}},[_vm._v("6 Months Warranty")]),_vm._v(" "),_c('el-option',{attrs:{"value":"1 Year Warranty"}},[_vm._v("1 Year Warranty")]),_vm._v(" "),_c('el-option',{attrs:{"value":"2 Year Warranty"}},[_vm._v("2 Year Warranty")]),_vm._v(" "),_c('el-option',{attrs:{"value":"3 Year Warranty"}},[_vm._v("3 Year Warranty")]),_vm._v(" "),_c('el-option',{attrs:{"value":"4 Year Warranty"}},[_vm._v("4 Year Warranty")]),_vm._v(" "),_c('el-option',{attrs:{"value":"5 Year Warranty"}},[_vm._v("5 Year Warranty")]),_vm._v(" "),_c('el-option',{attrs:{"value":"10 Year Warranty"}},[_vm._v("10 Year Warranty")]),_vm._v(" "),_c('el-option',{attrs:{"value":"Lifetime Warranty"}},[_vm._v("Lifetime Warranty")])],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Product Description","prop":"desc"}},[_c('el-input',{attrs:{"type":"textarea","maxlength":"1000","autosize":{ minRows: 2, maxRows: 4 }},model:{value:(_vm.formdata.desc),callback:function ($$v) {_vm.$set(_vm.formdata, "desc", $$v)},expression:"formdata.desc"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.updateForm('formdata')}}},[_vm._v("Update")]),_vm._v(" "),_c('el-button',{attrs:{"type":"danger"},on:{"click":function($event){_vm.goback()}}},[_vm._v("Go Back")])],1)],1)],1)])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Offers_vue__ = __webpack_require__(232);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ac7096e0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Offers_vue__ = __webpack_require__(787);
function injectStyle (ssrContext) {
  __webpack_require__(709)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ac7096e0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Offers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ac7096e0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Offers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 709 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 710 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 711 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('footer',{staticClass:"footer section section-sm"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"container mt-4"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 mx-auto mt-2"},[_c('div',{staticClass:"copyright text-center"},[_c('img',{attrs:{"src":__webpack_require__(25),"alt":"eshops-logo"}}),_vm._v(" "),_c('p',{staticClass:"m-f-text mt-2"},[_vm._v("\n              © "+_vm._s(new Date().getFullYear())+" eshops.lk | All Rights Reserved\n            ")])])])])])]),_vm._v(" "),_c('footer',{}),_vm._v(" "),(_vm.isVisible)?_c('button',{staticClass:"goTop",on:{"click":_vm.backToTop}},[_c('i',{staticClass:"fa fa-angle-up",attrs:{"aria-hidden":"true"}})]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-md-12 m-auto"},[_c('div',{staticClass:"block block-info m-auto text-center"},[_c('h4',[_vm._v("Contact Us")]),_vm._v(" "),_c('ul',[_c('li',[_c('a',[_c('i',{staticClass:"fa fa-phone mr-2",attrs:{"aria-hidden":"true"}}),_vm._v("0719 500\n                  600")])]),_vm._v(" "),_c('li',[_c('a',[_c('i',{staticClass:"fa fa-envelope mr-2",attrs:{"aria-hidden":"true"}}),_vm._v("info@eshops.lk")])])]),_vm._v(" "),_c('ul',{staticClass:"social-media-icons mb-2 d-inline"},[_c('li',{},[_c('a',{staticClass:"px-0 ml-0 mr-2",attrs:{"href":"https://www.facebook.com/Eshopslk-2212428785713128/"}},[_c('i',{staticClass:"fa fa-facebook-official f-sm-link",staticStyle:{"font-size":"34px","color":"#3b5998","background-color":"#fff","width":"30px","height":"30px","border-radius":"4px","text-align":"center","vertical-align":"middle"}})])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"px-0 mx-2",attrs:{"href":"https://www.instagram.com/eshops.lk/"}},[_c('i',{staticClass:"fa fa-instagram f-sm-link",staticStyle:{"font-size":"30px","color":"#fff","background":"radial-gradient(","width":"32px","height":"32px","border-radius":"4px","text-align":"center","vertical-align":"middle"}})])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"px-0 mx-2",attrs:{"href":"https://www.youtube.com/channel/UCJhY3IfJD3T2bA5PJ3SrMZw"}},[_c('i',{staticClass:"fa fa-youtube-square f-sm-link",staticStyle:{"font-size":"35px","color":"#ff0000","background-color":"#fff","width":"30px","height":"30px","border-radius":"6px","text-align":"center","vertical-align":"middle"}})])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 713 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 735 */,
/* 736 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 259,
	"./af.js": 259,
	"./ar": 260,
	"./ar-dz": 261,
	"./ar-dz.js": 261,
	"./ar-kw": 262,
	"./ar-kw.js": 262,
	"./ar-ly": 263,
	"./ar-ly.js": 263,
	"./ar-ma": 264,
	"./ar-ma.js": 264,
	"./ar-sa": 265,
	"./ar-sa.js": 265,
	"./ar-tn": 266,
	"./ar-tn.js": 266,
	"./ar.js": 260,
	"./az": 267,
	"./az.js": 267,
	"./be": 268,
	"./be.js": 268,
	"./bg": 269,
	"./bg.js": 269,
	"./bm": 270,
	"./bm.js": 270,
	"./bn": 271,
	"./bn-bd": 272,
	"./bn-bd.js": 272,
	"./bn.js": 271,
	"./bo": 273,
	"./bo.js": 273,
	"./br": 274,
	"./br.js": 274,
	"./bs": 275,
	"./bs.js": 275,
	"./ca": 276,
	"./ca.js": 276,
	"./cs": 277,
	"./cs.js": 277,
	"./cv": 278,
	"./cv.js": 278,
	"./cy": 279,
	"./cy.js": 279,
	"./da": 280,
	"./da.js": 280,
	"./de": 281,
	"./de-at": 282,
	"./de-at.js": 282,
	"./de-ch": 283,
	"./de-ch.js": 283,
	"./de.js": 281,
	"./dv": 284,
	"./dv.js": 284,
	"./el": 285,
	"./el.js": 285,
	"./en-au": 286,
	"./en-au.js": 286,
	"./en-ca": 287,
	"./en-ca.js": 287,
	"./en-gb": 288,
	"./en-gb.js": 288,
	"./en-ie": 289,
	"./en-ie.js": 289,
	"./en-il": 290,
	"./en-il.js": 290,
	"./en-in": 291,
	"./en-in.js": 291,
	"./en-nz": 292,
	"./en-nz.js": 292,
	"./en-sg": 293,
	"./en-sg.js": 293,
	"./eo": 294,
	"./eo.js": 294,
	"./es": 295,
	"./es-do": 296,
	"./es-do.js": 296,
	"./es-mx": 297,
	"./es-mx.js": 297,
	"./es-us": 298,
	"./es-us.js": 298,
	"./es.js": 295,
	"./et": 299,
	"./et.js": 299,
	"./eu": 300,
	"./eu.js": 300,
	"./fa": 301,
	"./fa.js": 301,
	"./fi": 302,
	"./fi.js": 302,
	"./fil": 303,
	"./fil.js": 303,
	"./fo": 304,
	"./fo.js": 304,
	"./fr": 305,
	"./fr-ca": 306,
	"./fr-ca.js": 306,
	"./fr-ch": 307,
	"./fr-ch.js": 307,
	"./fr.js": 305,
	"./fy": 308,
	"./fy.js": 308,
	"./ga": 309,
	"./ga.js": 309,
	"./gd": 310,
	"./gd.js": 310,
	"./gl": 311,
	"./gl.js": 311,
	"./gom-deva": 312,
	"./gom-deva.js": 312,
	"./gom-latn": 313,
	"./gom-latn.js": 313,
	"./gu": 314,
	"./gu.js": 314,
	"./he": 315,
	"./he.js": 315,
	"./hi": 316,
	"./hi.js": 316,
	"./hr": 317,
	"./hr.js": 317,
	"./hu": 318,
	"./hu.js": 318,
	"./hy-am": 319,
	"./hy-am.js": 319,
	"./id": 320,
	"./id.js": 320,
	"./is": 321,
	"./is.js": 321,
	"./it": 322,
	"./it-ch": 323,
	"./it-ch.js": 323,
	"./it.js": 322,
	"./ja": 324,
	"./ja.js": 324,
	"./jv": 325,
	"./jv.js": 325,
	"./ka": 326,
	"./ka.js": 326,
	"./kk": 327,
	"./kk.js": 327,
	"./km": 328,
	"./km.js": 328,
	"./kn": 329,
	"./kn.js": 329,
	"./ko": 330,
	"./ko.js": 330,
	"./ku": 331,
	"./ku.js": 331,
	"./ky": 332,
	"./ky.js": 332,
	"./lb": 333,
	"./lb.js": 333,
	"./lo": 334,
	"./lo.js": 334,
	"./lt": 335,
	"./lt.js": 335,
	"./lv": 336,
	"./lv.js": 336,
	"./me": 337,
	"./me.js": 337,
	"./mi": 338,
	"./mi.js": 338,
	"./mk": 339,
	"./mk.js": 339,
	"./ml": 340,
	"./ml.js": 340,
	"./mn": 341,
	"./mn.js": 341,
	"./mr": 342,
	"./mr.js": 342,
	"./ms": 343,
	"./ms-my": 344,
	"./ms-my.js": 344,
	"./ms.js": 343,
	"./mt": 345,
	"./mt.js": 345,
	"./my": 346,
	"./my.js": 346,
	"./nb": 347,
	"./nb.js": 347,
	"./ne": 348,
	"./ne.js": 348,
	"./nl": 349,
	"./nl-be": 350,
	"./nl-be.js": 350,
	"./nl.js": 349,
	"./nn": 351,
	"./nn.js": 351,
	"./oc-lnc": 352,
	"./oc-lnc.js": 352,
	"./pa-in": 353,
	"./pa-in.js": 353,
	"./pl": 354,
	"./pl.js": 354,
	"./pt": 355,
	"./pt-br": 356,
	"./pt-br.js": 356,
	"./pt.js": 355,
	"./ro": 357,
	"./ro.js": 357,
	"./ru": 358,
	"./ru.js": 358,
	"./sd": 359,
	"./sd.js": 359,
	"./se": 360,
	"./se.js": 360,
	"./si": 361,
	"./si.js": 361,
	"./sk": 362,
	"./sk.js": 362,
	"./sl": 363,
	"./sl.js": 363,
	"./sq": 364,
	"./sq.js": 364,
	"./sr": 365,
	"./sr-cyrl": 366,
	"./sr-cyrl.js": 366,
	"./sr.js": 365,
	"./ss": 367,
	"./ss.js": 367,
	"./sv": 368,
	"./sv.js": 368,
	"./sw": 369,
	"./sw.js": 369,
	"./ta": 370,
	"./ta.js": 370,
	"./te": 371,
	"./te.js": 371,
	"./tet": 372,
	"./tet.js": 372,
	"./tg": 373,
	"./tg.js": 373,
	"./th": 374,
	"./th.js": 374,
	"./tk": 375,
	"./tk.js": 375,
	"./tl-ph": 376,
	"./tl-ph.js": 376,
	"./tlh": 377,
	"./tlh.js": 377,
	"./tr": 378,
	"./tr.js": 378,
	"./tzl": 379,
	"./tzl.js": 379,
	"./tzm": 380,
	"./tzm-latn": 381,
	"./tzm-latn.js": 381,
	"./tzm.js": 380,
	"./ug-cn": 382,
	"./ug-cn.js": 382,
	"./uk": 383,
	"./uk.js": 383,
	"./ur": 384,
	"./ur.js": 384,
	"./uz": 385,
	"./uz-latn": 386,
	"./uz-latn.js": 386,
	"./uz.js": 385,
	"./vi": 387,
	"./vi.js": 387,
	"./x-pseudo": 388,
	"./x-pseudo.js": 388,
	"./yo": 389,
	"./yo.js": 389,
	"./zh-cn": 390,
	"./zh-cn.js": 390,
	"./zh-hk": 391,
	"./zh-hk.js": 391,
	"./zh-mo": 392,
	"./zh-mo.js": 392,
	"./zh-tw": 393,
	"./zh-tw.js": 393
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 768;

/***/ }),
/* 769 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.order.date)?_c('div',{attrs:{"id":"orderPrint"}},[_c('div',{staticClass:"ticket"},[_c('p',[_vm._v("\n      Order No : "+_vm._s(_vm.order.orderNo)+" "),_c('br'),_vm._v("Date :\n      "+_vm._s(_vm.order.date)+" "),_c('br'),_vm._v("Customer : "+_vm._s(_vm.order.cusname)+"\n      "),_c('br'),_vm._v("Telephone : "+_vm._s(_vm.order.telno)+"\n      "),_c('br'),_vm._v("Address : "+_vm._s(_vm.order.address)+"\n    ")])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Loading")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.changed)?_c('div',[_c('div',{staticClass:"container"},[(_vm.dailyData)?_c('div',{staticClass:"row mt-4 no-gutters"},[_c('div',{staticClass:"col-lg-3 col-md-6 col-xs-6"},[_c('div',{staticClass:"rad-info-box-colored rad-bg-dark-blue1 rad-txt-white"},[_c('i',{staticClass:"el-icon-document"}),_vm._v(" "),_c('span',{staticClass:"heading"},[_vm._v("Today's Sales")]),_vm._v(" "),_c('span',{staticClass:"value"},[_c('span',[_vm._v(_vm._s(// (+dailyData.sales.toFixed(2)).toLocaleString()
                  _vm.salesToday.toFixed(2).toLocaleString()))])])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-3 col-md-6 col-xs-6"},[_c('div',{staticClass:"rad-info-box-colored rad-bg-dark-blue1 rad-txt-white"},[_c('i',{staticClass:"el-icon-money"}),_vm._v(" "),_c('span',{staticClass:"heading"},[_vm._v("Today's Expenses")]),_vm._v(" "),_c('span',{staticClass:"value"},[_c('span',[_vm._v(_vm._s((+_vm.dailyData.expenses.toFixed(2)).toLocaleString()))])])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-3 col-md-6 col-xs-6 text-center"},[_c('div',{staticClass:"rad-info-box-colored rad-bg-dark-blue1 rad-txt-white"},[_c('i',{staticClass:"el-icon-s-marketing"}),_vm._v(" "),_c('span',{staticClass:"heading"},[_vm._v("Today's Net Profit")]),_vm._v(" "),_c('span',{staticClass:"value"},[_c('span',[_vm._v(_vm._s(// (+(dailyData.profit - dailyData.expenses).toFixed(
                  //   2
                  // )).toLocaleString()
                  (_vm.profitToday - _vm.dailyData.expenses).toFixed(2).toLocaleString()))])])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-3 col-md-6 col-xs-6"},[_c('div',{staticClass:"rad-info-box-colored rad-bg-dark-blue1 rad-txt-white"},[_c('i',{staticClass:"el-icon-remove-outline"}),_vm._v(" "),_c('span',{staticClass:"heading"},[_vm._v("Today's Due")]),_vm._v(" "),_c('span',{staticClass:"value"},[_c('span',[_vm._v(_vm._s((+_vm.dailyData.due.toFixed(2)).toLocaleString()))])])])])]):_vm._e(),_vm._v(" "),(_vm.reportData)?_c('div',{staticClass:"row no-gutters"},[_c('div',{staticClass:"col-lg-3 col-md-6 col-xs-6"},[_c('div',{staticClass:"rad-info-box-colored rad-bg-dark-blue rad-txt-white"},[_c('i',{staticClass:"el-icon-document"}),_vm._v(" "),_c('span',{staticClass:"heading"},[_vm._v("Monthly Sales")]),_vm._v(" "),_c('span',{staticClass:"value"},[_c('span',[_vm._v(_vm._s((+_vm.reportData.totalSales.toFixed(2)).toLocaleString()))])])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-3 col-md-6 col-xs-6"},[_c('div',{staticClass:"rad-info-box-colored rad-bg-dark-blue rad-txt-white"},[_c('i',{staticClass:"el-icon-money"}),_vm._v(" "),_c('span',{staticClass:"heading"},[_vm._v("Monthly Expenses")]),_vm._v(" "),_c('span',{staticClass:"value"},[_c('span',[_vm._v(_vm._s((+_vm.reportData.totalExp.toFixed(2)).toLocaleString()))])])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-3 col-md-6 col-xs-6 text-center"},[_c('div',{staticClass:"rad-info-box-colored rad-bg-dark-blue rad-txt-white"},[_c('i',{staticClass:"el-icon-s-marketing"}),_vm._v(" "),_c('span',{staticClass:"heading"},[_vm._v("Monthly Net Profit")]),_vm._v(" "),_c('span',{staticClass:"value"},[_c('span',[_vm._v(_vm._s((+(_vm.reportData.totalProfit - _vm.reportData.totalExp).toFixed(
                    2
                  )).toLocaleString()))])])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-3 col-md-6 col-xs-6"},[_c('div',{staticClass:"rad-info-box-colored rad-bg-dark-blue rad-txt-white"},[_c('i',{staticClass:"el-icon-remove-outline"}),_vm._v(" "),_c('span',{staticClass:"heading"},[_vm._v("Monthly Due")]),_vm._v(" "),_c('span',{staticClass:"value"},[_c('span',[_vm._v(_vm._s((+_vm.reportData.totalRemaining.toFixed(2)).toLocaleString()))])])])])]):_vm._e(),_vm._v(" "),(_vm.storeData)?_c('div',{staticClass:"row mb-4 no-gutters"},[_c('div',{staticClass:"col-lg-3 col-md-6 col-xs-6"},[_c('div',{staticClass:"rad-info-box-colored rad-bg-dark-blue2 rad-txt-white"},[_c('i',{staticClass:"el-icon-document"}),_vm._v(" "),_c('span',{staticClass:"heading"},[_vm._v("Total Sales")]),_vm._v(" "),_c('span',{staticClass:"value"},[_c('span',[_vm._v(_vm._s((+_vm.storeData.netPay.toFixed(2)).toLocaleString()))])])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-3 col-md-6 col-xs-6"},[_c('div',{staticClass:"rad-info-box-colored rad-bg-dark-blue2 rad-txt-white"},[_c('i',{staticClass:"el-icon-money"}),_vm._v(" "),_c('span',{staticClass:"heading"},[_vm._v("Total Expenses")]),_vm._v(" "),_c('span',{staticClass:"value"},[_c('span',[_vm._v(_vm._s((+_vm.storeData.totalExp.toFixed(2)).toLocaleString()))])])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-3 col-md-6 col-xs-6 text-center"},[_c('div',{staticClass:"rad-info-box-colored rad-bg-dark-blue2 rad-txt-white"},[_c('i',{staticClass:"el-icon-s-marketing"}),_vm._v(" "),_c('span',{staticClass:"heading"},[_vm._v("Total Net Profit")]),_vm._v(" "),_c('span',{staticClass:"value"},[_c('span',[_vm._v(_vm._s((+(_vm.storeData.totalProfit - _vm.storeData.totalExp).toFixed(
                    2
                  )).toLocaleString()))])])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-3 col-md-6 col-xs-6"},[_c('div',{staticClass:"rad-info-box-colored rad-bg-dark-blue2 rad-txt-white"},[_c('i',{staticClass:"el-icon-remove-outline"}),_vm._v(" "),_c('span',{staticClass:"heading"},[_vm._v("Total Due")]),_vm._v(" "),_c('span',{staticClass:"value"},[_c('span',[_vm._v(_vm._s((+_vm.storeData.totalRemain.toFixed(2)).toLocaleString()))])])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row mt-4 no-gutters"},[_c('div',{staticClass:"col-lg-3 col-md-6 col-xs-6"},[_c('div',{staticClass:"rad-info-box rad-txt-violet"},[_c('i',{staticClass:"el-icon-discount"}),_vm._v(" "),_c('span',{staticClass:"heading"},[_vm._v("Products")]),_vm._v(" "),_c('span',{staticClass:"value"},[_c('span',[_vm._v(_vm._s(_vm.curProducts))])])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-3 col-md-6 col-xs-6"},[_c('div',{staticClass:"rad-info-box rad-txt-violet"},[_c('i',{staticClass:"fa fa-truck"}),_vm._v(" "),_c('span',{staticClass:"heading"},[_vm._v("Orders")]),_vm._v(" "),_c('span',{staticClass:"value"},[_c('span',[_vm._v(_vm._s(_vm.orders))])])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-3 col-md-6 col-xs-6"},[_c('div',{staticClass:"rad-info-box rad-txt-primary"},[_c('i',{staticClass:"fa fa-users"}),_vm._v(" "),_c('span',{staticClass:"heading"},[_vm._v("Customers")]),_vm._v(" "),_c('span',{staticClass:"value"},[_c('span',[_vm._v(_vm._s(_vm.cus))])])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-3 col-md-6 col-xs-6"},[_c('div',{staticClass:"rad-info-box rad-txt-primary"},[_c('i',{staticClass:"fa fa-shopping-bag"}),_vm._v(" "),_c('span',{staticClass:"heading"},[_vm._v("Offers")]),_vm._v(" "),_c('span',{staticClass:"value"},[_c('span',[_vm._v(_vm._s(_vm.curOffers))])])])])]),_vm._v(" "),_c('el-card',{staticClass:"my-4",staticStyle:{"background-color":"#dcdfe6"},attrs:{"shadow":"always"}},[_c('h5',{staticClass:"mb-3",staticStyle:{"text-align":"center"}},[_vm._v("Today's Invoices")]),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"my-1",attrs:{"sm":"4"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":""}},[_c('b-input-group',[_c('b-form-input',{attrs:{"placeholder":"Search"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),_c('b-input-group-append',[_c('b-btn',{attrs:{"disabled":!_vm.filter},on:{"click":function($event){_vm.filter = ''}}},[_vm._v("Clear")])],1)],1)],1)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"sm":"5"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":""}},[_c('b-input-group',[_c('b-form-select',{attrs:{"options":_vm.sortOptions},model:{value:(_vm.sortBy),callback:function ($$v) {_vm.sortBy=$$v},expression:"sortBy"}},[_c('option',{attrs:{"slot":"first"},domProps:{"value":null},slot:"first"},[_vm._v("Sort By")])]),_vm._v(" "),_c('b-form-select',{attrs:{"slot":"append","disabled":!_vm.sortBy},slot:"append",model:{value:(_vm.sortDesc),callback:function ($$v) {_vm.sortDesc=$$v},expression:"sortDesc"}},[_c('option',{domProps:{"value":false}},[_vm._v("Asc")]),_vm._v(" "),_c('option',{domProps:{"value":true}},[_vm._v("Desc")])])],1)],1)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"sm":"3"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"horizontal":""}},[_c('b-form-select',{model:{value:(_vm.invoiceperPage),callback:function ($$v) {_vm.invoiceperPage=$$v},expression:"invoiceperPage"}},[_c('option',{attrs:{"disabled":""}},[_vm._v("per page")]),_vm._v(" "),_c('option',{domProps:{"value":10}},[_vm._v("10")]),_vm._v(" "),_c('option',{domProps:{"value":20}},[_vm._v("20")]),_vm._v(" "),_c('option',{domProps:{"value":40}},[_vm._v("40")])])],1)],1)],1),_vm._v(" "),_c('el-card',{staticStyle:{"overflow-x":"scroll"},attrs:{"shadow":"always"}},[_c('b-table',{staticClass:"mt-4",attrs:{"show-empty":"","stacked":"sm","items":_vm.invoiceItems,"fields":_vm.invoiceFields,"hover":true,"head-variant":"dark","current-page":_vm.invoicecurrentPage,"per-page":_vm.invoiceperPage,"empty-text":_vm.emptyText,"filter":_vm.filter,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event},"filtered":_vm.onFiltered},scopedSlots:_vm._u([{key:"index",fn:function(data){return [_vm._v("\n                "+_vm._s(data.index + 1)+"\n              ")]}},{key:"actions",fn:function(row){return [_c('div',{staticClass:"btn-group",attrs:{"role":"group","aria-label":"Basic example"}},[_c('a',{staticClass:"btn btn-sm btn-info text-white",attrs:{"size":"sm"},on:{"click":function($event){$event.stopPropagation();row.toggleDetails($event)}}},[_vm._v("\n                    View\n                  ")])])]}},{key:"row-details",fn:function(row){return [_c('b-card',[_c('el-row',{staticStyle:{"margin-top":"20px"},attrs:{"gutter":10}},[_c('el-col',{attrs:{"xs":24,"sm":24,"md":24,"lg":24,"xl":24}},[_c('el-card',{staticClass:"box-card",staticStyle:{"background-color":"#eaf0ff"}},[_c('div',{staticClass:"clearfix text item"},[_c('span',[_vm._v("Gross Amount")]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","padding":"3px 0"}},[_vm._v(_vm._s(row.item.grossAmount.toLocaleString())+"\n                            LKR")])]),_vm._v(" "),_c('div',{staticClass:"clearfix text item"},[_c('span',[_vm._v("Discount")]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","padding":"3px 0"}},[_vm._v(_vm._s(row.item.discount.toLocaleString())+" LKR\n                          ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix text item"},[_c('span',[_vm._v("Other Discount")]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","padding":"3px 0"}},[_vm._v("\n                            "+_vm._s(row.item.otherDiscount.toLocaleString())+"\n                            LKR\n                          ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix text item"},[_c('span',[_vm._v("Service Charge")]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","padding":"3px 0"}},[_vm._v("\n                          "+_vm._s(row.item.serviceChargeMode === 'Percentage' ? ((row.item.grossAmount * row.item.sCharge) / 100).toLocaleString() : row.item.sCharge.toLocaleString())+" LKR\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix text item"},[_c('span',[_vm._v("Net Amount")]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","padding":"3px 0"}},[_vm._v(_vm._s(row.item.netAmount.toLocaleString())+" LKR")])]),_vm._v(" "),_c('div',{staticClass:"clearfix text item"},[_c('span',[_vm._v("Tax")]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","padding":"3px 0"}},[_vm._v("\n                          "+_vm._s(row.item.taxMode === 'Percentage' ? ((row.item.netAmount * row.item.tax) / 100).toLocaleString() : row.item.tax.toLocaleString())+" LKR\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix text item"},[_c('span',[_vm._v("Card Payment")]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","padding":"3px 0"}},[_vm._v("\n                            "+_vm._s(row.item.cardPayment.toLocaleString())+" LKR\n                          ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix text item"},[_c('span',[_vm._v("Cash Payment")]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","padding":"3px 0"}},[_vm._v("\n                            "+_vm._s(row.item.cashPayment.toLocaleString())+" LKR\n                          ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix text item"},[_c('span',[_vm._v("Cheque Payment")]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","padding":"3px 0"}},[_vm._v("\n                            "+_vm._s(row.item.chequePayment.toLocaleString())+" LKR\n                          ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix text item"},[_c('span',[_vm._v("Balance")]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","padding":"3px 0"}},[_vm._v(_vm._s(row.item.balance.toLocaleString())+" LKR")])])])],1),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":24,"md":24,"lg":24,"xl":24}},[_c('h5',{staticClass:"text-center text-info my-4"},[_vm._v("Ordeded Items")]),_vm._v(" "),_c('div',{staticStyle:{"overflow-x":"scroll"}},[_c('b-table',{staticClass:"mt-4",attrs:{"show-empty":"","stacked":"sm","items":row.item.products,"fields":_vm.invoiceProductsFields,"hover":true,"head-variant":"dark","empty-text":_vm.emptyText,"filter":_vm.filter,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event}},scopedSlots:_vm._u([{key:"index",fn:function(data){return [_vm._v("\n                            "+_vm._s(data.index + 1)+"\n                          ")]}}])})],1)])],1)],1)]}}])})],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"md":"6"}},[_c('b-pagination',{staticClass:"my-0",attrs:{"total-rows":_vm.invoicetotalRows,"per-page":_vm.invoiceperPage},model:{value:(_vm.invoicecurrentPage),callback:function ($$v) {_vm.invoicecurrentPage=$$v},expression:"invoicecurrentPage"}})],1)],1),_vm._v(" "),_c('el-card',{staticClass:"my-4",staticStyle:{"background-color":"#dcdfe6"},attrs:{"shadow":"always"}},[_c('h5',{staticClass:"mb-3",staticStyle:{"text-align":"center"}},[_vm._v("Products Low in Stock")]),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"my-1",attrs:{"sm":"4"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":""}},[_c('b-input-group',[_c('b-form-input',{attrs:{"placeholder":"Search"},model:{value:(_vm.filterLowItem),callback:function ($$v) {_vm.filterLowItem=$$v},expression:"filterLowItem"}}),_vm._v(" "),_c('b-input-group-append',[_c('b-btn',{attrs:{"disabled":!_vm.filter},on:{"click":function($event){_vm.filter = ''}}},[_vm._v("Clear")])],1)],1)],1)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"sm":"5"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":""}},[_c('b-input-group',[_c('b-form-select',{attrs:{"options":_vm.lowItemssortOptions},model:{value:(_vm.sortBy),callback:function ($$v) {_vm.sortBy=$$v},expression:"sortBy"}},[_c('option',{attrs:{"slot":"first"},domProps:{"value":null},slot:"first"},[_vm._v("Sort By")])]),_vm._v(" "),_c('b-form-select',{attrs:{"slot":"append","disabled":!_vm.sortBy},slot:"append",model:{value:(_vm.sortDesc),callback:function ($$v) {_vm.sortDesc=$$v},expression:"sortDesc"}},[_c('option',{domProps:{"value":false}},[_vm._v("Asc")]),_vm._v(" "),_c('option',{domProps:{"value":true}},[_vm._v("Desc")])])],1)],1)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"sm":"3"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"horizontal":""}},[_c('b-form-select',{model:{value:(_vm.lowItemsperPage),callback:function ($$v) {_vm.lowItemsperPage=$$v},expression:"lowItemsperPage"}},[_c('option',{attrs:{"disabled":""}},[_vm._v("per page")]),_vm._v(" "),_c('option',{domProps:{"value":10}},[_vm._v("10")]),_vm._v(" "),_c('option',{domProps:{"value":20}},[_vm._v("20")]),_vm._v(" "),_c('option',{domProps:{"value":40}},[_vm._v("40")])])],1)],1)],1),_vm._v(" "),_c('el-card',{staticStyle:{"overflow-x":"scroll"},attrs:{"shadow":"always"}},[_c('b-table',{staticClass:"mt-4",attrs:{"show-empty":"","stacked":"sm","items":_vm.lowStockItems,"fields":_vm.lowItemsFields,"hover":true,"head-variant":"dark","current-page":_vm.lowItemscurrentPage,"per-page":_vm.lowItemsperPage,"empty-text":_vm.lowStockEmptyText,"filter":_vm.filterLowItem,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event},"filtered":_vm.onFiltered},scopedSlots:_vm._u([{key:"index",fn:function(data){return [_vm._v("\n                "+_vm._s(data.index + 1)+"\n              ")]}}])})],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"md":"6"}},[_c('b-pagination',{staticClass:"my-0",attrs:{"total-rows":_vm.lowItemstotalRows,"per-page":_vm.lowItemsperPage},model:{value:(_vm.lowItemscurrentPage),callback:function ($$v) {_vm.lowItemscurrentPage=$$v},expression:"lowItemscurrentPage"}})],1)],1),_vm._v(" "),_c('el-card',{staticStyle:{"background-color":"#dcdfe6","overflow-x":"scroll"}},[_c('h5',{staticClass:"mb-3",staticStyle:{"text-align":"center"}},[_vm._v("New Orders")]),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"my-1",attrs:{"sm":"5"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":""}},[_c('b-input-group',[_c('b-form-select',{attrs:{"options":_vm.ordersSortOptions},model:{value:(_vm.sortBy),callback:function ($$v) {_vm.sortBy=$$v},expression:"sortBy"}},[_c('option',{attrs:{"slot":"first"},domProps:{"value":null},slot:"first"},[_vm._v("Sort By")])]),_vm._v(" "),_c('b-form-select',{attrs:{"slot":"append","disabled":!_vm.sortBy},slot:"append",model:{value:(_vm.sortDesc),callback:function ($$v) {_vm.sortDesc=$$v},expression:"sortDesc"}},[_c('option',{domProps:{"value":false}},[_vm._v("Asc")]),_vm._v(" "),_c('option',{domProps:{"value":true}},[_vm._v("Desc")])])],1)],1)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"sm":"3"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"horizontal":""}},[_c('b-form-select',{model:{value:(_vm.ordersperPage),callback:function ($$v) {_vm.ordersperPage=$$v},expression:"ordersperPage"}},[_c('option',{attrs:{"disabled":""}},[_vm._v("per page")]),_vm._v(" "),_c('option',{domProps:{"value":10}},[_vm._v("10")]),_vm._v(" "),_c('option',{domProps:{"value":20}},[_vm._v("20")]),_vm._v(" "),_c('option',{domProps:{"value":40}},[_vm._v("40")])])],1)],1)],1),_vm._v(" "),_c('b-table',{staticClass:"mt-4",staticStyle:{"overflow-x":"scroll"},attrs:{"show-empty":"","stacked":"sm","items":_vm.ordersItems,"fields":_vm.ordersFields,"hover":true,"head-variant":"dark","current-page":_vm.orderscurrentPage,"per-page":_vm.ordersperPage,"empty-text":_vm.emptyText,"filter":_vm.filter,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event},"filtered":_vm.onFiltered},scopedSlots:_vm._u([{key:"index",fn:function(data){return [_vm._v("\n              "+_vm._s(data.index + 1)+"\n            ")]}},{key:"name",fn:function(row){return [_c('b-media',[_c('b-img',{attrs:{"slot":"aside","src":"https://lorempixel.com/125/125/technics/8/","width":"64","height":"64","alt":"image"},slot:"aside"}),_vm._v(" "),_c('h6',{staticClass:"mt-4"},[_vm._v(_vm._s(row.value))])],1)]}},{key:"category",fn:function(row){return [_c('div',{staticClass:"row mt-4"},[_vm._v(_vm._s(row.value))])]}},{key:"status",fn:function(row){return [_c('el-select',{staticStyle:{"width":"160px"},attrs:{"size":"mini","placeholder":"Order Status"},on:{"change":function($event){_vm.upOrder(row.item.id, row.item.status, row.item.refid)}},model:{value:(row.item.status),callback:function ($$v) {_vm.$set(row.item, "status", $$v)},expression:"row.item.status"}},_vm._l((_vm.options),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}))]}},{key:"actions",fn:function(row){return [_c('div',{staticClass:"btn-group",attrs:{"role":"group","aria-label":"Basic example"}},[_c('a',{staticClass:"btn btn-sm btn-info text-white",attrs:{"size":"sm"},on:{"click":function($event){$event.stopPropagation();row.toggleDetails($event)}}},[_vm._v("\n                  View\n                ")]),_vm._v(" "),(row.item.orderNo)?_c('router-link',{staticClass:"btn btn-sm btn-primary text-white",attrs:{"to":{
                    name: 'createinvoice',
                    query: { order: row.item.orderNo, },
                  }}},[_vm._v("\n                  Invoice\n                ")]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-secondary text-white",attrs:{"size":"sm"},on:{"click":function($event){_vm.$root.$emit('orderPrint', row.item)}}},[_vm._v("\n                  Print\n                ")])],1)]}},{key:"row-details",fn:function(row){return [_c('b-card',[_c('ul',[_c('h5',{staticClass:"text-center text-info"},[_vm._v("Customer Details")]),_vm._v(" "),_c('li',{staticClass:"my-1 mr-2"},[_vm._v("\n                    Customer Name:\n                    "),_c('span',{staticClass:"ml-2"},[_vm._v(_vm._s(row.item.cusname))])]),_vm._v(" "),_c('li',{staticClass:"my-1 mr-2"},[_vm._v("\n                    Email: "),_c('span',{staticClass:"ml-2"},[_vm._v(_vm._s(row.item.cusemail))])]),_vm._v(" "),_c('li',{staticClass:"my-1 mr-2"},[_vm._v("\n                    Telephone: "),_c('span',{staticClass:"ml-2"},[_vm._v("0"+_vm._s(row.item.telno))])]),_vm._v(" "),_c('li',{staticClass:"my-1 mr-2"},[_vm._v("\n                    Address: "),_c('span',{staticClass:"ml-2"},[_vm._v(_vm._s(row.item.address))])]),_vm._v(" "),_c('li',{staticClass:"my-1 mr-2"},[_vm._v("\n                    Cart Total Rs:\n                    "),_c('span',{staticClass:"ml-2"},[_vm._v(_vm._s(row.item.total))])])]),_vm._v(" "),_c('h5',{staticClass:"text-center text-info my-4"},[_vm._v("Ordeded Items")]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._l((row.item.products),function(item,key){return [_c('div',{key:key,staticClass:"col-12 col-sm-4 col-lg-3"},[_c('img',{staticClass:"card-img-top",attrs:{"src":item.image,"alt":"image"}}),_vm._v(" "),_c('ul',{staticClass:"list-group list-group-flush"},[_c('li',{staticClass:"list-group-item"},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('li',{staticClass:"list-group-item"},[_c('span',[_vm._v("Rs")]),_vm._v(" "+_vm._s(item.price)+"\n                        ")]),_vm._v(" "),_c('li',{staticClass:"list-group-item"},[_c('span',[_vm._v("Quantity")]),_vm._v(" "+_vm._s(item.quantity)+"\n                        ")]),_vm._v(" "),_c('li',{staticClass:"list-group-item"},[_c('span',[_vm._v("Total Rs")]),_vm._v(" "+_vm._s(item.subTotal)+"\n                        ")])])])]})],2)])]}}])}),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"md":"6"}},[_c('b-pagination',{staticClass:"my-0",attrs:{"total-rows":_vm.orderstotalRows,"per-page":_vm.ordersperPage},model:{value:(_vm.orderscurrentPage),callback:function ($$v) {_vm.orderscurrentPage=$$v},expression:"orderscurrentPage"}})],1)],1)],1),_vm._v(" "),_c('OrderPrint',{staticStyle:{"display":"none"}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);

!function () {
  "use strict";
  function t(e, o) {
    var i;if (o = o || {}, this.trackingClick = !1, this.trackingClickStart = 0, this.targetElement = null, this.touchStartX = 0, this.touchStartY = 0, this.lastTouchIdentifier = 0, this.touchBoundary = o.touchBoundary || 10, this.layer = e, this.tapDelay = o.tapDelay || 200, this.tapTimeout = o.tapTimeout || 700, !t.notNeeded(e)) {
      for (var r = ["onMouse", "onClick", "onTouchStart", "onTouchMove", "onTouchEnd", "onTouchCancel"], a = this, c = 0, s = r.length; c < s; c++) {
        a[r[c]] = function (t, e) {
          return function () {
            return t.apply(e, arguments);
          };
        }(a[r[c]], a);
      }n && (e.addEventListener("mouseover", this.onMouse, !0), e.addEventListener("mousedown", this.onMouse, !0), e.addEventListener("mouseup", this.onMouse, !0)), e.addEventListener("click", this.onClick, !0), e.addEventListener("touchstart", this.onTouchStart, !1), e.addEventListener("touchmove", this.onTouchMove, !1), e.addEventListener("touchend", this.onTouchEnd, !1), e.addEventListener("touchcancel", this.onTouchCancel, !1), Event.prototype.stopImmediatePropagation || (e.removeEventListener = function (t, n, o) {
        var i = Node.prototype.removeEventListener;"click" === t ? i.call(e, t, n.hijacked || n, o) : i.call(e, t, n, o);
      }, e.addEventListener = function (t, n, o) {
        var i = Node.prototype.addEventListener;"click" === t ? i.call(e, t, n.hijacked || (n.hijacked = function (t) {
          t.propagationStopped || n(t);
        }), o) : i.call(e, t, n, o);
      }), "function" == typeof e.onclick && (i = e.onclick, e.addEventListener("click", function (t) {
        i(t);
      }, !1), e.onclick = null);
    }
  }var e = navigator.userAgent.indexOf("Windows Phone") >= 0,
      n = navigator.userAgent.indexOf("Android") > 0 && !e,
      o = /iP(ad|hone|od)/.test(navigator.userAgent) && !e,
      i = o && /OS 4_\d(_\d)?/.test(navigator.userAgent),
      r = o && /OS [6-7]_\d/.test(navigator.userAgent),
      a = navigator.userAgent.indexOf("BB10") > 0;t.prototype.needsClick = function (t) {
    switch (t.nodeName.toLowerCase()) {case "button":case "select":case "textarea":
        if (t.disabled) return !0;break;case "input":
        if (o && "file" === t.type || t.disabled) return !0;break;case "label":case "iframe":case "video":
        return !0;}return (/\bneedsclick\b/.test(t.className)
    );
  }, t.prototype.needsFocus = function (t) {
    switch (t.nodeName.toLowerCase()) {case "textarea":
        return !0;case "select":
        return !n;case "input":
        switch (t.type) {case "button":case "checkbox":case "file":case "image":case "radio":case "submit":
            return !1;}return !t.disabled && !t.readOnly;default:
        return (/\bneedsfocus\b/.test(t.className)
        );}
  }, t.prototype.sendClick = function (t, e) {
    var n, o;document.activeElement && document.activeElement !== t && document.activeElement.blur(), o = e.changedTouches[0], (n = document.createEvent("MouseEvents")).initMouseEvent(this.determineEventType(t), !0, !0, window, 1, o.screenX, o.screenY, o.clientX, o.clientY, !1, !1, !1, !1, 0, null), n.forwardedTouchEvent = !0, t.dispatchEvent(n);
  }, t.prototype.determineEventType = function (t) {
    return n && "select" === t.tagName.toLowerCase() ? "mousedown" : "click";
  }, t.prototype.focus = function (t) {
    var e;o && t.setSelectionRange && 0 !== t.type.indexOf("date") && "time" !== t.type && "month" !== t.type ? (e = t.value.length, t.setSelectionRange(e, e)) : t.focus();
  }, t.prototype.updateScrollParent = function (t) {
    var e, n;if (!(e = t.fastClickScrollParent) || !e.contains(t)) {
      n = t;do {
        if (n.scrollHeight > n.offsetHeight) {
          e = n, t.fastClickScrollParent = n;break;
        }n = n.parentElement;
      } while (n);
    }e && (e.fastClickLastScrollTop = e.scrollTop);
  }, t.prototype.getTargetElementFromEventTarget = function (t) {
    return t.nodeType === Node.TEXT_NODE ? t.parentNode : t;
  }, t.prototype.onTouchStart = function (t) {
    var e, n, r;if (t.targetTouches.length > 1) return !0;if (e = this.getTargetElementFromEventTarget(t.target), n = t.targetTouches[0], o) {
      if ((r = window.getSelection()).rangeCount && !r.isCollapsed) return !0;if (!i) {
        if (n.identifier && n.identifier === this.lastTouchIdentifier) return t.preventDefault(), !1;this.lastTouchIdentifier = n.identifier, this.updateScrollParent(e);
      }
    }return this.trackingClick = !0, this.trackingClickStart = t.timeStamp, this.targetElement = e, this.touchStartX = n.pageX, this.touchStartY = n.pageY, t.timeStamp - this.lastClickTime < this.tapDelay && t.preventDefault(), !0;
  }, t.prototype.touchHasMoved = function (t) {
    var e = t.changedTouches[0],
        n = this.touchBoundary;return Math.abs(e.pageX - this.touchStartX) > n || Math.abs(e.pageY - this.touchStartY) > n;
  }, t.prototype.onTouchMove = function (t) {
    return !this.trackingClick || ((this.targetElement !== this.getTargetElementFromEventTarget(t.target) || this.touchHasMoved(t)) && (this.trackingClick = !1, this.targetElement = null), !0);
  }, t.prototype.findControl = function (t) {
    return void 0 !== t.control ? t.control : t.htmlFor ? document.getElementById(t.htmlFor) : t.querySelector("button, input:not([type=hidden]), keygen, meter, output, progress, select, textarea");
  }, t.prototype.onTouchEnd = function (t) {
    var e,
        a,
        c,
        s,
        u,
        l = this.targetElement;if (!this.trackingClick) return !0;if (t.timeStamp - this.lastClickTime < this.tapDelay) return this.cancelNextClick = !0, !0;if (t.timeStamp - this.trackingClickStart > this.tapTimeout) return !0;if (this.cancelNextClick = !1, this.lastClickTime = t.timeStamp, a = this.trackingClickStart, this.trackingClick = !1, this.trackingClickStart = 0, r && (u = t.changedTouches[0], (l = document.elementFromPoint(u.pageX - window.pageXOffset, u.pageY - window.pageYOffset) || l).fastClickScrollParent = this.targetElement.fastClickScrollParent), "label" === (c = l.tagName.toLowerCase())) {
      if (e = this.findControl(l)) {
        if (this.focus(l), n) return !1;l = e;
      }
    } else if (this.needsFocus(l)) return t.timeStamp - a > 100 || o && window.top !== window && "input" === c ? (this.targetElement = null, !1) : (this.focus(l), this.sendClick(l, t), o && "select" === c || (this.targetElement = null, t.preventDefault()), !1);return !(!o || i || !(s = l.fastClickScrollParent) || s.fastClickLastScrollTop === s.scrollTop) || (this.needsClick(l) || (t.preventDefault(), this.sendClick(l, t)), !1);
  }, t.prototype.onTouchCancel = function () {
    this.trackingClick = !1, this.targetElement = null;
  }, t.prototype.onMouse = function (t) {
    return !this.targetElement || !!t.forwardedTouchEvent || !t.cancelable || !(!this.needsClick(this.targetElement) || this.cancelNextClick) || (t.stopImmediatePropagation ? t.stopImmediatePropagation() : t.propagationStopped = !0, t.stopPropagation(), t.preventDefault(), !1);
  }, t.prototype.onClick = function (t) {
    var e;return this.trackingClick ? (this.targetElement = null, this.trackingClick = !1, !0) : "submit" === t.target.type && 0 === t.detail || ((e = this.onMouse(t)) || (this.targetElement = null), e);
  }, t.prototype.destroy = function () {
    var t = this.layer;n && (t.removeEventListener("mouseover", this.onMouse, !0), t.removeEventListener("mousedown", this.onMouse, !0), t.removeEventListener("mouseup", this.onMouse, !0)), t.removeEventListener("click", this.onClick, !0), t.removeEventListener("touchstart", this.onTouchStart, !1), t.removeEventListener("touchmove", this.onTouchMove, !1), t.removeEventListener("touchend", this.onTouchEnd, !1), t.removeEventListener("touchcancel", this.onTouchCancel, !1);
  }, t.notNeeded = function (t) {
    var e, o, i;if (void 0 === window.ontouchstart) return !0;if (o = +(/Chrome\/([0-9]+)/.exec(navigator.userAgent) || [, 0])[1]) {
      if (!n) return !0;if (e = document.querySelector("meta[name=viewport]")) {
        if (-1 !== e.content.indexOf("user-scalable=no")) return !0;if (o > 31 && document.documentElement.scrollWidth <= window.outerWidth) return !0;
      }
    }if (a && (i = navigator.userAgent.match(/Version\/([0-9]*)\.([0-9]*)/))[1] >= 10 && i[2] >= 3 && (e = document.querySelector("meta[name=viewport]"))) {
      if (-1 !== e.content.indexOf("user-scalable=no")) return !0;if (document.documentElement.scrollWidth <= window.outerWidth) return !0;
    }return "none" === t.style.msTouchAction || "manipulation" === t.style.touchAction || !!(+(/Firefox\/([0-9]+)/.exec(navigator.userAgent) || [, 0])[1] >= 27 && (e = document.querySelector("meta[name=viewport]")) && (-1 !== e.content.indexOf("user-scalable=no") || document.documentElement.scrollWidth <= window.outerWidth)) || "none" === t.style.touchAction || "manipulation" === t.style.touchAction;
  }, t.attach = function (e, n) {
    return new t(e, n);
  }, "function" == typeof define && "object" == __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(__webpack_require__(397)) && __webpack_require__(397) ? define(function () {
    return t;
  }) : "undefined" != typeof module && module.exports ? (module.exports = t.attach, module.exports.FastClick = t) : window.FastClick = t;
}();
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(773)(module)))

/***/ }),
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{staticClass:"loading"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.fetch)?_c('div',[_c('div',{class:{enlarged: _vm.enlarged},attrs:{"id":"main"}},[_c('b-modal',{staticClass:"text-center text-info",attrs:{"ok-only":"","centered":"","centered":"","title":_vm.title},model:{value:(_vm.modalShow1),callback:function ($$v) {_vm.modalShow1=$$v},expression:"modalShow1"}},[_vm._v("\r\n      \r\n      "+_vm._s(_vm.msg)+"\r\n    ")]),_vm._v(" "),_c('div',{staticClass:"headerbar"},[_c('div',{staticClass:"headerbar-left"},[_c('ul',{staticClass:"list-inline menu-left mb-0"},[_c('li',{staticClass:"float-left"},[_c('button',{staticClass:"button-menu-mobile open-left"},[_c('i',{staticClass:"fa fa-fw fa-bars",on:{"click":function($event){_vm.LSB()}}})])])])]),_vm._v(" "),_c('nav',{staticClass:"navbar-custom"},[_c('ul',{staticClass:"list-inline float-right mb-0"},[_c('li',{staticClass:"list-inline-item dropdown notif"},[_c('a',{staticClass:"nav-link dropdown-toggle arrow-none",attrs:{"data-toggle":"dropdown","href":"#","role":"button","aria-haspopup":"false","aria-expanded":"false"}},[_c('i',{staticClass:"fa fa-fw fa-bell-o"}),(_vm.notices.length > 0)?_c('span',{staticClass:"notif-bullet"}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu dropdown-menu-right dropdown-arrow dropdown-lg",staticStyle:{"height":"250px","overflow-y":"scroll","width":"250px"}},[_c('div',{staticClass:"dropdown-item noti-title"},[_c('h5',[_c('small',[_c('span',{staticClass:"label label-danger pull-xs-right"},[_vm._v(_vm._s(_vm.notices.length))]),_vm._v("Allerts")])])]),_vm._v(" "),_c('a',{staticClass:"dropdown-item notify-item mb-1"},_vm._l((_vm.notices),function(notice){return _c('p',{key:notice.title,staticClass:"notify-details",on:{"click":function($event){_vm.showMsg(notice.title, notice.msg)}}},[_c('b',{staticStyle:{"cursor":"pointer"}},[_vm._v(_vm._s(notice.title))]),_vm._v(" "),_c('span',{staticClass:"mb-2",staticStyle:{"cursor":"pointer"}},[_vm._v(_vm._s(notice.msg))])])})),_vm._v(" "),(_vm.notices.length > 0)?_c('a',{staticClass:"dropdown-item notify-item notify-all",on:{"click":function($event){_vm.delMsg()}}},[_c('span',{staticStyle:{"cursor":"pointer"}},[_vm._v(" Delete All Allerts ")])]):_vm._e()])]),_vm._v(" "),_c('li',{staticClass:"list-inline-item dropdown notif"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"dropdown-menu dropdown-menu-right profile-dropdown"},[_vm._m(2),_vm._v(" "),_c('router-link',{staticClass:"dropdown-item notify-item",attrs:{"to":{name: 'storehome', params:{storename: _vm.storeid}}}},[_c('i',{staticClass:"fa fa-building-o"}),_vm._v(" "),_c('span',[_vm._v("My Store")])]),_vm._v(" "),_c('router-link',{staticClass:"dropdown-item notify-item",attrs:{"to":"/"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" "),_c('span',[_vm._v("Home")])]),_vm._v(" "),_c('a',{staticClass:"dropdown-item notify-item",staticStyle:{"cursor":"pointer"},on:{"click":_vm.logout}},[_c('i',{staticClass:"fa fa-power-off"}),_vm._v(" "),_c('span',[_vm._v("Sign out")])])],1)])]),_vm._v(" "),_vm._m(3)])]),_vm._v(" "),_c('div',[(_vm.showLSB)?_c('div',{staticClass:"left main-sidebar",attrs:{"id":"sidebar"}},[_c('div',{staticClass:"sidebar-inner leftscroll"},[_c('div',{attrs:{"id":"sidebar-menu"}},[_c('ul',[_c('li',{staticClass:"submenu",on:{"click":function($event){_vm.hideLSB()}}},[_c('router-link',{attrs:{"to":{name: 'dashboard'}}},[_c('i',{staticClass:"fa fa-fw fa-th"}),_c('span',[_vm._v(" Dashboard ")])])],1),_vm._v(" "),_c('li',{staticClass:"submenu",on:{"click":function($event){_vm.hideLSB()}}},[_c('router-link',{attrs:{"to":{name: 'adminhome'}}},[_c('i',{staticClass:"fa fa-home",attrs:{"aria-hidden":"true"}}),_c('span',[_vm._v(" Home Page ")])])],1),_vm._v(" "),_c('li',{staticClass:"submenu",on:{"click":function($event){_vm.hideLSB()}}},[_c('router-link',{attrs:{"to":{name: 'admincontact'}}},[_c('i',{staticClass:"fa fa-fw fa-phone"}),_c('span',[_vm._v(" Contact Page ")])])],1),_vm._v(" "),_c('li',{staticClass:"submenu",on:{"click":function($event){_vm.hideLSB()}}},[_c('router-link',{attrs:{"to":{name: 'admingallery'}}},[_c('i',{staticClass:"fa fa-file-image-o",attrs:{"aria-hidden":"true"}}),_c('span',[_vm._v(" Gallery ")])])],1),_vm._v(" "),(_vm.plan != 'Starter')?_c('li',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.toggle()}}},[_vm._m(4)]):_vm._e(),_vm._v(" "),_vm._l((_vm.shopcats),function(values,key){return (_vm.toggleCat)?_c('li',{key:key,on:{"click":function($event){_vm.hideLSB()}}},[(key != 'Mobiles' && key != 'Tablets' && key != 'Desktops' && key != 'Laptops' && _vm.shopcategory == '')?_c('router-link',{staticClass:"subcat",staticStyle:{"font-size":"13px","padding-left":"35px"},attrs:{"to":{name: 'categories', params:{cat: key}}}},[_c('span',{staticStyle:{"color":"#f3b55a"}},[_vm._v(_vm._s(key))])]):_vm._e(),_vm._v(" "),(key == 'Mobiles' || key == 'Tablets' || key == 'Desktops' || key == 'Laptops')?_c('router-link',{staticClass:"subcat",staticStyle:{"font-size":"13px","padding-left":"20px"},attrs:{"to":{name: 'mobiles', params:{cat: key}}}},[_c('span',{staticStyle:{"color":"#f3b55a"}},[_vm._v(_vm._s(key))])]):_vm._e(),_vm._v(" "),(_vm.shopcategory == 'Vehicles')?_c('router-link',{staticClass:"subcat",staticStyle:{"font-size":"13px","padding-left":"20px"},attrs:{"to":{name: 'vehicles', params:{cat: key}}}},[_c('span',{staticStyle:{"color":"#f3b55a"}},[_vm._v(_vm._s(key))])]):_vm._e()],1):_vm._e()}),_vm._v(" "),_c('li',{staticClass:"submenu",on:{"click":function($event){_vm.hideLSB()}}},[_c('router-link',{attrs:{"to":{name: 'alloffers'}}},[_c('i',{staticClass:"fa fa-percent",attrs:{"aria-hidden":"true"}}),_c('span',[_vm._v(" Offers ")])])],1),_vm._v(" "),(_vm.plan == 'Premium' || _vm.plan ==  'Enterprise')?_c('li',{staticClass:"submenu",on:{"click":function($event){_vm.hideLSB()}}},[_c('router-link',{attrs:{"to":{name: 'orders'}}},[_c('i',{staticClass:"fa fa-truck",attrs:{"aria-hidden":"true"}}),_c('span',[_vm._v(" Orders ")])])],1):_vm._e(),_vm._v(" "),_c('li',{staticClass:"submenu",on:{"click":function($event){_vm.hideLSB()}}},[_c('router-link',{attrs:{"to":{name: 'customers'}}},[_c('i',{staticClass:"fa fa-users",attrs:{"aria-hidden":"true"}}),_c('span',[_vm._v(" Customers ")])])],1),_vm._v(" "),_c('li',{staticClass:"submenu",on:{"click":function($event){_vm.hideLSB()}}},[_c('router-link',{attrs:{"to":{name: 'storehome', params:{storename: _vm.storeid}}}},[_c('i',{staticClass:"fa fa-fw fa-building-o"}),_c('span',[_vm._v("View Store")])])],1),_vm._v(" "),_c('li',{staticClass:"submenu",on:{"click":function($event){_vm.hideLSB()}}},[_c('router-link',{attrs:{"to":{name:'myshopin'}}},[_c('i',{staticClass:"fa fa-fw fa-shopping-cart"}),_c('span',[_vm._v("MY SHOPiN")])])],1)],2),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"content-page"},[(_vm.show2)?_c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[(_vm.show)?_c('Dashboard'):_vm._e(),_vm._v(" "),_c('router-view',{key:_vm.$route.fullPath})],1)]):_vm._e()]),_vm._v(" "),_c('footer',{},[_c('AdminFooter')],1)],1)]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader"},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"nav-link dropdown-toggle nav-user",attrs:{"data-toggle":"dropdown","href":"#","role":"button","aria-haspopup":"false","aria-expanded":"false"}},[_c('i',{staticClass:" fa fa-user avatar-rounded"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropdown-item noti-title"},[_c('h5',{staticClass:"text-overflow"},[_c('small',[_vm._v("Profile")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"list-inline menu-left mb-0"},[_c('li',{staticClass:"float-left"},[_c('button',{staticClass:"button-menu-mobile open-left"},[_vm._v("\r\n\t\t\t\t\t\t\t\tAdmin\r\n                            ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"cat"},[_c('i',{staticClass:"fa fa-fw fa-cubes"}),_c('span',[_vm._v("Add Products ")]),_c('i',{staticClass:"fa fa-chevron-down",staticStyle:{"font-size":"14px"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Loading")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.loading1)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Adding")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.changed)?_c('div',{},[_c('b-modal',{staticClass:"text-center text-info",attrs:{"ok-only":"","centered":""},model:{value:(_vm.modalShow),callback:function ($$v) {_vm.modalShow=$$v},expression:"modalShow"}},[_vm._v("\n      Offer Added\n    ")]),_vm._v(" "),_c('b-modal',{staticClass:"text-center text-danger",attrs:{"ok-only":"","centered":""},model:{value:(_vm.modalShow2),callback:function ($$v) {_vm.modalShow2=$$v},expression:"modalShow2"}},[_vm._v("\n      You have added maximum offers. You can't add more offers.\n    ")]),_vm._v(" "),_c('div',{staticClass:"m-auto text-right pt-3"},[_c('router-link',{staticClass:"text-white",staticStyle:{"text-decoration":"none"},attrs:{"to":{ name: 'alloffers' }}},[_c('el-button',{attrs:{"type":"primary","size":"medium"}},[_c('i',{staticClass:"el-icon-view mr-2"}),_vm._v("View Offers")])],1)],1),_vm._v(" "),_c('h2',{staticClass:"m-auto text-info text-center pt-3 pb-1"},[_vm._v("Add offers")]),_vm._v(" "),_c('div',{staticClass:"file-upload col-12 col-md-6 pb-3",staticStyle:{"margin-top":"30px"}},[_c('div',{staticClass:"image-upload-wrap",staticStyle:{"height":"100px"}},[_c('input',{staticClass:"file-upload-input",attrs:{"type":"file","accept":".jpg, .jpeg"},on:{"change":_vm.fileSelect1}}),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"file-upload-content mx-auto text-center",style:({ display: _vm.visible1 })},[_c('img',{staticClass:"file-upload-image",attrs:{"src":_vm.imageUrl,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"image-title-wrap"})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 m-auto pt-3",staticStyle:{"margin-top":"15px"}},[_c('el-input',{staticClass:"input-with-select",attrs:{"placeholder":"Discount","type":"number","min":"0","max":"100"},model:{value:(_vm.dis),callback:function ($$v) {_vm.dis=$$v},expression:"dis"}},[_c('template',{attrs:{"slot":"append"},slot:"append"},[_c('i',{staticClass:"fa fa-percent"})])],2),_vm._v(" "),_c('el-input',{staticClass:"pt-3",attrs:{"type":"textarea","maxlength":"1000","autosize":{ minRows: 4, maxRows: 12 },"placeholder":"Description"},model:{value:(_vm.desc),callback:function ($$v) {_vm.desc=$$v},expression:"desc"}}),_vm._v(" "),_c('el-button',{staticClass:"mt-3 float-right",attrs:{"type":"primary"},on:{"click":function($event){_vm.addOffer()}}},[_vm._v("Add")])],1)],1):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"drag-text"},[_c('h6',{staticClass:"pt-3"},[_vm._v("Drag and drop or select Image")]),_vm._v(" "),_c('h6')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Items_vue__ = __webpack_require__(398);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fa4e7c8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Items_vue__ = __webpack_require__(790);
function injectStyle (ssrContext) {
  __webpack_require__(789)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2fa4e7c8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Items_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fa4e7c8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Items_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 789 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 790 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Loading")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.loading1)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Adding")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.changed)?_c('div',{},[_c('b-modal',{staticClass:"text-center text-info",attrs:{"ok-only":"","centered":""},model:{value:(_vm.modalShow),callback:function ($$v) {_vm.modalShow=$$v},expression:"modalShow"}},[_vm._v("\n      Product Added\n    ")]),_vm._v(" "),_c('b-modal',{staticClass:"text-center text-danger",attrs:{"ok-only":"","centered":""},model:{value:(_vm.modalShow2),callback:function ($$v) {_vm.modalShow2=$$v},expression:"modalShow2"}},[_vm._v("\n      You have added maximum products. You can't add more products.\n    ")]),_vm._v(" "),_c('div',{staticClass:"m-auto text-center pt-4"},[_c('router-link',{staticClass:"btn btn-primary text-white",attrs:{"to":{ name: 'allitems' }}},[_vm._v("VIEW PRODUCTS")])],1),_vm._v(" "),_c('h2',{staticClass:"m-auto text-info text-center pt-3 pb-1"},[_vm._v("Add products")]),_vm._v(" "),_c('div',{staticClass:"file-upload col-12 col-md-6 pb-3 mb-4",staticStyle:{"margin-top":"30px"}},[_c('div',{staticClass:"image-upload-wrap",staticStyle:{"height":"80px"}},[_c('input',{staticClass:"file-upload-input",attrs:{"type":"file","accept":".jpg, .jpeg"},on:{"change":_vm.fileSelect1}}),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"file-upload-content mx-auto text-center",style:({ display: _vm.visible1 })},[_c('img',{staticClass:"file-upload-image",attrs:{"src":_vm.imageUrl,"alt":"your image"}}),_vm._v(" "),_c('div',{staticClass:"image-title-wrap"})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12 col-lg-8 m-auto bg-white py-4",staticStyle:{"margin-top":"15px"}},[_c('el-form',{attrs:{"label-width":"200px","label-position":_vm.labelPosition,"size":"medium"}},[_c('el-form-item',{attrs:{"label":"Product Name","prop":"name"}},[_c('el-input',{staticStyle:{"width":"220px"},attrs:{"placeholder":"Product Name","clearable":""},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Price","prop":"price"}},[_c('el-input',{staticClass:"input-with-select",staticStyle:{"width":"220px"},attrs:{"placeholder":"Price","type":"number","min":"0","clearable":""},model:{value:(_vm.price),callback:function ($$v) {_vm.price=$$v},expression:"price"}},[_c('template',{attrs:{"slot":"prepend"},slot:"prepend"},[_vm._v("RS")])],2)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Item Type","prop":"type"}},[_c('el-select',{attrs:{"placeholder":"Item Type"},model:{value:(_vm.type),callback:function ($$v) {_vm.type=$$v},expression:"type"}},[_c('el-option',{attrs:{"value":"none"}},[_vm._v("None")]),_vm._v(" "),_c('el-option',{attrs:{"value":"latest"}},[_vm._v("Latest Item")]),_vm._v(" "),_c('el-option',{attrs:{"value":"bestselling"}},[_vm._v("Best Selling Item")])],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Product Details","prop":"desc"}},[_c('el-input',{attrs:{"type":"textarea","maxlength":"1000","autosize":{ minRows: 4, maxRows: 8 }},model:{value:(_vm.desc),callback:function ($$v) {_vm.desc=$$v},expression:"desc"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{staticClass:"mt-3 float-right",attrs:{"type":"primary"},on:{"click":function($event){_vm.addItem()}}},[_vm._v("Add")])],1)],1)],1)],1):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"drag-text"},[_c('h6',{staticClass:"pt-3"},[_vm._v("Drag and drop or select Image")]),_vm._v(" "),_c('h6')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AllOffers_vue__ = __webpack_require__(399);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e4eb1c96_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AllOffers_vue__ = __webpack_require__(793);
function injectStyle (ssrContext) {
  __webpack_require__(792)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e4eb1c96"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AllOffers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e4eb1c96_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AllOffers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 792 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Updating")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.loading1)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Loading")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.loading2)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Deleting")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.changed)?_c('div',[_c('div',{staticClass:"m-auto text-right pt-3"},[_c('router-link',{staticClass:"text-white",staticStyle:{"text-decoration":"none"},attrs:{"to":{ name: 'offers' }}},[_c('el-button',{attrs:{"type":"primary","size":"medium"}},[_c('i',{staticClass:"el-icon-plus mr-2"}),_vm._v("Add Offer")])],1)],1),_vm._v(" "),_c('b-container',{staticClass:"col-lg-10 mt-5"},[_c('h3',{staticClass:"text-info text-center pt-4 my-4"},[_vm._v("All Offers")]),_vm._v(" "),_c('b-table',{staticClass:"mt-4",attrs:{"show-empty":"","stacked":"sm","items":_vm.items,"fields":_vm.fields,"hover":true,"head-variant":"dark","current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter,"empty-text":_vm.emptyText,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event},"filtered":_vm.onFiltered},scopedSlots:_vm._u([{key:"index",fn:function(data){return [_vm._v("\n          "+_vm._s(data.index + 1)+"\n        ")]}},{key:"id",fn:function(row){return [_c('div',[_vm._v(_vm._s(row.value))])]}},{key:"actions",fn:function(row){return [_c('div',{staticClass:"btn-group",attrs:{"role":"group","aria-label":"Basic example"}},[_c('a',{staticClass:"btn btn-sm btn-info text-white",attrs:{"size":"sm"},on:{"click":function($event){$event.stopPropagation();row.toggleDetails($event)}}},[_vm._v("\n              View\n            ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-danger text-white",attrs:{"size":"sm"},on:{"click":function($event){_vm.open(row.item.id)}}},[_vm._v("\n              Delete\n            ")])])]}},{key:"row-details",fn:function(row){return [_c('b-card',[_c('ul',[_c('h5',{staticClass:"text-center text-info"},[_vm._v("Offer Details")]),_vm._v(" "),_c('div',{staticClass:"col-6 col-sm-4 col-lg-4"},[_c('img',{staticClass:"card-img-top",attrs:{"src":row.item.image,"alt":"image"}})]),_vm._v(" "),_c('li',{staticClass:"my-3 mr-2"},[_vm._v("\n                Discount: "),_c('span',{staticClass:"ml-2"},[_vm._v(_vm._s(row.item.dis))])]),_vm._v(" "),_c('li',{staticClass:"my-3 mr-2"},[_vm._v("\n                Description: "),_c('span',{staticClass:"ml-2"},[_vm._v(_vm._s(row.item.desc))])])])])]}}])}),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"md":"6"}},[_c('b-pagination',{staticClass:"my-0",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AllItems_vue__ = __webpack_require__(400);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60c6e8f7_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AllItems_vue__ = __webpack_require__(796);
function injectStyle (ssrContext) {
  __webpack_require__(795)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-60c6e8f7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AllItems_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60c6e8f7_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AllItems_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 795 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Updating")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.loading1)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Loading")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.loading2)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Deleting")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.changed)?_c('div',[_c('b-container',{staticClass:"col-lg-10 mt-5"},[_c('h3',{staticClass:"text-info text-center pt-4 my-4"},[_vm._v("All Products")]),_vm._v(" "),_c('b-table',{staticClass:"mt-4",attrs:{"show-empty":"","stacked":"sm","items":_vm.items,"fields":_vm.fields,"hover":true,"head-variant":"dark","current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter,"empty-text":_vm.emptyText,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event},"filtered":_vm.onFiltered},scopedSlots:_vm._u([{key:"index",fn:function(data){return [_vm._v("\r\n      "+_vm._s(data.index + 1)+"\r\n    ")]}},{key:"id",fn:function(row){return [_c('div',[_vm._v(_vm._s(row.value)+"\r\n           ")])]}},{key:"actions",fn:function(row){return [_c('div',{staticClass:"btn-group",attrs:{"role":"group","aria-label":"Basic example"}},[_c('a',{staticClass:"btn btn-sm btn-info text-white ",attrs:{"size":"sm"},on:{"click":function($event){$event.stopPropagation();row.toggleDetails($event)}}},[_vm._v("\r\n        View\r\n        ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-danger text-white ",attrs:{"size":"sm"},on:{"click":function($event){_vm.open(row.item.id)}}},[_vm._v("\r\n        Delete\r\n        ")])])]}},{key:"row-details",fn:function(row){return [_c('b-card',[_c('ul',[_c('h5',{staticClass:"text-center text-info"},[_vm._v("Product Details")]),_vm._v(" "),_c('div',{staticClass:"col-6 col-sm-4 col-lg-4"},[_c('img',{staticClass:"card-img-top",attrs:{"src":row.item.image,"alt":"image"}})]),_vm._v(" "),_c('li',{staticClass:"my-3 mr-2"},[_vm._v("Name: "),_c('span',{staticClass:"ml-2"},[_vm._v(_vm._s(row.item.name))])]),_vm._v(" "),_c('li',{staticClass:"my-3 mr-2"},[_vm._v("Price: "),_c('span',{staticClass:"ml-2"},[_vm._v(_vm._s(row.item.price))])])])])]}}])}),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"md":"6"}},[_c('b-pagination',{staticClass:"my-0",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Payment_vue__ = __webpack_require__(401);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11d7eada_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Payment_vue__ = __webpack_require__(799);
function injectStyle (ssrContext) {
  __webpack_require__(798)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-11d7eada"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Payment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11d7eada_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Payment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 798 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Loading")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.loading1)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Updating")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.fetch)?_c('div',{staticStyle:{"height":"300px"}},[_vm._m(0)]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mx-auto text-center pt-5"},[_c('h4',{staticClass:"text-info mb-2"},[_vm._v("You are still in the free trial period.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Orders_vue__ = __webpack_require__(402);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a47b9d12_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Orders_vue__ = __webpack_require__(802);
function injectStyle (ssrContext) {
  __webpack_require__(801)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a47b9d12"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Orders_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a47b9d12_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Orders_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 801 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Loading")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.loading1)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Updating")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.loading2)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Deleting")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.changed)?_c('div',{},[_c('b-container',{staticClass:"col-lg-10 mt-5"},[_c('h3',{staticClass:"text-info text-center pt-4 my-4"},[_vm._v("All Orders")]),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"my-1",attrs:{"sm":"5"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":""}},[_c('b-input-group',[_c('b-form-select',{attrs:{"options":_vm.sortOptions},model:{value:(_vm.sortBy),callback:function ($$v) {_vm.sortBy=$$v},expression:"sortBy"}},[_c('option',{attrs:{"slot":"first"},domProps:{"value":null},slot:"first"},[_vm._v("Sort By")])]),_vm._v(" "),_c('b-form-select',{attrs:{"slot":"append","disabled":!_vm.sortBy},slot:"append",model:{value:(_vm.sortDesc),callback:function ($$v) {_vm.sortDesc=$$v},expression:"sortDesc"}},[_c('option',{domProps:{"value":false}},[_vm._v("Asc")]),_vm._v(" "),_c('option',{domProps:{"value":true}},[_vm._v("Desc")])])],1)],1)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"sm":"3"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"horizontal":""}},[_c('b-form-select',{model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}},[_c('option',{attrs:{"disabled":""}},[_vm._v("per page")]),_vm._v(" "),_c('option',{domProps:{"value":10}},[_vm._v("10")]),_vm._v(" "),_c('option',{domProps:{"value":20}},[_vm._v("20")]),_vm._v(" "),_c('option',{domProps:{"value":40}},[_vm._v("40")])])],1)],1)],1),_vm._v(" "),_c('el-card',{staticStyle:{"overflow-x":"scroll"},attrs:{"shadow":"always"}},[_c('b-table',{staticClass:"mt-4",attrs:{"show-empty":"","stacked":"sm","items":_vm.items,"fields":_vm.fields,"hover":true,"head-variant":"dark","current-page":_vm.currentPage,"per-page":_vm.perPage,"empty-text":_vm.emptyText,"filter":_vm.filter,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event},"filtered":_vm.onFiltered},scopedSlots:_vm._u([{key:"index",fn:function(data){return [_vm._v("\n              "+_vm._s(data.index + 1)+"\n            ")]}},{key:"name",fn:function(row){return [_c('b-media',[_c('b-img',{attrs:{"slot":"aside","src":"https://lorempixel.com/125/125/technics/8/","width":"64","height":"64","alt":"image"},slot:"aside"}),_vm._v(" "),_c('h6',{staticClass:"mt-4"},[_vm._v(_vm._s(row.value))])],1)]}},{key:"category",fn:function(row){return [_c('div',{staticClass:"row mt-4"},[_vm._v(_vm._s(row.value))])]}},{key:"status",fn:function(row){return [_c('el-select',{staticStyle:{"width":"160px"},attrs:{"size":"mini","placeholder":"Order Status"},on:{"change":function($event){_vm.upOrder(row.item.id, row.item.status, row.item.refid)}},model:{value:(row.item.status),callback:function ($$v) {_vm.$set(row.item, "status", $$v)},expression:"row.item.status"}},_vm._l((_vm.options),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}))]}},{key:"actions",fn:function(row){return [_c('div',{staticClass:"btn-group",attrs:{"role":"group","aria-label":"Basic example"}},[_c('a',{staticClass:"btn btn-sm btn-info text-white",attrs:{"size":"sm"},on:{"click":function($event){$event.stopPropagation();row.toggleDetails($event)}}},[_vm._v("\n                  View\n                ")]),_vm._v(" "),(row.item.orderNo)?_c('router-link',{staticClass:"btn btn-sm btn-primary text-white",attrs:{"to":{
                    name: 'createinvoice',
                    query: { order: row.item.orderNo, },
                  }}},[_vm._v("\n                  Invoice\n                ")]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-secondary text-white",attrs:{"size":"sm"},on:{"click":function($event){_vm.$root.$emit('orderPrint', row.item)}}},[_vm._v("\n                  Print\n                ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-danger text-white",attrs:{"size":"sm"},on:{"click":function($event){_vm.open(row.item.id, row.item.status)}}},[_vm._v("\n                  Delete\n                ")])],1)]}},{key:"row-details",fn:function(row){return [_c('b-card',[_c('ul',[_c('h5',{staticClass:"text-center text-info"},[_vm._v("Customer Details")]),_vm._v(" "),_c('li',{staticClass:"my-1 mr-2"},[_vm._v("\n                    Customer Name:\n                    "),_c('span',{staticClass:"ml-2"},[_vm._v(_vm._s(row.item.cusname))])]),_vm._v(" "),_c('li',{staticClass:"my-1 mr-2"},[_vm._v("\n                    Email: "),_c('span',{staticClass:"ml-2"},[_vm._v(_vm._s(row.item.cusemail))])]),_vm._v(" "),_c('li',{staticClass:"my-1 mr-2"},[_vm._v("\n                    Telephone: "),_c('span',{staticClass:"ml-2"},[_vm._v("0"+_vm._s(row.item.telno))])]),_vm._v(" "),_c('li',{staticClass:"my-1 mr-2"},[_vm._v("\n                    Address: "),_c('span',{staticClass:"ml-2"},[_vm._v(_vm._s(row.item.address))])]),_vm._v(" "),_c('li',{staticClass:"my-1 mr-2"},[_vm._v("\n                    Cart Total Rs:\n                    "),_c('span',{staticClass:"ml-2"},[_vm._v(_vm._s(row.item.total))])])]),_vm._v(" "),_c('h5',{staticClass:"text-center text-info my-4"},[_vm._v("Ordeded Items")]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._l((row.item.products),function(item,key){return [_c('div',{key:key,staticClass:"col-12 col-sm-4 col-lg-3"},[_c('img',{staticClass:"card-img-top",attrs:{"src":item.image,"alt":"image"}}),_vm._v(" "),_c('ul',{staticClass:"list-group list-group-flush"},[_c('li',{staticClass:"list-group-item"},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('li',{staticClass:"list-group-item"},[_c('span',[_vm._v("Rs")]),_vm._v(" "+_vm._s(item.price)+"\n                        ")]),_vm._v(" "),_c('li',{staticClass:"list-group-item"},[_c('span',[_vm._v("Quantity")]),_vm._v(" "+_vm._s(item.quantity)+"\n                        ")]),_vm._v(" "),_c('li',{staticClass:"list-group-item"},[_c('span',[_vm._v("Total Rs")]),_vm._v(" "+_vm._s(item.subTotal)+"\n                        ")])])])]})],2)])]}}])})],1),_vm._v(" "),_c('OrderPrint',{staticStyle:{"display":"none"}}),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"md":"6"}},[_c('b-pagination',{staticClass:"my-0",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Gallery_vue__ = __webpack_require__(403);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_000e2f35_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Gallery_vue__ = __webpack_require__(805);
function injectStyle (ssrContext) {
  __webpack_require__(804)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-000e2f35"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Gallery_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_000e2f35_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Gallery_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 804 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Loading")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.loading1)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Uploading")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.changed)?_c('div',{},[_c('b-modal',{staticClass:"text-center text-info",attrs:{"ok-only":"","centered":"","centered":""},model:{value:(_vm.modalShow),callback:function ($$v) {_vm.modalShow=$$v},expression:"modalShow"}},[_vm._v("\n      Image Uploaded\n    ")]),_vm._v(" "),_c('b-modal',{staticClass:"text-center text-danger",attrs:{"ok-only":"","centered":"","centered":""},model:{value:(_vm.modalShow2),callback:function ($$v) {_vm.modalShow2=$$v},expression:"modalShow2"}},[_vm._v("\n      You have added maximum imagess. You can't add more images.\n    ")]),_vm._v(" "),_c('h2',{staticClass:"m-auto text-info text-center pt-3 pb-1"},[_vm._v("Add images")]),_vm._v(" "),_c('div',{staticClass:"file-upload col-12 col-md-6 pb-3",staticStyle:{"margin-top":"30px"}},[_c('div',{staticClass:"image-upload-wrap",staticStyle:{"height":"80px"}},[_c('input',{staticClass:"file-upload-input",attrs:{"type":"file","accept":".jpg, .jpeg"},on:{"change":_vm.fileSelect1}}),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"file-upload-content mx-auto text-center",style:({ display: _vm.visible1 })},[_c('img',{staticClass:"file-upload-image",attrs:{"src":_vm.imageUrl,"alt":""}}),_vm._v(" "),_c('el-button',{staticClass:"mt-3 mx-auto text-center",attrs:{"type":"primary"},on:{"click":function($event){_vm.Upload()}}},[_vm._v("Upload Image")])],1)]),_vm._v(" "),_c('h2',{staticClass:"m-auto text-info text-center pt-3 pb-3"},[_vm._v("Shop Image Gallery")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"product-grid-list"},[_c('div',{staticClass:"row mt-30 justify-content-around"},[_vm._l((_vm.shops[0].gallery),function(img,i){return [_c('div',{key:i,staticClass:"col-12 col-sm-6 col-md-4 col-lg-3"},[_c('div',{staticClass:"product-item bg-light"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"block2-pic hov-img0"},[_c('img',{attrs:{"src":img,"alt":""}})]),_vm._v(" "),_c('a',{staticClass:"btn btn-danger text-white",on:{"click":function($event){_vm.open(i)}}},[_vm._v("Delete Image")])])])])]})],2)])])])],1):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"drag-text"},[_c('h6',{staticClass:"pt-3"},[_vm._v("Drag and drop or select Image")]),_vm._v(" "),_c('h6')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyShopin_vue__ = __webpack_require__(404);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d7ea316_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyShopin_vue__ = __webpack_require__(808);
function injectStyle (ssrContext) {
  __webpack_require__(807)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3d7ea316"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyShopin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d7ea316_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyShopin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 807 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Updating")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.loading1)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Loading")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.fetch)?_c('div',[_c('section',{staticClass:"section-sm",staticStyle:{"padding-top":"15px"}},[_c('div',{staticClass:"container"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"product-grid-list"},[_c('div',{staticClass:"row mt-30 justify-content-around"},[(_vm.noresults)?_c('div',{staticClass:"mt-3 mb-2 text-center text-danger h4"},[_vm._v("You Haven't Added Any Favourite Shops Yet  ")]):_vm._e(),_vm._v(" "),(_vm.nofavshops)?_c('div',{staticClass:"mt-3 mb-2 text-center text-danger h4"},[_vm._v("You Haven't Any Favourite Shops")]):_vm._e(),_vm._v(" "),_vm._l((_vm.shops),function(shop,i){return [_c('div',{key:shop.id,staticClass:" col-12 col-sm-6 col-md-6 col-lg-4 "},[_c('div',{staticClass:"product-item bg-light"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"block2-pic hov-img0"},[(shop.isHosted != true && shop.isCloned != true)?_c('router-link',{attrs:{"to":{name: 'storehome', params: {storename: shop.owner}}}},[_c('img',{attrs:{"src":shop.homeimg,"alt":"IMG-SHOP"}})]):_vm._e(),_vm._v(" "),(shop.isCloned == true)?_c('router-link',{attrs:{"to":{name: 'storehome', params: {storename: shop.realOwner}}}},[_c('img',{attrs:{"src":shop.homeimg,"alt":"IMG-SHOP"}})]):_vm._e(),_vm._v(" "),(shop.isHosted == true)?_c('a',{attrs:{"target":"blank","href":shop.domain}},[_c('img',{attrs:{"src":shop.homeimg,"alt":"IMG-SHOP"}})]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('span',{staticClass:"float-right"},[_c('i',{staticClass:"fa fa-trash fa-lg text-danger",staticStyle:{"cursor":"pointer","font-size":"20px"},on:{"click":function($event){_vm.delFavShop(shop)}}})]),_vm._v(" "),_vm._m(1,true),_vm._v(" "),(shop.isHosted != true && shop.isCloned != true)?_c('span',{staticClass:"card-title"},[_c('router-link',{staticClass:"text-primary",attrs:{"to":{name: 'storehome', params: {storename: shop.owner}}}},[_vm._v(_vm._s(shop.name))])],1):_vm._e(),_vm._v(" "),(shop.isCloned == true)?_c('span',{staticClass:"card-title"},[_c('router-link',{staticClass:"text-primary",attrs:{"to":{name: 'storehome', params: {storename: shop.realOwner}}}},[_vm._v(_vm._s(shop.name))])],1):_vm._e(),_vm._v(" "),(shop.isHosted == true)?_c('span',{staticClass:"card-title"},[_c('a',{staticClass:"text-primary",attrs:{"href":shop.domain,"target":"blank"}},[_vm._v(_vm._s(shop.name))])]):_vm._e(),_vm._v(" "),(shop.plan == 'Premium' || shop.plan == 'Enterprise')?_c('ul',{staticClass:"list-inline product-meta mb-1 mt-2"},[_vm._m(2,true)]):_vm._e(),_vm._v(" "),_c('ul',{staticClass:"list-inline product-meta mb-1"},[_c('li',{staticClass:"list-inline-item mr-2"},[_c('a',{},[_c('i',{staticClass:"fa fa-map-marker",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(shop.location))])])]),_vm._v(" "),_c('ul',{staticClass:"list-inline product-meta mb-1"},[_c('li',{staticClass:"list-inline-item "},[_c('a',{},[_c('i',{staticClass:"fa fa-tag",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(shop.category))])])]),_vm._v(" "),(shop.shoptype != '')?_c('ul',{staticClass:"list-inline product-meta mb-1"},[_c('li',{staticClass:"list-inline-item "},[_c('a',{},[_c('i',{staticClass:"fa fa-tag",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(shop.shoptype))])])]):_vm._e(),_vm._v(" "),(shop.details.etime && shop.details.stime)?_c('ul',{staticClass:"list-inline product-meta mb-1"},[_c('li',{staticClass:"list-inline-item mr-2"},[_c('a',{},[_c('i',{staticClass:"fa fa-clock-o",attrs:{"aria-hidden":"true"}}),_vm._v("Open - Close  "+_vm._s(shop.details.stime)+" AM  - "+_vm._s(shop.details.etime)+" PM ")])])]):_vm._e(),_vm._v(" "),(shop.details.tel1)?_c('ul',{staticClass:"list-inline product-meta mb-1"},[_c('li',{staticClass:"list-inline-item"},[_c('a',[_c('i',{staticClass:"fa fa-phone-square",attrs:{"aria-hidden":"true"}}),_vm._v("+94 "+_vm._s(shop.details.tel1))])])]):_vm._e(),_vm._v(" "),(shop.details.address)?_c('ul',{staticClass:"list-inline product-meta mb-2"},[_c('li',{staticClass:"list-inline-item"},[_c('a',[_c('i',{staticClass:"fa fa-address-card ",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(shop.details.address))])])]):_vm._e()])])])])]})],2)])])])])])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row mb-4"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"search-result bg-gray text-center"},[_c('h2',{staticStyle:{"letter-spacing":"-2px"}},[_c('span',{staticClass:"text-secondary"},[_vm._v("My")]),_vm._v(" "),_c('span',{staticStyle:{"color":"orange","letter-spacing":"-5px"}},[_vm._v("S")]),_vm._v(" "),_c('span',{staticStyle:{"color":"red","letter-spacing":"-5px"}},[_vm._v("H")]),_vm._v(" "),_c('span',{staticStyle:{"color":"blue","letter-spacing":"-5px"}},[_vm._v("O")]),_vm._v(" "),_c('span',{staticStyle:{"color":"green","letter-spacing":"-5px"}},[_vm._v("P")]),_vm._v(" "),_c('span',{staticStyle:{"color":"purple","letter-spacing":"-5px"}},[_vm._v("i")]),_vm._v(" "),_c('span',{staticStyle:{"color":"purple","letter-spacing":"-5px"}},[_vm._v("N")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"float-right mr-3"},[_c('i',{staticClass:"fa fa-heart-o text-danger",staticStyle:{"font-size":"18px"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"list-inline-item mr-2"},[_c('a',{staticStyle:{"color":"red"}},[_c('i',{staticClass:"fa fa-home",attrs:{"aria-hidden":"true"}}),_vm._v("Home Deliver")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Customers_vue__ = __webpack_require__(405);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ad61a4ca_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Customers_vue__ = __webpack_require__(811);
function injectStyle (ssrContext) {
  __webpack_require__(810)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ad61a4ca"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Customers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ad61a4ca_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Customers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 810 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Updating")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.loading1)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Loading")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.loading2)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Deleting")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.changed)?_c('div',[_c('div',{staticClass:"m-auto text-right pt-3"},[_c('el-button',{attrs:{"type":"primary","size":"medium"},on:{"click":function($event){_vm.dialogFormVisible2 = true}}},[_c('i',{staticClass:"el-icon-plus mr-2"}),_vm._v("Add Customer")])],1),_vm._v(" "),_c('div',{staticClass:"col-sm-12 col-md-8 col-lg-6 m-auto pl-4"},[_c('el-dialog',{attrs:{"title":"Add Customer","visible":_vm.dialogFormVisible2,"width":_vm.width},on:{"update:visible":function($event){_vm.dialogFormVisible2=$event}}},[_c('el-card',{staticStyle:{"background-color":"#f5f7fa"},attrs:{"shadow":"always"}},[_c('el-form',{ref:"formdata",staticStyle:{"<!-- border":"1px solid #e2e2e2","border-radius":"5px","-->\n              background-color":"#fff","padding":"25px"},attrs:{"model":_vm.formdata,"status-icon":"","rules":_vm.rules2,"label-width":"120px","label-position":_vm.labelPosition,"size":"medium"}},[_c('el-form-item',{attrs:{"label":"Name","prop":"name","rules":[
                { required: true, message: 'Customer name', trigger: 'blur' } ]}},[_c('el-input',{attrs:{"placeholder":"Name"},model:{value:(_vm.formdata.name),callback:function ($$v) {_vm.$set(_vm.formdata, "name", $$v)},expression:"formdata.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Telephone Without 0","prop":"telephone","rules":[
                { required: true, message: 'telephone no is required' },
                { type: 'number', message: 'telephone no must be a number' } ]}},[_c('el-input',{attrs:{"auto-complete":"off","placeholder":"Telephone"},on:{"change":function($event){_vm.checkTelephone(_vm.formdata, 'create')}},model:{value:(_vm.formdata.telephone),callback:function ($$v) {_vm.$set(_vm.formdata, "telephone", _vm._n($$v))},expression:"formdata.telephone"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"City/Town","prop":"city"}},[_c('el-input',{attrs:{"placeholder":"City/Town"},model:{value:(_vm.formdata.city),callback:function ($$v) {_vm.$set(_vm.formdata, "city", $$v)},expression:"formdata.city"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"email","label":"Email","rules":[
                {
                  type: 'email',
                  message: 'Please input correct email address',
                  trigger: ['blur', 'change'],
                } ]}},[_c('el-input',{attrs:{"placeholder":"Email","type":"email"},model:{value:(_vm.formdata.email),callback:function ($$v) {_vm.$set(_vm.formdata, "email", $$v)},expression:"formdata.email"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Notes","prop":"note"}},[_c('el-input',{attrs:{"type":"textarea"},model:{value:(_vm.formdata.note),callback:function ($$v) {_vm.$set(_vm.formdata, "note", $$v)},expression:"formdata.note"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"pt-2",staticStyle:{"margin-bottom":"0px"}},[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.submitForm('formdata')}}},[_vm._v("Add")]),_vm._v(" "),_c('el-button',{on:{"click":function($event){_vm.resetForm('formdata')}}},[_vm._v("Reset")])],1)],1)],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"danger"},on:{"click":function($event){_vm.dialogFormVisible2 = false}}},[_vm._v("Cancel")])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"col-sm-12 col-md-8 col-lg-6 m-auto pl-4"},[_c('el-dialog',{attrs:{"title":"Edit Customer","visible":_vm.dialogFormVisible3,"width":_vm.width},on:{"update:visible":function($event){_vm.dialogFormVisible3=$event}}},[_c('el-form',{ref:"formdata2",staticStyle:{"border":"1px solid #e2e2e2","border-radius":"5px","background-color":"#fff","padding":"25px"},attrs:{"model":_vm.formdata2,"status-icon":"","rules":_vm.rules2,"label-width":"120px","label-position":_vm.labelPosition,"size":"medium"}},[_c('el-form-item',{attrs:{"label":"Name","prop":"name","rules":[
              { required: true, message: 'Customer name', trigger: 'blur' } ]}},[_c('el-input',{attrs:{"placeholder":"Name"},model:{value:(_vm.formdata2.name),callback:function ($$v) {_vm.$set(_vm.formdata2, "name", $$v)},expression:"formdata2.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Telephone Without 0","prop":"telephone","rules":[
              { required: true, message: 'telephone no is required' },
              { type: 'number', message: 'telephone no must be a number' } ]}},[_c('el-input',{attrs:{"auto-complete":"off","placeholder":"Telephone"},on:{"change":function($event){_vm.checkTelephone(_vm.formdata2, 'update')}},model:{value:(_vm.formdata2.telephone),callback:function ($$v) {_vm.$set(_vm.formdata2, "telephone", _vm._n($$v))},expression:"formdata2.telephone"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"City/Town","prop":"city"}},[_c('el-input',{attrs:{"placeholder":"City/Town"},model:{value:(_vm.formdata2.city),callback:function ($$v) {_vm.$set(_vm.formdata2, "city", $$v)},expression:"formdata2.city"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"email","label":"Email","rules":[
              {
                type: 'email',
                message: 'Please input correct email address',
                trigger: ['blur', 'change'],
              } ]}},[_c('el-input',{attrs:{"placeholder":"Email","type":"email"},model:{value:(_vm.formdata2.email),callback:function ($$v) {_vm.$set(_vm.formdata2, "email", $$v)},expression:"formdata2.email"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Notes","prop":"note"}},[_c('el-input',{attrs:{"type":"textarea"},model:{value:(_vm.formdata2.note),callback:function ($$v) {_vm.$set(_vm.formdata2, "note", $$v)},expression:"formdata2.note"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"pt-2",staticStyle:{"margin-bottom":"0px"}},[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.update('formdata2')}}},[_vm._v("Update")])],1)],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"danger"},on:{"click":function($event){_vm.dialogFormVisible3 = false}}},[_vm._v("Cancel")])],1)],1)],1),_vm._v(" "),_c('b-container',{staticClass:"col-lg-10 mt-1"},[_c('h3',{staticClass:"text-info text-center my-4"},[_vm._v("Customers")]),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"my-1",attrs:{"sm":"4"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":""}},[_c('b-input-group',[_c('b-form-input',{attrs:{"placeholder":"Search"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),_c('b-input-group-append',[_c('b-btn',{attrs:{"disabled":!_vm.filter},on:{"click":function($event){_vm.filter = ''}}},[_vm._v("Clear")])],1)],1)],1)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"sm":"5"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":""}},[_c('b-input-group',[_c('b-form-select',{attrs:{"options":_vm.sortOptions},model:{value:(_vm.sortBy),callback:function ($$v) {_vm.sortBy=$$v},expression:"sortBy"}},[_c('option',{attrs:{"slot":"first"},domProps:{"value":null},slot:"first"},[_vm._v("Sort By")])]),_vm._v(" "),_c('b-form-select',{attrs:{"slot":"append","disabled":!_vm.sortBy},slot:"append",model:{value:(_vm.sortDesc),callback:function ($$v) {_vm.sortDesc=$$v},expression:"sortDesc"}},[_c('option',{domProps:{"value":false}},[_vm._v("Asc")]),_vm._v(" "),_c('option',{domProps:{"value":true}},[_vm._v("Desc")])])],1)],1)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"sm":"3"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"horizontal":""}},[_c('b-form-select',{model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}},[_c('option',{attrs:{"disabled":""}},[_vm._v("per page")]),_vm._v(" "),_c('option',{domProps:{"value":10}},[_vm._v("10")]),_vm._v(" "),_c('option',{domProps:{"value":25}},[_vm._v("25")]),_vm._v(" "),_c('option',{domProps:{"value":50}},[_vm._v("50")])])],1)],1)],1),_vm._v(" "),_c('el-card',{staticStyle:{"overflow-x":"scroll"},attrs:{"shadow":"always"}},[_c('b-table',{staticClass:"mt-4",attrs:{"show-empty":"","stacked":"sm","items":_vm.items,"fields":_vm.fields,"hover":true,"head-variant":"dark","dark":false,"small":true,"current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter,"empty-text":_vm.emptyText,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event},"filtered":_vm.onFiltered},scopedSlots:_vm._u([{key:"id",fn:function(row){return [_c('div',[_vm._v(_vm._s(row.value))])]}},{key:"actions",fn:function(row){return [_c('div',{staticClass:"btn-group",attrs:{"role":"group","aria-label":"Basic example"}},[_c('a',{staticClass:"btn btn-sm btn-primary text-white",attrs:{"size":"sm"},on:{"click":function($event){_vm.showUpdate(row.item)}}},[_vm._v("\n                Edit\n              ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-success text-white",attrs:{"href":("tel:" + (row.item.telephone)),"size":"sm"}},[_vm._v("\n                Call\n              ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-secondary text-white",attrs:{"href":("sms:" + (row.item.telephone)),"size":"sm"}},[_vm._v("\n                SMS\n              ")])])]}},{key:"row-details",fn:function(row){return [_c('div',{staticClass:"mx-auto"},[_c('el-button',{staticClass:"mt-1 d-block mx-auto",attrs:{"type":"info","size":"small"},on:{"click":function($event){_vm.showUpdate(row.item)}}},[_vm._v("Edit Details")])],1)]}}])})],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"md":"6"}},[_c('b-pagination',{staticClass:"my-0",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminHome_vue__ = __webpack_require__(406);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0558b62e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminHome_vue__ = __webpack_require__(815);
function injectStyle (ssrContext) {
  __webpack_require__(813)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0558b62e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminHome_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0558b62e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminHome_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 813 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 814 */,
/* 815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-modal',{staticClass:"text-center text-info",attrs:{"ok-only":"","centered":"","centered":""},model:{value:(_vm.modalShow1),callback:function ($$v) {_vm.modalShow1=$$v},expression:"modalShow1"}},[_vm._v("\r\n      Image Uploaded \r\n    ")]),_vm._v(" "),_c('b-modal',{staticClass:"text-center text-info",attrs:{"ok-only":"","centered":"","centered":""},model:{value:(_vm.modalShow2),callback:function ($$v) {_vm.modalShow2=$$v},expression:"modalShow2"}},[_vm._v("\r\n      Color Updated \r\n    ")]),_vm._v(" "),(_vm.loading)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Updating")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.loading1)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Loading")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.fetch)?_c('div',[_c('h2',{staticClass:"m-auto text-info text-center pt-5 pb-4"},[_vm._v("Add a banner image")]),_vm._v(" "),_c('div',{staticClass:"file-upload col-12 col-sm-8 col-md-6"},[_c('div',{staticClass:"image-upload-wrap",staticStyle:{"height":"100px"}},[_c('input',{staticClass:"file-upload-input",attrs:{"type":"file","accept":".jpg, .jpeg"},on:{"change":_vm.fileSelect1}}),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"file-upload-content mx-auto text-center",style:({display: _vm.visible1})},[_c('img',{staticClass:"file-upload-image",attrs:{"src":_vm.image,"alt":"your image"}}),_vm._v(" "),_c('div',{staticClass:" "},[_c('el-button',{staticClass:"mt-3 mx-auto text-center",attrs:{"type":"primary"},on:{"click":function($event){_vm.Upload()}}},[_vm._v("Upload Image")])],1)]),_vm._v(" "),_c('div',{staticClass:"mx-auto text-center"},[_c('el-button',{staticClass:"mt-4 ",attrs:{"type":"danger"},on:{"click":function($event){_vm.goback()}}},[_vm._v("Go Back")])],1)])]):_vm._e(),_vm._v(" "),(_vm.changed)?_c('div',[_c('h2',{staticClass:"m-auto text-info text-center pt-5 pb-4"},[_vm._v("Banner Image")]),_vm._v(" "),_c('div',{staticClass:" col-12 col-sm-8 col-md-6 mx-auto"},[(_vm.homeimg != undefined)?_c('img',{staticClass:"bnr-img",attrs:{"src":_vm.homeimg,"alt":"banner-image"}}):_vm._e(),_vm._v(" "),(_vm.homeimg == undefined)?_c('img',{staticClass:"bnr-img",attrs:{"src":__webpack_require__(816),"alt":"banner-image"}}):_vm._e(),_vm._v(" "),_c('el-button',{staticClass:"mt-3",attrs:{"type":"primary"},on:{"click":function($event){_vm.changeimg()}}},[_vm._v("Change Image")]),_vm._v(" "),_c('h3',{staticClass:"m-auto text-info text-center pt-5 pb-4"},[_vm._v("Change Text Color On Home Image")]),_vm._v(" "),_c('div',{staticClass:" col-12 col-sm-8 col-md-6 mx-auto"},[_c('div',[_c('ColorPicker',{attrs:{"width":240,"height":240,"disabled":false,"startColor":"#ffffff"},model:{value:(_vm.color1),callback:function ($$v) {_vm.color1=$$v},expression:"color1"}})],1),_vm._v(" "),_c('el-button',{staticClass:"mt-3",attrs:{"type":"primary"},on:{"click":function($event){_vm.changecolor()}}},[_vm._v("Change Color")])],1)],1)]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"drag-text"},[_c('h6',{staticClass:"pt-3"},[_vm._v("Drag and drop or select Image")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 816 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminAbout_vue__ = __webpack_require__(407);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a0b92f8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminAbout_vue__ = __webpack_require__(819);
function injectStyle (ssrContext) {
  __webpack_require__(818)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1a0b92f8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminAbout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a0b92f8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminAbout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 818 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-modal',{staticClass:"text-center text-info",attrs:{"ok-only":"","centered":"","centered":""},model:{value:(_vm.modalShow1),callback:function ($$v) {_vm.modalShow1=$$v},expression:"modalShow1"}},[_vm._v("\r\n      Image Uploaded \r\n    ")]),_vm._v(" "),_c('b-modal',{staticClass:"text-center text-info",attrs:{"ok-only":"","centered":"","centered":""},model:{value:(_vm.modalShow2),callback:function ($$v) {_vm.modalShow2=$$v},expression:"modalShow2"}},[_vm._v("\r\n      About Us Updated\r\n    ")]),_vm._v(" "),(_vm.loading)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Updating")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.loading1)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Loading")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.fetch)?_c('div',[_c('h2',{staticClass:"m-auto text-info text-center pt-5 pb-4"},[_vm._v("Add Your Team Image")]),_vm._v(" "),_c('div',{staticClass:"file-upload col-12 col-sm-8 col-md-6"},[_c('div',{staticClass:"image-upload-wrap",staticStyle:{"height":"100px"}},[_c('input',{staticClass:"file-upload-input",attrs:{"type":"file","accept":".jpg, .jpeg"},on:{"change":_vm.fileSelect1}}),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"file-upload-content mx-auto text-center",style:({display: _vm.visible1})},[_c('img',{staticClass:"file-upload-image",attrs:{"src":_vm.image,"alt":"your image"}}),_vm._v(" "),_c('div',{staticClass:" "},[_c('el-button',{staticClass:"mt-3 mx-auto text-center",attrs:{"type":"primary"},on:{"click":function($event){_vm.Upload()}}},[_vm._v("Upload Image")])],1)]),_vm._v(" "),_c('div',{staticClass:"mx-auto text-center"},[_c('el-button',{staticClass:"mt-4 ",attrs:{"type":"danger"},on:{"click":function($event){_vm.goback()}}},[_vm._v("Go Back")])],1)])]):_vm._e(),_vm._v(" "),(_vm.changed)?_c('div',[_c('div',{staticClass:"container mt-5"},[_c('div',{staticClass:"col-sm-12 col-md-6 m-auto"},[_c('h2',{staticClass:"m-auto text-info text-center pt-4 pb-4"},[_vm._v("About Us")]),_vm._v(" "),_c('el-input',{attrs:{"type":"textarea","maxlength":"6000","autosize":{ minRows: 4, maxRows: 16},"placeholder":"Please input"},model:{value:(_vm.aboutUs),callback:function ($$v) {_vm.aboutUs=$$v},expression:"aboutUs"}}),_vm._v(" "),_c('el-button',{staticClass:"mt-3",attrs:{"type":"primary"},on:{"click":function($event){_vm.upAbout()}}},[_vm._v("Update")])],1)]),_vm._v(" "),_c('h2',{staticClass:"m-auto text-info text-center pt-5 pb-4"},[_vm._v("Your Team Image")]),_vm._v(" "),_c('div',{staticClass:" col-12 col-sm-8 col-md-6 mx-auto"},[(_vm.aboutimg != undefined)?_c('img',{staticClass:"bnr-img",attrs:{"src":_vm.aboutimg,"alt":"banner-image"}}):_vm._e(),_vm._v(" "),(_vm.aboutimg == undefined)?_c('img',{staticClass:"bnr-img",attrs:{"src":__webpack_require__(820),"alt":"banner-image"}}):_vm._e(),_vm._v(" "),_c('el-button',{staticClass:"mt-3",attrs:{"type":"primary"},on:{"click":function($event){_vm.changeimg()}}},[_vm._v("Change Image")])],1)]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"drag-text"},[_c('h6',{staticClass:"pt-3"},[_vm._v("Drag and drop or select Image")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 820 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,iVBORw0KGgoAAAANSUhEUgAAAzQAAAHhBAMAAABKMObxAAAAG1BMVEXMzMyWlpbFxcW3t7eqqqqjo6OcnJy+vr6xsbFw65JxAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAKBklEQVR4nO3dSZPbxhmHcQhcj4Y8w+RISvE4R1El6TyM7dLVyCL7KLhi2UfTldg+kq6U/bXD3t+3u7nMyFVJeZ7fRRwMBqjqP3oFCDUNAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADA/7Wnnw2Lvz/X29r/vOm+/mSZ7fnTYePr9zhT23Wd+vlF7SxNM+u6D97jNL8b/+6sL+S2Pw922/Uztecru/Hb+59qoqOZ9e4s3+X7zYnG+FPn/TVtm4dtqtRu/MZv7n2utYqm3YSzLLP9JkRzMBtCDF2MoU3b/pj2HMWNz2oHusSgovkhHvAP2X6PiOZgG8un+zBsu0nbul3cc13ueEe2MsafZuIsWdhronEdc15tRKUR1WZW7nhXKxXNShwwqzY90biOOfqqsi3GcFPueFe9iqYXB1ws5X7mKiCavSmY18snL82/V26bbbm+/L592ssYTJ+9+PXJT0Pa8Y5cZxV+sq3bVTjLrdxxQjQHplj+Yj7YPnlpPtk2zo7C7ODWt2izsOf83i3aVEXzyCRjTmgHIo/ljnuiceXsy74P1+48NTDjVJaTuOc+v8gvtVfRmJ928dCyHtrwH3w05kL+PH38IHwIrZjJy42eVjGQcX6RX8iPOMKPh7pynT6KMbWbiD74aFahFXMtlh0obbs0mDV9/1v76dDVLPzGQU13LjZR0bQi4K1oIj9+4caHDz6adbp0TQ2xJb4R20axALs0nVmnlO54rj5FM0r11Ya2s5/SuP3BR7MR88e9j2SQc8qQyChWH9fi3WNB4HDcVYpmLA4yjzGlydODj6YXs72tqwyypbHZ2ao07tLCwPxe44DDX109StFMRCM2i7kTTTSIGFYumploaVKLN02dkijJuzgc/isRjTxgSzSlQZSBLzddJ7Y+mpXsX4ZsiDbrsipw3ZQOFfRZFk38XYyCaCJZBr70ZSeQItnLUdkmX+Hssz49X0lubGe1aEQ04iO1pqYrGzTZCaQS7GUa63ypZiXi2NZ7oqnZI4tm6T+naNpPLaKxTVO8wn23MhFllqJRbdgqHz2POz1/XDaFjQksa9DCFSAH0hbRpLmMsXF1YaqKNgx3VWHJxsiyE33XCppirkxIW3vUbIS285/HeUUjGjXHD5N81T+HCtKq63pSVIx9bJKm9eHbxB5cRDPOJko7uTfRuPV/3+fPfX8xfffuXdphm0bUt3HjuMvXnqdhampDqsxH1zYIEc2oS73XPj8e0biy8n3Iqnq5+w5orq7reVH8pqBt9TMrLZVVHLP5O90SdrHqtV3+N0QjbwDY1avycu9dB6RH1KO8AXLD512T6l5m7BKW0Ziq4ha4b7p8ME40PhB72+xVdaY486U2KaK51TtuffVb5YOt+GvzWxmNCWRhmrHRUPwN0TT+gZq/LVt7A7q8CzPxW/VkZ1aW/9gPzDb1oXPv6pSMxs4ur5837ga0/huiaeTDZUXXbux9CHpM1pbRtK58zT+VBwdGvjNRo+61OHPWBhKNkZ7TqzwnMwqBTc9F429Lj6uHMY2X7UxUNOLhRP1ADdE48enW2prkvqssPMuFlWRqm75tfei88VHquWp8pLfImWisfbx0i/ZsHNua89GMbFPWV4fOs9BY6mjik9XFU9REY4gGLV9fcXeDbSXIlmZqRWd2/rHsNoxJ6ICONWj5UJxommwYcKt/Z/vpSpnWi860ZW8qjZM70OPyMHIYkA0diKYRzVlZQGMR1wXRhMdxl8U5TO3bFYeZyzNnVwXR+PJZvF629nlZ1a649sandUE0bfX6N8axA8pXA7p/ft98/EvZmBKNn3HuzCc7J5f9xF5ezeeHAW62WX14cBsPLKKZpUDsl91Y3syYPPw8xC6cpN98ZAs6LG1dEs2q1qEbfUw4u5XmpzN2uKGORzRuwXjpPuv1TTc8iOPpS6JxjWP9JP5vRTTrdFGU65tEY0tcPocWh1dtb6OJX+88u1BjDHkJOzepJxHRDN2Jh3CIRjxj3ujHzH9QzdkFy5vGpt7VbFIVS9HoxbZ8UZRobKuyDD+0KQzXnIkvJpf3a26Lg7XlSMsSf5qiGXXZcyBqfYdo1JPn8bZZE0Znu/QrfV9T3/MM3DxoWWzvCtduZ/2wwa3+k4ceTa8u8/A8up8NivcIZPc1yxvQxlaOtoVqNJPigJ/rP3no0QxqKrMNA6x10TSde2zDcCOHcgmtGs20yzuvt/pPiEb22+GZMzsb1LdQzj3s1MTVuPLWwtFo0iHaLAuiyYogRHOTN2f5nsUjgsbUl3vR0lWj0YcgmoIuglBcm7w5a849WGuYVnDdVeaiF0STZ0E0WYP2KD0OWFz7m5OPozduMeHKdELFpPOCBq2hr8kVfU14Hr2YnqxPfomjcYOsx23RSWmprpx+2IBo1PcF49ecDv+UQ+DVqa8++R0Of2Xawt3x86VoTi8vEE38pqbj26lNrSeRg93qFwbdWosJ6MQ7BVI0Y5VhvrxANGmSabl2yjQu5eTk3NdsTVxX7lcnXmCTotGTTL0ORDSNfpdCaKfymblz7svp4THPoTv1ApsUzUxdANmggGhcUd2GH3w7NakXbqde6VBMa9b+SOtqsPJ86Xipem2zNpRobEMSr12/rFWdT9q279SLUAZ/3U+7Uy8ZFMfeyCugz45INLaixMHu3pXutt5bpFs7tdcHxTdExS/aVIloTFsa7nLO8yMSjVuS9I9Ohh7cDA0+Veyvw1cB6i/dSiOz/tTwWURj6mi4v10ckWjkEzVtuEcZn4GO7J6zsGf1VXVpPrM9NXyuP1Fjn31eyv2IJtz++uRJ+3QTin7Ik/GFaXY49oJH8ZW//L1ziuzH7Amvni+fvEghBUTT6HeTujlOkYwvzFOvRU2tnasNyyNnk9Hol6/yrbSCLHBb4urtwjKaUy8TNq3YW//Z1IbbI2eT0ahXFmcLb0TT6AKy5XM0GvH4eDE67rs0CTUjgsq3BSw1MD9RDYnGEO2KvXsmK4eO5viL69WIWb4UJafnTH08YP6fChCN9UrXBfWtDhVN/CpO8d89qHmmeClKQUczijU2351onJeueL5dnt3zF7fjb3bmkas3i59/syP+3jz97N3iH79esue/3vO/Fsq1L94MX395fDkUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPA/9V/P54dTvDtG+wAAAABJRU5ErkJggg=="

/***/ }),
/* 821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminContact_vue__ = __webpack_require__(408);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a04ba4ce_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminContact_vue__ = __webpack_require__(823);
function injectStyle (ssrContext) {
  __webpack_require__(822)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a04ba4ce"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminContact_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a04ba4ce_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminContact_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 822 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Updating")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.loading1)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Loading")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.changed)?_c('div',[_c('div',{staticClass:"container"},[_c('h2',{staticClass:"m-auto text-info text-center pt-5 pb-4"},[_vm._v("Contact Details ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-12 col-lg-8 m-auto bg-white py-4"},[_c('el-form',{ref:"condata",attrs:{"model":_vm.condata,"label-width":"200px","label-position":_vm.label,"size":"medium","status-icon":""},nativeOn:{"submit":function($event){$event.preventDefault();}}},[_c('el-form-item',{attrs:{"label":"Open time"}},[_c('el-time-select',{attrs:{"placeholder":"Start time","picker-options":{
      start: '00:00',
      step: '00:15',
      end: '10:00'
    }},model:{value:(_vm.condata.startTime),callback:function ($$v) {_vm.$set(_vm.condata, "startTime", $$v)},expression:"condata.startTime"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Close time"}},[_c('el-time-select',{attrs:{"placeholder":"End time","picker-options":{
      start: '16:00',
      step: '00:15',
      end: '23:59',
      minTime: _vm.condata.startTime
    }},model:{value:(_vm.condata.endTime),callback:function ($$v) {_vm.$set(_vm.condata, "endTime", $$v)},expression:"condata.endTime"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Shop Name","prop":"name","rules":[ { required: true, message: 'Please input shop name', trigger: 'blur' },
            { min: 3, max: 50, message: 'Length should be 3 to 50', trigger: 'blur' }]}},[_c('el-input',{attrs:{"clearable":"","placeholder":"Shop Name"},model:{value:(_vm.condata.name),callback:function ($$v) {_vm.$set(_vm.condata, "name", $$v)},expression:"condata.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Contact Number 01","prop":"phone1","rules":[
      { type: 'number', message: 'telephone no must be a number'}]}},[_c('el-input',{staticStyle:{"width":"220px"},attrs:{"placeholder":"777666666","auto-complete":"off"},model:{value:(_vm.condata.phone1),callback:function ($$v) {_vm.$set(_vm.condata, "phone1", _vm._n($$v))},expression:"condata.phone1"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Contact Number 02","prop":"phone2"}},[_c('el-input',{staticStyle:{"width":"220px"},attrs:{"placeholder":"112222222","auto-complete":"off"},model:{value:(_vm.condata.phone2),callback:function ($$v) {_vm.$set(_vm.condata, "phone2", _vm._n($$v))},expression:"condata.phone2"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Email","prop":"email","rules":[
     
      { type: 'email', message: 'Please input correct email address', trigger: ['blur', 'change'] }]}},[_c('el-input',{attrs:{"placeholder":"Email"},model:{value:(_vm.condata.email),callback:function ($$v) {_vm.$set(_vm.condata, "email", $$v)},expression:"condata.email"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Address","prop":"address"}},[_c('el-input',{attrs:{"type":"textarea","placeholder":"Address"},model:{value:(_vm.condata.address),callback:function ($$v) {_vm.$set(_vm.condata, "address", $$v)},expression:"condata.address"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Delivery Details & Special Notes","prop":"darea"}},[_c('el-input',{attrs:{"type":"textarea","placeholder":"Delivery Details & Special Notes"},model:{value:(_vm.condata.darea),callback:function ($$v) {_vm.$set(_vm.condata, "darea", $$v)},expression:"condata.darea"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Latitude","prop":"lat"}},[_c('el-input',{attrs:{"placeholder":"Latitude"},model:{value:(_vm.condata.lat),callback:function ($$v) {_vm.$set(_vm.condata, "lat", _vm._n($$v))},expression:"condata.lat"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Longtitude","prop":"long"}},[_c('el-input',{attrs:{"placeholder":"Longtitude"},model:{value:(_vm.condata.long),callback:function ($$v) {_vm.$set(_vm.condata, "long", _vm._n($$v))},expression:"condata.long"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"success"},on:{"click":function($event){_vm.getLatLon()}}},[_vm._v("Get Latitude & Longtitude")])],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.upDet('condata')}}},[_vm._v("Update Details")])],1)],1)],1)])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 824 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminSetting_vue__ = __webpack_require__(410);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fc8d8c4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminSetting_vue__ = __webpack_require__(826);
function injectStyle (ssrContext) {
  __webpack_require__(825)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6fc8d8c4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminSetting_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fc8d8c4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminSetting_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 825 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 826 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-modal',{staticClass:"text-center text-danger",attrs:{"ok-only":"","centered":""},model:{value:(_vm.modalShow1),callback:function ($$v) {_vm.modalShow1=$$v},expression:"modalShow1"}},[_vm._v("\r\n      Please enter valid config object\r\n    ")]),_vm._v(" "),_c('b-modal',{staticClass:"text-center text-info",attrs:{"ok-only":"","centered":""},model:{value:(_vm.modalShow2),callback:function ($$v) {_vm.modalShow2=$$v},expression:"modalShow2"}},[_vm._v("\r\n      Project Id Updated\r\n    ")]),_vm._v(" "),(_vm.loading)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Updating")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.loading1)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Loading")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.changed)?_c('div',[_c('div',{staticClass:"container mt-5"},[_c('div',{staticClass:"col-sm-12 col-md-6 m-auto"},[_c('h4',{staticClass:"m-auto text-info text-center pt-4 pb-4"},[_vm._v("Enter Your Project Id")]),_vm._v(" "),_c('el-input',{attrs:{"requried":"","placeholder":"Please input your Project Id"},model:{value:(_vm.inputObj),callback:function ($$v) {_vm.inputObj=$$v},expression:"inputObj"}}),_vm._v(" "),_c('el-button',{staticClass:"mt-3",attrs:{"type":"primary"},on:{"click":function($event){_vm.upConfig()}}},[_vm._v("Update")]),_vm._v(" "),_c('h4',{staticClass:"m-auto text-info text-center pt-4 pb-2"},[_vm._v("How to Get Your Project Id")]),_vm._v(" "),_c('h6',{staticClass:"m-auto text-dark text-center pt-2 pb-2"},[_vm._v("Go to the link shown below using your Gmail Address and do the steps shown in the video. It only takes a minute!")]),_vm._v(" "),_c('a',{staticClass:"text-info",attrs:{"href":"https://console.firebase.google.com","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("https://console.firebase.google.com")])],1)])]):_vm._e(),_vm._v(" "),(_vm.fetched)?_c('div',{staticStyle:{"min-height":"60vh"}},[_c('h4',{staticClass:"m-auto text-info text-center pt-5 pb-5 my-5"},[_vm._v("Settings are Done!")])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminView_vue__ = __webpack_require__(411);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6161a714_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminView_vue__ = __webpack_require__(829);
function injectStyle (ssrContext) {
  __webpack_require__(828)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6161a714"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6161a714_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 828 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-container',[_c('el-drawer',{attrs:{"with-header":false,"direction":"ltr","append-to-body":true,"visible":_vm.drawer,"size":"260px"},on:{"update:visible":function($event){_vm.drawer=$event}}},[_c('el-menu',{staticStyle:{"min-height":"100vh","max-height":"100vh","overflow-y":"scroll"},attrs:{"id":"elaside","router":false,"default-openeds":_vm.openeds,"collapse":_vm.isCollapse,"collapse-transition":false,"background-color":_vm.color,"text-color":_vm.color1,"active-text-color":_vm.color2},on:{"open":_vm.handleOpen,"close":_vm.handleClose}},[_c('div',{staticClass:"text-center mt-3 mb-1"},[(_vm.searchbar)?_c('a',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.setRoute('admin')}}},[_c('img',{attrs:{"src":__webpack_require__(13),"width":"60","height":"60","alt":""}})]):_vm._e()]),_vm._v(" "),(_vm.permissions.includes('dashboard'))?_c('el-menu-item',{attrs:{"index":"dashboard"},on:{"click":function($event){_vm.setRoute('dashboard')}}},[_c('i',{staticClass:"el-icon-menu"}),_vm._v(" "),_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Dashboard")])]):_vm._e(),_vm._v(" "),(_vm.permissions.includes('analytics'))?_c('el-menu-item',{attrs:{"index":"Footers"},on:{"click":function($event){_vm.setRoute('analytics')}}},[_c('i',{staticClass:"el-icon-data-analysis"}),_vm._v(" "),_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Analytics")])]):_vm._e(),_vm._v(" "),(_vm.permissions.includes('categories'))?_c('el-menu-item',{attrs:{"index":"Form"},on:{"click":function($event){_vm.setRoute('managecategories')}}},[_c('i',{staticClass:"el-icon-collection-tag"}),_vm._v(" "),_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Categories")])]):_vm._e(),_vm._v(" "),(_vm.permissions.includes('products'))?_c('el-submenu',{attrs:{"index":"6"}},[_c('template',{attrs:{"slot":"title"},slot:"title"},[_c('i',{staticClass:"el-icon-goods"}),_vm._v(" "),_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Products")])]),_vm._v(" "),_vm._l((Object.keys(_vm.$store.state.categories).sort()),function(value,key){return [_c('el-menu-item',{key:key,attrs:{"index":("6-" + key)},on:{"click":function($event){_vm.setRoute('categories', 'cat', value)}}},[_c('i',{staticClass:"el-icon-discount"}),_vm._v(" "+_vm._s(value))])]})],2):_vm._e(),_vm._v(" "),(_vm.permissions.includes('products'))?_c('el-menu-item',{attrs:{"index":"stockSummary"},on:{"click":function($event){_vm.setRoute('stockSummary')}}},[_c('i',{staticClass:"el-icon-s-claim"}),_vm._v(" "),_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Stock Summary")])]):_vm._e(),_vm._v(" "),(
          _vm.permissions.includes('invoice write') ||
          _vm.permissions.includes('invoice list') ||
          _vm.permissions.includes('invoice return')
        )?_c('el-submenu',{attrs:{"index":"7"}},[_c('template',{attrs:{"slot":"title"},slot:"title"},[_c('i',{staticClass:"el-icon-document-copy"}),_vm._v(" "),_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Invoice")])]),_vm._v(" "),(_vm.permissions.includes('invoice write'))?_c('el-menu-item',{attrs:{"index":"7-1"},on:{"click":function($event){_vm.setRoute('createinvoice')}}},[_c('i',{staticClass:"el-icon-document-add"}),_vm._v("\n            Create Invoice")]):_vm._e(),_vm._v(" "),(_vm.permissions.includes('invoice list'))?_c('el-menu-item',{attrs:{"index":"7-2"},on:{"click":function($event){_vm.setRoute('invoicelist')}}},[_c('i',{staticClass:"el-icon-document"}),_vm._v("Invoice List")]):_vm._e(),_vm._v(" "),(_vm.permissions.includes('invoice return'))?_c('el-menu-item',{attrs:{"index":"7-3"},on:{"click":function($event){_vm.setRoute('returns')}}},[_c('i',{staticClass:"el-icon-bottom"}),_vm._v("Returns")]):_vm._e()],2):_vm._e(),_vm._v(" "),(_vm.shopcategory === 'Food / Restaurants')?_c('el-menu-item',{attrs:{"index":"kot"},on:{"click":function($event){_vm.setRoute('kot')}}},[_c('i',{staticClass:"el-icon-tableware"}),_vm._v(" "),_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("KOT")])]):_vm._e(),_vm._v(" "),(_vm.shopcategory == 'Mobiles & Tablets' || _vm.shopcategory == 'Computers')?_c('el-menu-item',{attrs:{"index":"jobs"},on:{"click":function($event){_vm.setRoute('jobNotes')}}},[_c('i',{staticClass:"el-icon-cpu"}),_vm._v(" "),_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Job Notes")])]):_vm._e(),_vm._v(" "),(_vm.shopcategory)?_c('el-menu-item',{attrs:{"index":"orderProcessing"},on:{"click":function($event){_vm.setRoute('orderProcessing')}}},[_c('i',{staticClass:"el-icon-refresh"}),_vm._v(" "),_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Order Processing")])]):_vm._e(),_vm._v(" "),(
          _vm.permissions.includes('GRN list') ||
          _vm.permissions.includes('GRN write') ||
          _vm.permissions.includes('GRN return')
        )?_c('el-submenu',{attrs:{"index":"8"}},[_c('template',{attrs:{"slot":"title"},slot:"title"},[_c('i',{staticClass:"el-icon-truck"}),_vm._v(" "),_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Purchasing")])]),_vm._v(" "),(_vm.permissions.includes('GRN list'))?_c('el-menu-item',{attrs:{"index":"purchase-order-list"},on:{"click":function($event){_vm.setRoute('purchase-order-list')}}},[_c('i',{staticClass:"el-icon-truck"}),_vm._v(" "),_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("GRN List")])]):_vm._e(),_vm._v(" "),(_vm.permissions.includes('GRN write'))?_c('el-menu-item',{attrs:{"index":"create-purchase-order"},on:{"click":function($event){_vm.setRoute('create-purchase-order')}}},[_c('i',{staticClass:"el-icon-truck"}),_vm._v(" "),_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Create GRN")])]):_vm._e(),_vm._v(" "),(_vm.permissions.includes('GRN return'))?_c('el-menu-item',{attrs:{"index":"8-3"},on:{"click":function($event){_vm.setRoute('purchase-order-returns')}}},[_c('i',{staticClass:"el-icon-bottom"}),_vm._v("Returns")]):_vm._e()],2):_vm._e(),_vm._v(" "),(_vm.permissions.includes('expenses'))?_c('el-submenu',{attrs:{"index":"9"}},[_c('template',{attrs:{"slot":"title"},slot:"title"},[_c('i',{staticClass:"el-icon-wallet"}),_vm._v(" "),_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Expenses")])]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"expenses"},on:{"click":function($event){_vm.setRoute('expenses')}}},[_c('i',{staticClass:"el-icon-wallet"}),_vm._v(" "),_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Manage Expenses")])]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"expense-categories"},on:{"click":function($event){_vm.setRoute('expense-categories')}}},[_c('i',{staticClass:"el-icon-collection-tag"}),_vm._v(" "),_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Expense Categories")])])],2):_vm._e(),_vm._v(" "),(_vm.permissions.includes('cash flow'))?_c('el-menu-item',{attrs:{"index":"cash-flow-history"},on:{"click":function($event){_vm.setRoute('cash-flow-history')}}},[_c('i',{staticClass:"el-icon-money"}),_vm._v(" "),_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Cash Flow")])]):_vm._e(),_vm._v(" "),(
          _vm.permissions.includes('quotation list') ||
          _vm.permissions.includes('quotation write')
        )?_c('el-submenu',{attrs:{"index":"10"}},[_c('template',{attrs:{"slot":"title"},slot:"title"},[_c('i',{staticClass:"el-icon-edit-outline"}),_vm._v(" "),_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Quotations")])]),_vm._v(" "),(_vm.permissions.includes('quotation list'))?_c('el-menu-item',{attrs:{"index":"quotation-list"},on:{"click":function($event){_vm.setRoute('quotation-list')}}},[_c('i',{staticClass:"el-icon-edit-outline"}),_vm._v(" "),_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Quotations List")])]):_vm._e(),_vm._v(" "),(_vm.permissions.includes('quotation write'))?_c('el-menu-item',{attrs:{"index":"create-quotation"},on:{"click":function($event){_vm.setRoute('create-quotation')}}},[_c('i',{staticClass:"el-icon-edit-outline"}),_vm._v(" "),_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Create Quotation")])]):_vm._e()],2):_vm._e(),_vm._v(" "),(_vm.permissions.includes('customers'))?_c('el-menu-item',{attrs:{"index":"customers"},on:{"click":function($event){_vm.setRoute('customers')}}},[_c('i',{staticClass:"el-icon-s-custom"}),_vm._v(" "),_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Customers")])]):_vm._e(),_vm._v(" "),(_vm.permissions.includes('suppliers'))?_c('el-menu-item',{attrs:{"index":"suppliers"},on:{"click":function($event){_vm.setRoute('suppliers')}}},[_c('i',{staticClass:"el-icon-office-building"}),_vm._v(" "),_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Suppliers")])]):_vm._e(),_vm._v(" "),(_vm.permissions.includes('online store'))?_c('el-submenu',{attrs:{"index":"5"}},[_c('template',{attrs:{"slot":"title"},slot:"title"},[_c('i',{staticClass:"el-icon-shopping-cart-2"}),_vm._v(" "),_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Online Store")])]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"admincontact"},on:{"click":function($event){_vm.setRoute('admincontact')}}},[_c('i',{staticClass:"el-icon-phone-outline"}),_vm._v(" "),_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Contact Page")])]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"adminhome"},on:{"click":function($event){_vm.setRoute('adminhome')}}},[_c('i',{staticClass:"el-icon-s-home"}),_vm._v(" "),_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Home Page")])]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"admingallery"},on:{"click":function($event){_vm.setRoute('admingallery')}}},[_c('i',{staticClass:"el-icon-picture"}),_vm._v(" "),_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Gallery")])]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"offers"},on:{"click":function($event){_vm.setRoute('offers')}}},[_c('i',{staticClass:"el-icon-shopping-cart-full"}),_vm._v(" "),_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Offers")])]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"orders"},on:{"click":function($event){_vm.setRoute('orders')}}},[_c('i',{staticClass:"el-icon-truck"}),_vm._v(" "),_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Orders")])]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"storehome"},on:{"click":function($event){_vm.setRoute('storehome', 'storename', _vm.storeid)}}},[_c('i',{staticClass:"el-icon-s-shop"}),_vm._v(" "),_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("View Store")])])],2):_vm._e(),_vm._v(" "),(_vm.permissions.includes('users'))?_c('el-menu-item',{attrs:{"index":"users"},on:{"click":function($event){_vm.setRoute('users')}}},[_c('i',{staticClass:"el-icon-user"}),_vm._v(" "),_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Users")])]):_vm._e(),_vm._v(" "),(_vm.permissions.includes('stores'))?_c('el-menu-item',{attrs:{"index":"storelocations"},on:{"click":function($event){_vm.setRoute('storelocations')}}},[_c('i',{staticClass:"el-icon-s-shop"}),_vm._v(" "),_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Stores")])]):_vm._e(),_vm._v(" "),(_vm.permissions.includes('settings'))?_c('el-menu-item',{attrs:{"index":"setting"},on:{"click":function($event){_vm.setRoute('setting')}}},[_c('i',{staticClass:"el-icon-setting"}),_vm._v(" "),_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Setting")])]):_vm._e()],1)],1),_vm._v(" "),_c('el-container',{staticStyle:{"background-color":"rgb(246, 247, 248)"},style:({ marginLeft: _vm.elMainMargin })},[_c('el-header',{staticClass:"el-header",staticStyle:{"font-size":"24px"},style:({ width: _vm.elHheaderWidth, backgroundColor: _vm.color3 })},[_c('i',{class:_vm.menuicon,staticStyle:{"text-align":"right","margin-right":"15px","margin-top":"16px","cursor":"pointer","font-size":"25px"},on:{"click":function($event){_vm.drawer = true}}}),_vm._v(" "),_c('el-dropdown',{staticStyle:{"float":"right","font-size":"20px"},attrs:{"trigger":"click"},on:{"command":_vm.handleCommand}},[_c('el-avatar',{staticStyle:{"cursor":"pointer","margin-top":"10px"},attrs:{"src":"https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png"}}),_vm._v(" "),_c('el-dropdown-menu',{attrs:{"slot":"dropdown"},slot:"dropdown"},[(_vm.permissions.includes('dashboard'))?_c('a',{on:{"click":function($event){_vm.setRoute('dashboard')}}},[_c('el-dropdown-item',[_c('i',{staticClass:"el-icon-menu mr-2"}),_vm._v("Dashboard\n                ")])],1):_vm._e(),_vm._v(" "),(_vm.permissions.includes('invoice write'))?_c('a',{on:{"click":function($event){_vm.setRoute('createinvoice')}}},[_c('el-dropdown-item',[_c('i',{staticClass:"el-icon-document-add mr-2"}),_vm._v("Create\n                Invoice")])],1):_vm._e(),_vm._v(" "),_c('a',{on:{"click":function($event){_vm.setRoute('storehome', 'storename', _vm.storeid)}}},[_c('el-dropdown-item',[_c('i',{staticClass:"el-icon-s-shop mr-2"}),_vm._v("View\n                Store")])],1),_vm._v(" "),(_vm.permissions.includes('settings'))?_c('a',{on:{"click":function($event){_vm.setRoute('setting')}}},[_c('el-dropdown-item',[_c('i',{staticClass:"el-icon-setting mr-2"}),_vm._v("Setting")])],1):_vm._e(),_vm._v(" "),_c('a',{on:{"click":_vm.logout}},[_c('el-dropdown-item',{attrs:{"divided":"","command":"logout"}},[_c('i',{staticClass:"el-icon-switch-button mr-2"}),_vm._v("Log\n                out")])],1),_vm._v(" "),_c('a',{staticStyle:{"text-decoration":"none"},attrs:{"href":"tel:+94719500600"}},[_c('el-dropdown-item',{attrs:{"divided":""}},[_c('i',{staticClass:"el-icon-phone mr-2"}),_vm._v("+94 719 500 600")])],1)])],1),_vm._v(" "),_c('el-select',{staticStyle:{"float":"right","width":"160px !important","margin-right":"80px"},attrs:{"disabled":_vm.disableSelect,"size":"small","label":"Select Store","placeholder":"Select Store"},on:{"change":function($event){_vm.changeStore(_vm.store)}},model:{value:(_vm.store),callback:function ($$v) {_vm.store=$$v},expression:"store"}},_vm._l((_vm.stores),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.id}})})),_vm._v(" "),_c('el-drawer',{attrs:{"title":"","append-to-body":true,"size":"340px"}},[_c('div',[_c('h6',{staticClass:"text-center"},[_vm._v("Sidemenu Color")]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('el-color-picker',{attrs:{"show-alpha":"","predefine":_vm.predefineColors,"size":"medium"},model:{value:(_vm.color),callback:function ($$v) {_vm.color=$$v},expression:"color"}})],1),_vm._v(" "),_c('h6',{staticClass:"text-center"},[_vm._v("Sidemenu Text Color")]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('el-color-picker',{attrs:{"show-alpha":"","predefine":_vm.predefineColors,"size":"medium"},model:{value:(_vm.color1),callback:function ($$v) {_vm.color1=$$v},expression:"color1"}})],1),_vm._v(" "),_c('h6',{staticClass:"text-center"},[_vm._v("Sidemenu Active Color")]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('el-color-picker',{attrs:{"show-alpha":"","predefine":_vm.predefineColors,"size":"medium"},model:{value:(_vm.color2),callback:function ($$v) {_vm.color2=$$v},expression:"color2"}})],1),_vm._v(" "),_c('h6',{staticClass:"text-center"},[_vm._v("Header Color")]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('el-color-picker',{attrs:{"show-alpha":"","predefine":_vm.predefineColors,"size":"medium"},model:{value:(_vm.color3),callback:function ($$v) {_vm.color3=$$v},expression:"color3"}})],1),_vm._v(" "),_c('h6',{staticClass:"text-center"},[_vm._v("Footer Color")]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('el-color-picker',{attrs:{"show-alpha":"","predefine":_vm.predefineColors,"size":"medium"},model:{value:(_vm.color4),callback:function ($$v) {_vm.color4=$$v},expression:"color4"}})],1)])])],1),_vm._v(" "),(_vm.show2)?_c('el-main',{staticStyle:{"margin-top":"60px","margin-bottom":"100px"}},[(_vm.show)?_c('Dashboard'):_vm._e(),_vm._v(" "),_c('router-view',{key:_vm.$route.fullPath,staticStyle:{"min-height":"85vh"}})],1):_vm._e(),_vm._v(" "),(_vm.showfooter)?_c('el-footer',{style:({ backgroundColor: _vm.color4 })},[_c('p',{staticClass:"text-white mt-2 py-2",staticStyle:{"width":"100%"}},[_vm._v("\n          Eshops.lk © "+_vm._s(new Date().getFullYear())+" All rights reserved.\n        ")])]):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateInvoice_vue__ = __webpack_require__(412);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19edf283_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateInvoice_vue__ = __webpack_require__(840);
function injectStyle (ssrContext) {
  __webpack_require__(831)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-19edf283"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateInvoice_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19edf283_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateInvoice_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 831 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.invoiceNo)?_c('div',[_c('div',{staticClass:"ticket"},[(_vm.logo)?_c('img',{attrs:{"src":_vm.logo,"alt":"Logo"}}):_vm._e(),_vm._v(" "),_c('p',{staticClass:"centered",staticStyle:{"margin-bottom":"10px"}},[(!_vm.logo)?_c('span',[_vm._v(_vm._s(_vm.name))]):_vm._e(),_vm._v(" "),_c('br'),_vm._v("\n      "+_vm._s(_vm.address)+"\n      "),_c('br'),_vm._v(_vm._s(_vm.telephone)+" "),_c('br')]),_vm._v(" "),(_vm.type === 'invo')?_c('p',[_vm._v("\n      Inovice No : "+_vm._s(_vm.invoiceNo)+" "),_c('br'),_vm._v("Date :\n      "+_vm._s(_vm.date)+" "),_c('br'),_vm._v("Cashier : "+_vm._s(_vm.cashier)+"\n      "),_c('br'),_vm._v("Customer : "+_vm._s(_vm.customerName)+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.type === 'quota')?_c('p',[_vm._v("\n      Quotation No : "+_vm._s(_vm.invoiceNo)+" "),_c('br'),_vm._v("Date :\n      "+_vm._s(_vm.date)+" "),_c('br'),_vm._v("Cashier : "+_vm._s(_vm.cashier)+"\n      "),_c('br'),_vm._v("Customer : "+_vm._s(_vm.customerName)+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.type === 'po')?_c('p',[_vm._v("\n      PO No : "+_vm._s(_vm.invoiceNo)+" "),_c('br'),_vm._v("Date : "+_vm._s(_vm.date)+"\n      "),_c('br'),_vm._v("Supplier : "+_vm._s(_vm.supplierName)+"\n    ")]):_vm._e(),_vm._v(" "),_c('table',{staticStyle:{"margin-top":"-30px"}},[_vm._m(0),_vm._v(" "),_c('tbody',[_vm._l((_vm.products),function(product){return _c('tr',{key:product.barcode},[_c('td',{staticClass:"description"},[_vm._v(_vm._s(product.name)+" "+_vm._s(product.serial))]),_vm._v(" "),_c('td',{staticClass:"price"},[_vm._v(_vm._s(product.price.toLocaleString()))]),_vm._v(" "),_c('td',{staticClass:"quantity"},[_vm._v(_vm._s(product.quantity))]),_vm._v(" "),_c('td',{staticClass:"price"},[_vm._v(_vm._s((product.price*product.quantity).toLocaleString()))])])}),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('tr',{staticStyle:{"border-top":"1px solid rgb(49, 49, 49)"}},[_c('td',{staticClass:"description"},[_vm._v("Bill Total")]),_vm._v(" "),_c('td',{staticClass:"quantity"}),_vm._v(" "),_c('td',{staticClass:"quantity"}),_vm._v(" "),_c('td',{staticClass:"price"},[_vm._v(_vm._s(_vm.grossAmount.toLocaleString()))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"description"},[_vm._v("Product Discount")]),_vm._v(" "),_c('td',{staticClass:"quantity"}),_vm._v(" "),_c('td',{staticClass:"quantity"}),_vm._v(" "),_c('td',{staticClass:"price"},[_vm._v(_vm._s(_vm.discount.toLocaleString()))])]),_vm._v(" "),(_vm.otherDiscount)?_c('tr',[_c('td',{staticClass:"description"},[_vm._v("Other Discount")]),_vm._v(" "),_c('td',{staticClass:"quantity"}),_vm._v(" "),_c('td',{staticClass:"quantity"}),_vm._v(" "),_c('td',{staticClass:"price"},[_vm._v(_vm._s(_vm.otherDiscount.toLocaleString()))])]):_vm._e(),_vm._v(" "),(_vm.sCharge)?_c('tr',[_c('td',{staticClass:"description"},[_vm._v("Service Charge")]),_vm._v(" "),_c('td',{staticClass:"quantity"}),_vm._v(" "),_c('td',{staticClass:"quantity"}),_vm._v(" "),_c('td',{staticClass:"price"},[_vm._v(_vm._s(_vm.sCharge.toLocaleString()))])]):_vm._e(),_vm._v(" "),(_vm.dilCharge)?_c('tr',[_c('td',{staticClass:"description"},[_vm._v("Delivery Charge")]),_vm._v(" "),_c('td',{staticClass:"quantity"}),_vm._v(" "),_c('td',{staticClass:"quantity"}),_vm._v(" "),_c('td',{staticClass:"price"},[_vm._v(_vm._s(_vm.dilCharge.toLocaleString()))])]):_vm._e(),_vm._v(" "),_c('tr',[_c('td',{staticClass:"description"},[_vm._v("Net Total")]),_vm._v(" "),_c('td',{staticClass:"quantity"}),_vm._v(" "),_c('td',{staticClass:"quantity"}),_vm._v(" "),_c('td',{staticClass:"price"},[_vm._v(_vm._s((_vm.netAmount + _vm.dilCharge).toLocaleString()))])]),_vm._v(" "),(_vm.tax)?_c('tr',[_c('td',{staticClass:"description"},[_vm._v("Tax")]),_vm._v(" "),_c('td',{staticClass:"quantity"}),_vm._v(" "),_c('td',{staticClass:"quantity"}),_vm._v(" "),_c('td',{staticClass:"price"},[_vm._v(_vm._s(_vm.tax.toLocaleString()))])]):_vm._e(),_vm._v(" "),(_vm.cardPayment)?_c('tr',[_c('td',{staticClass:"description"},[_vm._v("Card")]),_vm._v(" "),_c('td',{staticClass:"quantity"}),_vm._v(" "),_c('td',{staticClass:"quantity"}),_vm._v(" "),_c('td',{staticClass:"price"},[_vm._v(_vm._s(_vm.cardPayment.toLocaleString()))])]):_vm._e(),_vm._v(" "),(_vm.cashPayment)?_c('tr',[_c('td',{staticClass:"description"},[_vm._v("Cash")]),_vm._v(" "),_c('td',{staticClass:"quantity"}),_vm._v(" "),_c('td',{staticClass:"quantity"}),_vm._v(" "),_c('td',{staticClass:"price"},[_vm._v(_vm._s(_vm.cashPayment === _vm.netAmount ? (_vm.cashPayment + _vm.dilCharge).toLocaleString() : (_vm.cashPayment).toLocaleString()))])]):_vm._e(),_vm._v(" "),(_vm.chequePayment)?_c('tr',[_c('td',{staticClass:"description"},[_vm._v("Cheque")]),_vm._v(" "),_c('td',{staticClass:"quantity"}),_vm._v(" "),_c('td',{staticClass:"quantity"}),_vm._v(" "),_c('td',{staticClass:"price"},[_vm._v(_vm._s(_vm.chequePayment.toLocaleString()))])]):_vm._e(),_vm._v(" "),(_vm.loyalityPoints)?_c('tr',[_c('td',{staticClass:"description"},[_vm._v("Loyalty Points")]),_vm._v(" "),_c('td',{staticClass:"quantity"}),_vm._v(" "),_c('td',{staticClass:"quantity"}),_vm._v(" "),_c('td',{staticClass:"price"},[_vm._v(_vm._s(_vm.loyalityPoints))])]):_vm._e(),_vm._v(" "),(_vm.giftVouchers)?_c('tr',[_c('td',{staticClass:"description"},[_vm._v("Gift Vouchers")]),_vm._v(" "),_c('td',{staticClass:"quantity"}),_vm._v(" "),_c('td',{staticClass:"quantity"}),_vm._v(" "),_c('td',{staticClass:"price"},[_vm._v(_vm._s(_vm.giftVouchers.toLocaleString()))])]):_vm._e(),_vm._v(" "),(!_vm.dilCharge)?_c('tr',[_c('td',{staticClass:"description"},[_vm._v("Balance")]),_vm._v(" "),_c('td',{staticClass:"quantity"}),_vm._v(" "),_c('td',{staticClass:"quantity"}),_vm._v(" "),_c('td',{staticClass:"price"},[_vm._v(_vm._s(_vm.balance.toLocaleString()))])]):_vm._e(),_vm._v(" "),(_vm.remaining)?_c('tr',[_c('td',{staticClass:"description"},[_vm._v("Remaining")]),_vm._v(" "),_c('td',{staticClass:"quantity"}),_vm._v(" "),_c('td',{staticClass:"quantity"}),_vm._v(" "),_c('td',{staticClass:"price"},[_vm._v(_vm._s((_vm.remaining + _vm.dilCharge).toLocaleString()))])]):_vm._e(),_vm._v(" "),(_vm.customer)?_c('tr',[_c('td',{staticClass:"description"},[_vm._v("Earned Loyalty Points")]),_vm._v(" "),_c('td',{staticClass:"quantity"}),_vm._v(" "),_c('td',{staticClass:"quantity"}),_vm._v(" "),_c('td',{staticClass:"price"},[_vm._v(_vm._s(_vm.earnedLoyalityPoints))])]):_vm._e(),_vm._v(" "),(_vm.customer && _vm.totalLoyalityPoints)?_c('tr',[_c('td',{staticClass:"description"},[_vm._v("Total Loyalty Points")]),_vm._v(" "),_c('td',{staticClass:"quantity"}),_vm._v(" "),_c('td',{staticClass:"quantity"}),_vm._v(" "),_c('td',{staticClass:"price"},[_vm._v(_vm._s(_vm.totalLoyalityPoints))])]):_vm._e(),_vm._v(" "),_vm._m(2)],2)]),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('p',{staticClass:"centered"},[_vm._v(_vm._s(_vm.footer))])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',{staticStyle:{"border-top":"hidden"}},[_c('th',{staticClass:"description",staticStyle:{"text-align":"left"}},[_vm._v("Item")]),_vm._v(" "),_c('th',{staticClass:"unitprice",staticStyle:{"text-align":"left"}},[_vm._v("Price")]),_vm._v(" "),_c('th',{staticClass:"quantity",staticStyle:{"text-align":"left"}},[_vm._v("Qty")]),_vm._v(" "),_c('th',{staticClass:"price",staticStyle:{"text-align":"left"}},[_vm._v("Amount")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"centered",staticStyle:{"margin-bottom":"10px"}},[_vm._v("\n      Thanks for your purchase! "),_c('br'),_vm._v("Come again.\n    ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading2)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Updating")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.loading1)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Loading")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.changed)?_c('div',[_c('el-dialog',{attrs:{"title":"Add Customer","visible":_vm.dialogFormVisible,"width":"300px"},on:{"update:visible":function($event){_vm.dialogFormVisible=$event}}},[_c('el-form',{ref:"formdata",staticStyle:{"<!-- border":"1px solid #e2e2e2","border-radius":"5px","-->\n              background-color":"#fff","margin-top":"-25px"},attrs:{"model":_vm.formdata,"status-icon":"","label-width":"120px","label-position":"top","size":"medium"}},[_c('el-form-item',{attrs:{"label":"Name","prop":"name","rules":[
          { required: true, message: 'Customer name', trigger: 'blur' } ]}},[_c('el-input',{attrs:{"placeholder":"Name"},model:{value:(_vm.formdata.name),callback:function ($$v) {_vm.$set(_vm.formdata, "name", $$v)},expression:"formdata.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Telephone Without 0","prop":"telephone","rules":[
          { required: true, message: 'telephone no is required' },
          { type: 'number', message: 'telephone no must be a number' } ]}},[_c('el-input',{attrs:{"auto-complete":"off","placeholder":"Telephone"},on:{"change":_vm.checkTelephone},model:{value:(_vm.formdata.telephone),callback:function ($$v) {_vm.$set(_vm.formdata, "telephone", _vm._n($$v))},expression:"formdata.telephone"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"pt-2",staticStyle:{"margin-bottom":"0px"}},[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.submitCustomerForm('formdata')}}},[_vm._v("Add")]),_vm._v(" "),_c('el-button',{attrs:{"type":"danger"},on:{"click":function($event){_vm.dialogFormVisible = false}}},[_vm._v("Cancel")])],1)],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"width":_vm.priceTableWidth,"show-close":false,"close-on-click-modal":false,"title":"Select Price","center":"","visible":_vm.dialogTableVisible},on:{"update:visible":function($event){_vm.dialogTableVisible=$event}}},[_c('h6',[_vm._v(_vm._s(_vm.priceData[0] ? _vm.priceData[0].name : ""))]),_vm._v(" "),_c('el-table',{ref:"priceTable",staticStyle:{"width":"300px"},attrs:{"data":_vm.priceData,"size":"mini","highlight-current-row":""},on:{"current-change":_vm.handleCurrentChange}},[_c('el-table-column',{staticStyle:{"margin-right":"0px"},attrs:{"property":"serial","label":"Serial/Item Code","width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          "+_vm._s(scope.row.serial)+"\n        ")]}}])}),_vm._v(" "),_c('el-table-column',{staticStyle:{"margin-right":"0px"},attrs:{"property":"price","label":"Price (LKR)","width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          "+_vm._s(scope.row.price.toLocaleString())+"\n        ")]}}])})],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"width":"80%","title":"Items","visible":_vm.innerVisible,"append-to-body":""},on:{"update:visible":function($event){_vm.innerVisible=$event}}},[_c('el-row',_vm._l((_vm.allProducts),function(item,index){return _c('el-col',{key:index,attrs:{"xs":12,"sm":8,"md":8,"lg":6,"xl":6}},[_c('el-card',{attrs:{"body-style":{ padding: '0px' }}},[_c('img',{staticClass:"image",attrs:{"src":item.img}}),_vm._v(" "),_c('div',{staticStyle:{"padding":"4px 14px","font-weight":"500"}},[_vm._v("\n              "+_vm._s(item.name)+"\n              "),_c('el-button',{staticStyle:{"padding-top":"4px","display":"block"},attrs:{"type":"text"},on:{"click":function($event){_vm.handleProductChange(item)}}},[_vm._v("Add to Invoice")])],1)])],1)}))],1),_vm._v(" "),_c('el-row',{staticStyle:{"margin-top":"8px"},attrs:{"gutter":10}},[_c('el-col',{staticStyle:{"margin-top":"0px"},attrs:{"justify":"space-between","xs":24,"sm":24,"md":24,"lg":16,"xl":16}},[_c('el-card',{staticStyle:{"background-color":"#05639b","overflow":"initial","margin-top":"2px"},attrs:{"shadow":"always"}},[_c('el-row',{staticStyle:{"margin-top":"0px"},attrs:{"justify":"space-between"}},[_c('el-col',{staticStyle:{"margin-right":"5px"},attrs:{"xs":24,"sm":24,"md":5,"lg":5,"xl":5}},[_c('el-autocomplete',{staticStyle:{"margin-bottom":"1px","border":"1px solid #409eff","border-radius":"5px","width":"100%"},attrs:{"size":"medium","popper-class":"my-autocomplete","fetch-suggestions":_vm.querySearch,"placeholder":"Barcode/Name"},on:{"select":_vm.handleProductChange},scopedSlots:_vm._u([{key:"default",fn:function(ref){
        var item = ref.item;
return [_c('div',{staticClass:"link"},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v("Barcode: "+_vm._s(item.barcode))])]}}]),model:{value:(_vm.productBarcode),callback:function ($$v) {_vm.productBarcode=$$v},expression:"productBarcode"}},[_c('i',{staticClass:"el-icon-edit el-input__icon",attrs:{"slot":"suffix"},slot:"suffix"})]),_vm._v(" "),(_vm.shops[0].curProducts <= 100)?_c('el-link',{staticStyle:{"color":"#fff"},attrs:{"icon":"el-icon-view"},on:{"click":function($event){_vm.innerVisible = true}}},[_vm._v("View Items")]):_vm._e()],1),_vm._v(" "),(
             ( _vm.$route.name === 'createinvoice' ||
              _vm.$route.name === 'create-quotation') && _vm.displayName !== 'starterplan shop owner'
            )?_c('el-col',{staticStyle:{"margin-right":"5px"},attrs:{"xs":24,"sm":24,"md":5,"lg":5,"xl":5}},[_c('el-input',{staticStyle:{"margin-bottom":"1px","border":"1px solid #409eff","border-radius":"5px"},attrs:{"size":"medium","label":"Customer Mobile No","placeholder":"Customer Mobile No"},on:{"change":function($event){_vm.handleCustomerChange('customer')}},model:{value:(_vm.customerMobile),callback:function ($$v) {_vm.customerMobile=$$v},expression:"customerMobile"}}),_vm._v(" "),_c('el-link',{staticStyle:{"color":"#fff"},attrs:{"icon":"el-icon-edit"},on:{"click":function($event){_vm.dialogFormVisible = true}}},[_vm._v("Add Customer")])],1):_vm._e(),_vm._v(" "),(_vm.$route.name === 'createinvoice' && _vm.displayName !== 'starterplan shop owner')?_c('el-col',{staticStyle:{"margin-right":"5px"},attrs:{"xs":24,"sm":24,"md":5,"lg":5,"xl":5}},[_c('el-input',{staticStyle:{"margin-bottom":"1px","border":"1px solid #409eff","border-radius":"5px"},attrs:{"size":"medium","label":"Referral Customer Mobile No","placeholder":"Referral Customer Mobile No"},on:{"change":function($event){_vm.handleCustomerChange('referral')}},model:{value:(_vm.referralCustomerMobile),callback:function ($$v) {_vm.referralCustomerMobile=$$v},expression:"referralCustomerMobile"}})],1):_vm._e(),_vm._v(" "),(_vm.$route.name === 'create-purchase-order' && _vm.displayName !== 'starterplan shop owner')?_c('el-col',{staticStyle:{"margin-right":"5px"},attrs:{"xs":24,"sm":24,"md":5,"lg":5,"xl":5}},[_c('el-input',{staticStyle:{"margin-bottom":"1px","border":"1px solid #409eff","border-radius":"5px"},attrs:{"size":"medium","label":"Supplier Mobile No","placeholder":"Supplier Mobile No"},on:{"change":function($event){_vm.handleSupplierChange()}},model:{value:(_vm.supplierMobile),callback:function ($$v) {_vm.supplierMobile=$$v},expression:"supplierMobile"}})],1):_vm._e(),_vm._v(" "),_c('el-col',{attrs:{"xs":{ span: 24, offset: 0 },"sm":{ span: 24, offset: 0 },"md":{ span: 8, offset: 0 },"lg":{ span: 8, offset: 0 },"xl":{ span: 8, offset: 0 }}},[_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"clearfix text item",staticStyle:{"margin":"-10px 0px 0px","line-height":"12px"}},[(_vm.printInvoType === 'invo')?_c('span',[_vm._v("Invoice No")]):_vm._e(),_vm._v(" "),(_vm.printInvoType === 'quota')?_c('span',[_vm._v("Quotation No")]):_vm._e(),_vm._v(" "),(_vm.printInvoType === 'po')?_c('span',[_vm._v("GRN/PO No")]):_vm._e(),_vm._v(" "),_c('span',{staticStyle:{"float":"right","padding":"0px 0"}},[_vm._v(_vm._s(_vm.invoiceNo))])]),_vm._v(" "),(_vm.customerName)?_c('div',{staticClass:"clearfix text item",staticStyle:{"margin":"0px 0px -10px","line-height":"10px"}},[_c('span',[_vm._v("Customer")]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","padding":"0px 0"}},[_vm._v(_vm._s(_vm.customerName))])]):_vm._e(),_vm._v(" "),(_vm.supplierName)?_c('div',{staticClass:"clearfix text item",staticStyle:{"margin":"0px 0px -10px","line-height":"16px"}},[_c('span',[_vm._v("Supplier")]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","padding":"0px 0"}},[_vm._v(_vm._s(_vm.supplierName))])]):_vm._e()])],1)],1)],1),_vm._v(" "),_c('el-col',{staticStyle:{"margin-bottom":"15px","margin-top":"15px"},attrs:{"xs":24,"sm":24,"md":24,"lg":24,"xl":24}},[_c('el-card',{staticStyle:{"background-color":"#f5fbff","overflow":"initial","margin-top":"2px"},attrs:{"shadow":"always"}},[(_vm.isInvoiceRendered)?_c('el-table',{staticStyle:{"width":"100%","border-radius":"5px"},attrs:{"height":"70vh","data":_vm.products.filter(
              function (data) { return !_vm.search ||
                data.name.toLowerCase().includes(_vm.search.toLowerCase()); }
            )}},[_c('el-table-column',{attrs:{"label":"Name","prop":"name","width":"210"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v(_vm._s(((scope.row.name) + " " + (scope.row.serial? (' - ' + scope.row.serial):''))))]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Quantity","prop":"quantity","width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-input-number',{attrs:{"size":"small","precision":2,"min":0,"max":_vm.maxQuantityforRoute == 'invoice' && !_vm.$route.query.invoice
                    ? scope.row.availableQnty
                    : _vm.maxQuantityforRoute == 'invoice' && _vm.$route.query.invoice
                    ? _vm.initialProducts.find(
                        function (product) { return product.barcode === scope.row.barcode &&
                          product.cost === scope.row.cost &&
                          product.serial === scope.row.serial &&
                          product.price === scope.row.price; }
                      ).quantity
                    : _vm.maxQuantityforRoute == 'PO' && !_vm.$route.query.PO
                    ? 1000000
                    : _vm.maxQuantityforRoute == 'PO' && _vm.$route.query.PO
                    ? _vm.initialProducts.find(
                        function (product) { return product.barcode === scope.row.barcode &&
                          product.cost === scope.row.cost &&
                          product.serial === scope.row.serial &&
                          product.price === scope.row.price; }
                      ).quantity
                    : 0},on:{"change":function($event){_vm.updateProducts(scope.$index, scope.row)}},model:{value:(scope.row.quantity),callback:function ($$v) {_vm.$set(scope.row, "quantity", $$v)},expression:"scope.row.quantity"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Price (LKR)","prop":"price","width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-input-number',{attrs:{"size":"small","precision":2,"min":0,"disabled":_vm.$route.query.invoice ? true : false},on:{"change":function($event){_vm.updateProducts(scope.$index, scope.row)}},model:{value:(scope.row.price),callback:function ($$v) {_vm.$set(scope.row, "price", $$v)},expression:"scope.row.price"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Discount %","prop":"discount","width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-input-number',{attrs:{"size":"small","precision":2,"min":0,"max":100,"disabled":_vm.$route.query.invoice ? true : false},on:{"change":function($event){_vm.updateProducts(scope.$index, scope.row)}},model:{value:(scope.row.discount),callback:function ($$v) {_vm.$set(scope.row, "discount", $$v)},expression:"scope.row.discount"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Sub Total (LKR)","width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{},[_vm._v("\n                "+_vm._s(scope.row.subTotal.toLocaleString())+"\n              ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"right"},scopedSlots:_vm._u([{key:"header",fn:function(scope){return [_c('el-input',{attrs:{"size":"mini","placeholder":"Search"},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})]}},{key:"default",fn:function(scope){return [(!_vm.$route.query.invoice)?_c('el-button',{attrs:{"size":"mini","type":"danger"},on:{"click":function($event){_vm.handleDelete(scope.$index, scope.row)}}},[_vm._v("Remove")]):_vm._e()]}}])})],1):_vm._e()],1)],1)],1),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":24,"md":24,"lg":8,"xl":8}},[_c('el-card',{staticClass:"box-card",staticStyle:{"background-color":"rgb(56 98 203)","color":"#fff"}},[_c('div',{staticClass:"clearfix text item"},[_c('span',[_vm._v("Gross Amount")]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","padding":"3px 0"}},[_vm._v(_vm._s(_vm.grossAmount.toLocaleString())+" LKR")])]),_vm._v(" "),_c('div',{staticClass:"clearfix text item"},[_c('span',[_vm._v("Products Discount")]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","padding":"3px 0"}},[_vm._v(_vm._s(_vm.discount.toLocaleString())+" LKR\n          ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix text item"},[_c('span',[_vm._v("Other Discount")]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","padding":"3px 0"}},[_c('el-input-number',{attrs:{"size":"mini","precision":2,"min":0},on:{"change":function($event){_vm.updatePaymentDetails()}},model:{value:(_vm.otherDiscount),callback:function ($$v) {_vm.otherDiscount=$$v},expression:"otherDiscount"}})],1)]),_vm._v(" "),(_vm.invoOptions.includes('Service Charge'))?_c('div',{staticClass:"clearfix text item"},[_c('span',[_vm._v("Service Charge\n            "+_vm._s(_vm.serviceChargeMode === "Percentage" ? "%" : ""))]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","padding":"3px 0"}},[_c('el-input-number',{attrs:{"size":"mini","precision":2,"min":0,"max":_vm.serviceChargeMode === 'Percentage' ? 100 : _vm.grossAmount},on:{"change":function($event){_vm.updatePaymentDetails()}},model:{value:(_vm.sCharge),callback:function ($$v) {_vm.sCharge=$$v},expression:"sCharge"}})],1)]):_vm._e(),_vm._v(" "),(_vm.invoOptions.includes('Delivery Charge'))?_c('div',{staticClass:"clearfix text item"},[_c('span',[_vm._v("Delivery Charge\n            ")]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","padding":"3px 0"}},[_c('el-input-number',{attrs:{"size":"mini","precision":2,"min":0},model:{value:(_vm.dilCharge),callback:function ($$v) {_vm.dilCharge=$$v},expression:"dilCharge"}})],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"clearfix text item"},[_c('span',[_vm._v("Net Amount")]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","padding":"3px 0"}},[_vm._v(_vm._s(_vm.netAmount.toLocaleString())+" LKR")])]),_vm._v(" "),(_vm.invoOptions.includes('Tax'))?_c('div',{staticClass:"clearfix text item"},[_c('span',[_vm._v("Tax\n            "+_vm._s(_vm.taxMode === "Percentage" ? "%" : ""))]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","padding":"3px 0"}},[_c('el-input-number',{attrs:{"size":"mini","precision":2,"min":0,"max":_vm.taxMode === 'Percentage' ? 100 : _vm.netAmount},on:{"change":function($event){_vm.updatePaymentDetails()}},model:{value:(_vm.tax),callback:function ($$v) {_vm.tax=$$v},expression:"tax"}})],1)]):_vm._e(),_vm._v(" "),(_vm.invoOptions.includes('Card Payment'))?_c('div',{staticClass:"clearfix text item"},[_c('span',[_vm._v("Card Payment")]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","padding":"3px 0"}},[_c('el-input-number',{attrs:{"size":"mini","precision":2,"min":0},on:{"change":function($event){_vm.updateCardPayment()}},model:{value:(_vm.cardPayment),callback:function ($$v) {_vm.cardPayment=$$v},expression:"cardPayment"}})],1)]):_vm._e(),_vm._v(" "),(_vm.invoOptions.includes('Card Payment'))?_c('div',{staticClass:"clearfix text item"},[_c('span',[_vm._v("Add Card Payment 3%")]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","padding":"3px 0"}},[_c('el-checkbox',{staticStyle:{"{\n                  color":"#fff"},on:{"change":function($event){_vm.updateCardPayment()}},model:{value:(_vm.card3Percent),callback:function ($$v) {_vm.card3Percent=$$v},expression:"card3Percent"}})],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"clearfix text item"},[_c('span',[_vm._v("Cash Payment")]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","padding":"3px 0"}},[_c('el-input-number',{attrs:{"size":"mini","precision":2,"min":0},on:{"change":function($event){_vm.updatePaymentDetails()}},model:{value:(_vm.cashPayment),callback:function ($$v) {_vm.cashPayment=$$v},expression:"cashPayment"}})],1)]),_vm._v(" "),(_vm.invoOptions.includes('Cheque Payment'))?_c('div',{staticClass:"clearfix text item"},[_c('span',[_vm._v("Cheque Payment")]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","padding":"3px 0"}},[_c('el-input-number',{attrs:{"size":"mini","precision":2,"min":0},on:{"change":function($event){_vm.updatePaymentDetails()}},model:{value:(_vm.chequePayment),callback:function ($$v) {_vm.chequePayment=$$v},expression:"chequePayment"}})],1)]):_vm._e(),_vm._v(" "),(_vm.invoOptions.includes('Gift Vouchers'))?_c('div',{staticClass:"clearfix text item"},[_c('span',[_vm._v("Gift Vouchers")]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","padding":"3px 0"}},[_c('el-input-number',{attrs:{"size":"mini","precision":2,"min":0},on:{"change":function($event){_vm.updatePaymentDetails()}},model:{value:(_vm.giftVouchers),callback:function ($$v) {_vm.giftVouchers=$$v},expression:"giftVouchers"}})],1)]):_vm._e(),_vm._v(" "),(_vm.invoOptions.includes('Loyalty Points'))?_c('div',{staticClass:"clearfix text item"},[_c('span',[_vm._v("Loyalty Points")]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","padding":"3px 0"}},[_c('el-input-number',{attrs:{"size":"mini","precision":2,"min":0,"max":_vm.maxLoyalityPoints},on:{"change":function($event){_vm.updatePaymentDetails()}},model:{value:(_vm.loyalityPoints),callback:function ($$v) {_vm.loyalityPoints=$$v},expression:"loyalityPoints"}})],1)]):_vm._e(),_vm._v(" "),(_vm.balance < 0)?_c('div',{staticClass:"clearfix text item"},[_c('span',[_vm._v("Credit")]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","padding":"3px 0"}},[_vm._v(_vm._s((-1 * _vm.balance).toLocaleString())+" LKR")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"clearfix text item"},[_c('span',[_vm._v("Balance")]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","padding":"3px 0"}},[_vm._v(_vm._s(_vm.balance > 0 ? _vm.balance.toLocaleString() : 0)+" LKR")])]),_vm._v(" "),(!this.$route.query.invoice && !this.$route.query.PO)?_c('div',{},[(_vm.invoOptions.includes('Card Payment'))?_c('el-button',{staticStyle:{"float":"right"},attrs:{"type":"danger","round":"","size":"medium"},on:{"click":function () {
            _vm.cardPaymentButtonClicked = true
            _vm.cardPayment=_vm.netAmount;
            _vm.cashPayment = 0;
            _vm.updatePaymentDetails()
            }}},[_vm._v("Card")]):_vm._e(),_vm._v(" "),_c('el-button',{staticClass:"mr-3 mb-2",staticStyle:{"float":"right"},attrs:{"type":"success","round":"","size":"medium"},on:{"click":function () {
            _vm.cashPaymentButtonClicked = true
            _vm.cashPayment=_vm.netAmount;
            _vm.cardPayment = 0;
            _vm.updatePaymentDetails()
            }}},[_vm._v("Cash")])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"clearfix text item"},[_c('span',[_vm._v("Notes")]),_vm._v(" "),_c('div',{staticStyle:{"padding":"3px 0"}},[_c('el-input',{attrs:{"rows":3,"type":"textarea"},model:{value:(_vm.note),callback:function ($$v) {_vm.note=$$v},expression:"note"}})],1)]),_vm._v(" "),_c('div',{staticClass:"clearfix"},[(
              (_vm.$route.name === 'create-purchase-order' ||
                _vm.$route.name === 'createinvoice') &&
              !(_vm.$route.query.invoice || _vm.$route.query.PO)
            )?_c('el-button',{staticStyle:{"float":"right","background-color":"#ff6014"},attrs:{"round":"","disabled":_vm.disabled,"size":"medium","type":"warning"},on:{"click":_vm.open3}},[_vm._v("SAVE & PRINT")]):_vm._e(),_vm._v(" "),(_vm.$route.query.invoice || _vm.$route.query.PO)?_c('el-button',{staticStyle:{"float":"right","background-color":"#ff6014"},attrs:{"round":"","disabled":_vm.disabled,"size":"medium","type":"warning"},on:{"click":_vm.open}},[_vm._v("SAVE")]):_vm._e(),_vm._v(" "),(_vm.$route.name === 'create-quotation')?_c('el-button',{staticStyle:{"float":"right","background-color":"#ff6014"},attrs:{"round":"","disabled":_vm.disabled,"size":"medium","type":"warning"},on:{"click":_vm.open2}},[_vm._v("SAVE & PRINT")]):_vm._e(),_vm._v(" "),(_vm.printOnly)?_c('el-button',{staticClass:"mr-3",staticStyle:{"float":"right","background-color":"#ff6014"},attrs:{"round":"","size":"medium","type":"warning"},on:{"click":function($event){_vm.PrintElem('print')}}},[_vm._v("PRINT ONLY")]):_vm._e()],1)])],1)],1),_vm._v(" "),_c('POSPrinter',{staticStyle:{"display":"none"},attrs:{"address":_vm.address,"telephone":_vm.telephone,"logo":_vm.logo,"name":_vm.storeName,"footer":_vm.footer,"products":_vm.products,"balance":_vm.balance,"cardPayment":_vm.cardPayment,"cashier":_vm.cashierName,"cashPayment":_vm.cashPayment,"chequePayment":_vm.chequePayment,"giftVouchers":_vm.giftVouchers,"discount":_vm.discount,"earnedLoyalityPoints":_vm.earnedLoyalityPoints,"grossAmount":_vm.grossAmount,"invoiceNo":_vm.invoiceNo,"loyalityPoints":_vm.loyalityPoints,"netAmount":_vm.netAmount,"otherDiscount":_vm.otherDiscount,"remaining":_vm.remaining,"tax":_vm.taxMode === 'Percentage' ? (_vm.netAmount * _vm.tax) / 100 : _vm.tax,"sCharge":_vm.serviceChargeMode === 'Percentage' ? (_vm.grossAmount * _vm.sCharge) / 100 : _vm.sCharge,"dilCharge":_vm.dilCharge,"totalLoyalityPoints":_vm.customerTotalLoyalityPoints + _vm.earnedLoyalityPoints,"customer":_vm.customer,"customerName":_vm.customerName,"supplierName":_vm.supplierName,"type":_vm.printInvoType,"date":new Date().toLocaleString(),"id":"print"}}),_vm._v(" "),(_vm.shops.length > 0)?_c('div',[_c('el-dialog',{attrs:{"title":"Warning","visible":_vm.showUpdatedDialog,"width":"90%","center":""},on:{"update:visible":function($event){_vm.showUpdatedDialog=$event}}},[_c('el-collapse',[_c('el-collapse-item',{attrs:{"title":"Customer Data","name":"1"}},[_c('el-row',{staticStyle:{"margin-top":"0px"},attrs:{"justify":"space-between"}},[_c('el-col',{attrs:{"md":6}},[_c('vue-json-pretty',{attrs:{"path":'res',"data":_vm.jsonDataforTest.cusInit}})],1),_vm._v(" "),_c('el-col',{attrs:{"md":6}},[_c('vue-json-pretty',{attrs:{"path":'res',"data":_vm.customer}})],1),_vm._v(" "),_c('el-col',{attrs:{"md":6}},[_c('vue-json-pretty',{attrs:{"path":'res',"data":_vm.jsonDataforTest.refCusInit}})],1),_vm._v(" "),_c('el-col',{attrs:{"md":6}},[_c('vue-json-pretty',{attrs:{"path":'res',"data":_vm.referralCustomer}})],1)],1)],1),_vm._v(" "),_c('el-collapse-item',{attrs:{"title":"Report Data","name":"2"}},[_c('el-col',{attrs:{"md":8}},[_c('vue-json-pretty',{attrs:{"path":'res',"data":_vm.jsonDataforTest.reportInit}})],1),_vm._v(" "),_c('el-col',{attrs:{"md":8}},[_c('vue-json-pretty',{attrs:{"path":'res',"data":_vm.reports[0]}})],1)],1),_vm._v(" "),_c('el-collapse-item',{attrs:{"title":"Store Data","name":"3"}},[_c('el-row',{staticStyle:{"margin-top":"0px"},attrs:{"justify":"space-between"}},[_c('el-col',{attrs:{"md":8}},[_c('vue-json-pretty',{attrs:{"path":'res',"data":_vm.jsonDataforTest.stores}})],1),_vm._v(" "),_c('el-col',{attrs:{"md":8}},[_c('vue-json-pretty',{attrs:{"path":'res',"data":_vm.jsonDataforTest.store}})],1)],1)],1),_vm._v(" "),_c('el-collapse-item',{attrs:{"title":"Supplier","name":"4"}},[_c('el-row',{staticStyle:{"margin-top":"0px"},attrs:{"justify":"space-between"}},[_c('el-col',{attrs:{"lg":6}},[_c('vue-json-pretty',{attrs:{"path":'res',"data":_vm.jsonDataforTest.supInit}})],1),_vm._v(" "),_c('el-col',{attrs:{"lg":6}},[_c('vue-json-pretty',{attrs:{"path":'res',"data":_vm.supplier}})],1)],1)],1)],1),_vm._v(" "),_c('el-row',{staticStyle:{"margin-top":"0px"},attrs:{"justify":"space-between"}},[_c('el-col',{attrs:{"md":8}},[_c('vue-json-pretty',{attrs:{"path":'res',"data":_vm.jsonDataforTest.invo}})],1),_vm._v(" "),_c('el-col',{attrs:{"md":6}},[_vm._v("\n          priceListInit\n          "),_c('vue-json-pretty',{attrs:{"path":'res',"data":_vm.jsonDataforTest.priceListInit}})],1),_vm._v(" "),_c('el-col',{attrs:{"md":6}},[_vm._v("\n          priceListNew\n          "),_c('vue-json-pretty',{attrs:{"path":'res',"data":_vm.jsonDataforTest.priceList}})],1)],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.showUpdatedDialog = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.pushToNewRoute()}}},[_vm._v("Confirm")])],1)],1)],1):_vm._e()],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateBarcode_vue__ = __webpack_require__(415);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6271db88_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateBarcode_vue__ = __webpack_require__(843);
function injectStyle (ssrContext) {
  __webpack_require__(842)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6271db88"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateBarcode_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6271db88_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateBarcode_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 842 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{on:{"click":_vm.printDemo}},[_vm._v("Test Print")]),_vm._v(" "),_c('vue-easy-print',{ref:"easyPrint",attrs:{"tableShow":true}},[_c('el-row',[_c('el-col',{attrs:{"id":"print","span":5}},[_c('barcode',{staticStyle:{"text-align":"center","height":"78px"},attrs:{"id":"pdf","value":'barcodeValue',"width":1,"height":40,"fontSize":14}},[_vm._v("\n        rendering fails.\n      ")]),_vm._v(" "),_c('p',{staticStyle:{"{\n        margin-bottom":"-4px !important","font-size":"12px","font-weight":"bold","text-align":"center","margin-bottom":"-4px !important"}},[_vm._v("Rs 455")]),_vm._v(" "),_c('p',{staticStyle:{"{\n        margin-bottom":"-4px !important","font-size":"12px","font-weight":"bold","text-align":"center","margin-bottom":"-4px !important"}},[_vm._v("Barcode Scanner YHD-1100L")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvoiceList_vue__ = __webpack_require__(416);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_88d15ef2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvoiceList_vue__ = __webpack_require__(847);
function injectStyle (ssrContext) {
  __webpack_require__(845)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-88d15ef2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvoiceList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_88d15ef2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvoiceList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 845 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('POSPrinter',{staticStyle:{"display":"none"},attrs:{"address":_vm.address,"telephone":_vm.telephone,"logo":_vm.logo,"name":_vm.name,"footer":_vm.footer,"products":_vm.invoData.products,"balance":_vm.invoData.balance,"cardPayment":_vm.invoData.cardPayment,"cashier":_vm.invoData.cashierName,"cashPayment":_vm.invoData.cashPayment,"chequePayment":_vm.invoData.chequePayment,"giftVouchers":_vm.invoData.giftVouchers,"discount":_vm.invoData.discount,"earnedLoyalityPoints":_vm.invoData.earnedLoyalityPoints,"grossAmount":_vm.invoData.grossAmount,"invoiceNo":_vm.invoData.invoiceNo,"loyalityPoints":_vm.invoData.loyalityPoints,"netAmount":_vm.invoData.netAmount,"otherDiscount":_vm.invoData.otherDiscount,"remaining":_vm.invoData.remaining,"tax":_vm.invoData.taxMode === 'Percentage' ? (_vm.invoData.netAmount * _vm.invoData.tax) / 100 : _vm.invoData.tax,"sCharge":_vm.invoData.serviceChargeMode === 'Percentage' ? (_vm.invoData.grossAmount * _vm.invoData.sCharge) / 100 : _vm.invoData.sCharge,"dilCharge":_vm.invoData.dilCharge,"totalLoyalityPoints":_vm.invoData.customerTotalLoyalityPoints + _vm.invoData.earnedLoyalityPoints,"customer":_vm.invoData.customerMobile,"customerName":_vm.invoData.customer,"supplierName":_vm.invoData.supplier,"type":_vm.printInvoType,"date":_vm.invoData.date,"id":"print"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 847 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Loading")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.loading1)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Updating")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.loading2)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Deleting")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.changed)?_c('div',{},[_c('b-container',{staticClass:"col-lg-10 mt-5"},[_c('h3',{staticClass:"text-info text-center pt-4 my-4"},[_vm._v("Invoices")]),_vm._v(" "),_c('el-card',{staticStyle:{"background-color":"#f5f7fa","overflow":"initial"},attrs:{"shadow":"always"}},[_c('b-row',[_c('b-col',{staticClass:"my-1",attrs:{"sm":"3"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":""}},[_c('el-date-picker',{attrs:{"size":"medium","picker-options":{
                    disabledDate: function (time) { return _vm.disabledDate(time); },
                  },"type":"month","placeholder":"Month"},model:{value:(_vm.month),callback:function ($$v) {_vm.month=$$v},expression:"month"}})],1)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"sm":"3","lg":"2"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":""}},[_c('b-form-select',{attrs:{"placeholder":"Store Location","options":_vm.stores},on:{"change":function($event){_vm.changeStore()}},model:{value:(_vm.storeLocation),callback:function ($$v) {_vm.storeLocation=$$v},expression:"storeLocation"}})],1)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"sm":"3","lg":"2"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":""}},[_c('b-form-input',{attrs:{"placeholder":"Cashier's User ID"},model:{value:(_vm.cashier),callback:function ($$v) {_vm.cashier=$$v},expression:"cashier"}})],1)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"sm":"3","lg":"2"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":""}},[_c('b-form-input',{attrs:{"placeholder":"Invoice No"},model:{value:(_vm.invoiceNo),callback:function ($$v) {_vm.invoiceNo=$$v},expression:"invoiceNo"}})],1)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"sm":"3","lg":"2"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":""}},[_c('b-form-input',{attrs:{"placeholder":"Customer's Mobile No"},model:{value:(_vm.customer),callback:function ($$v) {_vm.customer=$$v},expression:"customer"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"my-1",attrs:{"sm":"12"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":""}},[_c('el-button',{staticStyle:{"display":"block","margin":"0 auto","margin-top":"10px"},attrs:{"type":"primary","size":"medium"},on:{"click":_vm.searchInvoices}},[_vm._v("Search")])],1)],1)],1)],1),_vm._v(" "),_c('b-row'),_vm._v(" "),_c('PrintInvo',{attrs:{"printInvoType":"invo"}}),_vm._v(" "),_c('el-card',{staticStyle:{"overflow-x":"scroll"},attrs:{"id":"realtable","shadow":"always"}},[_c('TableHeader',{attrs:{"pageOptions":_vm.pageOptions,"fields":_vm.fields,"items":_vm.items,"perPage":_vm.perPage,"month":_vm.month,"visibleFields":_vm.visibleFields,"downloadCSVMethod":'downloadCSV',"enableToggle":true}}),_vm._v(" "),_c('b-table',{staticClass:"mt-2",attrs:{"show-empty":"","stacked":"sm","items":_vm.items,"fields":_vm.visibleFields,"hover":true,"head-variant":"dark","current-page":_vm.currentPage,"per-page":_vm.perPage,"empty-text":_vm.emptyText,"filter":_vm.filter,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event},"filtered":_vm.onFiltered},scopedSlots:_vm._u([{key:"index",fn:function(data){return [_vm._v("\n              "+_vm._s(data.index + 1)+"\n            ")]}},{key:"credit",fn:function(row){return [_vm._v("\n              "+_vm._s(row.item.balance < 0 ? -1 * row.item.balance : 0)+"\n            ")]}},{key:"balance",fn:function(row){return [_vm._v("\n              "+_vm._s(row.item.balance > 0 ? row.item.balance : 0)+"\n            ")]}},{key:"note",fn:function(row){return [_c('el-popover',{attrs:{"placement":"bottom","width":"200","trigger":"hover","content":row.item.note}},[_c('span',{attrs:{"slot":"reference"},slot:"reference"},[_vm._v("\n                  "+_vm._s(("" + (row.item.note.substring(0,8)) + (row.item.note.length > 8 ? '...' : '')))+"\n                ")])])]}},{key:"actions",fn:function(row){return [_c('div',{staticClass:"btn-group",attrs:{"role":"group","aria-label":"Basic example"}},[_c('a',{staticClass:"btn btn-sm btn-info text-white",attrs:{"size":"sm"},on:{"click":function($event){$event.stopPropagation();row.toggleDetails($event)}}},[_vm._v("\n                  View\n                ")]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-sm btn-primary",attrs:{"to":{
                    name: 'createinvoice',
                    query: ( _obj = { invoice: row.item.invoiceNo }, _obj['return'] = 'true', _obj ),
                  }}},[_vm._v("\n                  Update\n                ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-secondary text-white",attrs:{"size":"sm"},on:{"click":function($event){_vm.printInvoice(_vm.storeLocation, row.item)}}},[_vm._v("\n                  Print\n                ")])],1)]
                  var _obj;}},{key:"row-details",fn:function(row){return [_c('b-card',[_c('el-row',{staticStyle:{"margin-top":"20px"},attrs:{"gutter":10}},[_c('el-col',{attrs:{"xs":24,"sm":24,"md":24,"lg":24,"xl":24}},[_c('el-card',{staticClass:"box-card",staticStyle:{"background-color":"#eaf0ff"}},[_c('div',{staticClass:"clearfix text item"},[_c('span',[_vm._v("Gross Amount")]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","padding":"3px 0"}},[_vm._v(_vm._s(row.item.grossAmount.toLocaleString())+" LKR")])]),_vm._v(" "),_c('div',{staticClass:"clearfix text item"},[_c('span',[_vm._v("Discount")]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","padding":"3px 0"}},[_vm._v(_vm._s(row.item.discount.toLocaleString())+" LKR\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix text item"},[_c('span',[_vm._v("Other Discount")]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","padding":"3px 0"}},[_vm._v("\n                          "+_vm._s(row.item.otherDiscount.toLocaleString())+" LKR\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix text item"},[_c('span',[_vm._v("Service Charge")]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","padding":"3px 0"}},[_vm._v("\n                          "+_vm._s(row.item.serviceChargeMode === 'Percentage' ? ((row.item.grossAmount * row.item.sCharge) / 100).toLocaleString() : row.item.sCharge.toLocaleString())+" LKR\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix text item"},[_c('span',[_vm._v("Net Amount")]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","padding":"3px 0"}},[_vm._v(_vm._s(row.item.netAmount.toLocaleString())+" LKR")])]),_vm._v(" "),_c('div',{staticClass:"clearfix text item"},[_c('span',[_vm._v("Tax")]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","padding":"3px 0"}},[_vm._v("\n                          "+_vm._s(row.item.taxMode === 'Percentage' ? ((row.item.netAmount * row.item.tax) / 100).toLocaleString() : row.item.tax.toLocaleString())+" LKR\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix text item"},[_c('span',[_vm._v("Card Payment")]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","padding":"3px 0"}},[_vm._v("\n                          "+_vm._s(row.item.cardPayment.toLocaleString())+" LKR\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix text item"},[_c('span',[_vm._v("Cash Payment")]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","padding":"3px 0"}},[_vm._v("\n                          "+_vm._s(row.item.cashPayment.toLocaleString())+" LKR\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix text item"},[_c('span',[_vm._v("Cheque Payment")]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","padding":"3px 0"}},[_vm._v("\n                          "+_vm._s(row.item.chequePayment.toLocaleString())+" LKR\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix text item"},[_c('span',[_vm._v("Balance")]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","padding":"3px 0"}},[_vm._v(_vm._s(row.item.balance.toLocaleString())+" LKR")])]),_vm._v(" "),(row.item.dilCharge)?_c('div',{staticClass:"clearfix text item"},[_c('span',[_vm._v("Delivery Charge")]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","padding":"3px 0"}},[_vm._v(_vm._s(row.item.dilCharge.toLocaleString())+" LKR")])]):_vm._e()])],1),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":24,"md":24,"lg":24,"xl":24}},[_c('h5',{staticClass:"text-center text-info my-4"},[_vm._v("Ordeded Items")]),_vm._v(" "),_c('div',{},[_c('b-table',{staticClass:"mt-4",attrs:{"show-empty":"","stacked":"sm","items":row.item.products,"fields":_vm.productsFields,"hover":true,"head-variant":"dark","empty-text":_vm.emptyText,"filter":_vm.filter,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event}},scopedSlots:_vm._u([{key:"cell(index)",fn:function(data){return [_vm._v("\n                          "+_vm._s(data.index + 1)+"\n                        ")]}}])})],1)])],1)],1)]}},{key:"bottom-row",fn:function(row){return [_c('td'),_vm._v(" "),_c('td',[_c('b',[_vm._v("Total Sales")])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm.items.reduce(function (accum, item) { return accum + parseFloat(item.netAmount); }, 0.00)))])]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_c('b',[_vm._v("Total Profit")])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm.items.reduce(function (accum, item) { return accum + parseFloat(item.profit); }, 0.00)))])]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_c('b',[_vm._v("Total Items Sold")])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm.items.reduce(function (accum, item) { return accum + parseFloat(item.soldItems); }, 0.00)))])]),_vm._v(" "),_c('td'),_vm._v(" "),(_vm.shopCategory === 'Food / Restaurants')?_c('td',[_vm._v("Service Charge")]):_vm._e(),_vm._v(" "),(_vm.shopCategory === 'Food / Restaurants')?_c('td',[_vm._v(_vm._s(_vm.items.reduce(function (accum, item) { return accum + parseFloat(item.sCharge); }, 0.00)))]):_vm._e()]}}])})],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"md":"3"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":""}},[_c('b-form-select',{model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}},[_c('option',{attrs:{"disabled":""}},[_vm._v("per page")]),_vm._v(" "),_c('option',{domProps:{"value":10}},[_vm._v("10")]),_vm._v(" "),_c('option',{domProps:{"value":20}},[_vm._v("20")]),_vm._v(" "),_c('option',{domProps:{"value":40}},[_vm._v("40")])])],1)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"md":"6"}},[_c('b-pagination',{staticClass:"my-0",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManageCategories_vue__ = __webpack_require__(418);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_730aa3d0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManageCategories_vue__ = __webpack_require__(850);
function injectStyle (ssrContext) {
  __webpack_require__(849)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-730aa3d0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManageCategories_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_730aa3d0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManageCategories_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 849 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-row',{staticStyle:{"margin-top":"20px"}},[_c('div',{staticClass:"m-auto text-right pb-3"},[_c('el-button',{attrs:{"type":"primary","size":"medium"},on:{"click":function($event){_vm.open()}}},[_c('i',{staticClass:"el-icon-plus mr-2"}),_vm._v("Add Main Category")])],1),_vm._v(" "),_c('el-alert',{attrs:{"title":"Category names cannot edit once created. So please check before saving.","type":"warning","center":"","show-icon":""}}),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData}},[_c('el-table-column',{attrs:{"label":"Main Category","width":"180"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticStyle:{"margin-left":"10px"}},[_vm._v(_vm._s(scope.row.mainCategory))]),_vm._v(" "),_c('el-button',{attrs:{"type":"danger","plain":"","size":"mini","icon":"el-icon-delete","circle":""},on:{"click":function($event){_vm.openDelete(scope.row.mainCategory)}}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Sub Categries"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"name-wrapper"},[_vm._l((scope.row.subCategories),function(name){return _c('el-tag',{key:name,staticStyle:{"margin":"5px","font-size":"15px"},attrs:{"type":"info","closable":"","disable-transitions":false},on:{"close":function($event){_vm.openDelete2(name, scope.$index, scope.row)}}},[_vm._v("\n              "+_vm._s(name)+"\n            ")])}),_vm._v(" "),(scope.row.inputVisible)?_c('el-input',{ref:scope.$index,staticClass:"input-new-tag",attrs:{"size":"mini","placeholder":"Hit enter to save"},on:{"blur":function($event){_vm.handleInputConfirm(scope.$index, scope.row)}},nativeOn:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }
                _vm.handleInputConfirm(scope.$index, scope.row)
              }},model:{value:(scope.row.newCategory),callback:function ($$v) {_vm.$set(scope.row, "newCategory", $$v)},expression:"scope.row.newCategory"}}):_c('el-button',{staticClass:"button-new-tag",attrs:{"plain":"","size":"small","type":"success"},on:{"click":function($event){_vm.showInput(("new-tag-" + (scope.$index)), scope.row)}}},[_vm._v("+ Add New")])],2)]}}])})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Analytics_vue__ = __webpack_require__(419);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bcb74fa4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Analytics_vue__ = __webpack_require__(865);
function injectStyle (ssrContext) {
  __webpack_require__(852)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bcb74fa4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Analytics_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bcb74fa4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Analytics_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 852 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AreaChart_vue__ = __webpack_require__(420);
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AreaChart_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 854 */,
/* 855 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"month-picker__container",class:( _obj = {
    'year-picker': _vm.yearOnly
  }, _obj[("month-picker--" + _vm.variant)] = true, _obj )},[(_vm.showYear)?_c('div',{staticClass:"month-picker__year"},[_c('button',{attrs:{"type":"button"},on:{"click":function($event){_vm.changeYear(-1)}}},[_vm._v("‹")]),_vm._v(" "),(!_vm.editableYear)?_c('p',[_vm._v("\n      "+_vm._s(_vm.year)+"\n    ")]):_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.year),expression:"year",modifiers:{"number":true}}],attrs:{"type":"text"},domProps:{"value":(_vm.year)},on:{"change":function($event){_vm.onChange()},"input":function($event){if($event.target.composing){ return; }_vm.year=_vm._n($event.target.value)},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),_c('button',{attrs:{"type":"button"},on:{"click":function($event){_vm.changeYear(+1)}}},[_vm._v("›")])]):_vm._e(),_vm._v(" "),(!_vm.yearOnly)?_c('div',{staticClass:"month-picker"},_vm._l((_vm.monthsByLang),function(month,monthIndex){return _c('div',{key:month,staticClass:"month-picker__month",class:{
        inactive: _vm.isInactive(month),
        clearable: _vm.clearable,
        selected:
          (_vm.highlightExactDate &&
            !_vm.range &&
            _vm.showYear &&
            _vm.currentMonthIndex === monthIndex &&
            _vm.year === _vm.selectedYear) ||
          (!_vm.range && !_vm.showYear && _vm.currentMonthIndex == monthIndex) ||
          (!_vm.highlightExactDate && !_vm.range && _vm.currentMonthIndex === monthIndex),
        'selected-range':
          _vm.range &&
          monthIndex > _vm.firstRangeMonthIndex &&
          monthIndex < _vm.secondRangeMonthIndex,
        'selected-range-first': _vm.range && _vm.firstRangeMonthIndex === monthIndex,
        'selected-range-second': _vm.range && _vm.secondRangeMonthIndex === monthIndex
      },on:{"click":function($event){_vm.selectMonth(monthIndex, true)}}},[_vm._v("\n      "+_vm._s(month)+"\n    ")])})):_vm._e()])
var _obj;}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_MonthPickerInput_vue__ = __webpack_require__(426);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_6ad07065_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_MonthPickerInput_vue__ = __webpack_require__(864);
function injectStyle (ssrContext) {
  __webpack_require__(863)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6ad07065"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_MonthPickerInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_6ad07065_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_MonthPickerInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 863 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.hide),expression:"hide"}],staticClass:"month-picker-input-container"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedDate),expression:"selectedDate"}],staticClass:"month-picker-input",attrs:{"type":"text","placeholder":_vm.placeholder,"readonly":""},domProps:{"value":(_vm.selectedDate)},on:{"click":function($event){_vm.showMonthPicker()},"input":function($event){if($event.target.composing){ return; }_vm.selectedDate=$event.target.value}}}),_vm._v(" "),_c('month-picker',{directives:[{name:"show",rawName:"v-show",value:(_vm.monthPickerVisible),expression:"monthPickerVisible"}],attrs:{"default-year":_vm.defaultYear,"default-month":_vm.defaultMonth,"lang":_vm.lang,"months":_vm.months,"no-default":_vm.noDefault,"show-year":_vm.showYear,"highlight-exact-date":_vm.highlightExactDate,"clearable":_vm.clearable,"variant":_vm.variant,"editable-year":_vm.editableYear,"max-date":_vm.maxDate,"min-date":_vm.minDate,"year-only":_vm.yearOnly,"range":_vm.range},on:{"input":_vm.populateInput,"change":_vm.updateDate}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[(_vm.loading)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Loading")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.changed)?_c('div',[_c('el-card',{staticStyle:{"background-color":"#f5f7fa","overflow":"initial","margin-top":"20px"},attrs:{"shadow":"always"}},[_c('b-row',[_c('b-col',{staticClass:"my-1",attrs:{"sm":"3"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":"Year"}},[_c('el-date-picker',{attrs:{"picker-options":{ disabledDate: function (time) { return _vm.disabledDate(time); } },"type":"year","placeholder":"Year"},on:{"change":
                function () {
                  _vm.getGraphData();
                }
              },model:{value:(_vm.year),callback:function ($$v) {_vm.year=$$v},expression:"year"}})],1)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"sm":"3"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":"Store Location"}},[_c('b-form-select',{attrs:{"placeholder":"Store Location","options":_vm.stores},on:{"change":
                function (id) {
                  _vm.storeLocation = id;
                  _vm.getGraphData();
                }
              },model:{value:(_vm.storeLocation),callback:function ($$v) {_vm.storeLocation=$$v},expression:"storeLocation"}})],1)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"sm":"3"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":"Main Category"}},[_c('b-form-select',{attrs:{"placeholder":"Main Category","options":_vm.mainCategories},on:{"change":
                function (value) {
                  _vm.mainCategory = value;
                  _vm.subCategories = [
                    {
                      value: null,
                      text: 'Select Sub Category',
                      disabled: true,
                    } ];
                  _vm.subCategory = null;
                  Object.keys(_vm.categories[_vm.mainCategory]).forEach(
                    function (subcat, index) { return _vm.subCategories.push(subcat); }
                  );
                  _vm.getGraphData();
                }
              },model:{value:(_vm.mainCategory),callback:function ($$v) {_vm.mainCategory=$$v},expression:"mainCategory"}})],1)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"sm":"3"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":"Sub Category"}},[_c('b-form-select',{attrs:{"placeholder":"Sub Category","options":_vm.subCategories},on:{"change":
                function (value) {
                  _vm.subCategory = value;
                  _vm.getGraphData();
                }
              },model:{value:(_vm.subCategory),callback:function ($$v) {_vm.subCategory=$$v},expression:"subCategory"}})],1)],1)],1)],1),_vm._v(" "),_c('el-card',{staticClass:"my-4",staticStyle:{"background-color":"#dcdfe6"},attrs:{"shadow":"always"}},[_c('h5',{staticClass:"mb-3",staticStyle:{"text-align":"center"}},[_vm._v("Store Summary for Year")]),_vm._v(" "),_c('el-card',{staticStyle:{"overflow-x":"scroll"},attrs:{"shadow":"always"}},[_c('b-table',{staticClass:"mt-4",attrs:{"show-empty":"","stacked":"sm","items":_vm.reports,"fields":_vm.summaryFields,"hover":true,"head-variant":"dark","empty-text":"No records to show"}})],1),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%","margin-top":"30px"},attrs:{"data":_vm.tableData,"row-key":"id"}},[_c('el-table-column',{attrs:{"prop":"category","label":"Category","sortable":"","width":"260"}}),_vm._v(" "),_vm._l((_vm.months),function(month,index){return _c('el-table-column',{key:index,attrs:{"label":month}},[_c('el-table-column',{attrs:{"label":"Sales LKR","width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n              "+_vm._s(scope.row.salesProfit[month]
                  ? scope.row.salesProfit[month].sales
                    ? ("" + (scope.row.salesProfit[month].sales.toLocaleString()))
                    : "-"
                  : "-"))]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Profit LKR","width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n              "+_vm._s(scope.row.salesProfit[month]
                  ? scope.row.salesProfit[month].profit
                    ? ("" + (scope.row.salesProfit[
                        month
                      ].profit.toLocaleString()))
                    : "-"
                  : "-")+"\n            ")]}}])})],1)})],2)],1),_vm._v(" "),_c('el-row',{staticStyle:{"margin-top":"20px"},attrs:{"justify":"space-between"}},[_c('el-col',{attrs:{"xs":24,"sm":24,"md":20,"lg":16,"xl":16,"offset":_vm.offset}},[_c('h5',{staticClass:"text-secondary mb-3",staticStyle:{"text-align":"center"}},[_vm._v("\n          Sales by Category per Month\n        ")]),_vm._v(" "),_c('el-card',{staticStyle:{"background-color":"#233964"},attrs:{"shadow":"always"}},[(_vm.reports.length > 0)?_c('AreaChart',{attrs:{"areaChartDataset":_vm.datasets,"areaChartLabels":_vm.labels}}):_vm._e(),_vm._v(" "),(_vm.reports.length === 0)?_c('div',[_c('p',{staticClass:"text-white mx-auto"},[_vm._v("No Data")])]):_vm._e()],1)],1),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":24,"md":20,"lg":16,"xl":16,"offset":_vm.offset}},[_c('h5',{staticClass:"text-secondary mt-5",staticStyle:{"text-align":"center"}},[_vm._v("\n          Total Sales per Month\n        ")]),_vm._v(" "),_c('el-card',{staticClass:"mt-3",staticStyle:{"background-color":"#263450"},attrs:{"shadow":"always"}},[(_vm.reports.length > 0)?_c('BarChart',{attrs:{"barChartDataset":_vm.barChartDataset,"barChartLabels":_vm.labels}}):_vm._e(),_vm._v(" "),(_vm.reports.length === 0)?_c('div',[_c('p',{staticClass:"text-white mx-auto"},[_vm._v("No Data")])]):_vm._e()],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"row mb-5 col-md-8",staticStyle:{"background-color":"#eee"}}),_vm._v(" "),_c('div',{staticClass:"row mb-5 col-md-8",staticStyle:{"background-color":"#eee"}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Returns_vue__ = __webpack_require__(427);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e5ef4470_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Returns_vue__ = __webpack_require__(868);
function injectStyle (ssrContext) {
  __webpack_require__(867)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e5ef4470"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Returns_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e5ef4470_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Returns_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 867 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReturnsGRN_vue__ = __webpack_require__(428);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_298f9024_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReturnsGRN_vue__ = __webpack_require__(871);
function injectStyle (ssrContext) {
  __webpack_require__(870)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-298f9024"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReturnsGRN_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_298f9024_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReturnsGRN_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 870 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Users_vue__ = __webpack_require__(429);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52ff7a5e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Users_vue__ = __webpack_require__(874);
function injectStyle (ssrContext) {
  __webpack_require__(873)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-52ff7a5e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Users_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52ff7a5e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Users_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 873 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Updating")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.loading1)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Loading")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.loading2)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Deleting")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.changed)?_c('div',[_c('div',{staticClass:"m-auto text-right pt-3"},[(_vm.displayName !== 'starterplan shop owner')?_c('el-button',{attrs:{"type":"primary","size":"medium"},on:{"click":function($event){_vm.dialogFormVisible2 = true}}},[_c('i',{staticClass:"el-icon-plus mr-2"}),_vm._v("Add User")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-sm-12 col-md-8 col-lg-6 m-auto pl-4"},[_c('el-dialog',{attrs:{"title":"Add User","visible":_vm.dialogFormVisible2,"width":_vm.width},on:{"update:visible":function($event){_vm.dialogFormVisible2=$event}}},[_c('el-card',{staticStyle:{"background-color":"#f5f7fa"},attrs:{"shadow":"always"}},[_c('el-form',{ref:"formdata",staticStyle:{"<!-- border":"1px solid #e2e2e2","border-radius":"5px","-->\n              background-color":"#fff","padding":"25px"},attrs:{"model":_vm.formdata,"status-icon":"","rules":_vm.rules2,"label-width":"120px","label-position":_vm.labelPosition,"size":"medium"}},[_c('el-form-item',{attrs:{"label":"Name","prop":"name","rules":[
                { required: true, message: 'User name', trigger: 'blur' } ]}},[_c('el-input',{attrs:{"placeholder":"Name"},model:{value:(_vm.formdata.name),callback:function ($$v) {_vm.$set(_vm.formdata, "name", $$v)},expression:"formdata.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"System ID (non-editable)","prop":"sysid","rules":[
                { required: true, message: 'System ID', trigger: 'blur' } ]}},[_c('el-input',{attrs:{"placeholder":"System ID"},model:{value:(_vm.formdata.sysid),callback:function ($$v) {_vm.$set(_vm.formdata, "sysid", $$v)},expression:"formdata.sysid"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Telephone Without 0","prop":"telephone","rules":[
                { required: true, message: 'Telephone' },
                { type: 'number', message: 'telephone no must be a number' } ]}},[_c('el-input',{attrs:{"auto-complete":"off","placeholder":"Telephone"},model:{value:(_vm.formdata.telephone),callback:function ($$v) {_vm.$set(_vm.formdata, "telephone", _vm._n($$v))},expression:"formdata.telephone"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"User Role","prop":"role","rules":[
                { required: true, message: 'User role', trigger: 'change' } ]}},[_c('el-select',{attrs:{"placeholder":"User Role"},on:{"change":_vm.handleSelect},model:{value:(_vm.formdata.role),callback:function ($$v) {_vm.$set(_vm.formdata, "role", $$v)},expression:"formdata.role"}},[_c('el-option',{attrs:{"value":"Admin"}},[_vm._v("Admin")]),_vm._v(" "),_c('el-option',{attrs:{"value":"Cashier"}},[_vm._v("Cashier")]),_vm._v(" "),_c('el-option',{attrs:{"value":"Shop Manager"}},[_vm._v("Manager")]),_vm._v(" "),_c('el-option',{attrs:{"value":"Technician"}},[_vm._v("Technician")]),_vm._v(" "),(_vm.shopCategory === 'Food / Restaurants')?_c('el-option',{attrs:{"value":"Service Staff"}},[_vm._v("Service Staff")]):_vm._e(),_vm._v(" "),(_vm.shopCategory === 'Food / Restaurants')?_c('el-option',{attrs:{"value":"Kitchen Staff"}},[_vm._v("Kitchen Staff")]):_vm._e()],1)],1),_vm._v(" "),(_vm.formdata.role !== 'Admin')?_c('el-form-item',{attrs:{"label":"Select Store","prop":"store","rules":[
                {
                  required: true,
                  message: 'Select Store',
                  trigger: 'change',
                } ]}},[_c('el-select',{attrs:{"multiple":"","placeholder":"Select Store"},model:{value:(_vm.formdata.store),callback:function ($$v) {_vm.$set(_vm.formdata, "store", $$v)},expression:"formdata.store"}},_vm._l((_vm.$store.state.stores),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.id}})}))],1):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":"City/Town","prop":"city"}},[_c('el-input',{attrs:{"placeholder":"City/Town"},model:{value:(_vm.formdata.city),callback:function ($$v) {_vm.$set(_vm.formdata, "city", $$v)},expression:"formdata.city"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"email","label":"Email","rules":[
                {
                  type: 'email',
                  message: 'Please input correct email address',
                  trigger: ['blur', 'change'],
                } ]}},[_c('el-input',{attrs:{"placeholder":"Email","type":"email"},model:{value:(_vm.formdata.email),callback:function ($$v) {_vm.$set(_vm.formdata, "email", $$v)},expression:"formdata.email"}})],1),_vm._v(" "),(
                _vm.formdata.role !== 'Admin'
              )?_c('el-form-item',{attrs:{"label":"Permissions List"}},[_c('el-checkbox-group',{model:{value:(_vm.formdata.permissions),callback:function ($$v) {_vm.$set(_vm.formdata, "permissions", $$v)},expression:"formdata.permissions"}},_vm._l((_vm.permissionsList),function(permission){return _c('el-checkbox',{key:permission,attrs:{"label":permission}},[_vm._v(_vm._s(permission))])}))],1):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Notes","prop":"note"}},[_c('el-input',{attrs:{"type":"textarea"},model:{value:(_vm.formdata.note),callback:function ($$v) {_vm.$set(_vm.formdata, "note", $$v)},expression:"formdata.note"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"pt-2",staticStyle:{"margin-bottom":"0px"}},[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.submitForm('formdata')}}},[_vm._v("Add")]),_vm._v(" "),_c('el-button',{on:{"click":function($event){_vm.resetForm('formdata')}}},[_vm._v("Reset")])],1)],1)],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"danger"},on:{"click":function($event){_vm.dialogFormVisible2 = false}}},[_vm._v("Cancel")])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"col-sm-12 col-md-8 col-lg-6 m-auto pl-4"},[_c('el-dialog',{attrs:{"title":"Edit User","visible":_vm.dialogFormVisible3,"width":_vm.width},on:{"update:visible":function($event){_vm.dialogFormVisible3=$event}}},[_c('el-form',{ref:"formdata2",staticStyle:{"border":"1px solid #e2e2e2","border-radius":"5px","background-color":"#fff","padding":"25px"},attrs:{"model":_vm.formdata2,"status-icon":"","rules":_vm.rules2,"label-width":"120px","label-position":_vm.labelPosition,"size":"medium"}},[_c('el-form-item',{attrs:{"label":"Name","prop":"name","rules":[
              { required: true, message: 'User name', trigger: 'blur' } ]}},[_c('el-input',{attrs:{"placeholder":"Name"},model:{value:(_vm.formdata2.name),callback:function ($$v) {_vm.$set(_vm.formdata2, "name", $$v)},expression:"formdata2.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"System ID","prop":"sysid","rules":[
              { required: true, message: 'System ID', trigger: 'blur' } ]}},[_c('el-input',{attrs:{"disabled":"","placeholder":"System ID"},model:{value:(_vm.formdata2.sysid),callback:function ($$v) {_vm.$set(_vm.formdata2, "sysid", $$v)},expression:"formdata2.sysid"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Telephone Without 0","prop":"telephone","rules":[
              { required: true, message: 'Telephone' },
              { type: 'number', message: 'telephone no must be a number' } ]}},[_c('el-input',{attrs:{"auto-complete":"off","placeholder":"Telephone"},model:{value:(_vm.formdata2.telephone),callback:function ($$v) {_vm.$set(_vm.formdata2, "telephone", _vm._n($$v))},expression:"formdata2.telephone"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"User Role","prop":"role","rules":[
              { required: true, message: 'User role', trigger: 'change' } ]}},[_c('el-select',{attrs:{"placeholder":"User Role"},on:{"change":_vm.handleSelect},model:{value:(_vm.formdata2.role),callback:function ($$v) {_vm.$set(_vm.formdata2, "role", $$v)},expression:"formdata2.role"}},[_c('el-option',{attrs:{"value":"Admin"}},[_vm._v("Admin")]),_vm._v(" "),_c('el-option',{attrs:{"value":"Cashier"}},[_vm._v("Cashier")]),_vm._v(" "),_c('el-option',{attrs:{"value":"Shop Manager"}},[_vm._v("Manager")]),_vm._v(" "),_c('el-option',{attrs:{"value":"Technician"}},[_vm._v("Technician")]),_vm._v(" "),(_vm.shopCategory === 'Food / Restaurants')?_c('el-option',{attrs:{"value":"Service Staff"}},[_vm._v("Service Staff")]):_vm._e(),_vm._v(" "),(_vm.shopCategory === 'Food / Restaurants')?_c('el-option',{attrs:{"value":"Kitchen Staff"}},[_vm._v("Kitchen Staff")]):_vm._e()],1)],1),_vm._v(" "),(_vm.formdata2.role !== 'Admin')?_c('el-form-item',{attrs:{"label":"Select Store","prop":"store","rules":[
              { required: true, message: 'Select Store', trigger: 'change' } ]}},[_c('el-select',{attrs:{"multiple":"","placeholder":"Select Store"},model:{value:(_vm.formdata2.store),callback:function ($$v) {_vm.$set(_vm.formdata2, "store", $$v)},expression:"formdata2.store"}},_vm._l((_vm.$store.state.stores),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.id}})}))],1):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":"City/Town","prop":"city"}},[_c('el-input',{attrs:{"placeholder":"City/Town"},model:{value:(_vm.formdata2.city),callback:function ($$v) {_vm.$set(_vm.formdata2, "city", $$v)},expression:"formdata2.city"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"email","label":"Email","rules":[
              {
                type: 'email',
                message: 'Please input correct email address',
                trigger: ['blur', 'change'],
              } ]}},[_c('el-input',{attrs:{"placeholder":"Email","type":"email"},model:{value:(_vm.formdata2.email),callback:function ($$v) {_vm.$set(_vm.formdata2, "email", $$v)},expression:"formdata2.email"}})],1),_vm._v(" "),(
              _vm.formdata2.role !== 'Admin'
            )?_c('el-form-item',{attrs:{"label":"Permissions List"}},[_c('el-checkbox-group',{model:{value:(_vm.formdata2.permissions),callback:function ($$v) {_vm.$set(_vm.formdata2, "permissions", $$v)},expression:"formdata2.permissions"}},_vm._l((_vm.permissionsList),function(permission){return _c('el-checkbox',{key:permission,attrs:{"label":permission}},[_vm._v(_vm._s(permission))])}))],1):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Notes","prop":"note"}},[_c('el-input',{attrs:{"type":"textarea"},model:{value:(_vm.formdata2.note),callback:function ($$v) {_vm.$set(_vm.formdata2, "note", $$v)},expression:"formdata2.note"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"pt-2",staticStyle:{"margin-bottom":"0px"}},[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.update('formdata2')}}},[_vm._v("Update")])],1)],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"danger"},on:{"click":function($event){_vm.dialogFormVisible3 = false}}},[_vm._v("Cancel")])],1)],1)],1),_vm._v(" "),_c('b-container',{staticClass:"col-lg-10 mt-1"},[_c('h3',{staticClass:"text-info text-center my-4"},[_vm._v("Users")]),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"my-1",attrs:{"sm":"4"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":""}},[_c('b-input-group',[_c('b-form-input',{attrs:{"placeholder":"Search"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),_c('b-input-group-append',[_c('b-btn',{attrs:{"disabled":!_vm.filter},on:{"click":function($event){_vm.filter = ''}}},[_vm._v("Clear")])],1)],1)],1)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"sm":"5"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":""}},[_c('b-input-group',[_c('b-form-select',{attrs:{"options":_vm.sortOptions},model:{value:(_vm.sortBy),callback:function ($$v) {_vm.sortBy=$$v},expression:"sortBy"}},[_c('option',{attrs:{"slot":"first"},domProps:{"value":null},slot:"first"},[_vm._v("Sort By")])]),_vm._v(" "),_c('b-form-select',{attrs:{"slot":"append","disabled":!_vm.sortBy},slot:"append",model:{value:(_vm.sortDesc),callback:function ($$v) {_vm.sortDesc=$$v},expression:"sortDesc"}},[_c('option',{domProps:{"value":false}},[_vm._v("Asc")]),_vm._v(" "),_c('option',{domProps:{"value":true}},[_vm._v("Desc")])])],1)],1)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"sm":"3"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"horizontal":""}},[_c('b-form-select',{model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}},[_c('option',{attrs:{"disabled":""}},[_vm._v("per page")]),_vm._v(" "),_c('option',{domProps:{"value":10}},[_vm._v("10")]),_vm._v(" "),_c('option',{domProps:{"value":25}},[_vm._v("25")]),_vm._v(" "),_c('option',{domProps:{"value":50}},[_vm._v("50")])])],1)],1)],1),_vm._v(" "),_c('el-card',{staticStyle:{"overflow-x":"scroll"},attrs:{"shadow":"always"}},[_c('b-table',{staticClass:"mt-4",attrs:{"show-empty":"","stacked":"sm","items":_vm.items,"fields":_vm.fields,"hover":true,"head-variant":"dark","dark":false,"small":true,"current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter,"empty-text":_vm.emptyText,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event},"filtered":_vm.onFiltered},scopedSlots:_vm._u([{key:"id",fn:function(row){return [_c('div',[_vm._v(_vm._s(row.value))])]}},{key:"actions",fn:function(row){return [_c('div',{staticClass:"btn-group",attrs:{"role":"group","aria-label":"Basic example"}},[_c('el-button',{staticClass:"mt-1 d-block mx-auto",attrs:{"type":"primary","size":"small"},on:{"click":function($event){_vm.showUpdate(row.item)}}},[_vm._v("Edit Details")])],1)]}}])})],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"md":"6"}},[_c('b-pagination',{staticClass:"my-0",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VerifyUser_vue__ = __webpack_require__(430);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_218f36e4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VerifyUser_vue__ = __webpack_require__(877);
function injectStyle (ssrContext) {
  __webpack_require__(876)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-218f36e4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VerifyUser_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_218f36e4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VerifyUser_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 876 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Setting_vue__ = __webpack_require__(431);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bdc412f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Setting_vue__ = __webpack_require__(880);
function injectStyle (ssrContext) {
  __webpack_require__(879)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2bdc412f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Setting_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bdc412f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Setting_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 879 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Updating")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.loading1)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Loading")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.changed)?_c('div',[_c('div',{staticClass:"container mt-5"},[_c('h3',{staticClass:"m-auto text-info text-center pb-4"},[_vm._v("Setting")]),_vm._v(" "),_c('div',{staticClass:"col-sm-12 col-lg-8 m-auto mt-4 bg-white py-4"},[_c('el-form',{ref:"setting",attrs:{"model":_vm.setting,"label-width":"200px","label-position":_vm.label,"size":"medium","status-icon":""},nativeOn:{"submit":function($event){$event.preventDefault();}}},[_c('el-form-item',{attrs:{"label":"Print Paper Size","prop":"printSize"}},[_c('el-select',{attrs:{"placeholder":"Print Paper Size"},model:{value:(_vm.setting.printSize),callback:function ($$v) {_vm.$set(_vm.setting, "printSize", $$v)},expression:"setting.printSize"}},_vm._l((_vm.printSizes),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Show/Hide Browser Print Popup","prop":"printPopup"}},[_c('el-select',{attrs:{"placeholder":"Show/Hide Browser Print Popup"},model:{value:(_vm.setting.printPopup),callback:function ($$v) {_vm.$set(_vm.setting, "printPopup", $$v)},expression:"setting.printPopup"}},_vm._l((_vm.printPopupMode),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Enable Print Only Button","prop":"printOnly"}},[_c('el-checkbox',{model:{value:(_vm.setting.printOnly),callback:function ($$v) {_vm.$set(_vm.setting, "printOnly", $$v)},expression:"setting.printOnly"}},[_vm._v("Enable Print Only Button")])],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Tax Calculation Mode","prop":"taxMode"}},[_c('el-select',{attrs:{"placeholder":"Tax Calculation Mode"},model:{value:(_vm.setting.taxMode),callback:function ($$v) {_vm.$set(_vm.setting, "taxMode", $$v)},expression:"setting.taxMode"}},_vm._l((_vm.discountModes),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Service Charge Calculation Mode","prop":"serviceChargeMode"}},[_c('el-select',{attrs:{"placeholder":"Service Charge Calculation Mode"},model:{value:(_vm.setting.serviceChargeMode),callback:function ($$v) {_vm.$set(_vm.setting, "serviceChargeMode", $$v)},expression:"setting.serviceChargeMode"}},_vm._l((_vm.discountModes),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Digits for Invoice No","prop":"invoDigits"}},[_c('el-select',{attrs:{"placeholder":"Digits for Invoice No"},model:{value:(_vm.setting.invoDigits),callback:function ($$v) {_vm.$set(_vm.setting, "invoDigits", $$v)},expression:"setting.invoDigits"}},_vm._l((_vm.invoDigitsOptions),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Loyalty Points per LKR 1000","prop":"loyalityPoints"}},[_c('el-input-number',{attrs:{"controls-position":"right","min":0},on:{"change":_vm.handleChange},model:{value:(_vm.setting.loyalityPoints),callback:function ($$v) {_vm.$set(_vm.setting, "loyalityPoints", $$v)},expression:"setting.loyalityPoints"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Referrals Points per LKR 1000","prop":"referralPoints"}},[_c('el-input-number',{attrs:{"controls-position":"right","min":0},on:{"change":_vm.handleChange},model:{value:(_vm.setting.referralPoints),callback:function ($$v) {_vm.$set(_vm.setting, "referralPoints", $$v)},expression:"setting.referralPoints"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Invoice Options to Enable"}},[_c('el-checkbox-group',{model:{value:(_vm.setting.invoOptions),callback:function ($$v) {_vm.$set(_vm.setting, "invoOptions", $$v)},expression:"setting.invoOptions"}},_vm._l((_vm.invoOptionsList),function(option){return _c('el-checkbox',{key:option,attrs:{"label":option}},[_vm._v(_vm._s(option))])}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Invoice Footer Content","prop":"footer"}},[_c('el-input',{attrs:{"type":"textarea","maxlength":"450","show-word-limit":"","placeholder":"Footer Content"},model:{value:(_vm.setting.footer),callback:function ($$v) {_vm.$set(_vm.setting, "footer", $$v)},expression:"setting.footer"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Upload Store Logo"}},[_c('el-upload',{ref:"upload",staticClass:"upload-demo",attrs:{"auto-upload":false,"multiple":false,"limit":1,"action":"/","on-change":_vm.fileSelect1}},[_c('el-button',{attrs:{"slot":"trigger","size":"small","type":"success"},slot:"trigger"},[_vm._v("select file")]),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v("\n                jpg/png files with a size less than 500kb\n              ")])],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Uploaded Logo","prop":"logo"}},[_c('img',{attrs:{"src":_vm.image1,"alt":"","width":"240px","height":"80px"}})]),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.upDet('setting')}}},[_vm._v("Update Setting")]),_vm._v(" "),_c('el-button',{attrs:{"type":"warning"},on:{"click":_vm.resetPassword}},[_vm._v("Reset Password")])],1)],1)],1)])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StoreLocations_vue__ = __webpack_require__(432);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39aaf1c2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StoreLocations_vue__ = __webpack_require__(883);
function injectStyle (ssrContext) {
  __webpack_require__(882)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-39aaf1c2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StoreLocations_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39aaf1c2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StoreLocations_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 882 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Updating")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.loading1)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Loading")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.loading2)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Deleting")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.changed)?_c('div',[_c('div',{staticClass:"m-auto text-right pt-3"},[(_vm.displayName !== 'starterplan shop owner')?_c('el-button',{attrs:{"type":"primary","size":"medium"},on:{"click":function($event){_vm.dialogFormVisible2 = true}}},[_c('i',{staticClass:"el-icon-plus mr-2"}),_vm._v("Add Store")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-sm-12 col-md-8 col-lg-6 m-auto pl-4"},[_c('el-dialog',{attrs:{"title":"Add Store","visible":_vm.dialogFormVisible2,"width":_vm.width},on:{"update:visible":function($event){_vm.dialogFormVisible2=$event}}},[_c('el-card',{staticStyle:{"background-color":"#f5f7fa"},attrs:{"shadow":"always"}},[_c('el-form',{ref:"formdata",staticStyle:{"<!-- border":"1px solid #e2e2e2","border-radius":"5px","-->\n              background-color":"#fff","padding":"25px"},attrs:{"model":_vm.formdata,"status-icon":"","rules":_vm.rules2,"label-width":"120px","label-position":_vm.labelPosition,"size":"medium"}},[_c('el-form-item',{attrs:{"label":"Store Name","prop":"name","rules":[
                {
                  required: true,
                  message: 'Store name is requried',
                  trigger: 'blur',
                } ]}},[_c('el-input',{attrs:{"placeholder":"Store Name"},on:{"change":function($event){_vm.checkStoreName(_vm.formdata, 'create')}},model:{value:(_vm.formdata.name),callback:function ($$v) {_vm.$set(_vm.formdata, "name", $$v)},expression:"formdata.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Address","prop":"address"}},[_c('el-input',{attrs:{"rules":[
                  {
                    required: true,
                    message: 'Address is requried',
                    trigger: 'blur',
                  } ],"type":"textarea","placeholder":"Address"},model:{value:(_vm.formdata.address),callback:function ($$v) {_vm.$set(_vm.formdata, "address", $$v)},expression:"formdata.address"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Telephone Without 0","prop":"telephone","rules":[
                { required: true, message: 'telephone no is required' },
                { type: 'number', message: 'telephone no must be a number' } ]}},[_c('el-input',{attrs:{"auto-complete":"off","placeholder":"Telephone"},model:{value:(_vm.formdata.telephone),callback:function ($$v) {_vm.$set(_vm.formdata, "telephone", _vm._n($$v))},expression:"formdata.telephone"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"City/Town","prop":"city"}},[_c('el-input',{attrs:{"placeholder":"City/Town"},model:{value:(_vm.formdata.city),callback:function ($$v) {_vm.$set(_vm.formdata, "city", $$v)},expression:"formdata.city"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"email","label":"Email","rules":[
                {
                  type: 'email',
                  message: 'Please input correct email address',
                  trigger: ['blur', 'change'],
                } ]}},[_c('el-input',{attrs:{"placeholder":"Email","type":"email"},model:{value:(_vm.formdata.email),callback:function ($$v) {_vm.$set(_vm.formdata, "email", $$v)},expression:"formdata.email"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"pt-2",staticStyle:{"margin-bottom":"0px"}},[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.submitForm('formdata')}}},[_vm._v("Add")]),_vm._v(" "),_c('el-button',{on:{"click":function($event){_vm.resetForm('formdata')}}},[_vm._v("Reset")])],1)],1)],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"danger"},on:{"click":function($event){_vm.dialogFormVisible2 = false}}},[_vm._v("Cancel")])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"col-sm-12 col-md-8 col-lg-6 m-auto pl-4"},[_c('el-dialog',{attrs:{"title":"Edit Store","visible":_vm.dialogFormVisible3,"width":_vm.width},on:{"update:visible":function($event){_vm.dialogFormVisible3=$event}}},[_c('el-form',{ref:"formdata2",staticStyle:{"border":"1px solid #e2e2e2","border-radius":"5px","background-color":"#fff","padding":"25px"},attrs:{"model":_vm.formdata2,"status-icon":"","rules":_vm.rules2,"label-width":"120px","label-position":_vm.labelPosition,"size":"medium"}},[_c('el-form-item',{attrs:{"label":"Store Name","prop":"name","rules":[
              {
                required: true,
                message: 'Store name is requried',
                trigger: 'blur',
              } ]}},[_c('el-input',{attrs:{"placeholder":"Store Name"},on:{"change":function($event){_vm.checkStoreName(_vm.formdata2, 'update')}},model:{value:(_vm.formdata2.name),callback:function ($$v) {_vm.$set(_vm.formdata2, "name", $$v)},expression:"formdata2.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Address","prop":"address"}},[_c('el-input',{attrs:{"rules":[
                {
                  required: true,
                  message: 'Address is requried',
                  trigger: 'blur',
                } ],"type":"textarea","placeholder":"Address"},model:{value:(_vm.formdata2.address),callback:function ($$v) {_vm.$set(_vm.formdata2, "address", $$v)},expression:"formdata2.address"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Telephone Without 0","prop":"telephone","rules":[
              { required: true, message: 'telephone no is required' },
              { type: 'number', message: 'telephone no must be a number' } ]}},[_c('el-input',{attrs:{"auto-complete":"off","placeholder":"Telephone"},model:{value:(_vm.formdata2.telephone),callback:function ($$v) {_vm.$set(_vm.formdata2, "telephone", _vm._n($$v))},expression:"formdata2.telephone"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"City/Town","prop":"city"}},[_c('el-input',{attrs:{"placeholder":"City/Town"},model:{value:(_vm.formdata2.city),callback:function ($$v) {_vm.$set(_vm.formdata2, "city", $$v)},expression:"formdata2.city"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"email","label":"Email","rules":[
              {
                type: 'email',
                message: 'Please input correct email address',
                trigger: ['blur', 'change'],
              } ]}},[_c('el-input',{attrs:{"placeholder":"Email","type":"email"},model:{value:(_vm.formdata2.email),callback:function ($$v) {_vm.$set(_vm.formdata2, "email", $$v)},expression:"formdata2.email"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"pt-2",staticStyle:{"margin-bottom":"0px"}},[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.update('formdata2')}}},[_vm._v("Update")])],1)],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"danger"},on:{"click":function($event){_vm.dialogFormVisible3 = false}}},[_vm._v("Cancel")])],1)],1)],1),_vm._v(" "),_c('b-container',{staticClass:"col-lg-10 mt-1"},[_c('h3',{staticClass:"text-info text-center my-4"},[_vm._v("Stores")]),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"my-1",attrs:{"sm":"4"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":""}},[_c('b-input-group',[_c('b-form-input',{attrs:{"placeholder":"Search"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),_c('b-input-group-append',[_c('b-btn',{attrs:{"disabled":!_vm.filter},on:{"click":function($event){_vm.filter = ''}}},[_vm._v("Clear")])],1)],1)],1)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"sm":"5"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":""}},[_c('b-input-group',[_c('b-form-select',{attrs:{"options":_vm.sortOptions},model:{value:(_vm.sortBy),callback:function ($$v) {_vm.sortBy=$$v},expression:"sortBy"}},[_c('option',{attrs:{"slot":"first"},domProps:{"value":null},slot:"first"},[_vm._v("Sort By")])]),_vm._v(" "),_c('b-form-select',{attrs:{"slot":"append","disabled":!_vm.sortBy},slot:"append",model:{value:(_vm.sortDesc),callback:function ($$v) {_vm.sortDesc=$$v},expression:"sortDesc"}},[_c('option',{domProps:{"value":false}},[_vm._v("Asc")]),_vm._v(" "),_c('option',{domProps:{"value":true}},[_vm._v("Desc")])])],1)],1)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"sm":"3"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"horizontal":""}},[_c('b-form-select',{model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}},[_c('option',{attrs:{"disabled":""}},[_vm._v("per page")]),_vm._v(" "),_c('option',{domProps:{"value":10}},[_vm._v("10")]),_vm._v(" "),_c('option',{domProps:{"value":25}},[_vm._v("25")]),_vm._v(" "),_c('option',{domProps:{"value":50}},[_vm._v("50")])])],1)],1)],1),_vm._v(" "),_c('el-card',{staticStyle:{"overflow-x":"scroll"},attrs:{"shadow":"always"}},[_c('b-table',{staticClass:"mt-4",attrs:{"show-empty":"","stacked":"sm","items":_vm.items,"fields":_vm.fields,"hover":true,"head-variant":"dark","dark":false,"small":true,"current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter,"empty-text":_vm.emptyText,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event},"filtered":_vm.onFiltered},scopedSlots:_vm._u([{key:"id",fn:function(row){return [_c('div',[_vm._v(_vm._s(row.value))])]}},{key:"actions",fn:function(row){return [_c('div',{staticClass:"btn-group",attrs:{"role":"group","aria-label":"Basic example"}},[_c('a',{staticClass:"btn btn-sm btn-primary text-white",attrs:{"size":"sm"},on:{"click":function($event){_vm.showUpdate(row.item)}}},[_vm._v("\n                Edit\n              ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-success text-white",attrs:{"href":("tel:" + (row.item.telephone)),"size":"sm"}},[_vm._v("\n                Call\n              ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-secondary text-white",attrs:{"href":("sms:" + (row.item.telephone)),"size":"sm"}},[_vm._v("\n                SMS\n              ")])])]}},{key:"row-details",fn:function(row){return [_c('div',{staticClass:"mx-auto"},[_c('el-button',{staticClass:"mt-1 d-block mx-auto",attrs:{"type":"info","size":"small"},on:{"click":function($event){_vm.showUpdate(row.item)}}},[_vm._v("Edit Details")])],1)]}}])})],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"md":"6"}},[_c('b-pagination',{staticClass:"my-0",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Suppliers_vue__ = __webpack_require__(433);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d104af3_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Suppliers_vue__ = __webpack_require__(886);
function injectStyle (ssrContext) {
  __webpack_require__(885)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2d104af3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Suppliers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d104af3_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Suppliers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 885 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Updating")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.loading1)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Loading")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.loading2)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Deleting")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.changed)?_c('div',[_c('div',{staticClass:"m-auto text-right pt-3"},[_c('el-button',{attrs:{"type":"primary","size":"medium"},on:{"click":function($event){_vm.dialogFormVisible2 = true}}},[_c('i',{staticClass:"el-icon-plus mr-2"}),_vm._v("Add Supplier")])],1),_vm._v(" "),_c('div',{staticClass:"col-sm-12 col-md-8 col-lg-6 m-auto pl-4"},[_c('el-dialog',{attrs:{"title":"Add Supplier","visible":_vm.dialogFormVisible2,"width":_vm.width},on:{"update:visible":function($event){_vm.dialogFormVisible2=$event}}},[_c('el-card',{staticStyle:{"background-color":"#f5f7fa"},attrs:{"shadow":"always"}},[_c('el-form',{ref:"formdata",staticStyle:{"<!-- border":"1px solid #e2e2e2","border-radius":"5px","-->\n              background-color":"#fff","padding":"25px"},attrs:{"model":_vm.formdata,"status-icon":"","rules":_vm.rules2,"label-width":"120px","label-position":_vm.labelPosition,"size":"medium"}},[_c('el-form-item',{attrs:{"label":"Name","prop":"name","rules":[
                { required: true, message: 'Supplier name', trigger: 'blur' } ]}},[_c('el-input',{attrs:{"placeholder":"Name"},model:{value:(_vm.formdata.name),callback:function ($$v) {_vm.$set(_vm.formdata, "name", $$v)},expression:"formdata.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Telephone Without 0","prop":"telephone","rules":[
                { required: true, message: 'telephone no is required' },
                { type: 'number', message: 'telephone no must be a number' } ]}},[_c('el-input',{attrs:{"auto-complete":"off","placeholder":"Telephone"},on:{"change":function($event){_vm.checkTelephone(_vm.formdata, 'create')}},model:{value:(_vm.formdata.telephone),callback:function ($$v) {_vm.$set(_vm.formdata, "telephone", _vm._n($$v))},expression:"formdata.telephone"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"City/Town","prop":"city"}},[_c('el-input',{attrs:{"placeholder":"City/Town"},model:{value:(_vm.formdata.city),callback:function ($$v) {_vm.$set(_vm.formdata, "city", $$v)},expression:"formdata.city"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"email","label":"Email","rules":[
                {
                  type: 'email',
                  message: 'Please input correct email address',
                  trigger: ['blur', 'change'],
                } ]}},[_c('el-input',{attrs:{"placeholder":"Email","type":"email"},model:{value:(_vm.formdata.email),callback:function ($$v) {_vm.$set(_vm.formdata, "email", $$v)},expression:"formdata.email"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Notes","prop":"note"}},[_c('el-input',{attrs:{"type":"textarea"},model:{value:(_vm.formdata.note),callback:function ($$v) {_vm.$set(_vm.formdata, "note", $$v)},expression:"formdata.note"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"pt-2",staticStyle:{"margin-bottom":"0px"}},[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.submitForm('formdata')}}},[_vm._v("Add")]),_vm._v(" "),_c('el-button',{on:{"click":function($event){_vm.resetForm('formdata')}}},[_vm._v("Reset")])],1)],1)],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"danger"},on:{"click":function($event){_vm.dialogFormVisible2 = false}}},[_vm._v("Cancel")])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"col-sm-12 col-md-8 col-lg-6 m-auto pl-4"},[_c('el-dialog',{attrs:{"title":"Edit Supplier","visible":_vm.dialogFormVisible3,"width":_vm.width},on:{"update:visible":function($event){_vm.dialogFormVisible3=$event}}},[_c('el-form',{ref:"formdata2",staticStyle:{"border":"1px solid #e2e2e2","border-radius":"5px","background-color":"#fff","padding":"25px"},attrs:{"model":_vm.formdata2,"status-icon":"","rules":_vm.rules2,"label-width":"120px","label-position":_vm.labelPosition,"size":"medium"}},[_c('el-form-item',{attrs:{"label":"Name","prop":"name","rules":[
              { required: true, message: 'Supplier name', trigger: 'blur' } ]}},[_c('el-input',{attrs:{"placeholder":"Name"},model:{value:(_vm.formdata2.name),callback:function ($$v) {_vm.$set(_vm.formdata2, "name", $$v)},expression:"formdata2.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Telephone Without 0","prop":"telephone","rules":[
              { required: true, message: 'telephone no is required' },
              { type: 'number', message: 'telephone no must be a number' } ]}},[_c('el-input',{attrs:{"auto-complete":"off","placeholder":"Telephone"},on:{"change":function($event){_vm.checkTelephone(_vm.formdata2, 'update')}},model:{value:(_vm.formdata2.telephone),callback:function ($$v) {_vm.$set(_vm.formdata2, "telephone", _vm._n($$v))},expression:"formdata2.telephone"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"City/Town","prop":"city"}},[_c('el-input',{attrs:{"placeholder":"City/Town"},model:{value:(_vm.formdata2.city),callback:function ($$v) {_vm.$set(_vm.formdata2, "city", $$v)},expression:"formdata2.city"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"email","label":"Email","rules":[
              {
                type: 'email',
                message: 'Please input correct email address',
                trigger: ['blur', 'change'],
              } ]}},[_c('el-input',{attrs:{"placeholder":"Email","type":"email"},model:{value:(_vm.formdata2.email),callback:function ($$v) {_vm.$set(_vm.formdata2, "email", $$v)},expression:"formdata2.email"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Notes","prop":"note"}},[_c('el-input',{attrs:{"type":"textarea"},model:{value:(_vm.formdata2.note),callback:function ($$v) {_vm.$set(_vm.formdata2, "note", $$v)},expression:"formdata2.note"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"pt-2",staticStyle:{"margin-bottom":"0px"}},[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.update('formdata2')}}},[_vm._v("Update")])],1)],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"danger"},on:{"click":function($event){_vm.dialogFormVisible3 = false}}},[_vm._v("Cancel")])],1)],1)],1),_vm._v(" "),_c('b-container',{staticClass:"col-lg-10 mt-1"},[_c('h3',{staticClass:"text-info text-center my-4"},[_vm._v("Suppliers")]),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"my-1",attrs:{"sm":"4"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":""}},[_c('b-input-group',[_c('b-form-input',{attrs:{"placeholder":"Search"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),_c('b-input-group-append',[_c('b-btn',{attrs:{"disabled":!_vm.filter},on:{"click":function($event){_vm.filter = ''}}},[_vm._v("Clear")])],1)],1)],1)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"sm":"5"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":""}},[_c('b-input-group',[_c('b-form-select',{attrs:{"options":_vm.sortOptions},model:{value:(_vm.sortBy),callback:function ($$v) {_vm.sortBy=$$v},expression:"sortBy"}},[_c('option',{attrs:{"slot":"first"},domProps:{"value":null},slot:"first"},[_vm._v("Sort By")])]),_vm._v(" "),_c('b-form-select',{attrs:{"slot":"append","disabled":!_vm.sortBy},slot:"append",model:{value:(_vm.sortDesc),callback:function ($$v) {_vm.sortDesc=$$v},expression:"sortDesc"}},[_c('option',{domProps:{"value":false}},[_vm._v("Asc")]),_vm._v(" "),_c('option',{domProps:{"value":true}},[_vm._v("Desc")])])],1)],1)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"sm":"3"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"horizontal":""}},[_c('b-form-select',{model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}},[_c('option',{attrs:{"disabled":""}},[_vm._v("per page")]),_vm._v(" "),_c('option',{domProps:{"value":10}},[_vm._v("10")]),_vm._v(" "),_c('option',{domProps:{"value":25}},[_vm._v("25")]),_vm._v(" "),_c('option',{domProps:{"value":50}},[_vm._v("50")])])],1)],1)],1),_vm._v(" "),_c('el-card',{staticStyle:{"overflow-x":"scroll"},attrs:{"shadow":"always"}},[_c('b-table',{staticClass:"mt-4",attrs:{"show-empty":"","stacked":"sm","items":_vm.items,"fields":_vm.fields,"hover":true,"head-variant":"dark","dark":false,"small":true,"current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter,"empty-text":_vm.emptyText,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event},"filtered":_vm.onFiltered},scopedSlots:_vm._u([{key:"id",fn:function(row){return [_c('div',[_vm._v(_vm._s(row.value))])]}},{key:"actions",fn:function(row){return [_c('div',{staticClass:"btn-group",attrs:{"role":"group","aria-label":"Basic example"}},[_c('a',{staticClass:"btn btn-sm btn-primary text-white",attrs:{"size":"sm"},on:{"click":function($event){_vm.showUpdate(row.item)}}},[_vm._v("\n                Edit\n              ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-success text-white",attrs:{"href":("tel:" + (row.item.telephone)),"size":"sm"}},[_vm._v("\n                Call\n              ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-secondary text-white",attrs:{"href":("sms:" + (row.item.telephone)),"size":"sm"}},[_vm._v("\n                SMS\n              ")])])]}},{key:"row-details",fn:function(row){return [_c('div',{staticClass:"mx-auto"},[_c('el-button',{staticClass:"mt-1 d-block mx-auto",attrs:{"type":"info","size":"small"},on:{"click":function($event){_vm.showUpdate(row.item)}}},[_vm._v("Edit Details")])],1)]}}])})],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"md":"6"}},[_c('b-pagination',{staticClass:"my-0",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CashFlow_vue__ = __webpack_require__(434);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a99b1d54_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CashFlow_vue__ = __webpack_require__(891);
function injectStyle (ssrContext) {
  __webpack_require__(888)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a99b1d54"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CashFlow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a99b1d54_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CashFlow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 888 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CFAddDeductTable_vue__ = __webpack_require__(435);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_082c4c1f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CFAddDeductTable_vue__ = __webpack_require__(890);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CFAddDeductTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_082c4c1f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CFAddDeductTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-table',{ref:"singleTable",staticStyle:{"{\n        overflow-x":"scroll"},attrs:{"data":_vm.cashData,"highlight-current-row":""}},[_c('el-table-column',{attrs:{"property":"date","label":"Date"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-date-picker',{attrs:{"size":"small","type":"date","picker-options":{
            disabledDate: function (time) { return _vm.disabledDate(time); },
          },"placeholder":"Pick a date"},model:{value:(scope.row.date),callback:function ($$v) {_vm.$set(scope.row, "date", $$v)},expression:"scope.row.date"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"property":"type","label":"Type"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-select',{attrs:{"size":"small","placeholder":"Type"},on:{"change":_vm.updateCashData},model:{value:(scope.row.type),callback:function ($$v) {_vm.$set(scope.row, "type", $$v)},expression:"scope.row.type"}},[_c('el-option',{attrs:{"label":"Addition","value":"add"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"Deduction","value":"deduct"}})],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"150","property":"amount","label":"Amount"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-input-number',{attrs:{"size":"small","precision":2,"min":0},on:{"change":_vm.updateCashData},model:{value:(scope.row.amount),callback:function ($$v) {_vm.$set(scope.row, "amount", $$v)},expression:"scope.row.amount"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"250","property":"note","label":"Note"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-input',{attrs:{"size":"small","placeholder":"Note"},model:{value:(scope.row.note),callback:function ($$v) {_vm.$set(scope.row, "note", $$v)},expression:"scope.row.note"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"100","label":""},scopedSlots:_vm._u([{key:"header",fn:function(scope){return [_c('el-button',{attrs:{"size":"small","type":"primary"},on:{"click":function($event){_vm.addRow()}}},[_vm._v("Add Row")])]}},{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"size":"small","type":"danger","icon":"el-icon-delete","circle":""},on:{"click":function($event){_vm.handleDelete(scope.$index, scope.row)}}})]}}])})],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"20px"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Loading")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.loading1)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Updating")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.changed)?_c('el-row',{staticStyle:{"margin-top":"8px"},attrs:{"gutter":10}},[_c('el-col',{staticStyle:{"margin-bottom":"15px"},attrs:{"xs":24,"sm":24,"md":24,"lg":16,"xl":16}},[_c('el-table',{staticStyle:{"width":"100%","margin-bottom":"20px","border-radius":"5px"},attrs:{"size":"mini","height":"305px","data":_vm.notesData}},[_c('el-table-column',{attrs:{"label":"Denomination","prop":"note"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Opening Notes Count","prop":"openCount"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-input-number',{attrs:{"size":"mini","precision":0,"min":0},on:{"change":function($event){_vm.updateOpenAmount(scope.$index, scope.row)}},model:{value:(scope.row.openCount),callback:function ($$v) {_vm.$set(scope.row, "openCount", $$v)},expression:"scope.row.openCount"}})]}}])}),_vm._v(" "),(_vm.$route.query.update)?_c('el-table-column',{attrs:{"label":"Closing Notes Count","prop":"closeCount","width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-input-number',{attrs:{"size":"mini","precision":0,"min":0},on:{"change":function($event){_vm.updateCloseAmount(scope.$index, scope.row)}},model:{value:(scope.row.closeCount),callback:function ($$v) {_vm.$set(scope.row, "closeCount", $$v)},expression:"scope.row.closeCount"}})]}}])}):_vm._e()],1),_vm._v(" "),_c('h6',{staticClass:"mx-auto"},[_vm._v("Cash Additions & Subtractionss")]),_vm._v(" "),_c('CFAddDeductTable',{attrs:{"cashData":_vm.cashData,"updateCashData":_vm.updateCashData}})],1),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":24,"md":24,"lg":8,"xl":8}},[_c('el-card',{staticClass:"box-card",staticStyle:{"background-color":"rgb(56 98 203)","color":"#fff"}},[(_vm.$route.query.update)?_c('div',{staticClass:"clearfix text item"},[_c('span',[_vm._v("Cash Sales")]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","padding":"3px 0"}},[_vm._v(_vm._s(_vm.sales.toLocaleString())+" LKR")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"clearfix text item"},[_c('span',[_vm._v("Cash Open Amount")]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","padding":"3px 0"}},[_c('el-input-number',{attrs:{"size":"mini","precision":0,"min":0},on:{"change":function($event){_vm.updateSummary()}},model:{value:(_vm.open),callback:function ($$v) {_vm.open=$$v},expression:"open"}})],1)]),_vm._v(" "),(_vm.$route.query.update)?_c('div',{staticClass:"clearfix text item"},[_c('span',[_vm._v("Cash Total Addition")]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","padding":"3px 0"}},[_c('el-input-number',{attrs:{"disabled":"","size":"mini","precision":2,"min":0},on:{"change":function($event){_vm.updateSummary()}},model:{value:(_vm.add),callback:function ($$v) {_vm.add=$$v},expression:"add"}})],1)]):_vm._e(),_vm._v(" "),(_vm.$route.query.update)?_c('div',{staticClass:"clearfix text item"},[_c('span',[_vm._v("Cash Total Subtraction")]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","padding":"3px 0"}},[_c('el-input-number',{attrs:{"disabled":"","size":"mini","precision":2,"min":0},on:{"change":function($event){_vm.updateSummary()}},model:{value:(_vm.deduct),callback:function ($$v) {_vm.deduct=$$v},expression:"deduct"}})],1)]):_vm._e(),_vm._v(" "),(_vm.$route.query.update)?_c('div',{staticClass:"clearfix text item"},[_c('span',[_vm._v("Cash should be in the register")]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","padding":"3px 0"}},[_vm._v(_vm._s(_vm.inRegi.toLocaleString())+" LKR")])]):_vm._e(),_vm._v(" "),(_vm.$route.query.update)?_c('div',{staticClass:"clearfix text item"},[_c('span',[_vm._v("Cash Flow Closing Amount")]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","padding":"3px 0"}},[_c('el-input-number',{attrs:{"size":"mini","precision":2,"min":0},on:{"change":function($event){_vm.updateSummary()}},model:{value:(_vm.close),callback:function ($$v) {_vm.close=$$v},expression:"close"}})],1)]):_vm._e(),_vm._v(" "),(_vm.$route.query.update)?_c('div',{staticClass:"clearfix text item"},[_c('span',[_vm._v("Difference")]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","padding":"3px 0"}},[_vm._v(_vm._s(_vm.diff.toLocaleString())+" LKR")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"clearfix text item"},[_c('span',[_vm._v("Notes")]),_vm._v(" "),_c('div',{staticStyle:{"padding":"3px 0"}},[_c('el-input',{attrs:{"rows":8,"type":"textarea"},model:{value:(_vm.desc),callback:function ($$v) {_vm.desc=$$v},expression:"desc"}})],1)]),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('el-button',{staticStyle:{"float":"right","background-color":"#ff6014","margin-top":"10px"},attrs:{"round":"","size":"medium","type":"warning"},on:{"click":_vm.saveCashFlow}},[_vm._v("SAVE")])],1)])],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CashFlowList_vue__ = __webpack_require__(436);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b594195_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CashFlowList_vue__ = __webpack_require__(894);
function injectStyle (ssrContext) {
  __webpack_require__(893)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0b594195"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CashFlowList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b594195_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CashFlowList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 893 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Loading")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.loading1)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Updating")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.loading2)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Deleting")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.changed)?_c('div',{},[_c('b-container',{staticClass:"col-lg-10 mt-5"},[_c('h3',{staticClass:"text-info text-center pt-4 my-4"},[_vm._v("Cash Flow History")]),_vm._v(" "),_c('el-card',{staticStyle:{"background-color":"#f5f7fa","overflow":"initial"},attrs:{"shadow":"always"}},[_c('b-row',[_c('b-col',{staticClass:"my-1",attrs:{"sm":"3"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":""}},[_c('el-date-picker',{attrs:{"size":"medium","picker-options":{
                  disabledDate: function (time) { return _vm.disabledDate(time); },
                },"type":"month","placeholder":"Month"},model:{value:(_vm.month),callback:function ($$v) {_vm.month=$$v},expression:"month"}})],1)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"sm":"3"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":""}},[_c('b-form-select',{attrs:{"placeholder":"Store Location","options":_vm.stores},model:{value:(_vm.storeLocation),callback:function ($$v) {_vm.storeLocation=$$v},expression:"storeLocation"}})],1)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"sm":"3"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":""}},[_c('el-button',{staticStyle:{"display":"block","margin":"0 auto"},attrs:{"type":"primary","size":"medium"},on:{"click":_vm.searchCashFlows}},[_vm._v("Search")])],1)],1),_vm._v(" "),(!_vm.currentCashFlow)?_c('b-col',{staticClass:"my-1",attrs:{"sm":"3"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":""}},[_c('el-button',{staticStyle:{"display":"block","margin":"0 auto"},attrs:{"type":"primary","size":"medium"},on:{"click":function($event){
                  _vm.$router.push({
                    name: 'cash-flow',
                    query: { create: 'true' },
                  })
                }}},[_vm._v("Open Cash Flow")])],1)],1):_vm._e(),_vm._v(" "),(_vm.currentCashFlow)?_c('b-col',{staticClass:"my-1",attrs:{"sm":"3"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":""}},[_c('el-button',{staticStyle:{"display":"block","margin":"0 auto"},attrs:{"type":"primary","size":"medium"},on:{"click":function($event){
                  _vm.$router.push({
                    name: 'cash-flow',
                    query: { update: 'true', id: _vm.currentCashFlow.id },
                  })
                }}},[_vm._v("Update/Close Cash Flow")])],1)],1):_vm._e()],1)],1),_vm._v(" "),_c('el-card',{staticStyle:{"overflow-x":"scroll"},attrs:{"id":"realtable","shadow":"always"}},[_c('TableHeader',{attrs:{"pageOptions":_vm.pageOptions,"fields":_vm.fields,"items":_vm.items,"perPage":_vm.perPage,"month":_vm.month,"visibleFields":undefined,"downloadCSVMethod":'downloadCSVCashFlow'}}),_vm._v(" "),_c('b-table',{staticClass:"mt-4",attrs:{"show-empty":"","stacked":"sm","items":_vm.items,"fields":_vm.fields,"hover":true,"head-variant":"dark","current-page":_vm.currentPage,"per-page":_vm.perPage,"empty-text":_vm.emptyText,"filter":_vm.filter,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event},"filtered":_vm.onFiltered},scopedSlots:_vm._u([{key:"index",fn:function(data){return [_vm._v("\n            "+_vm._s(data.index + 1)+"\n          ")]}},{key:"actions",fn:function(row){return [_c('div',{staticClass:"btn-group",attrs:{"role":"group","aria-label":"Basic example"}},[_c('a',{staticClass:"btn btn-sm btn-info text-white",attrs:{"size":"sm"},on:{"click":function($event){$event.stopPropagation();row.toggleDetails($event)}}},[_vm._v("\n                View\n              ")])])]}}])})],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"md":"3"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":""}},[_c('b-form-select',{model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}},[_c('option',{attrs:{"disabled":""}},[_vm._v("per page")]),_vm._v(" "),_c('option',{domProps:{"value":10}},[_vm._v("10")]),_vm._v(" "),_c('option',{domProps:{"value":20}},[_vm._v("20")]),_vm._v(" "),_c('option',{domProps:{"value":40}},[_vm._v("40")])])],1)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"md":"6"}},[_c('b-pagination',{staticClass:"my-0",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Expenses_vue__ = __webpack_require__(437);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bdbab50_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Expenses_vue__ = __webpack_require__(897);
function injectStyle (ssrContext) {
  __webpack_require__(896)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2bdbab50"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Expenses_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bdbab50_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Expenses_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 896 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Updating")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.loading1)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Loading")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.loading2)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Deleting")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.changed)?_c('div',[_c('div',{staticClass:"m-auto text-right pt-3"},[_c('el-button',{attrs:{"type":"primary","size":"medium"},on:{"click":function($event){_vm.dialogFormVisible2 = true}}},[_c('i',{staticClass:"el-icon-plus mr-2"}),_vm._v("Add Expense")])],1),_vm._v(" "),_c('div',{staticClass:"col-sm-12 col-md-8 col-lg-6 m-auto pl-4"},[_c('el-dialog',{attrs:{"title":"Add Expense","visible":_vm.dialogFormVisible2,"width":_vm.width},on:{"update:visible":function($event){_vm.dialogFormVisible2=$event}}},[_c('el-card',{staticStyle:{"background-color":"#f5f7fa"},attrs:{"shadow":"always"}},[_c('el-form',{ref:"formdata",staticStyle:{"<!-- border":"1px solid #e2e2e2","border-radius":"5px","-->\n              background-color":"#fff","padding":"25px"},attrs:{"model":_vm.formdata,"status-icon":"","rules":_vm.rules2,"label-width":"120px","label-position":_vm.labelPosition,"size":"medium"}},[_c('el-form-item',{attrs:{"label":"Store","prop":"store"}},[_c('el-select',{attrs:{"placeholder":"Select Store"},model:{value:(_vm.formdata.store),callback:function ($$v) {_vm.$set(_vm.formdata, "store", $$v)},expression:"formdata.store"}},_vm._l((_vm.stores),function(store,i){return _c('el-option',{key:i,attrs:{"value":store.id,"label":store.name}})}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Expense Main Category","prop":"cat"}},[_c('el-select',{attrs:{"placeholder":"Expense Main Category"},model:{value:(_vm.formdata.cat),callback:function ($$v) {_vm.$set(_vm.formdata, "cat", $$v)},expression:"formdata.cat"}},_vm._l((_vm.expenseCategories),function(cat,key){return _c('el-option',{key:key,attrs:{"value":key}},[_vm._v(_vm._s(key))])}))],1),_vm._v(" "),(_vm.formdata.cat)?_c('el-form-item',{attrs:{"label":"Expense Sub Category","prop":"subcat"}},[_c('el-select',{attrs:{"placeholder":"Expense Sub Category"},model:{value:(_vm.formdata.subcat),callback:function ($$v) {_vm.$set(_vm.formdata, "subcat", $$v)},expression:"formdata.subcat"}},_vm._l((_vm.expenseCategories[_vm.formdata.cat]),function(subcat,key){return _c('el-option',{key:key,attrs:{"value":key}},[_vm._v(_vm._s(key))])}))],1):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"date","label":"Date"}},[_c('el-date-picker',{attrs:{"type":"date","picker-options":{
                  disabledDate: function (time) { return _vm.disabledDate(time); },
                },"placeholder":"Pick a date"},model:{value:(_vm.formdata.date),callback:function ($$v) {_vm.$set(_vm.formdata, "date", $$v)},expression:"formdata.date"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Payment Method","prop":"pay"}},[_c('el-select',{attrs:{"placeholder":"Payment Method"},model:{value:(_vm.formdata.pay),callback:function ($$v) {_vm.$set(_vm.formdata, "pay", $$v)},expression:"formdata.pay"}},[_c('el-option',{attrs:{"label":"Cash","value":"Cash"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"Cheque","value":"Cheque"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"Card","value":"Card"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"Bank Transfer","value":"Bank Transfer"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"Gift Voucher","value":"Gift Voucher"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"Other","value":"Other"}})],1)],1),_vm._v(" "),(_vm.formdata.pay === 'Cash')?_c('el-form-item',{attrs:{"label":"Deduct from Current Cash Flow ","prop":"cashflow"}},[_c('el-checkbox',{model:{value:(_vm.formdata.cashflow),callback:function ($$v) {_vm.$set(_vm.formdata, "cashflow", $$v)},expression:"formdata.cashflow"}},[_vm._v("Deduct from Current Cash Flow")]),_vm._v(" "),_c('p',[_vm._v("Can't edit this record latter if deduct")])],1):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Amount","prop":"amount"}},[_c('el-input',{staticClass:"input-with-select",staticStyle:{"width":"220px"},attrs:{"type":"number","min":0,"clearable":""},model:{value:(_vm.formdata.amount),callback:function ($$v) {_vm.$set(_vm.formdata, "amount", _vm._n($$v))},expression:"formdata.amount"}},[_c('template',{attrs:{"slot":"prepend"},slot:"prepend"},[_vm._v("RS")])],2)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Expense Name","prop":"name","rules":[
                { required: true, message: 'Expense name', trigger: 'blur' } ]}},[_c('el-input',{attrs:{"placeholder":"Name"},model:{value:(_vm.formdata.name),callback:function ($$v) {_vm.$set(_vm.formdata, "name", $$v)},expression:"formdata.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Expense Note","prop":"note"}},[_c('el-input',{attrs:{"type":"textarea"},model:{value:(_vm.formdata.note),callback:function ($$v) {_vm.$set(_vm.formdata, "note", $$v)},expression:"formdata.note"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"pt-2",staticStyle:{"margin-bottom":"0px"}},[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.submitForm('formdata')}}},[_vm._v("Add")]),_vm._v(" "),_c('el-button',{on:{"click":function($event){_vm.resetForm('formdata', true)}}},[_vm._v("Reset")])],1)],1)],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"danger"},on:{"click":function($event){_vm.dialogFormVisible2 = false}}},[_vm._v("Cancel")])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"col-sm-12 col-md-8 col-lg-6 m-auto pl-4"},[_c('el-dialog',{attrs:{"title":"Edit Expense","visible":_vm.dialogFormVisible3,"width":_vm.width},on:{"update:visible":function($event){_vm.dialogFormVisible3=$event}}},[_c('el-form',{ref:"formdata2",staticStyle:{"border":"1px solid #e2e2e2","border-radius":"5px","background-color":"#fff","padding":"25px"},attrs:{"model":_vm.formdata2,"status-icon":"","rules":_vm.rules2,"label-width":"120px","label-position":_vm.labelPosition,"size":"medium"}},[_c('el-form-item',{attrs:{"label":"Store","prop":"store"}},[_c('el-select',{attrs:{"placeholder":"Select Store"},model:{value:(_vm.formdata2.store),callback:function ($$v) {_vm.$set(_vm.formdata2, "store", $$v)},expression:"formdata2.store"}},_vm._l((_vm.stores),function(store,i){return _c('el-option',{key:i,attrs:{"value":store.id,"label":store.name}})}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Expense Main Category","prop":"cat"}},[_c('el-select',{attrs:{"placeholder":"Expense Main Category"},model:{value:(_vm.formdata2.cat),callback:function ($$v) {_vm.$set(_vm.formdata2, "cat", $$v)},expression:"formdata2.cat"}},_vm._l((_vm.expenseCategories),function(cat,key){return _c('el-option',{key:key,attrs:{"value":key}},[_vm._v(_vm._s(key))])}))],1),_vm._v(" "),(_vm.formdata2.cat)?_c('el-form-item',{attrs:{"label":"Expense Sub Category","prop":"subcat"}},[_c('el-select',{attrs:{"placeholder":"Expense Sub Category"},model:{value:(_vm.formdata2.subcat),callback:function ($$v) {_vm.$set(_vm.formdata2, "subcat", $$v)},expression:"formdata2.subcat"}},_vm._l((_vm.expenseCategories[_vm.formdata.cat]),function(subcat,key){return _c('el-option',{key:key,attrs:{"value":key}},[_vm._v(_vm._s(key))])}))],1):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Payment Method","prop":"pay"}},[_c('el-select',{attrs:{"placeholder":"Payment Method"},model:{value:(_vm.formdata2.pay),callback:function ($$v) {_vm.$set(_vm.formdata2, "pay", $$v)},expression:"formdata2.pay"}},[_c('el-option',{attrs:{"label":"Cash","value":"Cash"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"Cheque","value":"Cheque"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"Card","value":"Card"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"Bank Transfer","value":"Bank Transfer"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"Gift Voucher","value":"Gift Voucher"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"Other","value":"Other"}})],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Amount","prop":"amount"}},[_c('el-input',{staticClass:"input-with-select",staticStyle:{"width":"220px"},attrs:{"type":"number","clearable":""},model:{value:(_vm.formdata2.amount),callback:function ($$v) {_vm.$set(_vm.formdata2, "amount", _vm._n($$v))},expression:"formdata2.amount"}},[_c('template',{attrs:{"slot":"prepend"},slot:"prepend"},[_vm._v("RS")])],2)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Expense Name","prop":"name","rules":[
              { required: true, message: 'Expense name', trigger: 'blur' } ]}},[_c('el-input',{attrs:{"placeholder":"Name"},model:{value:(_vm.formdata2.name),callback:function ($$v) {_vm.$set(_vm.formdata2, "name", $$v)},expression:"formdata2.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Expense Note","prop":"note"}},[_c('el-input',{attrs:{"type":"textarea"},model:{value:(_vm.formdata2.note),callback:function ($$v) {_vm.$set(_vm.formdata2, "note", $$v)},expression:"formdata2.note"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"pt-2",staticStyle:{"margin-bottom":"0px"}},[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.update('formdata2')}}},[_vm._v("Update")])],1)],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"danger"},on:{"click":function($event){_vm.dialogFormVisible3 = false}}},[_vm._v("Cancel")])],1)],1)],1),_vm._v(" "),_c('b-container',{staticClass:"col-lg-10 mt-1"},[_c('h3',{staticClass:"text-info text-center my-4"},[_vm._v("Expenses")]),_vm._v(" "),_c('el-card',{staticStyle:{"background-color":"#f5f7fa","overflow":"initial"},attrs:{"shadow":"always"}},[_c('b-row',[_c('b-col',{staticClass:"my-1",attrs:{"sm":"3"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":""}},[_c('el-date-picker',{attrs:{"size":"medium","picker-options":{
                  disabledDate: function (time) { return _vm.disabledDate(time); },
                },"type":"month","placeholder":"Month"},model:{value:(_vm.month),callback:function ($$v) {_vm.month=$$v},expression:"month"}})],1)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"sm":"3"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":""}},[_c('b-form-select',{attrs:{"placeholder":"Store Location","options":_vm.stores},model:{value:(_vm.storeLocation),callback:function ($$v) {_vm.storeLocation=$$v},expression:"storeLocation"}})],1)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"sm":"3"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":""}},[_c('b-form-select',{attrs:{"placeholder":"Main Category","options":_vm.mainCategories},on:{"change":
                  function (value) {
                    _vm.mainCategory = value;
                    _vm.subCategories = [
                      {
                        value: null,
                        text: 'Select Sub Category',
                        disabled: true,
                      } ];
                    _vm.subCategory = null;
                    Object.keys(_vm.expenseCategories[_vm.mainCategory]).forEach(
                      function (subcat, index) { return _vm.subCategories.push(subcat); }
                    );
                  }
                },model:{value:(_vm.mainCategory),callback:function ($$v) {_vm.mainCategory=$$v},expression:"mainCategory"}})],1)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"sm":"3"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":""}},[_c('b-form-select',{attrs:{"placeholder":"Sub Category","options":_vm.subCategories},on:{"change":
                  function (value) {
                    _vm.subCategory = value;
                  }
                },model:{value:(_vm.subCategory),callback:function ($$v) {_vm.subCategory=$$v},expression:"subCategory"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"my-1",attrs:{"sm":"12"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":""}},[_c('el-button',{staticStyle:{"display":"block","margin":"0 auto","margin-top":"10px"},attrs:{"type":"primary","size":"medium"},on:{"click":_vm.searchExpenses}},[_vm._v("Search")])],1)],1)],1)],1),_vm._v(" "),_c('el-card',{staticStyle:{"overflow-x":"scroll"},attrs:{"shadow":"always"}},[_c('b-table',{staticClass:"mt-4",attrs:{"show-empty":"","stacked":"sm","items":_vm.items,"fields":_vm.fields,"hover":true,"head-variant":"dark","dark":false,"small":true,"current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter,"empty-text":_vm.emptyText,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event},"filtered":_vm.onFiltered},scopedSlots:_vm._u([{key:"id",fn:function(row){return [_c('div',[_vm._v(_vm._s(row.value))])]}},{key:"actions",fn:function(row){return [_c('div',{staticClass:"btn-group",attrs:{"role":"group","aria-label":"Basic example"}},[_c('button',{staticClass:"btn btn-sm btn-primary text-white",attrs:{"disabled":row.item.cashflow,"size":"sm"},on:{"click":function($event){_vm.showUpdate(row.item)}}},[_vm._v("\n                Edit\n              ")])])]}}])})],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"md":"3"}},[_c('b-form-group',{staticClass:"mb-0"},[_c('b-form-select',{model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}},[_c('option',{attrs:{"disabled":""}},[_vm._v("per page")]),_vm._v(" "),_c('option',{domProps:{"value":10}},[_vm._v("10")]),_vm._v(" "),_c('option',{domProps:{"value":25}},[_vm._v("25")]),_vm._v(" "),_c('option',{domProps:{"value":50}},[_vm._v("50")])])],1)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"md":"6"}},[_c('b-pagination',{staticClass:"my-0",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExpenseCategories_vue__ = __webpack_require__(438);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42422aeb_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExpenseCategories_vue__ = __webpack_require__(900);
function injectStyle (ssrContext) {
  __webpack_require__(899)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-42422aeb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExpenseCategories_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42422aeb_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExpenseCategories_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 899 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-row',{staticStyle:{"margin-top":"20px"}},[_c('div',{staticClass:"m-auto text-right pb-3"},[_c('el-button',{attrs:{"type":"primary","size":"medium"},on:{"click":function($event){_vm.open()}}},[_c('i',{staticClass:"el-icon-plus mr-2"}),_vm._v("Add Main Category")])],1),_vm._v(" "),_c('el-alert',{attrs:{"title":"Category names cannot edit once created. So please check before saving.","type":"warning","center":"","show-icon":""}}),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData}},[_c('el-table-column',{attrs:{"label":"Main Expense Category","width":"180"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticStyle:{"margin-left":"10px"}},[_vm._v(_vm._s(scope.row.mainCategory))]),_vm._v(" "),_c('el-button',{attrs:{"type":"danger","plain":"","size":"mini","icon":"el-icon-delete","circle":""},on:{"click":function($event){_vm.openDelete(scope.row.mainCategory)}}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Sub Categries"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"name-wrapper"},[_vm._l((scope.row.subCategories),function(name){return _c('el-tag',{key:name,staticStyle:{"margin":"5px","font-size":"15px"},attrs:{"type":"info","closable":"","disable-transitions":false},on:{"close":function($event){_vm.openDelete2(name, scope.$index, scope.row)}}},[_vm._v("\n              "+_vm._s(name)+"\n            ")])}),_vm._v(" "),(scope.row.inputVisible)?_c('el-input',{ref:scope.$index,staticClass:"input-new-tag",attrs:{"size":"mini","placeholder":"Hit enter to save"},on:{"blur":function($event){_vm.handleInputConfirm(scope.$index, scope.row)}},nativeOn:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }
                _vm.handleInputConfirm(scope.$index, scope.row)
              }},model:{value:(scope.row.newCategory),callback:function ($$v) {_vm.$set(scope.row, "newCategory", $$v)},expression:"scope.row.newCategory"}}):_c('el-button',{staticClass:"button-new-tag",attrs:{"size":"small","type":"success","plain":""},on:{"click":function($event){_vm.showInput(("new-tag-" + (scope.$index)), scope.row)}}},[_vm._v("+ Add New")])],2)]}}])})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Quotations_vue__ = __webpack_require__(439);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e72d680_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Quotations_vue__ = __webpack_require__(903);
function injectStyle (ssrContext) {
  __webpack_require__(902)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6e72d680"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Quotations_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e72d680_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Quotations_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 902 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Loading")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.loading1)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Updating")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.loading2)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Deleting")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.changed)?_c('div',{},[_c('b-container',{staticClass:"col-lg-10 mt-5"},[_c('h3',{staticClass:"text-info text-center pt-4 my-4"},[_vm._v("Quotations")]),_vm._v(" "),_c('el-card',{staticStyle:{"background-color":"#f5f7fa","overflow":"initial"},attrs:{"shadow":"always"}},[_c('b-row',[_c('b-col',{staticClass:"my-1",attrs:{"sm":"3"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":""}},[_c('el-date-picker',{attrs:{"size":"medium","picker-options":{
                    disabledDate: function (time) { return _vm.disabledDate(time); },
                  },"type":"month","placeholder":"Month"},model:{value:(_vm.month),callback:function ($$v) {_vm.month=$$v},expression:"month"}})],1)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"sm":"3"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":""}},[_c('b-form-select',{attrs:{"placeholder":"Store Location","options":_vm.stores},model:{value:(_vm.storeLocation),callback:function ($$v) {_vm.storeLocation=$$v},expression:"storeLocation"}})],1)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"sm":"3"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":""}},[_c('b-form-input',{attrs:{"placeholder":"Quotation No"},model:{value:(_vm.invoiceNo),callback:function ($$v) {_vm.invoiceNo=$$v},expression:"invoiceNo"}})],1)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"sm":"3"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":""}},[_c('b-form-input',{attrs:{"placeholder":"Customer's Mobile No"},model:{value:(_vm.customer),callback:function ($$v) {_vm.customer=$$v},expression:"customer"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"my-1",attrs:{"sm":"12"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":""}},[_c('el-button',{staticStyle:{"display":"block","margin":"0 auto","margin-top":"10px"},attrs:{"type":"primary","size":"medium"},on:{"click":_vm.searchInvoices}},[_vm._v("Search")])],1)],1)],1)],1),_vm._v(" "),_c('b-row'),_vm._v(" "),_c('PrintInvo',{attrs:{"printInvoType":"quota"}}),_vm._v(" "),_c('el-card',{staticStyle:{"overflow-x":"scroll"},attrs:{"shadow":"always"}},[_c('b-table',{staticClass:"mt-4",attrs:{"show-empty":"","stacked":"sm","items":_vm.items,"fields":_vm.fields,"hover":true,"head-variant":"dark","current-page":_vm.currentPage,"per-page":_vm.perPage,"empty-text":_vm.emptyText,"filter":_vm.filter,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event},"filtered":_vm.onFiltered},scopedSlots:_vm._u([{key:"index",fn:function(data){return [_vm._v("\n              "+_vm._s(data.index + 1)+"\n            ")]}},{key:"actions",fn:function(row){return [_c('div',{staticClass:"btn-group",attrs:{"role":"group","aria-label":"Basic example"}},[_c('a',{staticClass:"btn btn-sm btn-info text-white",attrs:{"size":"sm"},on:{"click":function($event){$event.stopPropagation();row.toggleDetails($event)}}},[_vm._v("\n                  View\n                ")]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-sm btn-primary",attrs:{"to":{
                    name: 'create-quotation',
                    query: { Quo: row.item.invoiceNo },
                  }}},[_vm._v("\n                  Update\n                ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-secondary text-white",attrs:{"size":"sm"},on:{"click":function($event){_vm.printInvoice(_vm.storeLocation, row.item)}}},[_vm._v("\n                  Print\n                ")])],1)]}},{key:"row-details",fn:function(row){return [_c('b-card',[_c('el-row',{staticStyle:{"margin-top":"20px"},attrs:{"gutter":10}},[_c('el-col',{attrs:{"xs":24,"sm":24,"md":24,"lg":24,"xl":24}},[_c('el-card',{staticClass:"box-card",staticStyle:{"background-color":"#eaf0ff"}},[_c('div',{staticClass:"clearfix text item"},[_c('span',[_vm._v("Gross Amount")]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","padding":"3px 0"}},[_vm._v(_vm._s(row.item.grossAmount.toLocaleString())+" LKR")])]),_vm._v(" "),_c('div',{staticClass:"clearfix text item"},[_c('span',[_vm._v("Discount")]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","padding":"3px 0"}},[_vm._v(_vm._s(row.item.discount.toLocaleString())+" LKR\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix text item"},[_c('span',[_vm._v("Other Discount")]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","padding":"3px 0"}},[_vm._v("\n                          "+_vm._s(row.item.otherDiscount.toLocaleString())+" LKR\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix text item"},[_c('span',[_vm._v("Tax/Service Charge")]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","padding":"3px 0"}},[_vm._v("\n                          "+_vm._s(row.item.tax.toLocaleString())+" LKR\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix text item"},[_c('span',[_vm._v("Net Amount")]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","padding":"3px 0"}},[_vm._v(_vm._s(row.item.netAmount.toLocaleString())+" LKR")])])])],1),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":24,"md":24,"lg":24,"xl":24}},[_c('h5',{staticClass:"text-center text-info my-4"},[_vm._v("Items Summary")]),_vm._v(" "),_c('div',{},[_c('b-table',{staticClass:"mt-4",attrs:{"show-empty":"","stacked":"sm","items":row.item.products,"fields":_vm.productsFields,"hover":true,"head-variant":"dark","empty-text":_vm.emptyText,"filter":_vm.filter,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event}},scopedSlots:_vm._u([{key:"cell(index)",fn:function(data){return [_vm._v("\n                          "+_vm._s(data.index + 1)+"\n                        ")]}}])})],1)])],1)],1)]}}])})],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"md":"3"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":""}},[_c('b-form-select',{model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}},[_c('option',{attrs:{"disabled":""}},[_vm._v("per page")]),_vm._v(" "),_c('option',{domProps:{"value":10}},[_vm._v("10")]),_vm._v(" "),_c('option',{domProps:{"value":20}},[_vm._v("20")]),_vm._v(" "),_c('option',{domProps:{"value":40}},[_vm._v("40")])])],1)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"md":"6"}},[_c('b-pagination',{staticClass:"my-0",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PurchaseOrders_vue__ = __webpack_require__(440);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0885322f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PurchaseOrders_vue__ = __webpack_require__(906);
function injectStyle (ssrContext) {
  __webpack_require__(905)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0885322f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PurchaseOrders_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0885322f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PurchaseOrders_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 905 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Loading")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.loading1)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Updating")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.loading2)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Deleting")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.changed)?_c('div',{},[_c('b-container',{staticClass:"col-lg-10 mt-5"},[_c('h3',{staticClass:"text-info text-center pt-4 my-4"},[_vm._v("Purchase Orders")]),_vm._v(" "),_c('el-card',{staticStyle:{"background-color":"#f5f7fa","overflow":"initial"},attrs:{"shadow":"always"}},[_c('b-row',[_c('b-col',{staticClass:"my-1",attrs:{"sm":"3"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":""}},[_c('el-date-picker',{attrs:{"size":"medium","picker-options":{
                    disabledDate: function (time) { return _vm.disabledDate(time); },
                  },"type":"month","placeholder":"Month"},model:{value:(_vm.month),callback:function ($$v) {_vm.month=$$v},expression:"month"}})],1)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"sm":"3"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":""}},[_c('b-form-select',{attrs:{"placeholder":"Store Location","options":_vm.stores},model:{value:(_vm.storeLocation),callback:function ($$v) {_vm.storeLocation=$$v},expression:"storeLocation"}})],1)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"sm":"3"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":""}},[_c('b-form-input',{attrs:{"placeholder":"GRN No"},model:{value:(_vm.invoiceNo),callback:function ($$v) {_vm.invoiceNo=$$v},expression:"invoiceNo"}})],1)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"sm":"3"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":""}},[_c('b-form-input',{attrs:{"placeholder":"Supplier's Mobile No"},model:{value:(_vm.supplier),callback:function ($$v) {_vm.supplier=$$v},expression:"supplier"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"my-1",attrs:{"sm":"12"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":""}},[_c('el-button',{staticStyle:{"display":"block","margin":"0 auto","margin-top":"10px"},attrs:{"type":"primary","size":"medium"},on:{"click":_vm.searchInvoices}},[_vm._v("Search")])],1)],1)],1)],1),_vm._v(" "),_c('b-row'),_vm._v(" "),_c('PrintInvo',{attrs:{"printInvoType":"po"}}),_vm._v(" "),_c('el-card',{staticStyle:{"overflow-x":"scroll"},attrs:{"shadow":"always"}},[_c('b-table',{staticClass:"mt-4",attrs:{"show-empty":"","stacked":"sm","items":_vm.items,"fields":_vm.fields,"hover":true,"head-variant":"dark","current-page":_vm.currentPage,"per-page":_vm.perPage,"empty-text":_vm.emptyText,"filter":_vm.filter,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event},"filtered":_vm.onFiltered},scopedSlots:_vm._u([{key:"index",fn:function(data){return [_vm._v("\n              "+_vm._s(data.index + 1)+"\n            ")]}},{key:"actions",fn:function(row){return [_c('div',{staticClass:"btn-group",attrs:{"role":"group","aria-label":"Basic example"}},[_c('a',{staticClass:"btn btn-sm btn-info text-white",attrs:{"size":"sm"},on:{"click":function($event){$event.stopPropagation();row.toggleDetails($event)}}},[_vm._v("\n                  View\n                ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-primary text-white",attrs:{"size":"sm"},on:{"click":function($event){
                    _vm.$router.push({
                      name: 'create-purchase-order',
                      query: { PO: row.item.invoiceNo, return: 'true' },
                    })
                  }}},[_vm._v("\n                  Update\n                ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-secondary text-white",attrs:{"size":"sm"},on:{"click":function($event){_vm.printInvoice(_vm.storeLocation, row.item)}}},[_vm._v("\n                  Print\n                ")])])]}},{key:"row-details",fn:function(row){return [_c('b-card',[_c('el-row',{staticStyle:{"margin-top":"20px"},attrs:{"gutter":10}},[_c('el-col',{attrs:{"xs":24,"sm":24,"md":24,"lg":24,"xl":24}},[_c('el-card',{staticClass:"box-card",staticStyle:{"background-color":"#eaf0ff"}},[_c('div',{staticClass:"clearfix text item"},[_c('span',[_vm._v("Gross Amount")]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","padding":"3px 0"}},[_vm._v(_vm._s(row.item.grossAmount.toLocaleString())+" LKR")])]),_vm._v(" "),_c('div',{staticClass:"clearfix text item"},[_c('span',[_vm._v("Discount")]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","padding":"3px 0"}},[_vm._v(_vm._s(row.item.discount.toLocaleString())+" LKR\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix text item"},[_c('span',[_vm._v("Other Discount")]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","padding":"3px 0"}},[_vm._v("\n                          "+_vm._s(row.item.otherDiscount.toLocaleString())+" LKR\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix text item"},[_c('span',[_vm._v("Tax/Service Charge")]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","padding":"3px 0"}},[_vm._v("\n                          "+_vm._s(row.item.tax.toLocaleString())+" LKR\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix text item"},[_c('span',[_vm._v("Net Amount")]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","padding":"3px 0"}},[_vm._v(_vm._s(row.item.netAmount.toLocaleString())+" LKR")])]),_vm._v(" "),_c('div',{staticClass:"clearfix text item"},[_c('span',[_vm._v("Card Payment")]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","padding":"3px 0"}},[_vm._v("\n                          "+_vm._s(row.item.cardPayment.toLocaleString())+" LKR\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix text item"},[_c('span',[_vm._v("Cash Payment")]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","padding":"3px 0"}},[_vm._v("\n                          "+_vm._s(row.item.cashPayment.toLocaleString())+" LKR\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix text item"},[_c('span',[_vm._v("Cheque Payment")]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","padding":"3px 0"}},[_vm._v("\n                          "+_vm._s(row.item.chequePayment.toLocaleString())+" LKR\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix text item"},[_c('span',[_vm._v("Balance")]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","padding":"3px 0"}},[_vm._v(_vm._s(row.item.balance.toLocaleString())+" LKR")])])])],1),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":24,"md":24,"lg":24,"xl":24}},[_c('h5',{staticClass:"text-center text-info my-4"},[_vm._v("Ordeded Items")]),_vm._v(" "),_c('div',{},[_c('b-table',{staticClass:"mt-4",attrs:{"show-empty":"","stacked":"sm","items":row.item.products,"fields":_vm.productsFields,"hover":true,"head-variant":"dark","empty-text":_vm.emptyText,"filter":_vm.filter,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event}},scopedSlots:_vm._u([{key:"cell(index)",fn:function(data){return [_vm._v("\n                          "+_vm._s(data.index + 1)+"\n                        ")]}}])})],1)])],1)],1)]}}])})],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"md":"3"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":""}},[_c('b-form-select',{model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}},[_c('option',{attrs:{"disabled":""}},[_vm._v("per page")]),_vm._v(" "),_c('option',{domProps:{"value":10}},[_vm._v("10")]),_vm._v(" "),_c('option',{domProps:{"value":20}},[_vm._v("20")]),_vm._v(" "),_c('option',{domProps:{"value":40}},[_vm._v("40")])])],1)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"md":"6"}},[_c('b-pagination',{staticClass:"my-0",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KOT_vue__ = __webpack_require__(441);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8e1adb70_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KOT_vue__ = __webpack_require__(915);
function injectStyle (ssrContext) {
  __webpack_require__(908)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8e1adb70"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KOT_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8e1adb70_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KOT_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 908 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KOTItemTable_vue__ = __webpack_require__(442);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_226def72_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KOTItemTable_vue__ = __webpack_require__(911);
function injectStyle (ssrContext) {
  __webpack_require__(910)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-226def72"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KOTItemTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_226def72_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KOTItemTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 910 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"margin-bottom":"20px","height":"30px"}},[_c('el-autocomplete',{staticStyle:{"margin-bottom":"1px","border":"1px solid #409eff","border-radius":"5px","width":"100%"},attrs:{"size":"medium","popper-class":"my-autocomplete","fetch-suggestions":_vm.querySearch,"placeholder":"Search Item"},on:{"select":_vm.handleProductChange},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"link"},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v("SKU: "+_vm._s(item.barcode))])]}}]),model:{value:(_vm.itemName),callback:function ($$v) {_vm.itemName=$$v},expression:"itemName"}},[_c('i',{staticClass:"el-icon-edit el-input__icon",attrs:{"slot":"suffix"},slot:"suffix"})])],1),_vm._v(" "),_c('el-button',{staticStyle:{"width":"100%"},attrs:{"size":"medium","type":"primary"},on:{"click":function($event){_vm.innerVisible=true}}},[_vm._v("View Items")]),_vm._v(" "),_c('el-table',{ref:"singleTable",staticStyle:{"{\n          overflow-x":"scroll","width":"800px","margin":"0 auto"},attrs:{"data":_vm.KOTItemData,"highlight-current-row":""}},[_c('el-table-column',{attrs:{"type":"index","width":"50"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"150","property":"serial","label":"Item"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-input',{attrs:{"size":"mini"},model:{value:(scope.row.item),callback:function ($$v) {_vm.$set(scope.row, "item", $$v)},expression:"scope.row.item"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"150","property":"quantity","label":"Quantity"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-input-number',{attrs:{"size":"mini","precision":2,"min":0},model:{value:(scope.row.quantity),callback:function ($$v) {_vm.$set(scope.row, "quantity", $$v)},expression:"scope.row.quantity"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"150","label":"Operations"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"size":"small","type":"danger","icon":"el-icon-delete","circle":""},on:{"click":function($event){_vm.open(scope.$index, scope.row)}}})]}}])})],1),_vm._v(" "),_c('div',{staticStyle:{"margin":"10px 0px","height":"50px"}},[_c('el-input',{staticClass:"input-with-select",staticStyle:{"width":"100%","margin-bottom":"12px"},attrs:{"placeholder":"Note","size":"small","clearable":""},model:{value:(_vm.note),callback:function ($$v) {_vm.note=$$v},expression:"note"}}),_vm._v(" "),(_vm.store && _vm.store !== 'all')?_c('el-button',{staticStyle:{"float":"right","margin-right":"0px"},attrs:{"disabled":_vm.disabled,"size":"small","type":"success"},on:{"click":function($event){_vm.saveKOT(_vm.method, _vm.kotid)}}},[_vm._v("Save")]):_vm._e(),_vm._v(" "),_c('el-input',{staticClass:"input-with-select",staticStyle:{"float":"right","width":"220px","margin-right":"20px"},attrs:{"placeholder":"Table No","type":"number","size":"small","clearable":""},model:{value:(_vm.table),callback:function ($$v) {_vm.table=_vm._n($$v)},expression:"table"}}),_vm._v(" "),_c('el-dialog',{attrs:{"width":"80%","title":"Items","visible":_vm.innerVisible,"append-to-body":""},on:{"update:visible":function($event){_vm.innerVisible=$event}}},[_c('el-row',_vm._l((_vm.allProducts),function(item,index){return _c('el-col',{key:index,attrs:{"xs":24,"sm":8,"md":8,"lg":6,"xl":6}},[_c('el-card',{attrs:{"body-style":{ padding: '0px' }}},[_c('img',{staticClass:"image",attrs:{"src":item.img}}),_vm._v(" "),_c('div',{staticStyle:{"padding":"4px 14px"}},[_vm._v("\n              "+_vm._s(item.name)+"\n              "),_c('el-button',{staticStyle:{"padding-top":"4px","display":"block"},attrs:{"type":"text"},on:{"click":function($event){_vm.handleProductChange(item)}}},[_vm._v("Add to KOT")])],1)])],1)}))],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KOTPrint_vue__ = __webpack_require__(443);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18d2459c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KOTPrint_vue__ = __webpack_require__(914);
function injectStyle (ssrContext) {
  __webpack_require__(913)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-18d2459c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KOTPrint_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18d2459c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KOTPrint_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 913 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.kotNo)?_c('div',[_c('div',{staticClass:"ticket"},[_c('p',[_vm._v("\n      KOT No : "+_vm._s(_vm.kotNo)+" "),_c('br'),_vm._v("Date :\n      "+_vm._s(_vm.date)+" "),_c('br'),_vm._v("Table : "+_vm._s(_vm.table)+"\n      ")]),_vm._v(" "),_c('table',{staticStyle:{"margin-top":"-30px"}},[_vm._m(0),_vm._v(" "),_c('tbody',[_vm._l((_vm.products),function(product){return _c('tr',{key:product.barcode},[_c('td',{staticClass:"description"},[_vm._v(_vm._s(product.item))]),_vm._v(" "),_c('td',{staticClass:"quantity"},[_vm._v(_vm._s(product.quantity))])])}),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2)],2)]),_vm._v(" "),_c('p',{staticClass:"centered",staticStyle:{"margin-bottom":"10px"}},[_vm._v("\n      "+_vm._s(_vm.note)+"\n    ")])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',{staticStyle:{"border-top":"hidden"}},[_c('th',{staticClass:"description",staticStyle:{"text-align":"left"}},[_vm._v("Item")]),_vm._v(" "),_c('th',{staticClass:"quantity",staticStyle:{"text-align":"left"}},[_vm._v("Qty")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('br')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Loading")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.loading1)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Updating")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.loading2)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Deleting")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.changed)?_c('div',{},[(_vm.$store.state.systemUser.role !== 'Kitchen Staff')?_c('div',{staticClass:"m-auto text-right pt-3"},[_c('el-button',{attrs:{"type":"primary","size":"medium"},on:{"click":function($event){_vm.dialogFormVisible2 = true}}},[_c('i',{staticClass:"el-icon-plus mr-2"}),_vm._v("Add KOT")])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-sm-12 col-md-8 col-lg-6 m-auto pl-4"},[_c('el-dialog',{attrs:{"title":"Add KOT","visible":_vm.dialogFormVisible2,"width":_vm.width},on:{"update:visible":function($event){_vm.dialogFormVisible2=$event}}},[_c('el-card',{staticStyle:{"background-color":"#f5f7fa"},attrs:{"shadow":"always"}},[_c('KOTItemTable',{attrs:{"KOTItemData":_vm.kotItems,"tableNo":_vm.tableNo,"kotNote":_vm.kotNote,"method":'create',"allProducts":_vm.allProducts}})],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"Update KOT","visible":_vm.dialogFormVisible,"width":_vm.width},on:{"update:visible":function($event){_vm.dialogFormVisible=$event},"close":function($event){_vm.BUS.$emit('kotdialogClosed')},"open":function($event){_vm.BUS.$emit('kotdialogOpen', _vm.kot)}}},[_c('el-card',{staticStyle:{"background-color":"#f5f7fa"},attrs:{"shadow":"always"}},[_c('KOTItemTable',{attrs:{"KOTItemData":_vm.kot.items,"tableNo":_vm.kot.table,"method":'update',"kotNote":_vm.kot.note,"kotid":_vm.kot.id,"allProducts":_vm.allProducts}})],1)],1)],1),_vm._v(" "),_c('b-container',{staticClass:"col-lg-10 mt-5"},[_c('h3',{staticClass:"text-info text-center pt-4 my-4"},[_vm._v("Today's KOTs")]),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"my-1",attrs:{"sm":"5"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":""}},[_c('b-input-group',[_c('b-form-select',{attrs:{"options":_vm.sortOptions},model:{value:(_vm.sortBy),callback:function ($$v) {_vm.sortBy=$$v},expression:"sortBy"}},[_c('option',{attrs:{"slot":"first"},domProps:{"value":null},slot:"first"},[_vm._v("Sort By")])]),_vm._v(" "),_c('b-form-select',{attrs:{"slot":"append","disabled":!_vm.sortBy},slot:"append",model:{value:(_vm.sortDesc),callback:function ($$v) {_vm.sortDesc=$$v},expression:"sortDesc"}},[_c('option',{domProps:{"value":false}},[_vm._v("Asc")]),_vm._v(" "),_c('option',{domProps:{"value":true}},[_vm._v("Desc")])])],1)],1)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"sm":"3"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"horizontal":""}},[_c('b-form-select',{model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}},[_c('option',{attrs:{"disabled":""}},[_vm._v("per page")]),_vm._v(" "),_c('option',{domProps:{"value":10}},[_vm._v("10")]),_vm._v(" "),_c('option',{domProps:{"value":20}},[_vm._v("20")]),_vm._v(" "),_c('option',{domProps:{"value":40}},[_vm._v("40")])])],1)],1)],1),_vm._v(" "),_c('KOTPrint',{staticStyle:{"display":"none"},attrs:{"id":"printKOT","kotNo":_vm.printKot.kotNo,"note":_vm.printKot.note,"table":_vm.printKot.table,"date":_vm.printKot.date,"products":_vm.printKot.items}}),_vm._v(" "),_c('KOTPrint',{staticStyle:{"display":"none"},attrs:{"id":"printBOT","kotNo":_vm.printBot.kotNo,"note":_vm.printBot.note,"table":_vm.printBot.table,"date":_vm.printBot.date,"products":_vm.printBot.items}}),_vm._v(" "),_c('el-card',{staticStyle:{"overflow-x":"scroll"},attrs:{"shadow":"always"}},[_c('b-table',{staticClass:"mt-4",attrs:{"show-empty":"","stacked":"sm","items":_vm.items,"fields":_vm.fields,"hover":true,"head-variant":"dark","current-page":_vm.currentPage,"per-page":_vm.perPage,"empty-text":_vm.emptyText,"filter":_vm.filter,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event},"filtered":_vm.onFiltered},scopedSlots:_vm._u([{key:"index",fn:function(data){return [_vm._v("\n              "+_vm._s(data.index + 1)+"\n            ")]}},{key:"name",fn:function(row){return [_c('b-media',[_c('b-img',{attrs:{"slot":"aside","src":"https://lorempixel.com/125/125/technics/8/","width":"64","height":"64","alt":"image"},slot:"aside"}),_vm._v(" "),_c('h6',{staticClass:"mt-4"},[_vm._v(_vm._s(row.value))])],1)]}},{key:"category",fn:function(row){return [_c('div',{staticClass:"row mt-4"},[_vm._v(_vm._s(row.value))])]}},{key:"status",fn:function(row){return [_c('el-select',{staticStyle:{"width":"160px"},attrs:{"size":"mini","placeholder":"Order Status"},on:{"change":function($event){_vm.upOrder(row.item.id, row.item.status)}},model:{value:(row.item.status),callback:function ($$v) {_vm.$set(row.item, "status", $$v)},expression:"row.item.status"}},_vm._l((_vm.options),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}))]}},{key:"actions",fn:function(row){return [_c('div',{staticClass:"btn-group",attrs:{"role":"group","aria-label":"Basic example"}},[_c('a',{staticClass:"btn btn-sm btn-info text-white",attrs:{"size":"sm"},on:{"click":function($event){$event.stopPropagation();row.toggleDetails($event)}}},[_vm._v("\n                  View Items\n                ")]),_vm._v(" "),(_vm.$store.state.systemUser.role !== 'Kitchen Staff')?_c('a',{staticClass:"btn btn-sm btn-primary text-white",attrs:{"size":"sm"},on:{"click":function($event){$event.stopPropagation();_vm.showUpdateKOT(row.item)}}},[_vm._v("\n                  Update\n                ")]):_vm._e(),_vm._v(" "),_c('router-link',{staticClass:"btn btn-sm btn-warning text-white",attrs:{"to":{
                    name: 'createinvoice',
                    query: { kot: row.item.kotNo, },
                  }}},[_vm._v("\n                  Invoice\n                ")]),_vm._v(" "),(_vm.$store.state.systemUser.role !== 'Kitchen Staff')?_c('a',{staticClass:"btn btn-sm btn-danger text-white",attrs:{"size":"sm"},on:{"click":function($event){_vm.open(row.item.id, row.item.status)}}},[_vm._v("\n                  Delete\n                ")]):_vm._e(),_vm._v(" "),(_vm.$store.state.systemUser.role !== 'Kitchen Staff')?_c('a',{staticClass:"btn btn-sm btn-secondary text-white",attrs:{"size":"sm"},on:{"click":function($event){_vm.managePrint( row.item, 'kot')}}},[_vm._v("\n                  Print KOT\n                ")]):_vm._e(),_vm._v(" "),(_vm.$store.state.systemUser.role !== 'Kitchen Staff' &&
                  row.item.items.filter(function (itm) { return itm.cat === 'Beverage' || itm.cat === 'Beverages' || itm.cat.toLowerCase() === 'bot'; }).length > 0)?_c('a',{staticClass:"btn btn-sm btn-secondary text-white",attrs:{"size":"sm"},on:{"click":function($event){_vm.managePrint( row.item, 'bot')}}},[_vm._v("\n                  Print BOT\n                ")]):_vm._e()],1)]}},{key:"row-details",fn:function(row){return [_c('b-card',[_c('ul'),_vm._v(" "),_c('div',[_c('span',[_vm._v("Note: ")]),_vm._v(" "+_vm._s(row.item.note))]),_vm._v(" "),_c('h5',{staticClass:" text-info my-4"},[_vm._v("Ordeded Items")]),_vm._v(" "),_c('div',{staticClass:"row"},[[_c('div',{staticClass:"col-12 col-md-8"},[_c('el-table',{ref:"singleTable",staticStyle:{"{\n                              overflow-x":"scroll","width":"800px","margin":"0 auto"},attrs:{"data":row.item.items,"highlight-current-row":""}},[_c('el-table-column',{attrs:{"type":"index","width":"50"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"250","property":"serial","label":"Item"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                            "+_vm._s(scope.row.item)+"\n                          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"150","property":"quantity","label":"Quantity"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                            "+_vm._s(scope.row.quantity)+"\n                          ")]}}])})],1)],1)]],2)])]}}])})],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"md":"6"}},[_c('b-pagination',{staticClass:"my-0",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StockSummary_vue__ = __webpack_require__(444);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ad525d9c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StockSummary_vue__ = __webpack_require__(918);
function injectStyle (ssrContext) {
  __webpack_require__(917)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ad525d9c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StockSummary_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ad525d9c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StockSummary_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 917 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Updating")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.loading1)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Loading")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.loading2)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Deleting")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.changed)?_c('div',[_c('b-container',{staticClass:"col-lg-10 mt-5"},[_c('h3',{staticClass:"text-info text-center pt-4 my-4"},[_vm._v("\n        Stock Summary\n      ")]),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"my-1",attrs:{"sm":"3"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"horizontal":""}},[_c('el-select',{attrs:{"label":"Select Store","size":"medium","placeholder":"Select Store"},on:{"change":_vm.updateProducts},model:{value:(_vm.selectedStore),callback:function ($$v) {_vm.selectedStore=$$v},expression:"selectedStore"}},_vm._l((_vm.stores),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.id}})}))],1)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"sm":"3"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":""}},[_c('b-input-group',[_c('b-form-input',{attrs:{"placeholder":"Search"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),_c('b-input-group-append',[_c('b-btn',{attrs:{"disabled":!_vm.filter},on:{"click":function($event){_vm.filter = ''}}},[_vm._v("Clear")])],1)],1)],1)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"sm":"3"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":""}},[_c('b-input-group',[_c('b-form-select',{attrs:{"options":_vm.sortOptions},model:{value:(_vm.sortBy),callback:function ($$v) {_vm.sortBy=$$v},expression:"sortBy"}},[_c('option',{attrs:{"slot":"first"},domProps:{"value":null},slot:"first"},[_vm._v("Sort By")])]),_vm._v(" "),_c('b-form-select',{attrs:{"slot":"append","disabled":!_vm.sortBy},slot:"append",model:{value:(_vm.sortDesc),callback:function ($$v) {_vm.sortDesc=$$v},expression:"sortDesc"}},[_c('option',{domProps:{"value":false}},[_vm._v("Asc")]),_vm._v(" "),_c('option',{domProps:{"value":true}},[_vm._v("Desc")])])],1)],1)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"sm":"3"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"horizontal":""}},[_c('b-form-select',{model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}},[_c('option',{attrs:{"disabled":""}},[_vm._v("per page")]),_vm._v(" "),_c('option',{domProps:{"value":10}},[_vm._v("10")]),_vm._v(" "),_c('option',{domProps:{"value":25}},[_vm._v("25")]),_vm._v(" "),_c('option',{domProps:{"value":50}},[_vm._v("50")]),_vm._v(" "),_c('option',{domProps:{"value":80}},[_vm._v("80")]),_vm._v(" "),_c('option',{domProps:{"value":200}},[_vm._v("200")]),_vm._v(" "),_c('option',{domProps:{"value":500}},[_vm._v("500")])])],1)],1)],1),_vm._v(" "),_c('el-card',{staticStyle:{"overflow-x":"scroll"},attrs:{"id":"realtable","shadow":"always"}},[_c('TableHeader',{attrs:{"pageOptions":_vm.pageOptions,"fields":_vm.fields,"items":_vm.items,"perPage":_vm.perPage,"month":_vm.month,"visibleFields":undefined,"downloadCSVMethod":'downloadCSVProducts',"enableToggle":true,"shops":_vm.shops}}),_vm._v(" "),_c('b-table',{staticClass:"mt-4",attrs:{"show-empty":"","stacked":"sm","items":_vm.items,"fields":_vm.fields,"hover":true,"head-variant":"dark","current-page":_vm.currentPage,"per-page":_vm.perPage,"empty-text":_vm.emptyText,"filter":_vm.filter,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc,"responsive":""},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event},"filtered":_vm.onFiltered},scopedSlots:_vm._u([{key:"index",fn:function(data){return [_vm._v("\n            "+_vm._s(data.index + 1)+"\n          ")]}},{key:"default",fn:function(row){return [_c('b-img',{attrs:{"slot":"img","src":row.value,"width":"64","height":"64","alt":"image"},slot:"img"})]}},{key:"name",fn:function(row){return [_c('h6',{},[_vm._v(_vm._s(row.value))])]}},{key:"category",fn:function(row){return [_c('div',{staticClass:"row"},[_vm._v(_vm._s(row.value))])]}},{key:"actions",fn:function(row){return [_c('div',{staticClass:"btn-group",attrs:{"role":"group","aria-label":"Basic example"}},[(_vm.printItemPrice)?_c('PrintLabels',{attrs:{"id":row.item.id,"name":_vm.printItemName,"price":_vm.printItemPrice,"barcode":row.item.barcode}}):_vm._e(),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-info text-white",attrs:{"size":"sm"},on:{"click":function($event){$event.stopPropagation();row.toggleDetails($event)}}},[_vm._v("\n                View Prices\n              ")]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-sm btn-primary",attrs:{"to":{
                  name: 'editcommonproduct',
                  params: { product_id: row.item.id, cat: row.item.category },
                }}},[_vm._v("\n                View & Edit\n              ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-danger text-white",attrs:{"size":"sm"},on:{"click":function($event){_vm.open(row.item)}}},[_vm._v("\n                Delete\n              ")])],1)]}},{key:"row-details",fn:function(row){return [_c('b-card',{staticStyle:{"background-color":"#c9c9c9"}},[(_vm.selectedStore === 'all')?_c('el-button',{staticStyle:{"float":"right","margin-bottom":"5px"},attrs:{"type":"success","size":"small"},on:{"click":function($event){_vm.savePriceDetails(row.item)}}},[_vm._v("Save")]):_vm._e(),_vm._v(" "),_c('PriceTable',{staticStyle:{"margin":"0 auto"},attrs:{"priceData":row.item.priceList,"showPriceTable":true,"printMethod":_vm.print,"product":row.item,"profitMargin":row.item.profitMargin}})],1)]}}])})],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"md":"6"}},[_c('b-pagination',{staticClass:"my-0",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobNotes_vue__ = __webpack_require__(445);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a8e4aca8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobNotes_vue__ = __webpack_require__(927);
function injectStyle (ssrContext) {
  __webpack_require__(920)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a8e4aca8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobNotes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a8e4aca8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobNotes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 920 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobNoteDialog_vue__ = __webpack_require__(446);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fa77cb2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobNoteDialog_vue__ = __webpack_require__(923);
function injectStyle (ssrContext) {
  __webpack_require__(922)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4fa77cb2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobNoteDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fa77cb2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobNoteDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 922 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"margin-bottom":"20px","height":"30px"}},[_c('el-form',{ref:"formdata",staticStyle:{"<!-- border":"1px solid #e2e2e2","border-radius":"5px","-->\n              background-color":"#fff","padding":"25px"},attrs:{"model":_vm.formdata,"status-icon":"","label-width":"120px","label-position":_vm.labelPosition,"size":"medium"}},[_c('el-form-item',{attrs:{"label":"Customer Name","prop":"name","rules":[
                { required: true, message: 'Customer name', trigger: 'blur' } ]}},[_c('el-input',{attrs:{"placeholder":"Name"},model:{value:(_vm.formdata.name),callback:function ($$v) {_vm.$set(_vm.formdata, "name", $$v)},expression:"formdata.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Telephone Without 0","prop":"tel","rules":[
                { required: true, message: 'Telephone' },
                { type: 'number', message: 'Telephone no must be a number' } ]}},[_c('el-input',{attrs:{"auto-complete":"off","placeholder":"Telephone"},model:{value:(_vm.formdata.tel),callback:function ($$v) {_vm.$set(_vm.formdata, "tel", _vm._n($$v))},expression:"formdata.tel"}})],1),_vm._v(" "),(_vm.$route.name === 'jobNotes')?_c('el-form-item',{attrs:{"label":"Device","prop":"device","rules":[
                { required: true, message: 'Device', trigger: 'blur' } ]}},[_c('el-input',{attrs:{"placeholder":"Device"},model:{value:(_vm.formdata.device),callback:function ($$v) {_vm.$set(_vm.formdata, "device", $$v)},expression:"formdata.device"}})],1):_vm._e(),_vm._v(" "),(_vm.$route.name === 'jobNotes')?_c('el-form-item',{attrs:{"label":"Technician","prop":"techId","rules":[
                { required: true, message: 'User role', trigger: 'change' } ]}},[_c('el-select',{attrs:{"placeholder":"Technician"},on:{"change":function (value) {
                  _vm.formdata.techId = value.sysid
                  _vm.formdata.techName = value.name}},model:{value:(_vm.formdata.techName),callback:function ($$v) {_vm.$set(_vm.formdata, "techName", $$v)},expression:"formdata.techName"}},_vm._l((_vm.users.filter(function (user) { return user.role === 'Technician'; })),function(item){return _c('el-option',{key:item.sysid,attrs:{"label":item.name,"value":item}})}))],1):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Advanced Payment","prop":"tel","rules":[
                { required: true, message: 'Advanced Payment' },
                { type: 'number', message: 'Advanced Payment must be a number' } ]}},[_c('el-input',{attrs:{"auto-complete":"off","placeholder":"Advanced Payment"},model:{value:(_vm.formdata.adv),callback:function ($$v) {_vm.$set(_vm.formdata, "adv", _vm._n($$v))},expression:"formdata.adv"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Status","prop":"status","rules":[
                { required: true, message: 'Status', trigger: 'change' } ]}},[_c('el-select',{attrs:{"placeholder":"Status"},on:{"change":function (value) { return _vm.formdata.status = value; }},model:{value:(_vm.formdata.status),callback:function ($$v) {_vm.$set(_vm.formdata, "status", $$v)},expression:"formdata.status"}},[_c('el-option',{attrs:{"value":"Pending"}},[_vm._v("Pending")]),_vm._v(" "),_c('el-option',{attrs:{"value":"Working"}},[_vm._v("Working")]),_vm._v(" "),_c('el-option',{attrs:{"value":"Completed"}},[_vm._v("Completed")])],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Notes","prop":"note"}},[_c('el-input',{attrs:{"type":"textarea"},model:{value:(_vm.formdata.note),callback:function ($$v) {_vm.$set(_vm.formdata, "note", $$v)},expression:"formdata.note"}})],1)],1),_vm._v(" "),_c('h6',{staticClass:"text-info text-center pt-2 mb-3"},[_vm._v(_vm._s(_vm.$route.name === 'jobNotes'? 'Add require items for job' : 'Add items for order'))]),_vm._v(" "),_c('el-autocomplete',{staticStyle:{"margin-bottom":"1px","border":"1px solid #409eff","border-radius":"5px","width":"100%"},attrs:{"size":"medium","popper-class":"my-autocomplete","fetch-suggestions":_vm.querySearch,"placeholder":"Search Item"},on:{"select":_vm.handleProductChange},scopedSlots:_vm._u([{key:"default",fn:function(ref){
              var item = ref.item;
return [_c('div',{staticClass:"link"},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v("SKU: "+_vm._s(item.barcode))])]}}]),model:{value:(_vm.itemName),callback:function ($$v) {_vm.itemName=$$v},expression:"itemName"}},[_c('i',{staticClass:"el-icon-edit el-input__icon",attrs:{"slot":"suffix"},slot:"suffix"})]),_vm._v(" "),_c('el-button',{staticStyle:{"width":"100%"},attrs:{"size":"medium","type":"primary"},on:{"click":function($event){_vm.innerVisible=true}}},[_vm._v("View Items")]),_vm._v(" "),_c('h6',{staticClass:"text-info text-center pt-4 "},[_vm._v(_vm._s(_vm.$route.name === 'jobNotes'?'Required items for job' : 'Ordered items'))]),_vm._v(" "),_c('el-table',{ref:"singleTable",staticStyle:{"{\n          overflow-x":"scroll","width":"800px","margin":"0 auto"},attrs:{"data":_vm.jobItemData,"highlight-current-row":""}},[_c('el-table-column',{attrs:{"type":"index","width":"50"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"150","property":"serial","label":"Item"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-input',{attrs:{"size":"mini"},model:{value:(scope.row.item),callback:function ($$v) {_vm.$set(scope.row, "item", $$v)},expression:"scope.row.item"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"150","property":"quantity","label":"Quantity"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-input-number',{attrs:{"size":"mini","precision":2,"min":0},model:{value:(scope.row.quantity),callback:function ($$v) {_vm.$set(scope.row, "quantity", $$v)},expression:"scope.row.quantity"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"150","label":"Operations"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"size":"small","type":"danger","icon":"el-icon-delete","circle":""},on:{"click":function($event){_vm.open(scope.$index, scope.row)}}})]}}])})],1),_vm._v(" "),_c('div',{staticStyle:{"margin":"10px 0px","height":"50px"}},[(_vm.store && _vm.store !== 'all')?_c('el-button',{staticStyle:{"float":"right","margin-right":"0px"},attrs:{"disabled":_vm.disabled,"size":"medium","type":"success"},on:{"click":function($event){_vm.savejob(_vm.method, _vm.jobid)}}},[_vm._v("Save")]):_vm._e()],1),_vm._v(" "),_c('el-dialog',{attrs:{"width":"80%","title":"Items","visible":_vm.innerVisible,"append-to-body":""},on:{"update:visible":function($event){_vm.innerVisible=$event}}},[_c('el-row',_vm._l((_vm.allProducts),function(item,index){return _c('el-col',{key:index,attrs:{"xs":24,"sm":8,"md":8,"lg":6,"xl":6}},[_c('el-card',{attrs:{"body-style":{ padding: '0px' }}},[_c('img',{staticClass:"image",attrs:{"src":item.img}}),_vm._v(" "),_c('div',{staticStyle:{"padding":"4px 14px"}},[_vm._v("\n              "+_vm._s(item.name)+"\n              "),_c('el-button',{staticStyle:{"padding-top":"4px","display":"block"},attrs:{"type":"text"},on:{"click":function($event){_vm.handleProductChange(item)}}},[_vm._v("Add Item")])],1)])],1)}))],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobPrint_vue__ = __webpack_require__(447);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_752ec8fe_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobPrint_vue__ = __webpack_require__(926);
function injectStyle (ssrContext) {
  __webpack_require__(925)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-752ec8fe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobPrint_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_752ec8fe_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobPrint_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 925 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.job.date)?_c('div',{attrs:{"id":"jobPrint"}},[_c('div',{staticClass:"ticket"},[(_vm.store.logo)?_c('img',{attrs:{"src":_vm.store.logo,"alt":"Logo"}}):_vm._e(),_vm._v(" "),_c('p',{staticClass:"centered",staticStyle:{"margin-bottom":"10px"}},[(!_vm.store.logo)?_c('span',[_vm._v(_vm._s(_vm.store.name))]):_vm._e(),_vm._v(" "),_c('br'),_vm._v("\n      "+_vm._s(_vm.store.address)+"\n      "),_c('br'),_vm._v(_vm._s(_vm.store.telephone)+" "),_c('br')]),_vm._v(" "),_c('p',[_vm._v("\n      "+_vm._s(_vm.name === 'jobNotes' ? ("Job No : " + (_vm.job.jobNo)) : ("Order No : " + (_vm.job.jobNo)))+" "),_c('br'),_vm._v("Date :\n      "+_vm._s(_vm.job.date)+" "),_c('br'),_vm._v("Customer : "+_vm._s(_vm.job.name)+"\n      "),_c('br'),_vm._v("Telephone : "+_vm._s(_vm.job.tel)+"\n      "),_c('br'),_vm._v("Advance Payment : Rs "+_vm._s(_vm.job.adv)+"\n      "),_c('br'),_vm._v(_vm._s(_vm.name === 'jobNotes' ? ("Device : " + (_vm.job.device)) : '')+"\n\n    ")]),_vm._v(" "),_c('div',[(_vm.name !== 'jobNotes')?_c('table',{staticStyle:{"margin":"-10px auto 0 auto"}},[_vm._m(0),_vm._v(" "),_c('tbody',[_vm._l((_vm.job.items),function(product){return _c('tr',{key:product.barcode},[_c('td',{staticClass:"description"},[_vm._v(_vm._s(product.item)+" "+_vm._s(product.serial))]),_vm._v(" "),_c('td',{staticClass:"quantity"},[_vm._v(_vm._s(product.quantity))])])}),_vm._v(" "),_vm._m(1)],2)]):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"centered"},[_vm._v(_vm._s(_vm.store.footer))]),_vm._v(" "),_c('p',{staticClass:"centered",staticStyle:{"margin-bottom":"10px"}},[_vm._v("\n      Thank You\n    ")])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',{staticStyle:{"border-top":"hidden"}},[_c('th',{staticClass:"description",staticStyle:{"text-align":"left","min-width":"180px"}},[_vm._v("Item")]),_vm._v(" "),_c('th',{staticClass:"quantity",staticStyle:{"text-align":"left"}},[_vm._v("Qty")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('br')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Loading")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.loading1)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Updating")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.loading2)?_c('div',{attrs:{"id":"admin-preloader"}},[_c('div',{attrs:{"id":"admin-loader-text"}},[_vm._v("Deleting")]),_vm._v(" "),_c('div',{attrs:{"id":"admin-loader"}})]):_vm._e(),_vm._v(" "),(_vm.changed)?_c('div',{},[(_vm.$store.state.systemUser.role !== 'Kitchen Staff')?_c('div',{staticClass:"m-auto text-right pt-3"},[_c('el-button',{attrs:{"type":"primary","size":"medium"},on:{"click":function($event){_vm.dialogFormVisible2 = true}}},[_c('i',{staticClass:"el-icon-plus mr-2"}),_vm._v(_vm._s(_vm.$route.name === 'jobNotes' ? 'Add Job' : 'Add Order'))])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-sm-12 col-md-8 col-lg-6 m-auto pl-4"},[_c('el-dialog',{attrs:{"title":_vm.$route.name === 'jobNotes' ? 'Add job' : 'Add order',"visible":_vm.dialogFormVisible2,"width":_vm.width},on:{"update:visible":function($event){_vm.dialogFormVisible2=$event}}},[_c('el-card',{staticStyle:{"background-color":"#f5f7fa"},attrs:{"shadow":"always"}},[_c('JobNoteDialog',{attrs:{"jobItemData":_vm.jobItems,"method":'create',"users":_vm.users,"allProducts":_vm.allProducts}})],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":_vm.$route.name === 'jobNotes' ? 'Update job' : 'Update order',"visible":_vm.dialogFormVisible,"width":_vm.width},on:{"update:visible":function($event){_vm.dialogFormVisible=$event},"close":function($event){_vm.BUS.$emit('dialogClosed')},"open":function($event){_vm.BUS.$emit('dialogOpen', _vm.job)}}},[_c('el-card',{staticStyle:{"background-color":"#f5f7fa"},attrs:{"shadow":"always"}},[_c('JobNoteDialog',{attrs:{"jobItemData":_vm.job.items,"method":'update',"users":_vm.users,"jobData":_vm.job,"jobid":_vm.job.id,"allProducts":_vm.allProducts}})],1)],1)],1),_vm._v(" "),_c('b-container',{staticClass:"col-lg-10 mt-5"},[(_vm.$route.name === 'jobNotes')?_c('h3',{staticClass:"text-info text-center pt-4 my-4"},[_vm._v("Job Notes")]):_vm._e(),_vm._v(" "),(_vm.$route.name === 'orderProcessing')?_c('h3',{staticClass:"text-info text-center pt-4 my-4"},[_vm._v("Order Processing")]):_vm._e(),_vm._v(" "),_c('el-card',{staticStyle:{"background-color":"#f5f7fa","overflow":"initial"},attrs:{"shadow":"always"}},[_c('b-row',[_c('b-col',{staticClass:"my-1",attrs:{"sm":"3"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":""}},[_c('el-date-picker',{attrs:{"size":"medium","picker-options":{
                  disabledDate: function (time) { return _vm.disabledDate(time); },
                },"type":"month","placeholder":"Month"},model:{value:(_vm.month),callback:function ($$v) {_vm.month=$$v},expression:"month"}})],1)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"sm":"3","lg":"2"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":""}},[_c('b-form-select',{attrs:{"placeholder":"Store Location","options":_vm.stores},on:{"change":function($event){_vm.changeStore()}},model:{value:(_vm.storeLocation),callback:function ($$v) {_vm.storeLocation=$$v},expression:"storeLocation"}})],1)],1),_vm._v(" "),(_vm.$route.name === 'jobNotes')?_c('b-col',{staticClass:"my-1",attrs:{"sm":"3","lg":"2"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":""}},[_c('b-form-input',{attrs:{"placeholder":"Technician ID"},model:{value:(_vm.cashier),callback:function ($$v) {_vm.cashier=$$v},expression:"cashier"}})],1)],1):_vm._e(),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"sm":"3","lg":"2"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":""}},[_c('b-form-input',{attrs:{"placeholder":_vm.$route.name === 'jobNotes' ? 'Job No' : 'Order No'},model:{value:(_vm.jobNo),callback:function ($$v) {_vm.jobNo=$$v},expression:"jobNo"}})],1)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"sm":"3","lg":"2"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":""}},[_c('b-form-input',{attrs:{"placeholder":"Customer's Mobile No"},model:{value:(_vm.customer),callback:function ($$v) {_vm.customer=$$v},expression:"customer"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"my-1",attrs:{"sm":"12"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":""}},[_c('el-button',{staticStyle:{"display":"block","margin":"0 auto","margin-top":"10px"},attrs:{"type":"primary","size":"medium"},on:{"click":_vm.searchJobs}},[_vm._v("Search")])],1)],1)],1)],1),_vm._v(" "),_c('jobPrint',{staticStyle:{"display":"none"},attrs:{"id":"jobPrint"}}),_vm._v(" "),_c('el-card',{staticStyle:{"overflow-x":"scroll"},attrs:{"shadow":"always"}},[_c('b-table',{staticClass:"mt-4",attrs:{"show-empty":"","stacked":"sm","items":_vm.items,"fields":_vm.fields,"hover":true,"head-variant":"dark","current-page":_vm.currentPage,"per-page":_vm.perPage,"empty-text":_vm.emptyText,"filter":_vm.filter,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event},"filtered":_vm.onFiltered},scopedSlots:_vm._u([{key:"index",fn:function(data){return [_vm._v("\n            "+_vm._s(data.index + 1)+"\n          ")]}},{key:"status",fn:function(row){return [_c('el-select',{staticStyle:{"width":"160px"},attrs:{"size":"mini","placeholder":"Order Status"},on:{"change":function($event){_vm.upOrder(row.item.id, row.item.status)}},model:{value:(row.item.status),callback:function ($$v) {_vm.$set(row.item, "status", $$v)},expression:"row.item.status"}},_vm._l((_vm.options),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}))]}},{key:"actions",fn:function(row){return [_c('div',{staticClass:"btn-group",attrs:{"role":"group","aria-label":"Basic example"}},[_c('a',{staticClass:"btn btn-sm btn-info text-white",attrs:{"size":"sm"},on:{"click":function($event){$event.stopPropagation();row.toggleDetails($event)}}},[_vm._v("\n                View Items\n              ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-primary text-white",attrs:{"size":"sm"},on:{"click":function($event){$event.stopPropagation();_vm.showUpdatejob(row.item)}}},[_vm._v("\n                Update\n              ")]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-sm btn-warning text-white",attrs:{"to":{
                  name: 'createinvoice',
                  query: { job: row.item.jobNo, },
                }}},[_vm._v("\n                Invoice\n              ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-danger text-white",attrs:{"size":"sm"},on:{"click":function($event){_vm.open(row.item.id, row.item.status)}}},[_vm._v("\n                Delete\n              ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-secondary text-white",attrs:{"size":"sm"},on:{"click":function () {
                  var data = { job: row.item, store: _vm.storeDetails, name: _vm.$route.name }
                  return _vm.$root.$emit('jobPrint', data)
                }}},[_vm._v("\n                Print\n              ")])],1)]}},{key:"row-details",fn:function(row){return [_c('b-card',[_c('ul'),_vm._v(" "),_c('div',[_c('span',[_vm._v("Note: ")]),_vm._v(" "+_vm._s(row.item.note))]),_vm._v(" "),_c('h5',{staticClass:" text-info my-4"},[_vm._v("Required Items")]),_vm._v(" "),_c('div',{staticClass:"row"},[[_c('div',{staticClass:"col-12 col-md-8 "},[_c('el-table',{ref:"singleTable",staticStyle:{"{\n                            overflow-x":"scroll","width":"800px","margin":"0 auto"},attrs:{"data":row.item.items,"highlight-current-row":""}},[_c('el-table-column',{attrs:{"type":"index","width":"50"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"250","property":"serial","label":"Item"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                          "+_vm._s(scope.row.item)+"\n                        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"150","property":"quantity","label":"Quantity"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                          "+_vm._s(scope.row.quantity)+"\n                        ")]}}])})],1)],1)]],2)])]}}])})],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"sm":"3"}},[_c('b-form-group',{staticClass:"mb-0"},[_c('b-form-select',{model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}},[_c('option',{attrs:{"disabled":""}},[_vm._v("per page")]),_vm._v(" "),_c('option',{domProps:{"value":10}},[_vm._v("10")]),_vm._v(" "),_c('option',{domProps:{"value":20}},[_vm._v("20")]),_vm._v(" "),_c('option',{domProps:{"value":40}},[_vm._v("40")])])],1)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"md":"6"}},[_c('b-pagination',{staticClass:"my-0",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1098 */,
/* 1099 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_BackToTop_vue__ = __webpack_require__(490);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_be07a6cc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_BackToTop_vue__ = __webpack_require__(1101);
function injectStyle (ssrContext) {
  __webpack_require__(1100)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_BackToTop_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_be07a6cc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_BackToTop_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1100 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"back-to-top-fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"vue-back-to-top",style:(("bottom:" + (this.bottom) + ";right:" + (this.right) + ";")),on:{"click":_vm.backToTop}},[_vm._t("default",[_c('div',{staticClass:"default"},[_c('span',[_vm._v("\n          "+_vm._s(_vm.text)+"\n        ")])])])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
],[15]);


// WEBPACK FOOTER //
// static/js/app.0bef76cd1a01181fa9bf.js